export const ringModel = `
solid STL generated by MeshLab
  facet normal -7.465686e-01  1.068973e-07  6.653085e-01
    outer loop
      vertex   6.237039e+00  3.781313e+00  4.170912e+00
      vertex   6.088456e+00 -3.913052e+00  4.004183e+00
      vertex   6.237068e+00 -3.785059e+00  4.170946e+00
    endloop
  endfacet
  facet normal -8.300427e-01  5.706729e-08  5.576999e-01
    outer loop
      vertex   6.742568e+00  3.357542e+00  4.815872e+00
      vertex   6.742566e+00 -3.360556e+00  4.815869e+00
      vertex   6.959345e+00 -3.185122e+00  5.138508e+00
    endloop
  endfacet
  facet normal -7.873617e-01  5.805110e-06  6.164913e-01
    outer loop
      vertex   6.580883e+00  3.490953e+00  4.594908e+00
      vertex   6.416894e+00 -3.631935e+00  4.385535e+00
      vertex   6.582376e+00 -3.492981e+00  4.596881e+00
    endloop
  endfacet
  facet normal -8.071088e-01  3.500113e-08  5.904028e-01
    outer loop
      vertex   6.742568e+00  3.357542e+00  4.815872e+00
      vertex   6.582376e+00 -3.492981e+00  4.596881e+00
      vertex   6.742566e+00 -3.360556e+00  4.815869e+00
    endloop
  endfacet
  facet normal -8.880787e-01  1.411400e-05  4.596915e-01
    outer loop
      vertex   7.382584e+00  2.855700e+00  5.884530e+00
      vertex   7.276844e+00 -2.937180e+00  5.680428e+00
      vertex   7.385159e+00 -2.855360e+00  5.889679e+00
    endloop
  endfacet
  facet normal -6.723526e-01 -1.839359e-04  7.402312e-01
    outer loop
      vertex   5.529263e+00 -4.359472e+00  3.449402e+00
      vertex   5.576082e+00 -4.319799e+00  3.491938e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
    endloop
  endfacet
  facet normal -6.587014e-01  2.323274e-04  7.524044e-01
    outer loop
      vertex   5.529263e+00 -4.359472e+00  3.449402e+00
      vertex   5.432676e+00 -5.450840e-01  3.363666e+00
      vertex   5.346348e+00 -4.514809e+00  3.289315e+00
    endloop
  endfacet
  facet normal -6.599185e-01  1.775230e-04  7.513372e-01
    outer loop
      vertex   5.529263e+00 -4.359472e+00  3.449402e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
      vertex   5.432676e+00 -5.450840e-01  3.363666e+00
    endloop
  endfacet
  facet normal -6.363178e-01  2.705911e-04  7.714269e-01
    outer loop
      vertex   5.346348e+00 -4.514809e+00  3.289315e+00
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.159244e+00 -4.672935e+00  3.135036e+00
    endloop
  endfacet
  facet normal -7.072634e-01  1.214369e-07  7.069501e-01
    outer loop
      vertex   5.926354e+00  4.040663e+00  3.832204e+00
      vertex   5.752617e+00 -4.180309e+00  3.658392e+00
      vertex   5.926448e+00 -4.044765e+00  3.832300e+00
    endloop
  endfacet
  facet normal -9.999993e-01  9.778545e-10  1.131394e-03
    outer loop
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
      vertex   8.253390e+00 -2.206724e+00  9.385991e+00
      vertex   8.253806e+00  9.536743e-05  9.753502e+00
    endloop
  endfacet
  facet normal -9.909562e-01  1.971206e-07  1.341856e-01
    outer loop
      vertex   8.203593e+00  2.272276e+00  8.653778e+00
      vertex   8.154332e+00 -2.311420e+00  8.289993e+00
      vertex   8.203593e+00 -2.272078e+00  8.653785e+00
    endloop
  endfacet
  facet normal -9.959443e-01  1.342082e-07  8.997165e-02
    outer loop
      vertex   8.236661e+00  2.237776e+00  9.019822e+00
      vertex   8.203593e+00 -2.272078e+00  8.653785e+00
      vertex   8.236661e+00 -2.237551e+00  9.019829e+00
    endloop
  endfacet
  facet normal -9.839629e-01 -3.799698e-08  1.783733e-01
    outer loop
      vertex   8.154330e+00  2.311567e+00  8.289984e+00
      vertex   8.088120e+00 -2.358206e+00  7.924744e+00
      vertex   8.154332e+00 -2.311420e+00  8.289993e+00
    endloop
  endfacet
  facet normal -9.990934e-01 -6.810138e-03  4.202372e-02
    outer loop
      vertex   8.253390e+00 -2.206724e+00  9.385991e+00
      vertex   8.268659e+00 -2.178129e+00  9.753622e+00
      vertex   8.253806e+00  9.536743e-05  9.753502e+00
    endloop
  endfacet
  facet normal -9.023244e-01  5.554707e-08  4.310577e-01
    outer loop
      vertex   7.511272e+00  2.760725e+00  6.153669e+00
      vertex   7.385159e+00 -2.855360e+00  5.889679e+00
      vertex   7.511265e+00 -2.761974e+00  6.153654e+00
    endloop
  endfacet
  facet normal -9.509754e-01 -5.111975e-08  3.092665e-01
    outer loop
      vertex   7.791419e+00  2.560247e+00  6.850104e+00
      vertex   7.791418e+00 -2.560793e+00  6.850099e+00
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
    endloop
  endfacet
  facet normal -9.639528e-01  2.393101e-07  2.660733e-01
    outer loop
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
      vertex   8.005828e+00 -2.413929e+00  7.563893e+00
    endloop
  endfacet
  facet normal -9.189997e-01  1.802578e-07  3.942581e-01
    outer loop
      vertex   7.511272e+00  2.760725e+00  6.153669e+00
      vertex   7.511265e+00 -2.761974e+00  6.153654e+00
      vertex   7.658683e+00 -2.654942e+00  6.497281e+00
    endloop
  endfacet
  facet normal -6.401148e-01 -6.896464e-06  7.682793e-01
    outer loop
      vertex   5.346348e+00 -4.514809e+00  3.289315e+00
      vertex   5.353013e+00 -1.098413e+00  3.294899e+00
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
    endloop
  endfacet
  facet normal -6.535943e-01  3.809041e-05  7.568451e-01
    outer loop
      vertex   5.346348e+00 -4.514809e+00  3.289315e+00
      vertex   5.432676e+00 -5.450840e-01  3.363666e+00
      vertex   5.353013e+00 -1.098413e+00  3.294899e+00
    endloop
  endfacet
  facet normal -1.018750e-01 -3.960938e-03  9.947893e-01
    outer loop
      vertex   8.060707e-01 -6.644463e+00  1.364411e+00
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
    endloop
  endfacet
  facet normal -4.597106e-01  4.518837e-04  8.880687e-01
    outer loop
      vertex   3.942708e+00 -5.586086e+00  2.326981e+00
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   3.644648e+00 -5.760553e+00  2.172778e+00
    endloop
  endfacet
  facet normal -2.669746e-01  1.964638e-03  9.637015e-01
    outer loop
      vertex   2.394752e+00 -6.291546e+00  1.679824e+00
      vertex   2.166294e+00 -5.123985e+00  1.614154e+00
      vertex   2.004912e+00 -6.408859e+00  1.572065e+00
    endloop
  endfacet
  facet normal -2.189521e-01  9.551233e-04  9.757351e-01
    outer loop
      vertex   1.605798e+00 -6.508545e+00  1.482603e+00
      vertex   2.004912e+00 -6.408859e+00  1.572065e+00
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
    endloop
  endfacet
  facet normal -3.614444e-01  1.082001e-03  9.323930e-01
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   3.172365e+00 -5.993839e+00  1.958629e+00
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
    endloop
  endfacet
  facet normal -4.275789e-01  6.629612e-04  9.039778e-01
    outer loop
      vertex   3.644648e+00 -5.760553e+00  2.172778e+00
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
      vertex   3.411897e+00 -5.881508e+00  2.062777e+00
    endloop
  endfacet
  facet normal -3.983173e-01 -1.063265e-03  9.172471e-01
    outer loop
      vertex   3.411897e+00 -5.881508e+00  2.062777e+00
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
      vertex   3.172365e+00 -5.993839e+00  1.958629e+00
    endloop
  endfacet
  facet normal -1.171570e-01  1.495951e-04  9.931133e-01
    outer loop
      vertex   8.060707e-01 -6.644463e+00  1.364411e+00
      vertex   1.128407e+00 -6.600262e+00  1.402431e+00
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
    endloop
  endfacet
  facet normal -1.559390e-01 -1.188189e-04  9.877667e-01
    outer loop
      vertex   1.128407e+00 -6.600262e+00  1.402431e+00
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
    endloop
  endfacet
  facet normal -1.671672e-01 -3.590360e-03  9.859220e-01
    outer loop
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
    endloop
  endfacet
  facet normal -5.140913e-01  4.166583e-04  8.577354e-01
    outer loop
      vertex   4.145314e+00 -5.454771e+00  2.440770e+00
      vertex   4.341982e+00 -5.317970e+00  2.558578e+00
      vertex   4.250867e+00 -3.512360e+00  2.503091e+00
    endloop
  endfacet
  facet normal -2.304526e-01 -2.929774e-03  9.730791e-01
    outer loop
      vertex   2.004912e+00 -6.408859e+00  1.572065e+00
      vertex   2.166294e+00 -5.123985e+00  1.614154e+00
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
    endloop
  endfacet
  facet normal -5.327200e-01 -8.750694e-04  8.462912e-01
    outer loop
      vertex   4.341982e+00 -5.317970e+00  2.558578e+00
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
      vertex   4.250867e+00 -3.512360e+00  2.503091e+00
    endloop
  endfacet
  facet normal -5.746596e-01 -2.495417e-04  8.183925e-01
    outer loop
      vertex   4.773260e+00 -4.990042e+00  2.844279e+00
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   4.719419e+00 -5.032785e+00  2.806460e+00
    endloop
  endfacet
  facet normal -5.900280e-01  2.126755e-04  8.073828e-01
    outer loop
      vertex   4.968148e+00 -4.831974e+00  2.986660e+00
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   4.773260e+00 -4.990042e+00  2.844279e+00
    endloop
  endfacet
  facet normal -6.134427e-01  3.028285e-04  7.897393e-01
    outer loop
      vertex   4.968148e+00 -4.831974e+00  2.986660e+00
      vertex   5.159244e+00 -4.672935e+00  3.135036e+00
      vertex   5.043385e+00 -2.145653e+00  3.044071e+00
    endloop
  endfacet
  facet normal -4.487270e-01 -1.496283e-03  8.936676e-01
    outer loop
      vertex   3.644648e+00 -5.760553e+00  2.172778e+00
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
    endloop
  endfacet
  facet normal -4.929460e-01 -1.127814e-03  8.700592e-01
    outer loop
      vertex   4.145314e+00 -5.454771e+00  2.440770e+00
      vertex   4.250867e+00 -3.512360e+00  2.503091e+00
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
    endloop
  endfacet
  facet normal -6.189509e-01  2.311188e-04  7.854297e-01
    outer loop
      vertex   5.157131e+00  4.670424e+00  3.133343e+00
      vertex   5.020370e+00  2.202127e+00  3.026297e+00
      vertex   5.207137e+00  1.683670e+00  3.173629e+00
    endloop
  endfacet
  facet normal -9.909557e-01 -1.320283e-07  1.341897e-01
    outer loop
      vertex   8.154330e+00  2.311567e+00  8.289984e+00
      vertex   8.154332e+00 -2.311420e+00  8.289993e+00
      vertex   8.203593e+00  2.272276e+00  8.653778e+00
    endloop
  endfacet
  facet normal -9.999811e-01  8.264671e-04  6.094133e-03
    outer loop
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
      vertex   8.253806e+00  9.536743e-05  9.753502e+00
      vertex   8.255627e+00  2.180864e+00  9.756488e+00
    endloop
  endfacet
  facet normal -9.959443e-01  1.321697e-07  8.997167e-02
    outer loop
      vertex   8.203593e+00  2.272276e+00  8.653778e+00
      vertex   8.203593e+00 -2.272078e+00  8.653785e+00
      vertex   8.236661e+00  2.237776e+00  9.019822e+00
    endloop
  endfacet
  facet normal -9.639533e-01  9.702926e-08  2.660716e-01
    outer loop
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
      vertex   8.005828e+00 -2.413929e+00  7.563893e+00
      vertex   8.005827e+00  2.413839e+00  7.563888e+00
    endloop
  endfacet
  facet normal -9.509745e-01  1.656071e-07  3.092693e-01
    outer loop
      vertex   7.791419e+00  2.560247e+00  6.850104e+00
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
    endloop
  endfacet
  facet normal -6.528083e-01 -2.282216e-05  7.575231e-01
    outer loop
      vertex   5.343349e+00  4.512934e+00  3.286766e+00
      vertex   5.344658e+00  1.140909e+00  3.287793e+00
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
    endloop
  endfacet
  facet normal -6.596163e-01 -1.721801e-04  7.516025e-01
    outer loop
      vertex   5.525450e+00  4.358259e+00  3.445965e+00
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
    endloop
  endfacet
  facet normal -6.387705e-01 -1.375880e-05  7.693973e-01
    outer loop
      vertex   5.343349e+00  4.512934e+00  3.286766e+00
      vertex   5.207137e+00  1.683670e+00  3.173629e+00
      vertex   5.344658e+00  1.140909e+00  3.287793e+00
    endloop
  endfacet
  facet normal -9.359565e-01 -9.842320e-08  3.521156e-01
    outer loop
      vertex   7.658692e+00  2.654070e+00  6.497303e+00
      vertex   7.791418e+00 -2.560793e+00  6.850099e+00
      vertex   7.791419e+00  2.560247e+00  6.850104e+00
    endloop
  endfacet
  facet normal -7.276915e-01 -3.641298e-07  6.859045e-01
    outer loop
      vertex   5.926354e+00  4.040663e+00  3.832204e+00
      vertex   5.926448e+00 -4.044765e+00  3.832300e+00
      vertex   6.088405e+00  3.909117e+00  4.004127e+00
    endloop
  endfacet
  facet normal -8.070226e-01 -5.736658e-06  5.905204e-01
    outer loop
      vertex   6.580883e+00  3.490953e+00  4.594908e+00
      vertex   6.582376e+00 -3.492981e+00  4.596881e+00
      vertex   6.742568e+00  3.357542e+00  4.815872e+00
    endloop
  endfacet
  facet normal -8.745579e-01  7.916246e-08  4.849212e-01
    outer loop
      vertex   7.163462e+00  3.022242e+00  5.475860e+00
      vertex   7.163453e+00 -3.024397e+00  5.475844e+00
      vertex   7.275499e+00  2.936335e+00  5.677919e+00
    endloop
  endfacet
  facet normal -8.300423e-01  9.933524e-08  5.577006e-01
    outer loop
      vertex   6.742568e+00  3.357542e+00  4.815872e+00
      vertex   6.959345e+00 -3.185122e+00  5.138508e+00
      vertex   6.959351e+00  3.182512e+00  5.138515e+00
    endloop
  endfacet
  facet normal -7.662659e-01 -7.077528e-08  6.425235e-01
    outer loop
      vertex   6.237039e+00  3.781313e+00  4.170912e+00
      vertex   6.237068e+00 -3.785059e+00  4.170946e+00
      vertex   6.413812e+00  3.631025e+00  4.381729e+00
    endloop
  endfacet
  facet normal -7.870871e-01 -1.082531e-05  6.168419e-01
    outer loop
      vertex   6.413812e+00  3.631025e+00  4.381729e+00
      vertex   6.416894e+00 -3.631935e+00  4.385535e+00
      vertex   6.580883e+00  3.490953e+00  4.594908e+00
    endloop
  endfacet
  facet normal -7.465622e-01 -1.698819e-07  6.653156e-01
    outer loop
      vertex   6.088405e+00  3.909117e+00  4.004127e+00
      vertex   6.088456e+00 -3.913052e+00  4.004183e+00
      vertex   6.237039e+00  3.781313e+00  4.170912e+00
    endloop
  endfacet
  facet normal -5.264645e-01  1.089546e-03  8.501963e-01
    outer loop
      vertex   4.338367e+00  5.317045e+00  2.556341e+00
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
    endloop
  endfacet
  facet normal -5.898877e-01 -1.129532e-04  8.074853e-01
    outer loop
      vertex   4.773077e+00  4.986311e+00  2.844149e+00
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
      vertex   4.966979e+00  4.828844e+00  2.985777e+00
    endloop
  endfacet
  facet normal -6.132319e-01 -2.797425e-04  7.899029e-01
    outer loop
      vertex   5.157131e+00  4.670424e+00  3.133343e+00
      vertex   4.966979e+00  4.828844e+00  2.985777e+00
      vertex   5.020370e+00  2.202127e+00  3.026297e+00
    endloop
  endfacet
  facet normal -5.934896e-01  3.519948e-04  8.048416e-01
    outer loop
      vertex   4.966979e+00  4.828844e+00  2.985777e+00
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
      vertex   5.020370e+00  2.202127e+00  3.026297e+00
    endloop
  endfacet
  facet normal -5.625310e-01  5.823472e-04  8.267760e-01
    outer loop
      vertex   4.715715e+00  5.031897e+00  2.803882e+00
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
    endloop
  endfacet
  facet normal -5.745343e-01  3.391672e-05  8.184806e-01
    outer loop
      vertex   4.715715e+00  5.031897e+00  2.803882e+00
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
      vertex   4.773077e+00  4.986311e+00  2.844149e+00
    endloop
  endfacet
  facet normal -5.598581e-01  1.614168e-04  8.285885e-01
    outer loop
      vertex   4.529514e+00  5.176035e+00  2.678042e+00
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.715715e+00  5.031897e+00  2.803882e+00
    endloop
  endfacet
  facet normal -5.371289e-01 -1.107281e-04  8.435002e-01
    outer loop
      vertex   4.338367e+00  5.317045e+00  2.556341e+00
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.529514e+00  5.176035e+00  2.678042e+00
    endloop
  endfacet
  facet normal -3.951155e-01  1.144648e-03  9.186307e-01
    outer loop
      vertex   3.169260e+00  5.993425e+00  1.957336e+00
      vertex   3.088440e+00  4.607893e+00  1.924301e+00
      vertex   3.450360e+00  4.332602e+00  2.080311e+00
    endloop
  endfacet
  facet normal -2.510904e-01  2.124409e-03  9.679613e-01
    outer loop
      vertex   2.003154e+00  6.410124e+00  1.571624e+00
      vertex   1.863009e+00  5.246222e+00  1.537825e+00
      vertex   2.293362e+00  5.066713e+00  1.649853e+00
    endloop
  endfacet
  facet normal -1.974373e-01  2.649823e-03  9.803120e-01
    outer loop
      vertex   1.604250e+00  6.509223e+00  1.482296e+00
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
      vertex   1.863009e+00  5.246222e+00  1.537825e+00
    endloop
  endfacet
  facet normal -2.189863e-01 -1.966686e-03  9.757259e-01
    outer loop
      vertex   1.604250e+00  6.509223e+00  1.482296e+00
      vertex   1.863009e+00  5.246222e+00  1.537825e+00
      vertex   2.003154e+00  6.410124e+00  1.571624e+00
    endloop
  endfacet
  facet normal -3.982468e-01  5.145065e-04  9.172782e-01
    outer loop
      vertex   3.169260e+00  5.993425e+00  1.957336e+00
      vertex   3.450360e+00  4.332602e+00  2.080311e+00
      vertex   3.410246e+00  5.879915e+00  2.062027e+00
    endloop
  endfacet
  facet normal -4.273530e-01 -3.959610e-04  9.040847e-01
    outer loop
      vertex   3.410246e+00  5.879915e+00  2.062027e+00
      vertex   3.450360e+00  4.332602e+00  2.080311e+00
      vertex   3.644418e+00  5.757833e+00  2.172665e+00
    endloop
  endfacet
  facet normal -5.745434e-01 -6.211483e-01  5.329865e-01
    outer loop
      vertex  -6.524183e+00 -1.470648e+00  1.624230e+01
      vertex  -7.132257e+00 -1.470675e+00  1.558679e+01
      vertex  -7.015736e+00 -1.662584e+00  1.548874e+01
    endloop
  endfacet
  facet normal -2.666054e-01 -1.469244e-03  9.638047e-01
    outer loop
      vertex   2.003154e+00  6.410124e+00  1.571624e+00
      vertex   2.293362e+00  5.066713e+00  1.649853e+00
      vertex   2.392633e+00  6.292719e+00  1.679182e+00
    endloop
  endfacet
  facet normal -1.846651e-01  3.925871e-04  9.828014e-01
    outer loop
      vertex   1.446853e+00  6.542452e+00  1.452708e+00
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
      vertex   1.604250e+00  6.509223e+00  1.482296e+00
    endloop
  endfacet
  facet normal -4.136784e-01 -9.072682e-01  7.572792e-02
    outer loop
      vertex  -8.198880e+00 -2.495790e+00  6.145909e+00
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
    endloop
  endfacet
  facet normal -1.424677e-01  2.800180e-03  9.897955e-01
    outer loop
      vertex   1.127824e+00  6.599570e+00  1.402349e+00
      vertex   9.514104e-01  5.493269e+00  1.380087e+00
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
    endloop
  endfacet
  facet normal -8.648118e-02  2.660162e-03  9.962499e-01
    outer loop
      vertex   8.050640e-01  6.643335e+00  1.364312e+00
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
      vertex   9.514104e-01  5.493269e+00  1.380087e+00
    endloop
  endfacet
  facet normal -1.172131e-01 -1.293609e-03  9.931059e-01
    outer loop
      vertex   1.127824e+00  6.599570e+00  1.402349e+00
      vertex   8.050640e-01  6.643335e+00  1.364312e+00
      vertex   9.514104e-01  5.493269e+00  1.380087e+00
    endloop
  endfacet
  facet normal  8.648508e-02 -2.630824e-03  9.962496e-01
    outer loop
      vertex  -8.065596e-01 -6.645087e+00  1.364478e+00
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
      vertex  -9.513160e-01 -5.492985e+00  1.380087e+00
    endloop
  endfacet
  facet normal  1.725630e-01 -4.419988e-03 -9.849885e-01
    outer loop
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
      vertex  -1.183776e+00 -2.180971e+00  1.774998e+01
    endloop
  endfacet
  facet normal  2.448820e-02  4.458033e-05  9.997001e-01
    outer loop
      vertex  -4.043255e-01 -6.678886e+00  1.334889e+00
      vertex   8.787063e-05 -6.690313e+00  1.324984e+00
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
    endloop
  endfacet
  facet normal -8.794111e-01 -1.904343e-02 -4.756821e-01
    outer loop
      vertex  -7.378439e+00  1.985550e-03  1.241728e+00
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
      vertex  -7.001122e+00 -4.389858e-01  5.618219e-01
    endloop
  endfacet
  facet normal  7.347140e-02  1.301812e-03  9.972965e-01
    outer loop
      vertex  -4.043255e-01 -6.678886e+00  1.334889e+00
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
      vertex  -8.065596e-01 -6.645087e+00  1.364478e+00
    endloop
  endfacet
  facet normal -9.919524e-01  1.247256e-01 -2.177461e-02
    outer loop
      vertex   5.432676e+00 -5.450840e-01  3.363666e+00
      vertex   5.520783e+00 -4.315945e-01  1.734723e-18
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
    endloop
  endfacet
  facet normal  1.173771e-01  1.293478e-03  9.930866e-01
    outer loop
      vertex  -1.128790e+00 -6.602042e+00  1.402508e+00
      vertex  -8.065596e-01 -6.645087e+00  1.364478e+00
      vertex  -9.513160e-01 -5.492985e+00  1.380087e+00
    endloop
  endfacet
  facet normal  8.950373e-01 -1.260197e-02 -4.458132e-01
    outer loop
      vertex   7.759639e+00  2.861023e-04  1.955153e+00
      vertex   7.936329e+00 -2.689362e-04  2.309899e+00
      vertex   7.929991e+00 -5.209370e-01  2.311893e+00
    endloop
  endfacet
  facet normal  1.561177e-01  4.869155e-04  9.877383e-01
    outer loop
      vertex  -1.128790e+00 -6.602042e+00  1.402508e+00
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
      vertex  -1.447308e+00 -6.545586e+00  1.452824e+00
    endloop
  endfacet
  facet normal  3.826561e-01 -7.610939e-01  5.237466e-01
    outer loop
      vertex   5.760838e+00 -1.661295e+00  1.671921e+01
      vertex   4.864637e+00 -1.948717e+00  1.695632e+01
      vertex   5.548748e+00 -1.948668e+00  1.645657e+01
    endloop
  endfacet
  facet normal  2.670331e-01  1.521239e-03  9.636862e-01
    outer loop
      vertex  -2.006207e+00 -6.413306e+00  1.572435e+00
      vertex  -2.293268e+00 -5.066431e+00  1.649853e+00
      vertex  -2.396073e+00 -6.296173e+00  1.680281e+00
    endloop
  endfacet
  facet normal  4.275530e-01  3.955153e-04  9.039902e-01
    outer loop
      vertex  -3.412686e+00 -5.885452e+00  2.063216e+00
      vertex  -3.450266e+00 -4.332319e+00  2.080311e+00
      vertex  -3.644958e+00 -5.764738e+00  2.173019e+00
    endloop
  endfacet
  facet normal  9.077711e-01 -4.189618e-01 -2.056230e-02
    outer loop
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
      vertex  -4.930842e+00  2.532238e+00 -4.510281e-16
      vertex  -4.924090e+00  2.546866e+00 -3.700744e-17
    endloop
  endfacet
  facet normal  3.019398e-01 -1.653265e-03  9.533256e-01
    outer loop
      vertex  -2.396073e+00 -6.296173e+00  1.680281e+00
      vertex  -2.293268e+00 -5.066431e+00  1.649853e+00
      vertex  -2.702217e+00 -4.852983e+00  1.779746e+00
    endloop
  endfacet
  facet normal  7.395685e-01 -6.307391e-01 -2.349612e-01
    outer loop
      vertex   6.788991e+00 -3.179214e+00  1.985767e+00
      vertex   6.622387e+00 -3.512589e+00  2.356283e+00
      vertex   6.519882e+00 -3.500469e+00  2.001101e+00
    endloop
  endfacet
  facet normal  2.510910e-01 -2.122238e-03  9.679612e-01
    outer loop
      vertex  -2.006207e+00 -6.413306e+00  1.572435e+00
      vertex  -1.862915e+00 -5.245935e+00  1.537825e+00
      vertex  -2.293268e+00 -5.066431e+00  1.649853e+00
    endloop
  endfacet
  facet normal  5.754670e-01 -8.054754e-01  1.415884e-01
    outer loop
      vertex   4.773260e+00 -4.990042e+00  2.844279e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
    endloop
  endfacet
  facet normal  5.264857e-01 -1.067968e-03  8.501834e-01
    outer loop
      vertex  -4.343534e+00 -5.321756e+00  2.559642e+00
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
    endloop
  endfacet
  facet normal  5.378100e-01  1.657202e-04  8.430660e-01
    outer loop
      vertex  -4.343534e+00 -5.321756e+00  2.559642e+00
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
      vertex  -4.534791e+00 -5.180698e+00  2.681621e+00
    endloop
  endfacet
  facet normal -2.603790e-01  6.205966e-01  7.396367e-01
    outer loop
      vertex  -2.619798e+00  1.662946e+00  1.837016e+01
      vertex  -3.524038e+00  1.468016e+00  1.821539e+01
      vertex  -2.663953e+00  1.467962e+00  1.851822e+01
    endloop
  endfacet
  facet normal  7.665313e-01  1.146453e-05  6.422070e-01
    outer loop
      vertex  -6.414639e+00  3.632761e+00  4.382941e+00
      vertex  -6.417768e+00 -3.634079e+00  4.386804e+00
      vertex  -6.237097e+00 -3.788153e+00  4.171160e+00
    endloop
  endfacet
  facet normal  6.857048e-01 -8.428447e-04  7.278792e-01
    outer loop
      vertex  -5.576197e+00 -4.323465e+00  3.492194e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.752707e+00 -4.183825e+00  3.658639e+00
    endloop
  endfacet
  facet normal  6.588405e-01  2.450347e-04  7.522826e-01
    outer loop
      vertex  -5.530277e+00 -4.362434e+00  3.450466e+00
      vertex  -5.347189e+00 -4.518198e+00  3.290170e+00
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
    endloop
  endfacet
  facet normal -8.354391e-01 -5.473898e-01 -4.904857e-02
    outer loop
      vertex  -9.079116e+00 -1.757046e+00  7.576221e+00
      vertex  -9.146712e+00 -1.719254e+00  8.305818e+00
      vertex  -9.396447e+00 -1.338486e+00  8.310097e+00
    endloop
  endfacet
  facet normal  7.072907e-01  5.588997e-07  7.069228e-01
    outer loop
      vertex  -5.926451e+00  4.043840e+00  3.832467e+00
      vertex  -5.926527e+00 -4.048138e+00  3.832550e+00
      vertex  -5.752707e+00 -4.183825e+00  3.658639e+00
    endloop
  endfacet
  facet normal  8.139528e-01  5.534377e-01 -1.766002e-01
    outer loop
      vertex   8.234009e+00  2.378031e+00  4.747190e+00
      vertex   8.689773e+00  1.927053e+00  5.434519e+00
      vertex   8.503082e+00  1.978765e+00  4.736118e+00
    endloop
  endfacet
  facet normal  7.465839e-01  6.478373e-08  6.652911e-01
    outer loop
      vertex  -6.237068e+00  3.783979e+00  4.171127e+00
      vertex  -6.237097e+00 -3.788153e+00  4.171160e+00
      vertex  -6.088506e+00 -3.916286e+00  4.004413e+00
    endloop
  endfacet
  facet normal  8.300506e-01 -1.838942e-09  5.576881e-01
    outer loop
      vertex  -6.742538e+00  3.359671e+00  4.816041e+00
      vertex  -6.959290e+00 -3.187130e+00  5.138649e+00
      vertex  -6.742536e+00 -3.362928e+00  4.816038e+00
    endloop
  endfacet
  facet normal -6.463616e-01 -7.617264e-01  4.460438e-02
    outer loop
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
      vertex  -8.832759e+00 -1.949820e+00  9.764791e+00
    endloop
  endfacet
  facet normal  8.881182e-01  1.263678e-05  4.596152e-01
    outer loop
      vertex  -7.276982e+00 -2.938496e+00  5.680944e+00
      vertex  -7.383187e+00  2.856745e+00  5.886006e+00
      vertex  -7.385486e+00 -2.856359e+00  5.890606e+00
    endloop
  endfacet
  facet normal -8.544763e-01 -5.191609e-01 -1.849916e-02
    outer loop
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.634337e+00  3.046870e+00 -1.228184e-16
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
    endloop
  endfacet
  facet normal  4.664320e-01  8.801199e-01 -8.848830e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   3.868523e+00  5.588697e+00  1.385323e+00
    endloop
  endfacet
  facet normal  9.509737e-01  9.714020e-08  3.092718e-01
    outer loop
      vertex  -7.791326e+00  2.561319e+00  6.850196e+00
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
      vertex  -7.791324e+00 -2.561487e+00  6.850190e+00
    endloop
  endfacet
  facet normal  9.749689e-01 -3.886101e-08  2.223417e-01
    outer loop
      vertex  -8.005733e+00  2.414618e+00  7.563975e+00
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
      vertex  -8.005733e+00 -2.414318e+00  7.563979e+00
    endloop
  endfacet
  facet normal  9.989579e-01  9.861365e-09  4.564063e-02
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.253299e+00 -2.206669e+00  9.386083e+00
      vertex  -8.236569e+00 -2.237564e+00  9.019919e+00
    endloop
  endfacet
  facet normal  9.990388e-01 -7.000359e-03  4.327364e-02
    outer loop
      vertex  -8.253299e+00 -2.206669e+00  9.386083e+00
      vertex  -8.253727e+00  2.117157e-04  9.752975e+00
      vertex  -8.269004e+00 -2.177960e+00  9.753304e+00
    endloop
  endfacet
  facet normal  4.929565e-01  1.114921e-03  8.700533e-01
    outer loop
      vertex  -4.143497e+00  5.457701e+00  2.439818e+00
      vertex  -4.250774e+00  3.512644e+00  2.503092e+00
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
    endloop
  endfacet
  facet normal  2.904051e-01  2.970794e-03  9.568992e-01
    outer loop
      vertex  -2.393248e+00  6.295172e+00  1.679424e+00
      vertex  -2.650488e+00  4.882700e+00  1.761878e+00
      vertex  -2.166200e+00  5.124269e+00  1.614154e+00
    endloop
  endfacet
  facet normal  5.670854e-01  7.087426e-04  8.236587e-01
    outer loop
      vertex  -4.717629e+00  5.035028e+00  2.805334e+00
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
    endloop
  endfacet
  facet normal  5.371805e-01  2.447772e-04  8.434673e-01
    outer loop
      vertex  -4.340185e+00  5.320688e+00  2.557577e+00
      vertex  -4.531404e+00  5.179392e+00  2.679399e+00
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
    endloop
  endfacet
  facet normal  5.602504e-01 -1.268145e-04  8.283232e-01
    outer loop
      vertex  -4.717629e+00  5.035028e+00  2.805334e+00
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
      vertex  -4.531404e+00  5.179392e+00  2.679399e+00
    endloop
  endfacet
  facet normal  2.188482e-01 -9.816827e-04  9.757584e-01
    outer loop
      vertex  -2.003711e+00  6.412324e+00  1.571811e+00
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
      vertex  -1.604877e+00  6.511686e+00  1.482458e+00
    endloop
  endfacet
  facet normal  7.346195e-02 -2.176649e-03  9.972956e-01
    outer loop
      vertex  -8.056749e-01  6.646356e+00  1.364390e+00
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
      vertex  -4.039023e-01  6.679846e+00  1.334868e+00
    endloop
  endfacet
  facet normal  4.275681e-01 -6.910522e-04  9.039828e-01
    outer loop
      vertex  -3.411066e+00  5.884436e+00  2.062481e+00
      vertex  -3.644764e+00  5.762789e+00  2.172923e+00
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
    endloop
  endfacet
  facet normal  3.145220e-01 -1.868002e-03  9.492484e-01
    outer loop
      vertex  -2.393248e+00  6.295172e+00  1.679424e+00
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
      vertex  -2.650488e+00  4.882700e+00  1.761878e+00
    endloop
  endfacet
  facet normal  3.612511e-01 -1.080886e-03  9.324680e-01
    outer loop
      vertex  -3.170523e+00  5.997377e+00  1.957937e+00
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
    endloop
  endfacet
  facet normal  6.916271e-01 -6.959507e-01 -1.931439e-01
    outer loop
      vertex   7.331333e+00 -2.866991e+00  2.710981e+00
      vertex   7.548003e+00 -2.840347e+00  3.390848e+00
      vertex   7.248614e+00 -3.143639e+00  3.411612e+00
    endloop
  endfacet
  facet normal -2.491448e-01 -9.660190e-01  6.880622e-02
    outer loop
      vertex  -8.203500e+00 -2.272165e+00  8.653872e+00
      vertex  -8.236569e+00 -2.237564e+00  9.019919e+00
      vertex  -8.448242e+00 -2.182707e+00  9.023640e+00
    endloop
  endfacet
  facet normal  6.133708e-01 -3.193440e-04  7.897950e-01
    outer loop
      vertex  -5.158133e+00  4.673937e+00  3.134282e+00
      vertex  -5.043293e+00  2.145937e+00  3.044073e+00
      vertex  -4.967633e+00  4.832796e+00  2.986400e+00
    endloop
  endfacet
  facet normal -8.784752e-01 -1.537759e-02 -4.775404e-01
    outer loop
      vertex  -7.378439e+00  1.985550e-03  1.241728e+00
      vertex  -7.001122e+00 -4.389858e-01  5.618219e-01
      vertex  -7.370649e+00 -4.772720e-01  1.242829e+00
    endloop
  endfacet
  facet normal  8.879020e-01 -6.098719e-06  4.600326e-01
    outer loop
      vertex  -7.276982e+00 -2.938496e+00  5.680944e+00
      vertex  -7.275784e+00  2.937731e+00  5.678710e+00
      vertex  -7.383187e+00  2.856745e+00  5.886006e+00
    endloop
  endfacet
  facet normal  9.639531e-01 -6.191850e-09  2.660724e-01
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -8.005733e+00  2.414618e+00  7.563975e+00
      vertex  -8.005733e+00 -2.414318e+00  7.563979e+00
    endloop
  endfacet
  facet normal  6.209689e-01  2.384966e-04  7.838351e-01
    outer loop
      vertex  -5.158133e+00  4.673937e+00  3.134282e+00
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
      vertex  -5.043293e+00  2.145937e+00  3.044073e+00
    endloop
  endfacet
  facet normal  6.401323e-01 -1.627150e-06  7.682647e-01
    outer loop
      vertex  -5.344672e+00  4.515985e+00  3.288033e+00
      vertex  -5.352921e+00  1.098696e+00  3.294899e+00
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
    endloop
  endfacet
  facet normal -7.137526e-01  6.875876e-01 -1.333434e-01
    outer loop
      vertex  -6.517076e+00  3.502085e+00  2.001261e+00
      vertex  -6.018507e+00  4.096174e+00  2.395986e+00
      vertex  -5.940165e+00  4.107729e+00  2.036218e+00
    endloop
  endfacet
  facet normal  9.022201e-01 -1.585616e-05  4.312760e-01
    outer loop
      vertex  -7.511187e+00  2.762133e+00  6.153776e+00
      vertex  -7.385486e+00 -2.856359e+00  5.890606e+00
      vertex  -7.383187e+00  2.856745e+00  5.886006e+00
    endloop
  endfacet
  facet normal  9.359574e-01  4.244292e-08  3.521134e-01
    outer loop
      vertex  -7.658601e+00  2.655306e+00  6.497398e+00
      vertex  -7.791326e+00  2.561319e+00  6.850196e+00
      vertex  -7.791324e+00 -2.561487e+00  6.850190e+00
    endloop
  endfacet
  facet normal  9.989579e-01 -1.643467e-07  4.564274e-02
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.236569e+00 -2.237564e+00  9.019919e+00
      vertex  -8.236568e+00  2.238081e+00  9.019915e+00
    endloop
  endfacet
  facet normal  9.999993e-01  2.521697e-10  1.167099e-03
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.253727e+00  2.117157e-04  9.752975e+00
      vertex  -8.253299e+00 -2.206669e+00  9.386083e+00
    endloop
  endfacet
  facet normal  9.999835e-01  7.502945e-04  5.680263e-03
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.255363e+00  2.181059e+00  9.753010e+00
      vertex  -8.253727e+00  2.117157e-04  9.752975e+00
    endloop
  endfacet
  facet normal  6.856943e-01  8.361808e-04  7.278891e-01
    outer loop
      vertex  -5.576128e+00  4.319174e+00  3.492131e+00
      vertex  -5.752640e+00  4.179514e+00  3.658571e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
    endloop
  endfacet
  facet normal  7.277182e-01  1.511262e-07  6.858763e-01
    outer loop
      vertex  -5.926451e+00  4.043840e+00  3.832467e+00
      vertex  -6.088440e+00  3.912035e+00  4.004339e+00
      vertex  -5.926527e+00 -4.048138e+00  3.832550e+00
    endloop
  endfacet
  facet normal  6.722521e-01  1.674840e-04  7.403222e-01
    outer loop
      vertex  -5.576128e+00  4.319174e+00  3.492131e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.527053e+00  4.360826e+00  3.447559e+00
    endloop
  endfacet
  facet normal  8.745837e-01 -3.935813e-09  4.848747e-01
    outer loop
      vertex  -7.163397e+00  3.024019e+00  5.475995e+00
      vertex  -7.275784e+00  2.937731e+00  5.678710e+00
      vertex  -7.163385e+00 -3.026060e+00  5.475973e+00
    endloop
  endfacet
  facet normal  1.743021e-01  9.845945e-01 -1.387545e-02
    outer loop
      vertex   1.127824e+00  6.599570e+00  1.402349e+00
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
    endloop
  endfacet
  facet normal  8.555856e-01 -1.655445e-07  5.176613e-01
    outer loop
      vertex  -6.959301e+00  3.184469e+00  5.138667e+00
      vertex  -7.163397e+00  3.024019e+00  5.475995e+00
      vertex  -7.163385e+00 -3.026060e+00  5.475973e+00
    endloop
  endfacet
  facet normal -4.930709e-01 -8.687595e-01  4.623966e-02
    outer loop
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
      vertex  -8.198880e+00 -2.495790e+00  6.145909e+00
      vertex  -8.071532e+00 -2.605118e+00  5.449806e+00
    endloop
  endfacet
  facet normal  2.388486e-01  9.689210e-01  6.436857e-02
    outer loop
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
      vertex   8.447516e+00  2.183165e+00  9.023621e+00
    endloop
  endfacet
  facet normal  8.070552e-01 -5.994735e-06  5.904760e-01
    outer loop
      vertex  -6.581262e+00  3.492887e+00  4.595612e+00
      vertex  -6.742538e+00  3.359671e+00  4.816041e+00
      vertex  -6.582784e+00 -3.495262e+00  4.597621e+00
    endloop
  endfacet
  facet normal  7.871774e-01 -1.096940e-05  6.167266e-01
    outer loop
      vertex  -6.581262e+00  3.492887e+00  4.595612e+00
      vertex  -6.417768e+00 -3.634079e+00  4.386804e+00
      vertex  -6.414639e+00  3.632761e+00  4.382941e+00
    endloop
  endfacet
  facet normal -5.136167e-01 -3.420738e-04  8.580196e-01
    outer loop
      vertex   4.141760e+00  5.453775e+00  2.438705e+00
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
      vertex   4.338367e+00  5.317045e+00  2.556341e+00
    endloop
  endfacet
  facet normal  9.999862e-01 -2.940702e-03  4.372875e-03
    outer loop
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
      vertex   9.627390e+00  4.457207e-01  9.781108e+00
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
    endloop
  endfacet
  facet normal  9.999860e-01 -2.296490e-03  4.770754e-03
    outer loop
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
      vertex   9.629588e+00  6.732941e-04  9.045974e+00
    endloop
  endfacet
  facet normal  7.199306e-01 -1.124365e-06 -6.940461e-01
    outer loop
      vertex  -6.051849e+00  2.181334e+00  1.519486e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
      vertex  -6.051859e+00 -2.180950e+00  1.519485e+01
    endloop
  endfacet
  facet normal  2.340688e-01  9.699180e-01  6.686497e-02
    outer loop
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
      vertex   8.255627e+00  2.180864e+00  9.756488e+00
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
    endloop
  endfacet
  facet normal  2.654179e-01  9.612309e-01  7.475632e-02
    outer loop
      vertex   8.088119e+00  2.358255e+00  7.924740e+00
      vertex   8.154330e+00  2.311567e+00  8.289984e+00
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
    endloop
  endfacet
  facet normal  2.384380e-01  2.978015e-03  9.711531e-01
    outer loop
      vertex   2.749675e+00  4.949570e-04  1.880685e+01
      vertex   1.835788e+00 -4.431973e-01  1.903259e+01
      vertex   2.750051e+00 -4.432201e-01  1.880812e+01
    endloop
  endfacet
  facet normal  4.243744e-01  9.040894e-01  5.028620e-02
    outer loop
      vertex   8.841630e+00  1.986746e+00  9.030819e+00
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
      vertex   8.832999e+00  1.949952e+00  9.765159e+00
    endloop
  endfacet
  facet normal  6.605260e-01  7.494345e-01  4.531287e-02
    outer loop
      vertex   8.841630e+00  1.986746e+00  9.030819e+00
      vertex   8.832999e+00  1.949952e+00  9.765159e+00
      vertex   9.178001e+00  1.689901e+00  9.037074e+00
    endloop
  endfacet
  facet normal  6.470885e-01  7.616299e-01  3.458972e-02
    outer loop
      vertex   9.178001e+00  1.689901e+00  9.037074e+00
      vertex   8.832999e+00  1.949952e+00  9.765159e+00
      vertex   9.171400e+00  1.661978e+00  9.775407e+00
    endloop
  endfacet
  facet normal  2.574692e-01  9.642616e-01  6.252370e-02
    outer loop
      vertex   8.203593e+00  2.272276e+00  8.653778e+00
      vertex   8.447516e+00  2.183165e+00  9.023621e+00
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
    endloop
  endfacet
  facet normal  8.658196e-01 -5.000784e-01 -1.667176e-02
    outer loop
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
      vertex  -4.924090e+00  2.546866e+00 -3.700744e-17
      vertex  -4.642149e+00  3.035010e+00  2.037722e-16
    endloop
  endfacet
  facet normal -6.103031e-02  9.048138e-01  4.214110e-01
    outer loop
      vertex  -8.078656e-01  2.138033e+00  1.797553e+01
      vertex  -1.684469e+00  1.950029e+00  1.825224e+01
      vertex  -8.462134e-01  1.949980e+00  1.837375e+01
    endloop
  endfacet
  facet normal  2.656472e-01  9.616767e-01  6.789283e-02
    outer loop
      vertex   8.154330e+00  2.311567e+00  8.289984e+00
      vertex   8.203593e+00  2.272276e+00  8.653778e+00
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
    endloop
  endfacet
  facet normal  2.963887e-01  9.513661e-01  8.400149e-02
    outer loop
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
    endloop
  endfacet
  facet normal  4.795424e-02  3.009650e-03  9.988450e-01
    outer loop
      vertex   9.219017e-01  5.378723e-04  1.916359e+01
      vertex  -1.960567e-04  5.588531e-04  1.920786e+01
      vertex  -1.979089e-04 -4.431534e-01  1.920920e+01
    endloop
  endfacet
  facet normal  2.712762e-01  9.600275e-01  6.896612e-02
    outer loop
      vertex   8.088119e+00  2.358255e+00  7.924740e+00
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
    endloop
  endfacet
  facet normal  3.371025e-01  9.317955e-01  1.346067e-01
    outer loop
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
      vertex   7.902397e+00  2.533552e+00  6.850276e+00
    endloop
  endfacet
  facet normal  2.313527e-01  9.626877e-01  1.403863e-01
    outer loop
      vertex   7.791419e+00  2.560247e+00  6.850104e+00
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
      vertex   7.902397e+00  2.533552e+00  6.850276e+00
    endloop
  endfacet
  facet normal  2.884502e-01  9.378369e-01  1.930241e-01
    outer loop
      vertex   7.382584e+00  2.855700e+00  5.884530e+00
      vertex   7.511272e+00  2.760725e+00  6.153669e+00
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
    endloop
  endfacet
  facet normal  2.895001e-01  9.422727e-01  1.682615e-01
    outer loop
      vertex   7.658692e+00  2.654070e+00  6.497303e+00
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
      vertex   7.511272e+00  2.760725e+00  6.153669e+00
    endloop
  endfacet
  facet normal  3.595970e-01  9.171966e-01  1.715820e-01
    outer loop
      vertex   7.275499e+00  2.936335e+00  5.677919e+00
      vertex   7.382584e+00  2.855700e+00  5.884530e+00
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
    endloop
  endfacet
  facet normal  3.206331e-01  9.368079e-01  1.399471e-01
    outer loop
      vertex   7.382584e+00  2.855700e+00  5.884530e+00
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
    endloop
  endfacet
  facet normal  9.509748e-01 -1.693494e-07  3.092684e-01
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
      vertex  -7.791326e+00  2.561319e+00  6.850196e+00
    endloop
  endfacet
  facet normal -3.312771e-01 -6.210688e-01  7.103021e-01
    outer loop
      vertex  -3.523293e+00 -1.470545e+00  1.821354e+01
      vertex  -4.349491e+00 -1.470572e+00  1.782819e+01
      vertex  -4.278516e+00 -1.662261e+00  1.769369e+01
    endloop
  endfacet
  facet normal  3.471805e-01  9.168116e-01  1.972869e-01
    outer loop
      vertex   7.163462e+00  3.022242e+00  5.475860e+00
      vertex   7.275499e+00  2.936335e+00  5.677919e+00
      vertex   7.323770e+00  2.962626e+00  5.470797e+00
    endloop
  endfacet
  facet normal  6.887344e-01 -7.181396e-01 -9.960147e-02
    outer loop
      vertex   7.043986e+00 -3.198912e+00  2.716952e+00
      vertex   6.932614e+00 -3.405245e+00  3.434518e+00
      vertex   6.737225e+00 -3.494104e+00  2.724110e+00
    endloop
  endfacet
  facet normal  4.003343e-01  9.026028e-01  1.582421e-01
    outer loop
      vertex   6.959351e+00  3.182512e+00  5.138515e+00
      vertex   7.323770e+00  2.962626e+00  5.470797e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
    endloop
  endfacet
  facet normal  5.129408e-01  8.454102e-01  1.489073e-01
    outer loop
      vertex   6.237039e+00  3.781313e+00  4.170912e+00
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
    endloop
  endfacet
  facet normal -1.560013e-01 -4.673961e-04  9.877568e-01
    outer loop
      vertex   1.127824e+00  6.599570e+00  1.402349e+00
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
      vertex   1.446853e+00  6.542452e+00  1.452708e+00
    endloop
  endfacet
  facet normal  8.435516e-01 -2.837054e-01 -4.559956e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   6.651994e+00 -2.146391e+00  5.689535e-01
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
    endloop
  endfacet
  facet normal  5.935277e-01 -3.236653e-04  8.048134e-01
    outer loop
      vertex  -4.968631e+00 -4.836309e+00  2.987150e+00
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
      vertex  -5.020278e+00 -2.201843e+00  3.026298e+00
    endloop
  endfacet
  facet normal -8.794853e-01  1.800448e-02 -4.755853e-01
    outer loop
      vertex  -7.378439e+00  1.985550e-03  1.241728e+00
      vertex  -7.369229e+00  4.808502e-01  1.242824e+00
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
    endloop
  endfacet
  facet normal -8.742248e-01  7.542729e-02 -4.796266e-01
    outer loop
      vertex  -7.330915e+00  9.558201e-01  1.245726e+00
      vertex  -6.962196e+00  8.877678e-01  5.629520e-01
      vertex  -6.999551e+00  4.475117e-01  5.618038e-01
    endloop
  endfacet
  facet normal  5.091427e-01  8.462395e-01  1.570109e-01
    outer loop
      vertex   6.413812e+00  3.631025e+00  4.381729e+00
      vertex   6.580883e+00  3.490953e+00  4.594908e+00
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
    endloop
  endfacet
  facet normal  5.450168e-01  8.254675e-01  1.468333e-01
    outer loop
      vertex   6.088405e+00  3.909117e+00  4.004127e+00
      vertex   6.237039e+00  3.781313e+00  4.170912e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
    endloop
  endfacet
  facet normal -6.310851e-01 -3.133991e-01  7.095862e-01
    outer loop
      vertex  -6.018261e+00 -8.839493e-01  1.703736e+01
      vertex  -6.704895e+00 -8.839283e-01  1.642670e+01
      vertex  -6.634205e+00 -1.189585e+00  1.635457e+01
    endloop
  endfacet
  facet normal  5.291952e-01  8.366439e-01  1.413482e-01
    outer loop
      vertex   5.926354e+00  4.040663e+00  3.832204e+00
      vertex   6.088405e+00  3.909117e+00  4.004127e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
    endloop
  endfacet
  facet normal  5.280333e-01  8.470955e-01  6.008416e-02
    outer loop
      vertex   5.575973e+00  4.315458e+00  3.491837e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
    endloop
  endfacet
  facet normal  5.226992e-01  8.420669e-01  1.330752e-01
    outer loop
      vertex   5.752496e+00  4.176069e+00  3.658274e+00
      vertex   5.926354e+00  4.040663e+00  3.832204e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
    endloop
  endfacet
  facet normal -7.400927e-01 -6.215209e-01 -2.568551e-01
    outer loop
      vertex  -5.620892e+00 -3.918224e+00  5.863695e-01
      vertex  -5.783556e+00 -4.023340e+00  1.309416e+00
      vertex  -6.308788e+00 -3.388851e+00  1.287506e+00
    endloop
  endfacet
  facet normal  5.251681e-01  8.385112e-01  1.452494e-01
    outer loop
      vertex   5.575973e+00  4.315458e+00  3.491837e+00
      vertex   5.752496e+00  4.176069e+00  3.658274e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
    endloop
  endfacet
  facet normal  5.499578e-01  8.184963e-01  1.661636e-01
    outer loop
      vertex   5.343349e+00  4.512934e+00  3.286766e+00
      vertex   5.525450e+00  4.358259e+00  3.445965e+00
      vertex   5.425769e+00  4.556772e+00  2.798037e+00
    endloop
  endfacet
  facet normal  9.168558e-01 -7.552402e-02 -3.920098e-01
    outer loop
      vertex   8.083327e+00 -5.267620e-01  2.648672e+00
      vertex   8.373710e+00 -5.302849e-01  3.328514e+00
      vertex   8.333261e+00 -1.052835e+00  3.334583e+00
    endloop
  endfacet
  facet normal  5.810961e-01  8.060783e-01  1.120945e-01
    outer loop
      vertex   5.575973e+00  4.315458e+00  3.491837e+00
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
      vertex   5.525450e+00  4.358259e+00  3.445965e+00
    endloop
  endfacet
  facet normal -2.862408e-01  9.546326e-01  8.211279e-02
    outer loop
      vertex  -8.005733e+00  2.414618e+00  7.563975e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
      vertex  -8.088025e+00  2.358904e+00  7.924828e+00
    endloop
  endfacet
  facet normal -2.656427e-01  9.611471e-01  7.503475e-02
    outer loop
      vertex  -8.088025e+00  2.358904e+00  7.924828e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
      vertex  -8.154238e+00  2.312090e+00  8.290074e+00
    endloop
  endfacet
  facet normal -2.714634e-01  9.599516e-01  6.928652e-02
    outer loop
      vertex  -8.088025e+00  2.358904e+00  7.924828e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
    endloop
  endfacet
  facet normal -2.390649e-01  9.688529e-01  6.459279e-02
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
    endloop
  endfacet
  facet normal  7.277240e-01  4.027295e-07  6.858701e-01
    outer loop
      vertex  -6.088440e+00  3.912035e+00  4.004339e+00
      vertex  -6.088506e+00 -3.916286e+00  4.004413e+00
      vertex  -5.926527e+00 -4.048138e+00  3.832550e+00
    endloop
  endfacet
  facet normal -8.554474e-01  5.175232e-01  1.948051e-02
    outer loop
      vertex  -9.427529e+00  1.298449e+00  9.776813e+00
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
    endloop
  endfacet
  facet normal -9.999872e-01 -2.580862e-03  4.326802e-03
    outer loop
      vertex  -9.630352e+00  4.547825e-01  9.045909e+00
      vertex  -9.626000e+00  7.368724e-04  9.780801e+00
      vertex  -9.627151e+00  4.464064e-01  9.780823e+00
    endloop
  endfacet
  facet normal -8.766641e-02 -9.645228e-01  2.490187e-01
    outer loop
      vertex  -2.741698e+00 -2.180965e+00  1.736673e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
    endloop
  endfacet
  facet normal -5.297477e-01  8.361889e-01  1.419694e-01
    outer loop
      vertex  -5.926451e+00  4.043840e+00  3.832467e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
      vertex  -6.088440e+00  3.912035e+00  4.004339e+00
    endloop
  endfacet
  facet normal -4.341349e-01  8.812510e-01  1.868789e-01
    outer loop
      vertex  -6.959301e+00  3.184469e+00  5.138667e+00
      vertex  -6.742538e+00  3.359671e+00  4.816041e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
    endloop
  endfacet
  facet normal -5.692092e-01  8.126404e-01  1.249652e-01
    outer loop
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
      vertex  -4.967633e+00  4.832796e+00  2.986400e+00
      vertex  -4.773370e+00  4.990690e+00  2.844480e+00
    endloop
  endfacet
  facet normal -2.883858e-01  9.377614e-01  1.934872e-01
    outer loop
      vertex  -7.511187e+00  2.762133e+00  6.153776e+00
      vertex  -7.383187e+00  2.856745e+00  5.886006e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
    endloop
  endfacet
  facet normal -2.313554e-01  9.626279e-01  1.407907e-01
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -7.791326e+00  2.561319e+00  6.850196e+00
      vertex  -7.902413e+00  2.534609e+00  6.850279e+00
    endloop
  endfacet
  facet normal -3.372733e-01  9.316735e-01  1.350225e-01
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -7.902413e+00  2.534609e+00  6.850279e+00
      vertex  -8.300170e+00  2.390478e+00  6.851242e+00
    endloop
  endfacet
  facet normal -3.457323e-01  9.111531e-01  2.242082e-01
    outer loop
      vertex  -7.324272e+00  2.964247e+00  5.470831e+00
      vertex  -7.163397e+00  3.024019e+00  5.475995e+00
      vertex  -6.959301e+00  3.184469e+00  5.138667e+00
    endloop
  endfacet
  facet normal -3.203828e-01  9.368072e-01  1.405252e-01
    outer loop
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
      vertex  -7.383187e+00  2.856745e+00  5.886006e+00
    endloop
  endfacet
  facet normal  5.347182e-01  8.403409e-01  8.890308e-02
    outer loop
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   4.966979e+00  4.828844e+00  2.985777e+00
      vertex   5.425769e+00  4.556772e+00  2.798037e+00
    endloop
  endfacet
  facet normal  5.352305e-01  8.297205e-01  1.584053e-01
    outer loop
      vertex   4.680184e+00  5.115396e+00  2.486569e+00
      vertex   4.529514e+00  5.176035e+00  2.678042e+00
      vertex   4.715715e+00  5.031897e+00  2.803882e+00
    endloop
  endfacet
  facet normal -9.036920e-01 -1.853986e-01 -3.859640e-01
    outer loop
      vertex  -7.944685e+00 -1.554760e+00  2.664340e+00
      vertex  -8.333854e+00 -1.053164e+00  3.334592e+00
      vertex  -8.044674e+00 -1.047447e+00  2.654763e+00
    endloop
  endfacet
  facet normal  5.247000e-01  8.384362e-01  1.473586e-01
    outer loop
      vertex   4.680184e+00  5.115396e+00  2.486569e+00
      vertex   4.338367e+00  5.317045e+00  2.556341e+00
      vertex   4.529514e+00  5.176035e+00  2.678042e+00
    endloop
  endfacet
  facet normal -9.599141e-01 -2.965622e-03 -2.802787e-01
    outer loop
      vertex  -8.875355e+00 -5.201721e-01  4.715995e+00
      vertex  -9.081449e+00 -5.084209e-01  5.421712e+00
      vertex  -9.082709e+00 -2.098083e-05  5.420651e+00
    endloop
  endfacet
  facet normal -8.709102e-01 -4.877576e-01  6.006399e-02
    outer loop
      vertex  -9.417384e+00 -1.189667e+00  1.068511e+01
      vertex  -9.479942e+00 -1.189680e+00  9.777925e+00
      vertex  -9.261168e+00 -1.470842e+00  1.066687e+01
    endloop
  endfacet
  facet normal  5.278842e-01  8.473675e-01  5.750289e-02
    outer loop
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   3.926537e+00  5.606951e+00  2.157274e+00
      vertex   4.141760e+00  5.453775e+00  2.438705e+00
    endloop
  endfacet
  facet normal -2.324645e-01  9.718354e-01  3.868089e-02
    outer loop
      vertex  -8.243571e+00  2.138269e+00  1.136140e+01
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -8.376205e+00  2.138299e+00  1.056355e+01
    endloop
  endfacet
  facet normal  3.907484e-01  9.186644e-01 -5.806310e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
      vertex   3.161976e+00  5.992579e+00  1.805074e+00
    endloop
  endfacet
  facet normal  4.707130e-01  8.819845e-01 -2.308124e-02
    outer loop
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   3.410246e+00  5.879915e+00  2.062027e+00
      vertex   3.644418e+00  5.757833e+00  2.172665e+00
    endloop
  endfacet
  facet normal  4.568438e-01  8.880230e-01 -5.204613e-02
    outer loop
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   3.161976e+00  5.992579e+00  1.805074e+00
      vertex   3.410246e+00  5.879915e+00  2.062027e+00
    endloop
  endfacet
  facet normal  4.351369e-01  8.999939e-01 -2.582381e-02
    outer loop
      vertex   3.161976e+00  5.992579e+00  1.805074e+00
      vertex   3.169260e+00  5.993425e+00  1.957336e+00
      vertex   3.410246e+00  5.879915e+00  2.062027e+00
    endloop
  endfacet
  facet normal  3.473620e-01  9.367895e-01 -4.201162e-02
    outer loop
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
      vertex   2.392633e+00  6.292719e+00  1.679182e+00
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
    endloop
  endfacet
  facet normal  2.407907e-01  9.705760e-01  1.456793e-03
    outer loop
      vertex   1.820081e+00  6.455732e+00  1.445411e+00
      vertex   1.604250e+00  6.509223e+00  1.482296e+00
      vertex   2.003154e+00  6.410124e+00  1.571624e+00
    endloop
  endfacet
  facet normal  1.779897e-01  9.839646e-01 -1.155373e-02
    outer loop
      vertex   1.127824e+00  6.599570e+00  1.402349e+00
      vertex   1.446853e+00  6.542452e+00  1.452708e+00
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
    endloop
  endfacet
  facet normal  2.878428e-01  9.549336e-01 -7.244504e-02
    outer loop
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
      vertex   1.820081e+00  6.455732e+00  1.445411e+00
      vertex   2.003154e+00  6.410124e+00  1.571624e+00
    endloop
  endfacet
  facet normal -2.647717e-02 -9.989901e-01  3.630110e-02
    outer loop
      vertex  -4.870253e+00  2.181326e+00  1.624569e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
    endloop
  endfacet
  facet normal  3.743452e-01  9.242418e-01 -7.511744e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
    endloop
  endfacet
  facet normal  6.669168e-01  6.197942e-01  4.136146e-01
    outer loop
      vertex   8.022988e+00  1.661601e+00  1.402842e+01
      vertex   7.676747e+00  1.467287e+00  1.487788e+01
      vertex   8.157441e+00  1.467236e+00  1.410288e+01
    endloop
  endfacet
  facet normal  2.076408e-01  9.781867e-01 -6.003758e-03
    outer loop
      vertex   1.446853e+00  6.542452e+00  1.452708e+00
      vertex   1.604250e+00  6.509223e+00  1.482296e+00
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
    endloop
  endfacet
  facet normal  9.359571e-01  6.835405e-08  3.521137e-01
    outer loop
      vertex  -7.658601e+00  2.655306e+00  6.497398e+00
      vertex  -7.791324e+00 -2.561487e+00  6.850190e+00
      vertex  -7.658592e+00 -2.655830e+00  6.497374e+00
    endloop
  endfacet
  facet normal -2.892343e-01  9.570627e-01 -1.934784e-02
    outer loop
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
      vertex  -1.820179e+00  6.458174e+00  1.445504e+00
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
    endloop
  endfacet
  facet normal -5.602886e-01 -3.133855e-01  7.667243e-01
    outer loop
      vertex  -5.276351e+00 -8.839722e-01  1.757950e+01
      vertex  -5.954819e+00 -1.189575e+00  1.695880e+01
      vertex  -5.220737e+00 -1.189564e+00  1.749524e+01
    endloop
  endfacet
  facet normal -2.874364e-01  9.551694e-01 -7.093361e-02
    outer loop
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
      vertex  -2.003711e+00  6.412324e+00  1.571811e+00
      vertex  -1.820179e+00  6.458174e+00  1.445504e+00
    endloop
  endfacet
  facet normal -3.723448e-01  9.251123e-01 -7.434060e-02
    outer loop
      vertex  -3.144492e+00  5.979891e+00  1.410066e+00
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
    endloop
  endfacet
  facet normal -3.453996e-01  9.375437e-01 -4.136255e-02
    outer loop
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
      vertex  -2.393248e+00  6.295172e+00  1.679424e+00
    endloop
  endfacet
  facet normal -5.501126e-01  8.182399e-01  1.669117e-01
    outer loop
      vertex  -5.344672e+00  4.515985e+00  3.288033e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
      vertex  -5.527053e+00  4.360826e+00  3.447559e+00
    endloop
  endfacet
  facet normal  2.916451e-02 -1.673158e-03  9.995733e-01
    outer loop
      vertex  -4.043255e-01 -6.678886e+00  1.334889e+00
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
    endloop
  endfacet
  facet normal -2.310992e-01  9.711513e-01 -5.880725e-02
    outer loop
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
    endloop
  endfacet
  facet normal -8.273277e-02  9.965612e-01  4.581507e-03
    outer loop
      vertex  -8.056749e-01  6.646356e+00  1.364390e+00
      vertex  -4.039023e-01  6.679846e+00  1.334868e+00
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
    endloop
  endfacet
  facet normal  5.114272e-01 -8.419012e-01  1.721761e-01
    outer loop
      vertex   6.237068e+00 -3.785059e+00  4.170946e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
      vertex   6.416894e+00 -3.631935e+00  4.385535e+00
    endloop
  endfacet
  facet normal -5.090844e-01  3.076921e-03  8.607112e-01
    outer loop
      vertex  -4.490940e+00  6.666183e-04  1.809628e+01
      vertex  -5.301142e+00  6.875992e-04  1.761707e+01
      vertex  -5.301896e+00 -4.430199e-01  1.761821e+01
    endloop
  endfacet
  facet normal -2.579502e-02  9.996420e-01  7.093097e-03
    outer loop
      vertex  -4.039023e-01  6.679846e+00  1.334868e+00
      vertex   4.720593e-05  6.690340e+00  1.324984e+00
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
    endloop
  endfacet
  facet normal  2.349191e-01 -9.718245e-01  1.923924e-02
    outer loop
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
      vertex   1.441300e+00 -6.508503e+00  1.031293e-15
      vertex   1.754346e+00 -6.432830e+00  1.721713e-15
    endloop
  endfacet
  facet normal -9.106102e-01 -1.150587e-02 -4.131062e-01
    outer loop
      vertex  -7.936165e+00 -2.708435e-04  2.309898e+00
      vertex  -7.930489e+00 -5.212479e-01  2.311898e+00
      vertex  -8.088883e+00 -6.465912e-04  2.646546e+00
    endloop
  endfacet
  facet normal -5.616421e-02  9.983634e-01 -1.077835e-02
    outer loop
      vertex  -4.039023e-01  6.679846e+00  1.334868e+00
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
    endloop
  endfacet
  facet normal -2.255070e-01  9.720470e-01 -6.535462e-02
    outer loop
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
      vertex  -1.820179e+00  6.458174e+00  1.445504e+00
    endloop
  endfacet
  facet normal -7.031984e-01  6.210633e-01  3.461104e-01
    outer loop
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
      vertex  -8.559678e+00  1.468428e+00  1.328400e+01
      vertex  -8.157006e+00  1.468376e+00  1.410220e+01
    endloop
  endfacet
  facet normal -1.092512e-01 -9.814888e-01  1.573017e-01
    outer loop
      vertex  -4.870266e+00 -2.180956e+00  1.624568e+01
      vertex  -4.545118e+00 -2.180956e+00  1.647151e+01
      vertex  -4.564079e+00 -2.174232e+00  1.650029e+01
    endloop
  endfacet
  facet normal -5.375763e-01  8.395171e-01  7.888483e-02
    outer loop
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
      vertex  -4.340185e+00  5.320688e+00  2.557577e+00
      vertex  -4.143497e+00  5.457701e+00  2.439818e+00
    endloop
  endfacet
  facet normal -3.732193e-01  9.127957e-01  1.658658e-01
    outer loop
      vertex  -7.324272e+00  2.964247e+00  5.470831e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
    endloop
  endfacet
  facet normal -5.250654e-01  8.381091e-01  1.479170e-01
    outer loop
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
      vertex  -4.531404e+00  5.179392e+00  2.679399e+00
      vertex  -4.340185e+00  5.320688e+00  2.557577e+00
    endloop
  endfacet
  facet normal  6.722463e-01  7.402596e-01 -1.003302e-02
    outer loop
      vertex  -3.842140e+00 -3.973835e+00  2.273273e+00
      vertex  -3.450266e+00 -4.332319e+00  2.080311e+00
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
    endloop
  endfacet
  facet normal  8.777958e-01  4.341292e-01 -2.025001e-01
    outer loop
      vertex   8.503082e+00  1.978765e+00  4.736118e+00
      vertex   8.689773e+00  1.927053e+00  5.434519e+00
      vertex   8.906188e+00  1.486849e+00  5.428903e+00
    endloop
  endfacet
  facet normal -5.453697e-01  8.235170e-01  1.561781e-01
    outer loop
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
      vertex  -4.773370e+00  4.990690e+00  2.844480e+00
      vertex  -4.717629e+00  5.035028e+00  2.805334e+00
    endloop
  endfacet
  facet normal -5.760202e-01  8.050572e-01  1.417168e-01
    outer loop
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
      vertex  -4.773370e+00  4.990690e+00  2.844480e+00
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
    endloop
  endfacet
  facet normal -5.346671e-01  8.403209e-01  8.939765e-02
    outer loop
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
      vertex  -4.967633e+00  4.832796e+00  2.986400e+00
    endloop
  endfacet
  facet normal -9.999840e-01  3.073506e-03  4.753590e-03
    outer loop
      vertex  -9.629494e+00  6.732941e-04  9.045976e+00
      vertex  -9.627370e+00 -4.448690e-01  9.780826e+00
      vertex  -9.626000e+00  7.368724e-04  9.780801e+00
    endloop
  endfacet
  facet normal -9.999871e-01  2.503682e-03  4.408114e-03
    outer loop
      vertex  -9.630630e+00 -4.532566e-01  9.045915e+00
      vertex  -9.627370e+00 -4.448690e-01  9.780826e+00
      vertex  -9.629494e+00  6.732941e-04  9.045976e+00
    endloop
  endfacet
  facet normal -7.826504e-01 -6.216931e-01  3.091948e-02
    outer loop
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
      vertex  -9.178523e+00 -1.689043e+00  9.037090e+00
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
    endloop
  endfacet
  facet normal  9.880753e-01  1.521475e-01 -2.363264e-02
    outer loop
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
      vertex  -5.344566e+00 -1.140627e+00  3.287794e+00
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
    endloop
  endfacet
  facet normal  5.531578e-01  8.162677e-01  1.665034e-01
    outer loop
      vertex   5.157131e+00  4.670424e+00  3.133343e+00
      vertex   5.343349e+00  4.512934e+00  3.286766e+00
      vertex   5.425769e+00  4.556772e+00  2.798037e+00
    endloop
  endfacet
  facet normal  9.805972e-01 -6.450315e-04 -1.960323e-01
    outer loop
      vertex   9.257847e+00  3.471375e-04  6.134778e+00
      vertex   9.401924e+00  6.008148e-04  6.855484e+00
      vertex   9.401635e+00 -4.805756e-01  6.855621e+00
    endloop
  endfacet
  facet normal -9.946046e-01 -1.035376e-01  6.458827e-03
    outer loop
      vertex  -9.630630e+00 -4.532566e-01  9.045915e+00
      vertex  -9.584477e+00 -8.966770e-01  9.044888e+00
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
    endloop
  endfacet
  facet normal -9.138627e-01 -4.026211e-01  5.245167e-02
    outer loop
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
      vertex  -9.432609e+00 -1.316837e+00  9.041911e+00
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
    endloop
  endfacet
  facet normal -2.243279e-01  9.696589e-01 -9.715319e-02
    outer loop
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
      vertex  -1.820179e+00  6.458174e+00  1.445504e+00
      vertex  -1.604877e+00  6.511686e+00  1.482458e+00
    endloop
  endfacet
  facet normal  7.290647e-01  1.047338e-01  6.763842e-01
    outer loop
      vertex   7.329475e+00  8.849373e-01  1.575328e+01
      vertex   6.704513e+00  8.849583e-01  1.642692e+01
      vertex   6.737047e+00  4.440575e-01  1.646012e+01
    endloop
  endfacet
  facet normal -6.613501e-01 -7.493072e-01  3.398266e-02
    outer loop
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
      vertex  -9.178523e+00 -1.689043e+00  9.037090e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
    endloop
  endfacet
  facet normal -6.463026e-01 -7.616913e-01  4.603536e-02
    outer loop
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
      vertex  -8.832759e+00 -1.949820e+00  9.764791e+00
    endloop
  endfacet
  facet normal -7.036734e-01  7.088835e-01 -4.824802e-02
    outer loop
      vertex  -8.978601e+00  1.807972e+00  6.853913e+00
      vertex  -9.078510e+00  1.757957e+00  7.576210e+00
      vertex  -8.755844e+00  2.077982e+00  7.572240e+00
    endloop
  endfacet
  facet normal -2.656122e-01 -9.611403e-01  7.522894e-02
    outer loop
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
      vertex  -8.154238e+00 -2.311592e+00  8.290080e+00
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
    endloop
  endfacet
  facet normal -2.491001e-01 -9.659359e-01  7.012045e-02
    outer loop
      vertex  -8.253299e+00 -2.206669e+00  9.386083e+00
      vertex  -8.448242e+00 -2.182707e+00  9.023640e+00
      vertex  -8.236569e+00 -2.237564e+00  9.019919e+00
    endloop
  endfacet
  facet normal -2.714348e-01 -9.599474e-01  6.945604e-02
    outer loop
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
    endloop
  endfacet
  facet normal -2.856694e-01 -9.531069e-01  9.990118e-02
    outer loop
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
      vertex  -8.005733e+00 -2.414318e+00  7.563979e+00
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
    endloop
  endfacet
  facet normal -2.306216e-01 -9.581747e-01  1.694548e-01
    outer loop
      vertex  -7.658592e+00 -2.655830e+00  6.497374e+00
      vertex  -7.791324e+00 -2.561487e+00  6.850190e+00
      vertex  -7.903955e+00 -2.534363e+00  6.850277e+00
    endloop
  endfacet
  facet normal -5.564808e-01 -8.304210e-01  2.701845e-02
    outer loop
      vertex  -6.933262e+00 -3.407667e+00  3.434591e+00
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
      vertex  -7.421945e+00 -3.058773e+00  4.092888e+00
    endloop
  endfacet
  facet normal -3.201598e-01 -9.367181e-01  1.416227e-01
    outer loop
      vertex  -7.385486e+00 -2.856359e+00  5.890606e+00
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
    endloop
  endfacet
  facet normal  4.930522e-01  8.665876e-01 -7.697582e-02
    outer loop
      vertex   3.868523e+00  5.588697e+00  1.385323e+00
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
    endloop
  endfacet
  facet normal -5.127153e-01 -8.452395e-01  1.506427e-01
    outer loop
      vertex  -6.237097e+00 -3.788153e+00  4.171160e+00
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
    endloop
  endfacet
  facet normal -5.447161e-01 -8.253151e-01  1.487925e-01
    outer loop
      vertex  -6.088506e+00 -3.916286e+00  4.004413e+00
      vertex  -6.237097e+00 -3.788153e+00  4.171160e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
    endloop
  endfacet
  facet normal -5.498123e-01 -8.183734e-01  1.672465e-01
    outer loop
      vertex  -5.530277e+00 -4.362434e+00  3.450466e+00
      vertex  -5.430634e+00 -4.562702e+00  2.798081e+00
      vertex  -5.347189e+00 -4.518198e+00  3.290170e+00
    endloop
  endfacet
  facet normal  9.960581e-01 -1.789838e-07 -8.870343e-02
    outer loop
      vertex  -8.200814e+00  2.181055e+00  1.054299e+01
      vertex  -8.235943e+00 -2.180941e+00  1.014854e+01
      vertex  -8.235942e+00  2.181364e+00  1.014854e+01
    endloop
  endfacet
  facet normal -5.689535e-01 -8.128294e-01  1.249009e-01
    outer loop
      vertex  -4.773528e+00 -4.994781e+00  2.844591e+00
      vertex  -4.968631e+00 -4.836309e+00  2.987150e+00
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
    endloop
  endfacet
  facet normal  2.375053e-01 -9.691740e-01  6.552067e-02
    outer loop
      vertex   8.253390e+00 -2.206724e+00  9.385991e+00
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
      vertex   8.268659e+00 -2.178129e+00  9.753622e+00
    endloop
  endfacet
  facet normal  2.493220e-01 -9.659883e-01  6.859285e-02
    outer loop
      vertex   8.203593e+00 -2.272078e+00  8.653785e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
      vertex   8.236661e+00 -2.237551e+00  9.019829e+00
    endloop
  endfacet
  facet normal  2.492761e-01 -9.659045e-01  6.992880e-02
    outer loop
      vertex   8.253390e+00 -2.206724e+00  9.385991e+00
      vertex   8.236661e+00 -2.237551e+00  9.019829e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
    endloop
  endfacet
  facet normal  2.577296e-01 -9.641864e-01  6.261007e-02
    outer loop
      vertex   8.203593e+00 -2.272078e+00  8.653785e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
    endloop
  endfacet
  facet normal  4.452013e-01 -8.940322e-01  5.002085e-02
    outer loop
      vertex   8.833118e+00 -1.949384e+00  9.765130e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
      vertex   8.842025e+00 -1.986032e+00  9.030830e+00
    endloop
  endfacet
  facet normal -3.375516e-01 -9.311424e-01  1.379595e-01
    outer loop
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
      vertex  -7.903955e+00 -2.534363e+00  6.850277e+00
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
    endloop
  endfacet
  facet normal  4.241439e-02 -1.653140e-02 -9.989633e-01
    outer loop
      vertex   9.427947e+00 -1.297487e+00  9.776816e+00
      vertex   9.323505e+00 -1.470018e+00  9.775237e+00
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
    endloop
  endfacet
  facet normal  3.580001e-02 -7.265052e-04 -9.993587e-01
    outer loop
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
      vertex   9.627322e+00 -4.434872e-01  9.781425e+00
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
    endloop
  endfacet
  facet normal  8.253641e-01 -5.642306e-01  2.044421e-02
    outer loop
      vertex   9.427947e+00 -1.297487e+00  9.776816e+00
      vertex   9.178670e+00 -1.688936e+00  9.037090e+00
      vertex   9.432705e+00 -1.317156e+00  9.041909e+00
    endloop
  endfacet
  facet normal  1.429144e-02  3.349356e-03  9.998924e-01
    outer loop
      vertex  -9.427529e+00  1.298449e+00  9.776813e+00
      vertex  -9.480475e+00  1.189270e+00  9.777935e+00
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
    endloop
  endfacet
  facet normal  8.172187e-01 -5.755876e-01  2.919896e-02
    outer loop
      vertex   9.427947e+00 -1.297487e+00  9.776816e+00
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
      vertex   9.178670e+00 -1.688936e+00  9.037090e+00
    endloop
  endfacet
  facet normal  9.979988e-01 -5.092106e-02  3.748948e-02
    outer loop
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
      vertex   9.630534e+00 -4.535618e-01  9.045911e+00
    endloop
  endfacet
  facet normal  9.999864e-01  2.082031e-03  4.772461e-03
    outer loop
      vertex   9.629588e+00  6.732941e-04  9.045974e+00
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
      vertex   9.630534e+00 -4.535618e-01  9.045911e+00
    endloop
  endfacet
  facet normal  4.676222e-01 -8.779190e-01  1.028967e-01
    outer loop
      vertex   6.582376e+00 -3.492981e+00  4.596881e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
    endloop
  endfacet
  facet normal  3.995564e-01 -9.026875e-01  1.597179e-01
    outer loop
      vertex   7.325849e+00 -2.964117e+00  5.470715e+00
      vertex   6.959345e+00 -3.185122e+00  5.138508e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
    endloop
  endfacet
  facet normal -1.413749e-01  9.048480e-01  4.015760e-01
    outer loop
      vertex  -2.408869e+00  2.138071e+00  1.766289e+01
      vertex  -3.186596e+00  2.138090e+00  1.738905e+01
      vertex  -3.337810e+00  1.950125e+00  1.775935e+01
    endloop
  endfacet
  facet normal  5.745851e-01  2.318615e-04  8.184447e-01
    outer loop
      vertex  -4.773370e+00  4.990690e+00  2.844480e+00
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
      vertex  -4.717629e+00  5.035028e+00  2.805334e+00
    endloop
  endfacet
  facet normal -3.108347e-02  7.616558e-01  6.472359e-01
    outer loop
      vertex  -1.667350e-04  1.949934e+00  1.841449e+01
      vertex  -8.786176e-01  1.662752e+00  1.871025e+01
      vertex  -1.770278e-04  1.662657e+00  1.875255e+01
    endloop
  endfacet
  facet normal  3.452971e-01 -9.110824e-01  2.251637e-01
    outer loop
      vertex   7.325849e+00 -2.964117e+00  5.470715e+00
      vertex   7.163453e+00 -3.024397e+00  5.475844e+00
      vertex   6.959345e+00 -3.185122e+00  5.138508e+00
    endloop
  endfacet
  facet normal  3.729715e-01 -9.127571e-01  1.666332e-01
    outer loop
      vertex   7.325849e+00 -2.964117e+00  5.470715e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
    endloop
  endfacet
  facet normal  5.278242e-01 -8.472285e-01  6.004777e-02
    outer loop
      vertex   5.576082e+00 -4.319799e+00  3.491938e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
    endloop
  endfacet
  facet normal -3.384217e-01 -9.048180e-01  2.584089e-01
    outer loop
      vertex  -6.757536e+00 -1.949457e+00  1.527148e+01
      vertex  -7.271570e+00 -1.949509e+00  1.459810e+01
      vertex  -6.941944e+00 -2.137688e+00  1.437088e+01
    endloop
  endfacet
  facet normal -6.002836e-01  7.986699e-01  4.226011e-02
    outer loop
      vertex  -5.312944e+00  4.666594e+00  2.075194e+00
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
    endloop
  endfacet
  facet normal  5.290419e-01 -8.365609e-01  1.424093e-01
    outer loop
      vertex   6.088456e+00 -3.913052e+00  4.004183e+00
      vertex   5.926448e+00 -4.044765e+00  3.832300e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
    endloop
  endfacet
  facet normal -6.721240e-01  1.745261e-04  7.404386e-01
    outer loop
      vertex   5.575973e+00  4.315458e+00  3.491837e+00
      vertex   5.525450e+00  4.358259e+00  3.445965e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
    endloop
  endfacet
  facet normal  5.249193e-01 -8.385379e-01  1.459926e-01
    outer loop
      vertex   5.752617e+00 -4.180309e+00  3.658392e+00
      vertex   5.576082e+00 -4.319799e+00  3.491938e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
    endloop
  endfacet
  facet normal  2.656715e-01 -9.611455e-01  7.495344e-02
    outer loop
      vertex   8.088120e+00 -2.358206e+00  7.924744e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
      vertex   8.154332e+00 -2.311420e+00  8.289993e+00
    endloop
  endfacet
  facet normal -4.203565e-01  1.047321e-01  9.012945e-01
    outer loop
      vertex  -3.620762e+00  8.852310e-01  1.845226e+01
      vertex  -4.491520e+00  4.443474e-01  1.809738e+01
      vertex  -3.638337e+00  4.443245e-01  1.849530e+01
    endloop
  endfacet
  facet normal  5.809336e-01 -8.061455e-01  1.124521e-01
    outer loop
      vertex   5.529263e+00 -4.359472e+00  3.449402e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
      vertex   5.576082e+00 -4.319799e+00  3.491938e+00
    endloop
  endfacet
  facet normal  2.311423e-01 -9.626281e-01  1.411396e-01
    outer loop
      vertex   7.791418e+00 -2.560793e+00  6.850099e+00
      vertex   7.903616e+00 -2.533827e+00  6.850272e+00
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
    endloop
  endfacet
  facet normal  9.675743e-01 -8.847914e-02 -2.365826e-01
    outer loop
      vertex   9.081166e+00 -5.084686e-01  5.421710e+00
      vertex   9.256927e+00 -4.945354e-01  6.135322e+00
      vertex   9.212836e+00 -9.801426e-01  6.136613e+00
    endloop
  endfacet
  facet normal  2.861969e-01 -9.546427e-01  8.215066e-02
    outer loop
      vertex   8.088120e+00 -2.358206e+00  7.924744e+00
      vertex   8.005828e+00 -2.413929e+00  7.563893e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
    endloop
  endfacet
  facet normal -4.666528e-01  8.812317e-01 -7.527134e-02
    outer loop
      vertex  -3.870190e+00  5.593496e+00  1.385433e+00
      vertex  -3.144492e+00  5.979891e+00  1.410066e+00
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
    endloop
  endfacet
  facet normal  7.568181e-01 -5.121120e-01 -4.061622e-01
    outer loop
      vertex   6.767753e+00 -2.690432e+00  1.269229e+00
      vertex   6.904957e+00 -2.766088e+00  1.620279e+00
      vertex   6.669502e+00 -3.123020e+00  1.631585e+00
    endloop
  endfacet
  facet normal  9.985882e-01  2.087136e-03 -5.307747e-02
    outer loop
      vertex   9.629588e+00  6.732941e-04  9.045974e+00
      vertex   9.630534e+00 -4.535618e-01  9.045911e+00
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
    endloop
  endfacet
  facet normal  3.373626e-01 -9.315435e-01  1.356950e-01
    outer loop
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
      vertex   7.903616e+00 -2.533827e+00  6.850272e+00
      vertex   8.301332e+00 -2.389652e+00  6.851235e+00
    endloop
  endfacet
  facet normal  3.590035e-01 -9.171998e-01  1.728037e-01
    outer loop
      vertex   7.385159e+00 -2.855360e+00  5.889679e+00
      vertex   7.276844e+00 -2.937180e+00  5.680428e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
    endloop
  endfacet
  facet normal  2.881247e-01 -9.377168e-01  1.940911e-01
    outer loop
      vertex   7.385159e+00 -2.855360e+00  5.889679e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
      vertex   7.511265e+00 -2.761974e+00  6.153654e+00
    endloop
  endfacet
  facet normal  2.891783e-01 -9.421664e-01  1.694062e-01
    outer loop
      vertex   7.658683e+00 -2.654942e+00  6.497281e+00
      vertex   7.511265e+00 -2.761974e+00  6.153654e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
    endloop
  endfacet
  facet normal  3.196301e-01 -9.369348e-01  1.413847e-01
    outer loop
      vertex   7.385159e+00 -2.855360e+00  5.889679e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
    endloop
  endfacet
  facet normal -9.334197e-01 -6.575537e-03 -3.587261e-01
    outer loop
      vertex  -8.374131e+00 -5.304680e-01  3.328518e+00
      vertex  -8.639026e+00 -5.278988e-01  4.017737e+00
      vertex  -8.641997e+00 -8.125305e-04  4.015808e+00
    endloop
  endfacet
  facet normal -5.148230e-01 -8.552651e-01  5.898142e-02
    outer loop
      vertex  -4.343534e+00 -5.321756e+00  2.559642e+00
      vertex  -4.685282e+00 -5.121077e+00  2.486646e+00
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
    endloop
  endfacet
  facet normal -5.366325e-01 -8.401208e-01  7.888392e-02
    outer loop
      vertex  -4.146790e+00 -5.458500e+00  2.441726e+00
      vertex  -4.343534e+00 -5.321756e+00  2.559642e+00
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
    endloop
  endfacet
  facet normal  7.330992e-01  2.906658e-03  6.801155e-01
    outer loop
      vertex   7.364036e+00  3.700256e-04  1.578237e+01
      vertex   6.737034e+00 -4.433289e-01  1.646011e+01
      vertex   7.365021e+00 -4.433498e-01  1.578320e+01
    endloop
  endfacet
  facet normal -3.472871e-01 -9.163970e-01  1.990180e-01
    outer loop
      vertex  -7.326120e+00 -2.965523e+00  5.470749e+00
      vertex  -7.163385e+00 -3.026060e+00  5.475973e+00
      vertex  -7.276982e+00 -2.938496e+00  5.680944e+00
    endloop
  endfacet
  facet normal -5.128314e-01 -8.553753e-01  7.305480e-02
    outer loop
      vertex  -4.146790e+00 -5.458500e+00  2.441726e+00
      vertex  -3.931183e+00 -5.612051e+00  2.157365e+00
      vertex  -3.944028e+00 -5.589794e+00  2.327796e+00
    endloop
  endfacet
  facet normal -7.514548e-01 -5.457389e-01 -3.707894e-01
    outer loop
      vertex  -6.308788e+00 -3.388851e+00  1.287506e+00
      vertex  -6.669674e+00 -3.125740e+00  1.631636e+00
      vertex  -6.547886e+00 -3.053078e+00  1.277870e+00
    endloop
  endfacet
  facet normal -4.697518e-01 -8.824854e-01 -2.351147e-02
    outer loop
      vertex  -3.412686e+00 -5.885452e+00  2.063216e+00
      vertex  -3.644958e+00 -5.764738e+00  2.173019e+00
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
    endloop
  endfacet
  facet normal  8.389746e-01 -2.951303e-01 -4.571866e-01
    outer loop
      vertex   6.651994e+00 -2.146391e+00  5.689535e-01
      vertex   6.261974e+00 -2.373744e+00 -1.699398e-15
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
    endloop
  endfacet
  facet normal -4.725581e-01 -8.777505e-01  7.901212e-02
    outer loop
      vertex  -3.644958e+00 -5.764738e+00  2.173019e+00
      vertex  -3.944028e+00 -5.589794e+00  2.327796e+00
      vertex  -3.931183e+00 -5.612051e+00  2.157365e+00
    endloop
  endfacet
  facet normal -5.272967e-01 -8.477032e-01  5.794411e-02
    outer loop
      vertex  -4.146790e+00 -5.458500e+00  2.441726e+00
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
      vertex  -3.931183e+00 -5.612051e+00  2.157365e+00
    endloop
  endfacet
  facet normal  8.403178e-01  4.101479e-01 -3.544640e-01
    outer loop
      vertex   7.431244e+00  2.459944e+00  2.337697e+00
      vertex   7.574259e+00  2.473860e+00  2.692841e+00
      vertex   7.783234e+00  2.032179e+00  2.677185e+00
    endloop
  endfacet
  facet normal -4.695277e-01 -8.825997e-01 -2.369775e-02
    outer loop
      vertex  -3.644958e+00 -5.764738e+00  2.173019e+00
      vertex  -3.931183e+00 -5.612051e+00  2.157365e+00
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
    endloop
  endfacet
  facet normal -8.940951e-01  1.509417e-02 -4.476229e-01
    outer loop
      vertex  -7.759465e+00  2.861023e-04  1.955147e+00
      vertex  -7.929305e+00  5.204182e-01  2.311929e+00
      vertex  -7.751578e+00  5.112591e-01  1.956624e+00
    endloop
  endfacet
  facet normal -7.945732e-01  5.999559e-01 -9.330772e-02
    outer loop
      vertex  -8.690358e+00  1.927992e+00  5.434532e+00
      vertex  -8.549037e+00  2.225302e+00  6.142756e+00
      vertex  -8.404983e+00  2.307024e+00  5.441505e+00
    endloop
  endfacet
  facet normal -3.904445e-01 -9.203169e-01 -2.387108e-02
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -3.173697e+00 -5.997675e+00  1.959259e+00
      vertex  -3.166358e+00 -5.996792e+00  1.805169e+00
    endloop
  endfacet
  facet normal -2.397405e-01 -9.708344e-01  2.224925e-03
    outer loop
      vertex  -1.820554e+00 -6.459442e+00  1.445536e+00
      vertex  -1.606912e+00 -6.512114e+00  1.482861e+00
      vertex  -2.006207e+00 -6.413306e+00  1.572435e+00
    endloop
  endfacet
  facet normal  3.487654e-16  8.403154e-16 -1.000000e+00
    outer loop
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
      vertex   4.924182e+00 -2.546585e+00 -1.464878e-17
      vertex   4.930933e+00 -2.531955e+00  0.000000e+00
    endloop
  endfacet
  facet normal -1.763065e-01 -9.842657e-01 -1.170800e-02
    outer loop
      vertex  -1.128790e+00 -6.602042e+00  1.402508e+00
      vertex  -1.447308e+00 -6.545586e+00  1.452824e+00
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
    endloop
  endfacet
  facet normal -8.341674e-02 -9.965053e-01  4.341906e-03
    outer loop
      vertex  -4.043255e-01 -6.678886e+00  1.334889e+00
      vertex  -8.065596e-01 -6.645087e+00  1.364478e+00
      vertex  -8.018533e-01 -6.648617e+00  6.447229e-01
    endloop
  endfacet
  facet normal -5.285735e-01  8.467304e-01  6.047991e-02
    outer loop
      vertex  -5.576128e+00  4.319174e+00  3.492131e+00
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
    endloop
  endfacet
  facet normal  3.324924e-01 -9.431059e-01  4.548897e-05
    outer loop
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
      vertex  -2.057643e+00  5.175800e+00  2.081668e-17
      vertex  -1.574733e+00  5.346050e+00  1.179612e-16
    endloop
  endfacet
  facet normal -2.385729e-01 -9.689964e-01  6.425595e-02
    outer loop
      vertex  -8.253299e+00 -2.206669e+00  9.386083e+00
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
      vertex  -8.448242e+00 -2.182707e+00  9.023640e+00
    endloop
  endfacet
  facet normal -8.704947e-01  1.571664e-01 -4.664092e-01
    outer loop
      vertex  -7.330915e+00  9.558201e-01  1.245726e+00
      vertex  -7.426454e+00  1.471172e+00  1.597696e+00
      vertex  -7.248943e+00  1.422327e+00  1.249935e+00
    endloop
  endfacet
  facet normal -2.868320e-01 -9.552459e-01 -7.233685e-02
    outer loop
      vertex  -1.820554e+00 -6.459442e+00  1.445536e+00
      vertex  -2.006207e+00 -6.413306e+00  1.572435e+00
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
    endloop
  endfacet
  facet normal -1.319439e-01 -9.912491e-01  3.998817e-03
    outer loop
      vertex  -1.128790e+00 -6.602042e+00  1.402508e+00
      vertex  -8.018533e-01 -6.648617e+00  6.447229e-01
      vertex  -8.065596e-01 -6.645087e+00  1.364478e+00
    endloop
  endfacet
  facet normal -4.000358e-01  9.026222e-01  1.588855e-01
    outer loop
      vertex  -7.324272e+00  2.964247e+00  5.470831e+00
      vertex  -6.959301e+00  3.184469e+00  5.138667e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
    endloop
  endfacet
  facet normal -2.806902e-02 -9.995806e-01  7.132039e-03
    outer loop
      vertex  -4.043255e-01 -6.678886e+00  1.334889e+00
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
      vertex   8.787063e-05 -6.690313e+00  1.324984e+00
    endloop
  endfacet
  facet normal -1.727078e-01 -9.848739e-01 -1.398007e-02
    outer loop
      vertex  -1.128790e+00 -6.602042e+00  1.402508e+00
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -8.018533e-01 -6.648617e+00  6.447229e-01
    endloop
  endfacet
  facet normal -2.871242e-01 -9.576890e-01 -1.978198e-02
    outer loop
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
      vertex  -2.367681e+00 -6.277615e+00  6.327448e-01
    endloop
  endfacet
  facet normal  9.458584e-01 -2.785795e-01 -1.665694e-01
    outer loop
      vertex   9.212836e+00 -9.801426e-01  6.136613e+00
      vertex   9.215240e+00 -1.401539e+00  6.855026e+00
      vertex   9.076302e+00 -1.444693e+00  6.138244e+00
    endloop
  endfacet
  facet normal  3.153239e-01 -3.132103e-01  8.958069e-01
    outer loop
      vertex   3.620520e+00 -8.841972e-01  1.845259e+01
      vertex   2.707990e+00 -1.189478e+00  1.866706e+01
      vertex   3.582416e+00 -1.189468e+00  1.835927e+01
    endloop
  endfacet
  facet normal -7.827150e-01  6.216087e-01  3.098062e-02
    outer loop
      vertex  -9.178032e+00  1.689976e+00  9.037078e+00
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
    endloop
  endfacet
  facet normal -5.248537e-01 -8.384341e-01  1.468225e-01
    outer loop
      vertex  -5.576197e+00 -4.323465e+00  3.492194e+00
      vertex  -5.752707e+00 -4.183825e+00  3.658639e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
    endloop
  endfacet
  facet normal  9.985878e-01 -2.301301e-03 -5.307574e-02
    outer loop
      vertex   9.591737e+00  4.614162e-01  8.313847e+00
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
      vertex   9.629588e+00  6.732941e-04  9.045974e+00
    endloop
  endfacet
  facet normal -5.789069e-02 -9.982684e-01 -1.043813e-02
    outer loop
      vertex  -4.043255e-01 -6.678886e+00  1.334889e+00
      vertex  -8.018533e-01 -6.648617e+00  6.447229e-01
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
    endloop
  endfacet
  facet normal  9.430083e-01  3.299293e-01 -4.338162e-02
    outer loop
      vertex   9.396003e+00  1.339525e+00  8.310082e+00
      vertex   9.584334e+00  8.978500e-01  9.044880e+00
      vertex   9.545728e+00  9.119377e-01  8.312808e+00
    endloop
  endfacet
  facet normal  2.984936e-01 -9.534946e-01 -4.182727e-02
    outer loop
      vertex   2.394752e+00 -6.291546e+00  1.679824e+00
      vertex   2.004912e+00 -6.408859e+00  1.572065e+00
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
    endloop
  endfacet
  facet normal -7.031152e-01 -6.211872e-01  3.460570e-01
    outer loop
      vertex  -8.155293e+00 -1.470728e+00  1.410125e+01
      vertex  -8.557884e+00 -1.470757e+00  1.328322e+01
      vertex  -8.417951e+00 -1.662831e+00  1.322275e+01
    endloop
  endfacet
  facet normal  9.046424e-01  2.024449e-01 -3.750176e-01
    outer loop
      vertex   7.942900e+00  1.551197e+00  2.664423e+00
      vertex   8.223418e+00  1.556984e+00  3.344231e+00
      vertex   8.332925e+00  1.049910e+00  3.334658e+00
    endloop
  endfacet
  facet normal  3.456060e-01 -9.374115e-01 -4.261738e-02
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   2.394752e+00 -6.291546e+00  1.679824e+00
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
    endloop
  endfacet
  facet normal  4.337481e-01 -9.006542e-01 -2.616502e-02
    outer loop
      vertex   3.411897e+00 -5.881508e+00  2.062777e+00
      vertex   3.172365e+00 -5.993839e+00  1.958629e+00
      vertex   3.165092e+00 -5.992880e+00  1.805041e+00
    endloop
  endfacet
  facet normal  3.886432e-01 -9.195141e-01 -5.874069e-02
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   3.146301e+00 -5.975582e+00  1.409939e+00
      vertex   3.165092e+00 -5.992880e+00  1.805041e+00
    endloop
  endfacet
  facet normal  1.810000e-01 -9.833520e-01 -1.605412e-02
    outer loop
      vertex   1.128407e+00 -6.600262e+00  1.402431e+00
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
    endloop
  endfacet
  facet normal  5.876128e-02 -9.982138e-01 -1.078360e-02
    outer loop
      vertex   4.041913e-01 -6.678841e+00  1.334873e+00
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
    endloop
  endfacet
  facet normal  8.433884e-01 -4.874709e-01  2.259827e-01
    outer loop
      vertex   9.268517e+00 -1.189360e+00  1.158263e+01
      vertex   8.879113e+00 -1.470104e+00  1.243032e+01
      vertex   9.115124e+00 -1.470076e+00  1.154957e+01
    endloop
  endfacet
  facet normal -1.425759e-01 -1.044826e-01  9.842538e-01
    outer loop
      vertex  -9.224034e-01 -4.431305e-01  1.916488e+01
      vertex  -1.827286e+00 -8.840618e-01  1.898700e+01
      vertex  -9.179602e-01 -8.840847e-01  1.911872e+01
    endloop
  endfacet
  facet normal -8.041892e-01 -4.327038e-01 -4.074890e-01
    outer loop
      vertex  -6.767282e+00 -2.692802e+00  1.269251e+00
      vertex  -6.904522e+00 -2.768339e+00  1.620308e+00
      vertex  -7.114015e+00 -2.369659e+00  1.610398e+00
    endloop
  endfacet
  facet normal  5.245042e-01 -8.385062e-01  1.476572e-01
    outer loop
      vertex   4.341982e+00 -5.317970e+00  2.558578e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
      vertex   4.533190e+00 -5.176903e+00  2.680458e+00
    endloop
  endfacet
  facet normal  9.269196e-01 -3.186392e-07 -3.752599e-01
    outer loop
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -7.727574e+00  2.181353e+00  1.248473e+01
      vertex  -7.727578e+00 -2.180943e+00  1.248473e+01
    endloop
  endfacet
  facet normal  5.153893e-01 -8.549531e-01  5.856036e-02
    outer loop
      vertex   4.341982e+00 -5.317970e+00  2.558578e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
    endloop
  endfacet
  facet normal  2.877409e-01  9.575111e-01 -1.943618e-02
    outer loop
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
      vertex   2.363800e+00  6.274577e+00  6.326923e-01
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
    endloop
  endfacet
  facet normal -7.332212e-02 -1.304425e-03  9.973075e-01
    outer loop
      vertex   4.036640e-01  6.677962e+00  1.334846e+00
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
      vertex   8.050640e-01  6.643335e+00  1.364312e+00
    endloop
  endfacet
  facet normal  8.350403e-01  5.479715e-01 -4.934660e-02
    outer loop
      vertex   9.078284e+00  1.757601e+00  7.576207e+00
      vertex   9.146042e+00  1.720049e+00  8.305800e+00
      vertex   9.396003e+00  1.339525e+00  8.310082e+00
    endloop
  endfacet
  facet normal  4.560695e-01 -8.883737e-01 -5.284645e-02
    outer loop
      vertex   3.411897e+00 -5.881508e+00  2.062777e+00
      vertex   3.165092e+00 -5.992880e+00  1.805041e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
    endloop
  endfacet
  facet normal  5.133429e-01 -8.550925e-01  7.277250e-02
    outer loop
      vertex   4.145314e+00 -5.454771e+00  2.440770e+00
      vertex   3.942708e+00 -5.586086e+00  2.326981e+00
      vertex   3.930022e+00 -5.608150e+00  2.157217e+00
    endloop
  endfacet
  facet normal -6.230171e-01  6.209703e-01  4.756528e-01
    outer loop
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
      vertex  -7.676430e+00  1.468325e+00  1.487720e+01
      vertex  -7.133762e+00  1.468275e+00  1.558806e+01
    endloop
  endfacet
  facet normal  5.278586e-01 -8.473784e-01  5.757846e-02
    outer loop
      vertex   4.145314e+00 -5.454771e+00  2.440770e+00
      vertex   3.930022e+00 -5.608150e+00  2.157217e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
    endloop
  endfacet
  facet normal  6.584880e-01 -2.436470e-04  7.525913e-01
    outer loop
      vertex  -5.344672e+00  4.515985e+00  3.288033e+00
      vertex  -5.527053e+00  4.360826e+00  3.447559e+00
      vertex  -5.432583e+00  5.453663e-01  3.363667e+00
    endloop
  endfacet
  facet normal -8.498521e-01  3.133401e-03  5.270118e-01
    outer loop
      vertex  -7.924467e+00  7.686615e-04  1.504819e+01
      vertex  -8.420585e+00  7.877350e-04  1.424816e+01
      vertex  -8.421803e+00 -4.429150e-01  1.424883e+01
    endloop
  endfacet
  facet normal  2.963893e-01 -9.513110e-01  8.462100e-02
    outer loop
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
      vertex   8.301332e+00 -2.389652e+00  6.851235e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
    endloop
  endfacet
  facet normal -8.615751e-01  1.431734e-01 -4.870211e-01
    outer loop
      vertex  -6.962196e+00  8.877678e-01  5.629520e-01
      vertex  -6.890904e+00  1.322287e+00  5.645704e-01
      vertex  -6.591945e+00  1.200882e+00 -6.308086e-18
    endloop
  endfacet
  facet normal  9.944867e-01 -7.164853e-04 -1.048603e-01
    outer loop
      vertex   9.514176e+00  4.699631e-01  7.582161e+00
      vertex   9.591002e+00  7.381439e-04  8.313971e+00
      vertex   9.513846e+00  7.247925e-04  7.582238e+00
    endloop
  endfacet
  facet normal  9.201517e-01 -9.473318e-03 -3.914476e-01
    outer loop
      vertex   8.089043e+00 -6.465912e-04  2.646547e+00
      vertex   8.378257e+00 -9.479523e-04  3.326392e+00
      vertex   8.373710e+00 -5.302849e-01  3.328514e+00
    endloop
  endfacet
  facet normal -2.304508e-02 -9.989825e-01  3.876776e-02
    outer loop
      vertex  -4.202793e+00  2.181318e+00  1.668542e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
    endloop
  endfacet
  facet normal  9.883483e-01  4.290334e-04 -1.522086e-01
    outer loop
      vertex   9.401737e+00  4.812756e-01  6.855625e+00
      vertex   9.513846e+00  7.247925e-04  7.582238e+00
      vertex   9.401924e+00  6.008148e-04  6.855484e+00
    endloop
  endfacet
  facet normal  8.794482e-01  2.074240e-02 -4.755422e-01
    outer loop
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
      vertex   7.000476e+00  4.469490e-01  5.618172e-01
      vertex   7.378617e+00  1.985550e-03  1.241727e+00
    endloop
  endfacet
  facet normal  9.882336e-01 -7.199686e-04 -1.529508e-01
    outer loop
      vertex   9.401737e+00  4.812756e-01  6.855625e+00
      vertex   9.514176e+00  4.699631e-01  7.582161e+00
      vertex   9.513846e+00  7.247925e-04  7.582238e+00
    endloop
  endfacet
  facet normal  9.476190e-01  7.312180e-03 -3.193192e-01
    outer loop
      vertex   8.638736e+00  5.256424e-01  4.017771e+00
      vertex   8.877553e+00 -4.463196e-04  4.714444e+00
      vertex   8.642137e+00 -8.125305e-04  4.015808e+00
    endloop
  endfacet
  facet normal  9.099749e-01  1.149824e-02 -4.145040e-01
    outer loop
      vertex   7.930045e+00  5.198708e-01  2.311933e+00
      vertex   8.083388e+00  5.249405e-01  2.648714e+00
      vertex   8.089043e+00 -6.465912e-04  2.646547e+00
    endloop
  endfacet
  facet normal  8.950369e-01  1.403202e-02 -4.457713e-01
    outer loop
      vertex   7.752392e+00  5.107079e-01  1.956668e+00
      vertex   7.936329e+00 -2.689362e-04  2.309899e+00
      vertex   7.759639e+00  2.861023e-04  1.955153e+00
    endloop
  endfacet
  facet normal  8.942065e-01  1.255285e-02 -4.474786e-01
    outer loop
      vertex   7.752392e+00  5.107079e-01  1.956668e+00
      vertex   7.930045e+00  5.198708e-01  2.311933e+00
      vertex   7.936329e+00 -2.689362e-04  2.309899e+00
    endloop
  endfacet
  facet normal -7.049581e-01  6.942722e-01 -1.449836e-01
    outer loop
      vertex  -8.038638e+00  2.434683e+00  4.057520e+00
      vertex  -8.234803e+00  2.379526e+00  4.747215e+00
      vertex  -7.918496e+00  2.703440e+00  4.760324e+00
    endloop
  endfacet
  facet normal  1.559737e-01  1.085865e-04  9.877611e-01
    outer loop
      vertex  -1.128328e+00  6.602671e+00  1.402445e+00
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
    endloop
  endfacet
  facet normal  8.823322e-01  1.541009e-02 -4.703747e-01
    outer loop
      vertex   7.557823e+00  4.967327e-01  1.592848e+00
      vertex   7.759639e+00  2.861023e-04  1.955153e+00
      vertex   7.565843e+00  1.035690e-03  1.591653e+00
    endloop
  endfacet
  facet normal  8.815094e-01  1.391768e-02 -4.719613e-01
    outer loop
      vertex   7.557823e+00  4.967327e-01  1.592848e+00
      vertex   7.752392e+00  5.107079e-01  1.956668e+00
      vertex   7.759639e+00  2.861023e-04  1.955153e+00
    endloop
  endfacet
  facet normal -6.066884e-01  7.807779e-01 -1.493825e-01
    outer loop
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
      vertex  -3.788864e+00  5.493610e+00 -1.020017e-15
      vertex  -4.404419e+00  5.015305e+00 -2.983724e-16
    endloop
  endfacet
  facet normal  8.808264e-01  1.539249e-02 -4.731892e-01
    outer loop
      vertex   7.370080e+00  4.802914e-01  1.242837e+00
      vertex   7.557823e+00  4.967327e-01  1.592848e+00
      vertex   7.565843e+00  1.035690e-03  1.591653e+00
    endloop
  endfacet
  facet normal  8.784345e-01  1.678581e-02 -4.775678e-01
    outer loop
      vertex   7.370080e+00  4.802914e-01  1.242837e+00
      vertex   7.378617e+00  1.985550e-03  1.241727e+00
      vertex   7.000476e+00  4.469490e-01  5.618172e-01
    endloop
  endfacet
  facet normal -2.194921e-01 -6.346388e-09 -9.756143e-01
    outer loop
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   1.967929e+00  2.181269e+00  1.759733e+01
      vertex   1.967912e+00 -2.180986e+00  1.759733e+01
    endloop
  endfacet
  facet normal  9.769196e-01  9.329072e-02 -1.921587e-01
    outer loop
      vertex   9.212695e+00  9.799118e-01  6.136631e+00
      vertex   9.356750e+00  9.523754e-01  6.855629e+00
      vertex   9.401737e+00  4.812756e-01  6.855625e+00
    endloop
  endfacet
  facet normal  9.569540e-01  8.248397e-02 -2.782721e-01
    outer loop
      vertex   8.832343e+00  1.029762e+00  4.720400e+00
      vertex   9.081264e+00  5.079060e-01  5.421731e+00
      vertex   8.875118e+00  5.187302e-01  4.716023e+00
    endloop
  endfacet
  facet normal  9.572687e-01  8.519515e-02 -2.763664e-01
    outer loop
      vertex   8.832343e+00  1.029762e+00  4.720400e+00
      vertex   9.037666e+00  1.007128e+00  5.424614e+00
      vertex   9.081264e+00  5.079060e-01  5.421731e+00
    endloop
  endfacet
  facet normal  9.444302e-01  7.957448e-02 -3.189347e-01
    outer loop
      vertex   8.596871e+00  1.044603e+00  4.023283e+00
      vertex   8.875118e+00  5.187302e-01  4.716023e+00
      vertex   8.638736e+00  5.256424e-01  4.017771e+00
    endloop
  endfacet
  facet normal  8.911535e-01  7.446734e-02 -4.475489e-01
    outer loop
      vertex   7.711735e+00  1.016129e+00  1.959809e+00
      vertex   7.930045e+00  5.198708e-01  2.311933e+00
      vertex   7.752392e+00  5.107079e-01  1.956668e+00
    endloop
  endfacet
  facet normal  8.778545e-01  7.355722e-02 -4.732449e-01
    outer loop
      vertex   7.517587e+00  9.879436e-01  1.595290e+00
      vertex   7.711735e+00  1.016129e+00  1.959809e+00
      vertex   7.752392e+00  5.107079e-01  1.956668e+00
    endloop
  endfacet
  facet normal  8.775600e-01  7.423694e-02 -4.736848e-01
    outer loop
      vertex   7.331723e+00  9.546490e-01  1.245735e+00
      vertex   7.517587e+00  9.879436e-01  1.595290e+00
      vertex   7.557823e+00  4.967327e-01  1.592848e+00
    endloop
  endfacet
  facet normal  9.153031e-01  2.200797e-01 -3.373205e-01
    outer loop
      vertex   8.223418e+00  1.556984e+00  3.344231e+00
      vertex   8.479278e+00  1.546875e+00  4.031898e+00
      vertex   8.596871e+00  1.044603e+00  4.023283e+00
    endloop
  endfacet
  facet normal  9.442925e-01  3.159716e-01 -9.205246e-02
    outer loop
      vertex   9.322192e+00  1.366310e+00  7.579377e+00
      vertex   9.545728e+00  9.119377e-01  8.312808e+00
      vertex   9.468619e+00  9.292984e-01  7.581406e+00
    endloop
  endfacet
  facet normal  9.169261e-01  7.480789e-02 -3.919827e-01
    outer loop
      vertex   8.043606e+00  1.044596e+00  2.654828e+00
      vertex   8.373780e+00  5.278606e-01  3.328556e+00
      vertex   8.083388e+00  5.249405e-01  2.648714e+00
    endloop
  endfacet
  facet normal -7.719470e-01  4.823798e-01 -4.140142e-01
    outer loop
      vertex  -6.764935e+00  2.694681e+00  1.269298e+00
      vertex  -6.544655e+00  3.054583e+00  1.277907e+00
      vertex  -6.484798e+00  2.544256e+00  5.717058e-01
    endloop
  endfacet
  facet normal  9.407213e-01  3.288761e-01 -8.296946e-02
    outer loop
      vertex   9.322192e+00  1.366310e+00  7.579377e+00
      vertex   9.396003e+00  1.339525e+00  8.310082e+00
      vertex   9.545728e+00  9.119377e-01  8.312808e+00
    endloop
  endfacet
  facet normal  5.870131e-02 -9.978724e-01 -2.837236e-02
    outer loop
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
    endloop
  endfacet
  facet normal  9.445896e-01  2.987103e-01 -1.360981e-01
    outer loop
      vertex   9.214503e+00  1.401918e+00  6.855026e+00
      vertex   9.468619e+00  9.292984e-01  7.581406e+00
      vertex   9.356750e+00  9.523754e-01  6.855629e+00
    endloop
  endfacet
  facet normal  4.600601e-01  9.499363e-04  8.878873e-01
    outer loop
      vertex  -3.644958e+00 -5.764738e+00  2.173019e+00
      vertex  -3.842140e+00 -3.973835e+00  2.273273e+00
      vertex  -3.944028e+00 -5.589794e+00  2.327796e+00
    endloop
  endfacet
  facet normal  4.361352e-02 -9.989801e-01  1.169108e-02
    outer loop
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
      vertex   7.974295e+00  2.181215e+00  1.171663e+01
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
    endloop
  endfacet
  facet normal  9.409950e-01  3.147165e-01 -1.244262e-01
    outer loop
      vertex   9.214503e+00  1.401918e+00  6.855026e+00
      vertex   9.322192e+00  1.366310e+00  7.579377e+00
      vertex   9.468619e+00  9.292984e-01  7.581406e+00
    endloop
  endfacet
  facet normal  9.339297e-01  2.403658e-01 -2.645742e-01
    outer loop
      vertex   8.707416e+00  1.522598e+00  4.727156e+00
      vertex   9.037666e+00  1.007128e+00  5.424614e+00
      vertex   8.832343e+00  1.029762e+00  4.720400e+00
    endloop
  endfacet
  facet normal  9.146253e-01  2.041095e-01 -3.489982e-01
    outer loop
      vertex   8.223418e+00  1.556984e+00  3.344231e+00
      vertex   8.596871e+00  1.044603e+00  4.023283e+00
      vertex   8.332925e+00  1.049910e+00  3.334658e+00
    endloop
  endfacet
  facet normal  8.942634e-01  1.781954e-01 -4.105354e-01
    outer loop
      vertex   7.794792e+00  1.537182e+00  2.326651e+00
      vertex   8.043606e+00  1.044596e+00  2.654828e+00
      vertex   7.890829e+00  1.034529e+00  2.317666e+00
    endloop
  endfacet
  facet normal  8.666599e-01  1.716886e-01 -4.684270e-01
    outer loop
      vertex   7.426193e+00  1.469454e+00  1.597667e+00
      vertex   7.615463e+00  1.510658e+00  1.962947e+00
      vertex   7.711735e+00  1.016129e+00  1.959809e+00
    endloop
  endfacet
  facet normal  8.684046e-01  1.671342e-01 -4.668401e-01
    outer loop
      vertex   7.248661e+00  1.420551e+00  1.249919e+00
      vertex   7.426193e+00  1.469454e+00  1.597667e+00
      vertex   7.517587e+00  9.879436e-01  1.595290e+00
    endloop
  endfacet
  facet normal  8.654158e-01  1.585557e-01 -4.753057e-01
    outer loop
      vertex   7.248661e+00  1.420551e+00  1.249919e+00
      vertex   7.331723e+00  9.546490e-01  1.245735e+00
      vertex   6.890595e+00  1.320393e+00  5.645571e-01
    endloop
  endfacet
  facet normal  8.698579e-01  4.680745e-01 -1.557350e-01
    outer loop
      vertex   8.689773e+00  1.927053e+00  5.434519e+00
      vertex   8.848385e+00  1.867100e+00  6.140252e+00
      vertex   9.075440e+00  1.444485e+00  6.138266e+00
    endloop
  endfacet
  facet normal -6.074722e-01  7.939948e-01 -2.344465e-02
    outer loop
      vertex  -6.018507e+00  4.096174e+00  2.395986e+00
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
    endloop
  endfacet
  facet normal  8.863307e-01  4.015489e-01 -2.306002e-01
    outer loop
      vertex   8.503082e+00  1.978765e+00  4.736118e+00
      vertex   8.906188e+00  1.486849e+00  5.428903e+00
      vertex   8.707416e+00  1.522598e+00  4.727156e+00
    endloop
  endfacet
  facet normal  8.813825e-01  3.997475e-01 -2.517278e-01
    outer loop
      vertex   8.288459e+00  2.015738e+00  4.043362e+00
      vertex   8.503082e+00  1.978765e+00  4.736118e+00
      vertex   8.707416e+00  1.522598e+00  4.727156e+00
    endloop
  endfacet
  facet normal  9.401395e-01  3.404518e-01  1.517074e-02
    outer loop
      vertex   9.427593e+00  1.298067e+00  9.776810e+00
      vertex   9.584334e+00  8.978500e-01  9.044880e+00
      vertex   9.432271e+00  1.317898e+00  9.041898e+00
    endloop
  endfacet
  facet normal  8.811611e-01  3.659378e-01 -2.994072e-01
    outer loop
      vertex   8.047511e+00  2.034334e+00  3.356977e+00
      vertex   8.288459e+00  2.015738e+00  4.043362e+00
      vertex   8.479278e+00  1.546875e+00  4.031898e+00
    endloop
  endfacet
  facet normal  7.381216e-16 -6.418490e-16 -1.000000e+00
    outer loop
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
      vertex  -3.788864e+00  5.493610e+00 -1.020017e-15
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
    endloop
  endfacet
  facet normal  1.390756e-01  9.718224e-01  1.903138e-01
    outer loop
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
      vertex   4.643673e+00  2.137899e+00  1.662149e+01
    endloop
  endfacet
  facet normal  8.803380e-01  3.019428e-01 -3.658354e-01
    outer loop
      vertex   7.783234e+00  2.032179e+00  2.677185e+00
      vertex   8.223418e+00  1.556984e+00  3.344231e+00
      vertex   7.942900e+00  1.551197e+00  2.664423e+00
    endloop
  endfacet
  facet normal  8.746803e-01  3.004498e-01 -3.803477e-01
    outer loop
      vertex   7.639423e+00  2.016447e+00  2.334038e+00
      vertex   7.783234e+00  2.032179e+00  2.677185e+00
      vertex   7.942900e+00  1.551197e+00  2.664423e+00
    endloop
  endfacet
  facet normal  8.545010e-01  2.740020e-01 -4.413058e-01
    outer loop
      vertex   7.465204e+00  1.984163e+00  1.965994e+00
      vertex   7.794792e+00  1.537182e+00  2.326651e+00
      vertex   7.615463e+00  1.510658e+00  1.962947e+00
    endloop
  endfacet
  facet normal  8.566546e-01  2.843466e-01 -4.304532e-01
    outer loop
      vertex   7.465204e+00  1.984163e+00  1.965994e+00
      vertex   7.639423e+00  2.016447e+00  2.334038e+00
      vertex   7.794792e+00  1.537182e+00  2.326651e+00
    endloop
  endfacet
  facet normal  8.807482e-01 -1.683084e-02 -4.732859e-01
    outer loop
      vertex   7.370050e+00 -4.768314e-01  1.242812e+00
      vertex   7.378617e+00  1.985550e-03  1.241727e+00
      vertex   7.557779e+00 -4.951801e-01  1.592813e+00
    endloop
  endfacet
  facet normal -5.907151e-01 -8.060122e-01  3.741689e-02
    outer loop
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
      vertex  -6.933262e+00 -3.407667e+00  3.434591e+00
    endloop
  endfacet
  facet normal  8.487287e-01  2.722478e-01 -4.533660e-01
    outer loop
      vertex   7.287334e+00  1.932436e+00  1.601949e+00
      vertex   7.465204e+00  1.984163e+00  1.965994e+00
      vertex   7.615463e+00  1.510658e+00  1.962947e+00
    endloop
  endfacet
  facet normal -8.498570e-01 -2.737303e-03  5.270063e-01
    outer loop
      vertex  -7.925472e+00  4.444542e-01  1.504889e+01
      vertex  -8.421647e+00  4.444752e-01  1.424875e+01
      vertex  -8.420585e+00  7.877350e-04  1.424816e+01
    endloop
  endfacet
  facet normal  8.493413e-01  2.442204e-01 -4.679483e-01
    outer loop
      vertex   7.122206e+00  1.870544e+00  1.255249e+00
      vertex   7.426193e+00  1.469454e+00  1.597667e+00
      vertex   7.248661e+00  1.420551e+00  1.249919e+00
    endloop
  endfacet
  facet normal  8.529373e-01  2.600016e-01 -4.526555e-01
    outer loop
      vertex   7.122206e+00  1.870544e+00  1.255249e+00
      vertex   7.287334e+00  1.932436e+00  1.601949e+00
      vertex   7.426193e+00  1.469454e+00  1.597667e+00
    endloop
  endfacet
  facet normal -4.247707e-01 -9.048255e-01  2.933738e-02
    outer loop
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
      vertex  -8.832759e+00 -1.949820e+00  9.764791e+00
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
    endloop
  endfacet
  facet normal  9.831162e-01 -3.094488e-07 -1.829822e-01
    outer loop
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -8.143590e+00 -2.180941e+00  1.093485e+01
      vertex  -8.143588e+00  2.181360e+00  1.093485e+01
    endloop
  endfacet
  facet normal  8.519126e-01  2.166953e-01 -4.767474e-01
    outer loop
      vertex   7.248661e+00  1.420551e+00  1.249919e+00
      vertex   6.890595e+00  1.320393e+00  5.645571e-01
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
    endloop
  endfacet
  facet normal  7.042021e-01  7.094117e-01 -2.888635e-02
    outer loop
      vertex   8.755881e+00  2.077475e+00  7.572239e+00
      vertex   9.146042e+00  1.720049e+00  8.305800e+00
      vertex   9.078284e+00  1.757601e+00  7.576207e+00
    endloop
  endfacet
  facet normal  6.804788e-01  7.327515e-01 -4.896337e-03
    outer loop
      vertex   8.755881e+00  2.077475e+00  7.572239e+00
      vertex   8.815482e+00  2.026991e+00  8.300353e+00
      vertex   9.146042e+00  1.720049e+00  8.305800e+00
    endloop
  endfacet
  facet normal  7.630376e-01  6.406999e-01 -8.530767e-02
    outer loop
      vertex   8.548699e+00  2.224340e+00  6.142745e+00
      vertex   8.978265e+00  1.807442e+00  6.853908e+00
      vertex   8.848385e+00  1.867100e+00  6.140252e+00
    endloop
  endfacet
  facet normal -7.199064e-01  8.196104e-07 -6.940712e-01
    outer loop
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   6.051607e+00  2.181234e+00  1.519522e+01
      vertex   6.051597e+00 -2.181005e+00  1.519523e+01
    endloop
  endfacet
  facet normal  7.911094e-01  5.983516e-01 -1.269691e-01
    outer loop
      vertex   8.404426e+00  2.305803e+00  5.441488e+00
      vertex   8.848385e+00  1.867100e+00  6.140252e+00
      vertex   8.689773e+00  1.927053e+00  5.434519e+00
    endloop
  endfacet
  facet normal  7.632232e-01  6.408364e-01 -8.257835e-02
    outer loop
      vertex   8.404426e+00  2.305803e+00  5.441488e+00
      vertex   8.548699e+00  2.224340e+00  6.142745e+00
      vertex   8.848385e+00  1.867100e+00  6.140252e+00
    endloop
  endfacet
  facet normal  8.121634e-01  5.525299e-01 -1.873539e-01
    outer loop
      vertex   8.037576e+00  2.432901e+00  4.057489e+00
      vertex   8.234009e+00  2.378031e+00  4.747190e+00
      vertex   8.503082e+00  1.978765e+00  4.736118e+00
    endloop
  endfacet
  facet normal  2.394738e-01 -9.687589e-01  6.448582e-02
    outer loop
      vertex   8.253390e+00 -2.206724e+00  9.385991e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
    endloop
  endfacet
  facet normal  8.483484e-01  4.131199e-01 -3.311149e-01
    outer loop
      vertex   7.574259e+00  2.473860e+00  2.692841e+00
      vertex   8.047511e+00  2.034334e+00  3.356977e+00
      vertex   7.783234e+00  2.032179e+00  2.677185e+00
    endloop
  endfacet
  facet normal  8.264897e-01  3.706182e-01 -4.237417e-01
    outer loop
      vertex   7.268930e+00  2.425638e+00  1.969299e+00
      vertex   7.639423e+00  2.016447e+00  2.334038e+00
      vertex   7.465204e+00  1.984163e+00  1.965994e+00
    endloop
  endfacet
  facet normal  8.234573e-01  3.439855e-01 -4.512118e-01
    outer loop
      vertex   7.110293e+00  2.367334e+00  1.610399e+00
      vertex   7.465204e+00  1.984163e+00  1.965994e+00
      vertex   7.287334e+00  1.932436e+00  1.601949e+00
    endloop
  endfacet
  facet normal  8.293772e-01  3.265560e-01 -4.533152e-01
    outer loop
      vertex   6.957979e+00  2.296583e+00  1.261688e+00
      vertex   7.287334e+00  1.932436e+00  1.601949e+00
      vertex   7.122206e+00  1.870544e+00  1.255249e+00
    endloop
  endfacet
  facet normal  9.959439e-01 -1.163556e-07  8.997613e-02
    outer loop
      vertex  -8.236568e+00  2.238081e+00  9.019915e+00
      vertex  -8.236569e+00 -2.237564e+00  9.019919e+00
      vertex  -8.203500e+00 -2.272165e+00  8.653872e+00
    endloop
  endfacet
  facet normal  9.252163e-01  2.218942e-01 -3.077951e-01
    outer loop
      vertex   8.479278e+00  1.546875e+00  4.031898e+00
      vertex   8.832343e+00  1.029762e+00  4.720400e+00
      vertex   8.596871e+00  1.044603e+00  4.023283e+00
    endloop
  endfacet
  facet normal  8.563537e-02  9.963174e-01  4.255908e-03
    outer loop
      vertex   4.036640e-01  6.677962e+00  1.334846e+00
      vertex   8.050640e-01  6.643335e+00  1.364312e+00
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
    endloop
  endfacet
  facet normal -7.913483e-01 -5.972157e-01 -1.307723e-01
    outer loop
      vertex  -8.236091e+00 -2.381275e+00  4.747116e+00
      vertex  -8.406209e+00 -2.307894e+00  5.441439e+00
      vertex  -8.691193e+00 -1.928747e+00  5.434473e+00
    endloop
  endfacet
  facet normal  8.316102e-01  3.469629e-01 -4.336372e-01
    outer loop
      vertex   6.957979e+00  2.296583e+00  1.261688e+00
      vertex   7.110293e+00  2.367334e+00  1.610399e+00
      vertex   7.287334e+00  1.932436e+00  1.601949e+00
    endloop
  endfacet
  facet normal  4.667747e-01 -8.833840e-01  4.188094e-02
    outer loop
      vertex   7.421623e+00 -3.057121e+00  4.092836e+00
      vertex   7.574584e+00 -2.943947e+00  4.775200e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
    endloop
  endfacet
  facet normal  4.735857e-01  8.801827e-01  3.154118e-02
    outer loop
      vertex   8.815482e+00  2.026991e+00  8.300353e+00
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
      vertex   8.841630e+00  1.986746e+00  9.030819e+00
    endloop
  endfacet
  facet normal -3.225143e-01 -9.465635e-01  1.439646e-03
    outer loop
      vertex   1.863009e+00  5.246222e+00  1.537825e+00
      vertex   1.511153e+00  5.363768e+00 -6.869505e-17
      vertex   2.026891e+00  5.188045e+00 -1.376214e-17
    endloop
  endfacet
  facet normal  4.446709e-01  8.941544e-01  5.249476e-02
    outer loop
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
      vertex   8.447516e+00  2.183165e+00  9.023621e+00
      vertex   8.841630e+00  1.986746e+00  9.030819e+00
    endloop
  endfacet
  facet normal -1.215378e-01 -9.706955e-01  2.073133e-01
    outer loop
      vertex  -3.934147e+00 -2.137609e+00  1.704107e+01
      vertex  -4.564079e+00 -2.174232e+00  1.650029e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
    endloop
  endfacet
  facet normal -5.102648e-01 -8.585426e-01  5.034395e-02
    outer loop
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
      vertex  -8.756927e+00 -2.077204e+00  7.572257e+00
    endloop
  endfacet
  facet normal  5.105208e-01  8.596808e-01  1.781647e-02
    outer loop
      vertex   8.755881e+00  2.077475e+00  7.572239e+00
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
      vertex   8.815482e+00  2.026991e+00  8.300353e+00
    endloop
  endfacet
  facet normal -4.492549e-02 -9.989895e-01 -1.285280e-03
    outer loop
      vertex   3.864515e-01  5.562234e+00 -1.209102e-16
      vertex   4.404008e-01  5.559808e+00  0.000000e+00
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
    endloop
  endfacet
  facet normal  7.663316e-01 -1.121363e-07  6.424452e-01
    outer loop
      vertex  -6.414639e+00  3.632761e+00  4.382941e+00
      vertex  -6.237097e+00 -3.788153e+00  4.171160e+00
      vertex  -6.237068e+00  3.783979e+00  4.171127e+00
    endloop
  endfacet
  facet normal  5.097019e-01  8.589203e-01  4.959672e-02
    outer loop
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
      vertex   8.755881e+00  2.077475e+00  7.572239e+00
    endloop
  endfacet
  facet normal  7.874539e-01  5.721168e-06  6.163735e-01
    outer loop
      vertex  -6.581262e+00  3.492887e+00  4.595612e+00
      vertex  -6.582784e+00 -3.495262e+00  4.597621e+00
      vertex  -6.417768e+00 -3.634079e+00  4.386804e+00
    endloop
  endfacet
  facet normal  2.395138e-01  9.708716e-01 -6.443792e-03
    outer loop
      vertex   1.820081e+00  6.455732e+00  1.445411e+00
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
      vertex   1.604250e+00  6.509223e+00  1.482296e+00
    endloop
  endfacet
  facet normal -5.089127e-01  8.462237e-01  1.578394e-01
    outer loop
      vertex  -6.581262e+00  3.492887e+00  4.595612e+00
      vertex  -6.414639e+00  3.632761e+00  4.382941e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
    endloop
  endfacet
  facet normal  6.622670e-01  7.482889e-01 -3.829199e-02
    outer loop
      vertex   7.917879e+00  2.701559e+00  4.760293e+00
      vertex   8.069473e+00  2.602678e+00  5.449855e+00
      vertex   8.404426e+00  2.305803e+00  5.441488e+00
    endloop
  endfacet
  facet normal -8.611653e-01 -4.877375e-01  1.432003e-01
    outer loop
      vertex  -9.268229e+00 -1.189653e+00  1.158213e+01
      vertex  -9.417384e+00 -1.189667e+00  1.068511e+01
      vertex  -9.261168e+00 -1.470842e+00  1.066687e+01
    endloop
  endfacet
  facet normal  7.095969e-01  6.974326e-01 -1.002993e-01
    outer loop
      vertex   7.742470e+00  2.781343e+00  4.074096e+00
      vertex   7.917879e+00  2.701559e+00  4.760293e+00
      vertex   8.234009e+00  2.378031e+00  4.747190e+00
    endloop
  endfacet
  facet normal -8.625543e-01  1.559060e-01 -4.813454e-01
    outer loop
      vertex  -7.330915e+00  9.558201e-01  1.245726e+00
      vertex  -7.248943e+00  1.422327e+00  1.249935e+00
      vertex  -6.962196e+00  8.877678e-01  5.629520e-01
    endloop
  endfacet
  facet normal  7.800642e-01  5.834296e-01 -2.260749e-01
    outer loop
      vertex   7.327545e+00  2.863512e+00  2.711124e+00
      vertex   7.544757e+00  2.836538e+00  3.390997e+00
      vertex   7.816690e+00  2.465845e+00  3.372647e+00
    endloop
  endfacet
  facet normal -3.460700e-01 -9.372833e-01 -4.165975e-02
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
      vertex  -2.396073e+00 -6.296173e+00  1.680281e+00
    endloop
  endfacet
  facet normal  2.509125e-15 -1.256098e-15 -1.000000e+00
    outer loop
      vertex   1.754346e+00 -6.432830e+00  1.721713e-15
      vertex   1.441300e+00 -6.508503e+00  1.031293e-15
      vertex   1.519274e+00 -5.360741e+00 -2.147588e-16
    endloop
  endfacet
  facet normal  7.943039e-01  5.178328e-01 -3.176959e-01
    outer loop
      vertex   7.184754e+00  2.856169e+00  2.342148e+00
      vertex   7.327545e+00  2.863512e+00  2.711124e+00
      vertex   7.574259e+00  2.473860e+00  2.692841e+00
    endloop
  endfacet
  facet normal  9.462553e-01 -2.979722e-01 -1.257515e-01
    outer loop
      vertex   9.356856e+00 -9.520664e-01  6.855625e+00
      vertex   9.322818e+00 -1.365606e+00  7.579388e+00
      vertex   9.215240e+00 -1.401539e+00  6.855026e+00
    endloop
  endfacet
  facet normal  7.927811e-01  4.661361e-01 -3.927026e-01
    outer loop
      vertex   7.036183e+00  2.824865e+00  1.973314e+00
      vertex   7.431244e+00  2.459944e+00  2.337697e+00
      vertex   7.268930e+00  2.425638e+00  1.969299e+00
    endloop
  endfacet
  facet normal  7.902280e-01  4.956471e-01 -3.603799e-01
    outer loop
      vertex   7.036183e+00  2.824865e+00  1.973314e+00
      vertex   7.184754e+00  2.856169e+00  2.342148e+00
      vertex   7.431244e+00  2.459944e+00  2.337697e+00
    endloop
  endfacet
  facet normal -4.001848e-01 -1.596864e-03  9.164331e-01
    outer loop
      vertex   3.411897e+00 -5.881508e+00  2.062777e+00
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
    endloop
  endfacet
  facet normal -1.251633e-01 -4.876340e-01  8.640296e-01
    outer loop
      vertex  -9.082920e-01 -1.189516e+00  1.901830e+01
      vertex  -1.808037e+00 -1.189526e+00  1.888795e+01
      vertex  -1.778063e+00 -1.470493e+00  1.873373e+01
    endloop
  endfacet
  facet normal  7.971424e-01  4.314142e-01 -4.224283e-01
    outer loop
      vertex   6.900171e+00  2.765280e+00  1.620299e+00
      vertex   7.268930e+00  2.425638e+00  1.969299e+00
      vertex   7.110293e+00  2.367334e+00  1.610399e+00
    endloop
  endfacet
  facet normal  7.954714e-01  4.676313e-01 -3.854170e-01
    outer loop
      vertex   6.900171e+00  2.765280e+00  1.620299e+00
      vertex   7.036183e+00  2.824865e+00  1.973314e+00
      vertex   7.268930e+00  2.425638e+00  1.969299e+00
    endloop
  endfacet
  facet normal  8.037124e-01  4.344878e-01 -4.065299e-01
    outer loop
      vertex   6.762638e+00  2.691202e+00  1.269223e+00
      vertex   6.900171e+00  2.765280e+00  1.620299e+00
      vertex   7.110293e+00  2.367334e+00  1.610399e+00
    endloop
  endfacet
  facet normal  4.130330e-01  9.076515e-01  7.464832e-02
    outer loop
      vertex   8.197143e+00  2.494410e+00  6.145931e+00
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
    endloop
  endfacet
  facet normal  3.369942e-01  9.315116e-01  1.368249e-01
    outer loop
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
      vertex   7.902397e+00  2.533552e+00  6.850276e+00
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
    endloop
  endfacet
  facet normal  1.381222e-15 -2.563463e-15 -1.000000e+00
    outer loop
      vertex   6.509523e+00  1.583495e+00  1.110223e-16
      vertex   6.590715e+00  1.207189e+00  1.187813e-15
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
    endloop
  endfacet
  facet normal  1.974419e-01 -2.634788e-03  9.803110e-01
    outer loop
      vertex  -1.606912e+00 -6.512114e+00  1.482861e+00
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
      vertex  -1.862915e+00 -5.245935e+00  1.537825e+00
    endloop
  endfacet
  facet normal  4.116501e-01  9.035873e-01  1.186348e-01
    outer loop
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
      vertex   8.197143e+00  2.494410e+00  6.145931e+00
    endloop
  endfacet
  facet normal  3.627650e-01 -9.043027e-01  2.250295e-01
    outer loop
      vertex   7.727928e+00 -1.948465e+00  1.386502e+01
      vertex   6.942640e+00 -2.137383e+00  1.437178e+01
      vertex   7.377430e+00 -2.137368e+00  1.367093e+01
    endloop
  endfacet
  facet normal  4.921198e-01  8.674765e-01  7.282063e-02
    outer loop
      vertex   7.572250e+00  2.941378e+00  4.775318e+00
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
      vertex   8.069473e+00  2.602678e+00  5.449855e+00
    endloop
  endfacet
  facet normal -1.798467e-01  9.835612e-01 -1.620447e-02
    outer loop
      vertex  -1.128328e+00  6.602671e+00  1.402445e+00
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
    endloop
  endfacet
  facet normal  9.309565e-01 -1.044744e-01  3.498644e-01
    outer loop
      vertex   9.168580e+00 -4.434319e-01  1.252308e+01
      vertex   8.794788e+00 -8.843689e-01  1.338603e+01
      vertex   9.124413e+00 -8.843880e-01  1.250893e+01
    endloop
  endfacet
  facet normal  6.396345e-01  7.650554e-01 -7.455267e-02
    outer loop
      vertex   7.418854e+00  3.053747e+00  4.092981e+00
      vertex   7.917879e+00  2.701559e+00  4.760293e+00
      vertex   7.742470e+00  2.781343e+00  4.074096e+00
    endloop
  endfacet
  facet normal  7.371781e-01  6.422238e-01 -2.100407e-01
    outer loop
      vertex   7.040045e+00  3.195406e+00  2.716892e+00
      vertex   7.544757e+00  2.836538e+00  3.390997e+00
      vertex   7.327545e+00  2.863512e+00  2.711124e+00
    endloop
  endfacet
  facet normal  7.441731e-01  5.985019e-01 -2.966509e-01
    outer loop
      vertex   6.784631e+00  3.177065e+00  1.985825e+00
      vertex   6.910635e+00  3.199858e+00  2.347902e+00
      vertex   7.184754e+00  2.856169e+00  2.342148e+00
    endloop
  endfacet
  facet normal  7.752984e-01  4.839523e-01 -4.058359e-01
    outer loop
      vertex   6.542725e+00  3.050726e+00  1.277834e+00
      vertex   6.900171e+00  2.765280e+00  1.620299e+00
      vertex   6.762638e+00  2.691202e+00  1.269223e+00
    endloop
  endfacet
  facet normal  8.081383e-01  4.177605e-01 -4.151972e-01
    outer loop
      vertex   6.762638e+00  2.691202e+00  1.269223e+00
      vertex   6.482162e+00  2.540468e+00  5.716410e-01
      vertex   6.294444e+00  2.906713e+00  5.747747e-01
    endloop
  endfacet
  facet normal  6.608722e-01  1.047302e-01  7.431551e-01
    outer loop
      vertex   6.704513e+00  8.849583e-01  1.642692e+01
      vertex   6.047083e+00  4.440784e-01  1.707369e+01
      vertex   6.737047e+00  4.440575e-01  1.646012e+01
    endloop
  endfacet
  facet normal  4.672859e-01  8.782271e-01  1.017889e-01
    outer loop
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
      vertex   7.572250e+00  2.941378e+00  4.775318e+00
    endloop
  endfacet
  facet normal  6.847437e-01  7.141665e-01 -1.452318e-01
    outer loop
      vertex   6.733425e+00  3.490854e+00  2.724072e+00
      vertex   7.245383e+00  3.139837e+00  3.411770e+00
      vertex   7.040045e+00  3.195406e+00  2.716892e+00
    endloop
  endfacet
  facet normal  8.042058e-01  4.063731e-01 -4.337211e-01
    outer loop
      vertex   6.762638e+00  2.691202e+00  1.269223e+00
      vertex   7.110293e+00  2.367334e+00  1.610399e+00
      vertex   6.957979e+00  2.296583e+00  1.261688e+00
    endloop
  endfacet
  facet normal  7.034410e-01  6.694977e-01 -2.386287e-01
    outer loop
      vertex   6.618492e+00  3.509832e+00  2.356373e+00
      vertex   7.040045e+00  3.195406e+00  2.716892e+00
      vertex   6.910635e+00  3.199858e+00  2.347902e+00
    endloop
  endfacet
  facet normal  5.138040e-01 -8.515899e-01 -1.039232e-01
    outer loop
      vertex   3.816425e+00 -5.551033e+00  6.146011e-01
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
      vertex   3.789027e+00 -5.492561e+00  3.174544e-16
    endloop
  endfacet
  facet normal -9.864493e-01  3.162793e-03  1.640357e-01
    outer loop
      vertex  -9.411016e+00  8.449554e-04  1.161289e+01
      vertex  -9.563873e+00 -4.428368e-01  1.070222e+01
      vertex  -9.412389e+00 -4.428558e-01  1.161319e+01
    endloop
  endfacet
  facet normal  7.058790e-01  6.714399e-01 -2.256178e-01
    outer loop
      vertex   6.515748e+00  3.498491e+00  2.001171e+00
      vertex   6.618492e+00  3.509832e+00  2.356373e+00
      vertex   6.910635e+00  3.199858e+00  2.347902e+00
    endloop
  endfacet
  facet normal -8.395630e-01  3.284222e-01 -4.327503e-01
    outer loop
      vertex  -7.123807e+00  1.872915e+00  1.255299e+00
      vertex  -7.112368e+00  2.370153e+00  1.610469e+00
      vertex  -6.960249e+00  2.299536e+00  1.261756e+00
    endloop
  endfacet
  facet normal  7.510653e-01  5.471238e-01 -3.695354e-01
    outer loop
      vertex   6.303267e+00  3.385946e+00  1.287462e+00
      vertex   6.664850e+00  3.122030e+00  1.631618e+00
      vertex   6.542725e+00  3.050726e+00  1.277834e+00
    endloop
  endfacet
  facet normal  7.408440e-01  5.852852e-01 -3.295322e-01
    outer loop
      vertex   6.303267e+00  3.385946e+00  1.287462e+00
      vertex   6.410461e+00  3.451159e+00  1.644279e+00
      vertex   6.664850e+00  3.122030e+00  1.631618e+00
    endloop
  endfacet
  facet normal  6.794859e-01  7.123594e-01 -1.756219e-01
    outer loop
      vertex   6.017262e+00  4.093054e+00  2.395866e+00
      vertex   6.733425e+00  3.490854e+00  2.724072e+00
      vertex   6.618492e+00  3.509832e+00  2.356373e+00
    endloop
  endfacet
  facet normal -5.758988e-01 -8.050799e-01  1.420811e-01
    outer loop
      vertex  -4.773528e+00 -4.994781e+00  2.844591e+00
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
      vertex  -4.685282e+00 -5.121077e+00  2.486646e+00
    endloop
  endfacet
  facet normal  6.863678e-01  7.161388e-01 -1.266666e-01
    outer loop
      vertex   5.938993e+00  4.104437e+00  2.036110e+00
      vertex   6.017262e+00  4.093054e+00  2.395866e+00
      vertex   6.618492e+00  3.509832e+00  2.356373e+00
    endloop
  endfacet
  facet normal -5.282612e-01  8.471103e-01  5.782939e-02
    outer loop
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
      vertex  -4.143497e+00  5.457701e+00  2.439818e+00
      vertex  -3.928066e+00  5.611322e+00  2.157428e+00
    endloop
  endfacet
  facet normal  5.062577e-01 -1.044686e-01  8.560312e-01
    outer loop
      vertex   5.301583e+00 -4.432869e-01  1.761840e+01
      vertex   4.469616e+00 -8.842201e-01  1.805662e+01
      vertex   5.276037e+00 -8.842430e-01  1.757970e+01
    endloop
  endfacet
  facet normal  7.175268e-01  6.484747e-01 -2.542360e-01
    outer loop
      vertex   5.777733e+00  4.019957e+00  1.309361e+00
      vertex   5.858973e+00  4.072660e+00  1.673073e+00
      vertex   6.410461e+00  3.451159e+00  1.644279e+00
    endloop
  endfacet
  facet normal -1.565985e-01  9.718346e-01  1.761091e-01
    outer loop
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
      vertex  -5.900717e+00  2.138166e+00  1.560617e+01
    endloop
  endfacet
  facet normal  7.654261e-01  5.492897e-01 -3.352666e-01
    outer loop
      vertex   6.303267e+00  3.385946e+00  1.287462e+00
      vertex   6.086132e+00  3.255663e+00  5.782843e-01
      vertex   5.614513e+00  3.917742e+00  5.862894e-01
    endloop
  endfacet
  facet normal  8.180872e-01  4.860160e-01  3.074442e-01
    outer loop
      vertex   8.881103e+00  1.467134e+00  1.243096e+01
      vertex   8.702976e+00  1.187906e+00  1.334635e+01
      vertex   9.029185e+00  1.187859e+00  1.247841e+01
    endloop
  endfacet
  facet normal -5.120571e-01  8.416386e-01  1.715863e-01
    outer loop
      vertex  -6.414639e+00  3.632761e+00  4.382941e+00
      vertex  -6.237068e+00  3.783979e+00  4.171127e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
    endloop
  endfacet
  facet normal  9.312741e-01 -7.622484e-02 -3.562562e-01
    outer loop
      vertex   8.373710e+00 -5.302849e-01  3.328514e+00
      vertex   8.597154e+00 -1.047232e+00  4.023216e+00
      vertex   8.333261e+00 -1.052835e+00  3.334583e+00
    endloop
  endfacet
  facet normal  6.096271e-01  7.898787e-01  6.668270e-02
    outer loop
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   5.425769e+00  4.556772e+00  2.798037e+00
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
    endloop
  endfacet
  facet normal -9.473300e-01 -3.135246e-01  6.533059e-02
    outer loop
      vertex  -9.517808e+00 -8.837872e-01  1.069684e+01
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
      vertex  -9.417384e+00 -1.189667e+00  1.068511e+01
    endloop
  endfacet
  facet normal  6.780011e-01  6.906880e-01 -2.515243e-01
    outer loop
      vertex   5.192330e+00  4.603491e+00  1.333755e+00
      vertex   5.858973e+00  4.072660e+00  1.673073e+00
      vertex   5.777733e+00  4.019957e+00  1.309361e+00
    endloop
  endfacet
  facet normal -9.749691e-01 -3.978858e-08  2.223406e-01
    outer loop
      vertex   8.088119e+00  2.358255e+00  7.924740e+00
      vertex   8.005828e+00 -2.413929e+00  7.563893e+00
      vertex   8.088120e+00 -2.358206e+00  7.924744e+00
    endloop
  endfacet
  facet normal  6.398338e-01 -7.664152e-01  5.674871e-02
    outer loop
      vertex   6.020991e+00 -4.094975e+00  2.395767e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
    endloop
  endfacet
  facet normal  5.338404e-01 -8.409221e-01  8.868238e-02
    outer loop
      vertex   4.968148e+00 -4.831974e+00  2.986660e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
    endloop
  endfacet
  facet normal  7.209332e-01  6.448216e-01 -2.538907e-01
    outer loop
      vertex   5.777733e+00  4.019957e+00  1.309361e+00
      vertex   5.614513e+00  3.917742e+00  5.862894e-01
      vertex   5.073212e+00  4.526468e+00  5.952616e-01
    endloop
  endfacet
  facet normal -5.899407e-01  8.073110e-01  1.479791e-02
    outer loop
      vertex  -6.930485e+00  3.404509e+00  3.434753e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
    endloop
  endfacet
  facet normal  5.980254e-01  8.011042e-01 -2.444465e-02
    outer loop
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   5.311325e+00  4.662725e+00  2.075060e+00
    endloop
  endfacet
  facet normal  8.414408e-01  4.603715e-01 -2.829053e-01
    outer loop
      vertex   7.816690e+00  2.465845e+00  3.372647e+00
      vertex   8.288459e+00  2.015738e+00  4.043362e+00
      vertex   8.047511e+00  2.034334e+00  3.356977e+00
    endloop
  endfacet
  facet normal  6.084284e-01  7.822485e-01 -1.337996e-01
    outer loop
      vertex   4.553915e+00  5.129000e+00  1.359486e+00
      vertex   4.596550e+00  5.160742e+00  1.738938e+00
      vertex   5.252198e+00  4.645002e+00  1.705145e+00
    endloop
  endfacet
  facet normal  5.387365e-01  8.393829e-01 -7.210595e-02
    outer loop
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   4.596550e+00  5.160742e+00  1.738938e+00
    endloop
  endfacet
  facet normal -2.577162e-01  9.641774e-01  6.280449e-02
    outer loop
      vertex  -8.203500e+00  2.272688e+00  8.653869e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
    endloop
  endfacet
  facet normal -2.357596e-01 -9.695868e-01  6.571779e-02
    outer loop
      vertex  -8.253299e+00 -2.206669e+00  9.386083e+00
      vertex  -8.269004e+00 -2.177960e+00  9.753304e+00
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
    endloop
  endfacet
  facet normal  4.563699e-01  8.877719e-01 -5.989591e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   3.161976e+00  5.992579e+00  1.805074e+00
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
    endloop
  endfacet
  facet normal -3.930601e-01  9.192556e-01 -2.174826e-02
    outer loop
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
    endloop
  endfacet
  facet normal -2.971568e-01 -9.532802e-01 -5.435574e-02
    outer loop
      vertex  -2.367681e+00 -6.277615e+00  6.327448e-01
      vertex  -2.354590e+00 -6.245616e+00 -4.946853e-16
      vertex  -1.585613e+00 -6.485322e+00 -5.642188e-16
    endloop
  endfacet
  facet normal  2.304575e-01  2.916150e-03  9.730780e-01
    outer loop
      vertex  -2.003711e+00  6.412324e+00  1.571811e+00
      vertex  -2.166200e+00  5.124269e+00  1.614154e+00
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
    endloop
  endfacet
  facet normal -3.738647e-01  9.265385e-01 -4.185072e-02
    outer loop
      vertex  -3.144492e+00  5.979891e+00  1.410066e+00
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
    endloop
  endfacet
  facet normal -6.900360e-01  6.987857e-01 -1.885442e-01
    outer loop
      vertex  -5.779037e+00  4.023558e+00  1.309442e+00
      vertex  -5.253759e+00  4.649057e+00  1.705261e+00
      vertex  -5.194129e+00  4.607729e+00  1.333857e+00
    endloop
  endfacet
  facet normal -4.675756e-01  8.819540e-01 -5.941524e-02
    outer loop
      vertex  -3.870190e+00  5.593496e+00  1.385433e+00
      vertex  -3.163172e+00  5.996607e+00  1.805202e+00
      vertex  -3.144492e+00  5.979891e+00  1.410066e+00
    endloop
  endfacet
  facet normal -4.538842e-01  8.867915e-01 -8.712103e-02
    outer loop
      vertex  -3.870190e+00  5.593496e+00  1.385433e+00
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
      vertex  -3.163172e+00  5.996607e+00  1.805202e+00
    endloop
  endfacet
  facet normal  9.369025e-01  3.129339e-01  1.558403e-01
    outer loop
      vertex   9.418399e+00  1.187765e+00  1.068572e+01
      vertex   9.366868e+00  8.848324e-01  1.160382e+01
      vertex   9.517658e+00  8.848133e-01  1.069732e+01
    endloop
  endfacet
  facet normal -5.417687e-01  8.400297e-01 -2.892706e-02
    outer loop
      vertex  -4.598021e+00  5.164835e+00  1.739065e+00
      vertex  -3.928066e+00  5.611322e+00  2.157428e+00
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
    endloop
  endfacet
  facet normal -5.224981e-01  8.497490e-01 -7.015945e-02
    outer loop
      vertex  -4.598021e+00  5.164835e+00  1.739065e+00
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
      vertex  -3.928066e+00  5.611322e+00  2.157428e+00
    endloop
  endfacet
  facet normal -5.527415e-01  8.283726e-01 -9.097088e-02
    outer loop
      vertex  -4.555652e+00  5.133276e+00  1.359595e+00
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
      vertex  -3.870190e+00  5.593496e+00  1.385433e+00
    endloop
  endfacet
  facet normal  9.375640e-01 -3.474729e-01  1.536945e-02
    outer loop
      vertex   9.427947e+00 -1.297487e+00  9.776816e+00
      vertex   9.432705e+00 -1.317156e+00  9.041909e+00
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
    endloop
  endfacet
  facet normal  3.386970e-01  9.046582e-01  2.586074e-01
    outer loop
      vertex   6.942175e+00  2.137827e+00  1.437145e+01
      vertex   6.757576e+00  1.949507e+00  1.527199e+01
      vertex   7.271794e+00  1.949461e+00  1.459869e+01
    endloop
  endfacet
  facet normal -5.340187e-01  8.355559e-01 -1.291139e-01
    outer loop
      vertex  -4.555652e+00  5.133276e+00  1.359595e+00
      vertex  -4.598021e+00  5.164835e+00  1.739065e+00
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
    endloop
  endfacet
  facet normal -5.501848e-01  8.262448e-01 -1.208977e-01
    outer loop
      vertex  -4.555652e+00  5.133276e+00  1.359595e+00
      vertex  -3.870190e+00  5.593496e+00  1.385433e+00
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
    endloop
  endfacet
  facet normal -5.887460e-01  7.974679e-01 -1.319964e-01
    outer loop
      vertex  -5.253759e+00  4.649057e+00  1.705261e+00
      vertex  -5.312944e+00  4.666594e+00  2.075194e+00
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
    endloop
  endfacet
  facet normal -6.655614e-01  7.354318e-01 -1.271534e-01
    outer loop
      vertex  -4.555652e+00  5.133276e+00  1.359595e+00
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
      vertex  -5.075042e+00  4.531092e+00  5.953255e-01
    endloop
  endfacet
  facet normal -6.305102e-01  7.679650e-01 -1.126350e-01
    outer loop
      vertex  -5.940165e+00  4.107729e+00  2.036218e+00
      vertex  -6.018507e+00  4.096174e+00  2.395986e+00
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
    endloop
  endfacet
  facet normal  9.338997e-01 -7.481885e-03 -3.574567e-01
    outer loop
      vertex   8.378257e+00 -9.479523e-04  3.326392e+00
      vertex   8.642137e+00 -8.125305e-04  4.015808e+00
      vertex   8.638652e+00 -5.277958e-01  4.017734e+00
    endloop
  endfacet
  facet normal -6.758170e-01  7.231820e-01 -1.424055e-01
    outer loop
      vertex  -5.860100e+00  4.076109e+00  1.673166e+00
      vertex  -5.312944e+00  4.666594e+00  2.075194e+00
      vertex  -5.253759e+00  4.649057e+00  1.705261e+00
    endloop
  endfacet
  facet normal -6.581164e-01  7.104387e-01 -2.493182e-01
    outer loop
      vertex  -5.779037e+00  4.023558e+00  1.309442e+00
      vertex  -5.860100e+00  4.076109e+00  1.673166e+00
      vertex  -5.253759e+00  4.649057e+00  1.705261e+00
    endloop
  endfacet
  facet normal  5.327514e-01  8.430991e-04  8.462713e-01
    outer loop
      vertex  -4.340185e+00  5.320688e+00  2.557577e+00
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
      vertex  -4.250774e+00  3.512644e+00  2.503092e+00
    endloop
  endfacet
  facet normal -6.788800e-01  6.902042e-01 -2.504797e-01
    outer loop
      vertex  -5.779037e+00  4.023558e+00  1.309442e+00
      vertex  -5.194129e+00  4.607729e+00  1.333857e+00
      vertex  -5.615840e+00  3.921659e+00  5.863419e-01
    endloop
  endfacet
  facet normal  8.258601e-01  3.703492e-01 -4.252017e-01
    outer loop
      vertex   7.110293e+00  2.367334e+00  1.610399e+00
      vertex   7.268930e+00  2.425638e+00  1.969299e+00
      vertex   7.465204e+00  1.984163e+00  1.965994e+00
    endloop
  endfacet
  facet normal -6.421317e-01  7.493598e-01 -1.616379e-01
    outer loop
      vertex  -6.619835e+00  3.513231e+00  2.356470e+00
      vertex  -6.734791e+00  3.494051e+00  2.724230e+00
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
    endloop
  endfacet
  facet normal  8.814438e-01 -1.542889e-02 -4.720369e-01
    outer loop
      vertex   7.557779e+00 -4.951801e-01  1.592813e+00
      vertex   7.565843e+00  1.035690e-03  1.591653e+00
      vertex   7.752341e+00 -5.106583e-01  1.956629e+00
    endloop
  endfacet
  facet normal  7.325881e-01  6.784766e-01 -5.462722e-02
    outer loop
      vertex   8.666203e+00  2.144281e+00  6.852543e+00
      vertex   9.078284e+00  1.757601e+00  7.576207e+00
      vertex   8.978265e+00  1.807442e+00  6.853908e+00
    endloop
  endfacet
  facet normal -6.844766e-01  6.687580e-01 -2.902662e-01
    outer loop
      vertex  -6.411795e+00  3.454931e+00  1.644359e+00
      vertex  -6.517076e+00  3.502085e+00  2.001261e+00
      vertex  -5.940165e+00  4.107729e+00  2.036218e+00
    endloop
  endfacet
  facet normal -7.202842e-01  6.090722e-01 -3.319965e-01
    outer loop
      vertex  -6.304759e+00  3.389902e+00  1.287535e+00
      vertex  -5.779037e+00  4.023558e+00  1.309442e+00
      vertex  -6.087716e+00  3.260000e+00  5.783348e-01
    endloop
  endfacet
  facet normal  9.896667e-01  1.008337e-01 -1.019426e-01
    outer loop
      vertex   9.468619e+00  9.292984e-01  7.581406e+00
      vertex   9.545728e+00  9.119377e-01  8.312808e+00
      vertex   9.591737e+00  4.614162e-01  8.313847e+00
    endloop
  endfacet
  facet normal -7.120185e-01  6.767267e-01 -1.872717e-01
    outer loop
      vertex  -6.912291e+00  3.203196e+00  2.348057e+00
      vertex  -6.734791e+00  3.494051e+00  2.724230e+00
      vertex  -6.619835e+00  3.513231e+00  2.356470e+00
    endloop
  endfacet
  facet normal  7.905595e-01  5.980267e-01 -1.318320e-01
    outer loop
      vertex   8.234009e+00  2.378031e+00  4.747190e+00
      vertex   8.404426e+00  2.305803e+00  5.441488e+00
      vertex   8.689773e+00  1.927053e+00  5.434519e+00
    endloop
  endfacet
  facet normal -6.728424e-01  7.041185e-01 -2.269365e-01
    outer loop
      vertex  -6.912291e+00  3.203196e+00  2.348057e+00
      vertex  -7.041600e+00  3.198557e+00  2.717051e+00
      vertex  -6.734791e+00  3.494051e+00  2.724230e+00
    endloop
  endfacet
  facet normal -6.938947e-01  6.622226e-01 -2.827922e-01
    outer loop
      vertex  -6.786282e+00  3.180582e+00  1.985910e+00
      vertex  -6.912291e+00  3.203196e+00  2.348057e+00
      vertex  -6.619835e+00  3.513231e+00  2.356470e+00
    endloop
  endfacet
  facet normal -7.140568e-01  6.139676e-01 -3.364024e-01
    outer loop
      vertex  -6.666580e+00  3.125719e+00  1.631697e+00
      vertex  -6.786282e+00  3.180582e+00  1.985910e+00
      vertex  -6.517076e+00  3.502085e+00  2.001261e+00
    endloop
  endfacet
  facet normal  8.642535e-01 -1.686266e-01 -4.739525e-01
    outer loop
      vertex   7.518118e+00 -9.869938e-01  1.595263e+00
      vertex   7.712224e+00 -1.016657e+00  1.959770e+00
      vertex   7.617409e+00 -1.511604e+00  1.962971e+00
    endloop
  endfacet
  facet normal -8.067388e-01  4.861273e-01 -3.359355e-01
    outer loop
      vertex  -6.304759e+00  3.389902e+00  1.287535e+00
      vertex  -6.087716e+00  3.260000e+00  5.783348e-01
      vertex  -6.296607e+00  2.910921e+00  5.748339e-01
    endloop
  endfacet
  facet normal  8.531539e-01 -2.569472e-01 -4.539894e-01
    outer loop
      vertex   7.428255e+00 -1.468988e+00  1.597705e+00
      vertex   7.468736e+00 -1.985460e+00  1.966090e+00
      vertex   7.290936e+00 -1.932402e+00  1.601931e+00
    endloop
  endfacet
  facet normal -3.376450e-01 -9.313870e-01  1.360663e-01
    outer loop
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
      vertex  -7.903955e+00 -2.534363e+00  6.850277e+00
    endloop
  endfacet
  facet normal -4.134431e-01  9.081386e-01  6.594847e-02
    outer loop
      vertex  -8.069816e+00  2.604250e+00  5.449877e+00
      vertex  -8.197238e+00  2.495691e+00  6.145942e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
    endloop
  endfacet
  facet normal -5.681795e-01  8.214384e-01 -4.909948e-02
    outer loop
      vertex  -7.743393e+00  2.783541e+00  4.074136e+00
      vertex  -7.918496e+00  2.703440e+00  4.760324e+00
      vertex  -7.572854e+00  2.943415e+00  4.775358e+00
    endloop
  endfacet
  facet normal  4.241432e-01 -9.033380e-01  6.389782e-02
    outer loop
      vertex   8.833118e+00 -1.949384e+00  9.765130e+00
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
    endloop
  endfacet
  facet normal -7.535742e-01  6.052677e-01 -2.564704e-01
    outer loop
      vertex  -7.186638e+00  2.859190e+00  2.342308e+00
      vertex  -7.041600e+00  3.198557e+00  2.717051e+00
      vertex  -6.912291e+00  3.203196e+00  2.348057e+00
    endloop
  endfacet
  facet normal -6.460487e-01 -7.620060e-01  4.436123e-02
    outer loop
      vertex  -9.108448e+00 -1.664360e+00  1.064903e+01
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
    endloop
  endfacet
  facet normal -7.312788e-01  5.889506e-01 -3.440474e-01
    outer loop
      vertex  -7.038194e+00  2.828043e+00  1.973469e+00
      vertex  -7.186638e+00  2.859190e+00  2.342308e+00
      vertex  -6.912291e+00  3.203196e+00  2.348057e+00
    endloop
  endfacet
  facet normal -2.856209e-01  9.531736e-01  9.940286e-02
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
      vertex  -8.005733e+00  2.414618e+00  7.563975e+00
    endloop
  endfacet
  facet normal  2.206018e-01  9.718327e-01  8.292164e-02
    outer loop
      vertex   8.031503e+00  2.137777e+00  1.215875e+01
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   7.741251e+00  2.137793e+00  1.293075e+01
    endloop
  endfacet
  facet normal -4.703895e-01  8.821607e-01 -2.294037e-02
    outer loop
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
      vertex  -3.928066e+00  5.611322e+00  2.157428e+00
      vertex  -3.644764e+00  5.762789e+00  2.172923e+00
    endloop
  endfacet
  facet normal  3.951073e-01 -1.157742e-03  9.186343e-01
    outer loop
      vertex  -3.173697e+00 -5.997675e+00  1.959259e+00
      vertex  -3.088347e+00 -4.607609e+00  1.924301e+00
      vertex  -3.450266e+00 -4.332319e+00  2.080311e+00
    endloop
  endfacet
  facet normal  5.560509e-01  8.300768e-01  4.218939e-02
    outer loop
      vertex   8.197143e+00  2.494410e+00  6.145931e+00
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
      vertex   8.666203e+00  2.144281e+00  6.852543e+00
    endloop
  endfacet
  facet normal -7.785413e-01  5.246776e-01 -3.443644e-01
    outer loop
      vertex  -6.902237e+00  2.768610e+00  1.620378e+00
      vertex  -6.786282e+00  3.180582e+00  1.985910e+00
      vertex  -6.666580e+00  3.125719e+00  1.631697e+00
    endloop
  endfacet
  facet normal  2.252210e-01 -9.694385e-01 -9.728532e-02
    outer loop
      vertex   1.820122e+00 -6.455023e+00  1.445436e+00
      vertex   1.605798e+00 -6.508545e+00  1.482603e+00
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
    endloop
  endfacet
  facet normal -7.104786e-01 -6.967066e-01 -9.909573e-02
    outer loop
      vertex  -7.745277e+00 -2.786051e+00  4.074001e+00
      vertex  -7.920292e+00 -2.705179e+00  4.760216e+00
      vertex  -8.236091e+00 -2.381275e+00  4.747116e+00
    endloop
  endfacet
  facet normal -7.463981e-01  5.467406e-01 -3.794268e-01
    outer loop
      vertex  -6.902237e+00  2.768610e+00  1.620378e+00
      vertex  -7.038194e+00  2.828043e+00  1.973469e+00
      vertex  -6.786282e+00  3.180582e+00  1.985910e+00
    endloop
  endfacet
  facet normal -7.882677e-01  4.913268e-01 -3.704484e-01
    outer loop
      vertex  -6.764935e+00  2.694681e+00  1.269298e+00
      vertex  -6.666580e+00  3.125719e+00  1.631697e+00
      vertex  -6.544655e+00  3.054583e+00  1.277907e+00
    endloop
  endfacet
  facet normal -3.473460e-01 -2.166325e-03  9.377346e-01
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
      vertex   2.650582e+00 -4.882418e+00  1.761878e+00
    endloop
  endfacet
  facet normal -2.063313e-01 -9.784638e-01 -6.008653e-03
    outer loop
      vertex  -1.606912e+00 -6.512114e+00  1.482861e+00
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -1.447308e+00 -6.545586e+00  1.452824e+00
    endloop
  endfacet
  facet normal  8.861231e-01  4.373687e-04 -4.634498e-01
    outer loop
      vertex  -7.219871e+00 -2.180944e+00  1.358320e+01
      vertex  -7.406964e+00 -2.180943e+00  1.322548e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
    endloop
  endfacet
  facet normal  6.990835e-01  7.000223e-01 -1.457771e-01
    outer loop
      vertex   7.245383e+00  3.139837e+00  3.411770e+00
      vertex   7.742470e+00  2.781343e+00  4.074096e+00
      vertex   7.544757e+00  2.836538e+00  3.390997e+00
    endloop
  endfacet
  facet normal -5.107123e-01  8.595927e-01  1.653660e-02
    outer loop
      vertex  -8.666344e+00  2.145002e+00  6.852547e+00
      vertex  -8.755844e+00  2.077982e+00  7.572240e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
    endloop
  endfacet
  facet normal -6.092974e-01  7.924008e-01  2.928515e-02
    outer loop
      vertex  -8.549037e+00  2.225302e+00  6.142756e+00
      vertex  -8.300170e+00  2.390478e+00  6.851242e+00
      vertex  -8.197238e+00  2.495691e+00  6.145942e+00
    endloop
  endfacet
  facet normal  1.982835e-13  6.964920e-14 -1.000000e+00
    outer loop
      vertex   1.441300e+00 -6.508503e+00  1.031293e-15
      vertex   1.427193e+00 -6.511893e+00 -2.001871e-15
      vertex   1.072319e+00 -5.471157e+00  1.188286e-16
    endloop
  endfacet
  facet normal -5.568282e-01  8.306254e-01  1.942848e-03
    outer loop
      vertex  -8.549037e+00  2.225302e+00  6.142756e+00
      vertex  -8.666344e+00  2.145002e+00  6.852547e+00
      vertex  -8.300170e+00  2.390478e+00  6.851242e+00
    endloop
  endfacet
  facet normal -6.634163e-01  7.482354e-01 -4.750452e-03
    outer loop
      vertex  -8.404983e+00  2.307024e+00  5.441505e+00
      vertex  -8.197238e+00  2.495691e+00  6.145942e+00
      vertex  -8.069816e+00  2.604250e+00  5.449877e+00
    endloop
  endfacet
  facet normal -3.732423e-01 -9.247097e-01 -7.484660e-02
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
    endloop
  endfacet
  facet normal -6.088796e-01  7.925879e-01 -3.271261e-02
    outer loop
      vertex  -8.404983e+00  2.307024e+00  5.441505e+00
      vertex  -8.549037e+00  2.225302e+00  6.142756e+00
      vertex  -8.197238e+00  2.495691e+00  6.145942e+00
    endloop
  endfacet
  facet normal  8.255644e-01 -5.637890e-01 -2.419538e-02
    outer loop
      vertex   9.396529e+00 -1.338722e+00  8.310096e+00
      vertex   9.432705e+00 -1.317156e+00  9.041909e+00
      vertex   9.178670e+00 -1.688936e+00  9.037090e+00
    endloop
  endfacet
  facet normal -3.622070e-17  1.155364e-16 -1.000000e+00
    outer loop
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
      vertex  -5.507651e+00 -5.796566e-01 -6.938894e-18
      vertex  -6.687660e+00 -3.790381e-01  5.898060e-17
    endloop
  endfacet
  facet normal -7.890708e-01  5.872591e-01 -1.802615e-01
    outer loop
      vertex  -7.818043e+00  2.467924e+00  3.372682e+00
      vertex  -7.743393e+00  2.783541e+00  4.074136e+00
      vertex  -7.546020e+00  2.839064e+00  3.391044e+00
    endloop
  endfacet
  facet normal  9.072034e-01  7.374144e-02 -4.141791e-01
    outer loop
      vertex   7.890829e+00  1.034529e+00  2.317666e+00
      vertex   8.083388e+00  5.249405e-01  2.648714e+00
      vertex   7.930045e+00  5.198708e-01  2.311933e+00
    endloop
  endfacet
  facet normal -7.417277e-01  6.376430e-01 -2.079698e-01
    outer loop
      vertex  -7.818043e+00  2.467924e+00  3.372682e+00
      vertex  -8.038638e+00  2.434683e+00  4.057520e+00
      vertex  -7.743393e+00  2.783541e+00  4.074136e+00
    endloop
  endfacet
  facet normal -5.247626e-02 -9.330014e-01  3.560261e-01
    outer loop
      vertex  -1.183776e+00 -2.180971e+00  1.774998e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
    endloop
  endfacet
  facet normal -8.155594e-01  5.270329e-01 -2.389543e-01
    outer loop
      vertex  -7.575926e+00  2.476240e+00  2.692879e+00
      vertex  -7.546020e+00  2.839064e+00  3.391044e+00
      vertex  -7.329176e+00  2.866369e+00  2.711174e+00
    endloop
  endfacet
  facet normal  1.282870e-14  2.238121e-14 -1.000000e+00
    outer loop
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
      vertex  -4.924090e+00  2.546866e+00 -3.700744e-17
      vertex  -4.930842e+00  2.532238e+00 -4.510281e-16
    endloop
  endfacet
  facet normal -3.112027e-02  7.617059e-01  6.471752e-01
    outer loop
      vertex  -1.667350e-04  1.949934e+00  1.841449e+01
      vertex  -8.462134e-01  1.949980e+00  1.837375e+01
      vertex  -8.786176e-01  1.662752e+00  1.871025e+01
    endloop
  endfacet
  facet normal -7.708165e-01  5.781937e-01 -2.674582e-01
    outer loop
      vertex  -7.575926e+00  2.476240e+00  2.692879e+00
      vertex  -7.818043e+00  2.467924e+00  3.372682e+00
      vertex  -7.546020e+00  2.839064e+00  3.391044e+00
    endloop
  endfacet
  facet normal  9.602398e-01  5.352214e-03 -2.791253e-01
    outer loop
      vertex   8.875118e+00  5.187302e-01  4.716023e+00
      vertex   9.082833e+00 -2.098083e-05  5.420652e+00
      vertex   8.877553e+00 -4.463196e-04  4.714444e+00
    endloop
  endfacet
  facet normal -8.030656e-01  5.026117e-01 -3.201049e-01
    outer loop
      vertex  -7.433151e+00  2.462477e+00  2.337850e+00
      vertex  -7.329176e+00  2.866369e+00  2.711174e+00
      vertex  -7.186638e+00  2.859190e+00  2.342308e+00
    endloop
  endfacet
  facet normal  6.609421e-01 -7.496495e-01  3.436640e-02
    outer loop
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
      vertex   8.842025e+00 -1.986032e+00  9.030830e+00
      vertex   9.178670e+00 -1.688936e+00  9.037090e+00
    endloop
  endfacet
  facet normal  6.027330e-02  9.977780e-01 -2.839563e-02
    outer loop
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
    endloop
  endfacet
  facet normal -8.118765e-01  4.377587e-01 -3.862951e-01
    outer loop
      vertex  -7.112368e+00  2.370153e+00  1.610469e+00
      vertex  -7.038194e+00  2.828043e+00  1.973469e+00
      vertex  -6.902237e+00  2.768610e+00  1.620378e+00
    endloop
  endfacet
  facet normal -7.823570e-01  4.597962e-01 -4.201251e-01
    outer loop
      vertex  -7.112368e+00  2.370153e+00  1.610469e+00
      vertex  -7.270958e+00  2.428316e+00  1.969450e+00
      vertex  -7.038194e+00  2.828043e+00  1.973469e+00
    endloop
  endfacet
  facet normal -1.239688e-01  5.392591e-08 -9.922861e-01
    outer loop
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex   1.183401e+00  2.181276e+00  1.775005e+01
      vertex   1.183383e+00 -2.180983e+00  1.775005e+01
    endloop
  endfacet
  facet normal -8.162342e-01  4.111974e-01 -4.058058e-01
    outer loop
      vertex  -6.960249e+00  2.299536e+00  1.261756e+00
      vertex  -6.902237e+00  2.768610e+00  1.620378e+00
      vertex  -6.764935e+00  2.694681e+00  1.269298e+00
    endloop
  endfacet
  facet normal -6.799853e-01  7.330437e-01  1.634201e-02
    outer loop
      vertex  -9.146167e+00  1.720255e+00  8.305802e+00
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
      vertex  -8.815278e+00  2.027315e+00  8.300351e+00
    endloop
  endfacet
  facet normal -6.613472e-01  7.500766e-01  2.239624e-03
    outer loop
      vertex  -9.146167e+00  1.720255e+00  8.305802e+00
      vertex  -9.178032e+00  1.689976e+00  9.037078e+00
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
    endloop
  endfacet
  facet normal -2.168515e-01 -9.047154e-01  3.666955e-01
    outer loop
      vertex  -4.121021e+00 -1.949259e+00  1.739520e+01
      vertex  -4.864460e+00 -1.949308e+00  1.695544e+01
      vertex  -4.643888e+00 -2.137625e+00  1.662126e+01
    endloop
  endfacet
  facet normal -7.042215e-01  7.099343e-01 -8.081949e-03
    outer loop
      vertex  -9.078510e+00  1.757957e+00  7.576210e+00
      vertex  -8.815278e+00  2.027315e+00  8.300351e+00
      vertex  -8.755844e+00  2.077982e+00  7.572240e+00
    endloop
  endfacet
  facet normal -6.802276e-01  7.325669e-01 -2.522255e-02
    outer loop
      vertex  -9.078510e+00  1.757957e+00  7.576210e+00
      vertex  -9.146167e+00  1.720255e+00  8.305802e+00
      vertex  -8.815278e+00  2.027315e+00  8.300351e+00
    endloop
  endfacet
  facet normal  5.559638e-01  8.308049e-01  2.583326e-02
    outer loop
      vertex   6.929443e+00  3.401724e+00  3.434681e+00
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
      vertex   7.418854e+00  3.053747e+00  4.092981e+00
    endloop
  endfacet
  facet normal -7.333229e-01  6.793063e-01 -2.793593e-02
    outer loop
      vertex  -8.978601e+00  1.807972e+00  6.853913e+00
      vertex  -8.755844e+00  2.077982e+00  7.572240e+00
      vertex  -8.666344e+00  2.145002e+00  6.852547e+00
    endloop
  endfacet
  facet normal  1.162311e-14 -1.071358e-14 -1.000000e+00
    outer loop
      vertex   3.794700e+00  5.487965e+00  3.504141e-16
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
      vertex   3.773587e+00  5.503273e+00 -5.898060e-17
    endloop
  endfacet
  facet normal -7.606052e-01  6.387033e-01 -1.163519e-01
    outer loop
      vertex  -8.690358e+00  1.927992e+00  5.434532e+00
      vertex  -8.848840e+00  1.867825e+00  6.140260e+00
      vertex  -8.549037e+00  2.225302e+00  6.142756e+00
    endloop
  endfacet
  facet normal  7.376790e-01  5.832448e-01 -3.400812e-01
    outer loop
      vertex   6.410461e+00  3.451159e+00  1.644279e+00
      vertex   6.784631e+00  3.177065e+00  1.985825e+00
      vertex   6.664850e+00  3.122030e+00  1.631618e+00
    endloop
  endfacet
  facet normal -8.374863e-01  5.095386e-01 -1.974514e-01
    outer loop
      vertex  -8.289346e+00  2.017138e+00  4.043384e+00
      vertex  -8.234803e+00  2.379526e+00  4.747215e+00
      vertex  -8.038638e+00  2.434683e+00  4.057520e+00
    endloop
  endfacet
  facet normal -8.063447e-01  5.489448e-01 -2.201542e-01
    outer loop
      vertex  -8.289346e+00  2.017138e+00  4.043384e+00
      vertex  -8.503814e+00  1.979933e+00  4.736134e+00
      vertex  -8.234803e+00  2.379526e+00  4.747215e+00
    endloop
  endfacet
  facet normal  1.413495e-16 -6.569515e-17 -1.000000e+00
    outer loop
      vertex  -4.634246e+00 -3.046586e+00  9.436896e-17
      vertex  -5.921600e+00 -3.112514e+00 -8.326673e-17
      vertex  -4.910936e+00 -2.571602e+00  2.405483e-17
    endloop
  endfacet
  facet normal  2.714129e-01 -9.599668e-01  6.927217e-02
    outer loop
      vertex   8.088120e+00 -2.358206e+00  7.924744e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
    endloop
  endfacet
  facet normal -8.500753e-01  4.628088e-01 -2.513562e-01
    outer loop
      vertex  -8.048572e+00  2.035978e+00  3.357002e+00
      vertex  -8.038638e+00  2.434683e+00  4.057520e+00
      vertex  -7.818043e+00  2.467924e+00  3.372682e+00
    endloop
  endfacet
  facet normal -8.584418e-01  4.155521e-01 -3.006562e-01
    outer loop
      vertex  -7.784481e+00  2.034075e+00  2.677211e+00
      vertex  -7.818043e+00  2.467924e+00  3.372682e+00
      vertex  -7.575926e+00  2.476240e+00  2.692879e+00
    endloop
  endfacet
  facet normal -8.455161e-01  3.984252e-01 -3.554714e-01
    outer loop
      vertex  -7.640823e+00  2.018465e+00  2.334151e+00
      vertex  -7.575926e+00  2.476240e+00  2.692879e+00
      vertex  -7.433151e+00  2.462477e+00  2.337850e+00
    endloop
  endfacet
  facet normal -8.526534e-01 -2.144202e-01 -4.764516e-01
    outer loop
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
      vertex  -6.512477e+00 -1.573938e+00 -2.775558e-16
      vertex  -6.501628e+00 -1.617079e+00  2.844947e-16
    endloop
  endfacet
  facet normal -9.172552e-01 -3.134860e-01  2.457018e-01
    outer loop
      vertex  -9.124593e+00 -8.838253e-01  1.250855e+01
      vertex  -9.268229e+00 -1.189653e+00  1.158213e+01
      vertex  -9.028337e+00 -1.189642e+00  1.247771e+01
    endloop
  endfacet
  facet normal -8.356964e-01  4.072271e-01 -3.684802e-01
    outer loop
      vertex  -7.640823e+00  2.018465e+00  2.334151e+00
      vertex  -7.784481e+00  2.034075e+00  2.677211e+00
      vertex  -7.575926e+00  2.476240e+00  2.692879e+00
    endloop
  endfacet
  facet normal -8.358638e-01  3.731540e-01 -4.026012e-01
    outer loop
      vertex  -7.466674e+00  1.986303e+00  1.966105e+00
      vertex  -7.433151e+00  2.462477e+00  2.337850e+00
      vertex  -7.270958e+00  2.428316e+00  1.969450e+00
    endloop
  endfacet
  facet normal -8.153325e-01  3.644212e-01 -4.499223e-01
    outer loop
      vertex  -7.288819e+00  1.934694e+00  1.602000e+00
      vertex  -7.466674e+00  1.986303e+00  1.966105e+00
      vertex  -7.270958e+00  2.428316e+00  1.969450e+00
    endloop
  endfacet
  facet normal  9.190021e-01 -1.550369e-07  3.942526e-01
    outer loop
      vertex  -7.658601e+00  2.655306e+00  6.497398e+00
      vertex  -7.658592e+00 -2.655830e+00  6.497374e+00
      vertex  -7.511187e+00  2.762133e+00  6.153776e+00
    endloop
  endfacet
  facet normal -8.782311e-01 -7.272274e-02 -4.726751e-01
    outer loop
      vertex  -7.518944e+00 -9.877434e-01  1.595321e+00
      vertex  -7.752903e+00 -5.110149e-01  1.956669e+00
      vertex  -7.558371e+00 -4.955788e-01  1.592854e+00
    endloop
  endfacet
  facet normal -8.502250e-01  2.866982e-01 -4.414992e-01
    outer loop
      vertex  -6.960249e+00  2.299536e+00  1.261756e+00
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
    endloop
  endfacet
  facet normal -8.252924e-01  5.641893e-01 -2.414109e-02
    outer loop
      vertex  -9.395976e+00  1.340061e+00  8.310084e+00
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
      vertex  -9.178032e+00  1.689976e+00  9.037078e+00
    endloop
  endfacet
  facet normal  3.824608e-01  7.613609e-01  5.235010e-01
    outer loop
      vertex   5.548191e+00  1.949602e+00  1.645586e+01
      vertex   4.864143e+00  1.949648e+00  1.695555e+01
      vertex   5.050371e+00  1.662075e+00  1.723773e+01
    endloop
  endfacet
  facet normal  7.966797e-01  4.994361e-01 -3.403898e-01
    outer loop
      vertex   7.184754e+00  2.856169e+00  2.342148e+00
      vertex   7.574259e+00  2.473860e+00  2.692841e+00
      vertex   7.431244e+00  2.459944e+00  2.337697e+00
    endloop
  endfacet
  facet normal -8.477588e-01  5.278919e-01 -5.133487e-02
    outer loop
      vertex  -9.322186e+00  1.366940e+00  7.579379e+00
      vertex  -9.146167e+00  1.720255e+00  8.305802e+00
      vertex  -9.078510e+00  1.757957e+00  7.576210e+00
    endloop
  endfacet
  facet normal  4.628722e-01  6.200410e-01  6.334813e-01
    outer loop
      vertex   5.760602e+00  1.661981e+00  1.671890e+01
      vertex   5.135185e+00  1.467489e+00  1.736625e+01
      vertex   5.857304e+00  1.467438e+00  1.683866e+01
    endloop
  endfacet
  facet normal -8.343496e-01  5.474938e-01 -6.411799e-02
    outer loop
      vertex  -9.322186e+00  1.366940e+00  7.579379e+00
      vertex  -9.395976e+00  1.340061e+00  8.310084e+00
      vertex  -9.146167e+00  1.720255e+00  8.305802e+00
    endloop
  endfacet
  facet normal -8.612757e-01  5.010734e-01 -8.443744e-02
    outer loop
      vertex  -9.214517e+00  1.402653e+00  6.855028e+00
      vertex  -9.078510e+00  1.757957e+00  7.576210e+00
      vertex  -8.978601e+00  1.807972e+00  6.853913e+00
    endloop
  endfacet
  facet normal  2.384322e-01 -2.903734e-03  9.711548e-01
    outer loop
      vertex   2.750044e+00  4.441681e-01  1.880809e+01
      vertex   1.835537e+00  5.168915e-04  1.903129e+01
      vertex   2.749675e+00  4.949570e-04  1.880685e+01
    endloop
  endfacet
  facet normal -8.448283e-01  5.256740e-01 -9.965917e-02
    outer loop
      vertex  -9.214517e+00  1.402653e+00  6.855028e+00
      vertex  -9.322186e+00  1.366940e+00  7.579379e+00
      vertex  -9.078510e+00  1.757957e+00  7.576210e+00
    endloop
  endfacet
  facet normal -8.746490e-01  4.697620e-01 -1.196361e-01
    outer loop
      vertex  -9.075479e+00  1.445339e+00  6.138269e+00
      vertex  -8.978601e+00  1.807972e+00  6.853913e+00
      vertex  -8.848840e+00  1.867825e+00  6.140260e+00
    endloop
  endfacet
  facet normal -8.666527e-01  4.657515e-01 -1.788537e-01
    outer loop
      vertex  -8.906251e+00  1.487829e+00  5.428909e+00
      vertex  -9.075479e+00  1.445339e+00  6.138269e+00
      vertex  -8.848840e+00  1.867825e+00  6.140260e+00
    endloop
  endfacet
  facet normal  8.456478e-01  2.579505e-01 -4.672701e-01
    outer loop
      vertex   7.287334e+00  1.932436e+00  1.601949e+00
      vertex   7.615463e+00  1.510658e+00  1.962947e+00
      vertex   7.426193e+00  1.469454e+00  1.597667e+00
    endloop
  endfacet
  facet normal -8.915692e-01  4.021745e-01 -2.082309e-01
    outer loop
      vertex  -8.707513e+00  1.523714e+00  4.727165e+00
      vertex  -8.690358e+00  1.927992e+00  5.434532e+00
      vertex  -8.503814e+00  1.979933e+00  4.736134e+00
    endloop
  endfacet
  facet normal -8.934979e-01  3.683717e-01 -2.568337e-01
    outer loop
      vertex  -8.479411e+00  1.548126e+00  4.031908e+00
      vertex  -8.503814e+00  1.979933e+00  4.736134e+00
      vertex  -8.289346e+00  2.017138e+00  4.043384e+00
    endloop
  endfacet
  facet normal -8.253423e-01  5.646070e-01  5.405991e-03
    outer loop
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
      vertex  -9.178032e+00  1.689976e+00  9.037078e+00
    endloop
  endfacet
  facet normal  7.300282e-01  6.366960e-01 -2.483489e-01
    outer loop
      vertex   6.910635e+00  3.199858e+00  2.347902e+00
      vertex   7.040045e+00  3.195406e+00  2.716892e+00
      vertex   7.327545e+00  2.863512e+00  2.711124e+00
    endloop
  endfacet
  facet normal -8.752433e-01  3.625244e-01 -3.201954e-01
    outer loop
      vertex  -8.223594e+00  1.558374e+00  3.344243e+00
      vertex  -8.479411e+00  1.548126e+00  4.031908e+00
      vertex  -8.289346e+00  2.017138e+00  4.043384e+00
    endloop
  endfacet
  facet normal -8.883348e-01  3.019568e-01 -3.459529e-01
    outer loop
      vertex  -7.943122e+00  1.552727e+00  2.664435e+00
      vertex  -8.048572e+00  2.035978e+00  3.357002e+00
      vertex  -7.784481e+00  2.034075e+00  2.677211e+00
    endloop
  endfacet
  facet normal -8.232369e-01  3.423870e-01 -4.528268e-01
    outer loop
      vertex  -7.123807e+00  1.872915e+00  1.255299e+00
      vertex  -7.288819e+00  1.934694e+00  1.602000e+00
      vertex  -7.112368e+00  2.370153e+00  1.610469e+00
    endloop
  endfacet
  facet normal -8.600564e-01  2.732829e-01 -4.308358e-01
    outer loop
      vertex  -7.615716e+00  1.512320e+00  1.962978e+00
      vertex  -7.640823e+00  2.018465e+00  2.334151e+00
      vertex  -7.466674e+00  1.986303e+00  1.966105e+00
    endloop
  endfacet
  facet normal -8.533114e-01  2.575861e-01 -4.533309e-01
    outer loop
      vertex  -7.426454e+00  1.471172e+00  1.597696e+00
      vertex  -7.466674e+00  1.986303e+00  1.966105e+00
      vertex  -7.288819e+00  1.934694e+00  1.602000e+00
    endloop
  endfacet
  facet normal  6.686227e-01  7.193941e-01 -1.881909e-01
    outer loop
      vertex   5.192330e+00  4.603491e+00  1.333755e+00
      vertex   5.252198e+00  4.645002e+00  1.705145e+00
      vertex   5.858973e+00  4.072660e+00  1.673073e+00
    endloop
  endfacet
  facet normal -8.427325e-01  2.680729e-01 -4.668393e-01
    outer loop
      vertex  -7.426454e+00  1.471172e+00  1.597696e+00
      vertex  -7.615716e+00  1.512320e+00  1.962978e+00
      vertex  -7.466674e+00  1.986303e+00  1.966105e+00
    endloop
  endfacet
  facet normal  9.368610e-01 -3.130541e-01  1.558481e-01
    outer loop
      vertex   9.517684e+00 -8.844261e-01  1.069732e+01
      vertex   9.268517e+00 -1.189360e+00  1.158263e+01
      vertex   9.417737e+00 -1.189346e+00  1.068564e+01
    endloop
  endfacet
  facet normal -4.928417e-01 -8.667130e-01 -7.691357e-02
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -3.097691e+00 -5.910476e+00  1.601150e-15
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
    endloop
  endfacet
  facet normal  9.659289e-01  2.865581e-03  2.587917e-01
    outer loop
      vertex   9.411002e+00  2.746582e-04  1.161333e+01
      vertex   9.167368e+00  2.927780e-04  1.252269e+01
      vertex   9.168580e+00 -4.434319e-01  1.252308e+01
    endloop
  endfacet
  facet normal -8.460899e-01  2.555759e-01 -4.677743e-01
    outer loop
      vertex  -7.248943e+00  1.422327e+00  1.249935e+00
      vertex  -7.426454e+00  1.471172e+00  1.597696e+00
      vertex  -7.288819e+00  1.934694e+00  1.602000e+00
    endloop
  endfacet
  facet normal -8.603867e-01  2.154509e-01 -4.618611e-01
    outer loop
      vertex  -7.123807e+00  1.872915e+00  1.255299e+00
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
      vertex  -6.890904e+00  1.322287e+00  5.645704e-01
    endloop
  endfacet
  facet normal -9.433860e-01  3.296323e-01 -3.694943e-02
    outer loop
      vertex  -9.545411e+00  9.126930e-01  8.312806e+00
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
      vertex  -9.395976e+00  1.340061e+00  8.310084e+00
    endloop
  endfacet
  facet normal -9.401905e-01  3.281684e-01 -9.136395e-02
    outer loop
      vertex  -9.468263e+00  9.300938e-01  7.581403e+00
      vertex  -9.545411e+00  9.126930e-01  8.312806e+00
      vertex  -9.395976e+00  1.340061e+00  8.310084e+00
    endloop
  endfacet
  facet normal -7.664623e-01  1.126450e-05  6.422894e-01
    outer loop
      vertex   6.413812e+00  3.631025e+00  4.381729e+00
      vertex   6.237068e+00 -3.785059e+00  4.170946e+00
      vertex   6.416894e+00 -3.631935e+00  4.385535e+00
    endloop
  endfacet
  facet normal -9.460959e-01  2.984082e-01 -1.259168e-01
    outer loop
      vertex  -9.356354e+00  9.532146e-01  6.855628e+00
      vertex  -9.322186e+00  1.366940e+00  7.579379e+00
      vertex  -9.214517e+00  1.402653e+00  6.855028e+00
    endloop
  endfacet
  facet normal -9.456791e-01  2.790336e-01 -1.668268e-01
    outer loop
      vertex  -9.212256e+00  9.808025e-01  6.136631e+00
      vertex  -9.214517e+00  1.402653e+00  6.855028e+00
      vertex  -9.075479e+00  1.445339e+00  6.138269e+00
    endloop
  endfacet
  facet normal  5.121736e-01 -8.456951e-01  1.499270e-01
    outer loop
      vertex   6.237068e+00 -3.785059e+00  4.170946e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
    endloop
  endfacet
  facet normal -9.356803e-01  2.762753e-01 -2.194863e-01
    outer loop
      vertex  -9.037185e+00  1.008070e+00  5.424614e+00
      vertex  -9.212256e+00  9.808025e-01  6.136631e+00
      vertex  -9.075479e+00  1.445339e+00  6.138269e+00
    endloop
  endfacet
  facet normal -9.009100e-01  2.003004e-01 -3.850206e-01
    outer loop
      vertex  -8.042939e+00  1.045719e+00  2.654829e+00
      vertex  -8.332305e+00  1.050993e+00  3.334660e+00
      vertex  -8.223594e+00  1.558374e+00  3.344243e+00
    endloop
  endfacet
  facet normal -8.986566e-01  1.770562e-01 -4.013321e-01
    outer loop
      vertex  -7.890131e+00  1.035671e+00  2.317667e+00
      vertex  -7.943122e+00  1.552727e+00  2.664435e+00
      vertex  -7.795024e+00  1.538778e+00  2.326663e+00
    endloop
  endfacet
  facet normal -5.562537e-01  8.299783e-01  4.144812e-02
    outer loop
      vertex  -8.666344e+00  2.145002e+00  6.852547e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
      vertex  -8.300170e+00  2.390478e+00  6.851242e+00
    endloop
  endfacet
  facet normal -8.932626e-01  1.836348e-01 -4.103170e-01
    outer loop
      vertex  -7.890131e+00  1.035671e+00  2.317667e+00
      vertex  -8.042939e+00  1.045719e+00  2.654829e+00
      vertex  -7.943122e+00  1.552727e+00  2.664435e+00
    endloop
  endfacet
  facet normal -8.769950e-01  1.737953e-01 -4.479676e-01
    outer loop
      vertex  -7.710962e+00  1.017282e+00  1.959771e+00
      vertex  -7.890131e+00  1.035671e+00  2.317667e+00
      vertex  -7.795024e+00  1.538778e+00  2.326663e+00
    endloop
  endfacet
  facet normal  6.531867e-01  7.441311e-01 -1.400571e-01
    outer loop
      vertex   5.252198e+00  4.645002e+00  1.705145e+00
      vertex   5.311325e+00  4.662725e+00  2.075060e+00
      vertex   5.938993e+00  4.104437e+00  2.036110e+00
    endloop
  endfacet
  facet normal -8.643351e-01  1.693670e-01 -4.735397e-01
    outer loop
      vertex  -7.516775e+00  9.891090e-01  1.595251e+00
      vertex  -7.710962e+00  1.017282e+00  1.959771e+00
      vertex  -7.615716e+00  1.512320e+00  1.962978e+00
    endloop
  endfacet
  facet normal -8.643516e-01  1.643579e-01 -4.752713e-01
    outer loop
      vertex  -7.330915e+00  9.558201e-01  1.245726e+00
      vertex  -7.516775e+00  9.891090e-01  1.595251e+00
      vertex  -7.426454e+00  1.471172e+00  1.597696e+00
    endloop
  endfacet
  facet normal  8.300513e-01 -7.375685e-08  5.576870e-01
    outer loop
      vertex  -6.959301e+00  3.184469e+00  5.138667e+00
      vertex  -6.959290e+00 -3.187130e+00  5.138649e+00
      vertex  -6.742538e+00  3.359671e+00  4.816041e+00
    endloop
  endfacet
  facet normal -7.485650e-01  5.463304e-01 -3.757306e-01
    outer loop
      vertex  -6.544655e+00  3.054583e+00  1.277907e+00
      vertex  -6.304759e+00  3.389902e+00  1.287535e+00
      vertex  -6.296607e+00  2.910921e+00  5.748339e-01
    endloop
  endfacet
  facet normal -9.843985e-01  9.391274e-02 -1.487948e-01
    outer loop
      vertex  -9.401338e+00  4.816837e-01  6.855623e+00
      vertex  -9.468263e+00  9.300938e-01  7.581403e+00
      vertex  -9.356354e+00  9.532146e-01  6.855628e+00
    endloop
  endfacet
  facet normal  7.305314e-01  6.525794e-01 -2.011568e-01
    outer loop
      vertex   5.073212e+00  4.526468e+00  5.952616e-01
      vertex   5.614513e+00  3.917742e+00  5.862894e-01
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
    endloop
  endfacet
  facet normal  6.613922e-01  7.498329e-01  1.763681e-02
    outer loop
      vertex   8.815482e+00  2.026991e+00  8.300353e+00
      vertex   8.841630e+00  1.986746e+00  9.030819e+00
      vertex   9.178001e+00  1.689901e+00  9.037074e+00
    endloop
  endfacet
  facet normal -9.764692e-01  9.315674e-02 -1.944984e-01
    outer loop
      vertex  -9.256581e+00  4.951496e-01  6.135331e+00
      vertex  -9.401338e+00  4.816837e-01  6.855623e+00
      vertex  -9.356354e+00  9.532146e-01  6.855628e+00
    endloop
  endfacet
  facet normal -4.924705e-01  8.701612e-01  1.709869e-02
    outer loop
      vertex  -7.918496e+00  2.703440e+00  4.760324e+00
      vertex  -8.069816e+00  2.604250e+00  5.449877e+00
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
    endloop
  endfacet
  facet normal -5.154381e-01  4.865852e-01  7.053782e-01
    outer loop
      vertex  -5.135251e+00  1.468121e+00  1.736573e+01
      vertex  -5.955170e+00  1.188843e+00  1.695925e+01
      vertex  -5.221046e+00  1.188795e+00  1.749572e+01
    endloop
  endfacet
  facet normal -9.674989e-01  8.893614e-02 -2.367198e-01
    outer loop
      vertex  -9.080769e+00  5.083599e-01  5.421729e+00
      vertex  -9.256581e+00  4.951496e-01  6.135331e+00
      vertex  -9.212256e+00  9.808025e-01  6.136631e+00
    endloop
  endfacet
  facet normal -9.574546e-01  8.240099e-02 -2.765698e-01
    outer loop
      vertex  -8.874574e+00  5.192089e-01  4.716022e+00
      vertex  -9.037185e+00  1.008070e+00  5.424614e+00
      vertex  -8.831814e+00  1.030754e+00  4.720401e+00
    endloop
  endfacet
  facet normal -9.567401e-01  8.505205e-02 -2.782349e-01
    outer loop
      vertex  -8.874574e+00  5.192089e-01  4.716022e+00
      vertex  -9.080769e+00  5.083599e-01  5.421729e+00
      vertex  -9.037185e+00  1.008070e+00  5.424614e+00
    endloop
  endfacet
  facet normal -9.305665e-01  7.874288e-02 -3.575548e-01
    outer loop
      vertex  -8.373130e+00  5.283813e-01  3.328554e+00
      vertex  -8.638139e+00  5.261440e-01  4.017769e+00
      vertex  -8.596299e+00  1.045643e+00  4.023285e+00
    endloop
  endfacet
  facet normal  9.840823e-01  9.397431e-02 -1.508339e-01
    outer loop
      vertex   9.356750e+00  9.523754e-01  6.855629e+00
      vertex   9.514176e+00  4.699631e-01  7.582161e+00
      vertex   9.401737e+00  4.812756e-01  6.855625e+00
    endloop
  endfacet
  facet normal -6.631368e-01  7.331748e-01 -1.506792e-01
    outer loop
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
      vertex  -4.404419e+00  5.015305e+00 -2.983724e-16
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
    endloop
  endfacet
  facet normal -9.173399e-01  7.467207e-02 -3.910393e-01
    outer loop
      vertex  -8.082679e+00  5.254803e-01  2.648710e+00
      vertex  -8.332305e+00  1.050993e+00  3.334660e+00
      vertex  -8.042939e+00  1.045719e+00  2.654829e+00
    endloop
  endfacet
  facet normal -7.548963e-01  3.130466e-01  5.763103e-01
    outer loop
      vertex  -7.252964e+00  1.188940e+00  1.568837e+01
      vertex  -7.887197e+00  8.853626e-01  1.502250e+01
      vertex  -7.329620e+00  8.853416e-01  1.575287e+01
    endloop
  endfacet
  facet normal -9.071417e-01  7.416591e-02 -4.142382e-01
    outer loop
      vertex  -7.929305e+00  5.204182e-01  2.311929e+00
      vertex  -8.082679e+00  5.254803e-01  2.648710e+00
      vertex  -8.042939e+00  1.045719e+00  2.654829e+00
    endloop
  endfacet
  facet normal  7.586927e-01  5.540533e-01 -3.426518e-01
    outer loop
      vertex   6.664850e+00  3.122030e+00  1.631618e+00
      vertex   6.784631e+00  3.177065e+00  1.985825e+00
      vertex   7.036183e+00  2.824865e+00  1.973314e+00
    endloop
  endfacet
  facet normal -9.075238e-01  7.360226e-02 -4.135014e-01
    outer loop
      vertex  -7.929305e+00  5.204182e-01  2.311929e+00
      vertex  -8.042939e+00  1.045719e+00  2.654829e+00
      vertex  -7.890131e+00  1.035671e+00  2.317667e+00
    endloop
  endfacet
  facet normal -8.902062e-01  7.424737e-02 -4.494666e-01
    outer loop
      vertex  -7.751578e+00  5.112591e-01  1.956624e+00
      vertex  -7.890131e+00  1.035671e+00  2.317667e+00
      vertex  -7.710962e+00  1.017282e+00  1.959771e+00
    endloop
  endfacet
  facet normal -9.899432e-01  9.792963e-02 -1.020894e-01
    outer loop
      vertex  -9.513821e+00  4.703484e-01  7.582159e+00
      vertex  -9.545411e+00  9.126930e-01  8.312806e+00
      vertex  -9.468263e+00  9.300938e-01  7.581403e+00
    endloop
  endfacet
  facet normal -8.912317e-01  7.274412e-02 -4.476767e-01
    outer loop
      vertex  -7.751578e+00  5.112591e-01  1.956624e+00
      vertex  -7.929305e+00  5.204182e-01  2.311929e+00
      vertex  -7.890131e+00  1.035671e+00  2.317667e+00
    endloop
  endfacet
  facet normal -6.437889e-01  7.369091e-01 -2.061574e-01
    outer loop
      vertex  -5.860100e+00  4.076109e+00  1.673166e+00
      vertex  -5.940165e+00  4.107729e+00  2.036218e+00
      vertex  -5.312944e+00  4.666594e+00  2.075194e+00
    endloop
  endfacet
  facet normal -8.782225e-01  7.342923e-02 -4.725816e-01
    outer loop
      vertex  -7.556970e+00  4.972897e-01  1.592804e+00
      vertex  -7.751578e+00  5.112591e-01  1.956624e+00
      vertex  -7.710962e+00  1.017282e+00  1.959771e+00
    endloop
  endfacet
  facet normal  4.204130e-01 -9.073325e-01 -6.914458e-04
    outer loop
      vertex  -2.166200e+00  5.124269e+00  1.614154e+00
      vertex  -2.553828e+00  4.945892e+00  1.957759e-16
      vertex  -2.057643e+00  5.175800e+00  2.081668e-17
    endloop
  endfacet
  facet normal -8.776067e-01  7.368710e-02 -4.736842e-01
    outer loop
      vertex  -7.369229e+00  4.808502e-01  1.242824e+00
      vertex  -7.516775e+00  9.891090e-01  1.595251e+00
      vertex  -7.330915e+00  9.558201e-01  1.245726e+00
    endloop
  endfacet
  facet normal -9.945852e-01  1.037776e-01  5.515480e-03
    outer loop
      vertex  -9.630352e+00  4.547825e-01  9.045909e+00
      vertex  -9.627151e+00  4.464064e-01  9.780823e+00
      vertex  -9.584052e+00  8.985672e-01  9.044879e+00
    endloop
  endfacet
  facet normal -8.749729e-01  7.350443e-02 -4.785599e-01
    outer loop
      vertex  -7.369229e+00  4.808502e-01  1.242824e+00
      vertex  -7.330915e+00  9.558201e-01  1.245726e+00
      vertex  -6.999551e+00  4.475117e-01  5.618038e-01
    endloop
  endfacet
  facet normal -9.309464e-01  1.047318e-01  3.498142e-01
    outer loop
      vertex  -9.124299e+00  8.854256e-01  1.250846e+01
      vertex  -9.168571e+00  4.445152e-01  1.252264e+01
      vertex  -8.794720e+00  8.854065e-01  1.338556e+01
    endloop
  endfacet
  facet normal -9.709749e-01  4.213596e-03 -2.391446e-01
    outer loop
      vertex  -9.082709e+00 -2.098083e-05  5.420651e+00
      vertex  -9.256581e+00  4.951496e-01  6.135331e+00
      vertex  -9.080769e+00  5.083599e-01  5.421729e+00
    endloop
  endfacet
  facet normal  6.367748e-01  7.703311e-01 -3.328189e-02
    outer loop
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
      vertex   6.017262e+00  4.093054e+00  2.395866e+00
    endloop
  endfacet
  facet normal -9.476241e-01  6.159881e-03 -3.193283e-01
    outer loop
      vertex  -8.641997e+00 -8.125305e-04  4.015808e+00
      vertex  -8.877419e+00 -4.463196e-04  4.714443e+00
      vertex  -8.874574e+00  5.192089e-01  4.716022e+00
    endloop
  endfacet
  facet normal  9.683370e-01 -8.529634e-02 -2.346231e-01
    outer loop
      vertex   9.081166e+00 -5.084686e-01  5.421710e+00
      vertex   9.212836e+00 -9.801426e-01  6.136613e+00
      vertex   9.037848e+00 -1.008127e+00  5.424577e+00
    endloop
  endfacet
  facet normal -9.333414e-01  1.024073e-02 -3.588441e-01
    outer loop
      vertex  -8.378106e+00 -9.479523e-04  3.326391e+00
      vertex  -8.638139e+00  5.261440e-01  4.017769e+00
      vertex  -8.373130e+00  5.283813e-01  3.328554e+00
    endloop
  endfacet
  facet normal  6.645223e-01  2.934630e-03  7.472626e-01
    outer loop
      vertex   6.736129e+00  3.900528e-04  1.645918e+01
      vertex   6.046260e+00  4.100800e-04  1.707267e+01
      vertex   6.047077e+00 -4.433079e-01  1.707368e+01
    endloop
  endfacet
  facet normal  6.645222e-01 -2.948263e-03  7.472627e-01
    outer loop
      vertex   6.737047e+00  4.440575e-01  1.646012e+01
      vertex   6.046260e+00  4.100800e-04  1.707267e+01
      vertex   6.736129e+00  3.900528e-04  1.645918e+01
    endloop
  endfacet
  facet normal  5.605060e-01 -1.918967e-04  8.281503e-01
    outer loop
      vertex  -4.534791e+00 -5.180698e+00  2.681621e+00
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
      vertex  -4.721087e+00 -5.036455e+00  2.807743e+00
    endloop
  endfacet
  facet normal -9.194997e-01  1.245974e-02 -3.928931e-01
    outer loop
      vertex  -8.088883e+00 -6.465912e-04  2.646546e+00
      vertex  -8.373130e+00  5.283813e-01  3.328554e+00
      vertex  -8.082679e+00  5.254803e-01  2.648710e+00
    endloop
  endfacet
  facet normal -9.201434e-01  1.024988e-02 -3.914472e-01
    outer loop
      vertex  -8.088883e+00 -6.465912e-04  2.646546e+00
      vertex  -8.378106e+00 -9.479523e-04  3.326391e+00
      vertex  -8.373130e+00  5.283813e-01  3.328554e+00
    endloop
  endfacet
  facet normal -5.710614e-01  8.194476e-01  4.893397e-02
    outer loop
      vertex  -7.918496e+00  2.703440e+00  4.760324e+00
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
      vertex  -7.572854e+00  2.943415e+00  4.775358e+00
    endloop
  endfacet
  facet normal -9.106101e-01  1.243794e-02 -4.130795e-01
    outer loop
      vertex  -7.936165e+00 -2.708435e-04  2.309898e+00
      vertex  -8.088883e+00 -6.465912e-04  2.646546e+00
      vertex  -8.082679e+00  5.254803e-01  2.648710e+00
    endloop
  endfacet
  facet normal -8.807199e-01  1.802298e-02 -4.732945e-01
    outer loop
      vertex  -7.378439e+00  1.985550e-03  1.241728e+00
      vertex  -7.556970e+00  4.972897e-01  1.592804e+00
      vertex  -7.369229e+00  4.808502e-01  1.242824e+00
    endloop
  endfacet
  facet normal -8.781933e-01  2.213645e-02 -4.777934e-01
    outer loop
      vertex  -7.369229e+00  4.808502e-01  1.242824e+00
      vertex  -6.999551e+00  4.475117e-01  5.618038e-01
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
    endloop
  endfacet
  facet normal -9.986113e-01  1.885587e-03 -5.264810e-02
    outer loop
      vertex  -9.591765e+00 -4.601555e-01  8.313853e+00
      vertex  -9.629494e+00  6.732941e-04  9.045976e+00
      vertex  -9.590901e+00  7.381439e-04  8.313972e+00
    endloop
  endfacet
  facet normal  8.746585e-01  5.993799e-06  4.847398e-01
    outer loop
      vertex  -7.276982e+00 -2.938496e+00  5.680944e+00
      vertex  -7.163385e+00 -3.026060e+00  5.475973e+00
      vertex  -7.275784e+00  2.937731e+00  5.678710e+00
    endloop
  endfacet
  facet normal  9.606203e-01  1.047338e-01  2.573704e-01
    outer loop
      vertex   9.366868e+00  8.848324e-01  1.160382e+01
      vertex   9.124373e+00  8.848534e-01  1.250891e+01
      vertex   9.168643e+00  4.439545e-01  1.252310e+01
    endloop
  endfacet
  facet normal -5.137362e-01  8.548276e-01  7.310846e-02
    outer loop
      vertex  -3.928066e+00  5.611322e+00  2.157428e+00
      vertex  -4.143497e+00  5.457701e+00  2.439818e+00
      vertex  -3.940862e+00  5.589209e+00  2.326075e+00
    endloop
  endfacet
  facet normal  9.749687e-01  0.000000e+00  2.223422e-01
    outer loop
      vertex  -8.005733e+00  2.414618e+00  7.563975e+00
      vertex  -8.088025e+00  2.358904e+00  7.924828e+00
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
    endloop
  endfacet
  facet normal -9.985893e-01  2.507908e-03 -5.303868e-02
    outer loop
      vertex  -9.591765e+00 -4.601555e-01  8.313853e+00
      vertex  -9.630630e+00 -4.532566e-01  9.045915e+00
      vertex  -9.629494e+00  6.732941e-04  9.045976e+00
    endloop
  endfacet
  facet normal -9.944857e-01  1.066818e-03 -1.048667e-01
    outer loop
      vertex  -9.514237e+00 -4.687805e-01  7.582165e+00
      vertex  -9.590901e+00  7.381439e-04  8.313972e+00
      vertex  -9.513741e+00  7.247925e-04  7.582239e+00
    endloop
  endfacet
  facet normal -9.883471e-01  2.363716e-06 -1.522172e-01
    outer loop
      vertex  -9.401835e+00 -4.804020e-01  6.855625e+00
      vertex  -9.513741e+00  7.247925e-04  7.582239e+00
      vertex  -9.401813e+00  6.008148e-04  6.855484e+00
    endloop
  endfacet
  facet normal  6.940515e-02 -9.535858e-01  2.930135e-01
    outer loop
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
      vertex   1.967912e+00 -2.180986e+00  1.759733e+01
    endloop
  endfacet
  facet normal  9.904505e-01 -4.154357e-03 -1.378064e-01
    outer loop
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
      vertex  -8.143590e+00 -2.180941e+00  1.093485e+01
    endloop
  endfacet
  facet normal -9.882401e-01  1.067727e-03 -1.529062e-01
    outer loop
      vertex  -9.401835e+00 -4.804020e-01  6.855625e+00
      vertex  -9.514237e+00 -4.687805e-01  7.582165e+00
      vertex  -9.513741e+00  7.247925e-04  7.582239e+00
    endloop
  endfacet
  facet normal -9.190016e-01 -1.431360e-07  3.942538e-01
    outer loop
      vertex   7.658692e+00  2.654070e+00  6.497303e+00
      vertex   7.511272e+00  2.760725e+00  6.153669e+00
      vertex   7.658683e+00 -2.654942e+00  6.497281e+00
    endloop
  endfacet
  facet normal  2.171495e-01 -9.044254e-01  3.672339e-01
    outer loop
      vertex   4.864637e+00 -1.948717e+00  1.695632e+01
      vertex   3.934129e+00 -2.137462e+00  1.704169e+01
      vertex   4.643985e+00 -2.137446e+00  1.662199e+01
    endloop
  endfacet
  facet normal  6.083231e-01  7.821742e-01 -1.347089e-01
    outer loop
      vertex   4.596550e+00  5.160742e+00  1.738938e+00
      vertex   5.311325e+00  4.662725e+00  2.075060e+00
      vertex   5.252198e+00  4.645002e+00  1.705145e+00
    endloop
  endfacet
  facet normal -9.805948e-01 -1.329981e-03 -1.960406e-01
    outer loop
      vertex  -9.257167e+00 -4.944229e-01  6.135324e+00
      vertex  -9.401813e+00  6.008148e-04  6.855484e+00
      vertex  -9.257729e+00  3.471375e-04  6.134778e+00
    endloop
  endfacet
  facet normal  8.544768e-01  5.191600e-01 -1.849945e-02
    outer loop
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
      vertex  -4.634246e+00 -3.046586e+00  9.436896e-17
    endloop
  endfacet
  facet normal  5.899674e-01  2.935323e-03  8.074218e-01
    outer loop
      vertex   6.046260e+00  4.100800e-04  1.707267e+01
      vertex   5.301583e+00 -4.432869e-01  1.761840e+01
      vertex   6.047077e+00 -4.433079e-01  1.707368e+01
    endloop
  endfacet
  facet normal  9.338838e-01  9.368191e-03 -3.574539e-01
    outer loop
      vertex   8.373780e+00  5.278606e-01  3.328556e+00
      vertex   8.642137e+00 -8.125305e-04  4.015808e+00
      vertex   8.378257e+00 -9.479523e-04  3.326392e+00
    endloop
  endfacet
  facet normal  9.945717e-01  1.038554e-01  6.420269e-03
    outer loop
      vertex   9.584334e+00  8.978500e-01  9.044880e+00
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
    endloop
  endfacet
  facet normal -8.972175e-01  3.133635e-03  4.415779e-01
    outer loop
      vertex  -8.420585e+00  7.877350e-04  1.424816e+01
      vertex  -8.837564e+00 -4.428959e-01  1.340407e+01
      vertex  -8.421803e+00 -4.429150e-01  1.424883e+01
    endloop
  endfacet
  facet normal -9.712523e-01 -2.905533e-03 -2.380345e-01
    outer loop
      vertex  -9.081449e+00 -5.084209e-01  5.421712e+00
      vertex  -9.257729e+00  3.471375e-04  6.134778e+00
      vertex  -9.082709e+00 -2.098083e-05  5.420651e+00
    endloop
  endfacet
  facet normal -9.710012e-01 -1.366661e-03 -2.390705e-01
    outer loop
      vertex  -9.081449e+00 -5.084209e-01  5.421712e+00
      vertex  -9.257167e+00 -4.944229e-01  6.135324e+00
      vertex  -9.257729e+00  3.471375e-04  6.134778e+00
    endloop
  endfacet
  facet normal -9.476240e-01 -6.511398e-03 -3.193216e-01
    outer loop
      vertex  -8.639026e+00 -5.278988e-01  4.017737e+00
      vertex  -8.877419e+00 -4.463196e-04  4.714443e+00
      vertex  -8.641997e+00 -8.125305e-04  4.015808e+00
    endloop
  endfacet
  facet normal  8.772811e-01 -7.310812e-02 -4.743766e-01
    outer loop
      vertex   7.370050e+00 -4.768314e-01  1.242812e+00
      vertex   7.557779e+00 -4.951801e-01  1.592813e+00
      vertex   7.518118e+00 -9.869938e-01  1.595263e+00
    endloop
  endfacet
  facet normal -9.472231e-01 -4.720557e-03 -3.205402e-01
    outer loop
      vertex  -8.639026e+00 -5.278988e-01  4.017737e+00
      vertex  -8.875355e+00 -5.201721e-01  4.715995e+00
      vertex  -8.877419e+00 -4.463196e-04  4.714443e+00
    endloop
  endfacet
  facet normal -9.201381e-01 -1.046742e-02 -3.914541e-01
    outer loop
      vertex  -8.083801e+00 -5.270309e-01  2.648676e+00
      vertex  -8.378106e+00 -9.479523e-04  3.326391e+00
      vertex  -8.088883e+00 -6.465912e-04  2.646546e+00
    endloop
  endfacet
  facet normal -8.942642e-01 -1.145935e-02 -4.473928e-01
    outer loop
      vertex  -7.936165e+00 -2.708435e-04  2.309898e+00
      vertex  -7.752903e+00 -5.110149e-01  1.956669e+00
      vertex  -7.930489e+00 -5.212479e-01  2.311898e+00
    endloop
  endfacet
  facet normal -8.815565e-01 -1.271903e-02 -4.719072e-01
    outer loop
      vertex  -7.759465e+00  2.861023e-04  1.955147e+00
      vertex  -7.558371e+00 -4.955788e-01  1.592854e+00
      vertex  -7.752903e+00 -5.110149e-01  1.956669e+00
    endloop
  endfacet
  facet normal -8.816025e-01 -1.541510e-02 -4.717410e-01
    outer loop
      vertex  -7.378439e+00  1.985550e-03  1.241728e+00
      vertex  -7.370649e+00 -4.772720e-01  1.242829e+00
      vertex  -7.565663e+00  1.035690e-03  1.591647e+00
    endloop
  endfacet
  facet normal -8.170159e-01 -4.197248e-01 -3.953683e-01
    outer loop
      vertex  -6.300128e+00 -2.905363e+00  5.748463e-01
      vertex  -6.487278e+00 -2.538105e+00  5.717039e-01
      vertex  -6.102031e+00 -2.749480e+00 -1.179612e-16
    endloop
  endfacet
  facet normal -9.933794e-01 -1.032787e-01 -5.030931e-02
    outer loop
      vertex  -9.630630e+00 -4.532566e-01  9.045915e+00
      vertex  -9.545940e+00 -9.107361e-01  8.312819e+00
      vertex  -9.584477e+00 -8.966770e-01  9.044888e+00
    endloop
  endfacet
  facet normal  8.205975e-01 -5.016655e-01 -2.737727e-01
    outer loop
      vertex   8.050153e+00 -2.037596e+00  3.356859e+00
      vertex   8.290786e+00 -2.018566e+00  4.043255e+00
      vertex   8.040294e+00 -2.436008e+00  4.057366e+00
    endloop
  endfacet
  facet normal -9.898162e-01 -9.748906e-02 -1.037295e-01
    outer loop
      vertex  -9.514237e+00 -4.687805e-01  7.582165e+00
      vertex  -9.468905e+00 -9.282398e-01  7.581413e+00
      vertex  -9.591765e+00 -4.601555e-01  8.313853e+00
    endloop
  endfacet
  facet normal -9.841650e-01 -9.685824e-02 -1.484517e-01
    outer loop
      vertex  -9.514237e+00 -4.687805e-01  7.582165e+00
      vertex  -9.357120e+00 -9.516964e-01  6.855629e+00
      vertex  -9.468905e+00 -9.282398e-01  7.581413e+00
    endloop
  endfacet
  facet normal  3.896361e-01 -9.206508e-01 -2.420114e-02
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   3.165092e+00 -5.992880e+00  1.805041e+00
      vertex   3.172365e+00 -5.993839e+00  1.958629e+00
    endloop
  endfacet
  facet normal -9.768571e-01 -8.907531e-02 -1.944628e-01
    outer loop
      vertex  -9.257167e+00 -4.944229e-01  6.135324e+00
      vertex  -9.213157e+00 -9.798908e-01  6.136618e+00
      vertex  -9.401835e+00 -4.804020e-01  6.855625e+00
    endloop
  endfacet
  facet normal -9.681253e-01 -8.839004e-02 -2.343512e-01
    outer loop
      vertex  -9.257167e+00 -4.944229e-01  6.135324e+00
      vertex  -9.038230e+00 -1.008003e+00  5.424583e+00
      vertex  -9.213157e+00 -9.798908e-01  6.136618e+00
    endloop
  endfacet
  facet normal -9.570693e-01 -8.159169e-02 -2.781387e-01
    outer loop
      vertex  -8.875355e+00 -5.201721e-01  4.715995e+00
      vertex  -8.833016e+00 -1.031654e+00  4.720353e+00
      vertex  -9.081449e+00 -5.084209e-01  5.421712e+00
    endloop
  endfacet
  facet normal -8.773425e-01  7.406256e-02 -4.741150e-01
    outer loop
      vertex  -7.369229e+00  4.808502e-01  1.242824e+00
      vertex  -7.556970e+00  4.972897e-01  1.592804e+00
      vertex  -7.516775e+00  9.891090e-01  1.595251e+00
    endloop
  endfacet
  facet normal -3.029639e-01 -9.529955e-01 -3.525174e-03
    outer loop
      vertex   1.863009e+00  5.246222e+00  1.537825e+00
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
      vertex   1.511153e+00  5.363768e+00 -6.869505e-17
    endloop
  endfacet
  facet normal -9.445538e-01 -7.856198e-02 -3.188197e-01
    outer loop
      vertex  -8.639026e+00 -5.278988e-01  4.017737e+00
      vertex  -8.597669e+00 -1.047401e+00  4.023223e+00
      vertex  -8.875355e+00 -5.201721e-01  4.715995e+00
    endloop
  endfacet
  facet normal -9.311993e-01 -7.789246e-02 -3.560908e-01
    outer loop
      vertex  -8.639026e+00 -5.278988e-01  4.017737e+00
      vertex  -8.333854e+00 -1.053164e+00  3.334592e+00
      vertex  -8.597669e+00 -1.047401e+00  4.023223e+00
    endloop
  endfacet
  facet normal -9.170253e-01 -7.353141e-02 -3.919920e-01
    outer loop
      vertex  -8.083801e+00 -5.270309e-01  2.648676e+00
      vertex  -8.044674e+00 -1.047447e+00  2.654763e+00
      vertex  -8.374131e+00 -5.304680e-01  3.328518e+00
    endloop
  endfacet
  facet normal -9.076086e-01 -7.307393e-02 -4.134088e-01
    outer loop
      vertex  -8.083801e+00 -5.270309e-01  2.648676e+00
      vertex  -7.891964e+00 -1.036732e+00  2.317606e+00
      vertex  -8.044674e+00 -1.047447e+00  2.654763e+00
    endloop
  endfacet
  facet normal -1.982149e-15  2.289456e-15 -1.000000e+00
    outer loop
      vertex   4.304089e+00  3.502916e+00  1.477984e-16
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
    endloop
  endfacet
  facet normal -3.736447e-01 -9.124259e-01  1.669387e-01
    outer loop
      vertex  -7.326120e+00 -2.965523e+00  5.470749e+00
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
    endloop
  endfacet
  facet normal -1.909881e-01 -9.706992e-01  1.458313e-01
    outer loop
      vertex  -6.451189e+00 -2.137671e+00  1.501371e+01
      vertex  -6.941944e+00 -2.137688e+00  1.437088e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
    endloop
  endfacet
  facet normal -8.905148e-01 -7.152864e-02 -4.492960e-01
    outer loop
      vertex  -7.713012e+00 -1.017324e+00  1.959830e+00
      vertex  -7.891964e+00 -1.036732e+00  2.317606e+00
      vertex  -7.930489e+00 -5.212479e-01  2.311898e+00
    endloop
  endfacet
  facet normal  6.401092e-01  7.608736e-01  1.064499e-01
    outer loop
      vertex   8.775695e+00  1.949236e+00  1.061064e+01
      vertex   8.967095e+00  1.661316e+00  1.151767e+01
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
    endloop
  endfacet
  facet normal  3.724904e-01 -9.249598e-01 -7.549928e-02
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
      vertex   3.146301e+00 -5.975582e+00  1.409939e+00
    endloop
  endfacet
  facet normal -8.779527e-01 -7.212502e-02 -4.732833e-01
    outer loop
      vertex  -7.518944e+00 -9.877434e-01  1.595321e+00
      vertex  -7.713012e+00 -1.017324e+00  1.959830e+00
      vertex  -7.752903e+00 -5.110149e-01  1.956669e+00
    endloop
  endfacet
  facet normal -8.773869e-01 -7.216055e-02 -4.743260e-01
    outer loop
      vertex  -7.333118e+00 -9.526539e-01  1.245728e+00
      vertex  -7.558371e+00 -4.955788e-01  1.592854e+00
      vertex  -7.370649e+00 -4.772720e-01  1.242829e+00
    endloop
  endfacet
  facet normal -7.854241e-01  5.632473e-01 -2.566351e-01
    outer loop
      vertex  -5.779037e+00  4.023558e+00  1.309442e+00
      vertex  -5.615840e+00  3.921659e+00  5.863419e-01
      vertex  -6.087716e+00  3.260000e+00  5.783348e-01
    endloop
  endfacet
  facet normal -8.776288e-01 -7.268013e-02 -4.737988e-01
    outer loop
      vertex  -7.333118e+00 -9.526539e-01  1.245728e+00
      vertex  -7.518944e+00 -9.877434e-01  1.595321e+00
      vertex  -7.558371e+00 -4.955788e-01  1.592854e+00
    endloop
  endfacet
  facet normal  3.989971e-01  9.046063e-01  1.499627e-01
    outer loop
      vertex   8.031503e+00  2.137777e+00  1.215875e+01
      vertex   8.108811e+00  1.949369e+00  1.308958e+01
      vertex   8.412847e+00  1.949324e+00  1.228092e+01
    endloop
  endfacet
  facet normal  9.310508e-01  7.889161e-02 -3.562588e-01
    outer loop
      vertex   8.332925e+00  1.049910e+00  3.334658e+00
      vertex   8.596871e+00  1.044603e+00  4.023283e+00
      vertex   8.638736e+00  5.256424e-01  4.017771e+00
    endloop
  endfacet
  facet normal -9.432084e-01 -3.293639e-01 -4.332636e-02
    outer loop
      vertex  -9.396447e+00 -1.338486e+00  8.310097e+00
      vertex  -9.584477e+00 -8.966770e-01  9.044888e+00
      vertex  -9.545940e+00 -9.107361e-01  8.312819e+00
    endloop
  endfacet
  facet normal -9.399099e-01 -3.394767e-01 -3.640178e-02
    outer loop
      vertex  -9.396447e+00 -1.338486e+00  8.310097e+00
      vertex  -9.432609e+00 -1.316837e+00  9.041911e+00
      vertex  -9.584477e+00 -8.966770e-01  9.044888e+00
    endloop
  endfacet
  facet normal -3.382418e-01  9.049293e-01  2.582545e-01
    outer loop
      vertex  -6.450688e+00  2.138182e+00  1.501330e+01
      vertex  -7.270593e+00  1.950403e+00  1.459744e+01
      vertex  -6.756639e+00  1.950357e+00  1.527073e+01
    endloop
  endfacet
  facet normal -9.412532e-01 -3.140590e-01 -1.241338e-01
    outer loop
      vertex  -9.215196e+00 -1.401514e+00  6.855027e+00
      vertex  -9.322753e+00 -1.365467e+00  7.579388e+00
      vertex  -9.468905e+00 -9.282398e-01  7.581413e+00
    endloop
  endfacet
  facet normal -4.446219e-01 -8.934371e-01  6.388605e-02
    outer loop
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
      vertex  -8.448242e+00 -2.182707e+00  9.023640e+00
    endloop
  endfacet
  facet normal -9.437896e-01 -2.784961e-01 -1.780481e-01
    outer loop
      vertex  -9.076278e+00 -1.444799e+00  6.138248e+00
      vertex  -9.357120e+00 -9.516964e-01  6.855629e+00
      vertex  -9.213157e+00 -9.798908e-01  6.136618e+00
    endloop
  endfacet
  facet normal -2.316764e-01 -9.624648e-01  1.413776e-01
    outer loop
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
      vertex  -7.903955e+00 -2.534363e+00  6.850277e+00
      vertex  -7.791324e+00 -2.561487e+00  6.850190e+00
    endloop
  endfacet
  facet normal  9.986125e-01  1.391253e-03 -5.264046e-02
    outer loop
      vertex   9.629588e+00  6.732941e-04  9.045974e+00
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
      vertex   9.591002e+00  7.381439e-04  8.313971e+00
    endloop
  endfacet
  facet normal -9.407434e-01 -2.965977e-01 -1.644132e-01
    outer loop
      vertex  -9.076278e+00 -1.444799e+00  6.138248e+00
      vertex  -9.215196e+00 -1.401514e+00  6.855027e+00
      vertex  -9.357120e+00 -9.516964e-01  6.855629e+00
    endloop
  endfacet
  facet normal -9.403936e-01 -2.586507e-01 -2.208161e-01
    outer loop
      vertex  -8.907181e+00 -1.488121e+00  5.428863e+00
      vertex  -9.213157e+00 -9.798908e-01  6.136618e+00
      vertex  -9.038230e+00 -1.008003e+00  5.424583e+00
    endloop
  endfacet
  facet normal -9.383610e-01 -2.769984e-01 -2.067620e-01
    outer loop
      vertex  -8.907181e+00 -1.488121e+00  5.428863e+00
      vertex  -9.076278e+00 -1.444799e+00  6.138248e+00
      vertex  -9.213157e+00 -9.798908e-01  6.136618e+00
    endloop
  endfacet
  facet normal -4.889350e-01  6.290625e-04  8.723200e-01
    outer loop
      vertex   4.141760e+00  5.453775e+00  2.438705e+00
      vertex   3.939172e+00  5.585073e+00  2.325060e+00
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
    endloop
  endfacet
  facet normal -9.343063e-01 -2.392882e-01 -2.642215e-01
    outer loop
      vertex  -8.708583e+00 -1.524952e+00  4.727094e+00
      vertex  -9.038230e+00 -1.008003e+00  5.424583e+00
      vertex  -8.833016e+00 -1.031654e+00  4.720353e+00
    endloop
  endfacet
  facet normal -9.256017e-01 -2.207013e-01 -3.074937e-01
    outer loop
      vertex  -8.480636e+00 -1.550205e+00  4.031820e+00
      vertex  -8.833016e+00 -1.031654e+00  4.720353e+00
      vertex  -8.597669e+00 -1.047401e+00  4.023223e+00
    endloop
  endfacet
  facet normal -9.255660e-01 -2.375017e-01 -2.948227e-01
    outer loop
      vertex  -8.480636e+00 -1.550205e+00  4.031820e+00
      vertex  -8.708583e+00 -1.524952e+00  4.727094e+00
      vertex  -8.833016e+00 -1.031654e+00  4.720353e+00
    endloop
  endfacet
  facet normal -9.156918e-01 -2.188996e-01 -3.370332e-01
    outer loop
      vertex  -8.224982e+00 -1.560852e+00  3.344146e+00
      vertex  -8.480636e+00 -1.550205e+00  4.031820e+00
      vertex  -8.597669e+00 -1.047401e+00  4.023223e+00
    endloop
  endfacet
  facet normal -9.049700e-01 -2.011227e-01 -3.749385e-01
    outer loop
      vertex  -7.944685e+00 -1.554760e+00  2.664340e+00
      vertex  -8.224982e+00 -1.560852e+00  3.344146e+00
      vertex  -8.333854e+00 -1.053164e+00  3.334592e+00
    endloop
  endfacet
  facet normal -8.780710e-01 -1.741390e-01 -4.457207e-01
    outer loop
      vertex  -7.617569e+00 -1.512686e+00  1.962998e+00
      vertex  -7.796678e+00 -1.540154e+00  2.326575e+00
      vertex  -7.891964e+00 -1.036732e+00  2.317606e+00
    endloop
  endfacet
  facet normal -9.338876e-01 -8.446198e-03 -3.574668e-01
    outer loop
      vertex  -8.374131e+00 -5.304680e-01  3.328518e+00
      vertex  -8.641997e+00 -8.125305e-04  4.015808e+00
      vertex  -8.378106e+00 -9.479523e-04  3.326391e+00
    endloop
  endfacet
  facet normal -8.319929e-01 -3.450762e-01 -4.344079e-01
    outer loop
      vertex  -6.961944e+00 -2.297348e+00  1.261705e+00
      vertex  -7.114015e+00 -2.369659e+00  1.610398e+00
      vertex  -7.290304e+00 -1.933971e+00  1.601939e+00
    endloop
  endfacet
  facet normal -8.668472e-01 -1.700164e-01 -4.686902e-01
    outer loop
      vertex  -7.428417e+00 -1.470152e+00  1.597731e+00
      vertex  -7.617569e+00 -1.512686e+00  1.962998e+00
      vertex  -7.713012e+00 -1.017324e+00  1.959830e+00
    endloop
  endfacet
  facet normal -8.685360e-01 -1.653205e-01 -4.672412e-01
    outer loop
      vertex  -7.250942e+00 -1.419529e+00  1.249917e+00
      vertex  -7.428417e+00 -1.470152e+00  1.597731e+00
      vertex  -7.518944e+00 -9.877434e-01  1.595321e+00
    endloop
  endfacet
  facet normal -4.935854e-01  8.684878e-01 -4.585136e-02
    outer loop
      vertex  -3.144492e+00  5.979891e+00  1.410066e+00
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
    endloop
  endfacet
  facet normal  9.909559e-01  1.667955e-07  1.341872e-01
    outer loop
      vertex  -8.203500e+00  2.272688e+00  8.653869e+00
      vertex  -8.154238e+00 -2.311592e+00  8.290080e+00
      vertex  -8.154238e+00  2.312090e+00  8.290074e+00
    endloop
  endfacet
  facet normal -8.654910e-01 -1.566076e-01 -4.758145e-01
    outer loop
      vertex  -6.893128e+00 -1.314762e+00  5.645828e-01
      vertex  -7.250942e+00 -1.419529e+00  1.249917e+00
      vertex  -7.333118e+00 -9.526539e-01  1.245728e+00
    endloop
  endfacet
  facet normal  1.037758e-01 -9.693833e-01  2.225459e-01
    outer loop
      vertex   3.934129e+00 -2.137462e+00  1.704169e+01
      vertex   3.186728e+00 -2.137477e+00  1.739015e+01
      vertex   3.131773e+00 -2.174252e+00  1.725559e+01
    endloop
  endfacet
  facet normal -8.360588e-01 -5.480653e-01 -2.509973e-02
    outer loop
      vertex  -9.146712e+00 -1.719254e+00  8.305818e+00
      vertex  -9.432609e+00 -1.316837e+00  9.041911e+00
      vertex  -9.396447e+00 -1.338486e+00  8.310097e+00
    endloop
  endfacet
  facet normal -8.259184e-01 -5.636479e-01 -1.264236e-02
    outer loop
      vertex  -9.146712e+00 -1.719254e+00  8.305818e+00
      vertex  -9.178523e+00 -1.689043e+00  9.037090e+00
      vertex  -9.432609e+00 -1.316837e+00  9.041911e+00
    endloop
  endfacet
  facet normal -3.594464e-01  9.171621e-01  1.720817e-01
    outer loop
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
      vertex  -7.383187e+00  2.856745e+00  5.886006e+00
      vertex  -7.275784e+00  2.937731e+00  5.678710e+00
    endloop
  endfacet
  facet normal -4.443310e-01  8.935688e-01  6.406695e-02
    outer loop
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
    endloop
  endfacet
  facet normal -8.358246e-01  3.469555e-01 -4.254633e-01
    outer loop
      vertex  -7.288819e+00  1.934694e+00  1.602000e+00
      vertex  -7.270958e+00  2.428316e+00  1.969450e+00
      vertex  -7.112368e+00  2.370153e+00  1.610469e+00
    endloop
  endfacet
  facet normal -8.466131e-01 -5.261059e-01 -8.036641e-02
    outer loop
      vertex  -8.979276e+00 -1.807371e+00  6.853911e+00
      vertex  -9.079116e+00 -1.757046e+00  7.576221e+00
      vertex  -9.322753e+00 -1.365467e+00  7.579388e+00
    endloop
  endfacet
  facet normal -2.044132e-02 -9.046042e-01  4.257622e-01
    outer loop
      vertex  -1.826766e-04 -1.949013e+00  1.841550e+01
      vertex  -8.463282e-01 -1.949060e+00  1.837478e+01
      vertex  -8.079415e-01 -2.137550e+00  1.797614e+01
    endloop
  endfacet
  facet normal -8.723508e-01 -4.681669e-01 -1.407972e-01
    outer loop
      vertex  -8.849590e+00 -1.867790e+00  6.140233e+00
      vertex  -9.215196e+00 -1.401514e+00  6.855027e+00
      vertex  -9.076278e+00 -1.444799e+00  6.138248e+00
    endloop
  endfacet
  facet normal  8.441952e-01  4.859851e-01  2.261702e-01
    outer loop
      vertex   9.117169e+00  1.467085e+00  1.155001e+01
      vertex   9.029185e+00  1.187859e+00  1.247841e+01
      vertex   9.269166e+00  1.187811e+00  1.158277e+01
    endloop
  endfacet
  facet normal -8.590616e-01 -4.990494e-01 -1.138547e-01
    outer loop
      vertex  -8.849590e+00 -1.867790e+00  6.140233e+00
      vertex  -8.979276e+00 -1.807371e+00  6.853911e+00
      vertex  -9.215196e+00 -1.401514e+00  6.855027e+00
    endloop
  endfacet
  facet normal -7.832808e-01 -4.877056e-01  3.855055e-01
    outer loop
      vertex  -8.292838e+00 -1.189617e+00  1.417741e+01
      vertex  -8.557884e+00 -1.470757e+00  1.328322e+01
      vertex  -8.155293e+00 -1.470728e+00  1.410125e+01
    endloop
  endfacet
  facet normal -8.817281e-01 -4.345476e-01 -1.836410e-01
    outer loop
      vertex  -8.691193e+00 -1.928747e+00  5.434473e+00
      vertex  -9.076278e+00 -1.444799e+00  6.138248e+00
      vertex  -8.907181e+00 -1.488121e+00  5.428863e+00
    endloop
  endfacet
  facet normal -8.869799e-01 -4.004611e-01 -2.299946e-01
    outer loop
      vertex  -8.504741e+00 -1.981583e+00  4.736046e+00
      vertex  -8.907181e+00 -1.488121e+00  5.428863e+00
      vertex  -8.708583e+00 -1.524952e+00  4.727094e+00
    endloop
  endfacet
  facet normal -8.820554e-01 -3.986760e-01 -2.510689e-01
    outer loop
      vertex  -8.290376e+00 -2.019579e+00  4.043274e+00
      vertex  -8.504741e+00 -1.981583e+00  4.736046e+00
      vertex  -8.708583e+00 -1.524952e+00  4.727094e+00
    endloop
  endfacet
  facet normal -8.818044e-01 -3.647339e-01 -2.989820e-01
    outer loop
      vertex  -8.049710e+00 -2.038773e+00  3.356880e+00
      vertex  -8.290376e+00 -2.019579e+00  4.043274e+00
      vertex  -8.480636e+00 -1.550205e+00  4.031820e+00
    endloop
  endfacet
  facet normal -3.140540e-17  6.866467e-17 -1.000000e+00
    outer loop
      vertex  -3.077820e+00  5.921855e+00  1.040834e-16
      vertex  -2.350985e+00  6.245869e+00  1.035052e-16
      vertex  -2.057643e+00  5.175800e+00  2.081668e-17
    endloop
  endfacet
  facet normal -8.727463e-01 -2.870695e-01 -3.948479e-01
    outer loop
      vertex  -7.642212e+00 -2.020126e+00  2.334112e+00
      vertex  -7.944685e+00 -1.554760e+00  2.664340e+00
      vertex  -7.796678e+00 -1.540154e+00  2.326575e+00
    endloop
  endfacet
  facet normal -8.570452e-01 -2.825817e-01 -4.308376e-01
    outer loop
      vertex  -7.468137e+00 -1.986961e+00  1.966080e+00
      vertex  -7.642212e+00 -2.020126e+00  2.334112e+00
      vertex  -7.796678e+00 -1.540154e+00  2.326575e+00
    endloop
  endfacet
  facet normal -8.458773e-01 -2.561257e-01 -4.678581e-01
    outer loop
      vertex  -7.290304e+00 -1.933971e+00  1.601939e+00
      vertex  -7.617569e+00 -1.512686e+00  1.962998e+00
      vertex  -7.428417e+00 -1.470152e+00  1.597731e+00
    endloop
  endfacet
  facet normal -8.489837e-01 -2.704426e-01 -4.539686e-01
    outer loop
      vertex  -7.290304e+00 -1.933971e+00  1.601939e+00
      vertex  -7.468137e+00 -1.986961e+00  1.966080e+00
      vertex  -7.617569e+00 -1.512686e+00  1.962998e+00
    endloop
  endfacet
  facet normal -7.031772e-01  6.211016e-01  3.460850e-01
    outer loop
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
      vertex  -8.417369e+00  1.663807e+00  1.322250e+01
      vertex  -8.559678e+00  1.468428e+00  1.328400e+01
    endloop
  endfacet
  facet normal -8.495154e-01 -2.421349e-01 -4.687157e-01
    outer loop
      vertex  -7.125367e+00 -1.870438e+00  1.255257e+00
      vertex  -7.428417e+00 -1.470152e+00  1.597731e+00
      vertex  -7.250942e+00 -1.419529e+00  1.249917e+00
    endloop
  endfacet
  facet normal -8.531908e-01 -2.581707e-01 -4.532253e-01
    outer loop
      vertex  -7.125367e+00 -1.870438e+00  1.255257e+00
      vertex  -7.290304e+00 -1.933971e+00  1.601939e+00
      vertex  -7.428417e+00 -1.470152e+00  1.597731e+00
    endloop
  endfacet
  facet normal -8.518478e-01 -2.427304e-01 -4.641523e-01
    outer loop
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
      vertex  -7.125367e+00 -1.870438e+00  1.255257e+00
      vertex  -7.250942e+00 -1.419529e+00  1.249917e+00
    endloop
  endfacet
  facet normal -6.809194e-01 -7.323581e-01  6.349829e-04
    outer loop
      vertex  -8.816321e+00 -2.026443e+00  8.300373e+00
      vertex  -9.178523e+00 -1.689043e+00  9.037090e+00
      vertex  -9.146712e+00 -1.719254e+00  8.305818e+00
    endloop
  endfacet
  facet normal -6.617951e-01 -7.494717e-01  1.787497e-02
    outer loop
      vertex  -8.816321e+00 -2.026443e+00  8.300373e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
      vertex  -9.178523e+00 -1.689043e+00  9.037090e+00
    endloop
  endfacet
  facet normal -2.303145e-01  9.583867e-01  1.686717e-01
    outer loop
      vertex  -7.658601e+00  2.655306e+00  6.497398e+00
      vertex  -7.902413e+00  2.534609e+00  6.850279e+00
      vertex  -7.791326e+00  2.561319e+00  6.850196e+00
    endloop
  endfacet
  facet normal -7.047562e-01 -7.088738e-01 -2.857621e-02
    outer loop
      vertex  -8.756927e+00 -2.077204e+00  7.572257e+00
      vertex  -9.146712e+00 -1.719254e+00  8.305818e+00
      vertex  -9.079116e+00 -1.757046e+00  7.576221e+00
    endloop
  endfacet
  facet normal  6.557400e-01  7.455378e-01 -1.190730e-01
    outer loop
      vertex   5.311325e+00  4.662725e+00  2.075060e+00
      vertex   6.017262e+00  4.093054e+00  2.395866e+00
      vertex   5.938993e+00  4.104437e+00  2.036110e+00
    endloop
  endfacet
  facet normal -7.332096e-01 -6.778457e-01 -5.411927e-02
    outer loop
      vertex  -8.667470e+00 -2.144535e+00  6.852546e+00
      vertex  -9.079116e+00 -1.757046e+00  7.576221e+00
      vertex  -8.979276e+00 -1.807371e+00  6.853911e+00
    endloop
  endfacet
  facet normal -7.637289e-01 -6.399694e-01 -8.460130e-02
    outer loop
      vertex  -8.550210e+00 -2.225395e+00  6.142725e+00
      vertex  -8.979276e+00 -1.807371e+00  6.853911e+00
      vertex  -8.849590e+00 -1.867790e+00  6.140233e+00
    endloop
  endfacet
  facet normal  2.263767e-01 -9.717838e-01 -6.625704e-02
    outer loop
      vertex   1.820122e+00 -6.455023e+00  1.445436e+00
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
    endloop
  endfacet
  facet normal -7.335565e-01 -6.782077e-01 -4.392212e-02
    outer loop
      vertex  -8.550210e+00 -2.225395e+00  6.142725e+00
      vertex  -8.667470e+00 -2.144535e+00  6.852546e+00
      vertex  -8.979276e+00 -1.807371e+00  6.853911e+00
    endloop
  endfacet
  facet normal -7.918715e-01 -5.975235e-01 -1.261158e-01
    outer loop
      vertex  -8.406209e+00 -2.307894e+00  5.441439e+00
      vertex  -8.849590e+00 -1.867790e+00  6.140233e+00
      vertex  -8.691193e+00 -1.928747e+00  5.434473e+00
    endloop
  endfacet
  facet normal -7.639336e-01 -6.401197e-01 -8.156199e-02
    outer loop
      vertex  -8.406209e+00 -2.307894e+00  5.441439e+00
      vertex  -8.550210e+00 -2.225395e+00  6.142725e+00
      vertex  -8.849590e+00 -1.867790e+00  6.140233e+00
    endloop
  endfacet
  facet normal -8.147741e-01 -5.525101e-01 -1.757150e-01
    outer loop
      vertex  -8.236091e+00 -2.381275e+00  4.747116e+00
      vertex  -8.691193e+00 -1.928747e+00  5.434473e+00
      vertex  -8.504741e+00 -1.981583e+00  4.736046e+00
    endloop
  endfacet
  facet normal -8.285328e-01 -5.049337e-01 -2.420236e-01
    outer loop
      vertex  -7.819458e+00 -2.470802e+00  3.372544e+00
      vertex  -8.039986e+00 -2.437206e+00  4.057395e+00
      vertex  -8.290376e+00 -2.019579e+00  4.043274e+00
    endloop
  endfacet
  facet normal -8.269539e-01 -3.688493e-01 -4.243788e-01
    outer loop
      vertex  -7.272618e+00 -2.429152e+00  1.969417e+00
      vertex  -7.642212e+00 -2.020126e+00  2.334112e+00
      vertex  -7.468137e+00 -1.986961e+00  1.966080e+00
    endloop
  endfacet
  facet normal -2.978569e-01 -9.537339e-01 -4.090128e-02
    outer loop
      vertex  -2.006207e+00 -6.413306e+00  1.572435e+00
      vertex  -2.396073e+00 -6.296173e+00  1.680281e+00
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
    endloop
  endfacet
  facet normal -8.237693e-01 -3.420919e-01 -4.520813e-01
    outer loop
      vertex  -7.114015e+00 -2.369659e+00  1.610398e+00
      vertex  -7.468137e+00 -1.986961e+00  1.966080e+00
      vertex  -7.290304e+00 -1.933971e+00  1.601939e+00
    endloop
  endfacet
  facet normal  2.162623e-01 -9.706347e-01  1.053516e-01
    outer loop
      vertex   7.741767e+00 -2.137351e+00  1.293098e+01
      vertex   7.250019e+00 -2.174259e+00  1.360038e+01
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
    endloop
  endfacet
  facet normal -8.262231e-01 -3.685389e-01 -4.260685e-01
    outer loop
      vertex  -7.114015e+00 -2.369659e+00  1.610398e+00
      vertex  -7.272618e+00 -2.429152e+00  1.969417e+00
      vertex  -7.468137e+00 -1.986961e+00  1.966080e+00
    endloop
  endfacet
  facet normal -4.625326e-01  6.207947e-01  6.329909e-01
    outer loop
      vertex  -5.050044e+00  1.663237e+00  1.723664e+01
      vertex  -5.857307e+00  1.468172e+00  1.683807e+01
      vertex  -5.135251e+00  1.468121e+00  1.736573e+01
    endloop
  endfacet
  facet normal  7.971535e-01 -4.900015e-01 -3.527675e-01
    outer loop
      vertex   6.091302e+00 -3.251385e+00  5.783205e-01
      vertex   5.509706e+00 -3.781196e+00 -7.748432e-17
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
    endloop
  endfacet
  facet normal -8.297074e-01 -3.244755e-01 -4.542040e-01
    outer loop
      vertex  -6.961944e+00 -2.297348e+00  1.261705e+00
      vertex  -7.290304e+00 -1.933971e+00  1.601939e+00
      vertex  -7.125367e+00 -1.870438e+00  1.255257e+00
    endloop
  endfacet
  facet normal -8.388255e-01 -2.825362e-01 -4.653440e-01
    outer loop
      vertex  -6.650954e+00 -2.148561e+00  5.689487e-01
      vertex  -7.125367e+00 -1.870438e+00  1.255257e+00
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
    endloop
  endfacet
  facet normal  9.195403e-01 -1.157558e-02 -3.928251e-01
    outer loop
      vertex   8.083327e+00 -5.267620e-01  2.648672e+00
      vertex   8.089043e+00 -6.465912e-04  2.646547e+00
      vertex   8.373710e+00 -5.302849e-01  3.328514e+00
    endloop
  endfacet
  facet normal  5.822969e-01  8.035849e-01 -1.232142e-01
    outer loop
      vertex   4.553915e+00  5.129000e+00  1.359486e+00
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
    endloop
  endfacet
  facet normal -4.740793e-01 -8.799095e-01  3.175207e-02
    outer loop
      vertex  -8.816321e+00 -2.026443e+00  8.300373e+00
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
    endloop
  endfacet
  facet normal -6.943582e-01  4.866779e-01  5.301050e-01
    outer loop
      vertex  -7.133762e+00  1.468275e+00  1.558806e+01
      vertex  -7.676430e+00  1.468325e+00  1.487720e+01
      vertex  -7.804706e+00  1.188988e+00  1.496563e+01
    endloop
  endfacet
  facet normal -4.735648e-01 -8.794399e-01  4.818502e-02
    outer loop
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
      vertex  -8.816321e+00 -2.026443e+00  8.300373e+00
    endloop
  endfacet
  facet normal -5.572712e-01 -8.302880e-01  8.410089e-03
    outer loop
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
      vertex  -8.756927e+00 -2.077204e+00  7.572257e+00
      vertex  -8.667470e+00 -2.144535e+00  6.852546e+00
    endloop
  endfacet
  facet normal  4.769103e-02  1.047327e-01  9.933562e-01
    outer loop
      vertex   9.175743e-01  8.851166e-01  1.911859e+01
      vertex  -1.942747e-04  4.442348e-01  1.920913e+01
      vertex   9.220259e-01  4.442120e-01  1.916486e+01
    endloop
  endfacet
  facet normal -6.098184e-01 -7.924721e-01 -1.046446e-02
    outer loop
      vertex  -8.198880e+00 -2.495790e+00  6.145909e+00
      vertex  -8.667470e+00 -2.144535e+00  6.852546e+00
      vertex  -8.550210e+00 -2.225395e+00  6.142725e+00
    endloop
  endfacet
  facet normal -9.772072e-01  8.970352e-02 -1.924046e-01
    outer loop
      vertex  -9.256581e+00  4.951496e-01  6.135331e+00
      vertex  -9.356354e+00  9.532146e-01  6.855628e+00
      vertex  -9.212256e+00  9.808025e-01  6.136631e+00
    endloop
  endfacet
  facet normal  1.424703e-01 -2.788518e-03  9.897951e-01
    outer loop
      vertex  -1.128790e+00 -6.602042e+00  1.402508e+00
      vertex  -9.513160e-01 -5.492985e+00  1.380087e+00
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
    endloop
  endfacet
  facet normal -6.933425e-01  7.187318e-01 -5.196640e-02
    outer loop
      vertex  -6.619835e+00  3.513231e+00  2.356470e+00
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
      vertex  -6.018507e+00  4.096174e+00  2.395986e+00
    endloop
  endfacet
  facet normal -5.566844e-01 -8.295987e-01  4.322506e-02
    outer loop
      vertex  -8.198880e+00 -2.495790e+00  6.145909e+00
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
      vertex  -8.667470e+00 -2.144535e+00  6.852546e+00
    endloop
  endfacet
  facet normal -7.103566e-01 -6.966413e-01 -1.004203e-01
    outer loop
      vertex  -7.920292e+00 -2.705179e+00  4.760216e+00
      vertex  -8.406209e+00 -2.307894e+00  5.441439e+00
      vertex  -8.236091e+00 -2.381275e+00  4.747116e+00
    endloop
  endfacet
  facet normal -6.630619e-01 -7.476528e-01 -3.693526e-02
    outer loop
      vertex  -7.920292e+00 -2.705179e+00  4.760216e+00
      vertex  -8.071532e+00 -2.605118e+00  5.449806e+00
      vertex  -8.406209e+00 -2.307894e+00  5.441439e+00
    endloop
  endfacet
  facet normal -5.744790e-01  8.183013e-01 -1.889271e-02
    outer loop
      vertex  -5.312944e+00  4.666594e+00  2.075194e+00
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
    endloop
  endfacet
  facet normal -5.529872e-01 -8.161620e-01  1.675848e-01
    outer loop
      vertex  -5.159912e+00 -4.676804e+00  3.135705e+00
      vertex  -5.347189e+00 -4.518198e+00  3.290170e+00
      vertex  -5.430634e+00 -4.562702e+00  2.798081e+00
    endloop
  endfacet
  facet normal -7.815075e-01 -5.826547e-01 -2.230684e-01
    outer loop
      vertex  -7.547992e+00 -2.841942e+00  3.390894e+00
      vertex  -8.039986e+00 -2.437206e+00  4.057395e+00
      vertex  -7.819458e+00 -2.470802e+00  3.372544e+00
    endloop
  endfacet
  facet normal -7.496778e-01 -6.411473e-01 -1.640528e-01
    outer loop
      vertex  -7.547992e+00 -2.841942e+00  3.390894e+00
      vertex  -7.745277e+00 -2.786051e+00  4.074001e+00
      vertex  -8.039986e+00 -2.437206e+00  4.057395e+00
    endloop
  endfacet
  facet normal -8.057150e-01 -5.214940e-01 -2.808332e-01
    outer loop
      vertex  -7.331246e+00 -2.868858e+00  2.711025e+00
      vertex  -7.819458e+00 -2.470802e+00  3.372544e+00
      vertex  -7.577415e+00 -2.478678e+00  2.692742e+00
    endloop
  endfacet
  facet normal -7.809127e-01 -5.823597e-01 -2.259038e-01
    outer loop
      vertex  -7.331246e+00 -2.868858e+00  2.711025e+00
      vertex  -7.547992e+00 -2.841942e+00  3.390894e+00
      vertex  -7.819458e+00 -2.470802e+00  3.372544e+00
    endloop
  endfacet
  facet normal  8.601323e-01 -2.145025e-01 -4.627754e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   6.892925e+00 -1.313347e+00  5.645704e-01
      vertex   7.126010e+00 -1.868799e+00  1.255252e+00
    endloop
  endfacet
  facet normal -7.950905e-01 -5.165258e-01 -3.178559e-01
    outer loop
      vertex  -7.188881e+00 -2.861088e+00  2.342285e+00
      vertex  -7.331246e+00 -2.868858e+00  2.711025e+00
      vertex  -7.577415e+00 -2.478678e+00  2.692742e+00
    endloop
  endfacet
  facet normal -7.933602e-01 -4.644927e-01 -3.934797e-01
    outer loop
      vertex  -7.040504e+00 -2.829029e+00  1.973458e+00
      vertex  -7.434761e+00 -2.464277e+00  2.337805e+00
      vertex  -7.272618e+00 -2.429152e+00  1.969417e+00
    endloop
  endfacet
  facet normal -9.944856e-01 -1.151806e-03 -1.048667e-01
    outer loop
      vertex  -9.513741e+00  7.247925e-04  7.582239e+00
      vertex  -9.590901e+00  7.381439e-04  8.313972e+00
      vertex  -9.591422e+00  4.617844e-01  8.313846e+00
    endloop
  endfacet
  facet normal -7.908527e-01 -4.941199e-01 -3.611061e-01
    outer loop
      vertex  -7.040504e+00 -2.829029e+00  1.973458e+00
      vertex  -7.188881e+00 -2.861088e+00  2.342285e+00
      vertex  -7.434761e+00 -2.464277e+00  2.337805e+00
    endloop
  endfacet
  facet normal  5.922449e-02  1.388788e-02 -9.981480e-01
    outer loop
      vertex   9.427593e+00  1.298067e+00  9.776810e+00
      vertex   9.481034e+00  1.187719e+00  9.778445e+00
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
    endloop
  endfacet
  facet normal -7.975401e-01 -4.296082e-01 -4.235169e-01
    outer loop
      vertex  -6.904522e+00 -2.768339e+00  1.620308e+00
      vertex  -7.272618e+00 -2.429152e+00  1.969417e+00
      vertex  -7.114015e+00 -2.369659e+00  1.610398e+00
    endloop
  endfacet
  facet normal -5.815767e-01  8.056644e-01  1.125763e-01
    outer loop
      vertex  -5.576128e+00  4.319174e+00  3.492131e+00
      vertex  -5.527053e+00  4.360826e+00  3.447559e+00
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
    endloop
  endfacet
  facet normal -7.959309e-01 -4.659148e-01 -3.865454e-01
    outer loop
      vertex  -6.904522e+00 -2.768339e+00  1.620308e+00
      vertex  -7.040504e+00 -2.829029e+00  1.973458e+00
      vertex  -7.272618e+00 -2.429152e+00  1.969417e+00
    endloop
  endfacet
  facet normal -8.046404e-01 -4.043793e-01 -4.347772e-01
    outer loop
      vertex  -6.767282e+00 -2.692802e+00  1.269251e+00
      vertex  -7.114015e+00 -2.369659e+00  1.610398e+00
      vertex  -6.961944e+00 -2.297348e+00  1.261705e+00
    endloop
  endfacet
  facet normal  7.699031e-01  5.196015e-01 -3.704910e-01
    outer loop
      vertex   6.542725e+00  3.050726e+00  1.277834e+00
      vertex   6.664850e+00  3.122030e+00  1.631618e+00
      vertex   6.900171e+00  2.765280e+00  1.620299e+00
    endloop
  endfacet
  facet normal  3.147152e-01  1.342152e-03  9.491851e-01
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -2.396073e+00 -6.296173e+00  1.680281e+00
      vertex  -2.702217e+00 -4.852983e+00  1.779746e+00
    endloop
  endfacet
  facet normal -7.208259e-01  6.291676e-01 -2.907888e-01
    outer loop
      vertex  -7.186638e+00  2.859190e+00  2.342308e+00
      vertex  -7.329176e+00  2.866369e+00  2.711174e+00
      vertex  -7.041600e+00  3.198557e+00  2.717051e+00
    endloop
  endfacet
  facet normal -5.706241e-01 -8.211896e-01 -5.991559e-03
    outer loop
      vertex  -7.574894e+00 -2.945297e+00  4.775242e+00
      vertex  -8.071532e+00 -2.605118e+00  5.449806e+00
      vertex  -7.920292e+00 -2.705179e+00  4.760216e+00
    endloop
  endfacet
  facet normal -7.000182e-01 -6.992584e-01 -1.449562e-01
    outer loop
      vertex  -7.248965e+00 -3.145601e+00  3.411671e+00
      vertex  -7.745277e+00 -2.786051e+00  4.074001e+00
      vertex  -7.547992e+00 -2.841942e+00  3.390894e+00
    endloop
  endfacet
  facet normal -8.785412e-01  1.719195e-01 -4.456558e-01
    outer loop
      vertex  -7.710962e+00  1.017282e+00  1.959771e+00
      vertex  -7.795024e+00  1.538778e+00  2.326663e+00
      vertex  -7.615716e+00  1.512320e+00  1.962978e+00
    endloop
  endfacet
  facet normal -7.442541e-01 -5.967696e-01 -2.999198e-01
    outer loop
      vertex  -6.915232e+00 -3.205269e+00  2.348061e+00
      vertex  -7.331246e+00 -2.868858e+00  2.711025e+00
      vertex  -7.188881e+00 -2.861088e+00  2.342285e+00
    endloop
  endfacet
  facet normal -6.278872e-01  7.684739e-01 -1.233113e-01
    outer loop
      vertex  -7.041600e+00  3.198557e+00  2.717051e+00
      vertex  -7.246525e+00  3.142607e+00  3.411828e+00
      vertex  -6.930485e+00  3.404509e+00  3.434753e+00
    endloop
  endfacet
  facet normal -7.564412e-01 -5.511258e-01 -3.522175e-01
    outer loop
      vertex  -6.789246e+00 -3.181795e+00  1.985826e+00
      vertex  -7.188881e+00 -2.861088e+00  2.342285e+00
      vertex  -7.040504e+00 -2.829029e+00  1.973458e+00
    endloop
  endfacet
  facet normal -7.448052e-01 -5.971712e-01 -2.977447e-01
    outer loop
      vertex  -6.789246e+00 -3.181795e+00  1.985826e+00
      vertex  -6.915232e+00 -3.205269e+00  2.348061e+00
      vertex  -7.188881e+00 -2.861088e+00  2.342285e+00
    endloop
  endfacet
  facet normal -7.661555e-01 -5.155993e-01 -3.836186e-01
    outer loop
      vertex  -6.669674e+00 -3.125740e+00  1.631636e+00
      vertex  -7.040504e+00 -2.829029e+00  1.973458e+00
      vertex  -6.904522e+00 -2.768339e+00  1.620308e+00
    endloop
  endfacet
  facet normal  2.897352e-01 -9.568908e-01 -2.033528e-02
    outer loop
      vertex   1.820122e+00 -6.455023e+00  1.445436e+00
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
    endloop
  endfacet
  facet normal -8.772888e-01 -1.718967e-01 -4.481250e-01
    outer loop
      vertex  -7.617569e+00 -1.512686e+00  1.962998e+00
      vertex  -7.891964e+00 -1.036732e+00  2.317606e+00
      vertex  -7.713012e+00 -1.017324e+00  1.959830e+00
    endloop
  endfacet
  facet normal -7.757862e-01 -4.821658e-01 -4.070281e-01
    outer loop
      vertex  -6.547886e+00 -3.053078e+00  1.277870e+00
      vertex  -6.904522e+00 -2.768339e+00  1.620308e+00
      vertex  -6.767282e+00 -2.692802e+00  1.269251e+00
    endloop
  endfacet
  facet normal  2.002756e-01  9.718320e-01  1.242271e-01
    outer loop
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   6.942175e+00  2.137827e+00  1.437145e+01
    endloop
  endfacet
  facet normal  4.817681e-02  3.812566e-02  9.981109e-01
    outer loop
      vertex   9.427593e+00  1.298067e+00  9.776810e+00
      vertex   9.325606e+00  1.466988e+00  9.775280e+00
      vertex   9.481034e+00  1.187719e+00  9.778445e+00
    endloop
  endfacet
  facet normal -7.704206e-01 -5.180218e-01 -3.716256e-01
    outer loop
      vertex  -6.547886e+00 -3.053078e+00  1.277870e+00
      vertex  -6.669674e+00 -3.125740e+00  1.631636e+00
      vertex  -6.904522e+00 -2.768339e+00  1.620308e+00
    endloop
  endfacet
  facet normal -5.243701e-01 -8.510227e-01 -2.821952e-02
    outer loop
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
      vertex  -3.931183e+00 -5.612051e+00  2.157365e+00
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
    endloop
  endfacet
  facet normal  5.566145e-01  8.307347e-01  7.757103e-03
    outer loop
      vertex   8.300293e+00  2.389463e+00  6.851238e+00
      vertex   8.755881e+00  2.077475e+00  7.572239e+00
      vertex   8.666203e+00  2.144281e+00  6.852543e+00
    endloop
  endfacet
  facet normal -5.862384e-01  8.079401e-01 -5.964359e-02
    outer loop
      vertex  -6.734791e+00  3.494051e+00  2.724230e+00
      vertex  -6.930485e+00  3.404509e+00  3.434753e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
    endloop
  endfacet
  facet normal -7.861268e-01 -4.878052e-01 -3.795402e-01
    outer loop
      vertex  -6.300128e+00 -2.905363e+00  5.748463e-01
      vertex  -6.547886e+00 -3.053078e+00  1.277870e+00
      vertex  -6.767282e+00 -2.692802e+00  1.269251e+00
    endloop
  endfacet
  facet normal -4.678682e-01 -8.800122e-01  8.171831e-02
    outer loop
      vertex  -7.574894e+00 -2.945297e+00  4.775242e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
    endloop
  endfacet
  facet normal -6.854641e-01 -7.135718e-01 -1.447555e-01
    outer loop
      vertex  -6.738110e+00 -3.496881e+00  2.724241e+00
      vertex  -7.248965e+00 -3.145601e+00  3.411671e+00
      vertex  -7.044407e+00 -3.201189e+00  2.717045e+00
    endloop
  endfacet
  facet normal  7.094765e-01  6.973675e-01 -1.015957e-01
    outer loop
      vertex   7.917879e+00  2.701559e+00  4.760293e+00
      vertex   8.404426e+00  2.305803e+00  5.441488e+00
      vertex   8.234009e+00  2.378031e+00  4.747190e+00
    endloop
  endfacet
  facet normal -7.039097e-01 -6.688612e-01 -2.390313e-01
    outer loop
      vertex  -6.623233e+00 -3.515539e+00  2.356373e+00
      vertex  -7.044407e+00 -3.201189e+00  2.717045e+00
      vertex  -6.915232e+00 -3.205269e+00  2.348061e+00
    endloop
  endfacet
  facet normal -6.890650e-01  7.178619e-01 -9.931619e-02
    outer loop
      vertex  -7.041600e+00  3.198557e+00  2.717051e+00
      vertex  -6.930485e+00  3.404509e+00  3.434753e+00
      vertex  -6.734791e+00  3.494051e+00  2.724230e+00
    endloop
  endfacet
  facet normal -7.270913e-01 -6.208228e-01 -2.931164e-01
    outer loop
      vertex  -6.520677e+00 -3.503586e+00  2.001183e+00
      vertex  -6.915232e+00 -3.205269e+00  2.348061e+00
      vertex  -6.789246e+00 -3.181795e+00  1.985826e+00
    endloop
  endfacet
  facet normal  9.712514e-01  3.507120e-03 -2.380302e-01
    outer loop
      vertex   9.081264e+00  5.079060e-01  5.421731e+00
      vertex   9.257847e+00  3.471375e-04  6.134778e+00
      vertex   9.082833e+00 -2.098083e-05  5.420652e+00
    endloop
  endfacet
  facet normal -7.935731e-01 -4.755552e-01 -3.795905e-01
    outer loop
      vertex  -6.092205e+00 -3.255135e+00  5.783606e-01
      vertex  -6.547886e+00 -3.053078e+00  1.277870e+00
      vertex  -6.300128e+00 -2.905363e+00  5.748463e-01
    endloop
  endfacet
  facet normal -7.623328e-01 -5.525156e-01 -3.370093e-01
    outer loop
      vertex  -6.092205e+00 -3.255135e+00  5.783606e-01
      vertex  -6.308788e+00 -3.388851e+00  1.287506e+00
      vertex  -6.547886e+00 -3.053078e+00  1.277870e+00
    endloop
  endfacet
  facet normal  4.323826e-01 -8.760557e-01  2.134758e-01
    outer loop
      vertex   6.582376e+00 -3.492981e+00  4.596881e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
      vertex   6.742566e+00 -3.360556e+00  4.815869e+00
    endloop
  endfacet
  facet normal -6.505619e-01 -7.548012e-01 -8.392988e-02
    outer loop
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
      vertex  -6.933262e+00 -3.407667e+00  3.434591e+00
      vertex  -6.738110e+00 -3.496881e+00  2.724241e+00
    endloop
  endfacet
  facet normal -6.795726e-01 -7.121599e-01 -1.760943e-01
    outer loop
      vertex  -6.022293e+00 -4.098753e+00  2.395890e+00
      vertex  -6.738110e+00 -3.496881e+00  2.724241e+00
      vertex  -6.623233e+00 -3.515539e+00  2.356373e+00
    endloop
  endfacet
  facet normal -6.534583e-01 -7.559639e-01 -3.887115e-02
    outer loop
      vertex  -6.022293e+00 -4.098753e+00  2.395890e+00
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
      vertex  -6.738110e+00 -3.496881e+00  2.724241e+00
    endloop
  endfacet
  facet normal  2.522579e-01  9.556286e-01  1.521182e-01
    outer loop
      vertex   7.658692e+00  2.654070e+00  6.497303e+00
      vertex   7.902397e+00  2.533552e+00  6.850276e+00
      vertex   7.814347e+00  2.668272e+00  6.149960e+00
    endloop
  endfacet
  facet normal -7.248874e-01  6.538593e-01 -2.168090e-01
    outer loop
      vertex  -6.411795e+00  3.454931e+00  1.644359e+00
      vertex  -5.940165e+00  4.107729e+00  2.036218e+00
      vertex  -5.860100e+00  4.076109e+00  1.673166e+00
    endloop
  endfacet
  facet normal -7.080915e-01 -6.414387e-01 -2.952332e-01
    outer loop
      vertex  -5.864365e+00 -4.077097e+00  1.673114e+00
      vertex  -6.520677e+00 -3.503586e+00  2.001183e+00
      vertex  -6.415605e+00 -3.455317e+00  1.644304e+00
    endloop
  endfacet
  facet normal -7.175959e-01 -6.480110e-01 -2.552212e-01
    outer loop
      vertex  -5.783556e+00 -4.023340e+00  1.309416e+00
      vertex  -5.864365e+00 -4.077097e+00  1.673114e+00
      vertex  -6.415605e+00 -3.455317e+00  1.644304e+00
    endloop
  endfacet
  facet normal -6.334729e-01 -7.698900e-01 -7.734003e-02
    outer loop
      vertex  -6.738110e+00 -3.496881e+00  2.724241e+00
      vertex  -6.933262e+00 -3.407667e+00  3.434591e+00
      vertex  -7.248965e+00 -3.145601e+00  3.411671e+00
    endloop
  endfacet
  facet normal -6.558045e-01 -7.453620e-01 -1.198162e-01
    outer loop
      vertex  -5.316499e+00 -4.668179e+00  2.075112e+00
      vertex  -6.022293e+00 -4.098753e+00  2.395890e+00
      vertex  -5.944186e+00 -4.109646e+00  2.036141e+00
    endloop
  endfacet
  facet normal  7.346860e-01  6.196780e-01  2.761081e-01
    outer loop
      vertex   8.734851e+00  1.661410e+00  1.238410e+01
      vertex   8.560225e+00  1.467184e+00  1.328466e+01
      vertex   8.881103e+00  1.467134e+00  1.243096e+01
    endloop
  endfacet
  facet normal -6.651188e-01 -7.164598e-01 -2.104812e-01
    outer loop
      vertex  -5.257534e+00 -4.649870e+00  1.705203e+00
      vertex  -5.944186e+00 -4.109646e+00  2.036141e+00
      vertex  -5.864365e+00 -4.077097e+00  1.673114e+00
    endloop
  endfacet
  facet normal  5.525039e-01 -8.166230e-01  1.669326e-01
    outer loop
      vertex   5.346348e+00 -4.514809e+00  3.289315e+00
      vertex   5.159244e+00 -4.672935e+00  3.135036e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
    endloop
  endfacet
  facet normal -6.532210e-01 -7.439330e-01 -1.409473e-01
    outer loop
      vertex  -5.257534e+00 -4.649870e+00  1.705203e+00
      vertex  -5.316499e+00 -4.668179e+00  2.075112e+00
      vertex  -5.944186e+00 -4.109646e+00  2.036141e+00
    endloop
  endfacet
  facet normal -8.610907e-01 -1.433671e-01 -4.878203e-01
    outer loop
      vertex  -6.893128e+00 -1.314762e+00  5.645828e-01
      vertex  -6.964637e+00 -8.798046e-01  5.629778e-01
      vertex  -6.593333e+00 -1.194343e+00  4.857226e-17
    endloop
  endfacet
  facet normal -6.687412e-01 -7.190902e-01 -1.889302e-01
    outer loop
      vertex  -5.198132e+00 -4.607538e+00  1.333823e+00
      vertex  -5.257534e+00 -4.649870e+00  1.705203e+00
      vertex  -5.864365e+00 -4.077097e+00  1.673114e+00
    endloop
  endfacet
  facet normal -7.211658e-01 -6.437923e-01 -2.558349e-01
    outer loop
      vertex  -5.079527e+00 -4.528217e+00  5.953417e-01
      vertex  -5.783556e+00 -4.023340e+00  1.309416e+00
      vertex  -5.620892e+00 -3.918224e+00  5.863695e-01
    endloop
  endfacet
  facet normal -6.901489e-01 -6.993659e-01 -1.859616e-01
    outer loop
      vertex  -5.079527e+00 -4.528217e+00  5.953417e-01
      vertex  -5.198132e+00 -4.607538e+00  1.333823e+00
      vertex  -5.783556e+00 -4.023340e+00  1.309416e+00
    endloop
  endfacet
  facet normal -1.272460e-01 -9.918706e-01  1.143484e-03
    outer loop
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
      vertex   4.404008e-01  5.559808e+00  0.000000e+00
      vertex   9.072288e-01  5.499919e+00  6.370290e-17
    endloop
  endfacet
  facet normal  1.123242e-01 -6.209940e-01  7.757252e-01
    outer loop
      vertex   1.777746e+00 -1.470394e+00  1.873390e+01
      vertex   8.928719e-01 -1.470419e+00  1.886201e+01
      vertex   8.783308e-01 -1.661779e+00  1.871092e+01
    endloop
  endfacet
  facet normal  2.659046e-01 -9.615989e-01  6.798763e-02
    outer loop
      vertex   8.154332e+00 -2.311420e+00  8.289993e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
      vertex   8.203593e+00 -2.272078e+00  8.653785e+00
    endloop
  endfacet
  facet normal -5.979996e-01 -8.011059e-01 -2.501497e-02
    outer loop
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
      vertex  -5.316499e+00 -4.668179e+00  2.075112e+00
    endloop
  endfacet
  facet normal -9.396091e-01  3.395321e-01 -4.304386e-02
    outer loop
      vertex  -9.545411e+00  9.126930e-01  8.312806e+00
      vertex  -9.584052e+00  8.985672e-01  9.044879e+00
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
    endloop
  endfacet
  facet normal -6.083204e-01 -7.820094e-01 -1.356745e-01
    outer loop
      vertex  -4.601830e+00 -5.165804e+00  1.739013e+00
      vertex  -5.316499e+00 -4.668179e+00  2.075112e+00
      vertex  -5.257534e+00 -4.649870e+00  1.705203e+00
    endloop
  endfacet
  facet normal  2.977967e-01  9.533498e-01 -4.941038e-02
    outer loop
      vertex   2.363800e+00  6.274577e+00  6.326923e-01
      vertex   2.359956e+00  6.242986e+00  5.134781e-16
      vertex   1.593122e+00  6.482521e+00  2.211772e-17
    endloop
  endfacet
  facet normal -2.862982e-01 -9.545885e-01  8.242740e-02
    outer loop
      vertex  -8.005733e+00 -2.414318e+00  7.563979e+00
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
    endloop
  endfacet
  facet normal -5.942454e-01 -8.004492e-01 -7.844426e-02
    outer loop
      vertex  -4.601830e+00 -5.165804e+00  1.739013e+00
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
      vertex  -5.316499e+00 -4.668179e+00  2.075112e+00
    endloop
  endfacet
  facet normal -6.084902e-01 -7.821295e-01 -1.342127e-01
    outer loop
      vertex  -4.559697e+00 -5.133471e+00  1.359566e+00
      vertex  -4.601830e+00 -5.165804e+00  1.739013e+00
      vertex  -5.257534e+00 -4.649870e+00  1.705203e+00
    endloop
  endfacet
  facet normal  7.559175e-01  5.523810e-01 -3.513743e-01
    outer loop
      vertex   6.784631e+00  3.177065e+00  1.985825e+00
      vertex   7.184754e+00  2.856169e+00  2.342148e+00
      vertex   7.036183e+00  2.824865e+00  1.973314e+00
    endloop
  endfacet
  facet normal -6.276186e-01 -7.680904e-01 -1.270123e-01
    outer loop
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
      vertex  -4.559697e+00 -5.133471e+00  1.359566e+00
      vertex  -5.198132e+00 -4.607538e+00  1.333823e+00
    endloop
  endfacet
  facet normal -5.381854e-01 -8.396776e-01 -7.278702e-02
    outer loop
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
      vertex  -4.601830e+00 -5.165804e+00  1.739013e+00
    endloop
  endfacet
  facet normal  3.916532e-01  9.198036e-01 -2.385361e-02
    outer loop
      vertex   3.161976e+00  5.992579e+00  1.805074e+00
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
      vertex   3.169260e+00  5.993425e+00  1.957336e+00
    endloop
  endfacet
  facet normal -5.484471e-01 -8.258174e-01 -1.312683e-01
    outer loop
      vertex  -3.873714e+00 -5.593157e+00  1.385406e+00
      vertex  -4.601830e+00 -5.165804e+00  1.739013e+00
      vertex  -4.559697e+00 -5.133471e+00  1.359566e+00
    endloop
  endfacet
  facet normal  2.084523e-01 -9.693004e-01  1.304001e-01
    outer loop
      vertex   7.377430e+00 -2.137368e+00  1.367093e+01
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
      vertex   7.250019e+00 -2.174259e+00  1.360038e+01
    endloop
  endfacet
  facet normal  3.981983e-01  1.009884e-03  9.172988e-01
    outer loop
      vertex  -3.411066e+00  5.884436e+00  2.062481e+00
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
      vertex  -3.170523e+00  5.997377e+00  1.957937e+00
    endloop
  endfacet
  facet normal -4.927869e-01 -8.666432e-01 -7.804223e-02
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
      vertex  -3.873714e+00 -5.593157e+00  1.385406e+00
    endloop
  endfacet
  facet normal -4.683072e-01 -8.823665e-01 -4.601638e-02
    outer loop
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
      vertex  -3.873714e+00 -5.593157e+00  1.385406e+00
    endloop
  endfacet
  facet normal  6.079882e-01 -7.804225e-01  1.459145e-01
    outer loop
      vertex   5.529263e+00 -4.359472e+00  3.449402e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
    endloop
  endfacet
  facet normal -3.755304e-01 -9.265541e-01 -2.177779e-02
    outer loop
      vertex  -2.367681e+00 -6.277615e+00  6.327448e-01
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
    endloop
  endfacet
  facet normal  8.075091e-01  5.896790e-01 -1.440790e-02
    outer loop
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
      vertex  -4.303997e+00 -3.502633e+00  1.540434e-16
      vertex  -4.621866e+00 -3.067342e+00 -5.204170e-17
    endloop
  endfacet
  facet normal -8.751831e-01 -2.988937e-01 -3.804169e-01
    outer loop
      vertex  -7.642212e+00 -2.020126e+00  2.334112e+00
      vertex  -7.785738e+00 -2.036400e+00  2.677091e+00
      vertex  -7.944685e+00 -1.554760e+00  2.664340e+00
    endloop
  endfacet
  facet normal -4.746716e-01  7.620968e-01  4.403353e-01
    outer loop
      vertex  -6.180614e+00  1.950312e+00  1.589176e+01
      vertex  -6.756639e+00  1.950357e+00  1.527073e+01
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
    endloop
  endfacet
  facet normal  3.937284e-01 -9.189486e-01 -2.261826e-02
    outer loop
      vertex   3.110520e+00 -5.953293e+00  6.240654e-01
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
    endloop
  endfacet
  facet normal  6.073273e-01 -7.609600e-01  2.282397e-01
    outer loop
      vertex   8.735147e+00 -1.660802e+00  1.238419e+01
      vertex   8.419494e+00 -1.660886e+00  1.322384e+01
      vertex   8.109565e+00 -1.948414e+00  1.308991e+01
    endloop
  endfacet
  facet normal  3.740128e-01 -9.264120e-01 -4.330425e-02
    outer loop
      vertex   3.110520e+00 -5.953293e+00  6.240654e-01
      vertex   3.146301e+00 -5.975582e+00  1.409939e+00
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
    endloop
  endfacet
  facet normal  8.150365e-01 -3.638137e-01 -4.509492e-01
    outer loop
      vertex   7.290936e+00 -1.932402e+00  1.601931e+00
      vertex   7.468736e+00 -1.985460e+00  1.966090e+00
      vertex   7.273337e+00 -2.427338e+00  1.969424e+00
    endloop
  endfacet
  facet normal  4.675534e-01 -8.818682e-01 -6.084557e-02
    outer loop
      vertex   3.872465e+00 -5.588881e+00  1.385299e+00
      vertex   3.165092e+00 -5.992880e+00  1.805041e+00
      vertex   3.146301e+00 -5.975582e+00  1.409939e+00
    endloop
  endfacet
  facet normal -5.256871e-01  8.380992e-01  1.457495e-01
    outer loop
      vertex  -5.576128e+00  4.319174e+00  3.492131e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
      vertex  -5.752640e+00  4.179514e+00  3.658571e+00
    endloop
  endfacet
  facet normal  5.219932e-01 -8.499499e-01 -7.147218e-02
    outer loop
      vertex   4.600634e+00 -5.161119e+00  1.738890e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
      vertex   3.930022e+00 -5.608150e+00  2.157217e+00
    endloop
  endfacet
  facet normal -6.368539e-01 -7.702599e-01 -3.341764e-02
    outer loop
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
      vertex  -6.022293e+00 -4.098753e+00  2.395890e+00
    endloop
  endfacet
  facet normal  5.498613e-01 -8.261133e-01 -1.232459e-01
    outer loop
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
      vertex   4.558254e+00 -5.128565e+00  1.359461e+00
      vertex   3.872465e+00 -5.588881e+00  1.385299e+00
    endloop
  endfacet
  facet normal  5.738549e-01 -8.187144e-01 -1.993137e-02
    outer loop
      vertex   5.315550e+00 -4.664024e+00  2.074987e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
    endloop
  endfacet
  facet normal -9.403768e-01 -3.399768e-01  1.035800e-02
    outer loop
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
      vertex  -9.584477e+00 -8.966770e-01  9.044888e+00
      vertex  -9.432609e+00 -1.316837e+00  9.041911e+00
    endloop
  endfacet
  facet normal -5.348421e-01 -8.298463e-01  1.590565e-01
    outer loop
      vertex  -4.534791e+00 -5.180698e+00  2.681621e+00
      vertex  -4.721087e+00 -5.036455e+00  2.807743e+00
      vertex  -4.685282e+00 -5.121077e+00  2.486646e+00
    endloop
  endfacet
  facet normal  5.881208e-01 -7.976749e-01 -1.335237e-01
    outer loop
      vertex   5.256689e+00 -4.645506e+00  1.705096e+00
      vertex   5.315550e+00 -4.664024e+00  2.074987e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
    endloop
  endfacet
  facet normal -7.132004e-01  6.987196e-01 -5.600094e-02
    outer loop
      vertex  -8.234803e+00  2.379526e+00  4.747215e+00
      vertex  -8.069816e+00  2.604250e+00  5.449877e+00
      vertex  -7.918496e+00  2.703440e+00  4.760324e+00
    endloop
  endfacet
  facet normal  6.261851e-01 -7.677544e-01 -1.358143e-01
    outer loop
      vertex   5.197096e+00 -4.602970e+00  1.333733e+00
      vertex   4.600634e+00 -5.161119e+00  1.738890e+00
      vertex   4.558254e+00 -5.128565e+00  1.359461e+00
    endloop
  endfacet
  facet normal -8.722565e-01 -1.890596e-02 -4.886830e-01
    outer loop
      vertex  -7.001122e+00 -4.389858e-01  5.618219e-01
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
      vertex  -6.687660e+00 -3.790381e-01  5.898060e-17
    endloop
  endfacet
  facet normal  6.655747e-01 -7.350755e-01 -1.291295e-01
    outer loop
      vertex   5.078556e+00 -4.523216e+00  5.952883e-01
      vertex   4.558254e+00 -5.128565e+00  1.359461e+00
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
    endloop
  endfacet
  facet normal  6.067839e-01 -7.944964e-01 -2.426097e-02
    outer loop
      vertex   6.020991e+00 -4.094975e+00  2.395767e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
    endloop
  endfacet
  facet normal  6.628864e-01 -7.476422e-01 -4.015946e-02
    outer loop
      vertex   5.942955e+00 -4.105652e+00  2.036030e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
      vertex   5.315550e+00 -4.664024e+00  2.074987e+00
    endloop
  endfacet
  facet normal  3.498469e-01 -1.359785e-03  9.368059e-01
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -2.702217e+00 -4.852983e+00  1.779746e+00
      vertex  -3.088347e+00 -4.607609e+00  1.924301e+00
    endloop
  endfacet
  facet normal -5.867662e-01  1.047394e-01  8.029540e-01
    outer loop
      vertex  -5.276216e+00  8.852768e-01  1.757931e+01
      vertex  -6.047310e+00  4.443913e-01  1.707334e+01
      vertex  -5.301825e+00  4.443703e-01  1.761811e+01
    endloop
  endfacet
  facet normal  6.298221e-01 -7.683552e-01 -1.138175e-01
    outer loop
      vertex   5.942955e+00 -4.105652e+00  2.036030e+00
      vertex   6.020991e+00 -4.094975e+00  2.395767e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
    endloop
  endfacet
  facet normal  6.753530e-01 -7.233623e-01 -1.436846e-01
    outer loop
      vertex   5.863177e+00 -4.072899e+00  1.673018e+00
      vertex   5.315550e+00 -4.664024e+00  2.074987e+00
      vertex   5.256689e+00 -4.645506e+00  1.705096e+00
    endloop
  endfacet
  facet normal  9.023513e-01 -5.239179e-08  4.310013e-01
    outer loop
      vertex  -7.511187e+00  2.762133e+00  6.153776e+00
      vertex  -7.511179e+00 -2.763084e+00  6.153759e+00
      vertex  -7.385486e+00 -2.856359e+00  5.890606e+00
    endloop
  endfacet
  facet normal  9.840947e-01  9.735849e-02 -1.485895e-01
    outer loop
      vertex   9.356750e+00  9.523754e-01  6.855629e+00
      vertex   9.468619e+00  9.292984e-01  7.581406e+00
      vertex   9.514176e+00  4.699631e-01  7.582161e+00
    endloop
  endfacet
  facet normal  6.895072e-01 -6.987286e-01 -1.906781e-01
    outer loop
      vertex   5.782189e+00 -4.018940e+00  1.309332e+00
      vertex   5.256689e+00 -4.645506e+00  1.705096e+00
      vertex   5.197096e+00 -4.602970e+00  1.333733e+00
    endloop
  endfacet
  facet normal  9.071708e-01 -7.342108e-02 -4.143071e-01
    outer loop
      vertex   7.929991e+00 -5.209370e-01  2.311893e+00
      vertex   8.083327e+00 -5.267620e-01  2.648672e+00
      vertex   8.044003e+00 -1.046951e+00  2.654753e+00
    endloop
  endfacet
  facet normal  6.573185e-01 -7.103154e-01 -2.517627e-01
    outer loop
      vertex   5.782189e+00 -4.018940e+00  1.309332e+00
      vertex   5.863177e+00 -4.072899e+00  1.673018e+00
      vertex   5.256689e+00 -4.645506e+00  1.705096e+00
    endloop
  endfacet
  facet normal  8.648970e-01  1.665014e-01 -4.735300e-01
    outer loop
      vertex   7.426193e+00  1.469454e+00  1.597667e+00
      vertex   7.711735e+00  1.016129e+00  1.959809e+00
      vertex   7.517587e+00  9.879436e-01  1.595290e+00
    endloop
  endfacet
  facet normal -6.137393e-01  7.854943e-01 -7.951609e-02
    outer loop
      vertex  -5.253759e+00  4.649057e+00  1.705261e+00
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
      vertex  -4.598021e+00  5.164835e+00  1.739065e+00
    endloop
  endfacet
  facet normal  2.252467e-01 -9.706153e-01  8.467522e-02
    outer loop
      vertex   8.032036e+00 -2.137334e+00  1.215893e+01
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
    endloop
  endfacet
  facet normal  6.781129e-01 -6.899298e-01 -2.532979e-01
    outer loop
      vertex   5.619496e+00 -3.913401e+00  5.863152e-01
      vertex   5.782189e+00 -4.018940e+00  1.309332e+00
      vertex   5.197096e+00 -4.602970e+00  1.333733e+00
    endloop
  endfacet
  facet normal  5.894636e-01 -8.076532e-01  1.512778e-02
    outer loop
      vertex   6.932614e+00 -3.405245e+00  3.434518e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
    endloop
  endfacet
  facet normal  6.543449e-01 -7.561108e-01  1.136991e-02
    outer loop
      vertex   6.737225e+00 -3.494104e+00  2.724110e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
    endloop
  endfacet
  facet normal  5.857202e-01 -8.082900e-01 -5.999242e-02
    outer loop
      vertex   6.737225e+00 -3.494104e+00  2.724110e+00
      vertex   6.932614e+00 -3.405245e+00  3.434518e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
    endloop
  endfacet
  facet normal  6.415024e-01 -7.496890e-01 -1.626073e-01
    outer loop
      vertex   6.622387e+00 -3.512589e+00  2.356283e+00
      vertex   6.737225e+00 -3.494104e+00  2.724110e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
    endloop
  endfacet
  facet normal  7.133586e-01 -6.878045e-01 -1.343293e-01
    outer loop
      vertex   6.519882e+00 -3.500469e+00  2.001101e+00
      vertex   6.020991e+00 -4.094975e+00  2.395767e+00
      vertex   5.942955e+00 -4.105652e+00  2.036030e+00
    endloop
  endfacet
  facet normal  6.715131e-01 -7.082103e-01 -2.179638e-01
    outer loop
      vertex   6.519882e+00 -3.500469e+00  2.001101e+00
      vertex   6.622387e+00 -3.512589e+00  2.356283e+00
      vertex   6.020991e+00 -4.094975e+00  2.395767e+00
    endloop
  endfacet
  facet normal  7.244737e-01 -6.538516e-01 -2.182111e-01
    outer loop
      vertex   6.414841e+00 -3.452044e+00  1.644233e+00
      vertex   5.942955e+00 -4.105652e+00  2.036030e+00
      vertex   5.863177e+00 -4.072899e+00  1.673018e+00
    endloop
  endfacet
  facet normal  5.142509e-01  3.428128e-04  8.576397e-01
    outer loop
      vertex  -4.146790e+00 -5.458500e+00  2.441726e+00
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
      vertex  -4.343534e+00 -5.321756e+00  2.559642e+00
    endloop
  endfacet
  facet normal  6.837825e-01 -6.687100e-01 -2.920074e-01
    outer loop
      vertex   6.414841e+00 -3.452044e+00  1.644233e+00
      vertex   6.519882e+00 -3.500469e+00  2.001101e+00
      vertex   5.942955e+00 -4.105652e+00  2.036030e+00
    endloop
  endfacet
  facet normal  7.393193e-01 -6.223899e-01 -2.569779e-01
    outer loop
      vertex   6.307900e+00 -3.385426e+00  1.287444e+00
      vertex   5.863177e+00 -4.072899e+00  1.673018e+00
      vertex   5.782189e+00 -4.018940e+00  1.309332e+00
    endloop
  endfacet
  facet normal  7.194232e-01 -6.085675e-01 -3.347774e-01
    outer loop
      vertex   6.091302e+00 -3.251385e+00  5.783205e-01
      vertex   6.307900e+00 -3.385426e+00  1.287444e+00
      vertex   5.782189e+00 -4.018940e+00  1.309332e+00
    endloop
  endfacet
  facet normal  6.274677e-01 -7.687594e-01 -1.236660e-01
    outer loop
      vertex   7.043986e+00 -3.198912e+00  2.716952e+00
      vertex   7.248614e+00 -3.143639e+00  3.411612e+00
      vertex   6.932614e+00 -3.405245e+00  3.434518e+00
    endloop
  endfacet
  facet normal  6.723933e-01 -7.042665e-01 -2.278069e-01
    outer loop
      vertex   6.914867e+00 -3.202835e+00  2.347976e+00
      vertex   7.043986e+00 -3.198912e+00  2.716952e+00
      vertex   6.737225e+00 -3.494104e+00  2.724110e+00
    endloop
  endfacet
  facet normal  2.059398e-16 -2.192476e-16 -1.000000e+00
    outer loop
      vertex   5.507741e+00  5.799408e-01  7.632783e-17
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
      vertex   6.652087e+00  8.003138e-01  2.636780e-16
    endloop
  endfacet
  facet normal  8.063095e-01 -4.853857e-01 -3.380321e-01
    outer loop
      vertex   6.300029e+00 -2.902218e+00  5.748234e-01
      vertex   6.307900e+00 -3.385426e+00  1.287444e+00
      vertex   6.091302e+00 -3.251385e+00  5.783205e-01
    endloop
  endfacet
  facet normal  3.392064e-01 -9.363292e-01  9.070152e-02
    outer loop
      vertex   8.198556e+00 -2.495211e+00  6.145896e+00
      vertex   8.301332e+00 -2.389652e+00  6.851235e+00
      vertex   7.903616e+00 -2.533827e+00  6.850272e+00
    endloop
  endfacet
  facet normal  7.743227e-01  6.195440e-01  1.288005e-01
    outer loop
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
      vertex   9.117169e+00  1.467085e+00  1.155001e+01
      vertex   9.263976e+00  1.467035e+00  1.066768e+01
    endloop
  endfacet
  facet normal  4.134621e-01 -9.080734e-01  6.672070e-02
    outer loop
      vertex   8.071296e+00 -2.604301e+00  5.449783e+00
      vertex   8.198556e+00 -2.495211e+00  6.145896e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
    endloop
  endfacet
  facet normal -2.897735e-01 -9.419316e-01  1.696944e-01
    outer loop
      vertex  -7.511179e+00 -2.763084e+00  6.153759e+00
      vertex  -7.658592e+00 -2.655830e+00  6.497374e+00
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
    endloop
  endfacet
  facet normal  4.924331e-01 -8.701639e-01  1.800920e-02
    outer loop
      vertex   7.920142e+00 -2.704113e+00  4.760183e+00
      vertex   8.071296e+00 -2.604301e+00  5.449783e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
    endloop
  endfacet
  facet normal  7.056980e-01 -7.027771e-01 -8.996979e-02
    outer loop
      vertex   7.548003e+00 -2.840347e+00  3.390848e+00
      vertex   7.421623e+00 -3.057121e+00  4.092836e+00
      vertex   7.248614e+00 -3.143639e+00  3.411612e+00
    endloop
  endfacet
  facet normal -2.513259e-01 -9.047291e-01  3.439485e-01
    outer loop
      vertex  -4.864460e+00 -1.949308e+00  1.695544e+01
      vertex  -5.296856e+00 -2.137640e+00  1.614409e+01
      vertex  -4.643888e+00 -2.137625e+00  1.662126e+01
    endloop
  endfacet
  facet normal  7.699221e-01 -5.609931e-01 -3.041491e-01
    outer loop
      vertex   7.040828e+00 -2.826899e+00  1.973431e+00
      vertex   6.914867e+00 -3.202835e+00  2.347976e+00
      vertex   6.788991e+00 -3.179214e+00  1.985767e+00
    endloop
  endfacet
  facet normal  6.933080e-01 -6.622651e-01 -2.841282e-01
    outer loop
      vertex   6.788991e+00 -3.179214e+00  1.985767e+00
      vertex   6.914867e+00 -3.202835e+00  2.347976e+00
      vertex   6.622387e+00 -3.512589e+00  2.356283e+00
    endloop
  endfacet
  facet normal  8.222271e-01 -4.245887e-01 -3.790343e-01
    outer loop
      vertex   6.487965e+00 -2.535486e+00  5.716991e-01
      vertex   6.547676e+00 -3.050220e+00  1.277827e+00
      vertex   6.300029e+00 -2.902218e+00  5.748234e-01
    endloop
  endfacet
  facet normal  8.173147e-01 -4.874801e-01  3.071806e-01
    outer loop
      vertex   9.028557e+00 -1.189371e+00  1.247821e+01
      vertex   8.558311e+00 -1.470133e+00  1.328384e+01
      vertex   8.879113e+00 -1.470104e+00  1.243032e+01
    endloop
  endfacet
  facet normal -6.209027e-01  7.631047e-01 -1.793071e-01
    outer loop
      vertex  -5.194129e+00  4.607729e+00  1.333857e+00
      vertex  -4.555652e+00  5.133276e+00  1.359595e+00
      vertex  -5.075042e+00  4.531092e+00  5.953255e-01
    endloop
  endfacet
  facet normal  7.711609e-01 -4.816558e-01 -4.163153e-01
    outer loop
      vertex   6.487965e+00 -2.535486e+00  5.716991e-01
      vertex   6.767753e+00 -2.690432e+00  1.269229e+00
      vertex   6.547676e+00 -3.050220e+00  1.277827e+00
    endloop
  endfacet
  facet normal  2.326358e-01 -9.707782e-01 -5.890900e-02
    outer loop
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
    endloop
  endfacet
  facet normal  4.734172e-01 -8.793697e-01  5.084405e-02
    outer loop
      vertex   8.816117e+00 -2.026272e+00  8.300370e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
    endloop
  endfacet
  facet normal -2.886299e-01 -9.572009e-01 -2.142892e-02
    outer loop
      vertex  -1.820554e+00 -6.459442e+00  1.445536e+00
      vertex  -2.389261e+00 -6.287655e+00  1.432049e+00
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
    endloop
  endfacet
  facet normal  6.430666e-01 -7.370703e-01 -2.078288e-01
    outer loop
      vertex   5.863177e+00 -4.072899e+00  1.673018e+00
      vertex   5.942955e+00 -4.105652e+00  2.036030e+00
      vertex   5.315550e+00 -4.664024e+00  2.074987e+00
    endloop
  endfacet
  facet normal  4.457522e-01 -8.945306e-01  3.346792e-02
    outer loop
      vertex   8.816117e+00 -2.026272e+00  8.300370e+00
      vertex   8.842025e+00 -1.986032e+00  9.030830e+00
      vertex   8.447640e+00 -2.182827e+00  9.023629e+00
    endloop
  endfacet
  facet normal -9.099076e-01  1.360556e-02 -4.145876e-01
    outer loop
      vertex  -7.936165e+00 -2.708435e-04  2.309898e+00
      vertex  -8.082679e+00  5.254803e-01  2.648710e+00
      vertex  -7.929305e+00  5.204182e-01  2.311929e+00
    endloop
  endfacet
  facet normal  6.012764e-01 -7.772087e-01 -1.855086e-01
    outer loop
      vertex   5.197096e+00 -4.602970e+00  1.333733e+00
      vertex   5.256689e+00 -4.645506e+00  1.705096e+00
      vertex   4.600634e+00 -5.161119e+00  1.738890e+00
    endloop
  endfacet
  facet normal  5.564731e-01 -8.298203e-01  4.166269e-02
    outer loop
      vertex   8.667418e+00 -2.144091e+00  6.852542e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
      vertex   8.301332e+00 -2.389652e+00  6.851235e+00
    endloop
  endfacet
  facet normal  5.109780e-01 -8.594301e-01  1.677030e-02
    outer loop
      vertex   8.667418e+00 -2.144091e+00  6.852542e+00
      vertex   8.756794e+00 -2.076908e+00  7.572255e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
    endloop
  endfacet
  facet normal  6.094652e-01 -7.922540e-01  2.976009e-02
    outer loop
      vertex   8.550247e+00 -2.224781e+00  6.142717e+00
      vertex   8.301332e+00 -2.389652e+00  6.851235e+00
      vertex   8.198556e+00 -2.495211e+00  6.145896e+00
    endloop
  endfacet
  facet normal  5.570517e-01 -8.304742e-01  2.452459e-03
    outer loop
      vertex   8.550247e+00 -2.224781e+00  6.142717e+00
      vertex   8.667418e+00 -2.144091e+00  6.852542e+00
      vertex   8.301332e+00 -2.389652e+00  6.851235e+00
    endloop
  endfacet
  facet normal  6.635482e-01 -7.481225e-01 -4.065400e-03
    outer loop
      vertex   8.406335e+00 -2.307093e+00  5.441423e+00
      vertex   8.198556e+00 -2.495211e+00  6.145896e+00
      vertex   8.071296e+00 -2.604301e+00  5.449783e+00
    endloop
  endfacet
  facet normal -1.808748e-01  9.829574e-01 -3.284959e-02
    outer loop
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
    endloop
  endfacet
  facet normal  5.062400e-01  1.047350e-01  8.560091e-01
    outer loop
      vertex   5.275980e+00  8.850021e-01  1.757960e+01
      vertex   4.469564e+00  8.850250e-01  1.805651e+01
      vertex   4.491253e+00  4.441223e-01  1.809762e+01
    endloop
  endfacet
  facet normal  7.051164e-01 -6.942552e-01 -1.442934e-01
    outer loop
      vertex   8.040294e+00 -2.436008e+00  4.057366e+00
      vertex   8.236308e+00 -2.380280e+00  4.747092e+00
      vertex   7.920142e+00 -2.704113e+00  4.760183e+00
    endloop
  endfacet
  facet normal  7.418262e-01 -6.376193e-01 -2.076913e-01
    outer loop
      vertex   7.819855e+00 -2.469397e+00  3.372513e+00
      vertex   8.040294e+00 -2.436008e+00  4.057366e+00
      vertex   7.745208e+00 -2.784725e+00  4.073960e+00
    endloop
  endfacet
  facet normal  7.707669e-01 -5.780969e-01 -2.678106e-01
    outer loop
      vertex   7.577900e+00 -2.477064e+00  2.692711e+00
      vertex   7.819855e+00 -2.469397e+00  3.372513e+00
      vertex   7.548003e+00 -2.840347e+00  3.390848e+00
    endloop
  endfacet
  facet normal  9.946087e-01 -1.035012e-01  6.401201e-03
    outer loop
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
      vertex   9.584364e+00 -8.973045e-01  9.044883e+00
      vertex   9.630534e+00 -4.535618e-01  9.045911e+00
    endloop
  endfacet
  facet normal  8.030219e-01 -5.023722e-01 -3.205899e-01
    outer loop
      vertex   7.435361e+00 -2.462561e+00  2.337803e+00
      vertex   7.331333e+00 -2.866991e+00  2.710981e+00
      vertex   7.189068e+00 -2.859085e+00  2.342245e+00
    endloop
  endfacet
  facet normal  7.802635e-01 -4.890133e-01 -3.899421e-01
    outer loop
      vertex   7.273337e+00 -2.427338e+00  1.969424e+00
      vertex   7.435361e+00 -2.462561e+00  2.337803e+00
      vertex   7.189068e+00 -2.859085e+00  2.342245e+00
    endloop
  endfacet
  facet normal  8.115860e-01 -4.372040e-01 -3.875318e-01
    outer loop
      vertex   7.114815e+00 -2.367758e+00  1.610386e+00
      vertex   7.040828e+00 -2.826899e+00  1.973431e+00
      vertex   6.904957e+00 -2.766088e+00  1.620279e+00
    endloop
  endfacet
  facet normal -6.838573e-01  7.295076e-01 -1.255823e-02
    outer loop
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   3.914279e+00 -3.940507e+00  1.637579e-16
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
    endloop
  endfacet
  facet normal  5.819302e-01  7.611058e-01  2.864873e-01
    outer loop
      vertex   8.108811e+00  1.949369e+00  1.308958e+01
      vertex   7.727200e+00  1.949415e+00  1.386461e+01
      vertex   8.022988e+00  1.661601e+00  1.402842e+01
    endloop
  endfacet
  facet normal  4.336082e-01 -8.813004e-01  1.878657e-01
    outer loop
      vertex   6.959345e+00 -3.185122e+00  5.138508e+00
      vertex   6.742566e+00 -3.360556e+00  4.815869e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
    endloop
  endfacet
  facet normal  6.802952e-01 -7.327583e-01  1.623765e-02
    outer loop
      vertex   9.146890e+00 -1.719061e+00  8.305820e+00
      vertex   8.842025e+00 -1.986032e+00  9.030830e+00
      vertex   8.816117e+00 -2.026272e+00  8.300370e+00
    endloop
  endfacet
  facet normal  6.616685e-01 -7.497935e-01  2.132302e-03
    outer loop
      vertex   9.146890e+00 -1.719061e+00  8.305820e+00
      vertex   9.178670e+00 -1.688936e+00  9.037090e+00
      vertex   8.842025e+00 -1.986032e+00  9.030830e+00
    endloop
  endfacet
  facet normal  8.491204e-02 -9.963788e-01  4.372704e-03
    outer loop
      vertex   8.060707e-01 -6.644463e+00  1.364411e+00
      vertex   4.041913e-01 -6.678841e+00  1.334873e+00
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
    endloop
  endfacet
  facet normal  7.335918e-01 -6.790250e-01 -2.771455e-02
    outer loop
      vertex   8.979527e+00 -1.806957e+00  6.853909e+00
      vertex   8.756794e+00 -2.076908e+00  7.572255e+00
      vertex   8.667418e+00 -2.144091e+00  6.852542e+00
    endloop
  endfacet
  facet normal -5.355631e-01  8.294235e-01  1.588359e-01
    outer loop
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
      vertex  -4.717629e+00  5.035028e+00  2.805334e+00
      vertex  -4.531404e+00  5.179392e+00  2.679399e+00
    endloop
  endfacet
  facet normal  7.039711e-01 -7.086038e-01 -4.801442e-02
    outer loop
      vertex   8.979527e+00 -1.806957e+00  6.853909e+00
      vertex   9.079329e+00 -1.756750e+00  7.576222e+00
      vertex   8.756794e+00 -2.076908e+00  7.572255e+00
    endloop
  endfacet
  facet normal  6.388454e-01  4.513344e-05  7.693351e-01
    outer loop
      vertex  -5.347189e+00 -4.518198e+00  3.290170e+00
      vertex  -5.207044e+00 -1.683388e+00  3.173630e+00
      vertex  -5.344566e+00 -1.140627e+00  3.287794e+00
    endloop
  endfacet
  facet normal -8.084956e-01 -4.155655e-01 -4.167016e-01
    outer loop
      vertex  -6.300128e+00 -2.905363e+00  5.748463e-01
      vertex  -6.767282e+00 -2.692802e+00  1.269251e+00
      vertex  -6.487278e+00 -2.538105e+00  5.717039e-01
    endloop
  endfacet
  facet normal  9.385682e-01  3.443853e-01 -2.210069e-02
    outer loop
      vertex  -5.207044e+00 -1.683388e+00  3.173630e+00
      vertex  -5.020278e+00 -2.201843e+00  3.026298e+00
      vertex  -5.137498e+00 -2.076589e+00  1.309716e-16
    endloop
  endfacet
  facet normal -4.244249e-02 -9.990745e-01  6.976356e-03
    outer loop
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -8.143588e+00  2.181360e+00  1.093485e+01
      vertex  -8.200814e+00  2.181055e+00  1.054299e+01
    endloop
  endfacet
  facet normal  7.651658e-01 -6.416174e-01 -5.336959e-02
    outer loop
      vertex   8.849883e+00 -1.867241e+00  6.140228e+00
      vertex   8.667418e+00 -2.144091e+00  6.852542e+00
      vertex   8.550247e+00 -2.224781e+00  6.142717e+00
    endloop
  endfacet
  facet normal -8.643131e-01 -4.431524e-03 -5.029346e-01
    outer loop
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   7.015382e+00 -2.181009e+00  1.393177e+01
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
    endloop
  endfacet
  facet normal  7.318627e-01 -6.772296e-01 -7.574154e-02
    outer loop
      vertex   8.849883e+00 -1.867241e+00  6.140228e+00
      vertex   8.979527e+00 -1.806957e+00  6.853909e+00
      vertex   8.667418e+00 -2.144091e+00  6.852542e+00
    endloop
  endfacet
  facet normal  8.194532e-01 -5.552410e-01 -1.421404e-01
    outer loop
      vertex   8.505115e+00 -1.980730e+00  4.736032e+00
      vertex   8.406335e+00 -2.307093e+00  5.441423e+00
      vertex   8.236308e+00 -2.380280e+00  4.747092e+00
    endloop
  endfacet
  facet normal  8.778109e-01  1.756792e-01 -4.456287e-01
    outer loop
      vertex   7.615463e+00  1.510658e+00  1.962947e+00
      vertex   7.794792e+00  1.537182e+00  2.326651e+00
      vertex   7.890829e+00  1.034529e+00  2.317666e+00
    endloop
  endfacet
  facet normal -9.368663e-01  3.130681e-01  1.557883e-01
    outer loop
      vertex  -9.268758e+00  1.189178e+00  1.158224e+01
      vertex  -9.517486e+00  8.854656e-01  1.069680e+01
      vertex  -9.366744e+00  8.854465e-01  1.160335e+01
    endloop
  endfacet
  facet normal  8.066288e-01 -5.487567e-01 -2.195812e-01
    outer loop
      vertex   8.290786e+00 -2.018566e+00  4.043255e+00
      vertex   8.505115e+00 -1.980730e+00  4.736032e+00
      vertex   8.236308e+00 -2.380280e+00  4.747092e+00
    endloop
  endfacet
  facet normal  8.502643e-01 -4.625853e-01 -2.511284e-01
    outer loop
      vertex   8.050153e+00 -2.037596e+00  3.356859e+00
      vertex   8.040294e+00 -2.436008e+00  4.057366e+00
      vertex   7.819855e+00 -2.469397e+00  3.372513e+00
    endloop
  endfacet
  facet normal -5.619465e-02  9.718290e-01  2.288902e-01
    outer loop
      vertex  -1.608142e+00  2.138052e+00  1.785956e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
      vertex  -2.408869e+00  2.138071e+00  1.766289e+01
    endloop
  endfacet
  facet normal  8.298557e-01 -4.543389e-01 -3.239072e-01
    outer loop
      vertex   7.786209e+00 -2.035057e+00  2.677070e+00
      vertex   8.050153e+00 -2.037596e+00  3.356859e+00
      vertex   7.819855e+00 -2.469397e+00  3.372513e+00
    endloop
  endfacet
  facet normal -8.427511e-01 -2.837999e-01 -4.574145e-01
    outer loop
      vertex  -6.650954e+00 -2.148561e+00  5.689487e-01
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
      vertex  -6.397487e+00 -1.984235e+00  1.539173e-16
    endloop
  endfacet
  facet normal  8.357908e-01 -3.726313e-01 -4.032367e-01
    outer loop
      vertex   7.468736e+00 -1.985460e+00  1.966090e+00
      vertex   7.435361e+00 -2.462561e+00  2.337803e+00
      vertex   7.273337e+00 -2.427338e+00  1.969424e+00
    endloop
  endfacet
  facet normal -5.809868e-01 -8.059828e-01  1.133404e-01
    outer loop
      vertex  -5.530277e+00 -4.362434e+00  3.450466e+00
      vertex  -5.576197e+00 -4.323465e+00  3.492194e+00
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
    endloop
  endfacet
  facet normal  8.356080e-01 -3.463208e-01 -4.264049e-01
    outer loop
      vertex   7.290936e+00 -1.932402e+00  1.601931e+00
      vertex   7.273337e+00 -2.427338e+00  1.969424e+00
      vertex   7.114815e+00 -2.367758e+00  1.610386e+00
    endloop
  endfacet
  facet normal  8.392354e-01 -3.276877e-01 -4.339409e-01
    outer loop
      vertex   7.126010e+00 -1.868799e+00  1.255252e+00
      vertex   7.114815e+00 -2.367758e+00  1.610386e+00
      vertex   6.962789e+00 -2.295359e+00  1.261698e+00
    endloop
  endfacet
  facet normal -5.856776e-01  8.065326e-01 -8.054108e-02
    outer loop
      vertex  -3.870190e+00  5.593496e+00  1.385433e+00
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
    endloop
  endfacet
  facet normal  8.228149e-01 -3.416838e-01 -4.541229e-01
    outer loop
      vertex   7.126010e+00 -1.868799e+00  1.255252e+00
      vertex   7.290936e+00 -1.932402e+00  1.601931e+00
      vertex   7.114815e+00 -2.367758e+00  1.610386e+00
    endloop
  endfacet
  facet normal  8.241358e-01 -3.223896e-01 -4.656879e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   7.126010e+00 -1.868799e+00  1.255252e+00
      vertex   6.962789e+00 -2.295359e+00  1.261698e+00
    endloop
  endfacet
  facet normal  7.457992e-01 -5.464420e-01 -3.810311e-01
    outer loop
      vertex   6.904957e+00 -2.766088e+00  1.620279e+00
      vertex   7.040828e+00 -2.826899e+00  1.973431e+00
      vertex   6.788991e+00 -3.179214e+00  1.985767e+00
    endloop
  endfacet
  facet normal  8.359973e-01 -5.485617e-01 -1.373356e-02
    outer loop
      vertex   9.396529e+00 -1.338722e+00  8.310096e+00
      vertex   9.178670e+00 -1.688936e+00  9.037090e+00
      vertex   9.146890e+00 -1.719061e+00  8.305820e+00
    endloop
  endfacet
  facet normal  8.480189e-01 -5.274795e-01 -5.127763e-02
    outer loop
      vertex   9.322818e+00 -1.365606e+00  7.579388e+00
      vertex   9.146890e+00 -1.719061e+00  8.305820e+00
      vertex   9.079329e+00 -1.756750e+00  7.576222e+00
    endloop
  endfacet
  facet normal  8.615310e-01 -5.006679e-01 -8.423806e-02
    outer loop
      vertex   9.215240e+00 -1.401539e+00  6.855026e+00
      vertex   9.079329e+00 -1.756750e+00  7.576222e+00
      vertex   8.979527e+00 -1.806957e+00  6.853909e+00
    endloop
  endfacet
  facet normal  8.520922e-01 -3.130836e-01  4.194252e-01
    outer loop
      vertex   8.794788e+00 -8.843689e-01  1.338603e+01
      vertex   8.292924e+00 -1.189396e+00  1.417792e+01
      vertex   8.702374e+00 -1.189384e+00  1.334610e+01
    endloop
  endfacet
  facet normal  8.643149e-01  1.461725e-01 -4.812416e-01
    outer loop
      vertex   7.331723e+00  9.546490e-01  1.245735e+00
      vertex   6.963074e+00  8.865833e-01  5.629635e-01
      vertex   6.890595e+00  1.320393e+00  5.645571e-01
    endloop
  endfacet
  facet normal -8.650311e-01 -1.646961e-01 -4.739161e-01
    outer loop
      vertex  -7.428417e+00 -1.470152e+00  1.597731e+00
      vertex  -7.713012e+00 -1.017324e+00  1.959830e+00
      vertex  -7.518944e+00 -9.877434e-01  1.595321e+00
    endloop
  endfacet
  facet normal  8.854712e-01 -4.358671e-01 -1.611233e-01
    outer loop
      vertex   8.907182e+00 -1.487871e+00  5.428856e+00
      vertex   8.849883e+00 -1.867241e+00  6.140228e+00
      vertex   8.691527e+00 -1.928049e+00  5.434463e+00
    endloop
  endfacet
  facet normal  5.522696e-01  8.170687e-01  1.655203e-01
    outer loop
      vertex   5.157131e+00  4.670424e+00  3.133343e+00
      vertex   5.425769e+00  4.556772e+00  2.798037e+00
      vertex   4.966979e+00  4.828844e+00  2.985777e+00
    endloop
  endfacet
  facet normal  9.307140e-01  7.701637e-02 -3.575472e-01
    outer loop
      vertex   8.332925e+00  1.049910e+00  3.334658e+00
      vertex   8.638736e+00  5.256424e-01  4.017771e+00
      vertex   8.373780e+00  5.278606e-01  3.328556e+00
    endloop
  endfacet
  facet normal -7.500954e-01 -6.413673e-01 -1.612612e-01
    outer loop
      vertex  -7.745277e+00 -2.786051e+00  4.074001e+00
      vertex  -8.236091e+00 -2.381275e+00  4.747116e+00
      vertex  -8.039986e+00 -2.437206e+00  4.057395e+00
    endloop
  endfacet
  facet normal -4.014355e-01  3.130116e-01  8.607399e-01
    outer loop
      vertex  -3.582908e+00  1.188694e+00  1.835956e+01
      vertex  -4.469825e+00  8.852539e-01  1.805627e+01
      vertex  -3.620762e+00  8.852310e-01  1.845226e+01
    endloop
  endfacet
  facet normal  8.738944e-01 -4.310066e-01 -2.248155e-01
    outer loop
      vertex   8.708557e+00 -1.524548e+00  4.727085e+00
      vertex   8.907182e+00 -1.487871e+00  5.428856e+00
      vertex   8.691527e+00 -1.928049e+00  5.434463e+00
    endloop
  endfacet
  facet normal -2.996917e-01  9.525275e-01 -5.363108e-02
    outer loop
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
      vertex  -1.742376e+00  6.437355e+00  1.058181e-16
      vertex  -2.350985e+00  6.245869e+00  1.035052e-16
    endloop
  endfacet
  facet normal  8.240933e-01  3.519301e-01 -4.438642e-01
    outer loop
      vertex   6.957979e+00  2.296583e+00  1.261688e+00
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
      vertex   6.482162e+00  2.540468e+00  5.716410e-01
    endloop
  endfacet
  facet normal  1.015661e-01  9.047481e-01  4.136607e-01
    outer loop
      vertex   2.408713e+00  2.137957e+00  1.766331e+01
      vertex   1.684247e+00  1.949839e+00  1.825264e+01
      vertex   2.523059e+00  1.949789e+00  1.804679e+01
    endloop
  endfacet
  facet normal -1.080267e-15  1.477739e-16 -1.000000e+00
    outer loop
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
      vertex  -3.863586e-01 -5.561952e+00  2.942091e-16
      vertex   6.943097e-02 -5.576807e+00 -2.003606e-16
    endloop
  endfacet
  facet normal  8.937722e-01 -3.679993e-01 -2.564134e-01
    outer loop
      vertex   8.480577e+00 -1.549639e+00  4.031807e+00
      vertex   8.505115e+00 -1.980730e+00  4.736032e+00
      vertex   8.290786e+00 -2.018566e+00  4.043255e+00
    endloop
  endfacet
  facet normal  2.901511e-01  4.862727e-01  8.242276e-01
    outer loop
      vertex   3.523838e+00  1.467596e+00  1.821576e+01
      vertex   2.708174e+00  1.188345e+00  1.866765e+01
      vertex   3.582659e+00  1.188295e+00  1.835983e+01
    endloop
  endfacet
  facet normal  8.921615e-01 -3.345732e-01 -3.034938e-01
    outer loop
      vertex   8.224885e+00 -1.560116e+00  3.344132e+00
      vertex   8.290786e+00 -2.018566e+00  4.043255e+00
      vertex   8.050153e+00 -2.037596e+00  3.356859e+00
    endloop
  endfacet
  facet normal  8.720130e-01 -3.287762e-01 -3.626286e-01
    outer loop
      vertex   7.944548e+00 -1.553850e+00  2.664325e+00
      vertex   8.224885e+00 -1.560116e+00  3.344132e+00
      vertex   8.050153e+00 -2.037596e+00  3.356859e+00
    endloop
  endfacet
  facet normal  8.785594e-01 -2.877484e-01 -3.812273e-01
    outer loop
      vertex   7.796534e+00 -1.539156e+00  2.326561e+00
      vertex   7.786209e+00 -2.035057e+00  2.677070e+00
      vertex   7.642750e+00 -2.018703e+00  2.334118e+00
    endloop
  endfacet
  facet normal  8.775873e-01 -7.267401e-02 -4.738768e-01
    outer loop
      vertex   7.370050e+00 -4.768314e-01  1.242812e+00
      vertex   7.518118e+00 -9.869938e-01  1.595263e+00
      vertex   7.332275e+00 -9.518204e-01  1.245701e+00
    endloop
  endfacet
  facet normal  8.698713e-01 -2.966652e-01 -3.940986e-01
    outer loop
      vertex   7.796534e+00 -1.539156e+00  2.326561e+00
      vertex   7.944548e+00 -1.553850e+00  2.664325e+00
      vertex   7.786209e+00 -2.035057e+00  2.677070e+00
    endloop
  endfacet
  facet normal  2.896474e-01  9.568915e-01 -2.151963e-02
    outer loop
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
      vertex   1.820081e+00  6.455732e+00  1.445411e+00
    endloop
  endfacet
  facet normal  8.600286e-01 -2.726745e-01 -4.312764e-01
    outer loop
      vertex   7.617409e+00 -1.511604e+00  1.962971e+00
      vertex   7.642750e+00 -2.018703e+00  2.334118e+00
      vertex   7.468736e+00 -1.985460e+00  1.966090e+00
    endloop
  endfacet
  facet normal  1.868887e-01 -6.209642e-01  7.612333e-01
    outer loop
      vertex   2.663114e+00 -1.470369e+00  1.851656e+01
      vertex   1.777746e+00 -1.470394e+00  1.873390e+01
      vertex   1.748804e+00 -1.661699e+00  1.858495e+01
    endloop
  endfacet
  facet normal  5.998290e-01 -7.990466e-01  4.158892e-02
    outer loop
      vertex   5.315550e+00 -4.664024e+00  2.074987e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
    endloop
  endfacet
  facet normal  8.524870e-01 -2.803328e-01 -4.412250e-01
    outer loop
      vertex   7.617409e+00 -1.511604e+00  1.962971e+00
      vertex   7.796534e+00 -1.539156e+00  2.326561e+00
      vertex   7.642750e+00 -2.018703e+00  2.334118e+00
    endloop
  endfacet
  facet normal  8.070899e-01 -3.131330e-01  5.005534e-01
    outer loop
      vertex   8.381008e+00 -8.843479e-01  1.422670e+01
      vertex   7.887176e+00 -8.843269e-01  1.502296e+01
      vertex   7.804265e+00 -1.189407e+00  1.496580e+01
    endloop
  endfacet
  facet normal  8.425570e-01 -2.674313e-01 -4.675235e-01
    outer loop
      vertex   7.428255e+00 -1.468988e+00  1.597705e+00
      vertex   7.617409e+00 -1.511604e+00  1.962971e+00
      vertex   7.468736e+00 -1.985460e+00  1.966090e+00
    endloop
  endfacet
  facet normal -6.961946e-01 -3.134103e-01  6.458228e-01
    outer loop
      vertex  -6.704895e+00 -8.839283e-01  1.642670e+01
      vertex  -7.252540e+00 -1.189594e+00  1.568800e+01
      vertex  -6.634205e+00 -1.189585e+00  1.635457e+01
    endloop
  endfacet
  facet normal  8.579258e-01 -2.429350e-01 -4.527095e-01
    outer loop
      vertex   7.250757e+00 -1.418285e+00  1.249901e+00
      vertex   7.290936e+00 -1.932402e+00  1.601931e+00
      vertex   7.126010e+00 -1.868799e+00  1.255252e+00
    endloop
  endfacet
  facet normal  9.482427e-01 -3.169280e-01 -1.981140e-02
    outer loop
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
      vertex  -5.330578e+00  1.508395e+00  2.775558e-17
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
    endloop
  endfacet
  facet normal  8.457447e-01 -2.548865e-01 -4.687736e-01
    outer loop
      vertex   7.250757e+00 -1.418285e+00  1.249901e+00
      vertex   7.428255e+00 -1.468988e+00  1.597705e+00
      vertex   7.290936e+00 -1.932402e+00  1.601931e+00
    endloop
  endfacet
  facet normal  9.810488e-01 -1.044741e-01  1.631819e-01
    outer loop
      vertex   9.563747e+00 -4.434700e-01  1.070270e+01
      vertex   9.366902e+00 -8.844090e-01  1.160383e+01
      vertex   9.517684e+00 -8.844261e-01  1.069732e+01
    endloop
  endfacet
  facet normal  7.851270e-01 -5.626698e-01 -2.588019e-01
    outer loop
      vertex   5.619496e+00 -3.913401e+00  5.863152e-01
      vertex   6.091302e+00 -3.251385e+00  5.783205e-01
      vertex   5.782189e+00 -4.018940e+00  1.309332e+00
    endloop
  endfacet
  facet normal  8.197849e-01 -3.865462e-01 -4.225338e-01
    outer loop
      vertex   7.468736e+00 -1.985460e+00  1.966090e+00
      vertex   7.642750e+00 -2.018703e+00  2.334118e+00
      vertex   7.435361e+00 -2.462561e+00  2.337803e+00
    endloop
  endfacet
  facet normal  8.450656e-01 -2.396736e-01 -4.779337e-01
    outer loop
      vertex   6.892925e+00 -1.313347e+00  5.645704e-01
      vertex   7.250757e+00 -1.418285e+00  1.249901e+00
      vertex   7.126010e+00 -1.868799e+00  1.255252e+00
    endloop
  endfacet
  facet normal  9.435280e-01 -3.292269e-01 -3.693917e-02
    outer loop
      vertex   9.545779e+00 -9.112930e-01  8.312814e+00
      vertex   9.432705e+00 -1.317156e+00  9.041909e+00
      vertex   9.396529e+00 -1.338722e+00  8.310096e+00
    endloop
  endfacet
  facet normal  9.397464e-01 -3.391510e-01 -4.305007e-02
    outer loop
      vertex   9.545779e+00 -9.112930e-01  8.312814e+00
      vertex   9.584364e+00 -8.973045e-01  9.044883e+00
      vertex   9.432705e+00 -1.317156e+00  9.041909e+00
    endloop
  endfacet
  facet normal  4.923635e-01  8.692310e-01  4.489573e-02
    outer loop
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
      vertex   8.197143e+00  2.494410e+00  6.145931e+00
      vertex   8.069473e+00  2.602678e+00  5.449855e+00
    endloop
  endfacet
  facet normal  9.453072e-01 -3.152432e-01 -8.376113e-02
    outer loop
      vertex   9.468694e+00 -9.287109e-01  7.581409e+00
      vertex   9.396529e+00 -1.338722e+00  8.310096e+00
      vertex   9.322818e+00 -1.365606e+00  7.579388e+00
    endloop
  endfacet
  facet normal -5.603507e-01  3.130357e-01  7.668219e-01
    outer loop
      vertex  -5.221046e+00  1.188795e+00  1.749572e+01
      vertex  -5.955170e+00  1.188843e+00  1.695925e+01
      vertex  -6.018102e+00  8.852997e-01  1.703717e+01
    endloop
  endfacet
  facet normal -6.066156e-01 -7.616048e-01  2.279815e-01
    outer loop
      vertex  -8.733365e+00 -1.662915e+00  1.238321e+01
      vertex  -8.412040e+00 -1.949663e+00  1.228027e+01
      vertex  -8.417951e+00 -1.662831e+00  1.322275e+01
    endloop
  endfacet
  facet normal -5.454276e-01  8.250875e-01  1.474424e-01
    outer loop
      vertex  -6.237068e+00  3.783979e+00  4.171127e+00
      vertex  -6.088440e+00  3.912035e+00  4.004339e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
    endloop
  endfacet
  facet normal -2.658452e-01 -9.615991e-01  6.821666e-02
    outer loop
      vertex  -8.154238e+00 -2.311592e+00  8.290080e+00
      vertex  -8.203500e+00 -2.272165e+00  8.653872e+00
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
    endloop
  endfacet
  facet normal  9.400572e-01 -3.132543e-01 -1.347747e-01
    outer loop
      vertex   9.356856e+00 -9.520664e-01  6.855625e+00
      vertex   9.468694e+00 -9.287109e-01  7.581409e+00
      vertex   9.322818e+00 -1.365606e+00  7.579388e+00
    endloop
  endfacet
  facet normal -4.196485e-01  9.049981e-01  6.981117e-02
    outer loop
      vertex  -8.243571e+00  2.138269e+00  1.136140e+01
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
      vertex  -8.634320e+00  1.950586e+00  1.144556e+01
    endloop
  endfacet
  facet normal  9.388695e-01 -2.955774e-01 -1.765164e-01
    outer loop
      vertex   9.212836e+00 -9.801426e-01  6.136613e+00
      vertex   9.356856e+00 -9.520664e-01  6.855625e+00
      vertex   9.215240e+00 -1.401539e+00  6.855026e+00
    endloop
  endfacet
  facet normal  9.933422e-01  1.035950e-01 -5.039150e-02
    outer loop
      vertex   9.545728e+00  9.119377e-01  8.312808e+00
      vertex   9.584334e+00  8.978500e-01  9.044880e+00
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
    endloop
  endfacet
  facet normal  1.870055e-01  6.203108e-01  7.617372e-01
    outer loop
      vertex   2.619659e+00  1.662367e+00  1.837077e+01
      vertex   1.748731e+00  1.662465e+00  1.858451e+01
      vertex   1.778145e+00  1.467701e+00  1.873589e+01
    endloop
  endfacet
  facet normal  9.430531e-01 -2.587221e-01 -2.090785e-01
    outer loop
      vertex   9.037848e+00 -1.008127e+00  5.424577e+00
      vertex   9.076302e+00 -1.444693e+00  6.138244e+00
      vertex   8.907182e+00 -1.487871e+00  5.428856e+00
    endloop
  endfacet
  facet normal  9.291275e-01 -2.206660e-01 -2.966965e-01
    outer loop
      vertex   8.597154e+00 -1.047232e+00  4.023216e+00
      vertex   8.708557e+00 -1.524548e+00  4.727085e+00
      vertex   8.480577e+00 -1.549639e+00  4.031807e+00
    endloop
  endfacet
  facet normal -6.099342e-01 -7.923478e-01  1.285929e-02
    outer loop
      vertex  -8.071532e+00 -2.605118e+00  5.449806e+00
      vertex  -8.198880e+00 -2.495790e+00  6.145909e+00
      vertex  -8.550210e+00 -2.225395e+00  6.142725e+00
    endloop
  endfacet
  facet normal -9.311708e-01  7.690408e-02 -3.563798e-01
    outer loop
      vertex  -8.373130e+00  5.283813e-01  3.328554e+00
      vertex  -8.596299e+00  1.045643e+00  4.023285e+00
      vertex  -8.332305e+00  1.050993e+00  3.334660e+00
    endloop
  endfacet
  facet normal  9.222161e-01 -2.362084e-01 -3.061424e-01
    outer loop
      vertex   8.597154e+00 -1.047232e+00  4.023216e+00
      vertex   8.832570e+00 -1.031635e+00  4.720345e+00
      vertex   8.708557e+00 -1.524548e+00  4.727085e+00
    endloop
  endfacet
  facet normal  9.188567e-01 -2.026780e-01 -3.385616e-01
    outer loop
      vertex   8.333261e+00 -1.052835e+00  3.334583e+00
      vertex   8.480577e+00 -1.549639e+00  4.031807e+00
      vertex   8.224885e+00 -1.560116e+00  3.344132e+00
    endloop
  endfacet
  facet normal -2.443035e-02 -4.369598e-05  9.997016e-01
    outer loop
      vertex   4.720593e-05  6.690340e+00  1.324984e+00
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
      vertex   4.036640e-01  6.677962e+00  1.334846e+00
    endloop
  endfacet
  facet normal  8.786000e-01 -1.711930e-01 -4.458195e-01
    outer loop
      vertex   7.712224e+00 -1.016657e+00  1.959770e+00
      vertex   7.796534e+00 -1.539156e+00  2.326561e+00
      vertex   7.617409e+00 -1.511604e+00  1.962971e+00
    endloop
  endfacet
  facet normal  8.769918e-01 -1.731423e-01 -4.482266e-01
    outer loop
      vertex   7.712224e+00 -1.016657e+00  1.959770e+00
      vertex   7.891260e+00 -1.036148e+00  2.317596e+00
      vertex   7.796534e+00 -1.539156e+00  2.326561e+00
    endloop
  endfacet
  facet normal  9.890712e-01 -1.454186e-01 -2.432350e-02
    outer loop
      vertex  -5.352921e+00  1.098696e+00  3.294899e+00
      vertex  -5.432583e+00  5.453663e-01  3.363667e+00
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
    endloop
  endfacet
  facet normal -5.119829e-01 -8.415354e-01  1.723126e-01
    outer loop
      vertex  -6.237097e+00 -3.788153e+00  4.171160e+00
      vertex  -6.417768e+00 -3.634079e+00  4.386804e+00
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
    endloop
  endfacet
  facet normal  8.641708e-01 -1.635277e-01 -4.758859e-01
    outer loop
      vertex   7.332275e+00 -9.518204e-01  1.245701e+00
      vertex   7.518118e+00 -9.869938e-01  1.595263e+00
      vertex   7.428255e+00 -1.468988e+00  1.597705e+00
    endloop
  endfacet
  facet normal  8.681440e-01 -1.431859e-01 -4.752092e-01
    outer loop
      vertex   6.963712e+00 -8.787937e-01  5.629530e-01
      vertex   7.250757e+00 -1.418285e+00  1.249901e+00
      vertex   6.892925e+00 -1.313347e+00  5.645704e-01
    endloop
  endfacet
  facet normal -9.987514e-01  9.021742e-04 -4.994782e-02
    outer loop
      vertex   8.255627e+00  2.180864e+00  9.756488e+00
      vertex   8.253806e+00  9.536743e-05  9.753502e+00
      vertex   8.235993e+00  2.181208e+00  1.014908e+01
    endloop
  endfacet
  facet normal  8.311472e-15  1.615226e-17 -1.000000e+00
    outer loop
      vertex   1.574826e+00 -5.345766e+00  2.471981e-16
      vertex   1.754346e+00 -6.432830e+00  1.721713e-15
      vertex   1.519274e+00 -5.360741e+00 -2.147588e-16
    endloop
  endfacet
  facet normal  8.278829e-01  3.919214e-01 -4.012573e-01
    outer loop
      vertex   7.268930e+00  2.425638e+00  1.969299e+00
      vertex   7.431244e+00  2.459944e+00  2.337697e+00
      vertex   7.639423e+00  2.016447e+00  2.334038e+00
    endloop
  endfacet
  facet normal  9.936125e-01 -1.009456e-01 -5.044083e-02
    outer loop
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
      vertex   9.584364e+00 -8.973045e-01  9.044883e+00
      vertex   9.545779e+00 -9.112930e-01  8.312814e+00
    endloop
  endfacet
  facet normal  9.933072e-01 -1.032309e-01 -5.180958e-02
    outer loop
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
      vertex   9.630534e+00 -4.535618e-01  9.045911e+00
      vertex   9.584364e+00 -8.973045e-01  9.044883e+00
    endloop
  endfacet
  facet normal  9.895257e-01 -1.004076e-01 -1.037167e-01
    outer loop
      vertex   9.514075e+00 -4.690056e-01  7.582161e+00
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
      vertex   9.545779e+00 -9.112930e-01  8.312814e+00
    endloop
  endfacet
  facet normal -5.522447e-01  8.169484e-01  1.661958e-01
    outer loop
      vertex  -5.158133e+00  4.673937e+00  3.134282e+00
      vertex  -4.967633e+00  4.832796e+00  2.986400e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
    endloop
  endfacet
  facet normal  4.444588e-01 -8.957658e-01 -7.744075e-03
    outer loop
      vertex  -2.650488e+00  4.882700e+00  1.761878e+00
      vertex  -2.553828e+00  4.945892e+00  1.957759e-16
      vertex  -2.166200e+00  5.124269e+00  1.614154e+00
    endloop
  endfacet
  facet normal  1.426579e-01 -9.706602e-01  1.935658e-01
    outer loop
      vertex   5.297066e+00 -2.137431e+00  1.614491e+01
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
    endloop
  endfacet
  facet normal  7.805665e-01  5.836796e-01 -2.236828e-01
    outer loop
      vertex   7.544757e+00  2.836538e+00  3.390997e+00
      vertex   8.037576e+00  2.432901e+00  4.057489e+00
      vertex   7.816690e+00  2.465845e+00  3.372647e+00
    endloop
  endfacet
  facet normal -5.111025e-01 -8.593267e-01  1.821522e-02
    outer loop
      vertex  -8.756927e+00 -2.077204e+00  7.572257e+00
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
      vertex  -8.816321e+00 -2.026443e+00  8.300373e+00
    endloop
  endfacet
  facet normal -4.739631e-01  8.802555e-01  2.256558e-02
    outer loop
      vertex  -8.755844e+00  2.077982e+00  7.572240e+00
      vertex  -8.815278e+00  2.027315e+00  8.300351e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
    endloop
  endfacet
  facet normal  9.450203e-01 -7.884770e-02 -3.173637e-01
    outer loop
      vertex   8.638652e+00 -5.277958e-01  4.017734e+00
      vertex   8.832570e+00 -1.031635e+00  4.720345e+00
      vertex   8.597154e+00 -1.047232e+00  4.023216e+00
    endloop
  endfacet
  facet normal -6.104368e-02  9.048281e-01  4.213783e-01
    outer loop
      vertex  -8.078656e-01  2.138033e+00  1.797553e+01
      vertex  -1.608142e+00  2.138052e+00  1.785956e+01
      vertex  -1.684469e+00  1.950029e+00  1.825224e+01
    endloop
  endfacet
  facet normal -9.602413e-01 -4.648588e-03 -2.791327e-01
    outer loop
      vertex  -8.875355e+00 -5.201721e-01  4.715995e+00
      vertex  -9.082709e+00 -2.098083e-05  5.420651e+00
      vertex  -8.877419e+00 -4.463196e-04  4.714443e+00
    endloop
  endfacet
  facet normal -6.781452e-01 -6.901245e-01 -2.526802e-01
    outer loop
      vertex  -5.198132e+00 -4.607538e+00  1.333823e+00
      vertex  -5.864365e+00 -4.077097e+00  1.673114e+00
      vertex  -5.783556e+00 -4.023340e+00  1.309416e+00
    endloop
  endfacet
  facet normal -7.817121e-01 -6.213167e-01  5.377405e-02
    outer loop
      vertex  -9.110768e+00 -1.661802e+00  1.064930e+01
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
    endloop
  endfacet
  facet normal -8.950345e-01  1.353132e-02 -4.457917e-01
    outer loop
      vertex  -7.759465e+00  2.861023e-04  1.955147e+00
      vertex  -7.936165e+00 -2.708435e-04  2.309898e+00
      vertex  -7.929305e+00  5.204182e-01  2.311929e+00
    endloop
  endfacet
  facet normal  9.306520e-01 -7.812302e-02 -3.574686e-01
    outer loop
      vertex   8.373710e+00 -5.302849e-01  3.328514e+00
      vertex   8.638652e+00 -5.277958e-01  4.017734e+00
      vertex   8.597154e+00 -1.047232e+00  4.023216e+00
    endloop
  endfacet
  facet normal -6.471407e-01  6.715051e-07 -7.623706e-01
    outer loop
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
      vertex   5.485987e+00 -2.181002e+00  1.574896e+01
      vertex   5.486000e+00  2.181242e+00  1.574896e+01
    endloop
  endfacet
  facet normal  7.206091e-01 -6.290821e-01 -2.915105e-01
    outer loop
      vertex   7.189068e+00 -2.859085e+00  2.342245e+00
      vertex   7.331333e+00 -2.866991e+00  2.710981e+00
      vertex   7.043986e+00 -3.198912e+00  2.716952e+00
    endloop
  endfacet
  facet normal  9.075878e-01 -7.280587e-02 -4.135019e-01
    outer loop
      vertex   7.929991e+00 -5.209370e-01  2.311893e+00
      vertex   8.044003e+00 -1.046951e+00  2.654753e+00
      vertex   7.891260e+00 -1.036148e+00  2.317596e+00
    endloop
  endfacet
  facet normal -8.704500e-01 -4.672149e-01 -1.550064e-01
    outer loop
      vertex  -8.691193e+00 -1.928747e+00  5.434473e+00
      vertex  -8.849590e+00 -1.867790e+00  6.140233e+00
      vertex  -9.076278e+00 -1.444799e+00  6.138248e+00
    endloop
  endfacet
  facet normal  9.839627e-01  0.000000e+00  1.783747e-01
    outer loop
      vertex  -8.088025e+00  2.358904e+00  7.924828e+00
      vertex  -8.154238e+00  2.312090e+00  8.290074e+00
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
    endloop
  endfacet
  facet normal  8.902893e-01 -7.337374e-02 -4.494454e-01
    outer loop
      vertex   7.752341e+00 -5.106583e-01  1.956629e+00
      vertex   7.891260e+00 -1.036148e+00  2.317596e+00
      vertex   7.712224e+00 -1.016657e+00  1.959770e+00
    endloop
  endfacet
  facet normal  4.895966e-01 -5.348504e-04  8.719489e-01
    outer loop
      vertex  -4.146790e+00 -5.458500e+00  2.441726e+00
      vertex  -3.944028e+00 -5.589794e+00  2.327796e+00
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
    endloop
  endfacet
  facet normal  7.553923e-01 -6.447750e-01 -1.168230e-01
    outer loop
      vertex   8.040294e+00 -2.436008e+00  4.057366e+00
      vertex   7.920142e+00 -2.704113e+00  4.760183e+00
      vertex   7.745208e+00 -2.784725e+00  4.073960e+00
    endloop
  endfacet
  facet normal  5.531807e-01  8.292469e-01 -7.962775e-02
    outer loop
      vertex   3.868523e+00  5.588697e+00  1.385323e+00
      vertex   4.553915e+00  5.129000e+00  1.359486e+00
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
    endloop
  endfacet
  facet normal  8.356531e-01 -4.068813e-01 -3.689601e-01
    outer loop
      vertex   7.642750e+00 -2.018703e+00  2.334118e+00
      vertex   7.786209e+00 -2.035057e+00  2.677070e+00
      vertex   7.577900e+00 -2.477064e+00  2.692711e+00
    endloop
  endfacet
  facet normal -1.390117e-01  9.718416e-01  1.902622e-01
    outer loop
      vertex  -4.643528e+00  2.138128e+00  1.662074e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -5.296445e+00  2.138147e+00  1.614360e+01
    endloop
  endfacet
  facet normal  8.912561e-01 -7.195728e-02 -4.477554e-01
    outer loop
      vertex   7.752341e+00 -5.106583e-01  1.956629e+00
      vertex   7.929991e+00 -5.209370e-01  2.311893e+00
      vertex   7.891260e+00 -1.036148e+00  2.317596e+00
    endloop
  endfacet
  facet normal  8.778058e-01 -7.314558e-02 -4.733992e-01
    outer loop
      vertex   7.557779e+00 -4.951801e-01  1.592813e+00
      vertex   7.712224e+00 -1.016657e+00  1.959770e+00
      vertex   7.518118e+00 -9.869938e-01  1.595263e+00
    endloop
  endfacet
  facet normal  8.742035e-01 -7.421704e-02 -4.798542e-01
    outer loop
      vertex   7.000465e+00 -4.384537e-01  5.618048e-01
      vertex   7.332275e+00 -9.518204e-01  1.245701e+00
      vertex   6.963712e+00 -8.787937e-01  5.629530e-01
    endloop
  endfacet
  facet normal  8.748796e-01 -7.248916e-02 -4.788852e-01
    outer loop
      vertex   7.000465e+00 -4.384537e-01  5.618048e-01
      vertex   7.370050e+00 -4.768314e-01  1.242812e+00
      vertex   7.332275e+00 -9.518204e-01  1.245701e+00
    endloop
  endfacet
  facet normal -5.209441e-01  6.208903e-01  5.857580e-01
    outer loop
      vertex  -5.760086e+00  1.663332e+00  1.671769e+01
      vertex  -6.417213e+00  1.663426e+00  1.613317e+01
      vertex  -6.525561e+00  1.468224e+00  1.624372e+01
    endloop
  endfacet
  facet normal  8.811212e-01  4.355310e-01 -1.842231e-01
    outer loop
      vertex   8.689773e+00  1.927053e+00  5.434519e+00
      vertex   9.075440e+00  1.444485e+00  6.138266e+00
      vertex   8.906188e+00  1.486849e+00  5.428903e+00
    endloop
  endfacet
  facet normal  9.944277e-01  5.017763e-04 -1.054198e-01
    outer loop
      vertex   9.514075e+00 -4.690056e-01  7.582161e+00
      vertex   9.513846e+00  7.247925e-04  7.582238e+00
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
    endloop
  endfacet
  facet normal -3.762988e-02 -6.210092e-01  7.828996e-01
    outer loop
      vertex  -1.939251e-04 -1.470444e+00  1.890486e+01
      vertex  -8.786781e-01 -1.661938e+00  1.871074e+01
      vertex  -1.906334e-04 -1.661858e+00  1.875303e+01
    endloop
  endfacet
  facet normal  9.709877e-01  1.881688e-03 -2.391219e-01
    outer loop
      vertex   9.081264e+00  5.079060e-01  5.421731e+00
      vertex   9.257026e+00  4.947186e-01  6.135334e+00
      vertex   9.257847e+00  3.471375e-04  6.134778e+00
    endloop
  endfacet
  facet normal  1.065433e-02 -9.990111e-01  4.316638e-02
    outer loop
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
      vertex   1.967929e+00  2.181269e+00  1.759733e+01
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
    endloop
  endfacet
  facet normal  9.883483e-01  5.064581e-04 -1.522086e-01
    outer loop
      vertex   9.401924e+00  6.008148e-04  6.855484e+00
      vertex   9.513846e+00  7.247925e-04  7.582238e+00
      vertex   9.514075e+00 -4.690056e-01  7.582161e+00
    endloop
  endfacet
  facet normal  9.804161e-01 -2.039896e-03 -1.969268e-01
    outer loop
      vertex   9.256927e+00 -4.945354e-01  6.135322e+00
      vertex   9.257847e+00  3.471375e-04  6.134778e+00
      vertex   9.401635e+00 -4.805756e-01  6.855621e+00
    endloop
  endfacet
  facet normal -9.659419e-01 -2.718588e-03  2.587444e-01
    outer loop
      vertex  -9.168571e+00  4.445152e-01  1.252264e+01
      vertex  -9.411016e+00  8.449554e-04  1.161289e+01
      vertex  -9.167421e+00  8.258820e-04  1.252227e+01
    endloop
  endfacet
  facet normal -7.013666e-01 -6.795576e-01 -2.151425e-01
    outer loop
      vertex  -5.864365e+00 -4.077097e+00  1.673114e+00
      vertex  -5.944186e+00 -4.109646e+00  2.036141e+00
      vertex  -6.520677e+00 -3.503586e+00  2.001183e+00
    endloop
  endfacet
  facet normal  9.709928e-01 -3.680859e-03 -2.390803e-01
    outer loop
      vertex   9.081166e+00 -5.084686e-01  5.421710e+00
      vertex   9.082833e+00 -2.098083e-05  5.420652e+00
      vertex   9.256927e+00 -4.945354e-01  6.135322e+00
    endloop
  endfacet
  facet normal  9.598993e-01 -5.496115e-03 -2.802912e-01
    outer loop
      vertex   8.875030e+00 -5.201473e-01  4.715992e+00
      vertex   8.877553e+00 -4.463196e-04  4.714444e+00
      vertex   9.081166e+00 -5.084686e-01  5.421710e+00
    endloop
  endfacet
  facet normal  9.602484e-01 -3.728928e-03 -2.791223e-01
    outer loop
      vertex   8.877553e+00 -4.463196e-04  4.714444e+00
      vertex   9.082833e+00 -2.098083e-05  5.420652e+00
      vertex   9.081166e+00 -5.084686e-01  5.421710e+00
    endloop
  endfacet
  facet normal  9.333799e-01 -9.455939e-03 -3.587653e-01
    outer loop
      vertex   8.373710e+00 -5.302849e-01  3.328514e+00
      vertex   8.378257e+00 -9.479523e-04  3.326392e+00
      vertex   8.638652e+00 -5.277958e-01  4.017734e+00
    endloop
  endfacet
  facet normal -2.882532e-02 -4.178803e-03 -9.995758e-01
    outer loop
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex   3.955427e-01  2.181280e+00  1.782582e+01
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
    endloop
  endfacet
  facet normal  9.639533e-01 -8.967039e-08  2.660713e-01
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -8.005733e+00 -2.414318e+00  7.563979e+00
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
    endloop
  endfacet
  facet normal  9.476317e-01 -5.552852e-03 -3.193167e-01
    outer loop
      vertex   8.642137e+00 -8.125305e-04  4.015808e+00
      vertex   8.877553e+00 -4.463196e-04  4.714444e+00
      vertex   8.875030e+00 -5.201473e-01  4.715992e+00
    endloop
  endfacet
  facet normal  7.134373e-01 -6.137710e-01 -3.380715e-01
    outer loop
      vertex   6.669502e+00 -3.123020e+00  1.631585e+00
      vertex   6.788991e+00 -3.179214e+00  1.985767e+00
      vertex   6.519882e+00 -3.500469e+00  2.001101e+00
    endloop
  endfacet
  facet normal  7.278971e-01 -5.775912e-01 -3.695325e-01
    outer loop
      vertex   6.547676e+00 -3.050220e+00  1.277827e+00
      vertex   6.669502e+00 -3.123020e+00  1.631585e+00
      vertex   6.414841e+00 -3.452044e+00  1.644233e+00
    endloop
  endfacet
  facet normal  8.816029e-01 -1.543077e-02 -4.717395e-01
    outer loop
      vertex   7.378617e+00  1.985550e-03  1.241727e+00
      vertex   7.565843e+00  1.035690e-03  1.591653e+00
      vertex   7.557779e+00 -4.951801e-01  1.592813e+00
    endloop
  endfacet
  facet normal  8.782322e-01 -2.070133e-02 -4.777862e-01
    outer loop
      vertex   7.000465e+00 -4.384537e-01  5.618048e-01
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
      vertex   7.370050e+00 -4.768314e-01  1.242812e+00
    endloop
  endfacet
  facet normal  8.794551e-01 -1.681317e-02 -4.756848e-01
    outer loop
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
      vertex   7.378617e+00  1.985550e-03  1.241727e+00
      vertex   7.370050e+00 -4.768314e-01  1.242812e+00
    endloop
  endfacet
  facet normal -3.894352e-01 -9.192232e-01 -5.804147e-02
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -3.166358e+00 -5.996792e+00  1.805169e+00
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
    endloop
  endfacet
  facet normal  7.509782e-01 -4.161579e-03 -6.603138e-01
    outer loop
      vertex  -6.051859e+00 -2.180950e+00  1.519485e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
    endloop
  endfacet
  facet normal  9.289446e-01 -3.267165e-07 -3.702187e-01
    outer loop
      vertex  -7.727574e+00  2.181353e+00  1.248473e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
      vertex  -7.727578e+00 -2.180943e+00  1.248473e+01
    endloop
  endfacet
  facet normal  8.623038e-01 -1.550353e-01 -4.820748e-01
    outer loop
      vertex   6.963712e+00 -8.787937e-01  5.629530e-01
      vertex   7.332275e+00 -9.518204e-01  1.245701e+00
      vertex   7.250757e+00 -1.418285e+00  1.249901e+00
    endloop
  endfacet
  facet normal  9.964909e-01 -7.001625e-03 -8.340769e-02
    outer loop
      vertex  -8.269004e+00 -2.177960e+00  9.753304e+00
      vertex  -8.253727e+00  2.117157e-04  9.752975e+00
      vertex  -8.235943e+00 -2.180941e+00  1.014854e+01
    endloop
  endfacet
  facet normal  3.473690e-01  2.126453e-03  9.377261e-01
    outer loop
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
      vertex  -2.650488e+00  4.882700e+00  1.761878e+00
    endloop
  endfacet
  facet normal -1.588026e-01  9.873071e-01 -2.507737e-03
    outer loop
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
      vertex   1.072319e+00 -5.471157e+00  1.188286e-16
      vertex   1.011927e+00 -5.480871e+00 -3.873638e-16
    endloop
  endfacet
  facet normal  5.371275e-01  8.398448e-01  7.845205e-02
    outer loop
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   4.141760e+00  5.453775e+00  2.438705e+00
      vertex   4.338367e+00  5.317045e+00  2.556341e+00
    endloop
  endfacet
  facet normal  9.078776e-01 -1.852311e-01 -3.760953e-01
    outer loop
      vertex   8.044003e+00 -1.046951e+00  2.654753e+00
      vertex   8.224885e+00 -1.560116e+00  3.344132e+00
      vertex   7.944548e+00 -1.553850e+00  2.664325e+00
    endloop
  endfacet
  facet normal  9.894955e-01 -4.225843e-03 -1.445021e-01
    outer loop
      vertex  -8.200814e+00  2.181055e+00  1.054299e+01
      vertex  -8.143588e+00  2.181360e+00  1.093485e+01
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
    endloop
  endfacet
  facet normal  7.737539e-16  2.388005e-15 -1.000000e+00
    outer loop
      vertex   6.652087e+00  8.003138e-01  2.636780e-16
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
      vertex   6.590715e+00  1.207189e+00  1.187813e-15
    endloop
  endfacet
  facet normal -9.944292e-01  1.891281e-03 -1.053898e-01
    outer loop
      vertex  -9.514237e+00 -4.687805e-01  7.582165e+00
      vertex  -9.591765e+00 -4.601555e-01  8.313853e+00
      vertex  -9.590901e+00  7.381439e-04  8.313972e+00
    endloop
  endfacet
  facet normal -7.399267e-01  6.307329e-01 -2.338475e-01
    outer loop
      vertex  -6.786282e+00  3.180582e+00  1.985910e+00
      vertex  -6.619835e+00  3.513231e+00  2.356470e+00
      vertex  -6.517076e+00  3.502085e+00  2.001261e+00
    endloop
  endfacet
  facet normal  9.606346e-01 -4.920994e-07 -2.778150e-01
    outer loop
      vertex  -7.974323e+00  2.181356e+00  1.171618e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
      vertex  -7.974327e+00 -2.180941e+00  1.171617e+01
    endloop
  endfacet
  facet normal  5.859241e-01 -8.061866e-01 -8.219521e-02
    outer loop
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
      vertex   3.872465e+00 -5.588881e+00  1.385299e+00
      vertex   3.816425e+00 -5.551033e+00  6.146011e-01
    endloop
  endfacet
  facet normal  9.428131e-01 -4.165933e-03 -3.332958e-01
    outer loop
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
      vertex  -7.727574e+00  2.181353e+00  1.248473e+01
    endloop
  endfacet
  facet normal  4.686693e-01  8.775383e-01  1.013687e-01
    outer loop
      vertex   6.580883e+00  3.490953e+00  4.594908e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
    endloop
  endfacet
  facet normal  8.628379e-01 -4.159138e-03 -5.054636e-01
    outer loop
      vertex  -7.015543e+00 -2.180944e+00  1.393137e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
    endloop
  endfacet
  facet normal  8.277061e-01  5.060005e-01 -2.426237e-01
    outer loop
      vertex   7.816690e+00  2.465845e+00  3.372647e+00
      vertex   8.037576e+00  2.432901e+00  4.057489e+00
      vertex   8.288459e+00  2.015738e+00  4.043362e+00
    endloop
  endfacet
  facet normal  8.883064e-01 -6.631948e-07 -4.592513e-01
    outer loop
      vertex  -7.406958e+00  2.181349e+00  1.322548e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
      vertex  -7.406964e+00 -2.180943e+00  1.322548e+01
    endloop
  endfacet
  facet normal  8.600402e-01  4.374308e-04 -5.102261e-01
    outer loop
      vertex  -7.015535e+00  2.181345e+00  1.393137e+01
      vertex  -7.219871e+00 -2.180944e+00  1.358320e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
    endloop
  endfacet
  facet normal  7.491530e-01  6.422128e-01 -1.622730e-01
    outer loop
      vertex   7.742470e+00  2.781343e+00  4.074096e+00
      vertex   8.234009e+00  2.378031e+00  4.747190e+00
      vertex   8.037576e+00  2.432901e+00  4.057489e+00
    endloop
  endfacet
  facet normal  8.107107e-01 -4.159866e-03 -5.854322e-01
    outer loop
      vertex  -6.561809e+00 -2.180946e+00  1.458945e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
    endloop
  endfacet
  facet normal  7.459665e-01 -4.169608e-03 -6.659704e-01
    outer loop
      vertex  -6.051849e+00  2.181334e+00  1.519486e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
    endloop
  endfacet
  facet normal  7.147046e-01 -1.107092e-06 -6.994264e-01
    outer loop
      vertex  -6.051849e+00  2.181334e+00  1.519486e+01
      vertex  -6.051859e+00 -2.180950e+00  1.519485e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
    endloop
  endfacet
  facet normal  4.047075e-01 -6.159655e-07 -9.144462e-01
    outer loop
      vertex  -3.488899e+00  2.181314e+00  1.706183e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
      vertex  -3.488914e+00 -2.180962e+00  1.706183e+01
    endloop
  endfacet
  facet normal -9.333444e-01 -2.569925e-01 -2.506452e-01
    outer loop
      vertex  -8.708583e+00 -1.524952e+00  4.727094e+00
      vertex  -8.907181e+00 -1.488121e+00  5.428863e+00
      vertex  -9.038230e+00 -1.008003e+00  5.424583e+00
    endloop
  endfacet
  facet normal  4.003704e-01  4.378895e-04 -9.163533e-01
    outer loop
      vertex  -3.488914e+00 -2.180962e+00  1.706183e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
      vertex  -3.119041e+00 -2.180964e+00  1.722343e+01
    endloop
  endfacet
  facet normal  5.741010e-01 -3.251157e-07 -8.187845e-01
    outer loop
      vertex  -4.870253e+00  2.181326e+00  1.624569e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -4.870266e+00 -2.180956e+00  1.624568e+01
    endloop
  endfacet
  facet normal  6.500937e-01 -9.219437e-07 -7.598541e-01
    outer loop
      vertex  -5.486269e+00  2.181330e+00  1.574863e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
      vertex  -5.486282e+00 -2.180952e+00  1.574862e+01
    endloop
  endfacet
  facet normal  5.704445e-01  4.043976e-04 -8.213360e-01
    outer loop
      vertex  -4.870266e+00 -2.180956e+00  1.624568e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -4.545118e+00 -2.180956e+00  1.647151e+01
    endloop
  endfacet
  facet normal -8.748122e-01 -7.366194e-02 -4.788295e-01
    outer loop
      vertex  -6.964637e+00 -8.798046e-01  5.629778e-01
      vertex  -7.370649e+00 -4.772720e-01  1.242829e+00
      vertex  -7.001122e+00 -4.389858e-01  5.618219e-01
    endloop
  endfacet
  facet normal -8.555799e-01 -3.750101e-08  5.176708e-01
    outer loop
      vertex   6.959351e+00  3.182512e+00  5.138515e+00
      vertex   7.163453e+00 -3.024397e+00  5.475844e+00
      vertex   7.163462e+00  3.022242e+00  5.475860e+00
    endloop
  endfacet
  facet normal  1.979803e-16 -1.171498e-15 -1.000000e+00
    outer loop
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
      vertex  -5.921600e+00 -3.112514e+00 -8.326673e-17
      vertex  -4.634246e+00 -3.046586e+00  9.436896e-17
    endloop
  endfacet
  facet normal  6.464141e-01  4.377361e-04 -7.629867e-01
    outer loop
      vertex  -5.486282e+00 -2.180952e+00  1.574862e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
      vertex  -5.184224e+00 -2.180954e+00  1.600453e+01
    endloop
  endfacet
  facet normal  6.786986e-01 -4.171406e-03 -7.344051e-01
    outer loop
      vertex  -5.486269e+00  2.181330e+00  1.574863e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
    endloop
  endfacet
  facet normal  8.613191e-01  1.456921e-01 -4.867271e-01
    outer loop
      vertex   6.890595e+00  1.320393e+00  5.645571e-01
      vertex   6.963074e+00  8.865833e-01  5.629635e-01
      vertex   6.590715e+00  1.207189e+00  1.187813e-15
    endloop
  endfacet
  facet normal  6.443570e-01 -8.986237e-07 -7.647248e-01
    outer loop
      vertex  -5.486269e+00  2.181330e+00  1.574863e+01
      vertex  -5.486282e+00 -2.180952e+00  1.574862e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
    endloop
  endfacet
  facet normal -8.108772e-01  5.850281e-01 -1.484597e-02
    outer loop
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
      vertex   4.642241e+00 -3.034725e+00 -5.828671e-17
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
    endloop
  endfacet
  facet normal  6.053143e-01  4.378475e-04 -7.959864e-01
    outer loop
      vertex  -4.870253e+00  2.181326e+00  1.624569e+01
      vertex  -5.184224e+00 -2.180954e+00  1.600453e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
    endloop
  endfacet
  facet normal  8.754717e-01 -3.621447e-01 -3.200006e-01
    outer loop
      vertex   8.224885e+00 -1.560116e+00  3.344132e+00
      vertex   8.480577e+00 -1.549639e+00  4.031807e+00
      vertex   8.290786e+00 -2.018566e+00  4.043255e+00
    endloop
  endfacet
  facet normal -5.507818e-01 -7.615494e-01  3.415874e-01
    outer loop
      vertex  -7.549392e+00 -1.662664e+00  1.478962e+01
      vertex  -8.021980e+00 -1.662747e+00  1.402742e+01
      vertex  -7.726786e+00 -1.949560e+00  1.386397e+01
    endloop
  endfacet
  facet normal -6.819242e-01 -3.910413e-03 -7.314123e-01
    outer loop
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   5.485987e+00 -2.181002e+00  1.574896e+01
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
    endloop
  endfacet
  facet normal  5.262116e-01 -9.819817e-07 -8.503537e-01
    outer loop
      vertex  -4.202793e+00  2.181318e+00  1.668542e+01
      vertex  -4.202807e+00 -2.180958e+00  1.668542e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
    endloop
  endfacet
  facet normal  2.192958e-01 -3.516162e-03 -9.756521e-01
    outer loop
      vertex  -1.968264e+00  2.181299e+00  1.759722e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
    endloop
  endfacet
  facet normal  3.089004e-01  4.046337e-04 -9.510943e-01
    outer loop
      vertex  -2.741698e+00 -2.180965e+00  1.736673e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
      vertex  -2.357801e+00 -2.180967e+00  1.749141e+01
    endloop
  endfacet
  facet normal -3.749083e-02 -9.988870e-01  2.861950e-02
    outer loop
      vertex  -6.561799e+00  2.181341e+00  1.458946e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
    endloop
  endfacet
  facet normal  3.550157e-01 -9.106666e-07 -9.348603e-01
    outer loop
      vertex  -2.741681e+00  2.181307e+00  1.736673e+01
      vertex  -2.741698e+00 -2.180965e+00  1.736673e+01
      vertex  -3.119041e+00 -2.180964e+00  1.722343e+01
    endloop
  endfacet
  facet normal  2.621290e-01  4.048338e-04 -9.650328e-01
    outer loop
      vertex  -1.968280e+00 -2.180969e+00  1.759722e+01
      vertex  -2.357801e+00 -2.180967e+00  1.749141e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
    endloop
  endfacet
  facet normal  2.578945e-01 -1.000756e-06 -9.661731e-01
    outer loop
      vertex  -1.968264e+00  2.181299e+00  1.759722e+01
      vertex  -1.968280e+00 -2.180969e+00  1.759722e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
    endloop
  endfacet
  facet normal -8.823320e-01  1.497842e-02 -4.703889e-01
    outer loop
      vertex  -7.565663e+00  1.035690e-03  1.591647e+00
      vertex  -7.759465e+00  2.861023e-04  1.955147e+00
      vertex  -7.751578e+00  5.112591e-01  1.956624e+00
    endloop
  endfacet
  facet normal  7.290871e-01 -1.044770e-01  6.763996e-01
    outer loop
      vertex   7.365021e+00 -4.433498e-01  1.578320e+01
      vertex   6.704575e+00 -8.842850e-01  1.642699e+01
      vertex   7.329536e+00 -8.843060e-01  1.575334e+01
    endloop
  endfacet
  facet normal  1.243946e-01 -5.608367e-08 -9.922329e-01
    outer loop
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -1.183776e+00 -2.180971e+00  1.774998e+01
      vertex  -1.183759e+00  2.181295e+00  1.774998e+01
    endloop
  endfacet
  facet normal -9.398968e-01  3.136674e-01 -1.349323e-01
    outer loop
      vertex  -9.356354e+00  9.532146e-01  6.855628e+00
      vertex  -9.468263e+00  9.300938e-01  7.581403e+00
      vertex  -9.322186e+00  1.366940e+00  7.579379e+00
    endloop
  endfacet
  facet normal  1.239831e-01 -3.509469e-03 -9.922781e-01
    outer loop
      vertex  -1.183776e+00 -2.180971e+00  1.774998e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
    endloop
  endfacet
  facet normal  6.710066e-02 -4.431356e-03 -9.977364e-01
    outer loop
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -3.959303e-01  2.181288e+00  1.782579e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
    endloop
  endfacet
  facet normal  8.455422e-01 -3.980275e-01 -3.558546e-01
    outer loop
      vertex   7.642750e+00 -2.018703e+00  2.334118e+00
      vertex   7.577900e+00 -2.477064e+00  2.692711e+00
      vertex   7.435361e+00 -2.462561e+00  2.337803e+00
    endloop
  endfacet
  facet normal  1.847713e-02 -7.359384e-08 -9.998293e-01
    outer loop
      vertex  -3.959303e-01  2.181288e+00  1.782579e+01
      vertex  -3.959477e-01 -2.180975e+00  1.782579e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
    endloop
  endfacet
  facet normal -2.561162e-01 -3.489017e-03 -9.666397e-01
    outer loop
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   1.967912e+00 -2.180986e+00  1.759733e+01
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
    endloop
  endfacet
  facet normal -1.743227e-01 -4.620412e-03 -9.846778e-01
    outer loop
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex   1.183383e+00 -2.180983e+00  1.775005e+01
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
    endloop
  endfacet
  facet normal -5.527726e-01 -8.294244e-01 -8.060648e-02
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -3.873714e+00 -5.593157e+00  1.385406e+00
      vertex  -4.559697e+00 -5.133471e+00  1.359566e+00
    endloop
  endfacet
  facet normal  8.470078e-01  5.274391e-01 -6.622464e-02
    outer loop
      vertex   9.078284e+00  1.757601e+00  7.576207e+00
      vertex   9.396003e+00  1.339525e+00  8.310082e+00
      vertex   9.322192e+00  1.366310e+00  7.579377e+00
    endloop
  endfacet
  facet normal -7.467267e-02  2.964372e-07 -9.972081e-01
    outer loop
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
      vertex   3.955427e-01  2.181280e+00  1.782582e+01
      vertex   3.955254e-01 -2.180979e+00  1.782582e+01
    endloop
  endfacet
  facet normal -6.741360e-02  2.680104e-07 -9.977251e-01
    outer loop
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex   3.955254e-01 -2.180979e+00  1.782582e+01
      vertex   3.955427e-01  2.181280e+00  1.782582e+01
    endloop
  endfacet
  facet normal -1.653433e-02 -4.620466e-03 -9.998526e-01
    outer loop
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
      vertex   3.955254e-01 -2.180979e+00  1.782582e+01
    endloop
  endfacet
  facet normal -7.574848e-01  5.126790e-01 -4.041992e-01
    outer loop
      vertex  -6.764935e+00  2.694681e+00  1.269298e+00
      vertex  -6.902237e+00  2.768610e+00  1.620378e+00
      vertex  -6.666580e+00  3.125719e+00  1.631697e+00
    endloop
  endfacet
  facet normal -1.619412e-01 -3.495530e-03 -9.867942e-01
    outer loop
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
      vertex   1.183401e+00  2.181276e+00  1.775005e+01
    endloop
  endfacet
  facet normal  7.330959e-01 -2.962142e-03  6.801188e-01
    outer loop
      vertex   7.365042e+00  4.440365e-01  1.578322e+01
      vertex   6.736129e+00  3.900528e-04  1.645918e+01
      vertex   7.364036e+00  3.700256e-04  1.578237e+01
    endloop
  endfacet
  facet normal -3.130803e-01  4.117677e-04 -9.497266e-01
    outer loop
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
      vertex   2.741358e+00  2.181265e+00  1.736688e+01
      vertex   2.357441e+00 -2.180988e+00  1.749155e+01
    endloop
  endfacet
  facet normal -2.620716e-01  1.658925e-07 -9.650484e-01
    outer loop
      vertex   1.967929e+00  2.181269e+00  1.759733e+01
      vertex   2.357441e+00 -2.180988e+00  1.749155e+01
      vertex   1.967912e+00 -2.180986e+00  1.759733e+01
    endloop
  endfacet
  facet normal -3.505150e-01  4.632844e-07 -9.365572e-01
    outer loop
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   2.741342e+00 -2.180990e+00  1.736688e+01
      vertex   2.741358e+00  2.181265e+00  1.736688e+01
    endloop
  endfacet
  facet normal -5.703934e-01  7.930819e-07 -8.213716e-01
    outer loop
      vertex   4.869976e+00  2.181246e+00  1.624597e+01
      vertex   4.869961e+00 -2.181000e+00  1.624597e+01
      vertex   4.544808e+00 -2.180998e+00  1.647177e+01
    endloop
  endfacet
  facet normal -1.425776e-01  1.047346e-01  9.842267e-01
    outer loop
      vertex  -9.179352e-01  8.851624e-01  1.911854e+01
      vertex  -1.836113e+00  4.442806e-01  1.903244e+01
      vertex  -9.223928e-01  4.442577e-01  1.916481e+01
    endloop
  endfacet
  facet normal -5.330299e-01 -4.426792e-03 -8.460848e-01
    outer loop
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   4.202488e+00 -2.180996e+00  1.668565e+01
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
    endloop
  endfacet
  facet normal -8.919452e-01  3.349738e-01 -3.036880e-01
    outer loop
      vertex  -8.223594e+00  1.558374e+00  3.344243e+00
      vertex  -8.289346e+00  2.017138e+00  4.043384e+00
      vertex  -8.048572e+00  2.035978e+00  3.357002e+00
    endloop
  endfacet
  facet normal -4.919489e-01  4.696241e-07 -8.706241e-01
    outer loop
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   4.202503e+00  2.181250e+00  1.668565e+01
      vertex   4.202488e+00 -2.180996e+00  1.668565e+01
    endloop
  endfacet
  facet normal  7.477273e-01 -5.457111e-01 -3.782900e-01
    outer loop
      vertex   6.300029e+00 -2.902218e+00  5.748234e-01
      vertex   6.547676e+00 -3.050220e+00  1.277827e+00
      vertex   6.307900e+00 -3.385426e+00  1.287444e+00
    endloop
  endfacet
  facet normal -3.969581e-01  2.046648e-07 -9.178368e-01
    outer loop
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
      vertex   3.488575e+00 -2.180994e+00  1.706203e+01
      vertex   3.488590e+00  2.181257e+00  1.706202e+01
    endloop
  endfacet
  facet normal -9.921573e-01 -1.044860e-01  6.860380e-02
    outer loop
      vertex  -9.563873e+00 -4.428368e-01  1.070222e+01
      vertex  -9.627370e+00 -4.448690e-01  9.780826e+00
      vertex  -9.517808e+00 -8.837872e-01  1.069684e+01
    endloop
  endfacet
  facet normal -4.403650e-01 -4.438027e-03 -8.978079e-01
    outer loop
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
      vertex   3.488590e+00  2.181257e+00  1.706202e+01
    endloop
  endfacet
  facet normal -5.298792e-01  6.251984e-07 -8.480732e-01
    outer loop
      vertex   4.202503e+00  2.181250e+00  1.668565e+01
      vertex   4.544808e+00 -2.180998e+00  1.647177e+01
      vertex   4.202488e+00 -2.180996e+00  1.668565e+01
    endloop
  endfacet
  facet normal -5.254729e-01  4.805854e-04 -8.508102e-01
    outer loop
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
      vertex   4.544808e+00 -2.180998e+00  1.647177e+01
      vertex   4.202503e+00  2.181250e+00  1.668565e+01
    endloop
  endfacet
  facet normal -6.058821e-01  7.622780e-01  2.276820e-01
    outer loop
      vertex  -8.107093e+00  1.950495e+00  1.308844e+01
      vertex  -8.410871e+00  1.950541e+00  1.227990e+01
      vertex  -8.732751e+00  1.663901e+00  1.238302e+01
    endloop
  endfacet
  facet normal -6.055480e-01  9.404379e-07 -7.958088e-01
    outer loop
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   4.869961e+00 -2.181000e+00  1.624597e+01
      vertex   4.869976e+00  2.181246e+00  1.624597e+01
    endloop
  endfacet
  facet normal -5.448294e-01 -8.238401e-01  1.563600e-01
    outer loop
      vertex  -4.773528e+00 -4.994781e+00  2.844591e+00
      vertex  -4.685282e+00 -5.121077e+00  2.486646e+00
      vertex  -4.721087e+00 -5.036455e+00  2.807743e+00
    endloop
  endfacet
  facet normal -5.706899e-01 -3.910327e-03 -8.211563e-01
    outer loop
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
      vertex   4.869961e+00 -2.181000e+00  1.624597e+01
    endloop
  endfacet
  facet normal -2.331355e-01  9.700868e-01  6.767173e-02
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
      vertex  -8.255363e+00  2.181059e+00  9.753010e+00
    endloop
  endfacet
  facet normal  2.879166e-01 -9.549434e-01 -7.202180e-02
    outer loop
      vertex   1.820122e+00 -6.455023e+00  1.445436e+00
      vertex   2.387643e+00 -6.282898e+00  1.431952e+00
      vertex   2.004912e+00 -6.408859e+00  1.572065e+00
    endloop
  endfacet
  facet normal -6.786460e-01 -3.830270e-03 -7.344555e-01
    outer loop
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
      vertex   5.486000e+00  2.181242e+00  1.574896e+01
    endloop
  endfacet
  facet normal -2.965160e-01  9.512933e-01  8.437647e-02
    outer loop
      vertex  -7.906281e+00  2.481993e+00  7.203674e+00
      vertex  -8.300170e+00  2.390478e+00  6.851242e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
    endloop
  endfacet
  facet normal -8.392473e-01  5.161077e-07 -5.437500e-01
    outer loop
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   7.015390e+00  2.181227e+00  1.393177e+01
      vertex   7.015382e+00 -2.181009e+00  1.393177e+01
    endloop
  endfacet
  facet normal -9.976273e-01 -2.577944e-03  6.879710e-02
    outer loop
      vertex  -9.562470e+00  8.621216e-04  1.070205e+01
      vertex  -9.627151e+00  4.464064e-01  9.780823e+00
      vertex  -9.626000e+00  7.368724e-04  9.780801e+00
    endloop
  endfacet
  facet normal -7.830198e-01  9.446739e-07 -6.219968e-01
    outer loop
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   6.561607e+00  2.181231e+00  1.458983e+01
      vertex   6.561598e+00 -2.181007e+00  1.458984e+01
    endloop
  endfacet
  facet normal -8.912251e-01 -7.301068e-02 -4.476465e-01
    outer loop
      vertex  -7.713012e+00 -1.017324e+00  1.959830e+00
      vertex  -7.930489e+00 -5.212479e-01  2.311898e+00
      vertex  -7.752903e+00 -5.110149e-01  1.956669e+00
    endloop
  endfacet
  facet normal  3.829925e-01 -9.043120e-01  1.885117e-01
    outer loop
      vertex   8.109565e+00 -1.948414e+00  1.308991e+01
      vertex   7.727928e+00 -1.948465e+00  1.386502e+01
      vertex   7.377430e+00 -2.137368e+00  1.367093e+01
    endloop
  endfacet
  facet normal -7.172267e-01  8.092151e-07 -6.968399e-01
    outer loop
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
      vertex   6.051597e+00 -2.181005e+00  1.519523e+01
      vertex   6.051607e+00  2.181234e+00  1.519522e+01
    endloop
  endfacet
  facet normal -3.984415e-01 -9.048839e-01  1.497652e-01
    outer loop
      vertex  -8.412040e+00 -1.949663e+00  1.228027e+01
      vertex  -8.030813e+00 -2.137737e+00  1.215816e+01
      vertex  -8.108208e+00 -1.949612e+00  1.308891e+01
    endloop
  endfacet
  facet normal -8.062225e-01 -4.442586e-03 -5.915957e-01
    outer loop
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
      vertex   6.561607e+00  2.181231e+00  1.458983e+01
    endloop
  endfacet
  facet normal  3.766620e-01  9.261020e-01 -2.146415e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   2.363800e+00  6.274577e+00  6.326923e-01
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
    endloop
  endfacet
  facet normal -1.425759e-01  1.047311e-01  9.842274e-01
    outer loop
      vertex  -9.179352e-01  8.851624e-01  1.911854e+01
      vertex  -1.827242e+00  8.851852e-01  1.898681e+01
      vertex  -1.836113e+00  4.442806e-01  1.903244e+01
    endloop
  endfacet
  facet normal -8.599943e-01  4.418213e-04 -5.103035e-01
    outer loop
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   7.219731e+00 -2.181011e+00  1.358362e+01
      vertex   7.015390e+00  2.181227e+00  1.393177e+01
    endloop
  endfacet
  facet normal -8.874037e-01  6.627499e-07 -4.609932e-01
    outer loop
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
      vertex   7.406844e+00 -2.181011e+00  1.322591e+01
      vertex   7.406849e+00  2.181223e+00  1.322590e+01
    endloop
  endfacet
  facet normal -3.142251e-01 -1.276773e-03  9.493476e-01
    outer loop
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
      vertex   2.392633e+00  6.292719e+00  1.679182e+00
      vertex   2.702310e+00  4.853266e+00  1.779746e+00
    endloop
  endfacet
  facet normal  6.617948e-01  7.480652e-01 -4.925450e-02
    outer loop
      vertex   8.069473e+00  2.602678e+00  5.449855e+00
      vertex   8.548699e+00  2.224340e+00  6.142745e+00
      vertex   8.404426e+00  2.305803e+00  5.441488e+00
    endloop
  endfacet
  facet normal -3.384599e-01 -9.048023e-01  2.584135e-01
    outer loop
      vertex  -6.757536e+00 -1.949457e+00  1.527148e+01
      vertex  -6.941944e+00 -2.137688e+00  1.437088e+01
      vertex  -6.451189e+00 -2.137671e+00  1.501371e+01
    endloop
  endfacet
  facet normal -9.056811e-01 -3.833572e-03 -4.239423e-01
    outer loop
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
      vertex   7.406849e+00  2.181223e+00  1.322590e+01
    endloop
  endfacet
  facet normal -9.831108e-01  1.746863e-07 -1.830115e-01
    outer loop
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
      vertex   8.143600e+00  2.181211e+00  1.093534e+01
      vertex   8.143600e+00 -2.181015e+00  1.093535e+01
    endloop
  endfacet
  facet normal -2.320219e-01  9.725319e-01  1.864296e-02
    outer loop
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
    endloop
  endfacet
  facet normal -9.427836e-01 -3.834403e-03 -3.333832e-01
    outer loop
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
      vertex   7.727502e+00  2.181219e+00  1.248517e+01
    endloop
  endfacet
  facet normal -8.191970e-01  5.554519e-01 -1.427917e-01
    outer loop
      vertex  -8.503814e+00  1.979933e+00  4.736134e+00
      vertex  -8.404983e+00  2.307024e+00  5.441505e+00
      vertex  -8.234803e+00  2.379526e+00  4.747215e+00
    endloop
  endfacet
  facet normal -1.015340e-01  9.048331e-01  4.134826e-01
    outer loop
      vertex  -1.608142e+00  2.138052e+00  1.785956e+01
      vertex  -2.408869e+00  2.138071e+00  1.766289e+01
      vertex  -2.523188e+00  1.950075e+00  1.804622e+01
    endloop
  endfacet
  facet normal -9.708067e-01 -4.447303e-03 -2.398220e-01
    outer loop
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
      vertex   7.974295e+00  2.181215e+00  1.171663e+01
    endloop
  endfacet
  facet normal -9.987785e-01 -3.525121e-03 -4.928615e-02
    outer loop
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
      vertex   8.216428e+00 -2.177635e+00  1.054533e+01
    endloop
  endfacet
  facet normal  1.797336e-01  9.830283e-01 -3.675850e-02
    outer loop
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
      vertex   1.593122e+00  6.482521e+00  2.211772e-17
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
    endloop
  endfacet
  facet normal  4.596262e-01 -4.536775e-04  8.881124e-01
    outer loop
      vertex  -3.940862e+00  5.589209e+00  2.326075e+00
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -3.644764e+00  5.762789e+00  2.172923e+00
    endloop
  endfacet
  facet normal -7.291124e-01 -1.044853e-01  6.763711e-01
    outer loop
      vertex  -6.737354e+00 -4.429779e-01  1.645983e+01
      vertex  -7.329827e+00 -8.839073e-01  1.575304e+01
      vertex  -6.704895e+00 -8.839283e-01  1.642670e+01
    endloop
  endfacet
  facet normal -9.961178e-01  0.000000e+00 -8.803016e-02
    outer loop
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.235993e+00  2.181208e+00  1.014908e+01
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
    endloop
  endfacet
  facet normal -9.893842e-01 -3.531411e-03 -1.452807e-01
    outer loop
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.216428e+00 -2.177635e+00  1.054533e+01
      vertex   8.143600e+00  2.181211e+00  1.093534e+01
    endloop
  endfacet
  facet normal  5.698386e-01  8.217229e-01 -7.442229e-03
    outer loop
      vertex   7.572250e+00  2.941378e+00  4.775318e+00
      vertex   8.069473e+00  2.602678e+00  5.449855e+00
      vertex   7.917879e+00  2.701559e+00  4.760293e+00
    endloop
  endfacet
  facet normal -9.965788e-01 -6.799854e-03 -8.236824e-02
    outer loop
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
      vertex   8.253806e+00  9.536743e-05  9.753502e+00
      vertex   8.268659e+00 -2.178129e+00  9.753622e+00
    endloop
  endfacet
  facet normal  6.135274e-01  2.933945e-04  7.896734e-01
    outer loop
      vertex  -4.968631e+00 -4.836309e+00  2.987150e+00
      vertex  -5.020278e+00 -2.201843e+00  3.026298e+00
      vertex  -5.159912e+00 -4.676804e+00  3.135705e+00
    endloop
  endfacet
  facet normal  6.133450e-01 -7.856899e-01 -8.061824e-02
    outer loop
      vertex   5.256689e+00 -4.645506e+00  1.705096e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
      vertex   4.600634e+00 -5.161119e+00  1.738890e+00
    endloop
  endfacet
  facet normal -4.774026e-02  1.047326e-01  9.933539e-01
    outer loop
      vertex  -1.912162e-04  8.851395e-01  1.916265e+01
      vertex  -9.223928e-01  4.442577e-01  1.916481e+01
      vertex  -1.942747e-04  4.442348e-01  1.920913e+01
    endloop
  endfacet
  facet normal  5.062417e-01  1.047312e-01  8.560086e-01
    outer loop
      vertex   5.275980e+00  8.850021e-01  1.757960e+01
      vertex   4.491253e+00  4.441223e-01  1.809762e+01
      vertex   5.301584e+00  4.441013e-01  1.761840e+01
    endloop
  endfacet
  facet normal -4.152721e-16  2.193382e-16 -1.000000e+00
    outer loop
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
      vertex   5.330669e+00 -1.508112e+00 -2.775558e-17
    endloop
  endfacet
  facet normal -3.432357e-01 -9.375119e-01  5.710366e-02
    outer loop
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
      vertex  -8.143590e+00 -2.180941e+00  1.093485e+01
    endloop
  endfacet
  facet normal -9.976296e-01  3.069832e-03  6.874368e-02
    outer loop
      vertex  -9.563873e+00 -4.428368e-01  1.070222e+01
      vertex  -9.626000e+00  7.368724e-04  9.780801e+00
      vertex  -9.627370e+00 -4.448690e-01  9.780826e+00
    endloop
  endfacet
  facet normal -9.921310e-01 -1.048533e-01  6.842460e-02
    outer loop
      vertex  -9.517808e+00 -8.837872e-01  1.069684e+01
      vertex  -9.627370e+00 -4.448690e-01  9.780826e+00
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
    endloop
  endfacet
  facet normal -4.751745e-01 -7.615011e-01  4.408233e-01
    outer loop
      vertex  -6.417627e+00 -1.662502e+00  1.613357e+01
      vertex  -6.757536e+00 -1.949457e+00  1.527148e+01
      vertex  -6.181426e+00 -1.949408e+00  1.589257e+01
    endloop
  endfacet
  facet normal -7.820364e-01 -6.208938e-01  5.394495e-02
    outer loop
      vertex  -9.261168e+00 -1.470842e+00  1.066687e+01
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
      vertex  -9.110768e+00 -1.661802e+00  1.064930e+01
    endloop
  endfacet
  facet normal  7.465837e-01  5.112335e-08  6.652915e-01
    outer loop
      vertex  -6.237068e+00  3.783979e+00  4.171127e+00
      vertex  -6.088506e+00 -3.916286e+00  4.004413e+00
      vertex  -6.088440e+00  3.912035e+00  4.004339e+00
    endloop
  endfacet
  facet normal  8.884385e-01 -3.015029e-01 -3.460825e-01
    outer loop
      vertex   7.944548e+00 -1.553850e+00  2.664325e+00
      vertex   8.050153e+00 -2.037596e+00  3.356859e+00
      vertex   7.786209e+00 -2.035057e+00  2.677070e+00
    endloop
  endfacet
  facet normal  5.806825e-01  4.862178e-01  6.529933e-01
    outer loop
      vertex   6.525639e+00  1.467388e+00  1.624437e+01
      vertex   5.857304e+00  1.467438e+00  1.683866e+01
      vertex   5.955045e+00  1.188147e+00  1.695970e+01
    endloop
  endfacet
  facet normal  9.959441e-01  7.582607e-08  8.997378e-02
    outer loop
      vertex  -8.236568e+00  2.238081e+00  9.019915e+00
      vertex  -8.203500e+00 -2.272165e+00  8.653872e+00
      vertex  -8.203500e+00  2.272688e+00  8.653869e+00
    endloop
  endfacet
  facet normal -2.392032e-01 -9.707792e-01  1.922449e-02
    outer loop
      vertex  -8.376802e+00 -2.137806e+00  1.056362e+01
      vertex  -8.284958e+00 -2.174232e+00  9.866986e+00
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
    endloop
  endfacet
  facet normal -9.473305e-01 -3.135229e-01  6.533127e-02
    outer loop
      vertex  -9.417384e+00 -1.189667e+00  1.068511e+01
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
      vertex  -9.479942e+00 -1.189680e+00  9.777925e+00
    endloop
  endfacet
  facet normal  6.090727e-01 -7.924695e-01 -3.197465e-02
    outer loop
      vertex   8.406335e+00 -2.307093e+00  5.441423e+00
      vertex   8.550247e+00 -2.224781e+00  6.142717e+00
      vertex   8.198556e+00 -2.495211e+00  6.145896e+00
    endloop
  endfacet
  facet normal -1.166613e-01 -9.814910e-01  1.518734e-01
    outer loop
      vertex  -4.870266e+00 -2.180956e+00  1.624568e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
      vertex  -5.184224e+00 -2.180954e+00  1.600453e+01
    endloop
  endfacet
  facet normal  5.900419e-01  1.291982e-04  8.073726e-01
    outer loop
      vertex  -4.773528e+00 -4.994781e+00  2.844591e+00
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
      vertex  -4.968631e+00 -4.836309e+00  2.987150e+00
    endloop
  endfacet
  facet normal  8.155454e-01 -5.269158e-01 -2.392604e-01
    outer loop
      vertex   7.577900e+00 -2.477064e+00  2.692711e+00
      vertex   7.548003e+00 -2.840347e+00  3.390848e+00
      vertex   7.331333e+00 -2.866991e+00  2.710981e+00
    endloop
  endfacet
  facet normal  7.040672e-01  6.198139e-01  3.465836e-01
    outer loop
      vertex   8.419196e+00  1.661506e+00  1.322371e+01
      vertex   8.022988e+00  1.661601e+00  1.402842e+01
      vertex   8.157441e+00  1.467236e+00  1.410288e+01
    endloop
  endfacet
  facet normal -7.668290e-02 -9.814888e-01  1.754975e-01
    outer loop
      vertex  -3.488914e+00 -2.180962e+00  1.706183e+01
      vertex  -3.119041e+00 -2.180964e+00  1.722343e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
    endloop
  endfacet
  facet normal  5.372257e-01  8.384839e-01 -9.128807e-02
    outer loop
      vertex   3.868523e+00  5.588697e+00  1.385323e+00
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   4.596550e+00  5.160742e+00  1.738938e+00
    endloop
  endfacet
  facet normal  8.048635e-01  5.227904e-01 -2.808647e-01
    outer loop
      vertex   7.327545e+00  2.863512e+00  2.711124e+00
      vertex   7.816690e+00  2.465845e+00  3.372647e+00
      vertex   7.574259e+00  2.473860e+00  2.692841e+00
    endloop
  endfacet
  facet normal -3.391002e-01  9.364159e-01  9.020145e-02
    outer loop
      vertex  -8.197238e+00  2.495691e+00  6.145942e+00
      vertex  -8.300170e+00  2.390478e+00  6.851242e+00
      vertex  -7.902413e+00  2.534609e+00  6.850279e+00
    endloop
  endfacet
  facet normal  7.783610e-01 -1.048288e-06 -6.278169e-01
    outer loop
      vertex  -6.561799e+00  2.181341e+00  1.458946e+01
      vertex  -6.561809e+00 -2.180946e+00  1.458945e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
    endloop
  endfacet
  facet normal  8.061234e-01  5.915161e-01 -1.654869e-02
    outer loop
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
      vertex  -4.288297e+00 -3.524029e+00  0.000000e+00
      vertex  -4.303997e+00 -3.502633e+00  1.540434e-16
    endloop
  endfacet
  facet normal -5.917044e-02 -9.814853e-01  1.821689e-01
    outer loop
      vertex  -2.741698e+00 -2.180965e+00  1.736673e+01
      vertex  -2.357801e+00 -2.180967e+00  1.749141e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
    endloop
  endfacet
  facet normal -9.992821e-01  3.052766e-02 -2.243607e-02
    outer loop
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
      vertex   5.520783e+00 -4.315945e-01  1.734723e-18
    endloop
  endfacet
  facet normal  5.133305e-01  8.550944e-01  7.283829e-02
    outer loop
      vertex   3.926537e+00  5.606951e+00  2.157274e+00
      vertex   3.939172e+00  5.585073e+00  2.325060e+00
      vertex   4.141760e+00  5.453775e+00  2.438705e+00
    endloop
  endfacet
  facet normal -5.021051e-02 -9.814864e-01  1.848333e-01
    outer loop
      vertex  -1.968280e+00 -2.180969e+00  1.759722e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
      vertex  -2.357801e+00 -2.180967e+00  1.749141e+01
    endloop
  endfacet
  facet normal -9.757792e-02 -9.814574e-01  1.649844e-01
    outer loop
      vertex  -4.545118e+00 -2.180956e+00  1.647151e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
      vertex  -4.564079e+00 -2.174232e+00  1.650029e+01
    endloop
  endfacet
  facet normal -3.320833e-01 -2.821948e-03  9.432459e-01
    outer loop
      vertex  -2.750353e+00  4.443016e-01  1.880793e+01
      vertex  -3.637867e+00  6.446838e-04  1.849414e+01
      vertex  -2.749995e+00  6.237030e-04  1.880673e+01
    endloop
  endfacet
  facet normal -8.521255e-01  3.130467e-01  4.193851e-01
    outer loop
      vertex  -8.293319e+00  1.189035e+00  1.417769e+01
      vertex  -8.794720e+00  8.854065e-01  1.338556e+01
      vertex  -8.380980e+00  8.853855e-01  1.422623e+01
    endloop
  endfacet
  facet normal -1.259681e-01 -9.558513e-01  2.654814e-01
    outer loop
      vertex  -3.488914e+00 -2.180962e+00  1.706183e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
    endloop
  endfacet
  facet normal -6.948584e-02 -9.535097e-01  2.932423e-01
    outer loop
      vertex  -1.968280e+00 -2.180969e+00  1.759722e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
    endloop
  endfacet
  facet normal -4.244955e-01  9.049558e-01  2.930125e-02
    outer loop
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
      vertex  -8.831487e+00  1.950674e+00  9.764766e+00
    endloop
  endfacet
  facet normal -7.484959e-01 -3.822313e-03 -6.631284e-01
    outer loop
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   6.051597e+00 -2.181005e+00  1.519523e+01
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
    endloop
  endfacet
  facet normal -6.452123e-01  7.627060e-01  4.450604e-02
    outer loop
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
      vertex  -8.831487e+00  1.950674e+00  9.764766e+00
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
    endloop
  endfacet
  facet normal  9.715254e-01  2.359772e-01 -2.128852e-02
    outer loop
      vertex  -5.344566e+00 -1.140627e+00  3.287794e+00
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
    endloop
  endfacet
  facet normal -1.697247e-01 -9.814860e-01  8.876220e-02
    outer loop
      vertex  -7.219871e+00 -2.180944e+00  1.358320e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
      vertex  -7.406964e+00 -2.180943e+00  1.322548e+01
    endloop
  endfacet
  facet normal  9.404480e-01 -3.397822e-01  1.028205e-02
    outer loop
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
      vertex   9.432705e+00 -1.317156e+00  9.041909e+00
      vertex   9.584364e+00 -8.973045e-01  9.044883e+00
    endloop
  endfacet
  facet normal -6.633732e-01  7.472544e-01 -3.933104e-02
    outer loop
      vertex  -5.940165e+00  4.107729e+00  2.036218e+00
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
      vertex  -5.312944e+00  4.666594e+00  2.075194e+00
    endloop
  endfacet
  facet normal  1.361157e-01  3.129923e-01  9.399512e-01
    outer loop
      vertex   1.807832e+00  1.188396e+00  1.888868e+01
      vertex   9.175743e-01  8.851166e-01  1.911859e+01
      vertex   1.826918e+00  8.850937e-01  1.898691e+01
    endloop
  endfacet
  facet normal  8.669518e-01 -4.653852e-01 -1.783567e-01
    outer loop
      vertex   8.907182e+00 -1.487871e+00  5.428856e+00
      vertex   9.076302e+00 -1.444693e+00  6.138244e+00
      vertex   8.849883e+00 -1.867241e+00  6.140228e+00
    endloop
  endfacet
  facet normal -8.714231e-01  4.868352e-01  6.010955e-02
    outer loop
      vertex  -9.263100e+00  1.468576e+00  1.066709e+01
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
      vertex  -9.417916e+00  1.189226e+00  1.068517e+01
    endloop
  endfacet
  facet normal -9.921436e-01  1.047379e-01  6.841801e-02
    outer loop
      vertex  -9.517486e+00  8.854656e-01  1.069680e+01
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
      vertex  -9.563660e+00  4.445534e-01  1.070219e+01
    endloop
  endfacet
  facet normal -2.547647e-01 -9.376726e-01  2.363580e-01
    outer loop
      vertex  -6.051859e+00 -2.180950e+00  1.519485e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
    endloop
  endfacet
  facet normal  8.233640e-01 -4.102488e-01 -3.921322e-01
    outer loop
      vertex   6.300029e+00 -2.902218e+00  5.748234e-01
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
      vertex   6.104056e+00 -2.746094e+00  1.457168e-15
    endloop
  endfacet
  facet normal -9.920976e-01  1.050702e-01  6.857607e-02
    outer loop
      vertex  -9.563660e+00  4.445534e-01  1.070219e+01
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
      vertex  -9.627151e+00  4.464064e-01  9.780823e+00
    endloop
  endfacet
  facet normal  1.761436e-14 -2.429132e-14 -1.000000e+00
    outer loop
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
      vertex   4.408831e+00  5.010327e+00 -1.422473e-16
      vertex   4.435295e+00  4.986383e+00  9.055257e-16
    endloop
  endfacet
  facet normal -9.474778e-01  3.130741e-01  6.534909e-02
    outer loop
      vertex  -9.417916e+00  1.189226e+00  1.068517e+01
      vertex  -9.480475e+00  1.189270e+00  9.777935e+00
      vertex  -9.517486e+00  8.854656e-01  1.069680e+01
    endloop
  endfacet
  facet normal -2.602849e-01  9.655225e-01 -4.239647e-03
    outer loop
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
      vertex   1.574826e+00 -5.345766e+00  2.471981e-16
      vertex   1.519274e+00 -5.360741e+00 -2.147588e-16
    endloop
  endfacet
  facet normal -9.659399e-01  3.156734e-03  2.587470e-01
    outer loop
      vertex  -9.167421e+00  8.258820e-04  1.252227e+01
      vertex  -9.412389e+00 -4.428558e-01  1.161319e+01
      vertex  -9.168757e+00 -4.428749e-01  1.252270e+01
    endloop
  endfacet
  facet normal -7.820226e-01  6.209105e-01  5.395266e-02
    outer loop
      vertex  -9.263100e+00  1.468576e+00  1.066709e+01
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
    endloop
  endfacet
  facet normal  9.598937e-01  3.561881e-03 -2.803414e-01
    outer loop
      vertex   8.875118e+00  5.187302e-01  4.716023e+00
      vertex   9.081264e+00  5.079060e-01  5.421731e+00
      vertex   9.082833e+00 -2.098083e-05  5.420652e+00
    endloop
  endfacet
  facet normal -7.382572e-01 -6.410019e-01 -2.099833e-01
    outer loop
      vertex  -7.044407e+00 -3.201189e+00  2.717045e+00
      vertex  -7.547992e+00 -2.841942e+00  3.390894e+00
      vertex  -7.331246e+00 -2.868858e+00  2.711025e+00
    endloop
  endfacet
  facet normal -9.810558e-01 -1.044795e-01  1.631365e-01
    outer loop
      vertex  -9.412389e+00 -4.428558e-01  1.161319e+01
      vertex  -9.563873e+00 -4.428368e-01  1.070222e+01
      vertex  -9.517808e+00 -8.837872e-01  1.069684e+01
    endloop
  endfacet
  facet normal -6.451179e-01  7.627900e-01  4.443241e-02
    outer loop
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
      vertex  -9.107553e+00  1.665619e+00  1.064893e+01
    endloop
  endfacet
  facet normal  9.960159e-02  9.718326e-01  2.135907e-01
    outer loop
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   3.186519e+00  2.137938e+00  1.738959e+01
    endloop
  endfacet
  facet normal -2.351950e-01  9.718882e-01  1.079874e-02
    outer loop
      vertex  -8.235942e+00  2.181364e+00  1.014854e+01
      vertex  -8.255363e+00  2.181059e+00  9.753010e+00
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
    endloop
  endfacet
  facet normal -8.035517e-01  4.715659e-01 -3.632219e-01
    outer loop
      vertex  -7.270958e+00  2.428316e+00  1.969450e+00
      vertex  -7.186638e+00  2.859190e+00  2.342308e+00
      vertex  -7.038194e+00  2.828043e+00  1.973469e+00
    endloop
  endfacet
  facet normal  7.620866e-01  5.540079e-01 -3.351109e-01
    outer loop
      vertex   6.303267e+00  3.385946e+00  1.287462e+00
      vertex   6.542725e+00  3.050726e+00  1.277834e+00
      vertex   6.086132e+00  3.255663e+00  5.782843e-01
    endloop
  endfacet
  facet normal -4.330604e-02 -9.989945e-01  1.160116e-02
    outer loop
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
      vertex  -7.974323e+00  2.181356e+00  1.171618e+01
    endloop
  endfacet
  facet normal  2.252051e-01 -9.706272e-01  8.464882e-02
    outer loop
      vertex   8.032036e+00 -2.137334e+00  1.215893e+01
      vertex   7.741767e+00 -2.137351e+00  1.293098e+01
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
    endloop
  endfacet
  facet normal  1.018772e-01  3.946670e-03  9.947892e-01
    outer loop
      vertex  -8.056749e-01  6.646356e+00  1.364390e+00
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
    endloop
  endfacet
  facet normal -9.360892e-01  3.155998e-03  3.517486e-01
    outer loop
      vertex  -9.167421e+00  8.258820e-04  1.252227e+01
      vertex  -9.168757e+00 -4.428749e-01  1.252270e+01
      vertex  -8.836282e+00  8.068085e-04  1.340352e+01
    endloop
  endfacet
  facet normal -4.186600e-02 -9.989994e-01  1.573069e-02
    outer loop
      vertex  -7.727574e+00  2.181353e+00  1.248473e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
    endloop
  endfacet
  facet normal -3.818410e-02 -9.989902e-01  2.367711e-02
    outer loop
      vertex  -7.015535e+00  2.181345e+00  1.393137e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
    endloop
  endfacet
  facet normal  2.901333e-01  4.863046e-01  8.242151e-01
    outer loop
      vertex   3.523838e+00  1.467596e+00  1.821576e+01
      vertex   2.663707e+00  1.467648e+00  1.851851e+01
      vertex   2.708174e+00  1.188345e+00  1.866765e+01
    endloop
  endfacet
  facet normal -4.021411e-02 -9.989951e-01  1.978844e-02
    outer loop
      vertex  -7.406958e+00  2.181349e+00  1.322548e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
    endloop
  endfacet
  facet normal  8.918502e-01 -4.018108e-01 -2.077293e-01
    outer loop
      vertex   8.708557e+00 -1.524548e+00  4.727085e+00
      vertex   8.691527e+00 -1.928049e+00  5.434463e+00
      vertex   8.505115e+00 -1.980730e+00  4.736032e+00
    endloop
  endfacet
  facet normal -4.556164e-01 -8.881660e-01 -5.979083e-02
    outer loop
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
      vertex  -3.166358e+00 -5.996792e+00  1.805169e+00
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
    endloop
  endfacet
  facet normal -3.432674e-02 -9.989035e-01  3.183680e-02
    outer loop
      vertex  -6.051849e+00  2.181334e+00  1.519486e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
    endloop
  endfacet
  facet normal -9.883470e-01 -1.925401e-04 -1.522172e-01
    outer loop
      vertex  -9.401813e+00  6.008148e-04  6.855484e+00
      vertex  -9.513741e+00  7.247925e-04  7.582239e+00
      vertex  -9.513821e+00  4.703484e-01  7.582159e+00
    endloop
  endfacet
  facet normal -2.009682e-02 -9.988645e-01  4.319503e-02
    outer loop
      vertex  -3.488899e+00  2.181314e+00  1.706183e+01
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
    endloop
  endfacet
  facet normal -6.759294e-03 -9.988899e-01  4.661820e-02
    outer loop
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -1.183759e+00  2.181295e+00  1.774998e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
    endloop
  endfacet
  facet normal  6.504759e-01  7.547827e-01 -8.476023e-02
    outer loop
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
      vertex   6.929443e+00  3.401724e+00  3.434681e+00
      vertex   6.733425e+00  3.490854e+00  2.724072e+00
    endloop
  endfacet
  facet normal -9.804035e-01  2.493411e-03 -1.969840e-01
    outer loop
      vertex  -9.257729e+00  3.471375e-04  6.134778e+00
      vertex  -9.401338e+00  4.816837e-01  6.855623e+00
      vertex  -9.256581e+00  4.951496e-01  6.135331e+00
    endloop
  endfacet
  facet normal  5.914801e-02 -9.814883e-01  1.821601e-01
    outer loop
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
      vertex   2.357441e+00 -2.180988e+00  1.749155e+01
      vertex   2.741342e+00 -2.180990e+00  1.736688e+01
    endloop
  endfacet
  facet normal  2.518969e-01 -9.555703e-01  1.530796e-01
    outer loop
      vertex   7.658683e+00 -2.654942e+00  6.497281e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
      vertex   7.903616e+00 -2.533827e+00  6.850272e+00
    endloop
  endfacet
  facet normal -1.799306e-01  9.048522e-01  3.858336e-01
    outer loop
      vertex  -3.186596e+00  2.138090e+00  1.738905e+01
      vertex  -4.120495e+00  1.950171e+00  1.739424e+01
      vertex  -3.337810e+00  1.950125e+00  1.775935e+01
    endloop
  endfacet
  facet normal -2.446684e-02  4.279282e-05  9.997006e-01
    outer loop
      vertex   4.041913e-01 -6.678841e+00  1.334873e+00
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
      vertex   8.787063e-05 -6.690313e+00  1.324984e+00
    endloop
  endfacet
  facet normal  2.714739e-01 -9.288970e-01  2.518972e-01
    outer loop
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
      vertex   6.051597e+00 -2.181005e+00  1.519523e+01
    endloop
  endfacet
  facet normal -8.177121e-01  4.867487e-01  3.072826e-01
    outer loop
      vertex  -8.559678e+00  1.468428e+00  1.328400e+01
      vertex  -8.880441e+00  1.468477e+00  1.243033e+01
      vertex  -9.028855e+00  1.189133e+00  1.247788e+01
    endloop
  endfacet
  facet normal  2.772079e-01 -9.370409e-01  2.123913e-01
    outer loop
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
      vertex   6.561598e+00 -2.181007e+00  1.458984e+01
    endloop
  endfacet
  facet normal  8.717976e-01  4.690488e-01 -1.412872e-01
    outer loop
      vertex   8.848385e+00  1.867100e+00  6.140252e+00
      vertex   9.214503e+00  1.401918e+00  6.855026e+00
      vertex   9.075440e+00  1.444485e+00  6.138266e+00
    endloop
  endfacet
  facet normal  6.090972e-01  7.930138e-01 -1.138848e-02
    outer loop
      vertex   8.197143e+00  2.494410e+00  6.145931e+00
      vertex   8.666203e+00  2.144281e+00  6.852543e+00
      vertex   8.548699e+00  2.224340e+00  6.142745e+00
    endloop
  endfacet
  facet normal  3.996867e-01 -9.042541e-01  1.502502e-01
    outer loop
      vertex   8.413611e+00 -1.948362e+00  1.228117e+01
      vertex   7.741767e+00 -2.137351e+00  1.293098e+01
      vertex   8.032036e+00 -2.137334e+00  1.215893e+01
    endloop
  endfacet
  facet normal  1.651603e-01 -9.814904e-01  9.694652e-02
    outer loop
      vertex   7.250019e+00 -2.174259e+00  1.360038e+01
      vertex   7.015382e+00 -2.181009e+00  1.393177e+01
      vertex   7.219731e+00 -2.181011e+00  1.358362e+01
    endloop
  endfacet
  facet normal -6.809580e-01 -7.323087e-01 -4.495438e-03
    outer loop
      vertex  -8.756927e+00 -2.077204e+00  7.572257e+00
      vertex  -8.816321e+00 -2.026443e+00  8.300373e+00
      vertex  -9.146712e+00 -1.719254e+00  8.305818e+00
    endloop
  endfacet
  facet normal  9.380078e-01  2.778565e-01 -2.072127e-01
    outer loop
      vertex   8.906188e+00  1.486849e+00  5.428903e+00
      vertex   9.075440e+00  1.444485e+00  6.138266e+00
      vertex   9.212695e+00  9.799118e-01  6.136631e+00
    endloop
  endfacet
  facet normal  2.448159e-01 -9.572873e-01  1.538381e-01
    outer loop
      vertex   7.250019e+00 -2.174259e+00  1.360038e+01
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
      vertex   7.015382e+00 -2.181009e+00  1.393177e+01
    endloop
  endfacet
  facet normal  8.748251e-01  7.567383e-02 -4.784919e-01
    outer loop
      vertex   7.370080e+00  4.802914e-01  1.242837e+00
      vertex   7.000476e+00  4.469490e-01  5.618172e-01
      vertex   6.963074e+00  8.865833e-01  5.629635e-01
    endloop
  endfacet
  facet normal  8.452364e-01  3.001650e-01  4.421272e-01
    outer loop
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
      vertex   7.219731e+00 -2.181011e+00  1.358362e+01
      vertex   7.406844e+00 -2.181011e+00  1.322591e+01
    endloop
  endfacet
  facet normal  3.478357e-01 -9.328478e-01  9.383593e-02
    outer loop
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
      vertex   7.974292e+00 -2.181013e+00  1.171663e+01
    endloop
  endfacet
  facet normal  2.390576e-01 -9.709228e-01  1.266064e-02
    outer loop
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
      vertex   8.268659e+00 -2.178129e+00  9.753622e+00
    endloop
  endfacet
  facet normal  4.253871e-01 -9.045239e-01  2.970557e-02
    outer loop
      vertex   8.776464e+00 -1.948257e+00  1.061073e+01
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
      vertex   8.833118e+00 -1.949384e+00  9.765130e+00
    endloop
  endfacet
  facet normal  6.467451e-01 -7.613925e-01  4.474616e-02
    outer loop
      vertex   9.111837e+00 -1.660636e+00  1.064991e+01
      vertex   8.833118e+00 -1.949384e+00  9.765130e+00
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
    endloop
  endfacet
  facet normal  6.798239e-02 -9.814861e-01  1.790625e-01
    outer loop
      vertex   3.131773e+00 -2.174252e+00  1.725559e+01
      vertex   2.741342e+00 -2.180990e+00  1.736688e+01
      vertex   3.118692e+00 -2.180992e+00  1.722361e+01
    endloop
  endfacet
  facet normal -7.733043e-01  6.208215e-01  1.287680e-01
    outer loop
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
      vertex  -9.110337e+00  1.662560e+00  1.064925e+01
      vertex  -9.263100e+00  1.468576e+00  1.066709e+01
    endloop
  endfacet
  facet normal -3.596535e-01 -9.168947e-01  1.730706e-01
    outer loop
      vertex  -7.276982e+00 -2.938496e+00  5.680944e+00
      vertex  -7.385486e+00 -2.856359e+00  5.890606e+00
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
    endloop
  endfacet
  facet normal  9.976231e-01 -3.034932e-03  6.883961e-02
    outer loop
      vertex   9.563832e+00  4.439163e-01  1.070271e+01
      vertex   9.562493e+00  2.565384e-04  1.070256e+01
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
    endloop
  endfacet
  facet normal  9.474758e-01 -3.130692e-01  6.540071e-02
    outer loop
      vertex   9.517684e+00 -8.844261e-01  1.069732e+01
      vertex   9.417737e+00 -1.189346e+00  1.068564e+01
      vertex   9.480363e+00 -1.189333e+00  9.778431e+00
    endloop
  endfacet
  facet normal  8.498240e-01 -2.975913e-03  5.270582e-01
    outer loop
      vertex   8.421620e+00  4.439945e-01  1.424919e+01
      vertex   7.925389e+00  4.440155e-01  1.504931e+01
      vertex   7.924301e+00  3.509521e-04  1.504856e+01
    endloop
  endfacet
  facet normal -3.896734e-01  9.206558e-01 -2.339864e-02
    outer loop
      vertex  -3.163172e+00  5.996607e+00  1.805202e+00
      vertex  -3.170523e+00  5.997377e+00  1.957937e+00
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
    endloop
  endfacet
  facet normal -1.564339e-01  9.876847e-01 -2.697210e-03
    outer loop
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
      vertex   1.011927e+00 -5.480871e+00 -3.873638e-16
    endloop
  endfacet
  facet normal  6.031656e-02 -9.977173e-01 -3.036624e-02
    outer loop
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
      vertex   8.043078e-01 -6.628206e+00 -3.209238e-17
    endloop
  endfacet
  facet normal  2.393169e-01 -9.707335e-01  2.009647e-02
    outer loop
      vertex   8.378459e+00 -2.137298e+00  1.056425e+01
      vertex   8.216428e+00 -2.177635e+00  1.054533e+01
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
    endloop
  endfacet
  facet normal  3.595023e-14  1.809913e-14 -1.000000e+00
    outer loop
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
      vertex   3.890146e+00 -3.963536e+00 -1.120631e-15
      vertex   3.914279e+00 -3.940507e+00  1.637579e-16
    endloop
  endfacet
  facet normal  2.173870e-03 -9.990048e-01  4.455119e-02
    outer loop
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex   3.955427e-01  2.181280e+00  1.782582e+01
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
    endloop
  endfacet
  facet normal  7.821407e-01 -6.207623e-01  5.394508e-02
    outer loop
      vertex   9.261893e+00 -1.470047e+00  1.066743e+01
      vertex   9.111837e+00 -1.660636e+00  1.064991e+01
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
    endloop
  endfacet
  facet normal  8.710677e-01 -4.874693e-01  6.012361e-02
    outer loop
      vertex   9.417737e+00 -1.189346e+00  1.068564e+01
      vertex   9.323505e+00 -1.470018e+00  9.775237e+00
      vertex   9.480363e+00 -1.189333e+00  9.778431e+00
    endloop
  endfacet
  facet normal  8.722534e-01  2.059007e-02 -4.886204e-01
    outer loop
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
      vertex   6.687155e+00  3.876799e-01  7.355228e-17
      vertex   7.000476e+00  4.469490e-01  5.618172e-01
    endloop
  endfacet
  facet normal  9.976235e-01  2.842023e-03  6.884320e-02
    outer loop
      vertex   9.562493e+00  2.565384e-04  1.070256e+01
      vertex   9.563747e+00 -4.434700e-01  1.070270e+01
      vertex   9.627322e+00 -4.434872e-01  9.781425e+00
    endloop
  endfacet
  facet normal  9.471964e-01 -7.434991e-03 -3.205679e-01
    outer loop
      vertex   8.638652e+00 -5.277958e-01  4.017734e+00
      vertex   8.642137e+00 -8.125305e-04  4.015808e+00
      vertex   8.875030e+00 -5.201473e-01  4.715992e+00
    endloop
  endfacet
  facet normal  9.251581e-01  2.385628e-01 -2.952460e-01
    outer loop
      vertex   8.479278e+00  1.546875e+00  4.031898e+00
      vertex   8.707416e+00  1.522598e+00  4.727156e+00
      vertex   8.832343e+00  1.029762e+00  4.720400e+00
    endloop
  endfacet
  facet normal -4.454406e-01  8.946795e-01  3.363209e-02
    outer loop
      vertex  -8.815278e+00  2.027315e+00  8.300351e+00
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
    endloop
  endfacet
  facet normal  2.994248e-02 -9.989816e-01  3.375153e-02
    outer loop
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   5.486000e+00  2.181242e+00  1.574896e+01
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
    endloop
  endfacet
  facet normal -8.203949e-01  5.018682e-01 -2.740080e-01
    outer loop
      vertex  -8.048572e+00  2.035978e+00  3.357002e+00
      vertex  -8.289346e+00  2.017138e+00  4.043384e+00
      vertex  -8.038638e+00  2.434683e+00  4.057520e+00
    endloop
  endfacet
  facet normal -5.602854e-01 -3.133919e-01  7.667240e-01
    outer loop
      vertex  -5.276351e+00 -8.839722e-01  1.757950e+01
      vertex  -6.018261e+00 -8.839493e-01  1.703736e+01
      vertex  -5.954819e+00 -1.189575e+00  1.695880e+01
    endloop
  endfacet
  facet normal  6.367732e-01  7.703313e-01 -3.330908e-02
    outer loop
      vertex   5.311325e+00  4.662725e+00  2.075060e+00
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   6.017262e+00  4.093054e+00  2.395866e+00
    endloop
  endfacet
  facet normal  2.397656e-02 -9.988853e-01  4.066120e-02
    outer loop
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
      vertex   4.202503e+00  2.181250e+00  1.668565e+01
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
    endloop
  endfacet
  facet normal -1.536041e-01 -9.655125e-01  2.102179e-01
    outer loop
      vertex  -4.870266e+00 -2.180956e+00  1.624568e+01
      vertex  -4.564079e+00 -2.174232e+00  1.650029e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
    endloop
  endfacet
  facet normal  1.896393e-02 -9.989921e-01  4.068542e-02
    outer loop
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   3.488590e+00  2.181257e+00  1.706202e+01
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
    endloop
  endfacet
  facet normal -4.800674e-02 -2.851287e-03  9.988429e-01
    outer loop
      vertex  -1.942747e-04  4.442348e-01  1.920913e+01
      vertex  -9.223928e-01  4.442577e-01  1.916481e+01
      vertex  -9.222730e-01  5.807877e-04  1.916355e+01
    endloop
  endfacet
  facet normal  5.090369e-01 -2.919251e-03  8.607397e-01
    outer loop
      vertex   5.301584e+00  4.441013e-01  1.761840e+01
      vertex   4.491253e+00  4.441223e-01  1.809762e+01
      vertex   4.490647e+00  4.520416e-04  1.809648e+01
    endloop
  endfacet
  facet normal  4.048622e-02 -9.989811e-01  1.994083e-02
    outer loop
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.406849e+00  2.181223e+00  1.322590e+01
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
    endloop
  endfacet
  facet normal  6.473548e-01  7.608874e-01  4.452075e-02
    outer loop
      vertex   8.775695e+00  1.949236e+00  1.061064e+01
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
      vertex   8.832999e+00  1.949952e+00  9.765159e+00
    endloop
  endfacet
  facet normal -5.747301e-01  4.808322e-04 -8.183429e-01
    outer loop
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
      vertex   4.869976e+00  2.181246e+00  1.624597e+01
      vertex   4.544808e+00 -2.180998e+00  1.647177e+01
    endloop
  endfacet
  facet normal  6.466398e-01  7.614707e-01  4.493640e-02
    outer loop
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
      vertex   9.171400e+00  1.661978e+00  9.775407e+00
      vertex   8.832999e+00  1.949952e+00  9.765159e+00
    endloop
  endfacet
  facet normal  9.921045e-01  1.050780e-01  6.846280e-02
    outer loop
      vertex   9.517658e+00  8.848133e-01  1.069732e+01
      vertex   9.627390e+00  4.457207e-01  9.781108e+00
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
    endloop
  endfacet
  facet normal -1.762075e-01 -9.706835e-01  1.634762e-01
    outer loop
      vertex  -5.901175e+00 -2.137655e+00  1.560662e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
    endloop
  endfacet
  facet normal -9.999869e-01 -1.889366e-03  4.754034e-03
    outer loop
      vertex  -9.629494e+00  6.732941e-04  9.045976e+00
      vertex  -9.626000e+00  7.368724e-04  9.780801e+00
      vertex  -9.630352e+00  4.547825e-01  9.045909e+00
    endloop
  endfacet
  facet normal  9.368524e-01 -3.130865e-01  1.558346e-01
    outer loop
      vertex   9.366902e+00 -8.844090e-01  1.160383e+01
      vertex   9.268517e+00 -1.189360e+00  1.158263e+01
      vertex   9.517684e+00 -8.844261e-01  1.069732e+01
    endloop
  endfacet
  facet normal  7.133174e-01 -6.986616e-01 -5.522956e-02
    outer loop
      vertex   8.236308e+00 -2.380280e+00  4.747092e+00
      vertex   8.071296e+00 -2.604301e+00  5.449783e+00
      vertex   7.920142e+00 -2.704113e+00  4.760183e+00
    endloop
  endfacet
  facet normal  6.189964e-01 -2.043493e-04  7.853938e-01
    outer loop
      vertex  -5.159912e+00 -4.676804e+00  3.135705e+00
      vertex  -5.020278e+00 -2.201843e+00  3.026298e+00
      vertex  -5.207044e+00 -1.683388e+00  3.173630e+00
    endloop
  endfacet
  facet normal -3.824458e-01 -7.614486e-01  5.233845e-01
    outer loop
      vertex  -5.050360e+00 -1.662342e+00  1.723709e+01
      vertex  -5.548426e+00 -1.949358e+00  1.645558e+01
      vertex  -4.864460e+00 -1.949308e+00  1.695544e+01
    endloop
  endfacet
  facet normal -8.521270e-01  3.130351e-01  4.193905e-01
    outer loop
      vertex  -8.293319e+00  1.189035e+00  1.417769e+01
      vertex  -8.702725e+00  1.189085e+00  1.334581e+01
      vertex  -8.794720e+00  8.854065e-01  1.338556e+01
    endloop
  endfacet
  facet normal  2.352178e-01  9.718065e-01  1.626570e-02
    outer loop
      vertex   8.377821e+00  2.137769e+00  1.056418e+01
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
      vertex   8.255627e+00  2.180864e+00  9.756488e+00
    endloop
  endfacet
  facet normal  7.635312e-15  4.641213e-15 -1.000000e+00
    outer loop
      vertex   1.011927e+00 -5.480871e+00 -3.873638e-16
      vertex   1.072319e+00 -5.471157e+00  1.188286e-16
      vertex   1.427193e+00 -6.511893e+00 -2.001871e-15
    endloop
  endfacet
  facet normal  5.924953e-01  8.055558e-01 -5.393607e-03
    outer loop
      vertex  -3.088347e+00 -4.607609e+00  1.924301e+00
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
    endloop
  endfacet
  facet normal -9.759788e-17  5.744938e-16 -1.000000e+00
    outer loop
      vertex   4.911027e+00  2.571886e+00  1.632953e-16
      vertex   5.917587e+00  3.116910e+00  3.781697e-16
      vertex   6.097925e+00  2.755002e+00  1.526557e-16
    endloop
  endfacet
  facet normal  3.301619e-01 -7.611443e-01  5.582585e-01
    outer loop
      vertex   5.050582e+00 -1.661374e+00  1.723807e+01
      vertex   4.278577e+00 -1.661456e+00  1.769453e+01
      vertex   4.121053e+00 -1.948767e+00  1.739597e+01
    endloop
  endfacet
  facet normal  2.350673e-01  9.718426e-01  1.629040e-02
    outer loop
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.377821e+00  2.137769e+00  1.056418e+01
      vertex   8.255627e+00  2.180864e+00  9.756488e+00
    endloop
  endfacet
  facet normal -6.391888e-01 -7.616656e-01  1.063167e-01
    outer loop
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
      vertex  -8.635535e+00 -1.949717e+00  1.144582e+01
    endloop
  endfacet
  facet normal -9.118276e-01  2.180794e-01 -3.478675e-01
    outer loop
      vertex  -8.332305e+00  1.050993e+00  3.334660e+00
      vertex  -8.596299e+00  1.045643e+00  4.023285e+00
      vertex  -8.479411e+00  1.548126e+00  4.031908e+00
    endloop
  endfacet
  facet normal -6.387756e-01 -7.619858e-01  1.065049e-01
    outer loop
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
      vertex  -9.108448e+00 -1.664360e+00  1.064903e+01
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
    endloop
  endfacet
  facet normal  9.400463e-01  2.596179e-01 -2.211596e-01
    outer loop
      vertex   8.906188e+00  1.486849e+00  5.428903e+00
      vertex   9.212695e+00  9.799118e-01  6.136631e+00
      vertex   9.037666e+00  1.007128e+00  5.424614e+00
    endloop
  endfacet
  facet normal -5.208132e-01 -6.211393e-01  5.856104e-01
    outer loop
      vertex  -5.856068e+00 -1.470623e+00  1.683652e+01
      vertex  -6.417627e+00 -1.662502e+00  1.613357e+01
      vertex  -5.760451e+00 -1.662422e+00  1.671812e+01
    endloop
  endfacet
  facet normal -7.732916e-01 -6.208724e-01  1.285986e-01
    outer loop
      vertex  -9.114491e+00 -1.470814e+00  1.154900e+01
      vertex  -9.261168e+00 -1.470842e+00  1.066687e+01
      vertex  -9.110768e+00 -1.661802e+00  1.064930e+01
    endloop
  endfacet
  facet normal -3.119940e-01  9.049211e-01  2.894436e-01
    outer loop
      vertex  -5.900717e+00  2.138166e+00  1.560617e+01
      vertex  -6.450688e+00  2.138182e+00  1.501330e+01
      vertex  -6.756639e+00  1.950357e+00  1.527073e+01
    endloop
  endfacet
  facet normal -9.367223e-01 -3.135121e-01  1.557612e-01
    outer loop
      vertex  -9.367053e+00 -8.838062e-01  1.160342e+01
      vertex  -9.417384e+00 -1.189667e+00  1.068511e+01
      vertex  -9.268229e+00 -1.189653e+00  1.158213e+01
    endloop
  endfacet
  facet normal -7.370085e-01 -6.739681e-01  5.084739e-02
    outer loop
      vertex  -9.110768e+00 -1.661802e+00  1.064930e+01
      vertex  -9.169969e+00 -1.663280e+00  9.771631e+00
      vertex  -9.108448e+00 -1.664360e+00  1.064903e+01
    endloop
  endfacet
  facet normal  8.498303e-01  2.883571e-03  5.270486e-01
    outer loop
      vertex   8.420458e+00  3.309250e-04  1.424855e+01
      vertex   7.925358e+00 -4.433708e-01  1.504929e+01
      vertex   8.421578e+00 -4.433918e-01  1.424917e+01
    endloop
  endfacet
  facet normal -9.367232e-01 -3.135098e-01  1.557605e-01
    outer loop
      vertex  -9.367053e+00 -8.838062e-01  1.160342e+01
      vertex  -9.517808e+00 -8.837872e-01  1.069684e+01
      vertex  -9.417384e+00 -1.189667e+00  1.068511e+01
    endloop
  endfacet
  facet normal -7.459152e-01 -3.830819e-03 -6.660299e-01
    outer loop
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
      vertex   6.051607e+00  2.181234e+00  1.519522e+01
    endloop
  endfacet
  facet normal  5.867206e-01  1.047318e-01  8.029882e-01
    outer loop
      vertex   6.017879e+00  8.849792e-01  1.703752e+01
      vertex   5.301584e+00  4.441013e-01  1.761840e+01
      vertex   6.047083e+00  4.440784e-01  1.707369e+01
    endloop
  endfacet
  facet normal -2.384783e-01  3.038726e-03  9.711430e-01
    outer loop
      vertex  -1.835874e+00  6.017685e-04  1.903121e+01
      vertex  -2.749995e+00  6.237030e-04  1.880673e+01
      vertex  -2.750383e+00 -4.430866e-01  1.880802e+01
    endloop
  endfacet
  facet normal  1.361133e-01  3.129981e-01  9.399496e-01
    outer loop
      vertex   1.807832e+00  1.188396e+00  1.888868e+01
      vertex   9.079884e-01  1.188446e+00  1.901897e+01
      vertex   9.175743e-01  8.851166e-01  1.911859e+01
    endloop
  endfacet
  facet normal  8.718865e-01  4.859976e-01  6.016783e-02
    outer loop
      vertex   9.263976e+00  1.467035e+00  1.066768e+01
      vertex   9.418399e+00  1.187765e+00  1.068572e+01
      vertex   9.481034e+00  1.187719e+00  9.778445e+00
    endloop
  endfacet
  facet normal  7.857872e-01  4.896967e-01 -3.778038e-01
    outer loop
      vertex   6.542725e+00  3.050726e+00  1.277834e+00
      vertex   6.762638e+00  2.691202e+00  1.269223e+00
      vertex   6.294444e+00  2.906713e+00  5.747747e-01
    endloop
  endfacet
  facet normal -3.110605e-02 -7.613118e-01  6.476394e-01
    outer loop
      vertex  -1.906334e-04 -1.661858e+00  1.875303e+01
      vertex  -8.786781e-01 -1.661938e+00  1.871074e+01
      vertex  -8.463282e-01 -1.949060e+00  1.837478e+01
    endloop
  endfacet
  facet normal -9.864506e-01  3.179194e-03  1.640279e-01
    outer loop
      vertex  -9.411016e+00  8.449554e-04  1.161289e+01
      vertex  -9.562470e+00  8.621216e-04  1.070205e+01
      vertex  -9.563873e+00 -4.428368e-01  1.070222e+01
    endloop
  endfacet
  facet normal  8.151711e-02 -9.693923e-01  2.315894e-01
    outer loop
      vertex   3.186728e+00 -2.137477e+00  1.739015e+01
      vertex   2.408868e+00 -2.137492e+00  1.766389e+01
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
    endloop
  endfacet
  facet normal -8.616712e-01  4.868147e-01  1.432980e-01
    outer loop
      vertex  -9.116395e+00  1.468527e+00  1.154942e+01
      vertex  -9.263100e+00  1.468576e+00  1.066709e+01
      vertex  -9.417916e+00  1.189226e+00  1.068517e+01
    endloop
  endfacet
  facet normal -3.690194e-01 -4.876439e-01  7.912193e-01
    outer loop
      vertex  -3.582696e+00 -1.189545e+00  1.835902e+01
      vertex  -4.422828e+00 -1.189554e+00  1.796718e+01
      vertex  -4.349491e+00 -1.470572e+00  1.782819e+01
    endloop
  endfacet
  facet normal  9.190007e-01  8.936960e-08  3.942559e-01
    outer loop
      vertex  -7.511187e+00  2.762133e+00  6.153776e+00
      vertex  -7.658592e+00 -2.655830e+00  6.497374e+00
      vertex  -7.511179e+00 -2.763084e+00  6.153759e+00
    endloop
  endfacet
  facet normal  9.899870e-01 -9.756342e-02 -1.020150e-01
    outer loop
      vertex   9.514075e+00 -4.690056e-01  7.582161e+00
      vertex   9.545779e+00 -9.112930e-01  8.312814e+00
      vertex   9.468694e+00 -9.287109e-01  7.581409e+00
    endloop
  endfacet
  facet normal -7.276516e-01  6.751877e-01  1.210153e-01
    outer loop
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
      vertex  -9.107553e+00  1.665619e+00  1.064893e+01
      vertex  -9.110337e+00  1.662560e+00  1.064925e+01
    endloop
  endfacet
  facet normal -6.379052e-01  7.627730e-01  1.060860e-01
    outer loop
      vertex  -8.634320e+00  1.950586e+00  1.144556e+01
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
      vertex  -9.107553e+00  1.665619e+00  1.064893e+01
    endloop
  endfacet
  facet normal -3.611280e-01 -1.168934e-03  9.325155e-01
    outer loop
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
      vertex   3.088440e+00  4.607893e+00  1.924301e+00
      vertex   3.169260e+00  5.993425e+00  1.957336e+00
    endloop
  endfacet
  facet normal  4.834726e-01  3.129636e-01  8.175011e-01
    outer loop
      vertex   5.220885e+00  1.188196e+00  1.749611e+01
      vertex   4.469564e+00  8.850250e-01  1.805651e+01
      vertex   5.275980e+00  8.850021e-01  1.757960e+01
    endloop
  endfacet
  facet normal -1.651839e-01 -9.814869e-01  9.694234e-02
    outer loop
      vertex  -7.015543e+00 -2.180944e+00  1.393137e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
      vertex  -7.219871e+00 -2.180944e+00  1.358320e+01
    endloop
  endfacet
  facet normal -4.080308e-01 -9.098415e-01 -7.549414e-02
    outer loop
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
      vertex  -3.081993e+00 -5.919403e+00  2.393918e-16
      vertex  -2.354590e+00 -6.245616e+00 -4.946853e-16
    endloop
  endfacet
  facet normal  7.042838e-01  7.095809e-01 -2.188952e-02
    outer loop
      vertex   8.666203e+00  2.144281e+00  6.852543e+00
      vertex   8.755881e+00  2.077475e+00  7.572239e+00
      vertex   9.078284e+00  1.757601e+00  7.576207e+00
    endloop
  endfacet
  facet normal  6.361728e-01 -2.872463e-04  7.715465e-01
    outer loop
      vertex  -5.158133e+00  4.673937e+00  3.134282e+00
      vertex  -5.344672e+00  4.515985e+00  3.288033e+00
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
    endloop
  endfacet
  facet normal  7.308978e-01 -5.887740e-01 -3.451571e-01
    outer loop
      vertex   7.040828e+00 -2.826899e+00  1.973431e+00
      vertex   7.189068e+00 -2.859085e+00  2.342245e+00
      vertex   6.914867e+00 -3.202835e+00  2.347976e+00
    endloop
  endfacet
  facet normal -5.051404e-01 -8.630345e-01 -2.163327e-03
    outer loop
      vertex   2.702310e+00  4.853266e+00  1.779746e+00
      vertex   2.532637e+00  4.957038e+00 -2.247706e-16
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
    endloop
  endfacet
  facet normal -2.320180e-01 -9.707227e-01  6.216903e-02
    outer loop
      vertex  -8.030813e+00 -2.137737e+00  1.215816e+01
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
    endloop
  endfacet
  facet normal -2.319842e-01 -9.707310e-01  6.216705e-02
    outer loop
      vertex  -8.030813e+00 -2.137737e+00  1.215816e+01
      vertex  -8.244216e+00 -2.137755e+00  1.136154e+01
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
    endloop
  endfacet
  facet normal  9.173762e-01 -3.130574e-01  2.457969e-01
    outer loop
      vertex   9.366902e+00 -8.844090e-01  1.160383e+01
      vertex   9.028557e+00 -1.189371e+00  1.247821e+01
      vertex   9.268517e+00 -1.189360e+00  1.158263e+01
    endloop
  endfacet
  facet normal -6.259442e-01 -7.616239e-01  1.676990e-01
    outer loop
      vertex  -8.733365e+00 -1.662915e+00  1.238321e+01
      vertex  -8.635535e+00 -1.949717e+00  1.144582e+01
      vertex  -8.412040e+00 -1.949663e+00  1.228027e+01
    endloop
  endfacet
  facet normal  9.909559e-01  1.126298e-07  1.341878e-01
    outer loop
      vertex  -8.203500e+00  2.272688e+00  8.653869e+00
      vertex  -8.203500e+00 -2.272165e+00  8.653872e+00
      vertex  -8.154238e+00 -2.311592e+00  8.290080e+00
    endloop
  endfacet
  facet normal -9.935771e-01  1.012688e-01 -5.048990e-02
    outer loop
      vertex  -9.591422e+00  4.617844e-01  8.313846e+00
      vertex  -9.584052e+00  8.985672e-01  9.044879e+00
      vertex  -9.545411e+00  9.126930e-01  8.312806e+00
    endloop
  endfacet
  facet normal -6.259350e-01 -7.616308e-01  1.677020e-01
    outer loop
      vertex  -8.733365e+00 -1.662915e+00  1.238321e+01
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
      vertex  -8.635535e+00 -1.949717e+00  1.144582e+01
    endloop
  endfacet
  facet normal -2.977062e-16  3.962136e-16 -1.000000e+00
    outer loop
      vertex  -5.501915e+00  3.793403e+00  3.122502e-16
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
    endloop
  endfacet
  facet normal -7.521870e-01 -5.966381e-01 -2.797101e-01
    outer loop
      vertex  -5.620892e+00 -3.918224e+00  5.863695e-01
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
    endloop
  endfacet
  facet normal -3.765068e-02  6.205015e-01  7.833010e-01
    outer loop
      vertex  -1.770278e-04  1.662657e+00  1.875255e+01
      vertex  -8.786176e-01  1.662752e+00  1.871025e+01
      vertex  -8.934164e-01  1.467857e+00  1.886393e+01
    endloop
  endfacet
  facet normal -4.677163e-01 -8.778118e-01  1.033828e-01
    outer loop
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
      vertex  -7.574894e+00 -2.945297e+00  4.775242e+00
    endloop
  endfacet
  facet normal  9.034002e-01  1.868933e-01 -3.859261e-01
    outer loop
      vertex   7.942900e+00  1.551197e+00  2.664423e+00
      vertex   8.332925e+00  1.049910e+00  3.334658e+00
      vertex   8.043606e+00  1.044596e+00  2.654828e+00
    endloop
  endfacet
  facet normal -8.734124e-01 -2.317742e-02 -4.864294e-01
    outer loop
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
      vertex  -6.697911e+00  7.241169e-03  9.298118e-16
      vertex  -6.687660e+00 -3.790381e-01  5.898060e-17
    endloop
  endfacet
  facet normal -6.993566e-01  6.362358e-01 -3.257366e-01
    outer loop
      vertex  -6.304759e+00  3.389902e+00  1.287535e+00
      vertex  -6.411795e+00  3.454931e+00  1.644359e+00
      vertex  -5.860100e+00  4.076109e+00  1.673166e+00
    endloop
  endfacet
  facet normal -7.569473e-01 -6.212196e-01  2.027731e-01
    outer loop
      vertex  -8.878583e+00 -1.470785e+00  1.242973e+01
      vertex  -9.114491e+00 -1.470814e+00  1.154900e+01
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
    endloop
  endfacet
  facet normal -1.059159e-15  2.874344e-15 -1.000000e+00
    outer loop
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
      vertex   6.594516e+00 -1.186593e+00 -2.079145e-15
      vertex   6.513909e+00 -1.572044e+00 -3.101686e-15
    endloop
  endfacet
  facet normal -8.432675e-01 -4.877228e-01  2.258901e-01
    outer loop
      vertex  -9.028337e+00 -1.189642e+00  1.247771e+01
      vertex  -9.114491e+00 -1.470814e+00  1.154900e+01
      vertex  -8.878583e+00 -1.470785e+00  1.242973e+01
    endloop
  endfacet
  facet normal  3.948875e-01  9.177247e-01 -4.295621e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
      vertex   2.363800e+00  6.274577e+00  6.326923e-01
    endloop
  endfacet
  facet normal -4.003225e-01  2.201488e-07 -9.163744e-01
    outer loop
      vertex   3.488590e+00  2.181257e+00  1.706202e+01
      vertex   3.488575e+00 -2.180994e+00  1.706203e+01
      vertex   3.118692e+00 -2.180992e+00  1.722361e+01
    endloop
  endfacet
  facet normal -9.172561e-01 -3.134839e-01  2.457013e-01
    outer loop
      vertex  -9.124593e+00 -8.838253e-01  1.250855e+01
      vertex  -9.367053e+00 -8.838062e-01  1.160342e+01
      vertex  -9.268229e+00 -1.189653e+00  1.158213e+01
    endloop
  endfacet
  facet normal  8.324238e-01  3.532424e-01 -4.269548e-01
    outer loop
      vertex   6.482162e+00  2.540468e+00  5.716410e-01
      vertex   6.256312e+00  2.381761e+00 -4.475587e-16
      vertex   6.097925e+00  2.755002e+00  1.526557e-16
    endloop
  endfacet
  facet normal  8.555837e-01  7.801871e-08  5.176645e-01
    outer loop
      vertex  -6.959301e+00  3.184469e+00  5.138667e+00
      vertex  -7.163385e+00 -3.026060e+00  5.475973e+00
      vertex  -6.959290e+00 -3.187130e+00  5.138649e+00
    endloop
  endfacet
  facet normal  8.340696e-01  3.282150e-01 -4.433991e-01
    outer loop
      vertex   6.957979e+00  2.296583e+00  1.261688e+00
      vertex   7.122206e+00  1.870544e+00  1.255249e+00
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
    endloop
  endfacet
  facet normal -5.746580e-01  6.209537e-01  5.330897e-01
    outer loop
      vertex  -6.417213e+00  1.663426e+00  1.613317e+01
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
      vertex  -7.133762e+00  1.468275e+00  1.558806e+01
    endloop
  endfacet
  facet normal -8.172177e-01 -4.877031e-01  3.070846e-01
    outer loop
      vertex  -9.028337e+00 -1.189642e+00  1.247771e+01
      vertex  -8.878583e+00 -1.470785e+00  1.242973e+01
      vertex  -8.702224e+00 -1.189629e+00  1.334559e+01
    endloop
  endfacet
  facet normal  2.553635e-16 -2.935409e-16 -1.000000e+00
    outer loop
      vertex   2.553920e+00 -4.945607e+00 -2.782992e-16
      vertex   3.029783e+00 -4.664573e+00 -2.392762e-16
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
    endloop
  endfacet
  facet normal -9.659407e-01  3.162617e-03  2.587442e-01
    outer loop
      vertex  -9.167421e+00  8.258820e-04  1.252227e+01
      vertex  -9.411016e+00  8.449554e-04  1.161289e+01
      vertex  -9.412389e+00 -4.428558e-01  1.161319e+01
    endloop
  endfacet
  facet normal -9.606341e-01  1.047257e-01  2.573220e-01
    outer loop
      vertex  -9.124299e+00  8.854256e-01  1.250846e+01
      vertex  -9.366744e+00  8.854465e-01  1.160335e+01
      vertex  -9.412189e+00  4.445343e-01  1.161314e+01
    endloop
  endfacet
  facet normal  9.921651e-01 -1.045005e-01  6.846853e-02
    outer loop
      vertex   9.563747e+00 -4.434700e-01  1.070270e+01
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
      vertex   9.627322e+00 -4.434872e-01  9.781425e+00
    endloop
  endfacet
  facet normal  8.922963e-01 -1.044728e-01  4.391956e-01
    outer loop
      vertex   8.837360e+00 -4.434109e-01  1.340443e+01
      vertex   8.381008e+00 -8.843479e-01  1.422670e+01
      vertex   8.794788e+00 -8.843689e-01  1.338603e+01
    endloop
  endfacet
  facet normal -9.173943e-01  3.130452e-01  2.457445e-01
    outer loop
      vertex  -9.124299e+00  8.854256e-01  1.250846e+01
      vertex  -9.028855e+00  1.189133e+00  1.247788e+01
      vertex  -9.366744e+00  8.854465e-01  1.160335e+01
    endloop
  endfacet
  facet normal -9.173957e-01  3.130392e-01  2.457471e-01
    outer loop
      vertex  -9.268758e+00  1.189178e+00  1.158224e+01
      vertex  -9.366744e+00  8.854465e-01  1.160335e+01
      vertex  -9.028855e+00  1.189133e+00  1.247788e+01
    endloop
  endfacet
  facet normal -5.373767e-01 -2.501410e-04  8.433424e-01
    outer loop
      vertex   4.341982e+00 -5.317970e+00  2.558578e+00
      vertex   4.533190e+00 -5.176903e+00  2.680458e+00
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
    endloop
  endfacet
  facet normal  7.608957e-01 -6.384729e-01 -1.157153e-01
    outer loop
      vertex   8.691527e+00 -1.928049e+00  5.434463e+00
      vertex   8.849883e+00 -1.867241e+00  6.140228e+00
      vertex   8.550247e+00 -2.224781e+00  6.142717e+00
    endloop
  endfacet
  facet normal -8.437789e-01  4.867693e-01  2.260372e-01
    outer loop
      vertex  -9.268758e+00  1.189178e+00  1.158224e+01
      vertex  -9.028855e+00  1.189133e+00  1.247788e+01
      vertex  -8.880441e+00  1.468477e+00  1.243033e+01
    endloop
  endfacet
  facet normal  5.371515e-01 -8.398249e-01  7.850108e-02
    outer loop
      vertex   4.145314e+00 -5.454771e+00  2.440770e+00
      vertex   4.642581e+00 -5.167072e+00  2.116041e+00
      vertex   4.341982e+00 -5.317970e+00  2.558578e+00
    endloop
  endfacet
  facet normal  9.606208e-01  1.047317e-01  2.573695e-01
    outer loop
      vertex   9.366868e+00  8.848324e-01  1.160382e+01
      vertex   9.168643e+00  4.439545e-01  1.252310e+01
      vertex   9.412313e+00  4.439354e-01  1.161362e+01
    endloop
  endfacet
  facet normal -8.437759e-01  4.867763e-01  2.260335e-01
    outer loop
      vertex  -9.116395e+00  1.468527e+00  1.154942e+01
      vertex  -9.268758e+00  1.189178e+00  1.158224e+01
      vertex  -8.880441e+00  1.468477e+00  1.243033e+01
    endloop
  endfacet
  facet normal -3.438197e-02 -3.597669e-03  9.994023e-01
    outer loop
      vertex   4.041913e-01 -6.678841e+00  1.334873e+00
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
    endloop
  endfacet
  facet normal -6.251777e-01  7.622967e-01  1.675012e-01
    outer loop
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
      vertex  -8.732751e+00  1.663901e+00  1.238302e+01
      vertex  -8.410871e+00  1.950541e+00  1.227990e+01
    endloop
  endfacet
  facet normal  9.699574e-01 -2.421378e-01 -2.349692e-02
    outer loop
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
      vertex  -5.335880e+00  1.486812e+00 -2.081668e-16
      vertex  -5.334213e+00  1.493491e+00  1.457168e-16
    endloop
  endfacet
  facet normal  6.274679e-01  7.684336e-01 -1.256732e-01
    outer loop
      vertex   4.553915e+00  5.129000e+00  1.359486e+00
      vertex   5.192330e+00  4.603491e+00  1.333755e+00
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
    endloop
  endfacet
  facet normal -6.251465e-01  7.623299e-01  1.674661e-01
    outer loop
      vertex  -8.634320e+00  1.950586e+00  1.144556e+01
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
      vertex  -8.410871e+00  1.950541e+00  1.227990e+01
    endloop
  endfacet
  facet normal -2.980343e-01  9.536918e-01 -4.058877e-02
    outer loop
      vertex  -2.386352e+00  6.286799e+00  1.432061e+00
      vertex  -2.393248e+00  6.295172e+00  1.679424e+00
      vertex  -2.003711e+00  6.412324e+00  1.571811e+00
    endloop
  endfacet
  facet normal -8.676804e-01 -7.233825e-02 -4.918312e-01
    outer loop
      vertex  -7.001122e+00 -4.389858e-01  5.618219e-01
      vertex  -6.687660e+00 -3.790381e-01  5.898060e-17
      vertex  -6.653766e+00 -7.855896e-01 -3.986009e-16
    endloop
  endfacet
  facet normal  2.446794e-01 -9.297589e-01  2.751008e-01
    outer loop
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
      vertex   5.485987e+00 -2.181002e+00  1.574896e+01
    endloop
  endfacet
  facet normal -4.109611e-01  9.049786e-01  1.101117e-01
    outer loop
      vertex  -8.634320e+00  1.950586e+00  1.144556e+01
      vertex  -8.410871e+00  1.950541e+00  1.227990e+01
      vertex  -8.030187e+00  2.138250e+00  1.215796e+01
    endloop
  endfacet
  facet normal -4.731161e-01  8.795224e-01  5.100418e-02
    outer loop
      vertex  -8.815278e+00  2.027315e+00  8.300351e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
    endloop
  endfacet
  facet normal -2.248506e-01 -9.707210e-01  8.451629e-02
    outer loop
      vertex  -8.030813e+00 -2.137737e+00  1.215816e+01
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -7.740718e+00 -2.137720e+00  1.293013e+01
    endloop
  endfacet
  facet normal -9.960265e-02  9.718315e-01  2.135952e-01
    outer loop
      vertex  -3.186596e+00  2.138090e+00  1.738905e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
      vertex  -3.933839e+00  2.138109e+00  1.704051e+01
    endloop
  endfacet
  facet normal -4.559752e-02 -3.132889e-01  9.485626e-01
    outer loop
      vertex  -1.984666e-04 -8.841076e-01  1.916282e+01
      vertex  -9.082920e-01 -1.189516e+00  1.901830e+01
      vertex  -1.970066e-04 -1.189507e+00  1.906195e+01
    endloop
  endfacet
  facet normal -7.380485e-01 -5.820763e-01 -3.412794e-01
    outer loop
      vertex  -6.415605e+00 -3.455317e+00  1.644304e+00
      vertex  -6.789246e+00 -3.181795e+00  1.985826e+00
      vertex  -6.669674e+00 -3.125740e+00  1.631636e+00
    endloop
  endfacet
  facet normal -6.066282e-01 -7.615957e-01  2.279786e-01
    outer loop
      vertex  -8.412040e+00 -1.949663e+00  1.228027e+01
      vertex  -8.108208e+00 -1.949612e+00  1.308891e+01
      vertex  -8.417951e+00 -1.662831e+00  1.322275e+01
    endloop
  endfacet
  facet normal -5.923742e-01  8.056437e-01 -5.566646e-03
    outer loop
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
      vertex   3.029783e+00 -4.664573e+00 -2.392762e-16
    endloop
  endfacet
  facet normal -9.582189e-01  6.075445e-07 -2.860360e-01
    outer loop
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
      vertex   7.974292e+00 -2.181013e+00  1.171663e+01
      vertex   7.974295e+00  2.181215e+00  1.171663e+01
    endloop
  endfacet
  facet normal  1.847290e-01  4.984347e-04  9.827894e-01
    outer loop
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
      vertex  -1.604877e+00  6.511686e+00  1.482458e+00
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
    endloop
  endfacet
  facet normal  2.561053e-01 -9.938130e-07 -9.666489e-01
    outer loop
      vertex  -1.968264e+00  2.181299e+00  1.759722e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
      vertex  -1.968280e+00 -2.180969e+00  1.759722e+01
    endloop
  endfacet
  facet normal -7.058346e-01  7.026016e-01 -9.026917e-02
    outer loop
      vertex  -7.546020e+00  2.839064e+00  3.391044e+00
      vertex  -7.419713e+00  3.056143e+00  4.093033e+00
      vertex  -7.246525e+00  3.142607e+00  3.411828e+00
    endloop
  endfacet
  facet normal -7.335616e-01 -6.212072e-01  2.756610e-01
    outer loop
      vertex  -8.733365e+00 -1.662915e+00  1.238321e+01
      vertex  -8.417951e+00 -1.662831e+00  1.322275e+01
      vertex  -8.557884e+00 -1.470757e+00  1.328322e+01
    endloop
  endfacet
  facet normal -8.745039e-01 -7.196540e-02 -4.796498e-01
    outer loop
      vertex  -6.964637e+00 -8.798046e-01  5.629778e-01
      vertex  -7.333118e+00 -9.526539e-01  1.245728e+00
      vertex  -7.370649e+00 -4.772720e-01  1.242829e+00
    endloop
  endfacet
  facet normal -8.889139e-01 -3.134661e-01  3.340224e-01
    outer loop
      vertex  -9.028337e+00 -1.189642e+00  1.247771e+01
      vertex  -8.702224e+00 -1.189629e+00  1.334559e+01
      vertex  -8.794991e+00 -8.838463e-01  1.338567e+01
    endloop
  endfacet
  facet normal  8.872463e-01  3.678980e-01 -2.782897e-01
    outer loop
      vertex   8.288459e+00  2.015738e+00  4.043362e+00
      vertex   8.707416e+00  1.522598e+00  4.727156e+00
      vertex   8.479278e+00  1.546875e+00  4.031898e+00
    endloop
  endfacet
  facet normal -9.309682e-01 -1.044762e-01  3.498326e-01
    outer loop
      vertex  -9.124593e+00 -8.838253e-01  1.250855e+01
      vertex  -8.794991e+00 -8.838463e-01  1.338567e+01
      vertex  -8.837564e+00 -4.428959e-01  1.340407e+01
    endloop
  endfacet
  facet normal -2.368954e-01 -9.707354e-01  3.941237e-02
    outer loop
      vertex  -8.244216e+00 -2.137755e+00  1.136154e+01
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
    endloop
  endfacet
  facet normal  1.962976e-16  8.163473e-16 -1.000000e+00
    outer loop
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
      vertex   4.435295e+00  4.986383e+00  9.055257e-16
      vertex   3.919394e+00  3.934411e+00 -5.451988e-17
    endloop
  endfacet
  facet normal -9.360920e-01 -2.718371e-03  3.517447e-01
    outer loop
      vertex  -9.168571e+00  4.445152e-01  1.252264e+01
      vertex  -9.167421e+00  8.258820e-04  1.252227e+01
      vertex  -8.837394e+00  4.444962e-01  1.340400e+01
    endloop
  endfacet
  facet normal -9.309466e-01  1.047332e-01  3.498137e-01
    outer loop
      vertex  -9.168571e+00  4.445152e-01  1.252264e+01
      vertex  -8.837394e+00  4.444962e-01  1.340400e+01
      vertex  -8.794720e+00  8.854065e-01  1.338556e+01
    endloop
  endfacet
  facet normal  3.457031e-02 -9.704676e-01  2.387413e-01
    outer loop
      vertex   1.608019e+00 -2.137506e+00  1.786044e+01
      vertex   8.076244e-01 -2.137521e+00  1.797628e+01
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
    endloop
  endfacet
  facet normal -5.805601e-01  4.866274e-01  6.527968e-01
    outer loop
      vertex  -5.857307e+00  1.468172e+00  1.683807e+01
      vertex  -6.525561e+00  1.468224e+00  1.624372e+01
      vertex  -6.634596e+00  1.188892e+00  1.635498e+01
    endloop
  endfacet
  facet normal -8.246964e-01  3.231978e-01 -4.641326e-01
    outer loop
      vertex  -7.123807e+00  1.872915e+00  1.255299e+00
      vertex  -6.960249e+00  2.299536e+00  1.261756e+00
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
    endloop
  endfacet
  facet normal -8.890418e-01  3.130498e-01  3.340727e-01
    outer loop
      vertex  -9.124299e+00  8.854256e-01  1.250846e+01
      vertex  -8.794720e+00  8.854065e-01  1.338556e+01
      vertex  -8.702725e+00  1.189085e+00  1.334581e+01
    endloop
  endfacet
  facet normal -8.890454e-01  3.130304e-01  3.340816e-01
    outer loop
      vertex  -9.124299e+00  8.854256e-01  1.250846e+01
      vertex  -8.702725e+00  1.189085e+00  1.334581e+01
      vertex  -9.028855e+00  1.189133e+00  1.247788e+01
    endloop
  endfacet
  facet normal  9.944254e-01 -1.615571e-03 -1.054303e-01
    outer loop
      vertex   9.514176e+00  4.699631e-01  7.582161e+00
      vertex   9.591737e+00  4.614162e-01  8.313847e+00
      vertex   9.591002e+00  7.381439e-04  8.313971e+00
    endloop
  endfacet
  facet normal -6.059069e-01  7.622482e-01  2.277161e-01
    outer loop
      vertex  -8.107093e+00  1.950495e+00  1.308844e+01
      vertex  -8.732751e+00  1.663901e+00  1.238302e+01
      vertex  -8.417369e+00  1.663807e+00  1.322250e+01
    endloop
  endfacet
  facet normal  4.190097e-02  4.864085e-01  8.727262e-01
    outer loop
      vertex   8.930779e-01  1.467754e+00  1.886402e+01
      vertex  -1.819546e-04  1.467806e+00  1.890688e+01
      vertex  -1.872839e-04  1.188496e+00  1.906255e+01
    endloop
  endfacet
  facet normal  2.302940e-01  9.584655e-01  1.682515e-01
    outer loop
      vertex   7.658692e+00  2.654070e+00  6.497303e+00
      vertex   7.791419e+00  2.560247e+00  6.850104e+00
      vertex   7.902397e+00  2.533552e+00  6.850276e+00
    endloop
  endfacet
  facet normal -3.982803e-01  9.049683e-01  1.496836e-01
    outer loop
      vertex  -7.740116e+00  2.138235e+00  1.292988e+01
      vertex  -8.030187e+00  2.138250e+00  1.215796e+01
      vertex  -8.410871e+00  1.950541e+00  1.227990e+01
    endloop
  endfacet
  facet normal -2.202815e-01 -9.695128e-01  1.073361e-01
    outer loop
      vertex  -7.376554e+00 -2.137703e+00  1.367004e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
    endloop
  endfacet
  facet normal -5.814669e-01 -7.615670e-01  2.862028e-01
    outer loop
      vertex  -8.021980e+00 -1.662747e+00  1.402742e+01
      vertex  -8.108208e+00 -1.949612e+00  1.308891e+01
      vertex  -7.726786e+00 -1.949560e+00  1.386397e+01
    endloop
  endfacet
  facet normal  2.739395e-01  7.614440e-01  5.875034e-01
    outer loop
      vertex   4.120631e+00  1.949694e+00  1.739514e+01
      vertex   3.337795e+00  1.949743e+00  1.776009e+01
      vertex   3.465590e+00  1.662270e+00  1.807309e+01
    endloop
  endfacet
  facet normal -4.339067e-01  9.005989e-01 -2.542627e-02
    outer loop
      vertex  -3.163172e+00  5.996607e+00  1.805202e+00
      vertex  -3.411066e+00  5.884436e+00  2.062481e+00
      vertex  -3.170523e+00  5.997377e+00  1.957937e+00
    endloop
  endfacet
  facet normal -4.342986e-01 -8.808846e-01  1.882206e-01
    outer loop
      vertex  -6.742536e+00 -3.362928e+00  4.816038e+00
      vertex  -6.959290e+00 -3.187130e+00  5.138649e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
    endloop
  endfacet
  facet normal  7.476613e-02 -4.168950e-03 -9.971924e-01
    outer loop
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
      vertex  -3.959477e-01 -2.180975e+00  1.782579e+01
    endloop
  endfacet
  facet normal -7.832888e-01 -4.876937e-01  3.855041e-01
    outer loop
      vertex  -8.292838e+00 -1.189617e+00  1.417741e+01
      vertex  -8.702224e+00 -1.189629e+00  1.334559e+01
      vertex  -8.557884e+00 -1.470757e+00  1.328322e+01
    endloop
  endfacet
  facet normal -8.520077e-01 -3.134516e-01  4.193219e-01
    outer loop
      vertex  -8.381232e+00 -8.838654e-01  1.422637e+01
      vertex  -8.702224e+00 -1.189629e+00  1.334559e+01
      vertex  -8.292838e+00 -1.189617e+00  1.417741e+01
    endloop
  endfacet
  facet normal  3.996345e-01 -9.042878e-01  1.501864e-01
    outer loop
      vertex   8.413611e+00 -1.948362e+00  1.228117e+01
      vertex   8.109565e+00 -1.948414e+00  1.308991e+01
      vertex   7.741767e+00 -2.137351e+00  1.293098e+01
    endloop
  endfacet
  facet normal -8.923120e-01 -1.044750e-01  4.391631e-01
    outer loop
      vertex  -8.421803e+00 -4.429150e-01  1.424883e+01
      vertex  -8.794991e+00 -8.838463e-01  1.338567e+01
      vertex  -8.381232e+00 -8.838654e-01  1.422637e+01
    endloop
  endfacet
  facet normal  6.101785e-02  9.047882e-01  4.214680e-01
    outer loop
      vertex   1.607921e+00  2.137976e+00  1.785984e+01
      vertex   8.075836e-01  2.137995e+00  1.797567e+01
      vertex   8.459144e-01  1.949884e+00  1.837395e+01
    endloop
  endfacet
  facet normal -2.521961e-01  9.555697e-01  1.525899e-01
    outer loop
      vertex  -7.658601e+00  2.655306e+00  6.497398e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
      vertex  -7.902413e+00  2.534609e+00  6.850279e+00
    endloop
  endfacet
  facet normal -8.923132e-01 -1.044711e-01  4.391617e-01
    outer loop
      vertex  -8.421803e+00 -4.429150e-01  1.424883e+01
      vertex  -8.837564e+00 -4.428959e-01  1.340407e+01
      vertex  -8.794991e+00 -8.838463e-01  1.338567e+01
    endloop
  endfacet
  facet normal -6.019276e-01  7.772684e-01 -1.831315e-01
    outer loop
      vertex  -5.194129e+00  4.607729e+00  1.333857e+00
      vertex  -5.253759e+00  4.649057e+00  1.705261e+00
      vertex  -4.598021e+00  5.164835e+00  1.739065e+00
    endloop
  endfacet
  facet normal -4.792437e-14 -2.582442e-14 -1.000000e+00
    outer loop
      vertex  -3.077820e+00  5.921855e+00  1.040834e-16
      vertex  -2.553828e+00  4.945892e+00  1.957759e-16
      vertex  -3.093479e+00  5.912963e+00  1.084202e-15
    endloop
  endfacet
  facet normal  7.819019e-01 -5.605404e-01 -2.728074e-01
    outer loop
      vertex   5.619496e+00 -3.913401e+00  5.863152e-01
      vertex   5.509706e+00 -3.781196e+00 -7.748432e-17
      vertex   6.091302e+00 -3.251385e+00  5.783205e-01
    endloop
  endfacet
  facet normal  2.168284e-01  9.047258e-01  3.666834e-01
    outer loop
      vertex   4.643673e+00  2.137899e+00  1.662149e+01
      vertex   3.933867e+00  2.137918e+00  1.704117e+01
      vertex   4.120631e+00  1.949694e+00  1.739514e+01
    endloop
  endfacet
  facet normal -4.560836e-01 -8.884137e-01 -5.204707e-02
    outer loop
      vertex  -3.412686e+00 -5.885452e+00  2.063216e+00
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
      vertex  -3.166358e+00 -5.996792e+00  1.805169e+00
    endloop
  endfacet
  facet normal  5.867411e-01 -1.044826e-01  8.030058e-01
    outer loop
      vertex   6.047077e+00 -4.433079e-01  1.707368e+01
      vertex   5.276037e+00 -8.842430e-01  1.757970e+01
      vertex   6.017940e+00 -8.842640e-01  1.703760e+01
    endloop
  endfacet
  facet normal -2.269569e-15 -1.731219e-15 -1.000000e+00
    outer loop
      vertex   1.574826e+00 -5.345766e+00  2.471981e-16
      vertex   2.362674e+00 -6.239994e+00  7.228014e-18
      vertex   1.754346e+00 -6.432830e+00  1.721713e-15
    endloop
  endfacet
  facet normal -5.062868e-01  1.047330e-01  8.559816e-01
    outer loop
      vertex  -4.469825e+00  8.852539e-01  1.805627e+01
      vertex  -5.301825e+00  4.443703e-01  1.761811e+01
      vertex  -4.491520e+00  4.443474e-01  1.809738e+01
    endloop
  endfacet
  facet normal -8.972191e-01  3.141333e-03  4.415745e-01
    outer loop
      vertex  -8.420585e+00  7.877350e-04  1.424816e+01
      vertex  -8.836282e+00  8.068085e-04  1.340352e+01
      vertex  -8.837564e+00 -4.428959e-01  1.340407e+01
    endloop
  endfacet
  facet normal -5.151511e-01 -7.615305e-01  3.933073e-01
    outer loop
      vertex  -7.015736e+00 -1.662584e+00  1.548874e+01
      vertex  -7.271570e+00 -1.949509e+00  1.459810e+01
      vertex  -6.757536e+00 -1.949457e+00  1.527148e+01
    endloop
  endfacet
  facet normal -6.726641e-01 -7.398817e-01 -9.908239e-03
    outer loop
      vertex   3.842232e+00  3.974119e+00  2.273273e+00
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
      vertex   3.919394e+00  3.934411e+00 -5.451988e-17
    endloop
  endfacet
  facet normal  9.810210e-01  1.047366e-01  1.631809e-01
    outer loop
      vertex   9.517658e+00  8.848133e-01  1.069732e+01
      vertex   9.412313e+00  4.439354e-01  1.161362e+01
      vertex   9.563832e+00  4.439163e-01  1.070271e+01
    endloop
  endfacet
  facet normal -6.383207e-01  7.623709e-01  1.064766e-01
    outer loop
      vertex  -8.634320e+00  1.950586e+00  1.144556e+01
      vertex  -9.107553e+00  1.665619e+00  1.064893e+01
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
    endloop
  endfacet
  facet normal  7.377930e-17  4.670314e-16 -1.000000e+00
    outer loop
      vertex   5.507741e+00  5.799408e-01  7.632783e-17
      vertex   6.652087e+00  8.003138e-01  2.636780e-16
      vertex   6.687155e+00  3.876799e-01  7.355228e-17
    endloop
  endfacet
  facet normal -8.922903e-01  1.047288e-01  4.391467e-01
    outer loop
      vertex  -8.380980e+00  8.853855e-01  1.422623e+01
      vertex  -8.837394e+00  4.444962e-01  1.340400e+01
      vertex  -8.421647e+00  4.444752e-01  1.424875e+01
    endloop
  endfacet
  facet normal -5.367140e-01 -8.387967e-01 -9.142245e-02
    outer loop
      vertex  -3.873714e+00 -5.593157e+00  1.385406e+00
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
      vertex  -4.601830e+00 -5.165804e+00  1.739013e+00
    endloop
  endfacet
  facet normal  3.153604e-01  3.129822e-01  8.958738e-01
    outer loop
      vertex   3.582659e+00  1.188295e+00  1.835983e+01
      vertex   2.708174e+00  1.188345e+00  1.866765e+01
      vertex   2.736763e+00  8.850708e-01  1.876354e+01
    endloop
  endfacet
  facet normal -7.837716e-01  4.867186e-01  3.857551e-01
    outer loop
      vertex  -8.157006e+00  1.468376e+00  1.410220e+01
      vertex  -8.559678e+00  1.468428e+00  1.328400e+01
      vertex  -8.702725e+00  1.189085e+00  1.334581e+01
    endloop
  endfacet
  facet normal  8.158216e-01 -4.105120e-01 -4.073267e-01
    outer loop
      vertex   6.962789e+00 -2.295359e+00  1.261698e+00
      vertex   6.904957e+00 -2.766088e+00  1.620279e+00
      vertex   6.767753e+00 -2.690432e+00  1.269229e+00
    endloop
  endfacet
  facet normal -5.807983e-01  7.621970e-01  2.858828e-01
    outer loop
      vertex  -7.725738e+00  1.950449e+00  1.386340e+01
      vertex  -8.417369e+00  1.663807e+00  1.322250e+01
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
    endloop
  endfacet
  facet normal -3.618143e-01 -9.048360e-01  2.244156e-01
    outer loop
      vertex  -7.271570e+00 -1.949509e+00  1.459810e+01
      vertex  -7.726786e+00 -1.949560e+00  1.386397e+01
      vertex  -7.376554e+00 -2.137703e+00  1.367004e+01
    endloop
  endfacet
  facet normal -4.751545e-01 -7.615154e-01  4.408202e-01
    outer loop
      vertex  -6.417627e+00 -1.662502e+00  1.613357e+01
      vertex  -7.015736e+00 -1.662584e+00  1.548874e+01
      vertex  -6.757536e+00 -1.949457e+00  1.527148e+01
    endloop
  endfacet
  facet normal -2.867746e-01 -9.571520e-01 -4.025257e-02
    outer loop
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -2.367681e+00 -6.277615e+00  6.327448e-01
      vertex  -1.585613e+00 -6.485322e+00 -5.642188e-16
    endloop
  endfacet
  facet normal -7.419351e-01 -4.876935e-01  4.600950e-01
    outer loop
      vertex  -7.804250e+00 -1.189606e+00  1.496531e+01
      vertex  -8.155293e+00 -1.470728e+00  1.410125e+01
      vertex  -7.674814e+00 -1.470701e+00  1.487608e+01
    endloop
  endfacet
  facet normal -7.419394e-01 -4.876873e-01  4.600947e-01
    outer loop
      vertex  -7.804250e+00 -1.189606e+00  1.496531e+01
      vertex  -8.292838e+00 -1.189617e+00  1.417741e+01
      vertex  -8.155293e+00 -1.470728e+00  1.410125e+01
    endloop
  endfacet
  facet normal  2.487720e-15  4.990209e-16 -1.000000e+00
    outer loop
      vertex  -1.011834e+00  5.481153e+00  3.025358e-16
      vertex  -1.072226e+00  5.471439e+00  1.474515e-16
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
    endloop
  endfacet
  facet normal -8.070310e-01 -3.134382e-01  5.004572e-01
    outer loop
      vertex  -7.887427e+00 -8.838863e-01  1.502266e+01
      vertex  -8.381232e+00 -8.838654e-01  1.422637e+01
      vertex  -8.292838e+00 -1.189617e+00  1.417741e+01
    endloop
  endfacet
  facet normal  7.542657e-01 -5.959212e-01 -2.756103e-01
    outer loop
      vertex   5.619496e+00 -3.913401e+00  5.863152e-01
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
      vertex   5.509706e+00 -3.781196e+00 -7.748432e-17
    endloop
  endfacet
  facet normal  5.562540e-01 -8.276550e-01  7.462272e-02
    outer loop
      vertex   7.421623e+00 -3.057121e+00  4.092836e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
    endloop
  endfacet
  facet normal -8.452031e-01 -1.044741e-01  5.241344e-01
    outer loop
      vertex  -7.925608e+00 -4.429359e-01  1.504898e+01
      vertex  -8.381232e+00 -8.838654e-01  1.422637e+01
      vertex  -7.887427e+00 -8.838863e-01  1.502266e+01
    endloop
  endfacet
  facet normal  9.805955e-01  1.849162e-03 -1.960328e-01
    outer loop
      vertex   9.257026e+00  4.947186e-01  6.135334e+00
      vertex   9.401924e+00  6.008148e-04  6.855484e+00
      vertex   9.257847e+00  3.471375e-04  6.134778e+00
    endloop
  endfacet
  facet normal -9.301527e-01  2.562073e-01 -2.630091e-01
    outer loop
      vertex  -8.831814e+00  1.030754e+00  4.720401e+00
      vertex  -9.037185e+00  1.008070e+00  5.424614e+00
      vertex  -8.906251e+00  1.487829e+00  5.428909e+00
    endloop
  endfacet
  facet normal -8.228778e-01 -4.089773e-01 -3.944739e-01
    outer loop
      vertex  -6.300128e+00 -2.905363e+00  5.748463e-01
      vertex  -6.102031e+00 -2.749480e+00 -1.179612e-16
      vertex  -5.921600e+00 -3.112514e+00 -8.326673e-17
    endloop
  endfacet
  facet normal  3.592058e-01 -9.234377e-01  1.350337e-01
    outer loop
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
      vertex   7.727498e+00 -2.181013e+00  1.248517e+01
    endloop
  endfacet
  facet normal  4.698930e-01 -8.823975e-01 -2.397984e-02
    outer loop
      vertex   3.644648e+00 -5.760553e+00  2.172778e+00
      vertex   3.411897e+00 -5.881508e+00  2.062777e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
    endloop
  endfacet
  facet normal  4.689329e-01  8.820659e-01 -4.540444e-02
    outer loop
      vertex   3.142986e+00  5.975683e+00  1.409958e+00
      vertex   3.868523e+00  5.588697e+00  1.385323e+00
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
    endloop
  endfacet
  facet normal  1.131649e-02  9.718338e-01  2.353955e-01
    outer loop
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex  -1.551486e-04  2.138014e+00  1.801440e+01
    endloop
  endfacet
  facet normal -5.670662e-01 -7.249489e-04  8.236719e-01
    outer loop
      vertex   4.719419e+00 -5.032785e+00  2.806460e+00
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
    endloop
  endfacet
  facet normal -8.498532e-01 -2.752278e-03  5.270122e-01
    outer loop
      vertex  -7.925472e+00  4.444542e-01  1.504889e+01
      vertex  -8.420585e+00  7.877350e-04  1.424816e+01
      vertex  -7.924467e+00  7.686615e-04  1.504819e+01
    endloop
  endfacet
  facet normal -8.451830e-01  1.047240e-01  5.241170e-01
    outer loop
      vertex  -7.887197e+00  8.853626e-01  1.502250e+01
      vertex  -8.380980e+00  8.853855e-01  1.422623e+01
      vertex  -8.421647e+00  4.444752e-01  1.424875e+01
    endloop
  endfacet
  facet normal -6.597053e-01 -7.285979e-01 -1.842120e-01
    outer loop
      vertex  -5.079527e+00 -4.528217e+00  5.953417e-01
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
      vertex  -5.198132e+00 -4.607538e+00  1.333823e+00
    endloop
  endfacet
  facet normal -3.819729e-01 -9.048458e-01  1.880180e-01
    outer loop
      vertex  -7.726786e+00 -1.949560e+00  1.386397e+01
      vertex  -7.740718e+00 -2.137720e+00  1.293013e+01
      vertex  -7.376554e+00 -2.137703e+00  1.367004e+01
    endloop
  endfacet
  facet normal  8.781916e-01  7.428280e-02 -4.725057e-01
    outer loop
      vertex   7.517587e+00  9.879436e-01  1.595290e+00
      vertex   7.752392e+00  5.107079e-01  1.956668e+00
      vertex   7.557823e+00  4.967327e-01  1.592848e+00
    endloop
  endfacet
  facet normal -8.071405e-01  3.130367e-01  5.005320e-01
    outer loop
      vertex  -7.804706e+00  1.188988e+00  1.496563e+01
      vertex  -8.380980e+00  8.853855e-01  1.422623e+01
      vertex  -7.887197e+00  8.853626e-01  1.502250e+01
    endloop
  endfacet
  facet normal  9.475169e-01  3.129484e-01  6.538260e-02
    outer loop
      vertex   9.418399e+00  1.187765e+00  1.068572e+01
      vertex   9.517658e+00  8.848133e-01  1.069732e+01
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
    endloop
  endfacet
  facet normal -8.071407e-01  3.130326e-01  5.005340e-01
    outer loop
      vertex  -7.804706e+00  1.188988e+00  1.496563e+01
      vertex  -8.293319e+00  1.189035e+00  1.417769e+01
      vertex  -8.380980e+00  8.853855e-01  1.422623e+01
    endloop
  endfacet
  facet normal  4.624546e-01 -6.209077e-01  6.329371e-01
    outer loop
      vertex   5.856004e+00 -1.470266e+00  1.683706e+01
      vertex   5.134046e+00 -1.470291e+00  1.736454e+01
      vertex   5.050582e+00 -1.661374e+00  1.723807e+01
    endloop
  endfacet
  facet normal -7.424096e-01  4.866787e-01  4.604041e-01
    outer loop
      vertex  -7.676430e+00  1.468325e+00  1.487720e+01
      vertex  -8.293319e+00  1.189035e+00  1.417769e+01
      vertex  -7.804706e+00  1.188988e+00  1.496563e+01
    endloop
  endfacet
  facet normal -7.424068e-01  4.866892e-01  4.603975e-01
    outer loop
      vertex  -7.676430e+00  1.468325e+00  1.487720e+01
      vertex  -8.157006e+00  1.468376e+00  1.410220e+01
      vertex  -8.293319e+00  1.189035e+00  1.417769e+01
    endloop
  endfacet
  facet normal -9.219964e-01  2.366877e-01 -3.064335e-01
    outer loop
      vertex  -8.596299e+00  1.045643e+00  4.023285e+00
      vertex  -8.831814e+00  1.030754e+00  4.720401e+00
      vertex  -8.707513e+00  1.523714e+00  4.727165e+00
    endloop
  endfacet
  facet normal -6.664230e-01  6.205421e-01  4.132890e-01
    outer loop
      vertex  -7.550043e+00  1.662085e+00  1.479008e+01
      vertex  -8.157006e+00  1.468376e+00  1.410220e+01
      vertex  -7.676430e+00  1.468325e+00  1.487720e+01
    endloop
  endfacet
  facet normal  3.836369e-01  9.234649e-01 -5.949407e-03
    outer loop
      vertex  -2.293268e+00 -5.066431e+00  1.649853e+00
      vertex  -1.862915e+00 -5.245935e+00  1.537825e+00
      vertex  -2.026798e+00 -5.187760e+00 -4.897124e-16
    endloop
  endfacet
  facet normal  9.360751e-01 -3.012370e-03  3.517874e-01
    outer loop
      vertex   9.168643e+00  4.439545e-01  1.252310e+01
      vertex   8.836189e+00  3.118515e-04  1.340393e+01
      vertex   9.167368e+00  2.927780e-04  1.252269e+01
    endloop
  endfacet
  facet normal -6.661758e-01  6.210473e-01  4.129286e-01
    outer loop
      vertex  -7.550043e+00  1.662085e+00  1.479008e+01
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
      vertex  -8.157006e+00  1.468376e+00  1.410220e+01
    endloop
  endfacet
  facet normal -5.501629e-01  7.621799e-01  3.411784e-01
    outer loop
      vertex  -7.270593e+00  1.950403e+00  1.459744e+01
      vertex  -7.725738e+00  1.950449e+00  1.386340e+01
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
    endloop
  endfacet
  facet normal -4.122583e-01 -9.031219e-01  1.200577e-01
    outer loop
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
      vertex  -8.198880e+00 -2.495790e+00  6.145909e+00
    endloop
  endfacet
  facet normal -2.002831e-01  9.718310e-01  1.242227e-01
    outer loop
      vertex  -6.941405e+00  2.138201e+00  1.437052e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
      vertex  -7.375982e+00  2.138216e+00  1.366973e+01
    endloop
  endfacet
  facet normal -4.673904e-01  8.803617e-01  8.068098e-02
    outer loop
      vertex  -7.572854e+00  2.943415e+00  4.775358e+00
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
    endloop
  endfacet
  facet normal -6.379675e-01  7.700594e-01 -2.461283e-03
    outer loop
      vertex  -7.246525e+00  3.142607e+00  3.411828e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
      vertex  -6.930485e+00  3.404509e+00  3.434753e+00
    endloop
  endfacet
  facet normal  1.917072e-01 -9.704390e-01  1.466176e-01
    outer loop
      vertex   6.942640e+00 -2.137383e+00  1.437178e+01
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
    endloop
  endfacet
  facet normal -2.002910e-01  9.718283e-01  1.242305e-01
    outer loop
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
      vertex  -7.375982e+00  2.138216e+00  1.366973e+01
    endloop
  endfacet
  facet normal -7.960957e-01  4.915252e-01 -3.530360e-01
    outer loop
      vertex  -6.087716e+00  3.260000e+00  5.783348e-01
      vertex  -5.501915e+00  3.793403e+00  3.122502e-16
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
    endloop
  endfacet
  facet normal -3.377834e-02  9.718320e-01  2.332416e-01
    outer loop
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
      vertex  -1.608142e+00  2.138052e+00  1.785956e+01
    endloop
  endfacet
  facet normal -9.308351e-01 -7.588144e-02 -3.574744e-01
    outer loop
      vertex  -8.374131e+00 -5.304680e-01  3.328518e+00
      vertex  -8.333854e+00 -1.053164e+00  3.334592e+00
      vertex  -8.639026e+00 -5.278988e-01  4.017737e+00
    endloop
  endfacet
  facet normal -5.232444e-01  8.416362e-01  1.336556e-01
    outer loop
      vertex  -5.752640e+00  4.179514e+00  3.658571e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
      vertex  -5.926451e+00  4.043840e+00  3.832467e+00
    endloop
  endfacet
  facet normal -6.993076e-01 -6.989041e-01 -1.500060e-01
    outer loop
      vertex  -7.044407e+00 -3.201189e+00  2.717045e+00
      vertex  -7.248965e+00 -3.145601e+00  3.411671e+00
      vertex  -7.547992e+00 -2.841942e+00  3.390894e+00
    endloop
  endfacet
  facet normal -9.338886e-01  8.169029e-03 -3.574705e-01
    outer loop
      vertex  -8.378106e+00 -9.479523e-04  3.326391e+00
      vertex  -8.641997e+00 -8.125305e-04  4.015808e+00
      vertex  -8.638139e+00  5.261440e-01  4.017769e+00
    endloop
  endfacet
  facet normal  5.155913e-01 -7.610524e-01  3.936557e-01
    outer loop
      vertex   7.550447e+00 -1.661053e+00  1.479081e+01
      vertex   7.016542e+00 -1.661133e+00  1.548994e+01
      vertex   6.758233e+00 -1.948568e+00  1.527256e+01
    endloop
  endfacet
  facet normal  6.364160e-01  2.479057e-04  7.713460e-01
    outer loop
      vertex  -5.159912e+00 -4.676804e+00  3.135705e+00
      vertex  -5.207044e+00 -1.683388e+00  3.173630e+00
      vertex  -5.347189e+00 -4.518198e+00  3.290170e+00
    endloop
  endfacet
  facet normal -2.479090e-01 -9.561466e-01  1.559643e-01
    outer loop
      vertex  -7.015543e+00 -2.180944e+00  1.393137e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
    endloop
  endfacet
  facet normal -5.710391e-01 -8.208787e-01  8.514394e-03
    outer loop
      vertex  -7.421945e+00 -3.058773e+00  4.092888e+00
      vertex  -7.574894e+00 -2.945297e+00  4.775242e+00
      vertex  -7.920292e+00 -2.705179e+00  4.760216e+00
    endloop
  endfacet
  facet normal -2.344324e-17  2.148729e-16 -1.000000e+00
    outer loop
      vertex  -2.354590e+00 -6.245616e+00 -4.946853e-16
      vertex  -1.511060e+00 -5.363482e+00 -3.249137e-16
      vertex  -1.585613e+00 -6.485322e+00 -5.642188e-16
    endloop
  endfacet
  facet normal  6.805354e-01 -7.322821e-01 -2.518919e-02
    outer loop
      vertex   9.079329e+00 -1.756750e+00  7.576222e+00
      vertex   9.146890e+00 -1.719061e+00  8.305820e+00
      vertex   8.816117e+00 -2.026272e+00  8.300370e+00
    endloop
  endfacet
  facet normal -5.151389e-01 -7.615392e-01  3.933065e-01
    outer loop
      vertex  -7.015736e+00 -1.662584e+00  1.548874e+01
      vertex  -7.549392e+00 -1.662664e+00  1.478962e+01
      vertex  -7.271570e+00 -1.949509e+00  1.459810e+01
    endloop
  endfacet
  facet normal  4.185788e-02 -4.876101e-01  8.720575e-01
    outer loop
      vertex   9.079207e-01 -1.189497e+00  1.901836e+01
      vertex  -1.939251e-04 -1.470444e+00  1.890486e+01
      vertex   8.928719e-01 -1.470419e+00  1.886201e+01
    endloop
  endfacet
  facet normal -9.712880e-01 -3.826816e-03 -2.378760e-01
    outer loop
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   7.974292e+00 -2.181013e+00  1.171663e+01
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
    endloop
  endfacet
  facet normal  4.487462e-01  1.472394e-03  8.936580e-01
    outer loop
      vertex  -3.644764e+00  5.762789e+00  2.172923e+00
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
    endloop
  endfacet
  facet normal  8.390902e-01  2.973581e-01 -4.555281e-01
    outer loop
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
      vertex   6.385301e+00  2.017778e+00 -5.689893e-16
      vertex   6.256312e+00  2.381761e+00 -4.475587e-16
    endloop
  endfacet
  facet normal -8.714181e-01  4.868439e-01  6.011274e-02
    outer loop
      vertex  -9.417916e+00  1.189226e+00  1.068517e+01
      vertex  -9.324624e+00  1.468624e+00  9.774772e+00
      vertex  -9.480475e+00  1.189270e+00  9.777935e+00
    endloop
  endfacet
  facet normal  3.616783e-01  1.238529e-03  9.323021e-01
    outer loop
      vertex  -2.791368e+00 -6.156036e+00  1.811148e+00
      vertex  -3.088347e+00 -4.607609e+00  1.924301e+00
      vertex  -3.173697e+00 -5.997675e+00  1.959259e+00
    endloop
  endfacet
  facet normal  6.536756e-01 -5.740648e-05  7.567748e-01
    outer loop
      vertex  -5.344672e+00  4.515985e+00  3.288033e+00
      vertex  -5.432583e+00  5.453663e-01  3.363667e+00
      vertex  -5.352921e+00  1.098696e+00  3.294899e+00
    endloop
  endfacet
  facet normal  7.948166e-01  2.905868e-03  6.068428e-01
    outer loop
      vertex   7.924301e+00  3.509521e-04  1.504856e+01
      vertex   7.364036e+00  3.700256e-04  1.578237e+01
      vertex   7.365021e+00 -4.433498e-01  1.578320e+01
    endloop
  endfacet
  facet normal  6.985452e-01 -6.359079e-01 -3.281092e-01
    outer loop
      vertex   6.307900e+00 -3.385426e+00  1.287444e+00
      vertex   6.414841e+00 -3.452044e+00  1.644233e+00
      vertex   5.863177e+00 -4.072899e+00  1.673018e+00
    endloop
  endfacet
  facet normal -6.229021e-01 -6.211652e-01  4.755490e-01
    outer loop
      vertex  -7.132257e+00 -1.470675e+00  1.558679e+01
      vertex  -7.549392e+00 -1.662664e+00  1.478962e+01
      vertex  -7.015736e+00 -1.662584e+00  1.548874e+01
    endloop
  endfacet
  facet normal -3.297079e-01  7.618975e-01  5.574988e-01
    outer loop
      vertex  -4.120495e+00  1.950171e+00  1.739424e+01
      vertex  -5.050044e+00  1.663237e+00  1.723664e+01
      vertex  -4.278252e+00  1.663140e+00  1.769321e+01
    endloop
  endfacet
  facet normal -7.948427e-01  3.111004e-03  6.068075e-01
    outer loop
      vertex  -7.364252e+00  7.486343e-04  1.578201e+01
      vertex  -7.925608e+00 -4.429359e-01  1.504898e+01
      vertex  -7.365310e+00 -4.429569e-01  1.578290e+01
    endloop
  endfacet
  facet normal  5.821087e-01 -7.609425e-01  2.865590e-01
    outer loop
      vertex   8.419494e+00 -1.660886e+00  1.322384e+01
      vertex   7.727928e+00 -1.948465e+00  1.386502e+01
      vertex   8.109565e+00 -1.948414e+00  1.308991e+01
    endloop
  endfacet
  facet normal -5.801744e-01 -4.876878e-01  6.523483e-01
    outer loop
      vertex  -5.954819e+00 -1.189575e+00  1.695880e+01
      vertex  -6.524183e+00 -1.470648e+00  1.624230e+01
      vertex  -5.856068e+00 -1.470623e+00  1.683652e+01
    endloop
  endfacet
  facet normal -7.948469e-01 -2.762848e-03  6.068037e-01
    outer loop
      vertex  -7.365190e+00  4.444332e-01  1.578280e+01
      vertex  -7.924467e+00  7.686615e-04  1.504819e+01
      vertex  -7.364252e+00  7.486343e-04  1.578201e+01
    endloop
  endfacet
  facet normal  5.414748e-01 -8.401883e-01 -2.981034e-02
    outer loop
      vertex   4.600634e+00 -5.161119e+00  1.738890e+00
      vertex   3.930022e+00 -5.608150e+00  2.157217e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
    endloop
  endfacet
  facet normal -6.943605e-01  4.866660e-01  5.301129e-01
    outer loop
      vertex  -7.133762e+00  1.468275e+00  1.558806e+01
      vertex  -7.804706e+00  1.188988e+00  1.496563e+01
      vertex  -7.252964e+00  1.188940e+00  1.568837e+01
    endloop
  endfacet
  facet normal  8.250611e-01  5.643132e-01  2.871860e-02
    outer loop
      vertex   9.178001e+00  1.689901e+00  9.037074e+00
      vertex   9.171400e+00  1.661978e+00  9.775407e+00
      vertex   9.432271e+00  1.317898e+00  9.041898e+00
    endloop
  endfacet
  facet normal -6.061138e-16 -3.116824e-16 -1.000000e+00
    outer loop
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
      vertex  -3.914187e+00  3.940789e+00 -9.159340e-17
      vertex  -4.284296e+00  3.528093e+00  2.613650e-16
    endloop
  endfacet
  facet normal  8.890173e-01 -3.130698e-01  3.341189e-01
    outer loop
      vertex   9.124413e+00 -8.843880e-01  1.250893e+01
      vertex   8.702374e+00 -1.189384e+00  1.334610e+01
      vertex   9.028557e+00 -1.189371e+00  1.247821e+01
    endloop
  endfacet
  facet normal -8.085209e-01 -3.822917e-03 -5.884552e-01
    outer loop
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   6.561598e+00 -2.181007e+00  1.458984e+01
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
    endloop
  endfacet
  facet normal  8.785285e-01  3.328922e-01 -3.425935e-01
    outer loop
      vertex   7.783234e+00  2.032179e+00  2.677185e+00
      vertex   8.047511e+00  2.034334e+00  3.356977e+00
      vertex   8.223418e+00  1.556984e+00  3.344231e+00
    endloop
  endfacet
  facet normal -8.314698e-01 -3.512909e-01 -4.304101e-01
    outer loop
      vertex  -6.487278e+00 -2.538105e+00  5.717039e-01
      vertex  -6.260275e+00 -2.374932e+00 -9.714451e-17
      vertex  -6.102031e+00 -2.749480e+00 -1.179612e-16
    endloop
  endfacet
  facet normal -5.865918e-01  6.747958e-01  4.478401e-01
    outer loop
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
      vertex  -7.547735e+00  1.665148e+00  1.478848e+01
      vertex  -7.550043e+00  1.662085e+00  1.479008e+01
    endloop
  endfacet
  facet normal -1.873119e-01  9.718323e-01  1.430251e-01
    outer loop
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
      vertex  -6.941405e+00  2.138201e+00  1.437052e+01
    endloop
  endfacet
  facet normal -9.360904e-01 -2.727846e-03  3.517489e-01
    outer loop
      vertex  -9.167421e+00  8.258820e-04  1.252227e+01
      vertex  -8.836282e+00  8.068085e-04  1.340352e+01
      vertex  -8.837394e+00  4.444962e-01  1.340400e+01
    endloop
  endfacet
  facet normal -7.291161e-01 -1.044763e-01  6.763685e-01
    outer loop
      vertex  -6.737354e+00 -4.429779e-01  1.645983e+01
      vertex  -7.365310e+00 -4.429569e-01  1.578290e+01
      vertex  -7.329827e+00 -8.839073e-01  1.575304e+01
    endloop
  endfacet
  facet normal -1.413697e-01  9.048364e-01  4.016040e-01
    outer loop
      vertex  -2.408869e+00  2.138071e+00  1.766289e+01
      vertex  -3.337810e+00  1.950125e+00  1.775935e+01
      vertex  -2.523188e+00  1.950075e+00  1.804622e+01
    endloop
  endfacet
  facet normal -6.961898e-01 -3.134203e-01  6.458233e-01
    outer loop
      vertex  -6.704895e+00 -8.839283e-01  1.642670e+01
      vertex  -7.329827e+00 -8.839073e-01  1.575304e+01
      vertex  -7.252540e+00 -1.189594e+00  1.568800e+01
    endloop
  endfacet
  facet normal  1.666329e-16  3.319431e-16 -1.000000e+00
    outer loop
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
      vertex  -5.501915e+00  3.793403e+00  3.122502e-16
      vertex  -4.642149e+00  3.035010e+00  2.037722e-16
    endloop
  endfacet
  facet normal -9.448627e-01 -2.979356e-01 -1.358997e-01
    outer loop
      vertex  -9.215196e+00 -1.401514e+00  6.855027e+00
      vertex  -9.468905e+00 -9.282398e-01  7.581413e+00
      vertex  -9.357120e+00 -9.516964e-01  6.855629e+00
    endloop
  endfacet
  facet normal  1.199970e-01  9.718174e-01  2.029083e-01
    outer loop
      vertex   4.643673e+00  2.137899e+00  1.662149e+01
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
      vertex   3.933867e+00  2.137918e+00  1.704117e+01
    endloop
  endfacet
  facet normal -7.331230e-01  3.097305e-03  6.800891e-01
    outer loop
      vertex  -6.736389e+00  7.286072e-04  1.645885e+01
      vertex  -7.365310e+00 -4.429569e-01  1.578290e+01
      vertex  -6.737354e+00 -4.429779e-01  1.645983e+01
    endloop
  endfacet
  facet normal -7.331295e-01 -2.763106e-03  6.800834e-01
    outer loop
      vertex  -6.737250e+00  4.444122e-01  1.645972e+01
      vertex  -7.365190e+00  4.444332e-01  1.578280e+01
      vertex  -7.364252e+00  7.486343e-04  1.578201e+01
    endloop
  endfacet
  facet normal  2.213249e-15 -6.211985e-16 -1.000000e+00
    outer loop
      vertex   3.864515e-01  5.562234e+00 -1.209102e-16
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
      vertex   4.404008e-01  5.559808e+00  0.000000e+00
    endloop
  endfacet
  facet normal  3.047893e-02  9.995100e-01  7.132031e-03
    outer loop
      vertex   4.720593e-05  6.690340e+00  1.324984e+00
      vertex   4.036640e-01  6.677962e+00  1.334846e+00
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
    endloop
  endfacet
  facet normal -7.290980e-01  1.047351e-01  6.763480e-01
    outer loop
      vertex  -6.704711e+00  8.853207e-01  1.642652e+01
      vertex  -7.329620e+00  8.853416e-01  1.575287e+01
      vertex  -7.365190e+00  4.444332e-01  1.578280e+01
    endloop
  endfacet
  facet normal -3.817689e-01  9.049526e-01  1.879185e-01
    outer loop
      vertex  -7.375982e+00  2.138216e+00  1.366973e+01
      vertex  -7.740116e+00  2.138235e+00  1.292988e+01
      vertex  -8.107093e+00  1.950495e+00  1.308844e+01
    endloop
  endfacet
  facet normal -6.202404e-01 -7.620244e-01 -1.860664e-01
    outer loop
      vertex  -4.559697e+00 -5.133471e+00  1.359566e+00
      vertex  -5.257534e+00 -4.649870e+00  1.705203e+00
      vertex  -5.198132e+00 -4.607538e+00  1.333823e+00
    endloop
  endfacet
  facet normal -2.082064e-01 -9.695225e-01  1.291364e-01
    outer loop
      vertex  -6.941944e+00 -2.137688e+00  1.437088e+01
      vertex  -7.376554e+00 -2.137703e+00  1.367004e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
    endloop
  endfacet
  facet normal  8.451553e-01  1.047326e-01  5.241599e-01
    outer loop
      vertex   8.380954e+00  8.848953e-01  1.422666e+01
      vertex   7.925389e+00  4.440155e-01  1.504931e+01
      vertex   8.421620e+00  4.439945e-01  1.424919e+01
    endloop
  endfacet
  facet normal -6.962797e-01  3.130344e-01  6.459133e-01
    outer loop
      vertex  -6.634596e+00  1.188892e+00  1.635498e+01
      vertex  -7.252964e+00  1.188940e+00  1.568837e+01
      vertex  -7.329620e+00  8.853416e-01  1.575287e+01
    endloop
  endfacet
  facet normal  8.733764e-01 -2.503353e-02 -4.864021e-01
    outer loop
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
      vertex   6.687054e+00 -3.784631e-01  2.567391e-16
      vertex   6.698109e+00  7.242848e-03  5.134781e-16
    endloop
  endfacet
  facet normal -5.819973e-16 -1.763643e-16 -1.000000e+00
    outer loop
      vertex  -6.499778e+00  1.629298e+00  4.440892e-16
      vertex  -5.335880e+00  1.486812e+00 -2.081668e-16
      vertex  -6.510569e+00  1.586219e+00  4.579670e-16
    endloop
  endfacet
  facet normal -2.512875e-01 -9.047461e-01  3.439320e-01
    outer loop
      vertex  -4.864460e+00 -1.949308e+00  1.695544e+01
      vertex  -5.548426e+00 -1.949358e+00  1.645558e+01
      vertex  -5.296856e+00 -2.137640e+00  1.614409e+01
    endloop
  endfacet
  facet normal  3.257423e-02  9.994671e-01  2.080288e-03
    outer loop
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
      vertex   6.943097e-02 -5.576807e+00 -2.003606e-16
      vertex  -3.863586e-01 -5.561952e+00  2.942091e-16
    endloop
  endfacet
  facet normal -6.892234e-01 -6.932264e-01 -2.107327e-01
    outer loop
      vertex  -5.079527e+00 -4.528217e+00  5.953417e-01
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
      vertex  -4.435853e+00 -4.987197e+00  9.714451e-17
    endloop
  endfacet
  facet normal  7.329282e-01  6.788316e-01 -4.476695e-02
    outer loop
      vertex   8.548699e+00  2.224340e+00  6.142745e+00
      vertex   8.666203e+00  2.144281e+00  6.852543e+00
      vertex   8.978265e+00  1.807442e+00  6.853908e+00
    endloop
  endfacet
  facet normal -7.569774e-01  6.211768e-01  2.027920e-01
    outer loop
      vertex  -9.116395e+00  1.468527e+00  1.154942e+01
      vertex  -8.880441e+00  1.468477e+00  1.243033e+01
      vertex  -8.732751e+00  1.663901e+00  1.238302e+01
    endloop
  endfacet
  facet normal  9.897618e-01  9.799425e-02 -1.037724e-01
    outer loop
      vertex   9.468619e+00  9.292984e-01  7.581406e+00
      vertex   9.591737e+00  4.614162e-01  8.313847e+00
      vertex   9.514176e+00  4.699631e-01  7.582161e+00
    endloop
  endfacet
  facet normal  6.808766e-01  7.109041e-01 -1.761318e-01
    outer loop
      vertex   6.618492e+00  3.509832e+00  2.356373e+00
      vertex   6.733425e+00  3.490854e+00  2.724072e+00
      vertex   7.040045e+00  3.195406e+00  2.716892e+00
    endloop
  endfacet
  facet normal -6.404511e-01  4.866498e-01  5.941333e-01
    outer loop
      vertex  -6.525561e+00  1.468224e+00  1.624372e+01
      vertex  -7.133762e+00  1.468275e+00  1.558806e+01
      vertex  -7.252964e+00  1.188940e+00  1.568837e+01
    endloop
  endfacet
  facet normal  7.333341e-01 -6.532789e-01 -1.882758e-01
    outer loop
      vertex   5.619496e+00 -3.913401e+00  5.863152e-01
      vertex   5.197096e+00 -4.602970e+00  1.333733e+00
      vertex   5.078556e+00 -4.523216e+00  5.952883e-01
    endloop
  endfacet
  facet normal -5.746740e-01  6.209064e-01  5.331277e-01
    outer loop
      vertex  -6.417213e+00  1.663426e+00  1.613317e+01
      vertex  -7.133762e+00  1.468275e+00  1.558806e+01
      vertex  -6.525561e+00  1.468224e+00  1.624372e+01
    endloop
  endfacet
  facet normal -4.746829e-01  7.620622e-01  4.403832e-01
    outer loop
      vertex  -6.180614e+00  1.950312e+00  1.589176e+01
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
      vertex  -6.417213e+00  1.663426e+00  1.613317e+01
    endloop
  endfacet
  facet normal  4.795189e-02 -2.864293e-03  9.988456e-01
    outer loop
      vertex   9.220259e-01  4.442120e-01  1.916486e+01
      vertex  -1.942747e-04  4.442348e-01  1.920913e+01
      vertex  -1.960567e-04  5.588531e-04  1.920786e+01
    endloop
  endfacet
  facet normal -5.900036e-01 -2.799035e-03  8.073958e-01
    outer loop
      vertex  -5.301825e+00  4.443703e-01  1.761811e+01
      vertex  -6.046535e+00  7.076263e-04  1.707237e+01
      vertex  -5.301142e+00  6.875992e-04  1.761707e+01
    endloop
  endfacet
  facet normal -3.119988e-01  9.049143e-01  2.894596e-01
    outer loop
      vertex  -5.900717e+00  2.138166e+00  1.560617e+01
      vertex  -6.756639e+00  1.950357e+00  1.527073e+01
      vertex  -6.180614e+00  1.950312e+00  1.589176e+01
    endloop
  endfacet
  facet normal -1.727577e-01  9.718353e-01  1.602831e-01
    outer loop
      vertex  -5.900717e+00  2.138166e+00  1.560617e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
      vertex  -6.450688e+00  2.138182e+00  1.501330e+01
    endloop
  endfacet
  facet normal -9.606597e-01 -1.044703e-01  2.573302e-01
    outer loop
      vertex  -9.168757e+00 -4.428749e-01  1.252270e+01
      vertex  -9.412389e+00 -4.428558e-01  1.161319e+01
      vertex  -9.367053e+00 -8.838062e-01  1.160342e+01
    endloop
  endfacet
  facet normal  4.629822e-02 -9.989225e-01  3.190124e-03
    outer loop
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.255627e+00  2.180864e+00  9.756488e+00
      vertex   8.235993e+00  2.181208e+00  1.014908e+01
    endloop
  endfacet
  facet normal -1.597261e-01 -9.706824e-01  1.796201e-01
    outer loop
      vertex  -5.296856e+00 -2.137640e+00  1.614409e+01
      vertex  -5.901175e+00 -2.137655e+00  1.560662e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
    endloop
  endfacet
  facet normal -1.870011e-01  6.205897e-01  7.615110e-01
    outer loop
      vertex  -1.748968e+00  1.662848e+00  1.858409e+01
      vertex  -2.619798e+00  1.662946e+00  1.837016e+01
      vertex  -2.663953e+00  1.467962e+00  1.851822e+01
    endloop
  endfacet
  facet normal -1.910153e-01 -9.706917e-01  1.458443e-01
    outer loop
      vertex  -6.451189e+00 -2.137671e+00  1.501371e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
    endloop
  endfacet
  facet normal  8.062726e-01 -4.168821e-03 -5.915295e-01
    outer loop
      vertex  -6.561799e+00  2.181341e+00  1.458946e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
    endloop
  endfacet
  facet normal -3.498541e-01  1.346883e-03  9.368032e-01
    outer loop
      vertex   2.787426e+00  6.152181e+00  1.809665e+00
      vertex   2.702310e+00  4.853266e+00  1.779746e+00
      vertex   3.088440e+00  4.607893e+00  1.924301e+00
    endloop
  endfacet
  facet normal -1.446223e-01 -9.694875e-01  1.979350e-01
    outer loop
      vertex  -4.643888e+00 -2.137625e+00  1.662126e+01
      vertex  -5.296856e+00 -2.137640e+00  1.614409e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
    endloop
  endfacet
  facet normal -4.307517e-01 -7.614753e-01  4.843637e-01
    outer loop
      vertex  -5.760451e+00 -1.662422e+00  1.671812e+01
      vertex  -6.181426e+00 -1.949408e+00  1.589257e+01
      vertex  -5.548426e+00 -1.949358e+00  1.645558e+01
    endloop
  endfacet
  facet normal -1.136934e-14 -1.191211e-13 -1.000000e+00
    outer loop
      vertex   6.503150e+00 -1.615171e+00  2.157996e-15
      vertex   5.335972e+00 -1.486529e+00  1.040834e-16
      vertex   6.513909e+00 -1.572044e+00 -3.101686e-15
    endloop
  endfacet
  facet normal -8.591654e-01 -1.270259e-01 -4.956804e-01
    outer loop
      vertex  -6.964637e+00 -8.798046e-01  5.629778e-01
      vertex  -6.653766e+00 -7.855896e-01 -3.986009e-16
      vertex  -6.593333e+00 -1.194343e+00  4.857226e-17
    endloop
  endfacet
  facet normal -5.208135e-01 -6.211389e-01  5.856105e-01
    outer loop
      vertex  -5.856068e+00 -1.470623e+00  1.683652e+01
      vertex  -6.524183e+00 -1.470648e+00  1.624230e+01
      vertex  -6.417627e+00 -1.662502e+00  1.613357e+01
    endloop
  endfacet
  facet normal -8.746416e-01  6.778552e-06  4.847701e-01
    outer loop
      vertex   7.275499e+00  2.936335e+00  5.677919e+00
      vertex   7.163453e+00 -3.024397e+00  5.475844e+00
      vertex   7.276844e+00 -2.937180e+00  5.680428e+00
    endloop
  endfacet
  facet normal  7.548386e-01 -3.131330e-01  5.763388e-01
    outer loop
      vertex   7.887176e+00 -8.843269e-01  1.502296e+01
      vertex   7.252472e+00 -1.189419e+00  1.568848e+01
      vertex   7.804265e+00 -1.189407e+00  1.496580e+01
    endloop
  endfacet
  facet normal -5.801761e-01 -4.876854e-01  6.523487e-01
    outer loop
      vertex  -5.954819e+00 -1.189575e+00  1.695880e+01
      vertex  -6.634205e+00 -1.189585e+00  1.635457e+01
      vertex  -6.524183e+00 -1.470648e+00  1.624230e+01
    endloop
  endfacet
  facet normal  8.433755e-01 -4.875005e-01  2.259670e-01
    outer loop
      vertex   9.268517e+00 -1.189360e+00  1.158263e+01
      vertex   9.028557e+00 -1.189371e+00  1.247821e+01
      vertex   8.879113e+00 -1.470104e+00  1.243032e+01
    endloop
  endfacet
  facet normal  9.839632e-01  2.207445e-07  1.783720e-01
    outer loop
      vertex  -8.154238e+00  2.312090e+00  8.290074e+00
      vertex  -8.154238e+00 -2.311592e+00  8.290080e+00
      vertex  -8.088025e+00 -2.358479e+00  7.924828e+00
    endloop
  endfacet
  facet normal -3.817711e-01  9.049509e-01  1.879219e-01
    outer loop
      vertex  -7.375982e+00  2.138216e+00  1.366973e+01
      vertex  -8.107093e+00  1.950495e+00  1.308844e+01
      vertex  -7.725738e+00  1.950449e+00  1.386340e+01
    endloop
  endfacet
  facet normal  7.426556e-01  4.861170e-01  4.606006e-01
    outer loop
      vertex   8.157441e+00  1.467236e+00  1.410288e+01
      vertex   7.676747e+00  1.467287e+00  1.487788e+01
      vertex   7.804801e+00  1.188002e+00  1.496616e+01
    endloop
  endfacet
  facet normal -6.609229e-01 -1.044821e-01  7.431449e-01
    outer loop
      vertex  -6.047397e+00 -4.429989e-01  1.707344e+01
      vertex  -6.737354e+00 -4.429779e-01  1.645983e+01
      vertex  -6.704895e+00 -8.839283e-01  1.642670e+01
    endloop
  endfacet
  facet normal -6.645575e-01  3.096519e-03  7.472306e-01
    outer loop
      vertex  -6.046535e+00  7.076263e-04  1.707237e+01
      vertex  -6.736389e+00  7.286072e-04  1.645885e+01
      vertex  -6.737354e+00 -4.429779e-01  1.645983e+01
    endloop
  endfacet
  facet normal -6.645582e-01 -2.779584e-03  7.472313e-01
    outer loop
      vertex  -6.047310e+00  4.443913e-01  1.707334e+01
      vertex  -6.736389e+00  7.286072e-04  1.645885e+01
      vertex  -6.046535e+00  7.076263e-04  1.707237e+01
    endloop
  endfacet
  facet normal  6.528194e-01  2.596392e-05  7.575136e-01
    outer loop
      vertex  -5.347189e+00 -4.518198e+00  3.290170e+00
      vertex  -5.344566e+00 -1.140627e+00  3.287794e+00
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
    endloop
  endfacet
  facet normal -8.124581e-01 -4.078805e-01 -4.165879e-01
    outer loop
      vertex  -6.487278e+00 -2.538105e+00  5.717039e-01
      vertex  -6.767282e+00 -2.692802e+00  1.269251e+00
      vertex  -6.961944e+00 -2.297348e+00  1.261705e+00
    endloop
  endfacet
  facet normal -6.645629e-01 -2.766806e-03  7.472273e-01
    outer loop
      vertex  -6.047310e+00  4.443913e-01  1.707334e+01
      vertex  -6.737250e+00  4.444122e-01  1.645972e+01
      vertex  -6.736389e+00  7.286072e-04  1.645885e+01
    endloop
  endfacet
  facet normal -9.753482e-01  2.196861e-01 -2.083295e-02
    outer loop
      vertex   5.353013e+00 -1.098413e+00  3.294899e+00
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
      vertex   5.335972e+00 -1.486529e+00  1.040834e-16
    endloop
  endfacet
  facet normal -9.532408e-16 -1.186739e-15 -1.000000e+00
    outer loop
      vertex  -2.532545e+00 -4.956754e+00 -6.938894e-17
      vertex  -3.097691e+00 -5.910476e+00  1.601150e-15
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
    endloop
  endfacet
  facet normal -6.609089e-01  1.047327e-01  7.431222e-01
    outer loop
      vertex  -6.018102e+00  8.852997e-01  1.703717e+01
      vertex  -6.704711e+00  8.853207e-01  1.642652e+01
      vertex  -6.737250e+00  4.444122e-01  1.645972e+01
    endloop
  endfacet
  facet normal -9.100135e-01 -1.046269e-02 -4.144467e-01
    outer loop
      vertex  -8.083801e+00 -5.270309e-01  2.648676e+00
      vertex  -8.088883e+00 -6.465912e-04  2.646546e+00
      vertex  -7.930489e+00 -5.212479e-01  2.311898e+00
    endloop
  endfacet
  facet normal -2.740218e-01 -7.613758e-01  5.875533e-01
    outer loop
      vertex  -3.465818e+00 -1.662179e+00  1.807279e+01
      vertex  -4.121021e+00 -1.949259e+00  1.739520e+01
      vertex  -3.338233e+00 -1.949209e+00  1.776034e+01
    endloop
  endfacet
  facet normal -1.603694e-17  7.081477e-18 -1.000000e+00
    outer loop
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
      vertex   4.642241e+00 -3.034725e+00 -5.828671e-17
      vertex   5.509706e+00 -3.781196e+00 -7.748432e-17
    endloop
  endfacet
  facet normal -5.209541e-01  6.208514e-01  5.857904e-01
    outer loop
      vertex  -5.760086e+00  1.663332e+00  1.671769e+01
      vertex  -6.525561e+00  1.468224e+00  1.624372e+01
      vertex  -5.857307e+00  1.468172e+00  1.683807e+01
    endloop
  endfacet
  facet normal -6.599835e-01  7.465911e-01 -8.380657e-02
    outer loop
      vertex  -8.234803e+00  2.379526e+00  4.747215e+00
      vertex  -8.404983e+00  2.307024e+00  5.441505e+00
      vertex  -8.069816e+00  2.604250e+00  5.449877e+00
    endloop
  endfacet
  facet normal -1.565995e-01  9.718341e-01  1.761110e-01
    outer loop
      vertex  -5.296445e+00  2.138147e+00  1.614360e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
      vertex  -5.900717e+00  2.138166e+00  1.560617e+01
    endloop
  endfacet
  facet normal -1.446438e-01 -9.694803e-01  1.979551e-01
    outer loop
      vertex  -4.643888e+00 -2.137625e+00  1.662126e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
      vertex  -4.564079e+00 -2.174232e+00  1.650029e+01
    endloop
  endfacet
  facet normal -2.152801e-01 -7.613683e-01  6.115332e-01
    outer loop
      vertex  -2.619959e+00 -1.662099e+00  1.837066e+01
      vertex  -3.465818e+00 -1.662179e+00  1.807279e+01
      vertex  -3.338233e+00 -1.949209e+00  1.776034e+01
    endloop
  endfacet
  facet normal -9.810557e-01 -1.044804e-01  1.631369e-01
    outer loop
      vertex  -9.412389e+00 -4.428558e-01  1.161319e+01
      vertex  -9.517808e+00 -8.837872e-01  1.069684e+01
      vertex  -9.367053e+00 -8.838062e-01  1.160342e+01
    endloop
  endfacet
  facet normal -5.745388e-01 -6.211539e-01  5.329850e-01
    outer loop
      vertex  -6.524183e+00 -1.470648e+00  1.624230e+01
      vertex  -7.015736e+00 -1.662584e+00  1.548874e+01
      vertex  -6.417627e+00 -1.662502e+00  1.613357e+01
    endloop
  endfacet
  facet normal  7.978888e-01  4.906001e-01 -3.502643e-01
    outer loop
      vertex   6.086132e+00  3.255663e+00  5.782843e-01
      vertex   5.917587e+00  3.116910e+00  3.781697e-16
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
    endloop
  endfacet
  facet normal -3.824265e-01 -7.614630e-01  5.233775e-01
    outer loop
      vertex  -5.050360e+00 -1.662342e+00  1.723709e+01
      vertex  -5.760451e+00 -1.662422e+00  1.671812e+01
      vertex  -5.548426e+00 -1.949358e+00  1.645558e+01
    endloop
  endfacet
  facet normal -5.150893e-01 -4.876784e-01  7.048780e-01
    outer loop
      vertex  -5.220737e+00 -1.189564e+00  1.749524e+01
      vertex  -5.856068e+00 -1.470623e+00  1.683652e+01
      vertex  -5.134163e+00 -1.470596e+00  1.736407e+01
    endloop
  endfacet
  facet normal  2.193629e-01  2.000026e-03  9.756413e-01
    outer loop
      vertex  -1.606912e+00 -6.512114e+00  1.482861e+00
      vertex  -1.862915e+00 -5.245935e+00  1.537825e+00
      vertex  -2.006207e+00 -6.413306e+00  1.572435e+00
    endloop
  endfacet
  facet normal -5.821924e-01 -8.034396e-01 -1.246471e-01
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -4.559697e+00 -5.133471e+00  1.359566e+00
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
    endloop
  endfacet
  facet normal  5.128369e-01  8.526185e-01 -1.002000e-01
    outer loop
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
      vertex   3.773587e+00  5.503273e+00 -5.898060e-17
      vertex   3.100696e+00  5.908006e+00  8.482798e-16
    endloop
  endfacet
  facet normal  1.242792e-16 -3.380031e-17 -1.000000e+00
    outer loop
      vertex  -5.921600e+00 -3.112514e+00 -8.326673e-17
      vertex  -6.102031e+00 -2.749480e+00 -1.179612e-16
      vertex  -4.910936e+00 -2.571602e+00  2.405483e-17
    endloop
  endfacet
  facet normal -5.150914e-01 -4.876751e-01  7.048785e-01
    outer loop
      vertex  -5.220737e+00 -1.189564e+00  1.749524e+01
      vertex  -5.954819e+00 -1.189575e+00  1.695880e+01
      vertex  -5.856068e+00 -1.470623e+00  1.683652e+01
    endloop
  endfacet
  facet normal  7.487667e-01  6.420083e-01 -1.648447e-01
    outer loop
      vertex   7.544757e+00  2.836538e+00  3.390997e+00
      vertex   7.742470e+00  2.781343e+00  4.074096e+00
      vertex   8.037576e+00  2.432901e+00  4.057489e+00
    endloop
  endfacet
  facet normal  1.144373e-02 -9.704650e-01  2.409706e-01
    outer loop
      vertex   8.076244e-01 -2.137521e+00  1.797628e+01
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
    endloop
  endfacet
  facet normal -2.469942e-01  9.688668e-01  1.705996e-02
    outer loop
      vertex  -8.376205e+00  2.138299e+00  1.056355e+01
      vertex  -8.235942e+00  2.181364e+00  1.014854e+01
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
    endloop
  endfacet
  facet normal  8.890122e-01 -3.130986e-01  3.341058e-01
    outer loop
      vertex   9.124413e+00 -8.843880e-01  1.250893e+01
      vertex   8.794788e+00 -8.843689e-01  1.338603e+01
      vertex   8.702374e+00 -1.189384e+00  1.334610e+01
    endloop
  endfacet
  facet normal -5.499596e-01  7.625234e-01  3.407382e-01
    outer loop
      vertex  -7.270593e+00  1.950403e+00  1.459744e+01
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
      vertex  -7.547735e+00  1.665148e+00  1.478848e+01
    endloop
  endfacet
  facet normal -5.277929e-01 -8.471982e-01  6.074548e-02
    outer loop
      vertex  -5.576197e+00 -4.323465e+00  3.492194e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
    endloop
  endfacet
  facet normal  6.376030e-01 -7.703621e-01 -2.150614e-03
    outer loop
      vertex   7.248614e+00 -3.143639e+00  3.411612e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
      vertex   6.932614e+00 -3.405245e+00  3.434518e+00
    endloop
  endfacet
  facet normal -5.867745e-01 -1.044756e-01  8.029823e-01
    outer loop
      vertex  -5.301896e+00 -4.430199e-01  1.761821e+01
      vertex  -6.018261e+00 -8.839493e-01  1.703736e+01
      vertex  -5.276351e+00 -8.839722e-01  1.757950e+01
    endloop
  endfacet
  facet normal  8.782104e-01 -7.256071e-02 -4.727383e-01
    outer loop
      vertex   7.557779e+00 -4.951801e-01  1.592813e+00
      vertex   7.752341e+00 -5.106583e-01  1.956629e+00
      vertex   7.712224e+00 -1.016657e+00  1.959770e+00
    endloop
  endfacet
  facet normal -5.867740e-01 -1.044766e-01  8.029825e-01
    outer loop
      vertex  -5.301896e+00 -4.430199e-01  1.761821e+01
      vertex  -6.047397e+00 -4.429989e-01  1.707344e+01
      vertex  -6.018261e+00 -8.839493e-01  1.703736e+01
    endloop
  endfacet
  facet normal -5.899981e-01  3.077299e-03  8.073988e-01
    outer loop
      vertex  -5.301142e+00  6.875992e-04  1.761707e+01
      vertex  -6.047397e+00 -4.429989e-01  1.707344e+01
      vertex  -5.301896e+00 -4.430199e-01  1.761821e+01
    endloop
  endfacet
  facet normal  2.371314e-01 -1.044809e-01  9.658428e-01
    outer loop
      vertex   2.750051e+00 -4.432201e-01  1.880812e+01
      vertex   1.835788e+00 -4.431973e-01  1.903259e+01
      vertex   1.826940e+00 -8.841515e-01  1.898706e+01
    endloop
  endfacet
  facet normal  3.823340e-02 -9.989872e-01  2.372202e-02
    outer loop
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   7.015390e+00  2.181227e+00  1.393177e+01
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
    endloop
  endfacet
  facet normal -6.781510e-15  4.615396e-16 -1.000000e+00
    outer loop
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
      vertex   6.943097e-02 -5.576807e+00 -2.003606e-16
      vertex   1.330639e-01 -5.573392e+00 -6.303118e-16
    endloop
  endfacet
  facet normal -2.206118e-01  9.718305e-01  8.292067e-02
    outer loop
      vertex  -7.740116e+00  2.138235e+00  1.292988e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
      vertex  -8.030187e+00  2.138250e+00  1.215796e+01
    endloop
  endfacet
  facet normal -5.900111e-01 -2.779775e-03  8.073903e-01
    outer loop
      vertex  -5.301825e+00  4.443703e-01  1.761811e+01
      vertex  -6.047310e+00  4.443913e-01  1.707334e+01
      vertex  -6.046535e+00  7.076263e-04  1.707237e+01
    endloop
  endfacet
  facet normal -2.517736e-01 -9.676297e-01  1.740251e-02
    outer loop
      vertex  -8.376802e+00 -2.137806e+00  1.056362e+01
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
      vertex  -8.284958e+00 -2.174232e+00  9.866986e+00
    endloop
  endfacet
  facet normal  5.082648e-01 -8.464767e-01  1.585692e-01
    outer loop
      vertex   6.416894e+00 -3.631935e+00  4.385535e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
      vertex   6.582376e+00 -3.492981e+00  4.596881e+00
    endloop
  endfacet
  facet normal -2.425661e-16  8.074795e-16 -1.000000e+00
    outer loop
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
      vertex  -6.512477e+00 -1.573938e+00 -2.775558e-16
      vertex  -6.593333e+00 -1.194343e+00  4.857226e-17
    endloop
  endfacet
  facet normal -9.602416e-01  4.257395e-03 -2.791381e-01
    outer loop
      vertex  -8.877419e+00 -4.463196e-04  4.714443e+00
      vertex  -9.082709e+00 -2.098083e-05  5.420651e+00
      vertex  -9.080769e+00  5.083599e-01  5.421729e+00
    endloop
  endfacet
  facet normal -5.154381e-01  4.865916e-01  7.053737e-01
    outer loop
      vertex  -5.135251e+00  1.468121e+00  1.736573e+01
      vertex  -5.857307e+00  1.468172e+00  1.683807e+01
      vertex  -5.955170e+00  1.188843e+00  1.695925e+01
    endloop
  endfacet
  facet normal -4.625251e-01  6.208369e-01  6.329550e-01
    outer loop
      vertex  -5.050044e+00  1.663237e+00  1.723664e+01
      vertex  -5.760086e+00  1.663332e+00  1.671769e+01
      vertex  -5.857307e+00  1.468172e+00  1.683807e+01
    endloop
  endfacet
  facet normal -3.820768e-01  7.619602e-01  5.229090e-01
    outer loop
      vertex  -4.863835e+00  1.950220e+00  1.695451e+01
      vertex  -5.760086e+00  1.663332e+00  1.671769e+01
      vertex  -5.050044e+00  1.663237e+00  1.723664e+01
    endloop
  endfacet
  facet normal -1.361474e-01 -3.133163e-01  9.398386e-01
    outer loop
      vertex  -9.179602e-01 -8.840847e-01  1.911872e+01
      vertex  -1.827286e+00 -8.840618e-01  1.898700e+01
      vertex  -1.808037e+00 -1.189526e+00  1.888795e+01
    endloop
  endfacet
  facet normal -8.283930e-01 -3.902624e-01 -4.018212e-01
    outer loop
      vertex  -7.272618e+00 -2.429152e+00  1.969417e+00
      vertex  -7.434761e+00 -2.464277e+00  2.337805e+00
      vertex  -7.642212e+00 -2.020126e+00  2.334112e+00
    endloop
  endfacet
  facet normal  4.014055e-01  3.129826e-01  8.607646e-01
    outer loop
      vertex   4.422884e+00  1.188246e+00  1.796803e+01
      vertex   3.582659e+00  1.188295e+00  1.835983e+01
      vertex   3.620476e+00  8.850479e-01  1.845246e+01
    endloop
  endfacet
  facet normal -3.820747e-01  7.619990e-01  5.228543e-01
    outer loop
      vertex  -4.863835e+00  1.950220e+00  1.695451e+01
      vertex  -5.547705e+00  1.950266e+00  1.645471e+01
      vertex  -5.760086e+00  1.663332e+00  1.671769e+01
    endloop
  endfacet
  facet normal -9.944319e-01  1.051872e-01  6.390496e-03
    outer loop
      vertex  -9.584052e+00  8.985672e-01  9.044879e+00
      vertex  -9.627151e+00  4.464064e-01  9.780823e+00
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
    endloop
  endfacet
  facet normal -5.289726e-01 -8.364729e-01  1.431818e-01
    outer loop
      vertex  -5.926527e+00 -4.048138e+00  3.832550e+00
      vertex  -6.088506e+00 -3.916286e+00  4.004413e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
    endloop
  endfacet
  facet normal -1.390253e-01  9.718333e-01  1.902941e-01
    outer loop
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
      vertex  -5.296445e+00  2.138147e+00  1.614360e+01
    endloop
  endfacet
  facet normal -7.569561e-01  6.212084e-01  2.027748e-01
    outer loop
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
      vertex  -9.116395e+00  1.468527e+00  1.154942e+01
      vertex  -8.732751e+00  1.663901e+00  1.238302e+01
    endloop
  endfacet
  facet normal  8.566238e-01 -4.976720e-01 -1.360821e-01
    outer loop
      vertex   9.076302e+00 -1.444693e+00  6.138244e+00
      vertex   9.215240e+00 -1.401539e+00  6.855026e+00
      vertex   8.979527e+00 -1.806957e+00  6.853909e+00
    endloop
  endfacet
  facet normal -8.451848e-01  1.047351e-01  5.241118e-01
    outer loop
      vertex  -7.887197e+00  8.853626e-01  1.502250e+01
      vertex  -8.421647e+00  4.444752e-01  1.424875e+01
      vertex  -7.925472e+00  4.444542e-01  1.504889e+01
    endloop
  endfacet
  facet normal -1.248082e-01 -9.694766e-01  2.110404e-01
    outer loop
      vertex  -3.934147e+00 -2.137609e+00  1.704107e+01
      vertex  -4.643888e+00 -2.137625e+00  1.662126e+01
      vertex  -4.564079e+00 -2.174232e+00  1.650029e+01
    endloop
  endfacet
  facet normal  5.760061e-01  8.051870e-01  1.410343e-01
    outer loop
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   4.680184e+00  5.115396e+00  2.486569e+00
      vertex   4.773077e+00  4.986311e+00  2.844149e+00
    endloop
  endfacet
  facet normal -4.670751e-01  8.832622e-01  4.109464e-02
    outer loop
      vertex  -7.419713e+00  3.056143e+00  4.093033e+00
      vertex  -7.572854e+00  2.943415e+00  4.775358e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
    endloop
  endfacet
  facet normal -4.111342e-01 -9.048945e-01  1.101571e-01
    outer loop
      vertex  -8.412040e+00 -1.949663e+00  1.228027e+01
      vertex  -8.244216e+00 -2.137755e+00  1.136154e+01
      vertex  -8.030813e+00 -2.137737e+00  1.215816e+01
    endloop
  endfacet
  facet normal -3.300139e-01 -7.614101e-01  5.579835e-01
    outer loop
      vertex  -4.278516e+00 -1.662261e+00  1.769369e+01
      vertex  -4.864460e+00 -1.949308e+00  1.695544e+01
      vertex  -4.121021e+00 -1.949259e+00  1.739520e+01
    endloop
  endfacet
  facet normal -6.030036e-01 -7.976909e-01 -8.709284e-03
    outer loop
      vertex   3.088440e+00  4.607893e+00  1.924301e+00
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
      vertex   3.450360e+00  4.332602e+00  2.080311e+00
    endloop
  endfacet
  facet normal  7.434283e-01  5.979573e-01 -2.996020e-01
    outer loop
      vertex   6.910635e+00  3.199858e+00  2.347902e+00
      vertex   7.327545e+00  2.863512e+00  2.711124e+00
      vertex   7.184754e+00  2.856169e+00  2.342148e+00
    endloop
  endfacet
  facet normal -3.989940e-01 -6.210792e-01  6.745846e-01
    outer loop
      vertex  -4.349491e+00 -1.470572e+00  1.782819e+01
      vertex  -5.050360e+00 -1.662342e+00  1.723709e+01
      vertex  -4.278516e+00 -1.662261e+00  1.769369e+01
    endloop
  endfacet
  facet normal  1.449036e-01 -9.693651e-01  1.983288e-01
    outer loop
      vertex   5.297066e+00 -2.137431e+00  1.614491e+01
      vertex   4.643985e+00 -2.137446e+00  1.662199e+01
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
    endloop
  endfacet
  facet normal -7.552745e-01  6.447970e-01 -1.174625e-01
    outer loop
      vertex  -8.038638e+00  2.434683e+00  4.057520e+00
      vertex  -7.918496e+00  2.703440e+00  4.760324e+00
      vertex  -7.743393e+00  2.783541e+00  4.074136e+00
    endloop
  endfacet
  facet normal  1.251159e-01 -4.876126e-01  8.640487e-01
    outer loop
      vertex   1.807706e+00 -1.189487e+00  1.888808e+01
      vertex   9.079207e-01 -1.189497e+00  1.901836e+01
      vertex   8.928719e-01 -1.470419e+00  1.886201e+01
    endloop
  endfacet
  facet normal -3.989857e-01 -6.210911e-01  6.745786e-01
    outer loop
      vertex  -4.349491e+00 -1.470572e+00  1.782819e+01
      vertex  -5.134163e+00 -1.470596e+00  1.736407e+01
      vertex  -5.050360e+00 -1.662342e+00  1.723709e+01
    endloop
  endfacet
  facet normal  6.311448e-01  3.129700e-01  7.097225e-01
    outer loop
      vertex   6.634518e+00  1.188099e+00  1.635548e+01
      vertex   6.017879e+00  8.849792e-01  1.703752e+01
      vertex   6.704513e+00  8.849583e-01  1.642692e+01
    endloop
  endfacet
  facet normal -5.062942e-01 -1.044748e-01  8.560088e-01
    outer loop
      vertex  -4.491577e+00 -4.430428e-01  1.809748e+01
      vertex  -5.276351e+00 -8.839722e-01  1.757950e+01
      vertex  -4.469936e+00 -8.839931e-01  1.805646e+01
    endloop
  endfacet
  facet normal -9.573999e-01 -8.441120e-02 -2.761524e-01
    outer loop
      vertex  -9.081449e+00 -5.084209e-01  5.421712e+00
      vertex  -8.833016e+00 -1.031654e+00  4.720353e+00
      vertex  -9.038230e+00 -1.008003e+00  5.424583e+00
    endloop
  endfacet
  facet normal  7.948179e-01 -5.997237e-01 -9.271417e-02
    outer loop
      vertex   8.691527e+00 -1.928049e+00  5.434463e+00
      vertex   8.550247e+00 -2.224781e+00  6.142717e+00
      vertex   8.406335e+00 -2.307093e+00  5.441423e+00
    endloop
  endfacet
  facet normal -5.062973e-01 -1.044680e-01  8.560079e-01
    outer loop
      vertex  -4.491577e+00 -4.430428e-01  1.809748e+01
      vertex  -5.301896e+00 -4.430199e-01  1.761821e+01
      vertex  -5.276351e+00 -8.839722e-01  1.757950e+01
    endloop
  endfacet
  facet normal -6.111142e-02 -9.046054e-01  4.218464e-01
    outer loop
      vertex  -8.463282e-01 -1.949060e+00  1.837478e+01
      vertex  -1.608277e+00 -2.137565e+00  1.786017e+01
      vertex  -8.079415e-01 -2.137550e+00  1.797614e+01
    endloop
  endfacet
  facet normal -5.090783e-01  3.061849e-03  8.607148e-01
    outer loop
      vertex  -4.490940e+00  6.666183e-04  1.809628e+01
      vertex  -5.301896e+00 -4.430199e-01  1.761821e+01
      vertex  -4.491577e+00 -4.430428e-01  1.809748e+01
    endloop
  endfacet
  facet normal  9.099512e-01 -1.266365e-02 -4.145221e-01
    outer loop
      vertex   7.929991e+00 -5.209370e-01  2.311893e+00
      vertex   7.936329e+00 -2.689362e-04  2.309899e+00
      vertex   8.083327e+00 -5.267620e-01  2.648672e+00
    endloop
  endfacet
  facet normal -9.428513e-01  2.591932e-01 -2.094046e-01
    outer loop
      vertex  -9.037185e+00  1.008070e+00  5.424614e+00
      vertex  -9.075479e+00  1.445339e+00  6.138269e+00
      vertex  -8.906251e+00  1.487829e+00  5.428909e+00
    endloop
  endfacet
  facet normal -8.816226e-01  1.654263e-02 -4.716650e-01
    outer loop
      vertex  -7.378439e+00  1.985550e-03  1.241728e+00
      vertex  -7.565663e+00  1.035690e-03  1.591647e+00
      vertex  -7.556970e+00  4.972897e-01  1.592804e+00
    endloop
  endfacet
  facet normal -1.636844e-01 -9.694768e-01  1.825435e-01
    outer loop
      vertex  -5.296856e+00 -2.137640e+00  1.614409e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
    endloop
  endfacet
  facet normal  1.382459e-16 -5.467760e-16 -1.000000e+00
    outer loop
      vertex  -3.793262e+00 -5.489933e+00  6.765422e-16
      vertex  -4.409382e+00 -5.011184e+00  3.295975e-16
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
    endloop
  endfacet
  facet normal -5.062863e-01  1.047314e-01  8.559822e-01
    outer loop
      vertex  -4.469825e+00  8.852539e-01  1.805627e+01
      vertex  -5.276216e+00  8.852768e-01  1.757931e+01
      vertex  -5.301825e+00  4.443703e-01  1.761811e+01
    endloop
  endfacet
  facet normal -4.447522e-01  4.865423e-01  7.519788e-01
    outer loop
      vertex  -4.350411e+00  1.468069e+00  1.782996e+01
      vertex  -5.221046e+00  1.188795e+00  1.749572e+01
      vertex  -4.423090e+00  1.188745e+00  1.796770e+01
    endloop
  endfacet
  facet normal  8.498975e-01 -2.857429e-01 -4.427473e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   6.962789e+00 -2.295359e+00  1.261698e+00
      vertex   6.651994e+00 -2.146391e+00  5.689535e-01
    endloop
  endfacet
  facet normal  1.727410e-01  9.718395e-01  1.602763e-01
    outer loop
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   5.901123e+00  2.137865e+00  1.560709e+01
    endloop
  endfacet
  facet normal -7.335663e-01 -6.212018e-01  2.756608e-01
    outer loop
      vertex  -8.878583e+00 -1.470785e+00  1.242973e+01
      vertex  -8.733365e+00 -1.662915e+00  1.238321e+01
      vertex  -8.557884e+00 -1.470757e+00  1.328322e+01
    endloop
  endfacet
  facet normal -9.403093e-01  3.401640e-01  1.032655e-02
    outer loop
      vertex  -9.584052e+00  8.985672e-01  9.044879e+00
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
    endloop
  endfacet
  facet normal -1.509322e-15 -4.420918e-18 -1.000000e+00
    outer loop
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
      vertex  -3.863586e-01 -5.561952e+00  2.942091e-16
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
    endloop
  endfacet
  facet normal  5.447069e-01 -8.240172e-01  1.558523e-01
    outer loop
      vertex   4.773260e+00 -4.990042e+00  2.844279e+00
      vertex   4.719419e+00 -5.032785e+00  2.806460e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
    endloop
  endfacet
  facet normal  4.753381e-01  7.612683e-01  4.410492e-01
    outer loop
      vertex   6.757576e+00  1.949507e+00  1.527199e+01
      vertex   6.181304e+00  1.949553e+00  1.589299e+01
      vertex   6.417946e+00  1.661885e+00  1.613447e+01
    endloop
  endfacet
  facet normal  5.905818e-01  8.061362e-01  3.684719e-02
    outer loop
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
      vertex   6.929443e+00  3.401724e+00  3.434681e+00
    endloop
  endfacet
  facet normal -7.507171e-01  6.604885e-01 -1.336806e-02
    outer loop
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   4.250867e+00 -3.512360e+00  2.503091e+00
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
    endloop
  endfacet
  facet normal -2.166960e-01  9.048655e-01  3.664167e-01
    outer loop
      vertex  -3.933839e+00  2.138109e+00  1.704051e+01
      vertex  -4.863835e+00  1.950220e+00  1.695451e+01
      vertex  -4.120495e+00  1.950171e+00  1.739424e+01
    endloop
  endfacet
  facet normal  1.353838e-01 -9.907849e-01  4.062127e-03
    outer loop
      vertex   8.060707e-01 -6.644463e+00  1.364411e+00
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   1.128407e+00 -6.600262e+00  1.402431e+00
    endloop
  endfacet
  facet normal -9.445273e-01 -3.153026e-01 -9.193607e-02
    outer loop
      vertex  -9.322753e+00 -1.365467e+00  7.579388e+00
      vertex  -9.545940e+00 -9.107361e-01  8.312819e+00
      vertex  -9.468905e+00 -9.282398e-01  7.581413e+00
    endloop
  endfacet
  facet normal  4.917295e-01 -8.650727e-01  9.925248e-02
    outer loop
      vertex   8.071296e+00 -2.604301e+00  5.449783e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
    endloop
  endfacet
  facet normal -2.166958e-01  9.048734e-01  3.663974e-01
    outer loop
      vertex  -3.933839e+00  2.138109e+00  1.704051e+01
      vertex  -4.643528e+00  2.138128e+00  1.662074e+01
      vertex  -4.863835e+00  1.950220e+00  1.695451e+01
    endloop
  endfacet
  facet normal -6.864464e-01 -7.159405e-01 -1.273598e-01
    outer loop
      vertex  -5.944186e+00 -4.109646e+00  2.036141e+00
      vertex  -6.022293e+00 -4.098753e+00  2.395890e+00
      vertex  -6.623233e+00 -3.515539e+00  2.356373e+00
    endloop
  endfacet
  facet normal -4.109595e-01  9.049796e-01  1.101100e-01
    outer loop
      vertex  -8.243571e+00  2.138269e+00  1.136140e+01
      vertex  -8.634320e+00  1.950586e+00  1.144556e+01
      vertex  -8.030187e+00  2.138250e+00  1.215796e+01
    endloop
  endfacet
  facet normal -3.940421e-01 -9.180568e-01 -4.361561e-02
    outer loop
      vertex  -2.367681e+00 -6.277615e+00  6.327448e-01
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
    endloop
  endfacet
  facet normal -1.046081e-01 -9.694447e-01  2.218875e-01
    outer loop
      vertex  -3.186847e+00 -2.137594e+00  1.738963e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
    endloop
  endfacet
  facet normal -6.368268e-01 -7.702631e-01 -3.385703e-02
    outer loop
      vertex  -5.316499e+00 -4.668179e+00  2.075112e+00
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
      vertex  -6.022293e+00 -4.098753e+00  2.395890e+00
    endloop
  endfacet
  facet normal  9.309299e-01  1.047283e-01  3.498593e-01
    outer loop
      vertex   9.124373e+00  8.848534e-01  1.250891e+01
      vertex   8.837411e+00  4.439754e-01  1.340445e+01
      vertex   9.168643e+00  4.439545e-01  1.252310e+01
    endloop
  endfacet
  facet normal -9.976310e-01 -2.695240e-03  6.874063e-02
    outer loop
      vertex  -9.563660e+00  4.445534e-01  1.070219e+01
      vertex  -9.627151e+00  4.464064e-01  9.780823e+00
      vertex  -9.562470e+00  8.621216e-04  1.070205e+01
    endloop
  endfacet
  facet normal  9.374511e-01  3.479589e-01  1.049020e-02
    outer loop
      vertex   9.427593e+00  1.298067e+00  9.776810e+00
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
      vertex   9.584334e+00  8.978500e-01  9.044880e+00
    endloop
  endfacet
  facet normal -8.434871e-01  2.845273e-01 -4.556025e-01
    outer loop
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
      vertex  -6.387031e+00  2.021261e+00  3.261280e-16
      vertex  -6.400501e+00  1.981328e+00 -4.718448e-16
    endloop
  endfacet
  facet normal -1.015834e-01 -9.706851e-01  2.178335e-01
    outer loop
      vertex  -3.186847e+00 -2.137594e+00  1.738963e+01
      vertex  -3.934147e+00 -2.137609e+00  1.704107e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
    endloop
  endfacet
  facet normal -3.019448e-01  1.642941e-03  9.533240e-01
    outer loop
      vertex   2.392633e+00  6.292719e+00  1.679182e+00
      vertex   2.293362e+00  5.066713e+00  1.649853e+00
      vertex   2.702310e+00  4.853266e+00  1.779746e+00
    endloop
  endfacet
  facet normal  9.986122e-01 -1.608040e-03 -5.264071e-02
    outer loop
      vertex   9.591737e+00  4.614162e-01  8.313847e+00
      vertex   9.629588e+00  6.732941e-04  9.045974e+00
      vertex   9.591002e+00  7.381439e-04  8.313971e+00
    endloop
  endfacet
  facet normal -9.678606e-01 -8.508916e-02 -2.366548e-01
    outer loop
      vertex  -9.081449e+00 -5.084209e-01  5.421712e+00
      vertex  -9.038230e+00 -1.008003e+00  5.424583e+00
      vertex  -9.257167e+00 -4.944229e-01  6.135324e+00
    endloop
  endfacet
  facet normal  9.679359e-01  2.501257e-01 -2.317908e-02
    outer loop
      vertex  -5.207044e+00 -1.683388e+00  3.173630e+00
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
      vertex  -5.344566e+00 -1.140627e+00  3.287794e+00
    endloop
  endfacet
  facet normal -1.800655e-01 -9.046910e-01  3.861485e-01
    outer loop
      vertex  -3.338233e+00 -1.949209e+00  1.776034e+01
      vertex  -4.121021e+00 -1.949259e+00  1.739520e+01
      vertex  -3.934147e+00 -2.137609e+00  1.704107e+01
    endloop
  endfacet
  facet normal  7.904715e-01 -1.044815e-01  6.035216e-01
    outer loop
      vertex   7.925358e+00 -4.433708e-01  1.504929e+01
      vertex   7.365021e+00 -4.433498e-01  1.578320e+01
      vertex   7.329536e+00 -8.843060e-01  1.575334e+01
    endloop
  endfacet
  facet normal -8.709167e-01 -4.877456e-01  6.006939e-02
    outer loop
      vertex  -9.261168e+00 -1.470842e+00  1.066687e+01
      vertex  -9.479942e+00 -1.189680e+00  9.777925e+00
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
    endloop
  endfacet
  facet normal -2.739919e-01 -7.614008e-01  5.875349e-01
    outer loop
      vertex  -3.465818e+00 -1.662179e+00  1.807279e+01
      vertex  -4.278516e+00 -1.662261e+00  1.769369e+01
      vertex  -4.121021e+00 -1.949259e+00  1.739520e+01
    endloop
  endfacet
  facet normal -3.312710e-01 -6.210783e-01  7.102966e-01
    outer loop
      vertex  -3.523293e+00 -1.470545e+00  1.821354e+01
      vertex  -4.278516e+00 -1.662261e+00  1.769369e+01
      vertex  -3.465818e+00 -1.662179e+00  1.807279e+01
    endloop
  endfacet
  facet normal -3.690238e-01 -4.876367e-01  7.912217e-01
    outer loop
      vertex  -3.582696e+00 -1.189545e+00  1.835902e+01
      vertex  -4.349491e+00 -1.470572e+00  1.782819e+01
      vertex  -3.523293e+00 -1.470545e+00  1.821354e+01
    endloop
  endfacet
  facet normal  1.199502e-01  9.718334e-01  2.028590e-01
    outer loop
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   3.933867e+00  2.137918e+00  1.704117e+01
    endloop
  endfacet
  facet normal -4.013958e-01 -3.133443e-01  8.606375e-01
    outer loop
      vertex  -3.620850e+00 -8.840160e-01  1.845246e+01
      vertex  -4.469936e+00 -8.839931e-01  1.805646e+01
      vertex  -4.422828e+00 -1.189554e+00  1.796718e+01
    endloop
  endfacet
  facet normal  8.744545e-01  7.364012e-02 -4.794855e-01
    outer loop
      vertex   7.331723e+00  9.546490e-01  1.245735e+00
      vertex   7.370080e+00  4.802914e-01  1.242837e+00
      vertex   6.963074e+00  8.865833e-01  5.629635e-01
    endloop
  endfacet
  facet normal  5.525037e-01 -8.283368e-01 -9.272409e-02
    outer loop
      vertex   4.558254e+00 -5.128565e+00  1.359461e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
      vertex   3.872465e+00 -5.588881e+00  1.385299e+00
    endloop
  endfacet
  facet normal  9.055769e-01 -4.236952e-01 -2.031526e-02
    outer loop
      vertex  -5.043293e+00  2.145937e+00  3.044073e+00
      vertex  -4.930842e+00  2.532238e+00 -4.510281e-16
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
    endloop
  endfacet
  facet normal  3.110865e-02 -7.612832e-01  6.476728e-01
    outer loop
      vertex   8.783308e-01 -1.661779e+00  1.871092e+01
      vertex  -1.906334e-04 -1.661858e+00  1.875303e+01
      vertex  -1.826766e-04 -1.949013e+00  1.841550e+01
    endloop
  endfacet
  facet normal  2.324207e-01 -9.706191e-01  6.228212e-02
    outer loop
      vertex   8.245609e+00 -2.137315e+00  1.136222e+01
      vertex   8.032036e+00 -2.137334e+00  1.215893e+01
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
    endloop
  endfacet
  facet normal -6.609088e-01  1.047324e-01  7.431222e-01
    outer loop
      vertex  -6.018102e+00  8.852997e-01  1.703717e+01
      vertex  -6.737250e+00  4.444122e-01  1.645972e+01
      vertex  -6.047310e+00  4.443913e-01  1.707334e+01
    endloop
  endfacet
  facet normal  8.451016e-01 -5.252736e-01 -9.945321e-02
    outer loop
      vertex   9.215240e+00 -1.401539e+00  6.855026e+00
      vertex   9.322818e+00 -1.365606e+00  7.579388e+00
      vertex   9.079329e+00 -1.756750e+00  7.576222e+00
    endloop
  endfacet
  facet normal  2.811235e-02 -9.988696e-01  3.832984e-02
    outer loop
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   4.869976e+00  2.181246e+00  1.624597e+01
      vertex   4.545978e+00  2.180859e+00  1.647351e+01
    endloop
  endfacet
  facet normal -4.203641e-01 -1.044750e-01  9.013207e-01
    outer loop
      vertex  -3.638380e+00 -4.430637e-01  1.849540e+01
      vertex  -4.469936e+00 -8.839931e-01  1.805646e+01
      vertex  -3.620850e+00 -8.840160e-01  1.845246e+01
    endloop
  endfacet
  facet normal -4.203653e-01 -1.044725e-01  9.013205e-01
    outer loop
      vertex  -3.638380e+00 -4.430637e-01  1.849540e+01
      vertex  -4.491577e+00 -4.430428e-01  1.809748e+01
      vertex  -4.469936e+00 -8.839931e-01  1.805646e+01
    endloop
  endfacet
  facet normal -8.452045e-01 -1.044702e-01  5.241330e-01
    outer loop
      vertex  -7.925608e+00 -4.429359e-01  1.504898e+01
      vertex  -8.421803e+00 -4.429150e-01  1.424883e+01
      vertex  -8.381232e+00 -8.838654e-01  1.422637e+01
    endloop
  endfacet
  facet normal -4.226767e-01 -2.816684e-03  9.062762e-01
    outer loop
      vertex  -3.638337e+00  4.443245e-01  1.849530e+01
      vertex  -4.490940e+00  6.666183e-04  1.809628e+01
      vertex  -3.637867e+00  6.446838e-04  1.849414e+01
    endloop
  endfacet
  facet normal -4.226817e-01 -2.804713e-03  9.062738e-01
    outer loop
      vertex  -3.638337e+00  4.443245e-01  1.849530e+01
      vertex  -4.491520e+00  4.443474e-01  1.809738e+01
      vertex  -4.490940e+00  6.666183e-04  1.809628e+01
    endloop
  endfacet
  facet normal -4.244522e-01 -9.049698e-01  2.949722e-02
    outer loop
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
      vertex  -8.376802e+00 -2.137806e+00  1.056362e+01
    endloop
  endfacet
  facet normal  9.403367e-01 -3.277669e-01 -9.130006e-02
    outer loop
      vertex   9.468694e+00 -9.287109e-01  7.581409e+00
      vertex   9.545779e+00 -9.112930e-01  8.312814e+00
      vertex   9.396529e+00 -1.338722e+00  8.310096e+00
    endloop
  endfacet
  facet normal -8.461874e-01  2.386353e-01 -4.764663e-01
    outer loop
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
      vertex  -6.400501e+00  1.981328e+00 -4.718448e-16
      vertex  -6.499778e+00  1.629298e+00  4.440892e-16
    endloop
  endfacet
  facet normal -4.014346e-01  3.130069e-01  8.607421e-01
    outer loop
      vertex  -3.582908e+00  1.188694e+00  1.835956e+01
      vertex  -4.423090e+00  1.188745e+00  1.796770e+01
      vertex  -4.469825e+00  8.852539e-01  1.805627e+01
    endloop
  endfacet
  facet normal  2.043441e-02 -9.045571e-01  4.258625e-01
    outer loop
      vertex   8.459943e-01 -1.948963e+00  1.837494e+01
      vertex  -1.725861e-04 -2.137535e+00  1.801501e+01
      vertex   8.076244e-01 -2.137521e+00  1.797628e+01
    endloop
  endfacet
  facet normal -3.692699e-01  4.865078e-01  7.918017e-01
    outer loop
      vertex  -3.524038e+00  1.468016e+00  1.821539e+01
      vertex  -4.423090e+00  1.188745e+00  1.796770e+01
      vertex  -3.582908e+00  1.188694e+00  1.835956e+01
    endloop
  endfacet
  facet normal -3.692730e-01  4.865323e-01  7.917852e-01
    outer loop
      vertex  -3.524038e+00  1.468016e+00  1.821539e+01
      vertex  -4.350411e+00  1.468069e+00  1.782996e+01
      vertex  -4.423090e+00  1.188745e+00  1.796770e+01
    endloop
  endfacet
  facet normal  4.001957e-01  1.578092e-03  9.164283e-01
    outer loop
      vertex  -3.411066e+00  5.884436e+00  2.062481e+00
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
    endloop
  endfacet
  facet normal -6.660054e-01 -6.211728e-01  4.130149e-01
    outer loop
      vertex  -7.674814e+00 -1.470701e+00  1.487608e+01
      vertex  -8.021980e+00 -1.662747e+00  1.402742e+01
      vertex  -7.549392e+00 -1.662664e+00  1.478962e+01
    endloop
  endfacet
  facet normal -1.799323e-01  9.048604e-01  3.858135e-01
    outer loop
      vertex  -3.186596e+00  2.138090e+00  1.738905e+01
      vertex  -3.933839e+00  2.138109e+00  1.704051e+01
      vertex  -4.120495e+00  1.950171e+00  1.739424e+01
    endloop
  endfacet
  facet normal  8.432149e-01  2.865093e-01 -4.548636e-01
    outer loop
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
      vertex   6.398841e+00  1.977925e+00 -1.609823e-15
    endloop
  endfacet
  facet normal -8.145682e-02 -9.694474e-01  2.313797e-01
    outer loop
      vertex  -2.409062e+00 -2.137579e+00  1.766348e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
    endloop
  endfacet
  facet normal  4.674207e-01  8.804007e-01  8.007772e-02
    outer loop
      vertex   7.572250e+00  2.941378e+00  4.775318e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
    endloop
  endfacet
  facet normal -5.867626e-01  1.047283e-01  8.029581e-01
    outer loop
      vertex  -5.276216e+00  8.852768e-01  1.757931e+01
      vertex  -6.018102e+00  8.852997e-01  1.703717e+01
      vertex  -6.047310e+00  4.443913e-01  1.707334e+01
    endloop
  endfacet
  facet normal -1.415171e-01 -9.046488e-01  4.019746e-01
    outer loop
      vertex  -2.523508e+00 -1.949160e+00  1.804723e+01
      vertex  -3.186847e+00 -2.137594e+00  1.738963e+01
      vertex  -2.409062e+00 -2.137579e+00  1.766348e+01
    endloop
  endfacet
  facet normal -2.152983e-01 -7.613521e-01  6.115470e-01
    outer loop
      vertex  -2.619959e+00 -1.662099e+00  1.837066e+01
      vertex  -3.338233e+00 -1.949209e+00  1.776034e+01
      vertex  -2.523508e+00 -1.949160e+00  1.804723e+01
    endloop
  endfacet
  facet normal  7.830825e-01  6.195650e-01  5.404767e-02
    outer loop
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
      vertex   9.263976e+00  1.467035e+00  1.066768e+01
      vertex   9.325606e+00  1.466988e+00  9.775280e+00
    endloop
  endfacet
  facet normal -3.153630e-01 -3.133294e-01  8.957516e-01
    outer loop
      vertex  -2.737131e+00 -8.840389e-01  1.876358e+01
      vertex  -3.582696e+00 -1.189545e+00  1.835902e+01
      vertex  -2.708294e+00 -1.189535e+00  1.866687e+01
    endloop
  endfacet
  facet normal  2.516870e-01 -9.044389e-01  3.444473e-01
    outer loop
      vertex   5.548748e+00 -1.948668e+00  1.645657e+01
      vertex   4.864637e+00 -1.948717e+00  1.695632e+01
      vertex   4.643985e+00 -2.137446e+00  1.662199e+01
    endloop
  endfacet
  facet normal -9.409336e-01 -3.283178e-01 -8.277297e-02
    outer loop
      vertex  -9.322753e+00 -1.365467e+00  7.579388e+00
      vertex  -9.396447e+00 -1.338486e+00  8.310097e+00
      vertex  -9.545940e+00 -9.107361e-01  8.312819e+00
    endloop
  endfacet
  facet normal  8.377278e-01 -5.093469e-01 -1.969208e-01
    outer loop
      vertex   8.290786e+00 -2.018566e+00  4.043255e+00
      vertex   8.236308e+00 -2.380280e+00  4.747092e+00
      vertex   8.040294e+00 -2.436008e+00  4.057366e+00
    endloop
  endfacet
  facet normal -1.674365e-01 -9.858827e-01  6.097636e-04
    outer loop
      vertex   9.514104e-01  5.493269e+00  1.380087e+00
      vertex   9.072288e-01  5.499919e+00  6.370290e-17
      vertex   9.901700e-01  5.485833e+00 -1.118897e-16
    endloop
  endfacet
  facet normal -3.302615e-01 -1.044743e-01  9.380898e-01
    outer loop
      vertex  -2.750383e+00 -4.430866e-01  1.880802e+01
      vertex  -3.620850e+00 -8.840160e-01  1.845246e+01
      vertex  -2.737131e+00 -8.840389e-01  1.876358e+01
    endloop
  endfacet
  facet normal -3.302621e-01 -1.044732e-01  9.380897e-01
    outer loop
      vertex  -2.750383e+00 -4.430866e-01  1.880802e+01
      vertex  -3.638380e+00 -4.430637e-01  1.849540e+01
      vertex  -3.620850e+00 -8.840160e-01  1.845246e+01
    endloop
  endfacet
  facet normal  5.899658e-01  2.939412e-03  8.074229e-01
    outer loop
      vertex   6.046260e+00  4.100800e-04  1.707267e+01
      vertex   5.300865e+00  4.310608e-04  1.761731e+01
      vertex   5.301583e+00 -4.432869e-01  1.761840e+01
    endloop
  endfacet
  facet normal -8.384500e-01 -2.944621e-01 -4.585778e-01
    outer loop
      vertex  -6.650954e+00 -2.148561e+00  5.689487e-01
      vertex  -6.397487e+00 -1.984235e+00  1.539173e-16
      vertex  -6.260275e+00 -2.374932e+00 -9.714451e-17
    endloop
  endfacet
  facet normal  9.289638e-02  7.615578e-01  6.414047e-01
    outer loop
      vertex   1.684247e+00  1.949839e+00  1.825264e+01
      vertex   8.782997e-01  1.662560e+00  1.871046e+01
      vertex   1.748731e+00  1.662465e+00  1.858451e+01
    endloop
  endfacet
  facet normal  1.433143e-01  2.997307e-03  9.896727e-01
    outer loop
      vertex   1.835537e+00  5.168915e-04  1.903129e+01
      vertex   9.219017e-01  5.378723e-04  1.916359e+01
      vertex   9.220275e-01 -4.431763e-01  1.916492e+01
    endloop
  endfacet
  facet normal -6.962798e-01  3.130395e-01  6.459108e-01
    outer loop
      vertex  -6.634596e+00  1.188892e+00  1.635498e+01
      vertex  -7.329620e+00  8.853416e-01  1.575287e+01
      vertex  -6.704711e+00  8.853207e-01  1.642652e+01
    endloop
  endfacet
  facet normal  3.621832e-01  9.046341e-01  2.246345e-01
    outer loop
      vertex   7.376937e+00  2.137812e+00  1.367065e+01
      vertex   7.271794e+00  1.949461e+00  1.459869e+01
      vertex   7.727200e+00  1.949415e+00  1.386461e+01
    endloop
  endfacet
  facet normal  6.267678e-01 -7.608889e-01  1.679587e-01
    outer loop
      vertex   8.967391e+00 -1.660718e+00  1.151774e+01
      vertex   8.413611e+00 -1.948362e+00  1.228117e+01
      vertex   8.637318e+00 -1.948309e+00  1.144662e+01
    endloop
  endfacet
  facet normal -8.143819e-02 -9.694566e-01  2.313475e-01
    outer loop
      vertex  -2.409062e+00 -2.137579e+00  1.766348e+01
      vertex  -3.186847e+00 -2.137594e+00  1.738963e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
    endloop
  endfacet
  facet normal  8.596594e-01 -1.253335e-01 -4.952547e-01
    outer loop
      vertex   6.963712e+00 -8.787937e-01  5.629530e-01
      vertex   6.594516e+00 -1.186593e+00 -2.079145e-15
      vertex   6.652763e+00 -7.870749e-01 -3.087808e-16
    endloop
  endfacet
  facet normal -3.320753e-01  3.039206e-03  9.432480e-01
    outer loop
      vertex  -2.749995e+00  6.237030e-04  1.880673e+01
      vertex  -3.638380e+00 -4.430637e-01  1.849540e+01
      vertex  -2.750383e+00 -4.430866e-01  1.880802e+01
    endloop
  endfacet
  facet normal -9.882283e-01  1.019865e-03 -1.529826e-01
    outer loop
      vertex  -9.401813e+00  6.008148e-04  6.855484e+00
      vertex  -9.513821e+00  4.703484e-01  7.582159e+00
      vertex  -9.401338e+00  4.816837e-01  6.855623e+00
    endloop
  endfacet
  facet normal -9.715837e-01 -2.357397e-01 -2.125878e-02
    outer loop
      vertex   5.344658e+00  1.140909e+00  3.287793e+00
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
    endloop
  endfacet
  facet normal -3.320829e-01  3.056225e-03  9.432452e-01
    outer loop
      vertex  -2.749995e+00  6.237030e-04  1.880673e+01
      vertex  -3.637867e+00  6.446838e-04  1.849414e+01
      vertex  -3.638380e+00 -4.430637e-01  1.849540e+01
    endloop
  endfacet
  facet normal  9.120058e-01 -2.175657e-01 -3.477222e-01
    outer loop
      vertex   8.333261e+00 -1.052835e+00  3.334583e+00
      vertex   8.597154e+00 -1.047232e+00  4.023216e+00
      vertex   8.480577e+00 -1.549639e+00  4.031807e+00
    endloop
  endfacet
  facet normal -3.320853e-01 -2.817364e-03  9.432452e-01
    outer loop
      vertex  -2.750353e+00  4.443016e-01  1.880793e+01
      vertex  -3.638337e+00  4.443245e-01  1.849530e+01
      vertex  -3.637867e+00  6.446838e-04  1.849414e+01
    endloop
  endfacet
  facet normal -5.604324e-01  9.531034e-05  8.282002e-01
    outer loop
      vertex   4.719419e+00 -5.032785e+00  2.806460e+00
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
      vertex   4.533190e+00 -5.176903e+00  2.680458e+00
    endloop
  endfacet
  facet normal -3.302579e-01  1.047316e-01  9.380624e-01
    outer loop
      vertex  -2.737066e+00  8.852081e-01  1.876338e+01
      vertex  -3.638337e+00  4.443245e-01  1.849530e+01
      vertex  -2.750353e+00  4.443016e-01  1.880793e+01
    endloop
  endfacet
  facet normal  4.775087e-02 -3.804251e-02  9.981346e-01
    outer loop
      vertex   9.427947e+00 -1.297487e+00  9.776816e+00
      vertex   9.480363e+00 -1.189333e+00  9.778431e+00
      vertex   9.323505e+00 -1.470018e+00  9.775237e+00
    endloop
  endfacet
  facet normal -3.302571e-01  1.047297e-01  9.380629e-01
    outer loop
      vertex  -2.737066e+00  8.852081e-01  1.876338e+01
      vertex  -3.620762e+00  8.852310e-01  1.845226e+01
      vertex  -3.638337e+00  4.443245e-01  1.849530e+01
    endloop
  endfacet
  facet normal -9.449104e-01 -8.091774e-02 -3.171698e-01
    outer loop
      vertex  -8.875355e+00 -5.201721e-01  4.715995e+00
      vertex  -8.597669e+00 -1.047401e+00  4.023223e+00
      vertex  -8.833016e+00 -1.031654e+00  4.720353e+00
    endloop
  endfacet
  facet normal -3.153920e-01  3.130015e-01  8.958560e-01
    outer loop
      vertex  -2.708452e+00  1.188644e+00  1.866744e+01
      vertex  -3.620762e+00  8.852310e-01  1.845226e+01
      vertex  -2.737066e+00  8.852081e-01  1.876338e+01
    endloop
  endfacet
  facet normal  4.755347e-01 -7.610772e-01  4.411668e-01
    outer loop
      vertex   7.016542e+00 -1.661133e+00  1.548994e+01
      vertex   6.418201e+00 -1.661215e+00  1.613475e+01
      vertex   6.181915e+00 -1.948618e+00  1.589363e+01
    endloop
  endfacet
  facet normal  5.090457e-01  2.939651e-03  8.607345e-01
    outer loop
      vertex   5.300865e+00  4.310608e-04  1.761731e+01
      vertex   4.491258e+00 -4.432640e-01  1.809764e+01
      vertex   5.301583e+00 -4.432869e-01  1.761840e+01
    endloop
  endfacet
  facet normal -7.490327e-01  5.911953e-01 -2.990619e-01
    outer loop
      vertex  -6.666580e+00  3.125719e+00  1.631697e+00
      vertex  -6.517076e+00  3.502085e+00  2.001261e+00
      vertex  -6.411795e+00  3.454931e+00  1.644359e+00
    endloop
  endfacet
  facet normal -1.433681e-01 -2.834040e-03  9.896654e-01
    outer loop
      vertex  -9.223928e-01  4.442577e-01  1.916481e+01
      vertex  -1.836113e+00  4.442806e-01  1.903244e+01
      vertex  -1.835874e+00  6.017685e-04  1.903121e+01
    endloop
  endfacet
  facet normal -3.153929e-01  3.130052e-01  8.958543e-01
    outer loop
      vertex  -2.708452e+00  1.188644e+00  1.866744e+01
      vertex  -3.582908e+00  1.188694e+00  1.835956e+01
      vertex  -3.620762e+00  8.852310e-01  1.845226e+01
    endloop
  endfacet
  facet normal -6.645552e-01  3.090011e-03  7.472327e-01
    outer loop
      vertex  -6.046535e+00  7.076263e-04  1.707237e+01
      vertex  -6.737354e+00 -4.429779e-01  1.645983e+01
      vertex  -6.047397e+00 -4.429989e-01  1.707344e+01
    endloop
  endfacet
  facet normal -2.901241e-01  4.864851e-01  8.241118e-01
    outer loop
      vertex  -2.663953e+00  1.467962e+00  1.851822e+01
      vertex  -3.582908e+00  1.188694e+00  1.835956e+01
      vertex  -2.708452e+00  1.188644e+00  1.866744e+01
    endloop
  endfacet
  facet normal -6.400291e-01 -4.876990e-01  5.937274e-01
    outer loop
      vertex  -6.634205e+00 -1.189585e+00  1.635457e+01
      vertex  -7.132257e+00 -1.470675e+00  1.558679e+01
      vertex  -6.524183e+00 -1.470648e+00  1.624230e+01
    endloop
  endfacet
  facet normal -6.104062e-01  7.920121e-01 -1.100982e-02
    outer loop
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
    endloop
  endfacet
  facet normal -2.603829e-01  6.206534e-01  7.395878e-01
    outer loop
      vertex  -2.619798e+00  1.662946e+00  1.837016e+01
      vertex  -3.465606e+00  1.663043e+00  1.807230e+01
      vertex  -3.524038e+00  1.468016e+00  1.821539e+01
    endloop
  endfacet
  facet normal -4.344612e-16 -9.496236e-16 -1.000000e+00
    outer loop
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
      vertex  -4.404419e+00  5.015305e+00 -2.983724e-16
      vertex  -3.788864e+00  5.493610e+00 -1.020017e-15
    endloop
  endfacet
  facet normal -2.189840e-16  2.935327e-16 -1.000000e+00
    outer loop
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
      vertex  -6.397487e+00 -1.984235e+00  1.539173e-16
      vertex  -6.501628e+00 -1.617079e+00  2.844947e-16
    endloop
  endfacet
  facet normal -9.286615e-02  7.617079e-01  6.412309e-01
    outer loop
      vertex  -8.462134e-01  1.949980e+00  1.837375e+01
      vertex  -1.748968e+00  1.662848e+00  1.858409e+01
      vertex  -8.786176e-01  1.662752e+00  1.871025e+01
    endloop
  endfacet
  facet normal -5.612209e-02 -9.708530e-01  2.330125e-01
    outer loop
      vertex  -1.608277e+00 -2.137565e+00  1.786017e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
    endloop
  endfacet
  facet normal -8.311386e-01  3.545042e-01 -4.284104e-01
    outer loop
      vertex  -6.484798e+00  2.544256e+00  5.717058e-01
      vertex  -6.098308e+00  2.759493e+00  4.718448e-16
      vertex  -6.257010e+00  2.387415e+00  1.463476e-16
    endloop
  endfacet
  facet normal  9.309286e-01  1.047331e-01  3.498612e-01
    outer loop
      vertex   9.124373e+00  8.848534e-01  1.250891e+01
      vertex   8.794740e+00  8.848743e-01  1.338601e+01
      vertex   8.837411e+00  4.439754e-01  1.340445e+01
    endloop
  endfacet
  facet normal -5.849366e-02 -9.694473e-01  2.382235e-01
    outer loop
      vertex  -1.608277e+00 -2.137565e+00  1.786017e+01
      vertex  -2.409062e+00 -2.137579e+00  1.766348e+01
      vertex  -2.367632e+00 -2.174238e+00  1.752447e+01
    endloop
  endfacet
  facet normal  5.103341e-01 -8.588688e-01  4.362813e-02
    outer loop
      vertex   8.756794e+00 -2.076908e+00  7.572255e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
    endloop
  endfacet
  facet normal -9.434435e-01 -3.825913e-03 -3.315112e-01
    outer loop
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.727498e+00 -2.181013e+00  1.248517e+01
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
    endloop
  endfacet
  facet normal -2.264806e-01 -3.133058e-01  9.222505e-01
    outer loop
      vertex  -1.827286e+00 -8.840618e-01  1.898700e+01
      vertex  -2.708294e+00 -1.189535e+00  1.866687e+01
      vertex  -1.808037e+00 -1.189526e+00  1.888795e+01
    endloop
  endfacet
  facet normal  9.699696e-01 -2.420881e-01 -2.349973e-02
    outer loop
      vertex  -5.352921e+00  1.098696e+00  3.294899e+00
      vertex  -5.335880e+00  1.486812e+00 -2.081668e-16
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
    endloop
  endfacet
  facet normal -8.342879e-01 -3.260833e-01 -4.445600e-01
    outer loop
      vertex  -6.650954e+00 -2.148561e+00  5.689487e-01
      vertex  -6.961944e+00 -2.297348e+00  1.261705e+00
      vertex  -7.125367e+00 -1.870438e+00  1.255257e+00
    endloop
  endfacet
  facet normal -2.264720e-01 -3.133255e-01  9.222459e-01
    outer loop
      vertex  -1.827286e+00 -8.840618e-01  1.898700e+01
      vertex  -2.737131e+00 -8.840389e-01  1.876358e+01
      vertex  -2.708294e+00 -1.189535e+00  1.866687e+01
    endloop
  endfacet
  facet normal -2.371718e-01 -1.044730e-01  9.658338e-01
    outer loop
      vertex  -1.836132e+00 -4.431095e-01  1.903253e+01
      vertex  -2.750383e+00 -4.430866e-01  1.880802e+01
      vertex  -2.737131e+00 -8.840389e-01  1.876358e+01
    endloop
  endfacet
  facet normal -2.043126e-02  9.048020e-01  4.253420e-01
    outer loop
      vertex  -1.551486e-04  2.138014e+00  1.801440e+01
      vertex  -8.462134e-01  1.949980e+00  1.837375e+01
      vertex  -1.667350e-04  1.949934e+00  1.841449e+01
    endloop
  endfacet
  facet normal -2.384731e-01  3.027587e-03  9.711444e-01
    outer loop
      vertex  -1.835874e+00  6.017685e-04  1.903121e+01
      vertex  -2.750383e+00 -4.430866e-01  1.880802e+01
      vertex  -1.836132e+00 -4.431095e-01  1.903253e+01
    endloop
  endfacet
  facet normal -2.384786e-01 -2.833606e-03  9.711436e-01
    outer loop
      vertex  -1.836113e+00  4.442806e-01  1.903244e+01
      vertex  -2.749995e+00  6.237030e-04  1.880673e+01
      vertex  -1.835874e+00  6.017685e-04  1.903121e+01
    endloop
  endfacet
  facet normal -2.371717e-01  1.047296e-01  9.658060e-01
    outer loop
      vertex  -1.827242e+00  8.851852e-01  1.898681e+01
      vertex  -2.737066e+00  8.852081e-01  1.876338e+01
      vertex  -2.750353e+00  4.443016e-01  1.880793e+01
    endloop
  endfacet
  facet normal -8.784709e-01  2.883418e-01 -3.809828e-01
    outer loop
      vertex  -7.795024e+00  1.538778e+00  2.326663e+00
      vertex  -7.784481e+00  2.034075e+00  2.677211e+00
      vertex  -7.640823e+00  2.018465e+00  2.334151e+00
    endloop
  endfacet
  facet normal -2.264916e-01  3.129964e-01  9.223528e-01
    outer loop
      vertex  -1.808141e+00  1.188595e+00  1.888854e+01
      vertex  -2.708452e+00  1.188644e+00  1.866744e+01
      vertex  -2.737066e+00  8.852081e-01  1.876338e+01
    endloop
  endfacet
  facet normal -2.083472e-01  4.864436e-01  8.485069e-01
    outer loop
      vertex  -1.778435e+00  1.467911e+00  1.873570e+01
      vertex  -2.708452e+00  1.188644e+00  1.866744e+01
      vertex  -1.808141e+00  1.188595e+00  1.888854e+01
    endloop
  endfacet
  facet normal  9.397377e-01  3.399394e-01 -3.652645e-02
    outer loop
      vertex   9.396003e+00  1.339525e+00  8.310082e+00
      vertex   9.432271e+00  1.317898e+00  9.041898e+00
      vertex   9.584334e+00  8.978500e-01  9.044880e+00
    endloop
  endfacet
  facet normal -8.614244e-01  5.075670e-01 -1.799360e-02
    outer loop
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   4.642241e+00 -3.034725e+00 -5.828671e-17
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
    endloop
  endfacet
  facet normal -4.920284e-16 -3.042060e-15 -1.000000e+00
    outer loop
      vertex   6.498588e+00  1.626487e+00 -5.898060e-16
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
      vertex   6.398841e+00  1.977925e+00 -1.609823e-15
    endloop
  endfacet
  facet normal -1.544806e-01  7.617416e-01  6.291943e-01
    outer loop
      vertex  -1.684469e+00  1.950029e+00  1.825224e+01
      vertex  -2.619798e+00  1.662946e+00  1.837016e+01
      vertex  -1.748968e+00  1.662848e+00  1.858409e+01
    endloop
  endfacet
  facet normal  4.400387e-01 -4.040508e-03 -8.979698e-01
    outer loop
      vertex  -3.488899e+00  2.181314e+00  1.706183e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
    endloop
  endfacet
  facet normal -5.619384e-02  9.718415e-01  2.288371e-01
    outer loop
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
      vertex  -2.408869e+00  2.138071e+00  1.766289e+01
    endloop
  endfacet
  facet normal  2.114330e-01  9.718345e-01  1.040849e-01
    outer loop
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   7.376937e+00  2.137812e+00  1.367065e+01
    endloop
  endfacet
  facet normal -3.435915e-02 -9.708445e-01  2.372351e-01
    outer loop
      vertex  -8.079415e-01 -2.137550e+00  1.797614e+01
      vertex  -1.608277e+00 -2.137565e+00  1.786017e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
    endloop
  endfacet
  facet normal -6.107822e-02 -9.046269e-01  4.218052e-01
    outer loop
      vertex  -8.463282e-01 -1.949060e+00  1.837478e+01
      vertex  -1.684684e+00 -1.949110e+00  1.825327e+01
      vertex  -1.608277e+00 -2.137565e+00  1.786017e+01
    endloop
  endfacet
  facet normal -4.198024e-01 -9.049264e-01  6.981433e-02
    outer loop
      vertex  -8.635535e+00 -1.949717e+00  1.144582e+01
      vertex  -8.376802e+00 -2.137806e+00  1.056362e+01
      vertex  -8.244216e+00 -2.137755e+00  1.136154e+01
    endloop
  endfacet
  facet normal -9.295376e-02 -7.613139e-01  6.416859e-01
    outer loop
      vertex  -8.786781e-01 -1.661938e+00  1.871074e+01
      vertex  -1.684684e+00 -1.949110e+00  1.825327e+01
      vertex  -8.463282e-01 -1.949060e+00  1.837478e+01
    endloop
  endfacet
  facet normal -1.251687e-01 -4.876231e-01  8.640351e-01
    outer loop
      vertex  -9.082920e-01 -1.189516e+00  1.901830e+01
      vertex  -1.778063e+00 -1.470493e+00  1.873373e+01
      vertex  -8.932351e-01 -1.470469e+00  1.886192e+01
    endloop
  endfacet
  facet normal -1.361473e-01 -3.133165e-01  9.398386e-01
    outer loop
      vertex  -9.179602e-01 -8.840847e-01  1.911872e+01
      vertex  -1.808037e+00 -1.189526e+00  1.888795e+01
      vertex  -9.082920e-01 -1.189516e+00  1.901830e+01
    endloop
  endfacet
  facet normal -4.226741e-01  3.056293e-03  9.062766e-01
    outer loop
      vertex  -3.637867e+00  6.446838e-04  1.849414e+01
      vertex  -4.491577e+00 -4.430428e-01  1.809748e+01
      vertex  -3.638380e+00 -4.430637e-01  1.849540e+01
    endloop
  endfacet
  facet normal -1.790851e-14  1.631252e-14 -1.000000e+00
    outer loop
      vertex  -3.772143e+00 -5.505244e+00  4.857226e-17
      vertex  -3.793262e+00 -5.489933e+00  6.765422e-16
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
    endloop
  endfacet
  facet normal  8.451807e-01 -1.044698e-01  5.241713e-01
    outer loop
      vertex   8.421578e+00 -4.433918e-01  1.424917e+01
      vertex   7.887176e+00 -8.843269e-01  1.502296e+01
      vertex   8.381008e+00 -8.843479e-01  1.422670e+01
    endloop
  endfacet
  facet normal -5.507939e-01 -7.615408e-01  3.415871e-01
    outer loop
      vertex  -7.549392e+00 -1.662664e+00  1.478962e+01
      vertex  -7.726786e+00 -1.949560e+00  1.386397e+01
      vertex  -7.271570e+00 -1.949509e+00  1.459810e+01
    endloop
  endfacet
  facet normal -4.894786e-01 -4.179933e-04  8.720152e-01
    outer loop
      vertex   4.145314e+00 -5.454771e+00  2.440770e+00
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   3.942708e+00 -5.586086e+00  2.326981e+00
    endloop
  endfacet
  facet normal -6.405109e-01 -7.644459e-01 -7.326766e-02
    outer loop
      vertex  -7.421945e+00 -3.058773e+00  4.092888e+00
      vertex  -7.920292e+00 -2.705179e+00  4.760216e+00
      vertex  -7.745277e+00 -2.786051e+00  4.074001e+00
    endloop
  endfacet
  facet normal -1.433599e-01  3.027340e-03  9.896659e-01
    outer loop
      vertex  -9.222730e-01  5.807877e-04  1.916355e+01
      vertex  -1.835874e+00  6.017685e-04  1.903121e+01
      vertex  -1.836132e+00 -4.431095e-01  1.903253e+01
    endloop
  endfacet
  facet normal  2.513054e-01  9.047215e-01  3.439834e-01
    outer loop
      vertex   5.296712e+00  2.137880e+00  1.614445e+01
      vertex   4.643673e+00  2.137899e+00  1.662149e+01
      vertex   4.864143e+00  1.949648e+00  1.695555e+01
    endloop
  endfacet
  facet normal -1.433601e-01 -2.850959e-03  9.896665e-01
    outer loop
      vertex  -9.223928e-01  4.442577e-01  1.916481e+01
      vertex  -1.835874e+00  6.017685e-04  1.903121e+01
      vertex  -9.222730e-01  5.807877e-04  1.916355e+01
    endloop
  endfacet
  facet normal -4.117236e-01  9.030455e-01  1.224444e-01
    outer loop
      vertex  -8.197238e+00  2.495691e+00  6.145942e+00
      vertex  -7.902413e+00  2.534609e+00  6.850279e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
    endloop
  endfacet
  facet normal  9.057159e-01 -4.166893e-03 -4.238647e-01
    outer loop
      vertex  -7.406958e+00  2.181349e+00  1.322548e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
    endloop
  endfacet
  facet normal -1.361545e-01  3.130210e-01  9.399360e-01
    outer loop
      vertex  -9.083396e-01  1.188545e+00  1.901889e+01
      vertex  -1.827242e+00  8.851852e-01  1.898681e+01
      vertex  -9.179352e-01  8.851624e-01  1.911854e+01
    endloop
  endfacet
  facet normal -8.680105e-01  1.650082e-01 -4.683268e-01
    outer loop
      vertex  -7.516775e+00  9.891090e-01  1.595251e+00
      vertex  -7.615716e+00  1.512320e+00  1.962978e+00
      vertex  -7.426454e+00  1.471172e+00  1.597696e+00
    endloop
  endfacet
  facet normal  9.864429e-01 -3.034559e-03  1.640768e-01
    outer loop
      vertex   9.563832e+00  4.439163e-01  1.070271e+01
      vertex   9.411002e+00  2.746582e-04  1.161333e+01
      vertex   9.562493e+00  2.565384e-04  1.070256e+01
    endloop
  endfacet
  facet normal -1.340240e-16  4.467277e-16 -1.000000e+00
    outer loop
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
      vertex   5.520783e+00 -4.315945e-01  1.734723e-18
      vertex   6.652763e+00 -7.870749e-01 -3.087808e-16
    endloop
  endfacet
  facet normal -7.358609e-01  6.752137e-01  5.094324e-02
    outer loop
      vertex  -9.107553e+00  1.665619e+00  1.064893e+01
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
      vertex  -9.110337e+00  1.662560e+00  1.064925e+01
    endloop
  endfacet
  facet normal -1.123636e-01 -6.210462e-01  7.756778e-01
    outer loop
      vertex  -8.932351e-01 -1.470469e+00  1.886192e+01
      vertex  -1.778063e+00 -1.470493e+00  1.873373e+01
      vertex  -1.749077e+00 -1.662018e+00  1.858458e+01
    endloop
  endfacet
  facet normal  4.086419e-01 -9.098750e-01 -7.168949e-02
    outer loop
      vertex   3.110520e+00 -5.953293e+00  6.240654e-01
      vertex   2.362674e+00 -6.239994e+00  7.228014e-18
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
    endloop
  endfacet
  facet normal -2.371702e-01 -1.044764e-01  9.658338e-01
    outer loop
      vertex  -1.836132e+00 -4.431095e-01  1.903253e+01
      vertex  -2.737131e+00 -8.840389e-01  1.876358e+01
      vertex  -1.827286e+00 -8.840618e-01  1.898700e+01
    endloop
  endfacet
  facet normal -6.721353e-01  7.080198e-01 -2.166613e-01
    outer loop
      vertex  -6.517076e+00  3.502085e+00  2.001261e+00
      vertex  -6.619835e+00  3.513231e+00  2.356470e+00
      vertex  -6.018507e+00  4.096174e+00  2.395986e+00
    endloop
  endfacet
  facet normal -1.361532e-01  3.130168e-01  9.399377e-01
    outer loop
      vertex  -9.083396e-01  1.188545e+00  1.901889e+01
      vertex  -1.808141e+00  1.188595e+00  1.888854e+01
      vertex  -1.827242e+00  8.851852e-01  1.898681e+01
    endloop
  endfacet
  facet normal  6.079861e-01  7.804847e-01  1.455902e-01
    outer loop
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
      vertex   5.425769e+00  4.556772e+00  2.798037e+00
      vertex   5.525450e+00  4.358259e+00  3.445965e+00
    endloop
  endfacet
  facet normal  3.627253e-01 -9.043370e-01  2.249551e-01
    outer loop
      vertex   7.727928e+00 -1.948465e+00  1.386502e+01
      vertex   7.272491e+00 -1.948517e+00  1.459918e+01
      vertex   6.942640e+00 -2.137383e+00  1.437178e+01
    endloop
  endfacet
  facet normal -9.932773e-01  1.035080e-01 -5.183086e-02
    outer loop
      vertex  -9.591422e+00  4.617844e-01  8.313846e+00
      vertex  -9.630352e+00  4.547825e-01  9.045909e+00
      vertex  -9.584052e+00  8.985672e-01  9.044879e+00
    endloop
  endfacet
  facet normal -1.252432e-01  4.864312e-01  8.646958e-01
    outer loop
      vertex  -8.934164e-01  1.467857e+00  1.886393e+01
      vertex  -1.808141e+00  1.188595e+00  1.888854e+01
      vertex  -9.083396e-01  1.188545e+00  1.901889e+01
    endloop
  endfacet
  facet normal -1.124097e-01  6.205040e-01  7.761049e-01
    outer loop
      vertex  -8.786176e-01  1.662752e+00  1.871025e+01
      vertex  -1.778435e+00  1.467911e+00  1.873570e+01
      vertex  -8.934164e-01  1.467857e+00  1.886393e+01
    endloop
  endfacet
  facet normal -9.196006e-01 -8.480734e-03 -3.927629e-01
    outer loop
      vertex  -8.083801e+00 -5.270309e-01  2.648676e+00
      vertex  -8.374131e+00 -5.304680e-01  3.328518e+00
      vertex  -8.378106e+00 -9.479523e-04  3.326391e+00
    endloop
  endfacet
  facet normal  1.622593e-01 -2.070698e-07 -9.867482e-01
    outer loop
      vertex  -1.183759e+00  2.181295e+00  1.774998e+01
      vertex  -1.183776e+00 -2.180971e+00  1.774998e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
    endloop
  endfacet
  facet normal  3.320399e-01 -2.903878e-03  9.432609e-01
    outer loop
      vertex   3.638045e+00  4.441452e-01  1.849550e+01
      vertex   2.750044e+00  4.441681e-01  1.880809e+01
      vertex   2.749675e+00  4.949570e-04  1.880685e+01
    endloop
  endfacet
  facet normal  4.124874e-01 -9.042299e-01  1.105545e-01
    outer loop
      vertex   8.637318e+00 -1.948309e+00  1.144662e+01
      vertex   8.032036e+00 -2.137334e+00  1.215893e+01
      vertex   8.245609e+00 -2.137315e+00  1.136222e+01
    endloop
  endfacet
  facet normal -1.124247e-01  6.205665e-01  7.760528e-01
    outer loop
      vertex  -8.786176e-01  1.662752e+00  1.871025e+01
      vertex  -1.748968e+00  1.662848e+00  1.858409e+01
      vertex  -1.778435e+00  1.467911e+00  1.873570e+01
    endloop
  endfacet
  facet normal -1.782280e-16  2.244846e-16 -1.000000e+00
    outer loop
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
      vertex  -6.593333e+00 -1.194343e+00  4.857226e-17
      vertex  -5.507651e+00 -5.796566e-01 -6.938894e-18
    endloop
  endfacet
  facet normal -9.289359e-02  7.617524e-01  6.411739e-01
    outer loop
      vertex  -8.462134e-01  1.949980e+00  1.837375e+01
      vertex  -1.684469e+00  1.950029e+00  1.825224e+01
      vertex  -1.748968e+00  1.662848e+00  1.858409e+01
    endloop
  endfacet
  facet normal  8.593971e-01  1.296287e-01 -4.946039e-01
    outer loop
      vertex   6.963074e+00  8.865833e-01  5.629635e-01
      vertex   6.652087e+00  8.003138e-01  2.636780e-16
      vertex   6.590715e+00  1.207189e+00  1.187813e-15
    endloop
  endfacet
  facet normal  7.033868e-01 -6.207743e-01  3.462460e-01
    outer loop
      vertex   8.558311e+00 -1.470133e+00  1.328384e+01
      vertex   8.023282e+00 -1.660970e+00  1.402858e+01
      vertex   8.419494e+00 -1.660886e+00  1.322384e+01
    endloop
  endfacet
  facet normal  4.310431e-01 -7.610639e-01  4.847510e-01
    outer loop
      vertex   6.418201e+00 -1.661215e+00  1.613475e+01
      vertex   5.548748e+00 -1.948668e+00  1.645657e+01
      vertex   6.181915e+00 -1.948618e+00  1.589363e+01
    endloop
  endfacet
  facet normal -3.377810e-02  9.718313e-01  2.332443e-01
    outer loop
      vertex  -8.078656e-01  2.138033e+00  1.797553e+01
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -1.608142e+00  2.138052e+00  1.785956e+01
    endloop
  endfacet
  facet normal  1.092156e-01 -9.814963e-01  1.572797e-01
    outer loop
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
      vertex   4.544808e+00 -2.180998e+00  1.647177e+01
      vertex   4.869961e+00 -2.181000e+00  1.624597e+01
    endloop
  endfacet
  facet normal -2.388227e-01 -9.710618e-01 -1.674640e-03
    outer loop
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
      vertex  -8.269004e+00 -2.177960e+00  9.753304e+00
      vertex  -8.284958e+00 -2.174232e+00  9.866986e+00
    endloop
  endfacet
  facet normal  2.820305e-02 -9.995764e-01  7.168577e-03
    outer loop
      vertex   4.041913e-01 -6.678841e+00  1.334873e+00
      vertex   8.787063e-05 -6.690313e+00  1.324984e+00
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
    endloop
  endfacet
  facet normal -1.148543e-02 -9.706138e-01  2.403683e-01
    outer loop
      vertex  -1.725861e-04 -2.137535e+00  1.801501e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
    endloop
  endfacet
  facet normal  5.225098e-01 -8.420370e-01  1.340050e-01
    outer loop
      vertex   5.752617e+00 -4.180309e+00  3.658392e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
      vertex   5.926448e+00 -4.044765e+00  3.832300e+00
    endloop
  endfacet
  facet normal  8.255848e-01  5.641324e-01 -1.282433e-02
    outer loop
      vertex   9.146042e+00  1.720049e+00  8.305800e+00
      vertex   9.178001e+00  1.689901e+00  9.037074e+00
      vertex   9.432271e+00  1.317898e+00  9.041898e+00
    endloop
  endfacet
  facet normal -3.113008e-02 -7.612835e-01  6.476716e-01
    outer loop
      vertex  -1.906334e-04 -1.661858e+00  1.875303e+01
      vertex  -8.463282e-01 -1.949060e+00  1.837478e+01
      vertex  -1.826766e-04 -1.949013e+00  1.841550e+01
    endloop
  endfacet
  facet normal -8.525282e-01  2.809353e-01 -4.407617e-01
    outer loop
      vertex  -7.615716e+00  1.512320e+00  1.962978e+00
      vertex  -7.795024e+00  1.538778e+00  2.326663e+00
      vertex  -7.640823e+00  2.018465e+00  2.334151e+00
    endloop
  endfacet
  facet normal -3.762664e-02 -6.210175e-01  7.828930e-01
    outer loop
      vertex  -1.939251e-04 -1.470444e+00  1.890486e+01
      vertex  -8.932351e-01 -1.470469e+00  1.886192e+01
      vertex  -8.786781e-01 -1.661938e+00  1.871074e+01
    endloop
  endfacet
  facet normal -4.046765e-01  4.403375e-04 -9.144599e-01
    outer loop
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   3.488590e+00  2.181257e+00  1.706202e+01
      vertex   3.118692e+00 -2.180992e+00  1.722361e+01
    endloop
  endfacet
  facet normal  1.762633e-01 -9.706623e-01  1.635421e-01
    outer loop
      vertex   6.451702e+00 -2.137401e+00  1.501462e+01
      vertex   5.901518e+00 -2.137416e+00  1.560751e+01
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
    endloop
  endfacet
  facet normal  6.512170e-16  3.345940e-17 -1.000000e+00
    outer loop
      vertex   2.359956e+00  6.242986e+00  5.134781e-16
      vertex   1.511153e+00  5.363768e+00 -6.869505e-17
      vertex   1.593122e+00  6.482521e+00  2.211772e-17
    endloop
  endfacet
  facet normal -2.323848e-01  9.718558e-01  3.864780e-02
    outer loop
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -8.200814e+00  2.181055e+00  1.054299e+01
      vertex  -8.376205e+00  2.138299e+00  1.056355e+01
    endloop
  endfacet
  facet normal -5.142273e-01  7.625289e-01  3.925813e-01
    outer loop
      vertex  -6.756639e+00  1.950357e+00  1.527073e+01
      vertex  -7.270593e+00  1.950403e+00  1.459744e+01
      vertex  -7.547735e+00  1.665148e+00  1.478848e+01
    endloop
  endfacet
  facet normal -3.146904e-01  1.860615e-03  9.491925e-01
    outer loop
      vertex   2.790018e+00 -6.151764e+00  1.810594e+00
      vertex   2.650582e+00 -4.882418e+00  1.761878e+00
      vertex   2.394752e+00 -6.291546e+00  1.679824e+00
    endloop
  endfacet
  facet normal -4.191738e-02 -4.876215e-01  8.720483e-01
    outer loop
      vertex  -1.970066e-04 -1.189507e+00  1.906195e+01
      vertex  -9.082920e-01 -1.189516e+00  1.901830e+01
      vertex  -8.932351e-01 -1.470469e+00  1.886192e+01
    endloop
  endfacet
  facet normal -4.558725e-02 -3.133155e-01  9.485543e-01
    outer loop
      vertex  -1.984666e-04 -8.841076e-01  1.916282e+01
      vertex  -9.179602e-01 -8.840847e-01  1.911872e+01
      vertex  -9.082920e-01 -1.189516e+00  1.901830e+01
    endloop
  endfacet
  facet normal -9.841501e-01 -9.337658e-02 -1.507627e-01
    outer loop
      vertex  -9.401835e+00 -4.804020e-01  6.855625e+00
      vertex  -9.357120e+00 -9.516964e-01  6.855629e+00
      vertex  -9.514237e+00 -4.687805e-01  7.582165e+00
    endloop
  endfacet
  facet normal -4.773404e-02 -1.044824e-01  9.933805e-01
    outer loop
      vertex  -1.979089e-04 -4.431534e-01  1.920920e+01
      vertex  -9.224034e-01 -4.431305e-01  1.916488e+01
      vertex  -9.179602e-01 -8.840847e-01  1.911872e+01
    endloop
  endfacet
  facet normal  8.734780e-01  2.515000e-02 -4.862136e-01
    outer loop
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
      vertex   6.698109e+00  7.242848e-03  5.134781e-16
      vertex   6.687155e+00  3.876799e-01  7.355228e-17
    endloop
  endfacet
  facet normal  6.662329e-01 -6.207923e-01  4.132197e-01
    outer loop
      vertex   8.155621e+00 -1.470160e+00  1.410187e+01
      vertex   7.550447e+00 -1.661053e+00  1.479081e+01
      vertex   8.023282e+00 -1.660970e+00  1.402858e+01
    endloop
  endfacet
  facet normal -9.606344e-01  1.047370e-01  2.573165e-01
    outer loop
      vertex  -9.124299e+00  8.854256e-01  1.250846e+01
      vertex  -9.412189e+00  4.445343e-01  1.161314e+01
      vertex  -9.168571e+00  4.445152e-01  1.252264e+01
    endloop
  endfacet
  facet normal -1.199647e-01  9.718389e-01  2.028242e-01
    outer loop
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -4.643528e+00  2.138128e+00  1.662074e+01
    endloop
  endfacet
  facet normal  6.724412e-01 -1.779121e-04  7.401505e-01
    outer loop
      vertex  -5.530277e+00 -4.362434e+00  3.450466e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.576197e+00 -4.323465e+00  3.492194e+00
    endloop
  endfacet
  facet normal  6.984268e-01  6.996928e-01 -1.504326e-01
    outer loop
      vertex   7.040045e+00  3.195406e+00  2.716892e+00
      vertex   7.245383e+00  3.139837e+00  3.411770e+00
      vertex   7.544757e+00  2.836538e+00  3.390997e+00
    endloop
  endfacet
  facet normal -7.286475e-01  5.780447e-01 -3.673381e-01
    outer loop
      vertex  -6.544655e+00  3.054583e+00  1.277907e+00
      vertex  -6.666580e+00  3.125719e+00  1.631697e+00
      vertex  -6.411795e+00  3.454931e+00  1.644359e+00
    endloop
  endfacet
  facet normal -8.600859e-01 -4.996750e-01 -1.028447e-01
    outer loop
      vertex  -8.979276e+00 -1.807371e+00  6.853911e+00
      vertex  -9.322753e+00 -1.365467e+00  7.579388e+00
      vertex  -9.215196e+00 -1.401514e+00  6.855027e+00
    endloop
  endfacet
  facet normal  2.741055e-01 -7.611355e-01  5.878255e-01
    outer loop
      vertex   4.278577e+00 -1.661456e+00  1.769453e+01
      vertex   3.338141e+00 -1.948816e+00  1.776098e+01
      vertex   4.121053e+00 -1.948767e+00  1.739597e+01
    endloop
  endfacet
  facet normal -7.335377e-01  6.536698e-01 -1.861133e-01
    outer loop
      vertex  -5.194129e+00  4.607729e+00  1.333857e+00
      vertex  -5.075042e+00  4.531092e+00  5.953255e-01
      vertex  -5.615840e+00  3.921659e+00  5.863419e-01
    endloop
  endfacet
  facet normal -4.558724e-02  3.130082e-01  9.486557e-01
    outer loop
      vertex  -1.872839e-04  1.188496e+00  1.906255e+01
      vertex  -9.179352e-01  8.851624e-01  1.911854e+01
      vertex  -1.912162e-04  8.851395e-01  1.916265e+01
    endloop
  endfacet
  facet normal -4.559112e-02  3.130192e-01  9.486519e-01
    outer loop
      vertex  -1.872839e-04  1.188496e+00  1.906255e+01
      vertex  -9.083396e-01  1.188545e+00  1.901889e+01
      vertex  -9.179352e-01  8.851624e-01  1.911854e+01
    endloop
  endfacet
  facet normal -8.735843e-01  4.313579e-01 -2.253460e-01
    outer loop
      vertex  -8.707513e+00  1.523714e+00  4.727165e+00
      vertex  -8.906251e+00  1.487829e+00  5.428909e+00
      vertex  -8.690358e+00  1.927992e+00  5.434532e+00
    endloop
  endfacet
  facet normal  7.115812e-01 -6.769453e-01 -1.881419e-01
    outer loop
      vertex   6.914867e+00 -3.202835e+00  2.347976e+00
      vertex   6.737225e+00 -3.494104e+00  2.724110e+00
      vertex   6.622387e+00 -3.512589e+00  2.356283e+00
    endloop
  endfacet
  facet normal -4.193863e-02  4.864285e-01  8.727133e-01
    outer loop
      vertex  -1.819546e-04  1.467806e+00  1.890688e+01
      vertex  -8.934164e-01  1.467857e+00  1.886393e+01
      vertex  -9.083396e-01  1.188545e+00  1.901889e+01
    endloop
  endfacet
  facet normal -3.763339e-02  6.204472e-01  7.833447e-01
    outer loop
      vertex  -1.770278e-04  1.662657e+00  1.875255e+01
      vertex  -8.934164e-01  1.467857e+00  1.886393e+01
      vertex  -1.819546e-04  1.467806e+00  1.890688e+01
    endloop
  endfacet
  facet normal  8.710481e-01 -4.875028e-01  6.013599e-02
    outer loop
      vertex   9.417737e+00 -1.189346e+00  1.068564e+01
      vertex   9.261893e+00 -1.470047e+00  1.066743e+01
      vertex   9.323505e+00 -1.470018e+00  9.775237e+00
    endloop
  endfacet
  facet normal  6.638612e-01  7.337601e-01 -1.445148e-01
    outer loop
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
      vertex   4.435295e+00  4.986383e+00  9.055257e-16
      vertex   4.408831e+00  5.010327e+00 -1.422473e-16
    endloop
  endfacet
  facet normal  3.130633e-01 -7.482470e-07 -9.497322e-01
    outer loop
      vertex  -2.741681e+00  2.181307e+00  1.736673e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
      vertex  -2.741698e+00 -2.180965e+00  1.736673e+01
    endloop
  endfacet
  facet normal  7.877603e-01 -4.907570e-01 -3.722784e-01
    outer loop
      vertex   6.767753e+00 -2.690432e+00  1.269229e+00
      vertex   6.669502e+00 -3.123020e+00  1.631585e+00
      vertex   6.547676e+00 -3.050220e+00  1.277827e+00
    endloop
  endfacet
  facet normal -8.624175e-01  6.230159e-07 -5.061976e-01
    outer loop
      vertex   7.015390e+00  2.181227e+00  1.393177e+01
      vertex   7.219731e+00 -2.181011e+00  1.358362e+01
      vertex   7.015382e+00 -2.181009e+00  1.393177e+01
    endloop
  endfacet
  facet normal  8.612826e-01 -4.875091e-01  1.432726e-01
    outer loop
      vertex   9.268517e+00 -1.189360e+00  1.158263e+01
      vertex   9.115124e+00 -1.470076e+00  1.154957e+01
      vertex   9.417737e+00 -1.189346e+00  1.068564e+01
    endloop
  endfacet
  facet normal -9.985878e-01 -1.142309e-03 -5.311421e-02
    outer loop
      vertex  -9.590901e+00  7.381439e-04  8.313972e+00
      vertex  -9.630352e+00  4.547825e-01  9.045909e+00
      vertex  -9.591422e+00  4.617844e-01  8.313846e+00
    endloop
  endfacet
  facet normal -1.130367e-02  9.718327e-01  2.354003e-01
    outer loop
      vertex  -1.551486e-04  2.138014e+00  1.801440e+01
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex  -8.078656e-01  2.138033e+00  1.797553e+01
    endloop
  endfacet
  facet normal -8.490570e-01 -4.116424e-01 -3.311386e-01
    outer loop
      vertex  -7.577415e+00 -2.478678e+00  2.692742e+00
      vertex  -8.049710e+00 -2.038773e+00  3.356880e+00
      vertex  -7.785738e+00 -2.036400e+00  2.677091e+00
    endloop
  endfacet
  facet normal  6.575137e-03 -9.989209e-01  4.597671e-02
    outer loop
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   1.183401e+00  2.181276e+00  1.775005e+01
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
    endloop
  endfacet
  facet normal  1.154170e-02 -9.706141e-01  2.403644e-01
    outer loop
      vertex   8.076244e-01 -2.137521e+00  1.797628e+01
      vertex  -1.725861e-04 -2.137535e+00  1.801501e+01
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
    endloop
  endfacet
  facet normal  2.046237e-02 -9.045814e-01  4.258095e-01
    outer loop
      vertex   8.459943e-01 -1.948963e+00  1.837494e+01
      vertex  -1.826766e-04 -1.949013e+00  1.841550e+01
      vertex  -1.725861e-04 -2.137535e+00  1.801501e+01
    endloop
  endfacet
  facet normal -3.991232e-01  6.207180e-01  6.748406e-01
    outer loop
      vertex  -4.278252e+00  1.663140e+00  1.769321e+01
      vertex  -5.135251e+00  1.468121e+00  1.736573e+01
      vertex  -4.350411e+00  1.468069e+00  1.782996e+01
    endloop
  endfacet
  facet normal -3.991185e-01  6.207646e-01  6.748006e-01
    outer loop
      vertex  -4.278252e+00  1.663140e+00  1.769321e+01
      vertex  -5.050044e+00  1.663237e+00  1.723664e+01
      vertex  -5.135251e+00  1.468121e+00  1.736573e+01
    endloop
  endfacet
  facet normal -2.146160e-16  7.141294e-18 -1.000000e+00
    outer loop
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
      vertex  -3.919302e+00 -3.934127e+00 -6.195441e-18
      vertex  -4.435853e+00 -4.987197e+00  9.714451e-17
    endloop
  endfacet
  facet normal  9.074961e-01  7.433832e-02 -4.134305e-01
    outer loop
      vertex   7.890829e+00  1.034529e+00  2.317666e+00
      vertex   8.043606e+00  1.044596e+00  2.654828e+00
      vertex   8.083388e+00  5.249405e-01  2.648714e+00
    endloop
  endfacet
  facet normal -6.434567e-01  7.652712e-01 -1.798607e-02
    outer loop
      vertex  -7.743393e+00  2.783541e+00  4.074136e+00
      vertex  -7.572854e+00  2.943415e+00  4.775358e+00
      vertex  -7.419713e+00  3.056143e+00  4.093033e+00
    endloop
  endfacet
  facet normal  3.108956e-02 -7.612572e-01  6.477044e-01
    outer loop
      vertex   8.783308e-01 -1.661779e+00  1.871092e+01
      vertex  -1.826766e-04 -1.949013e+00  1.841550e+01
      vertex   8.459943e-01 -1.948963e+00  1.837494e+01
    endloop
  endfacet
  facet normal -8.454833e-01  2.404802e-01 -4.767886e-01
    outer loop
      vertex  -7.248943e+00  1.422327e+00  1.249935e+00
      vertex  -7.123807e+00  1.872915e+00  1.255299e+00
      vertex  -6.890904e+00  1.322287e+00  5.645704e-01
    endloop
  endfacet
  facet normal  4.769704e-02 -1.044828e-01  9.933823e-01
    outer loop
      vertex   9.220275e-01 -4.431763e-01  1.916492e+01
      vertex  -1.984666e-04 -8.841076e-01  1.916282e+01
      vertex   9.175830e-01 -8.841286e-01  1.911875e+01
    endloop
  endfacet
  facet normal  4.442217e-01  8.936589e-01  6.356795e-02
    outer loop
      vertex   8.841630e+00  1.986746e+00  9.030819e+00
      vertex   8.447516e+00  2.183165e+00  9.023621e+00
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
    endloop
  endfacet
  facet normal  5.751742e-01  6.199989e-01  5.336441e-01
    outer loop
      vertex   7.016270e+00  1.661791e+00  1.548970e+01
      vertex   6.417946e+00  1.661885e+00  1.613447e+01
      vertex   6.525639e+00  1.467388e+00  1.624437e+01
    endloop
  endfacet
  facet normal  8.346182e-01 -5.470906e-01 -6.406508e-02
    outer loop
      vertex   9.322818e+00 -1.365606e+00  7.579388e+00
      vertex   9.396529e+00 -1.338722e+00  8.310096e+00
      vertex   9.146890e+00 -1.719061e+00  8.305820e+00
    endloop
  endfacet
  facet normal  4.795998e-02  2.997674e-03  9.988447e-01
    outer loop
      vertex   9.219017e-01  5.378723e-04  1.916359e+01
      vertex  -1.979089e-04 -4.431534e-01  1.920920e+01
      vertex   9.220275e-01 -4.431763e-01  1.916492e+01
    endloop
  endfacet
  facet normal  4.704942e-01  8.820965e-01 -2.326069e-02
    outer loop
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   3.644418e+00  5.757833e+00  2.172665e+00
      vertex   3.926537e+00  5.606951e+00  2.157274e+00
    endloop
  endfacet
  facet normal  9.475296e-01  3.129069e-01  6.539875e-02
    outer loop
      vertex   9.418399e+00  1.187765e+00  1.068572e+01
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
      vertex   9.481034e+00  1.187719e+00  9.778445e+00
    endloop
  endfacet
  facet normal  4.795412e-02 -2.868944e-03  9.988454e-01
    outer loop
      vertex   9.220259e-01  4.442120e-01  1.916486e+01
      vertex  -1.960567e-04  5.588531e-04  1.920786e+01
      vertex   9.219017e-01  5.378723e-04  1.916359e+01
    endloop
  endfacet
  facet normal  9.882367e-01 -6.372693e-04 -1.529305e-01
    outer loop
      vertex   9.401635e+00 -4.805756e-01  6.855621e+00
      vertex   9.401924e+00  6.008148e-04  6.855484e+00
      vertex   9.514075e+00 -4.690056e-01  7.582161e+00
    endloop
  endfacet
  facet normal  4.769130e-02  1.047322e-01  9.933563e-01
    outer loop
      vertex   9.175743e-01  8.851166e-01  1.911859e+01
      vertex  -1.912162e-04  8.851395e-01  1.916265e+01
      vertex  -1.942747e-04  4.442348e-01  1.920913e+01
    endloop
  endfacet
  facet normal -5.342615e-01 -8.406189e-01  8.901982e-02
    outer loop
      vertex  -4.968631e+00 -4.836309e+00  2.987150e+00
      vertex  -5.430634e+00 -4.562702e+00  2.798081e+00
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
    endloop
  endfacet
  facet normal  9.753476e-01 -2.196885e-01 -2.083339e-02
    outer loop
      vertex  -5.352921e+00  1.098696e+00  3.294899e+00
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
      vertex  -5.335880e+00  1.486812e+00 -2.081668e-16
    endloop
  endfacet
  facet normal  4.555079e-02  3.129971e-01  9.486612e-01
    outer loop
      vertex   9.079884e-01  1.188446e+00  1.901897e+01
      vertex  -1.912162e-04  8.851395e-01  1.916265e+01
      vertex   9.175743e-01  8.851166e-01  1.911859e+01
    endloop
  endfacet
  facet normal  3.762228e-02  6.203938e-01  7.833876e-01
    outer loop
      vertex   8.782997e-01  1.662560e+00  1.871046e+01
      vertex  -1.819546e-04  1.467806e+00  1.890688e+01
      vertex   8.930779e-01  1.467754e+00  1.886402e+01
    endloop
  endfacet
  facet normal  3.105612e-02  7.616554e-01  6.472375e-01
    outer loop
      vertex   8.459144e-01  1.949884e+00  1.837395e+01
      vertex  -1.667350e-04  1.949934e+00  1.841449e+01
      vertex  -1.770278e-04  1.662657e+00  1.875255e+01
    endloop
  endfacet
  facet normal  9.474949e-01 -3.130153e-01  6.538206e-02
    outer loop
      vertex   9.517684e+00 -8.844261e-01  1.069732e+01
      vertex   9.480363e+00 -1.189333e+00  9.778431e+00
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
    endloop
  endfacet
  facet normal  2.043421e-02  9.047872e-01  4.253734e-01
    outer loop
      vertex   8.075836e-01  2.137995e+00  1.797567e+01
      vertex  -1.667350e-04  1.949934e+00  1.841449e+01
      vertex   8.459144e-01  1.949884e+00  1.837395e+01
    endloop
  endfacet
  facet normal -5.924945e-01 -8.055564e-01 -5.392341e-03
    outer loop
      vertex   3.088440e+00  4.607893e+00  1.924301e+00
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
    endloop
  endfacet
  facet normal  1.130739e-02  9.718416e-01  2.353637e-01
    outer loop
      vertex   8.075836e-01  2.137995e+00  1.797567e+01
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex  -1.551486e-04  2.138014e+00  1.801440e+01
    endloop
  endfacet
  facet normal  4.858968e-01 -1.147123e-03  8.740155e-01
    outer loop
      vertex  -3.944028e+00 -5.589794e+00  2.327796e+00
      vertex  -3.842140e+00 -3.973835e+00  2.273273e+00
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
    endloop
  endfacet
  facet normal  3.465838e-02 -9.708117e-01  2.373256e-01
    outer loop
      vertex   1.608019e+00 -2.137506e+00  1.786044e+01
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
    endloop
  endfacet
  facet normal  1.123202e-01 -6.209772e-01  7.757394e-01
    outer loop
      vertex   1.777746e+00 -1.470394e+00  1.873390e+01
      vertex   8.783308e-01 -1.661779e+00  1.871092e+01
      vertex   1.748804e+00 -1.661699e+00  1.858495e+01
    endloop
  endfacet
  facet normal  3.689942e-01 -4.875778e-01  7.912719e-01
    outer loop
      vertex   4.422585e+00 -1.189459e+00  1.796748e+01
      vertex   3.582416e+00 -1.189468e+00  1.835927e+01
      vertex   3.523055e+00 -1.470343e+00  1.821387e+01
    endloop
  endfacet
  facet normal  1.360921e-01 -3.132586e-01  9.398659e-01
    outer loop
      vertex   1.826940e+00 -8.841515e-01  1.898706e+01
      vertex   9.079207e-01 -1.189497e+00  1.901836e+01
      vertex   1.807706e+00 -1.189487e+00  1.888808e+01
    endloop
  endfacet
  facet normal  5.176957e-16 -1.141464e-15 -1.000000e+00
    outer loop
      vertex   6.698109e+00  7.242848e-03  5.134781e-16
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
      vertex   6.687155e+00  3.876799e-01  7.355228e-17
    endloop
  endfacet
  facet normal  1.360965e-01 -3.132725e-01  9.398606e-01
    outer loop
      vertex   1.826940e+00 -8.841515e-01  1.898706e+01
      vertex   9.175830e-01 -8.841286e-01  1.911875e+01
      vertex   9.079207e-01 -1.189497e+00  1.901836e+01
    endloop
  endfacet
  facet normal  1.425311e-01 -1.044837e-01  9.842601e-01
    outer loop
      vertex   1.835788e+00 -4.431973e-01  1.903259e+01
      vertex   9.220275e-01 -4.431763e-01  1.916492e+01
      vertex   9.175830e-01 -8.841286e-01  1.911875e+01
    endloop
  endfacet
  facet normal -5.900030e-01  3.089923e-03  8.073952e-01
    outer loop
      vertex  -5.301142e+00  6.875992e-04  1.761707e+01
      vertex  -6.046535e+00  7.076263e-04  1.707237e+01
      vertex  -6.047397e+00 -4.429989e-01  1.707344e+01
    endloop
  endfacet
  facet normal  1.433142e-01 -2.887546e-03  9.896730e-01
    outer loop
      vertex   1.835783e+00  4.441910e-01  1.903255e+01
      vertex   9.219017e-01  5.378723e-04  1.916359e+01
      vertex   1.835537e+00  5.168915e-04  1.903129e+01
    endloop
  endfacet
  facet normal  1.848718e-01 -3.874120e-04  9.827626e-01
    outer loop
      vertex  -1.606912e+00 -6.512114e+00  1.482861e+00
      vertex  -1.447308e+00 -6.545586e+00  1.452824e+00
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
    endloop
  endfacet
  facet normal  5.528085e-01 -8.325875e-01 -3.465458e-02
    outer loop
      vertex   7.248614e+00 -3.143639e+00  3.411612e+00
      vertex   7.421623e+00 -3.057121e+00  4.092836e+00
      vertex   7.082061e+00 -3.283449e+00  4.113759e+00
    endloop
  endfacet
  facet normal -2.371710e-01  1.047279e-01  9.658064e-01
    outer loop
      vertex  -1.827242e+00  8.851852e-01  1.898681e+01
      vertex  -2.750353e+00  4.443016e-01  1.880793e+01
      vertex  -1.836113e+00  4.442806e-01  1.903244e+01
    endloop
  endfacet
  facet normal  1.433056e-01 -2.869411e-03  9.896743e-01
    outer loop
      vertex   1.835783e+00  4.441910e-01  1.903255e+01
      vertex   9.220259e-01  4.442120e-01  1.916486e+01
      vertex   9.219017e-01  5.378723e-04  1.916359e+01
    endloop
  endfacet
  facet normal -6.404521e-01  4.866423e-01  5.941383e-01
    outer loop
      vertex  -6.525561e+00  1.468224e+00  1.624372e+01
      vertex  -7.252964e+00  1.188940e+00  1.568837e+01
      vertex  -6.634596e+00  1.188892e+00  1.635498e+01
    endloop
  endfacet
  facet normal -8.001240e-01  4.039523e-01 -4.434232e-01
    outer loop
      vertex  -6.960249e+00  2.299536e+00  1.261756e+00
      vertex  -6.764935e+00  2.694681e+00  1.269298e+00
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
    endloop
  endfacet
  facet normal  1.425204e-01  1.047380e-01  9.842346e-01
    outer loop
      vertex   1.826918e+00  8.850937e-01  1.898691e+01
      vertex   9.220259e-01  4.442120e-01  1.916486e+01
      vertex   1.835783e+00  4.441910e-01  1.903255e+01
    endloop
  endfacet
  facet normal  9.374492e-01 -2.393118e-01 -2.528220e-01
    outer loop
      vertex   8.832570e+00 -1.031635e+00  4.720345e+00
      vertex   8.907182e+00 -1.487871e+00  5.428856e+00
      vertex   8.708557e+00 -1.524548e+00  4.727085e+00
    endloop
  endfacet
  facet normal  8.176807e-01  4.224449e-01 -3.910736e-01
    outer loop
      vertex   6.294444e+00  2.906713e+00  5.747747e-01
      vertex   6.482162e+00  2.540468e+00  5.716410e-01
      vertex   6.097925e+00  2.755002e+00  1.526557e-16
    endloop
  endfacet
  facet normal -4.799385e-02  3.010044e-03  9.988431e-01
    outer loop
      vertex  -1.960567e-04  5.588531e-04  1.920786e+01
      vertex  -9.224034e-01 -4.431305e-01  1.916488e+01
      vertex  -1.979089e-04 -4.431534e-01  1.920920e+01
    endloop
  endfacet
  facet normal  1.425229e-01  1.047329e-01  9.842349e-01
    outer loop
      vertex   1.826918e+00  8.850937e-01  1.898691e+01
      vertex   9.175743e-01  8.851166e-01  1.911859e+01
      vertex   9.220259e-01  4.442120e-01  1.916486e+01
    endloop
  endfacet
  facet normal -2.383071e-01 -9.711685e-01 -6.451056e-03
    outer loop
      vertex  -1.820554e+00 -6.459442e+00  1.445536e+00
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -1.606912e+00 -6.512114e+00  1.482861e+00
    endloop
  endfacet
  facet normal  1.252201e-01  4.863828e-01  8.647263e-01
    outer loop
      vertex   1.778145e+00  1.467701e+00  1.873589e+01
      vertex   8.930779e-01  1.467754e+00  1.886402e+01
      vertex   9.079884e-01  1.188446e+00  1.901897e+01
    endloop
  endfacet
  facet normal  6.033510e-02  9.981241e-01 -1.038860e-02
    outer loop
      vertex   4.036640e-01  6.677962e+00  1.334846e+00
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
    endloop
  endfacet
  facet normal  1.123854e-01  6.203955e-01  7.761951e-01
    outer loop
      vertex   1.748731e+00  1.662465e+00  1.858451e+01
      vertex   8.782997e-01  1.662560e+00  1.871046e+01
      vertex   8.930779e-01  1.467754e+00  1.886402e+01
    endloop
  endfacet
  facet normal  4.444317e-01 -4.875582e-01  7.515101e-01
    outer loop
      vertex   5.220532e+00 -1.189449e+00  1.749559e+01
      vertex   4.422585e+00 -1.189459e+00  1.796748e+01
      vertex   4.349310e+00 -1.470318e+00  1.782860e+01
    endloop
  endfacet
  facet normal  5.923747e-01 -8.056433e-01 -5.567173e-03
    outer loop
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
    endloop
  endfacet
  facet normal  3.375396e-02  9.718432e-01  2.331983e-01
    outer loop
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   7.905493e-01  2.180949e+00  1.779913e+01
      vertex   8.075836e-01  2.137995e+00  1.797567e+01
    endloop
  endfacet
  facet normal  9.284868e-02  7.616078e-01  6.413522e-01
    outer loop
      vertex   1.684247e+00  1.949839e+00  1.825264e+01
      vertex   8.459144e-01  1.949884e+00  1.837395e+01
      vertex   8.782997e-01  1.662560e+00  1.871046e+01
    endloop
  endfacet
  facet normal -8.177162e-01  4.867379e-01  3.072887e-01
    outer loop
      vertex  -8.559678e+00  1.468428e+00  1.328400e+01
      vertex  -9.028855e+00  1.189133e+00  1.247788e+01
      vertex  -8.702725e+00  1.189085e+00  1.334581e+01
    endloop
  endfacet
  facet normal  6.104252e-02  9.047720e-01  4.214988e-01
    outer loop
      vertex   1.607921e+00  2.137976e+00  1.785984e+01
      vertex   8.459144e-01  1.949884e+00  1.837395e+01
      vertex   1.684247e+00  1.949839e+00  1.825264e+01
    endloop
  endfacet
  facet normal -9.386881e-01  2.960024e-01 -1.767691e-01
    outer loop
      vertex  -9.212256e+00  9.808025e-01  6.136631e+00
      vertex  -9.356354e+00  9.532146e-01  6.855628e+00
      vertex  -9.214517e+00  1.402653e+00  6.855028e+00
    endloop
  endfacet
  facet normal  7.831770e-01 -6.212536e-01 -2.603427e-02
    outer loop
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
      vertex  -4.284296e+00  3.528093e+00  2.613650e-16
    endloop
  endfacet
  facet normal -5.127931e-01  8.453942e-01  1.495053e-01
    outer loop
      vertex  -6.237068e+00  3.783979e+00  4.171127e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
    endloop
  endfacet
  facet normal  3.378320e-02  9.718243e-01  2.332728e-01
    outer loop
      vertex   1.607921e+00  2.137976e+00  1.785984e+01
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   8.075836e-01  2.137995e+00  1.797567e+01
    endloop
  endfacet
  facet normal  1.014638e-01 -9.814942e-01  1.624019e-01
    outer loop
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
      vertex   4.202488e+00 -2.180996e+00  1.668565e+01
      vertex   4.544808e+00 -2.180998e+00  1.647177e+01
    endloop
  endfacet
  facet normal -3.467287e-01 -9.333531e-01  9.290566e-02
    outer loop
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
      vertex  -7.974327e+00 -2.180941e+00  1.171617e+01
    endloop
  endfacet
  facet normal -6.995074e-01 -6.783462e-01 -2.248017e-01
    outer loop
      vertex  -5.944186e+00 -4.109646e+00  2.036141e+00
      vertex  -6.623233e+00 -3.515539e+00  2.356373e+00
      vertex  -6.520677e+00 -3.503586e+00  2.001183e+00
    endloop
  endfacet
  facet normal  5.718838e-02 -9.708076e-01  2.329424e-01
    outer loop
      vertex   2.408868e+00 -2.137492e+00  1.766389e+01
      vertex   1.608019e+00 -2.137506e+00  1.786044e+01
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
    endloop
  endfacet
  facet normal  9.721299e-01 -4.156231e-03 -2.344062e-01
    outer loop
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -7.974327e+00 -2.180941e+00  1.171617e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
    endloop
  endfacet
  facet normal  1.016677e-01 -9.045002e-01  4.141773e-01
    outer loop
      vertex   2.523320e+00 -1.948866e+00  1.804772e+01
      vertex   1.608019e+00 -2.137506e+00  1.786044e+01
      vertex   2.408868e+00 -2.137492e+00  1.766389e+01
    endloop
  endfacet
  facet normal  7.020276e-16 -1.141525e-15 -1.000000e+00
    outer loop
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
      vertex  -9.071357e-01 -5.499633e+00 -4.550758e-16
      vertex  -4.403078e-01 -5.559525e+00 -5.898060e-17
    endloop
  endfacet
  facet normal  1.546326e-01 -7.612174e-01  6.297911e-01
    outer loop
      vertex   2.619772e+00 -1.661618e+00  1.837120e+01
      vertex   1.748804e+00 -1.661699e+00  1.858495e+01
      vertex   1.684419e+00 -1.948915e+00  1.825361e+01
    endloop
  endfacet
  facet normal  7.781944e-01 -5.242988e-01 -3.457229e-01
    outer loop
      vertex   6.904957e+00 -2.766088e+00  1.620279e+00
      vertex   6.788991e+00 -3.179214e+00  1.985767e+00
      vertex   6.669502e+00 -3.123020e+00  1.631585e+00
    endloop
  endfacet
  facet normal  3.438219e-02  3.593645e-03  9.994023e-01
    outer loop
      vertex  -4.039023e-01  6.679846e+00  1.334868e+00
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
    endloop
  endfacet
  facet normal -8.563405e-01  4.980579e-01 -1.364527e-01
    outer loop
      vertex  -9.075479e+00  1.445339e+00  6.138269e+00
      vertex  -9.214517e+00  1.402653e+00  6.855028e+00
      vertex  -8.978601e+00  1.807972e+00  6.853913e+00
    endloop
  endfacet
  facet normal -9.989579e-01  6.808051e-08  4.564040e-02
    outer loop
      vertex   8.236661e+00  2.237776e+00  9.019822e+00
      vertex   8.236661e+00 -2.237551e+00  9.019829e+00
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
    endloop
  endfacet
  facet normal  2.264233e-01 -3.132337e-01  9.222890e-01
    outer loop
      vertex   2.736798e+00 -8.841743e-01  1.876368e+01
      vertex   1.807706e+00 -1.189487e+00  1.888808e+01
      vertex   2.707990e+00 -1.189478e+00  1.866706e+01
    endloop
  endfacet
  facet normal  2.854492e-01  9.532573e-01  9.909295e-02
    outer loop
      vertex   7.906376e+00  2.481073e+00  7.203587e+00
      vertex   8.005827e+00  2.413839e+00  7.563888e+00
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
    endloop
  endfacet
  facet normal -4.444564e-01  8.957670e-01 -7.742498e-03
    outer loop
      vertex   2.166294e+00 -5.123985e+00  1.614154e+00
      vertex   2.650582e+00 -4.882418e+00  1.761878e+00
      vertex   2.553920e+00 -4.945607e+00 -2.782992e-16
    endloop
  endfacet
  facet normal  2.264275e-01 -3.132491e-01  9.222828e-01
    outer loop
      vertex   2.736798e+00 -8.841743e-01  1.876368e+01
      vertex   1.826940e+00 -8.841515e-01  1.898706e+01
      vertex   1.807706e+00 -1.189487e+00  1.888808e+01
    endloop
  endfacet
  facet normal -9.449111e-01  7.947319e-02 -3.175327e-01
    outer loop
      vertex  -8.638139e+00  5.261440e-01  4.017769e+00
      vertex  -8.831814e+00  1.030754e+00  4.720401e+00
      vertex  -8.596299e+00  1.045643e+00  4.023285e+00
    endloop
  endfacet
  facet normal -7.948499e-01 -2.752812e-03  6.068000e-01
    outer loop
      vertex  -7.365190e+00  4.444332e-01  1.578280e+01
      vertex  -7.925472e+00  4.444542e-01  1.504889e+01
      vertex  -7.924467e+00  7.686615e-04  1.504819e+01
    endloop
  endfacet
  facet normal -8.878368e-01 -6.757264e-06  4.601585e-01
    outer loop
      vertex   7.275499e+00  2.936335e+00  5.677919e+00
      vertex   7.276844e+00 -2.937180e+00  5.680428e+00
      vertex   7.382584e+00  2.855700e+00  5.884530e+00
    endloop
  endfacet
  facet normal  7.045132e-01 -7.096453e-01 -8.048530e-03
    outer loop
      vertex   9.079329e+00 -1.756750e+00  7.576222e+00
      vertex   8.816117e+00 -2.026272e+00  8.300370e+00
      vertex   8.756794e+00 -2.076908e+00  7.572255e+00
    endloop
  endfacet
  facet normal -8.677916e-01  7.491178e-02 -4.912495e-01
    outer loop
      vertex  -6.999551e+00  4.475117e-01  5.618038e-01
      vertex  -6.962196e+00  8.877678e-01  5.629520e-01
      vertex  -6.650962e+00  8.014841e-01  8.326673e-16
    endloop
  endfacet
  facet normal  9.106144e-01 -1.156046e-02 -4.130954e-01
    outer loop
      vertex   7.936329e+00 -2.689362e-04  2.309899e+00
      vertex   8.089043e+00 -6.465912e-04  2.646547e+00
      vertex   8.083327e+00 -5.267620e-01  2.648672e+00
    endloop
  endfacet
  facet normal  2.384323e-01  2.990338e-03  9.711545e-01
    outer loop
      vertex   2.749675e+00  4.949570e-04  1.880685e+01
      vertex   1.835537e+00  5.168915e-04  1.903129e+01
      vertex   1.835788e+00 -4.431973e-01  1.903259e+01
    endloop
  endfacet
  facet normal -8.226464e-01  4.254402e-01 -3.771649e-01
    outer loop
      vertex  -6.544655e+00  3.054583e+00  1.277907e+00
      vertex  -6.296607e+00  2.910921e+00  5.748339e-01
      vertex  -6.484798e+00  2.544256e+00  5.717058e-01
    endloop
  endfacet
  facet normal  2.384250e-01 -2.887787e-03  9.711567e-01
    outer loop
      vertex   2.750044e+00  4.441681e-01  1.880809e+01
      vertex   1.835783e+00  4.441910e-01  1.903255e+01
      vertex   1.835537e+00  5.168915e-04  1.903129e+01
    endloop
  endfacet
  facet normal -7.962720e-01 -4.894086e-01 -3.555701e-01
    outer loop
      vertex  -6.092205e+00 -3.255135e+00  5.783606e-01
      vertex  -5.921600e+00 -3.112514e+00 -8.326673e-17
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
    endloop
  endfacet
  facet normal -8.070319e-01 -3.134366e-01  5.004570e-01
    outer loop
      vertex  -7.887427e+00 -8.838863e-01  1.502266e+01
      vertex  -8.292838e+00 -1.189617e+00  1.417741e+01
      vertex  -7.804250e+00 -1.189606e+00  1.496531e+01
    endloop
  endfacet
  facet normal  8.356684e-01  5.486558e-01 -2.520061e-02
    outer loop
      vertex   9.146042e+00  1.720049e+00  8.305800e+00
      vertex   9.432271e+00  1.317898e+00  9.041898e+00
      vertex   9.396003e+00  1.339525e+00  8.310082e+00
    endloop
  endfacet
  facet normal -5.603504e-01  3.130330e-01  7.668232e-01
    outer loop
      vertex  -5.221046e+00  1.188795e+00  1.749572e+01
      vertex  -6.018102e+00  8.852997e-01  1.703717e+01
      vertex  -5.276216e+00  8.852768e-01  1.757931e+01
    endloop
  endfacet
  facet normal  2.371179e-01  1.047339e-01  9.658188e-01
    outer loop
      vertex   2.736763e+00  8.850708e-01  1.876354e+01
      vertex   1.826918e+00  8.850937e-01  1.898691e+01
      vertex   1.835783e+00  4.441910e-01  1.903255e+01
    endloop
  endfacet
  facet normal -9.598742e-01  6.108570e-03 -2.803642e-01
    outer loop
      vertex  -8.877419e+00 -4.463196e-04  4.714443e+00
      vertex  -9.080769e+00  5.083599e-01  5.421729e+00
      vertex  -8.874574e+00  5.192089e-01  4.716022e+00
    endloop
  endfacet
  facet normal  3.302179e-01  1.047265e-01  9.380770e-01
    outer loop
      vertex   3.620476e+00  8.850479e-01  1.845246e+01
      vertex   2.750044e+00  4.441681e-01  1.880809e+01
      vertex   3.638045e+00  4.441452e-01  1.849550e+01
    endloop
  endfacet
  facet normal  2.264540e-01  3.129819e-01  9.223669e-01
    outer loop
      vertex   2.708174e+00  1.188345e+00  1.866765e+01
      vertex   1.807832e+00  1.188396e+00  1.888868e+01
      vertex   1.826918e+00  8.850937e-01  1.898691e+01
    endloop
  endfacet
  facet normal  2.083295e-01  4.863422e-01  8.485695e-01
    outer loop
      vertex   2.663707e+00  1.467648e+00  1.851851e+01
      vertex   1.778145e+00  1.467701e+00  1.873589e+01
      vertex   1.807832e+00  1.188396e+00  1.888868e+01
    endloop
  endfacet
  facet normal -8.923647e-16 -1.481687e-16 -1.000000e+00
    outer loop
      vertex   8.043078e-01 -6.628206e+00 -3.209238e-17
      vertex   5.742548e-01 -5.547085e+00  1.301043e-17
      vertex   1.011927e+00 -5.480871e+00 -3.873638e-16
    endloop
  endfacet
  facet normal  1.545060e-01  7.615467e-01  6.294240e-01
    outer loop
      vertex   2.523059e+00  1.949789e+00  1.804679e+01
      vertex   1.684247e+00  1.949839e+00  1.825264e+01
      vertex   1.748731e+00  1.662465e+00  1.858451e+01
    endloop
  endfacet
  facet normal  5.452837e-01  8.236670e-01  1.556867e-01
    outer loop
      vertex   4.680184e+00  5.115396e+00  2.486569e+00
      vertex   4.715715e+00  5.031897e+00  2.803882e+00
      vertex   4.773077e+00  4.986311e+00  2.844149e+00
    endloop
  endfacet
  facet normal  2.602677e-01 -6.209406e-01  7.393873e-01
    outer loop
      vertex   3.523055e+00 -1.470343e+00  1.821387e+01
      vertex   2.663114e+00 -1.470369e+00  1.851656e+01
      vertex   2.619772e+00 -1.661618e+00  1.837120e+01
    endloop
  endfacet
  facet normal  4.940777e-01 -8.681400e-01 -4.711813e-02
    outer loop
      vertex   3.816425e+00 -5.551033e+00  6.146011e-01
      vertex   3.146301e+00 -5.975582e+00  1.409939e+00
      vertex   3.110520e+00 -5.953293e+00  6.240654e-01
    endloop
  endfacet
  facet normal  6.433161e-01 -7.654060e-01 -1.726065e-02
    outer loop
      vertex   7.745208e+00 -2.784725e+00  4.073960e+00
      vertex   7.574584e+00 -2.943947e+00  4.775200e+00
      vertex   7.421623e+00 -3.057121e+00  4.092836e+00
    endloop
  endfacet
  facet normal -5.358414e-02  9.985604e-01 -2.431966e-03
    outer loop
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
      vertex   1.330639e-01 -5.573392e+00 -6.303118e-16
      vertex   6.943097e-02 -5.576807e+00 -2.003606e-16
    endloop
  endfacet
  facet normal  1.015346e-01  9.047667e-01  4.136279e-01
    outer loop
      vertex   2.408713e+00  2.137957e+00  1.766331e+01
      vertex   1.607921e+00  2.137976e+00  1.785984e+01
      vertex   1.684247e+00  1.949839e+00  1.825264e+01
    endloop
  endfacet
  facet normal -3.128519e-02 -9.988915e-01  3.517113e-02
    outer loop
      vertex  -5.486269e+00  2.181330e+00  1.574863e+01
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
      vertex  -5.185413e+00  2.180970e+00  1.600602e+01
    endloop
  endfacet
  facet normal -3.297105e-01  7.619346e-01  5.574464e-01
    outer loop
      vertex  -4.120495e+00  1.950171e+00  1.739424e+01
      vertex  -4.863835e+00  1.950220e+00  1.695451e+01
      vertex  -5.050044e+00  1.663237e+00  1.723664e+01
    endloop
  endfacet
  facet normal  7.216511e-01  6.095145e-01 -3.281944e-01
    outer loop
      vertex   5.777733e+00  4.019957e+00  1.309361e+00
      vertex   6.410461e+00  3.451159e+00  1.644279e+00
      vertex   6.303267e+00  3.385946e+00  1.287462e+00
    endloop
  endfacet
  facet normal  5.618604e-02  9.718406e-01  2.288429e-01
    outer loop
      vertex   2.408713e+00  2.137957e+00  1.766331e+01
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
      vertex   1.607921e+00  2.137976e+00  1.785984e+01
    endloop
  endfacet
  facet normal -1.921358e-01 -9.578993e-01  2.133372e-01
    outer loop
      vertex  -5.486282e+00 -2.180952e+00  1.574862e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
      vertex  -5.789776e+00 -2.177030e+00  1.549290e+01
    endloop
  endfacet
  facet normal  2.737646e-15  6.608358e-15 -1.000000e+00
    outer loop
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
      vertex   5.334304e+00 -1.493209e+00 -2.359224e-16
      vertex   6.503150e+00 -1.615171e+00  2.157996e-15
    endloop
  endfacet
  facet normal -9.989579e-01  3.944691e-08  4.564075e-02
    outer loop
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
      vertex   8.236661e+00 -2.237551e+00  9.019829e+00
      vertex   8.253390e+00 -2.206724e+00  9.385991e+00
    endloop
  endfacet
  facet normal -3.360445e-01 -9.333390e-01  1.263027e-01
    outer loop
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -7.727578e+00 -2.180943e+00  1.248473e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
    endloop
  endfacet
  facet normal  5.621876e-02  9.718233e-01  2.289079e-01
    outer loop
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
      vertex   1.574087e+00  2.180897e+00  1.768593e+01
      vertex   1.607921e+00  2.137976e+00  1.785984e+01
    endloop
  endfacet
  facet normal  5.513420e-01 -7.609701e-01  3.419745e-01
    outer loop
      vertex   8.023282e+00 -1.660970e+00  1.402858e+01
      vertex   7.272491e+00 -1.948517e+00  1.459918e+01
      vertex   7.727928e+00 -1.948465e+00  1.386502e+01
    endloop
  endfacet
  facet normal  1.416166e-01 -9.045032e-01  4.022668e-01
    outer loop
      vertex   3.338141e+00 -1.948816e+00  1.776098e+01
      vertex   2.523320e+00 -1.948866e+00  1.804772e+01
      vertex   2.408868e+00 -2.137492e+00  1.766389e+01
    endloop
  endfacet
  facet normal  2.153343e-01 -7.611620e-01  6.117709e-01
    outer loop
      vertex   3.465739e+00 -1.661538e+00  1.807350e+01
      vertex   2.523320e+00 -1.948866e+00  1.804772e+01
      vertex   3.338141e+00 -1.948816e+00  1.776098e+01
    endloop
  endfacet
  facet normal  2.153453e-01 -7.611941e-01  6.117271e-01
    outer loop
      vertex   3.465739e+00 -1.661538e+00  1.807350e+01
      vertex   2.619772e+00 -1.661618e+00  1.837120e+01
      vertex   2.523320e+00 -1.948866e+00  1.804772e+01
    endloop
  endfacet
  facet normal  2.898904e-01 -4.875804e-01  8.235465e-01
    outer loop
      vertex   3.582416e+00 -1.189468e+00  1.835927e+01
      vertex   2.707990e+00 -1.189478e+00  1.866706e+01
      vertex   2.663114e+00 -1.470369e+00  1.851656e+01
    endloop
  endfacet
  facet normal  3.153305e-01 -3.132386e-01  8.957948e-01
    outer loop
      vertex   3.620520e+00 -8.841972e-01  1.845259e+01
      vertex   2.736798e+00 -8.841743e-01  1.876368e+01
      vertex   2.707990e+00 -1.189478e+00  1.866706e+01
    endloop
  endfacet
  facet normal -5.120212e-01 -8.521868e-01 -1.077592e-01
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -3.772143e+00 -5.505244e+00  4.857226e-17
      vertex  -3.097691e+00 -5.910476e+00  1.601150e-15
    endloop
  endfacet
  facet normal  3.302286e-01 -1.044773e-01  9.381011e-01
    outer loop
      vertex   3.638051e+00 -4.432430e-01  1.849553e+01
      vertex   2.736798e+00 -8.841743e-01  1.876368e+01
      vertex   3.620520e+00 -8.841972e-01  1.845259e+01
    endloop
  endfacet
  facet normal  6.704490e-01 -7.419063e-01 -8.549467e-03
    outer loop
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
      vertex  -3.890054e+00  3.963817e+00  1.595946e-16
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
    endloop
  endfacet
  facet normal  4.203153e-01  1.047282e-01  9.013141e-01
    outer loop
      vertex   4.469564e+00  8.850250e-01  1.805651e+01
      vertex   3.620476e+00  8.850479e-01  1.845246e+01
      vertex   3.638045e+00  4.441452e-01  1.849550e+01
    endloop
  endfacet
  facet normal  3.320456e-01  2.965916e-03  9.432586e-01
    outer loop
      vertex   3.637555e+00  4.730225e-04  1.849431e+01
      vertex   2.750051e+00 -4.432201e-01  1.880812e+01
      vertex   3.638051e+00 -4.432430e-01  1.849553e+01
    endloop
  endfacet
  facet normal  3.320405e-01  2.977493e-03  9.432604e-01
    outer loop
      vertex   3.637555e+00  4.730225e-04  1.849431e+01
      vertex   2.749675e+00  4.949570e-04  1.880685e+01
      vertex   2.750051e+00 -4.432201e-01  1.880812e+01
    endloop
  endfacet
  facet normal -7.326716e-15 -1.949738e-15 -1.000000e+00
    outer loop
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
      vertex  -9.900771e-01 -5.485547e+00  1.251479e-16
      vertex  -9.071357e-01 -5.499633e+00 -4.550758e-16
    endloop
  endfacet
  facet normal  5.090428e-01 -2.933660e-03  8.607363e-01
    outer loop
      vertex   5.301584e+00  4.441013e-01  1.761840e+01
      vertex   4.490647e+00  4.520416e-04  1.809648e+01
      vertex   5.300865e+00  4.310608e-04  1.761731e+01
    endloop
  endfacet
  facet normal  3.320404e-01 -2.905156e-03  9.432607e-01
    outer loop
      vertex   3.638045e+00  4.441452e-01  1.849550e+01
      vertex   2.749675e+00  4.949570e-04  1.880685e+01
      vertex   3.637555e+00  4.730225e-04  1.849431e+01
    endloop
  endfacet
  facet normal  7.832288e-01  6.193731e-01  5.412606e-02
    outer loop
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
      vertex   9.325606e+00  1.466988e+00  9.775280e+00
      vertex   9.171400e+00  1.661978e+00  9.775407e+00
    endloop
  endfacet
  facet normal -2.206232e-01  9.718273e-01  8.292822e-02
    outer loop
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
      vertex  -8.030187e+00  2.138250e+00  1.215796e+01
    endloop
  endfacet
  facet normal -2.276449e-01  9.718315e-01  6.100234e-02
    outer loop
      vertex  -8.243571e+00  2.138269e+00  1.136140e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
    endloop
  endfacet
  facet normal -5.085156e-01  8.610476e-01 -2.982825e-03
    outer loop
      vertex   2.650582e+00 -4.882418e+00  1.761878e+00
      vertex   3.029783e+00 -4.664573e+00 -2.392762e-16
      vertex   2.553920e+00 -4.945607e+00 -2.782992e-16
    endloop
  endfacet
  facet normal -1.199910e-01  9.718185e-01  2.029067e-01
    outer loop
      vertex  -3.933839e+00  2.138109e+00  1.704051e+01
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
      vertex  -4.643528e+00  2.138128e+00  1.662074e+01
    endloop
  endfacet
  facet normal -7.631769e-01  5.554759e-01 -3.301628e-01
    outer loop
      vertex  -6.544655e+00  3.054583e+00  1.277907e+00
      vertex  -6.411795e+00  3.454931e+00  1.644359e+00
      vertex  -6.304759e+00  3.389902e+00  1.287535e+00
    endloop
  endfacet
  facet normal  3.302130e-01  1.047365e-01  9.380776e-01
    outer loop
      vertex   3.620476e+00  8.850479e-01  1.845246e+01
      vertex   2.736763e+00  8.850708e-01  1.876354e+01
      vertex   2.750044e+00  4.441681e-01  1.880809e+01
    endloop
  endfacet
  facet normal -9.976256e-01  3.179506e-03  6.879621e-02
    outer loop
      vertex  -9.562470e+00  8.621216e-04  1.070205e+01
      vertex  -9.626000e+00  7.368724e-04  9.780801e+00
      vertex  -9.563873e+00 -4.428368e-01  1.070222e+01
    endloop
  endfacet
  facet normal -1.425769e-01 -1.044805e-01  9.842539e-01
    outer loop
      vertex  -9.224034e-01 -4.431305e-01  1.916488e+01
      vertex  -1.836132e+00 -4.431095e-01  1.903253e+01
      vertex  -1.827286e+00 -8.840618e-01  1.898700e+01
    endloop
  endfacet
  facet normal  1.433173e-01  2.990964e-03  9.896722e-01
    outer loop
      vertex   1.835537e+00  5.168915e-04  1.903129e+01
      vertex   9.220275e-01 -4.431763e-01  1.916492e+01
      vertex   1.835788e+00 -4.431973e-01  1.903259e+01
    endloop
  endfacet
  facet normal  5.867175e-01  1.047388e-01  8.029896e-01
    outer loop
      vertex   6.017879e+00  8.849792e-01  1.703752e+01
      vertex   5.275980e+00  8.850021e-01  1.757960e+01
      vertex   5.301584e+00  4.441013e-01  1.761840e+01
    endloop
  endfacet
  facet normal  2.604379e-01  6.202692e-01  7.398907e-01
    outer loop
      vertex   3.465590e+00  1.662270e+00  1.807309e+01
      vertex   2.619659e+00  1.662367e+00  1.837077e+01
      vertex   2.663707e+00  1.467648e+00  1.851851e+01
    endloop
  endfacet
  facet normal  5.369804e-14 -3.094805e-14 -1.000000e+00
    outer loop
      vertex   2.532637e+00  4.957038e+00 -2.247706e-16
      vertex   3.084982e+00  5.916950e+00 -2.723516e-16
      vertex   3.100696e+00  5.908006e+00  8.482798e-16
    endloop
  endfacet
  facet normal  3.232963e-16 -6.945409e-17 -1.000000e+00
    outer loop
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
      vertex   4.414157e+00 -5.005417e+00  4.857226e-16
      vertex   3.789027e+00 -5.492561e+00  3.174544e-16
    endloop
  endfacet
  facet normal -6.311578e-01  3.130456e-01  7.096776e-01
    outer loop
      vertex  -5.955170e+00  1.188843e+00  1.695925e+01
      vertex  -6.704711e+00  8.853207e-01  1.642652e+01
      vertex  -6.018102e+00  8.852997e-01  1.703717e+01
    endloop
  endfacet
  facet normal  2.152581e-01  7.614367e-01  6.114557e-01
    outer loop
      vertex   3.337795e+00  1.949743e+00  1.776009e+01
      vertex   2.619659e+00  1.662367e+00  1.837077e+01
      vertex   3.465590e+00  1.662270e+00  1.807309e+01
    endloop
  endfacet
  facet normal -2.414380e-01  9.704152e-01  1.439353e-03
    outer loop
      vertex  -1.820179e+00  6.458174e+00  1.445504e+00
      vertex  -2.003711e+00  6.412324e+00  1.571811e+00
      vertex  -1.604877e+00  6.511686e+00  1.482458e+00
    endloop
  endfacet
  facet normal -9.385683e-01 -3.443849e-01 -2.210061e-02
    outer loop
      vertex   5.020370e+00  2.202127e+00  3.026297e+00
      vertex   5.137590e+00  2.076873e+00  9.801188e-17
      vertex   5.207137e+00  1.683670e+00  3.173629e+00
    endloop
  endfacet
  facet normal -6.272008e-01  6.747798e-01  3.889620e-01
    outer loop
      vertex  -7.547735e+00  1.665148e+00  1.478848e+01
      vertex  -8.021436e+00  1.663712e+00  1.402713e+01
      vertex  -7.550043e+00  1.662085e+00  1.479008e+01
    endloop
  endfacet
  facet normal  4.260486e-01 -9.042233e-01  2.937344e-02
    outer loop
      vertex   8.776464e+00 -1.948257e+00  1.061073e+01
      vertex   8.378459e+00 -2.137298e+00  1.056425e+01
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
    endloop
  endfacet
  facet normal  1.414418e-01  9.047370e-01  4.018024e-01
    outer loop
      vertex   3.186519e+00  2.137938e+00  1.738959e+01
      vertex   2.523059e+00  1.949789e+00  1.804679e+01
      vertex   3.337795e+00  1.949743e+00  1.776009e+01
    endloop
  endfacet
  facet normal  8.385941e-01  2.850080e-01 -4.642525e-01
    outer loop
      vertex   7.122206e+00  1.870544e+00  1.255249e+00
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
    endloop
  endfacet
  facet normal -3.313976e-01  6.207071e-01  7.105619e-01
    outer loop
      vertex  -3.465606e+00  1.663043e+00  1.807230e+01
      vertex  -4.278252e+00  1.663140e+00  1.769321e+01
      vertex  -4.350411e+00  1.468069e+00  1.782996e+01
    endloop
  endfacet
  facet normal -3.836443e-01 -9.234617e-01 -5.948773e-03
    outer loop
      vertex   1.863009e+00  5.246222e+00  1.537825e+00
      vertex   2.026891e+00  5.188045e+00 -1.376214e-17
      vertex   2.293362e+00  5.066713e+00  1.649853e+00
    endloop
  endfacet
  facet normal  1.339083e-01  9.909859e-01  3.951917e-03
    outer loop
      vertex   1.127824e+00  6.599570e+00  1.402349e+00
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
      vertex   8.050640e-01  6.643335e+00  1.364312e+00
    endloop
  endfacet
  facet normal  7.825844e-02  9.718303e-01  2.223096e-01
    outer loop
      vertex   3.186519e+00  2.137938e+00  1.738959e+01
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   2.408713e+00  2.137957e+00  1.766331e+01
    endloop
  endfacet
  facet normal  1.802689e-01 -9.044497e-01  3.866186e-01
    outer loop
      vertex   4.121053e+00 -1.948767e+00  1.739597e+01
      vertex   3.186728e+00 -2.137477e+00  1.739015e+01
      vertex   3.934129e+00 -2.137462e+00  1.704169e+01
    endloop
  endfacet
  facet normal  1.802751e-01 -9.044781e-01  3.865492e-01
    outer loop
      vertex   4.121053e+00 -1.948767e+00  1.739597e+01
      vertex   3.338141e+00 -1.948816e+00  1.776098e+01
      vertex   3.186728e+00 -2.137477e+00  1.739015e+01
    endloop
  endfacet
  facet normal  2.741125e-01 -7.611691e-01  5.877787e-01
    outer loop
      vertex   4.278577e+00 -1.661456e+00  1.769453e+01
      vertex   3.465739e+00 -1.661538e+00  1.807350e+01
      vertex   3.338141e+00 -1.948816e+00  1.776098e+01
    endloop
  endfacet
  facet normal  3.312878e-01 -6.209003e-01  7.104443e-01
    outer loop
      vertex   4.349310e+00 -1.470318e+00  1.782860e+01
      vertex   3.465739e+00 -1.661538e+00  1.807350e+01
      vertex   4.278577e+00 -1.661456e+00  1.769453e+01
    endloop
  endfacet
  facet normal  2.860706e-01  9.547089e-01  8.182088e-02
    outer loop
      vertex   8.005827e+00  2.413839e+00  7.563888e+00
      vertex   8.088119e+00  2.358255e+00  7.924740e+00
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
    endloop
  endfacet
  facet normal  3.312874e-01 -6.209201e-01  7.104272e-01
    outer loop
      vertex   4.349310e+00 -1.470318e+00  1.782860e+01
      vertex   3.523055e+00 -1.470343e+00  1.821387e+01
      vertex   3.465739e+00 -1.661538e+00  1.807350e+01
    endloop
  endfacet
  facet normal -2.384838e-01 -2.822178e-03  9.711424e-01
    outer loop
      vertex  -1.836113e+00  4.442806e-01  1.903244e+01
      vertex  -2.750353e+00  4.443016e-01  1.880793e+01
      vertex  -2.749995e+00  6.237030e-04  1.880673e+01
    endloop
  endfacet
  facet normal -1.239151e-01  5.382305e-08 -9.922928e-01
    outer loop
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
      vertex   1.183383e+00 -2.180983e+00  1.775005e+01
      vertex   1.183401e+00  2.181276e+00  1.775005e+01
    endloop
  endfacet
  facet normal  6.962733e-01  3.129618e-01  6.459556e-01
    outer loop
      vertex   7.252967e+00  1.188049e+00  1.568889e+01
      vertex   6.704513e+00  8.849583e-01  1.642692e+01
      vertex   7.329475e+00  8.849373e-01  1.575328e+01
    endloop
  endfacet
  facet normal  4.013719e-01 -3.132168e-01  8.606950e-01
    outer loop
      vertex   4.469616e+00 -8.842201e-01  1.805662e+01
      vertex   3.620520e+00 -8.841972e-01  1.845259e+01
      vertex   3.582416e+00 -1.189468e+00  1.835927e+01
    endloop
  endfacet
  facet normal  2.668381e-01 -1.980315e-03  9.637393e-01
    outer loop
      vertex  -2.003711e+00  6.412324e+00  1.571811e+00
      vertex  -2.393248e+00  6.295172e+00  1.679424e+00
      vertex  -2.166200e+00  5.124269e+00  1.614154e+00
    endloop
  endfacet
  facet normal -6.606364e-01  7.499388e-01  3.393047e-02
    outer loop
      vertex  -9.178032e+00  1.689976e+00  9.037078e+00
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
    endloop
  endfacet
  facet normal -9.173719e-01 -7.523190e-02 -3.908567e-01
    outer loop
      vertex  -8.374131e+00 -5.304680e-01  3.328518e+00
      vertex  -8.044674e+00 -1.047447e+00  2.654763e+00
      vertex  -8.333854e+00 -1.053164e+00  3.334592e+00
    endloop
  endfacet
  facet normal  4.203334e-01 -1.044794e-01  9.013345e-01
    outer loop
      vertex   4.491258e+00 -4.432640e-01  1.809764e+01
      vertex   3.638051e+00 -4.432430e-01  1.849553e+01
      vertex   3.620520e+00 -8.841972e-01  1.845259e+01
    endloop
  endfacet
  facet normal -2.828341e-01  9.049016e-01  3.180532e-01
    outer loop
      vertex  -5.296445e+00  2.138147e+00  1.614360e+01
      vertex  -6.180614e+00  1.950312e+00  1.589176e+01
      vertex  -5.547705e+00  1.950266e+00  1.645471e+01
    endloop
  endfacet
  facet normal -4.444509e-01 -4.876530e-01  7.514373e-01
    outer loop
      vertex  -4.422828e+00 -1.189554e+00  1.796718e+01
      vertex  -5.134163e+00 -1.470596e+00  1.736407e+01
      vertex  -4.349491e+00 -1.470572e+00  1.782819e+01
    endloop
  endfacet
  facet normal  4.203129e-01  1.047332e-01  9.013146e-01
    outer loop
      vertex   4.469564e+00  8.850250e-01  1.805651e+01
      vertex   3.638045e+00  4.441452e-01  1.849550e+01
      vertex   4.491253e+00  4.441223e-01  1.809762e+01
    endloop
  endfacet
  facet normal  3.029714e-01  9.529932e-01 -3.524215e-03
    outer loop
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
      vertex  -1.511060e+00 -5.363482e+00 -3.249137e-16
      vertex  -1.862915e+00 -5.245935e+00  1.537825e+00
    endloop
  endfacet
  facet normal -7.831845e-01  6.212441e-01 -2.603632e-02
    outer loop
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
      vertex   4.284388e+00 -3.527809e+00 -4.764707e-16
    endloop
  endfacet
  facet normal  4.252121e-01  9.046142e-01  2.946090e-02
    outer loop
      vertex   8.377821e+00  2.137769e+00  1.056418e+01
      vertex   8.775695e+00  1.949236e+00  1.061064e+01
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
    endloop
  endfacet
  facet normal -8.596940e-01  1.270329e-01 -4.947613e-01
    outer loop
      vertex  -6.962196e+00  8.877678e-01  5.629520e-01
      vertex  -6.591945e+00  1.200882e+00 -6.308086e-18
      vertex  -6.650962e+00  8.014841e-01  8.326673e-16
    endloop
  endfacet
  facet normal  3.744804e-02 -9.988891e-01  2.860487e-02
    outer loop
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   6.561607e+00  2.181231e+00  1.458983e+01
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
    endloop
  endfacet
  facet normal  8.521422e-01  3.129363e-01  4.194336e-01
    outer loop
      vertex   8.702976e+00  1.187906e+00  1.334635e+01
      vertex   8.380954e+00  8.848953e-01  1.422666e+01
      vertex   8.794740e+00  8.848743e-01  1.338601e+01
    endloop
  endfacet
  facet normal -6.265849e-01  7.677797e-01 -1.338124e-01
    outer loop
      vertex  -5.194129e+00  4.607729e+00  1.333857e+00
      vertex  -4.598021e+00  5.164835e+00  1.739065e+00
      vertex  -4.555652e+00  5.133276e+00  1.359595e+00
    endloop
  endfacet
  facet normal  4.014123e-01  3.129679e-01  8.607667e-01
    outer loop
      vertex   4.422884e+00  1.188246e+00  1.796803e+01
      vertex   3.620476e+00  8.850479e-01  1.845246e+01
      vertex   4.469564e+00  8.850250e-01  1.805651e+01
    endloop
  endfacet
  facet normal -1.252512e-01  4.864560e-01  8.646806e-01
    outer loop
      vertex  -8.934164e-01  1.467857e+00  1.886393e+01
      vertex  -1.778435e+00  1.467911e+00  1.873570e+01
      vertex  -1.808141e+00  1.188595e+00  1.888854e+01
    endloop
  endfacet
  facet normal  3.693216e-01  4.862443e-01  7.919394e-01
    outer loop
      vertex   4.350276e+00  1.467543e+00  1.783040e+01
      vertex   3.582659e+00  1.188295e+00  1.835983e+01
      vertex   4.422884e+00  1.188246e+00  1.796803e+01
    endloop
  endfacet
  facet normal  9.921287e-01  1.047429e-01  6.862628e-02
    outer loop
      vertex   9.517658e+00  8.848133e-01  1.069732e+01
      vertex   9.563832e+00  4.439163e-01  1.070271e+01
      vertex   9.627390e+00  4.457207e-01  9.781108e+00
    endloop
  endfacet
  facet normal  3.693003e-01  4.862801e-01  7.919273e-01
    outer loop
      vertex   4.350276e+00  1.467543e+00  1.783040e+01
      vertex   3.523838e+00  1.467596e+00  1.821576e+01
      vertex   3.582659e+00  1.188295e+00  1.835983e+01
    endloop
  endfacet
  facet normal  6.650833e-01  7.168270e-01 -2.093400e-01
    outer loop
      vertex   5.252198e+00  4.645002e+00  1.705145e+00
      vertex   5.938993e+00  4.104437e+00  2.036110e+00
      vertex   5.858973e+00  4.072660e+00  1.673073e+00
    endloop
  endfacet
  facet normal -7.528764e-01  5.970843e-01 -2.768889e-01
    outer loop
      vertex  -5.615840e+00  3.921659e+00  5.863419e-01
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
      vertex  -5.501915e+00  3.793403e+00  3.122502e-16
    endloop
  endfacet
  facet normal  3.315158e-01  6.202145e-01  7.109369e-01
    outer loop
      vertex   4.278395e+00  1.662172e+00  1.769416e+01
      vertex   3.465590e+00  1.662270e+00  1.807309e+01
      vertex   3.523838e+00  1.467596e+00  1.821576e+01
    endloop
  endfacet
  facet normal  7.883386e-01 -5.143211e-01 -3.376327e-01
    outer loop
      vertex   7.435361e+00 -2.462561e+00  2.337803e+00
      vertex   7.577900e+00 -2.477064e+00  2.692711e+00
      vertex   7.331333e+00 -2.866991e+00  2.710981e+00
    endloop
  endfacet
  facet normal  9.172389e-01  7.635225e-02 -3.909515e-01
    outer loop
      vertex   8.043606e+00  1.044596e+00  2.654828e+00
      vertex   8.332925e+00  1.049910e+00  3.334658e+00
      vertex   8.373780e+00  5.278606e-01  3.328556e+00
    endloop
  endfacet
  facet normal  2.740067e-01  7.613880e-01  5.875446e-01
    outer loop
      vertex   4.120631e+00  1.949694e+00  1.739514e+01
      vertex   3.465590e+00  1.662270e+00  1.807309e+01
      vertex   4.278395e+00  1.662172e+00  1.769416e+01
    endloop
  endfacet
  facet normal -8.643606e-01 -1.438827e-01 -4.818491e-01
    outer loop
      vertex  -6.893128e+00 -1.314762e+00  5.645828e-01
      vertex  -7.333118e+00 -9.526539e-01  1.245728e+00
      vertex  -6.964637e+00 -8.798046e-01  5.629778e-01
    endloop
  endfacet
  facet normal  1.800489e-01  9.047208e-01  3.860864e-01
    outer loop
      vertex   3.933867e+00  2.137918e+00  1.704117e+01
      vertex   3.337795e+00  1.949743e+00  1.776009e+01
      vertex   4.120631e+00  1.949694e+00  1.739514e+01
    endloop
  endfacet
  facet normal  1.800081e-01  9.047410e-01  3.860579e-01
    outer loop
      vertex   3.933867e+00  2.137918e+00  1.704117e+01
      vertex   3.186519e+00  2.137938e+00  1.738959e+01
      vertex   3.337795e+00  1.949743e+00  1.776009e+01
    endloop
  endfacet
  facet normal  8.816195e-01  1.682894e-02 -4.716607e-01
    outer loop
      vertex   7.370080e+00  4.802914e-01  1.242837e+00
      vertex   7.565843e+00  1.035690e-03  1.591653e+00
      vertex   7.378617e+00  1.985550e-03  1.241727e+00
    endloop
  endfacet
  facet normal  1.242554e-01 -9.693484e-01  2.119534e-01
    outer loop
      vertex   4.643985e+00 -2.137446e+00  1.662199e+01
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
    endloop
  endfacet
  facet normal -9.372317e-01  2.397985e-01 -2.531671e-01
    outer loop
      vertex  -8.831814e+00  1.030754e+00  4.720401e+00
      vertex  -8.906251e+00  1.487829e+00  5.428909e+00
      vertex  -8.707513e+00  1.523714e+00  4.727165e+00
    endloop
  endfacet
  facet normal -3.616420e-01  9.049349e-01  2.242942e-01
    outer loop
      vertex  -6.941405e+00  2.138201e+00  1.437052e+01
      vertex  -7.725738e+00  1.950449e+00  1.386340e+01
      vertex  -7.270593e+00  1.950403e+00  1.459744e+01
    endloop
  endfacet
  facet normal -4.303227e-01  7.620111e-01  4.839021e-01
    outer loop
      vertex  -5.547705e+00  1.950266e+00  1.645471e+01
      vertex  -6.417213e+00  1.663426e+00  1.613317e+01
      vertex  -5.760086e+00  1.663332e+00  1.671769e+01
    endloop
  endfacet
  facet normal  8.304802e-01  5.072486e-01 -2.302204e-01
    outer loop
      vertex   8.037576e+00  2.432901e+00  4.057489e+00
      vertex   8.503082e+00  1.978765e+00  4.736118e+00
      vertex   8.288459e+00  2.015738e+00  4.043362e+00
    endloop
  endfacet
  facet normal  5.299329e-01  4.045699e-04 -8.480395e-01
    outer loop
      vertex  -4.545118e+00 -2.180956e+00  1.647151e+01
      vertex  -4.546076e+00  2.180994e+00  1.647299e+01
      vertex  -4.202807e+00 -2.180958e+00  1.668542e+01
    endloop
  endfacet
  facet normal  7.346212e-01  6.197532e-01  2.761118e-01
    outer loop
      vertex   8.734851e+00  1.661410e+00  1.238410e+01
      vertex   8.419196e+00  1.661506e+00  1.322371e+01
      vertex   8.560225e+00  1.467184e+00  1.328466e+01
    endloop
  endfacet
  facet normal  4.624598e-01 -6.208797e-01  6.329608e-01
    outer loop
      vertex   5.856004e+00 -1.470266e+00  1.683706e+01
      vertex   5.050582e+00 -1.661374e+00  1.723807e+01
      vertex   5.760838e+00 -1.661295e+00  1.671921e+01
    endloop
  endfacet
  facet normal -1.324182e-01 -9.911938e-01 -5.368917e-04
    outer loop
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
      vertex   9.072288e-01  5.499919e+00  6.370290e-17
      vertex   9.514104e-01  5.493269e+00  1.380087e+00
    endloop
  endfacet
  facet normal  1.227536e-01 -9.704858e-01  2.075789e-01
    outer loop
      vertex   4.643985e+00 -2.137446e+00  1.662199e+01
      vertex   3.934129e+00 -2.137462e+00  1.704169e+01
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
    endloop
  endfacet
  facet normal  8.528198e-01 -1.783452e-01 -4.908067e-01
    outer loop
      vertex   6.892925e+00 -1.313347e+00  5.645704e-01
      vertex   6.513909e+00 -1.572044e+00 -3.101686e-15
      vertex   6.594516e+00 -1.186593e+00 -2.079145e-15
    endloop
  endfacet
  facet normal  2.371279e-01 -1.044729e-01  9.658446e-01
    outer loop
      vertex   2.750051e+00 -4.432201e-01  1.880812e+01
      vertex   1.826940e+00 -8.841515e-01  1.898706e+01
      vertex   2.736798e+00 -8.841743e-01  1.876368e+01
    endloop
  endfacet
  facet normal  9.303776e-01 -2.557476e-01 -2.626609e-01
    outer loop
      vertex   8.832570e+00 -1.031635e+00  4.720345e+00
      vertex   9.037848e+00 -1.008127e+00  5.424577e+00
      vertex   8.907182e+00 -1.487871e+00  5.428856e+00
    endloop
  endfacet
  facet normal -4.303156e-01  7.620486e-01  4.838495e-01
    outer loop
      vertex  -5.547705e+00  1.950266e+00  1.645471e+01
      vertex  -6.180614e+00  1.950312e+00  1.589176e+01
      vertex  -6.417213e+00  1.663426e+00  1.613317e+01
    endloop
  endfacet
  facet normal -8.498494e-01  3.122107e-03  5.270163e-01
    outer loop
      vertex  -7.924467e+00  7.686615e-04  1.504819e+01
      vertex  -8.421803e+00 -4.429150e-01  1.424883e+01
      vertex  -7.925608e+00 -4.429359e-01  1.504898e+01
    endloop
  endfacet
  facet normal  8.998378e-16  1.535154e-16 -1.000000e+00
    outer loop
      vertex  -1.585613e+00 -6.485322e+00 -5.642188e-16
      vertex  -1.511060e+00 -5.363482e+00 -3.249137e-16
      vertex  -9.900771e-01 -5.485547e+00  1.251479e-16
    endloop
  endfacet
  facet normal -1.869170e-01 -6.210323e-01  7.611707e-01
    outer loop
      vertex  -1.778063e+00 -1.470493e+00  1.873373e+01
      vertex  -2.619959e+00 -1.662099e+00  1.837066e+01
      vertex  -1.749077e+00 -1.662018e+00  1.858458e+01
    endloop
  endfacet
  facet normal  4.834673e-01  3.129747e-01  8.174999e-01
    outer loop
      vertex   5.220885e+00  1.188196e+00  1.749611e+01
      vertex   4.422884e+00  1.188246e+00  1.796803e+01
      vertex   4.469564e+00  8.850250e-01  1.805651e+01
    endloop
  endfacet
  facet normal  5.335419e-01 -8.355228e-01 -1.312810e-01
    outer loop
      vertex   4.558254e+00 -5.128565e+00  1.359461e+00
      vertex   4.600634e+00 -5.161119e+00  1.738890e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
    endloop
  endfacet
  facet normal  3.993664e-01  6.200837e-01  6.752797e-01
    outer loop
      vertex   5.050371e+00  1.662075e+00  1.723773e+01
      vertex   4.350276e+00  1.467543e+00  1.783040e+01
      vertex   5.135185e+00  1.467489e+00  1.736625e+01
    endloop
  endfacet
  facet normal  4.607400e-01  8.875007e-01 -7.822480e-03
    outer loop
      vertex  -2.293268e+00 -5.066431e+00  1.649853e+00
      vertex  -2.532545e+00 -4.956754e+00 -6.938894e-17
      vertex  -2.702217e+00 -4.852983e+00  1.779746e+00
    endloop
  endfacet
  facet normal -7.904983e-01 -1.044744e-01  6.034878e-01
    outer loop
      vertex  -7.365310e+00 -4.429569e-01  1.578290e+01
      vertex  -7.925608e+00 -4.429359e-01  1.504898e+01
      vertex  -7.887427e+00 -8.838863e-01  1.502266e+01
    endloop
  endfacet
  facet normal  3.465599e-01 -9.167336e-01  1.987355e-01
    outer loop
      vertex   7.276844e+00 -2.937180e+00  5.680428e+00
      vertex   7.163453e+00 -3.024397e+00  5.475844e+00
      vertex   7.325849e+00 -2.964117e+00  5.470715e+00
    endloop
  endfacet
  facet normal  2.855681e-01 -9.531722e-01  9.956715e-02
    outer loop
      vertex   7.906373e+00 -2.481363e+00  7.203579e+00
      vertex   8.378669e+00 -2.301809e+00  7.567889e+00
      vertex   8.005828e+00 -2.413929e+00  7.563893e+00
    endloop
  endfacet
  facet normal -8.403946e-01 -3.956073e-01 -3.704479e-01
    outer loop
      vertex  -7.434761e+00 -2.464277e+00  2.337805e+00
      vertex  -7.785738e+00 -2.036400e+00  2.677091e+00
      vertex  -7.642212e+00 -2.020126e+00  2.334112e+00
    endloop
  endfacet
  facet normal  3.826542e-01 -7.611307e-01  5.236945e-01
    outer loop
      vertex   5.760838e+00 -1.661295e+00  1.671921e+01
      vertex   5.050582e+00 -1.661374e+00  1.723807e+01
      vertex   4.864637e+00 -1.948717e+00  1.695632e+01
    endloop
  endfacet
  facet normal -8.520460e-01 -2.142615e-01 -4.776083e-01
    outer loop
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
      vertex  -7.250942e+00 -1.419529e+00  1.249917e+00
      vertex  -6.893128e+00 -1.314762e+00  5.645828e-01
    endloop
  endfacet
  facet normal -2.447999e-02  1.593566e-03 -9.996991e-01
    outer loop
      vertex  -9.427529e+00  1.298449e+00  9.776813e+00
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
      vertex  -9.480475e+00  1.189270e+00  9.777935e+00
    endloop
  endfacet
  facet normal -9.125442e-01  4.085757e-01 -1.813910e-02
    outer loop
      vertex   5.043385e+00 -2.145653e+00  3.044071e+00
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
      vertex   4.930933e+00 -2.531955e+00  0.000000e+00
    endloop
  endfacet
  facet normal -3.102383e-16  5.336458e-16 -1.000000e+00
    outer loop
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
      vertex  -6.260275e+00 -2.374932e+00 -9.714451e-17
      vertex  -6.397487e+00 -1.984235e+00  1.539173e-16
    endloop
  endfacet
  facet normal  1.870306e-01  6.202633e-01  7.617697e-01
    outer loop
      vertex   2.619659e+00  1.662367e+00  1.837077e+01
      vertex   1.778145e+00  1.467701e+00  1.873589e+01
      vertex   2.663707e+00  1.467648e+00  1.851851e+01
    endloop
  endfacet
  facet normal -2.492092e-01  9.659019e-01  7.020178e-02
    outer loop
      vertex  -8.253299e+00  2.207151e+00  9.386082e+00
      vertex  -8.236568e+00  2.238081e+00  9.019915e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
    endloop
  endfacet
  facet normal  8.397568e-01  3.972383e-01 -3.701488e-01
    outer loop
      vertex   7.431244e+00  2.459944e+00  2.337697e+00
      vertex   7.783234e+00  2.032179e+00  2.677185e+00
      vertex   7.639423e+00  2.016447e+00  2.334038e+00
    endloop
  endfacet
  facet normal  5.150805e-01 -4.875506e-01  7.049727e-01
    outer loop
      vertex   5.954641e+00 -1.189440e+00  1.695921e+01
      vertex   5.134046e+00 -1.470291e+00  1.736454e+01
      vertex   5.856004e+00 -1.470266e+00  1.683706e+01
    endloop
  endfacet
  facet normal -6.814500e-01 -7.101933e-01 -1.767804e-01
    outer loop
      vertex  -6.623233e+00 -3.515539e+00  2.356373e+00
      vertex  -6.738110e+00 -3.496881e+00  2.724241e+00
      vertex  -7.044407e+00 -3.201189e+00  2.717045e+00
    endloop
  endfacet
  facet normal -5.241124e-01 -8.386775e-01  1.480743e-01
    outer loop
      vertex  -4.343534e+00 -5.321756e+00  2.559642e+00
      vertex  -4.534791e+00 -5.180698e+00  2.681621e+00
      vertex  -4.685282e+00 -5.121077e+00  2.486646e+00
    endloop
  endfacet
  facet normal  9.659285e-01 -3.017523e-03  2.587917e-01
    outer loop
      vertex   9.412313e+00  4.439354e-01  1.161362e+01
      vertex   9.167368e+00  2.927780e-04  1.252269e+01
      vertex   9.411002e+00  2.746582e-04  1.161333e+01
    endloop
  endfacet
  facet normal -8.555782e-01  1.620449e-07  5.176736e-01
    outer loop
      vertex   6.959351e+00  3.182512e+00  5.138515e+00
      vertex   6.959345e+00 -3.185122e+00  5.138508e+00
      vertex   7.163453e+00 -3.024397e+00  5.475844e+00
    endloop
  endfacet
  facet normal  2.312433e-16 -1.056454e-16 -1.000000e+00
    outer loop
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
      vertex  -5.137498e+00 -2.076589e+00  1.309716e-16
      vertex  -6.260275e+00 -2.374932e+00 -9.714451e-17
    endloop
  endfacet
  facet normal -9.805951e-01  1.024806e-03 -1.960415e-01
    outer loop
      vertex  -9.257729e+00  3.471375e-04  6.134778e+00
      vertex  -9.401813e+00  6.008148e-04  6.855484e+00
      vertex  -9.401338e+00  4.816837e-01  6.855623e+00
    endloop
  endfacet
  facet normal  5.150804e-01 -4.875757e-01  7.049553e-01
    outer loop
      vertex   5.954641e+00 -1.189440e+00  1.695921e+01
      vertex   5.220532e+00 -1.189449e+00  1.749559e+01
      vertex   5.134046e+00 -1.470291e+00  1.736454e+01
    endloop
  endfacet
  facet normal -5.177004e-02 -4.029270e-02 -9.978458e-01
    outer loop
      vertex   9.427593e+00  1.298067e+00  9.776810e+00
      vertex   9.171400e+00  1.661978e+00  9.775407e+00
      vertex   9.325606e+00  1.466988e+00  9.775280e+00
    endloop
  endfacet
  facet normal  5.209201e-01 -6.208636e-01  5.858077e-01
    outer loop
      vertex   6.524189e+00 -1.470240e+00  1.624290e+01
      vertex   5.760838e+00 -1.661295e+00  1.671921e+01
      vertex   6.418201e+00 -1.661215e+00  1.613475e+01
    endloop
  endfacet
  facet normal  5.602816e-01 -3.132080e-01  7.668020e-01
    outer loop
      vertex   6.017940e+00 -8.842640e-01  1.703760e+01
      vertex   5.276037e+00 -8.842430e-01  1.757970e+01
      vertex   5.220532e+00 -1.189449e+00  1.749559e+01
    endloop
  endfacet
  facet normal  5.867392e-01 -1.044768e-01  8.030080e-01
    outer loop
      vertex   6.047077e+00 -4.433079e-01  1.707368e+01
      vertex   5.301583e+00 -4.432869e-01  1.761840e+01
      vertex   5.276037e+00 -8.842430e-01  1.757970e+01
    endloop
  endfacet
  facet normal  4.665889e-01 -8.810990e-01 -7.719668e-02
    outer loop
      vertex   3.816425e+00 -5.551033e+00  6.146011e-01
      vertex   3.872465e+00 -5.588881e+00  1.385299e+00
      vertex   3.146301e+00 -5.975582e+00  1.409939e+00
    endloop
  endfacet
  facet normal  4.226332e-01 -2.905718e-03  9.062963e-01
    outer loop
      vertex   4.491253e+00  4.441223e-01  1.809762e+01
      vertex   3.638045e+00  4.441452e-01  1.849550e+01
      vertex   3.637555e+00  4.730225e-04  1.849431e+01
    endloop
  endfacet
  facet normal  5.899656e-01 -2.947365e-03  8.074230e-01
    outer loop
      vertex   6.047083e+00  4.440784e-01  1.707369e+01
      vertex   5.300865e+00  4.310608e-04  1.761731e+01
      vertex   6.046260e+00  4.100800e-04  1.707267e+01
    endloop
  endfacet
  facet normal  6.637871e-01 -7.333817e-01 -1.467580e-01
    outer loop
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
      vertex   4.414157e+00 -5.005417e+00  4.857226e-16
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
    endloop
  endfacet
  facet normal -9.804211e-01 -1.113200e-05 -1.969123e-01
    outer loop
      vertex  -9.257167e+00 -4.944229e-01  6.135324e+00
      vertex  -9.401835e+00 -4.804020e-01  6.855625e+00
      vertex  -9.401813e+00  6.008148e-04  6.855484e+00
    endloop
  endfacet
  facet normal -1.016476e-01 -9.046216e-01  4.139173e-01
    outer loop
      vertex  -1.684684e+00 -1.949110e+00  1.825327e+01
      vertex  -2.409062e+00 -2.137579e+00  1.766348e+01
      vertex  -1.608277e+00 -2.137565e+00  1.786017e+01
    endloop
  endfacet
  facet normal -8.922902e-01  1.047279e-01  4.391471e-01
    outer loop
      vertex  -8.380980e+00  8.853855e-01  1.422623e+01
      vertex  -8.794720e+00  8.854065e-01  1.338556e+01
      vertex  -8.837394e+00  4.444962e-01  1.340400e+01
    endloop
  endfacet
  facet normal -6.635791e-01 -7.323194e-01 -1.528758e-01
    outer loop
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
      vertex  -4.435853e+00 -4.987197e+00  9.714451e-17
      vertex  -4.409382e+00 -5.011184e+00  3.295975e-16
    endloop
  endfacet
  facet normal  5.603282e-01  3.129733e-01  7.668638e-01
    outer loop
      vertex   5.955045e+00  1.188147e+00  1.695970e+01
      vertex   5.275980e+00  8.850021e-01  1.757960e+01
      vertex   6.017879e+00  8.849792e-01  1.703752e+01
    endloop
  endfacet
  facet normal  5.603226e-01  3.129846e-01  7.668632e-01
    outer loop
      vertex   5.955045e+00  1.188147e+00  1.695970e+01
      vertex   5.220885e+00  1.188196e+00  1.749611e+01
      vertex   5.275980e+00  8.850021e-01  1.757960e+01
    endloop
  endfacet
  facet normal  6.238861e-02  9.975703e-01 -3.100505e-02
    outer loop
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
    endloop
  endfacet
  facet normal -6.548744e-01  7.556464e-01  1.175392e-02
    outer loop
      vertex  -6.734791e+00  3.494051e+00  2.724230e+00
      vertex  -6.260829e+00  3.893172e+00  3.472187e+00
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
    endloop
  endfacet
  facet normal  8.034156e-01 -4.711661e-01 -3.640410e-01
    outer loop
      vertex   7.273337e+00 -2.427338e+00  1.969424e+00
      vertex   7.189068e+00 -2.859085e+00  2.342245e+00
      vertex   7.040828e+00 -2.826899e+00  1.973431e+00
    endloop
  endfacet
  facet normal  4.239197e-02 -9.989738e-01  1.594104e-02
    outer loop
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   7.727502e+00  2.181219e+00  1.248517e+01
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
    endloop
  endfacet
  facet normal -6.660048e-01 -6.211733e-01  4.130149e-01
    outer loop
      vertex  -7.674814e+00 -1.470701e+00  1.487608e+01
      vertex  -8.155293e+00 -1.470728e+00  1.410125e+01
      vertex  -8.021980e+00 -1.662747e+00  1.402742e+01
    endloop
  endfacet
  facet normal -9.839628e-01 -7.272261e-08  1.783738e-01
    outer loop
      vertex   8.088119e+00  2.358255e+00  7.924740e+00
      vertex   8.088120e+00 -2.358206e+00  7.924744e+00
      vertex   8.154330e+00  2.311567e+00  8.289984e+00
    endloop
  endfacet
  facet normal -8.823185e-01 -1.409881e-02 -4.704417e-01
    outer loop
      vertex  -7.565663e+00  1.035690e-03  1.591647e+00
      vertex  -7.558371e+00 -4.955788e-01  1.592854e+00
      vertex  -7.759465e+00  2.861023e-04  1.955147e+00
    endloop
  endfacet
  facet normal  9.446250e-01 -4.157193e-03 -3.281254e-01
    outer loop
      vertex  -7.727578e+00 -2.180943e+00  1.248473e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
    endloop
  endfacet
  facet normal  3.527933e-01 -9.356810e-01 -6.144120e-03
    outer loop
      vertex  -2.166200e+00  5.124269e+00  1.614154e+00
      vertex  -2.057643e+00  5.175800e+00  2.081668e-17
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
    endloop
  endfacet
  facet normal -4.773602e-02 -1.044784e-01  9.933809e-01
    outer loop
      vertex  -1.979089e-04 -4.431534e-01  1.920920e+01
      vertex  -9.179602e-01 -8.840847e-01  1.911872e+01
      vertex  -1.984666e-04 -8.841076e-01  1.916282e+01
    endloop
  endfacet
  facet normal -6.096587e-01 -7.898511e-01  6.671950e-02
    outer loop
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
      vertex  -5.430634e+00 -4.562702e+00  2.798081e+00
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
    endloop
  endfacet
  facet normal  9.990936e-01 -4.215603e-03 -4.235818e-02
    outer loop
      vertex  -8.200814e+00  2.181055e+00  1.054299e+01
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
      vertex  -8.235943e+00 -2.180941e+00  1.014854e+01
    endloop
  endfacet
  facet normal  9.765304e-01 -9.274543e-02 -1.943882e-01
    outer loop
      vertex   9.256927e+00 -4.945354e-01  6.135322e+00
      vertex   9.401635e+00 -4.805756e-01  6.855621e+00
      vertex   9.356856e+00 -9.520664e-01  6.855625e+00
    endloop
  endfacet
  facet normal  5.155451e-01  4.862051e-01  7.055621e-01
    outer loop
      vertex   5.857304e+00  1.467438e+00  1.683866e+01
      vertex   5.220885e+00  1.188196e+00  1.749611e+01
      vertex   5.955045e+00  1.188147e+00  1.695970e+01
    endloop
  endfacet
  facet normal -5.088335e-01 -8.460853e-01  1.588336e-01
    outer loop
      vertex  -6.417768e+00 -3.634079e+00  4.386804e+00
      vertex  -6.582784e+00 -3.495262e+00  4.597621e+00
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
    endloop
  endfacet
  facet normal  8.847707e-01  3.347034e-01 -3.242754e-01
    outer loop
      vertex   8.047511e+00  2.034334e+00  3.356977e+00
      vertex   8.479278e+00  1.546875e+00  4.031898e+00
      vertex   8.223418e+00  1.556984e+00  3.344231e+00
    endloop
  endfacet
  facet normal -7.072533e-01 -3.068045e-07  7.069603e-01
    outer loop
      vertex   5.752496e+00  4.176069e+00  3.658274e+00
      vertex   5.752617e+00 -4.180309e+00  3.658392e+00
      vertex   5.926354e+00  4.040663e+00  3.832204e+00
    endloop
  endfacet
  facet normal  7.823043e-02  9.718427e-01  2.222653e-01
    outer loop
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
      vertex   2.408713e+00  2.137957e+00  1.766331e+01
    endloop
  endfacet
  facet normal -6.888605e-01  6.942217e-01 -2.086320e-01
    outer loop
      vertex  -5.075042e+00  4.531092e+00  5.953255e-01
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
    endloop
  endfacet
  facet normal  1.416033e-01 -9.044741e-01  4.023372e-01
    outer loop
      vertex   3.338141e+00 -1.948816e+00  1.776098e+01
      vertex   2.408868e+00 -2.137492e+00  1.766389e+01
      vertex   3.186728e+00 -2.137477e+00  1.739015e+01
    endloop
  endfacet
  facet normal  5.155197e-01  4.862440e-01  7.055538e-01
    outer loop
      vertex   5.857304e+00  1.467438e+00  1.683866e+01
      vertex   5.135185e+00  1.467489e+00  1.736625e+01
      vertex   5.220885e+00  1.188196e+00  1.749611e+01
    endloop
  endfacet
  facet normal -6.400335e-01 -4.876926e-01  5.937279e-01
    outer loop
      vertex  -6.634205e+00 -1.189585e+00  1.635457e+01
      vertex  -7.252540e+00 -1.189594e+00  1.568800e+01
      vertex  -7.132257e+00 -1.470675e+00  1.558679e+01
    endloop
  endfacet
  facet normal  2.602659e-01 -6.209111e-01  7.394127e-01
    outer loop
      vertex   3.523055e+00 -1.470343e+00  1.821387e+01
      vertex   2.619772e+00 -1.661618e+00  1.837120e+01
      vertex   3.465739e+00 -1.661538e+00  1.807350e+01
    endloop
  endfacet
  facet normal  8.773772e-01  7.384345e-02 -4.740848e-01
    outer loop
      vertex   7.331723e+00  9.546490e-01  1.245735e+00
      vertex   7.557823e+00  4.967327e-01  1.592848e+00
      vertex   7.370080e+00  4.802914e-01  1.242837e+00
    endloop
  endfacet
  facet normal  7.830450e-01 -1.067228e-06 -6.219651e-01
    outer loop
      vertex  -6.561799e+00  2.181341e+00  1.458946e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
      vertex  -6.561809e+00 -2.180946e+00  1.458945e+01
    endloop
  endfacet
  facet normal  5.846100e-01 -8.047974e-01 -1.026278e-01
    outer loop
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
      vertex   3.816425e+00 -5.551033e+00  6.146011e-01
      vertex   3.789027e+00 -5.492561e+00  3.174544e-16
    endloop
  endfacet
  facet normal  4.628180e-01  6.201128e-01  6.334505e-01
    outer loop
      vertex   5.760602e+00  1.661981e+00  1.671890e+01
      vertex   5.050371e+00  1.662075e+00  1.723773e+01
      vertex   5.135185e+00  1.467489e+00  1.736625e+01
    endloop
  endfacet
  facet normal  5.746722e-01 -6.208791e-01  5.331613e-01
    outer loop
      vertex   7.132366e+00 -1.470213e+00  1.558741e+01
      vertex   6.524189e+00 -1.470240e+00  1.624290e+01
      vertex   6.418201e+00 -1.661215e+00  1.613475e+01
    endloop
  endfacet
  facet normal  8.070926e-01 -3.131016e-01  5.005685e-01
    outer loop
      vertex   8.381008e+00 -8.843479e-01  1.422670e+01
      vertex   7.804265e+00 -1.189407e+00  1.496580e+01
      vertex   8.292924e+00 -1.189396e+00  1.417792e+01
    endloop
  endfacet
  facet normal  2.041432e-02  9.048019e-01  4.253432e-01
    outer loop
      vertex   8.075836e-01  2.137995e+00  1.797567e+01
      vertex  -1.551486e-04  2.138014e+00  1.801440e+01
      vertex  -1.667350e-04  1.949934e+00  1.841449e+01
    endloop
  endfacet
  facet normal  4.226387e-01 -2.918933e-03  9.062935e-01
    outer loop
      vertex   4.491253e+00  4.441223e-01  1.809762e+01
      vertex   3.637555e+00  4.730225e-04  1.849431e+01
      vertex   4.490647e+00  4.520416e-04  1.809648e+01
    endloop
  endfacet
  facet normal  2.513492e-01  9.047021e-01  3.440023e-01
    outer loop
      vertex   5.296712e+00  2.137880e+00  1.614445e+01
      vertex   4.864143e+00  1.949648e+00  1.695555e+01
      vertex   5.548191e+00  1.949602e+00  1.645586e+01
    endloop
  endfacet
  facet normal  5.900965e-01  8.072098e-01  1.408695e-02
    outer loop
      vertex   6.929443e+00  3.401724e+00  3.434681e+00
      vertex   6.259799e+00  3.890604e+00  3.472019e+00
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
    endloop
  endfacet
  facet normal -9.986029e-01  4.677562e-02 -2.457884e-02
    outer loop
      vertex   5.432676e+00 -5.450840e-01  3.363666e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
      vertex   5.520783e+00 -4.315945e-01  1.734723e-18
    endloop
  endfacet
  facet normal  1.597887e-01 -9.706591e-01  1.796894e-01
    outer loop
      vertex   5.901518e+00 -2.137416e+00  1.560751e+01
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
    endloop
  endfacet
  facet normal -5.090870e-01 -2.799513e-03  8.607106e-01
    outer loop
      vertex  -4.491520e+00  4.443474e-01  1.809738e+01
      vertex  -5.301825e+00  4.443703e-01  1.761811e+01
      vertex  -5.301142e+00  6.875992e-04  1.761707e+01
    endloop
  endfacet
  facet normal  2.898883e-01 -4.875696e-01  8.235537e-01
    outer loop
      vertex   3.582416e+00 -1.189468e+00  1.835927e+01
      vertex   2.663114e+00 -1.470369e+00  1.851656e+01
      vertex   3.523055e+00 -1.470343e+00  1.821387e+01
    endloop
  endfacet
  facet normal  1.873179e-01  9.718309e-01  1.430275e-01
    outer loop
      vertex   6.942175e+00  2.137827e+00  1.437145e+01
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   6.451268e+00  2.137846e+00  1.501424e+01
    endloop
  endfacet
  facet normal  2.835247e-01 -9.044169e-01  3.188163e-01
    outer loop
      vertex   6.181915e+00 -1.948618e+00  1.589363e+01
      vertex   5.548748e+00 -1.948668e+00  1.645657e+01
      vertex   5.297066e+00 -2.137431e+00  1.614491e+01
    endloop
  endfacet
  facet normal  5.801835e-01 -4.875643e-01  6.524325e-01
    outer loop
      vertex   6.634067e+00 -1.189428e+00  1.635503e+01
      vertex   5.954641e+00 -1.189440e+00  1.695921e+01
      vertex   5.856004e+00 -1.470266e+00  1.683706e+01
    endloop
  endfacet
  facet normal  7.923958e-01 -4.282579e-01 -4.344009e-01
    outer loop
      vertex   6.962789e+00 -2.295359e+00  1.261698e+00
      vertex   7.114815e+00 -2.367758e+00  1.610386e+00
      vertex   6.904957e+00 -2.766088e+00  1.620279e+00
    endloop
  endfacet
  facet normal  1.272539e-01  9.918695e-01  1.142172e-03
    outer loop
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
      vertex  -4.403078e-01 -5.559525e+00 -5.898060e-17
      vertex  -9.071357e-01 -5.499633e+00 -4.550758e-16
    endloop
  endfacet
  facet normal -3.668318e-16 -5.483786e-17 -1.000000e+00
    outer loop
      vertex   1.574826e+00 -5.345766e+00  2.471981e-16
      vertex   2.057736e+00 -5.175515e+00  6.071532e-17
      vertex   2.362674e+00 -6.239994e+00  7.228014e-18
    endloop
  endfacet
  facet normal  4.448286e-01  4.862158e-01  7.521446e-01
    outer loop
      vertex   5.135185e+00  1.467489e+00  1.736625e+01
      vertex   4.422884e+00  1.188246e+00  1.796803e+01
      vertex   5.220885e+00  1.188196e+00  1.749611e+01
    endloop
  endfacet
  facet normal  6.310923e-01 -3.131847e-01  7.096744e-01
    outer loop
      vertex   6.704575e+00 -8.842850e-01  1.642699e+01
      vertex   6.017940e+00 -8.842640e-01  1.703760e+01
      vertex   5.954641e+00 -1.189440e+00  1.695921e+01
    endloop
  endfacet
  facet normal  2.987746e-01  9.534353e-01 -4.116940e-02
    outer loop
      vertex   2.385461e+00  6.284292e+00  1.431968e+00
      vertex   2.003154e+00  6.410124e+00  1.571624e+00
      vertex   2.392633e+00  6.292719e+00  1.679182e+00
    endloop
  endfacet
  facet normal -4.060456e-01  9.108501e-01 -7.402062e-02
    outer loop
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
      vertex  -2.350985e+00  6.245869e+00  1.035052e-16
      vertex  -3.077820e+00  5.921855e+00  1.040834e-16
    endloop
  endfacet
  facet normal  6.608900e-01 -1.044773e-01  7.431749e-01
    outer loop
      vertex   6.737034e+00 -4.433289e-01  1.646011e+01
      vertex   6.017940e+00 -8.842640e-01  1.703760e+01
      vertex   6.704575e+00 -8.842850e-01  1.642699e+01
    endloop
  endfacet
  facet normal -6.316409e-17 -4.768451e-17 -1.000000e+00
    outer loop
      vertex   4.642241e+00 -3.034725e+00 -5.828671e-17
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
      vertex   5.509706e+00 -3.781196e+00 -7.748432e-17
    endloop
  endfacet
  facet normal -7.303364e-01  6.511295e-01 -2.064922e-01
    outer loop
      vertex  -5.075042e+00  4.531092e+00  5.953255e-01
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
      vertex  -5.615840e+00  3.921659e+00  5.863419e-01
    endloop
  endfacet
  facet normal -5.000031e-16 -4.238006e-16 -1.000000e+00
    outer loop
      vertex  -4.642149e+00  3.035010e+00  2.037722e-16
      vertex  -5.501915e+00  3.793403e+00  3.122502e-16
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
    endloop
  endfacet
  facet normal -3.813727e-16 -6.514923e-16 -1.000000e+00
    outer loop
      vertex   2.553920e+00 -4.945607e+00 -2.782992e-16
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
      vertex   2.057736e+00 -5.175515e+00  6.071532e-17
    endloop
  endfacet
  facet normal -8.588909e-16 -3.513798e-16 -1.000000e+00
    outer loop
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
      vertex  -6.098308e+00  2.759493e+00  4.718448e-16
      vertex  -4.930842e+00  2.532238e+00 -4.510281e-16
    endloop
  endfacet
  facet normal  8.932813e-01 -1.830180e-01 -4.105520e-01
    outer loop
      vertex   7.891260e+00 -1.036148e+00  2.317596e+00
      vertex   8.044003e+00 -1.046951e+00  2.654753e+00
      vertex   7.944548e+00 -1.553850e+00  2.664325e+00
    endloop
  endfacet
  facet normal  8.373460e-01 -3.559240e-01 -4.149336e-01
    outer loop
      vertex   6.487965e+00 -2.535486e+00  5.716991e-01
      vertex   6.651994e+00 -2.146391e+00  5.689535e-01
      vertex   6.767753e+00 -2.690432e+00  1.269229e+00
    endloop
  endfacet
  facet normal  6.645219e-01 -2.947433e-03  7.472630e-01
    outer loop
      vertex   6.737047e+00  4.440575e-01  1.646012e+01
      vertex   6.047083e+00  4.440784e-01  1.707369e+01
      vertex   6.046260e+00  4.100800e-04  1.707267e+01
    endloop
  endfacet
  facet normal  5.090428e-01  2.946672e-03  8.607362e-01
    outer loop
      vertex   5.300865e+00  4.310608e-04  1.761731e+01
      vertex   4.490647e+00  4.520416e-04  1.809648e+01
      vertex   4.491258e+00 -4.432640e-01  1.809764e+01
    endloop
  endfacet
  facet normal  6.608700e-01  1.047351e-01  7.431563e-01
    outer loop
      vertex   6.704513e+00  8.849583e-01  1.642692e+01
      vertex   6.017879e+00  8.849792e-01  1.703752e+01
      vertex   6.047083e+00  4.440784e-01  1.707369e+01
    endloop
  endfacet
  facet normal -7.729646e-01 -6.212621e-01  1.286827e-01
    outer loop
      vertex  -9.114491e+00 -1.470814e+00  1.154900e+01
      vertex  -9.110768e+00 -1.661802e+00  1.064930e+01
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
    endloop
  endfacet
  facet normal  1.124187e-01  6.203244e-01  7.762472e-01
    outer loop
      vertex   1.748731e+00  1.662465e+00  1.858451e+01
      vertex   8.930779e-01  1.467754e+00  1.886402e+01
      vertex   1.778145e+00  1.467701e+00  1.873589e+01
    endloop
  endfacet
  facet normal  2.371172e-01  1.047354e-01  9.658189e-01
    outer loop
      vertex   2.736763e+00  8.850708e-01  1.876354e+01
      vertex   1.835783e+00  4.441910e-01  1.903255e+01
      vertex   2.750044e+00  4.441681e-01  1.880809e+01
    endloop
  endfacet
  facet normal -1.336810e-01  9.910155e-01  4.212799e-03
    outer loop
      vertex  -8.056749e-01  6.646356e+00  1.364390e+00
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
      vertex  -1.128328e+00  6.602671e+00  1.402445e+00
    endloop
  endfacet
  facet normal  6.901720e-01  6.945999e-01 -2.029620e-01
    outer loop
      vertex   5.073212e+00  4.526468e+00  5.952616e-01
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
      vertex   4.435295e+00  4.986383e+00  9.055257e-16
    endloop
  endfacet
  facet normal  6.311388e-01  3.129822e-01  7.097225e-01
    outer loop
      vertex   6.634518e+00  1.188099e+00  1.635548e+01
      vertex   5.955045e+00  1.188147e+00  1.695970e+01
      vertex   6.017879e+00  8.849792e-01  1.703752e+01
    endloop
  endfacet
  facet normal  5.213437e-01  6.200544e-01  5.862877e-01
    outer loop
      vertex   6.417946e+00  1.661885e+00  1.613447e+01
      vertex   5.760602e+00  1.661981e+00  1.671890e+01
      vertex   5.857304e+00  1.467438e+00  1.683866e+01
    endloop
  endfacet
  facet normal -2.916360e-02  1.693612e-03  9.995732e-01
    outer loop
      vertex   4.036640e-01  6.677962e+00  1.334846e+00
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
    endloop
  endfacet
  facet normal  4.309207e-01  7.612548e-01  4.845601e-01
    outer loop
      vertex   6.181304e+00  1.949553e+00  1.589299e+01
      vertex   5.760602e+00  1.661981e+00  1.671890e+01
      vertex   6.417946e+00  1.661885e+00  1.613447e+01
    endloop
  endfacet
  facet normal  8.770847e-01  1.735875e-01 -4.478726e-01
    outer loop
      vertex   7.615463e+00  1.510658e+00  1.962947e+00
      vertex   7.890829e+00  1.034529e+00  2.317666e+00
      vertex   7.711735e+00  1.016129e+00  1.959809e+00
    endloop
  endfacet
  facet normal  2.831444e-01  9.046828e-01  3.183998e-01
    outer loop
      vertex   5.901123e+00  2.137865e+00  1.560709e+01
      vertex   5.548191e+00  1.949602e+00  1.645586e+01
      vertex   6.181304e+00  1.949553e+00  1.589299e+01
    endloop
  endfacet
  facet normal  1.565927e-01  9.718363e-01  1.761046e-01
    outer loop
      vertex   5.901123e+00  2.137865e+00  1.560709e+01
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   5.296712e+00  2.137880e+00  1.614445e+01
    endloop
  endfacet
  facet normal  6.662171e-01 -6.208245e-01  4.131969e-01
    outer loop
      vertex   8.155621e+00 -1.470160e+00  1.410187e+01
      vertex   7.675037e+00 -1.470186e+00  1.487670e+01
      vertex   7.550447e+00 -1.661053e+00  1.479081e+01
    endloop
  endfacet
  facet normal  7.826461e-01  5.607691e-01 -2.701908e-01
    outer loop
      vertex   5.614513e+00  3.917742e+00  5.862894e-01
      vertex   6.086132e+00  3.255663e+00  5.782843e-01
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
    endloop
  endfacet
  facet normal -9.810303e-01  1.047362e-01  1.631255e-01
    outer loop
      vertex  -9.366744e+00  8.854465e-01  1.160335e+01
      vertex  -9.563660e+00  4.445534e-01  1.070219e+01
      vertex  -9.412189e+00  4.445343e-01  1.161314e+01
    endloop
  endfacet
  facet normal  3.128406e-01 -9.043595e-01  2.902836e-01
    outer loop
      vertex   6.758233e+00 -1.948568e+00  1.527256e+01
      vertex   5.901518e+00 -2.137416e+00  1.560751e+01
      vertex   6.451702e+00 -2.137401e+00  1.501462e+01
    endloop
  endfacet
  facet normal -6.193735e-16  3.921986e-16 -1.000000e+00
    outer loop
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
      vertex  -4.303997e+00 -3.502633e+00  1.540434e-16
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
    endloop
  endfacet
  facet normal  3.128172e-01 -9.043929e-01  2.902050e-01
    outer loop
      vertex   6.758233e+00 -1.948568e+00  1.527256e+01
      vertex   6.181915e+00 -1.948618e+00  1.589363e+01
      vertex   5.901518e+00 -2.137416e+00  1.560751e+01
    endloop
  endfacet
  facet normal  4.226469e-01  2.946549e-03  9.062896e-01
    outer loop
      vertex   4.490647e+00  4.520416e-04  1.809648e+01
      vertex   3.638051e+00 -4.432430e-01  1.849553e+01
      vertex   4.491258e+00 -4.432640e-01  1.809764e+01
    endloop
  endfacet
  facet normal  6.080606e-01 -7.802979e-01 -1.462789e-01
    outer loop
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
      vertex   3.789027e+00 -5.492561e+00  3.174544e-16
      vertex   4.414157e+00 -5.005417e+00  4.857226e-16
    endloop
  endfacet
  facet normal  1.374390e-16  1.136978e-15 -1.000000e+00
    outer loop
      vertex  -6.653766e+00 -7.855896e-01 -3.986009e-16
      vertex  -6.687660e+00 -3.790381e-01  5.898060e-17
      vertex  -5.507651e+00 -5.796566e-01 -6.938894e-18
    endloop
  endfacet
  facet normal  9.919527e-01 -1.247225e-01 -2.177508e-02
    outer loop
      vertex  -5.432583e+00  5.453663e-01  3.363667e+00
      vertex  -5.520691e+00  4.318787e-01 -2.428613e-17
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
    endloop
  endfacet
  facet normal -8.853880e-01 -3.333391e-01 -3.239956e-01
    outer loop
      vertex  -8.049710e+00 -2.038773e+00  3.356880e+00
      vertex  -8.480636e+00 -1.550205e+00  4.031820e+00
      vertex  -8.224982e+00 -1.560852e+00  3.344146e+00
    endloop
  endfacet
  facet normal -6.004284e-16 -3.941636e-16 -1.000000e+00
    outer loop
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
      vertex  -6.510569e+00  1.586219e+00  4.579670e-16
      vertex  -5.335880e+00  1.486812e+00 -2.081668e-16
    endloop
  endfacet
  facet normal  6.400566e-01 -4.875368e-01  5.938311e-01
    outer loop
      vertex   7.252472e+00 -1.189419e+00  1.568848e+01
      vertex   6.524189e+00 -1.470240e+00  1.624290e+01
      vertex   7.132366e+00 -1.470213e+00  1.558741e+01
    endloop
  endfacet
  facet normal -5.805616e-01  4.866053e-01  6.528121e-01
    outer loop
      vertex  -5.857307e+00  1.468172e+00  1.683807e+01
      vertex  -6.634596e+00  1.188892e+00  1.635498e+01
      vertex  -5.955170e+00  1.188843e+00  1.695925e+01
    endloop
  endfacet
  facet normal -9.360869e-01  3.141830e-03  3.517548e-01
    outer loop
      vertex  -9.168757e+00 -4.428749e-01  1.252270e+01
      vertex  -8.837564e+00 -4.428959e-01  1.340407e+01
      vertex  -8.836282e+00  8.068085e-04  1.340352e+01
    endloop
  endfacet
  facet normal  5.692009e-01  8.127412e-01  1.243464e-01
    outer loop
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
      vertex   4.773077e+00  4.986311e+00  2.844149e+00
      vertex   4.966979e+00  4.828844e+00  2.985777e+00
    endloop
  endfacet
  facet normal  3.300517e-01  7.613355e-01  5.580629e-01
    outer loop
      vertex   4.864143e+00  1.949648e+00  1.695555e+01
      vertex   4.278395e+00  1.662172e+00  1.769416e+01
      vertex   5.050371e+00  1.662075e+00  1.723773e+01
    endloop
  endfacet
  facet normal  8.621266e-01  4.859778e-01  1.433987e-01
    outer loop
      vertex   9.263976e+00  1.467035e+00  1.066768e+01
      vertex   9.269166e+00  1.187811e+00  1.158277e+01
      vertex   9.418399e+00  1.187765e+00  1.068572e+01
    endloop
  endfacet
  facet normal  6.400536e-01 -4.875595e-01  5.938157e-01
    outer loop
      vertex   7.252472e+00 -1.189419e+00  1.568848e+01
      vertex   6.634067e+00 -1.189428e+00  1.635503e+01
      vertex   6.524189e+00 -1.470240e+00  1.624290e+01
    endloop
  endfacet
  facet normal  9.712560e-01 -2.068104e-03 -2.380284e-01
    outer loop
      vertex   9.082833e+00 -2.098083e-05  5.420652e+00
      vertex   9.257847e+00  3.471375e-04  6.134778e+00
      vertex   9.256927e+00 -4.945354e-01  6.135322e+00
    endloop
  endfacet
  facet normal  4.212858e-01 -9.042132e-01  7.011791e-02
    outer loop
      vertex   8.776464e+00 -1.948257e+00  1.061073e+01
      vertex   8.245609e+00 -2.137315e+00  1.136222e+01
      vertex   8.378459e+00 -2.137298e+00  1.056425e+01
    endloop
  endfacet
  facet normal  2.276609e-01  9.718275e-01  6.100663e-02
    outer loop
      vertex   8.245063e+00  2.137758e+00  1.136211e+01
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
      vertex   8.031503e+00  2.137777e+00  1.215875e+01
    endloop
  endfacet
  facet normal -7.398486e-01  6.226369e-01 -2.548481e-01
    outer loop
      vertex  -6.304759e+00  3.389902e+00  1.287535e+00
      vertex  -5.860100e+00  4.076109e+00  1.673166e+00
      vertex  -5.779037e+00  4.023558e+00  1.309442e+00
    endloop
  endfacet
  facet normal  7.290882e-01 -1.044812e-01  6.763978e-01
    outer loop
      vertex   7.365021e+00 -4.433498e-01  1.578320e+01
      vertex   6.737034e+00 -4.433289e-01  1.646011e+01
      vertex   6.704575e+00 -8.842850e-01  1.642699e+01
    endloop
  endfacet
  facet normal -7.863618e-01  5.951067e-01 -1.657809e-01
    outer loop
      vertex  -8.503814e+00  1.979933e+00  4.736134e+00
      vertex  -8.690358e+00  1.927992e+00  5.434532e+00
      vertex  -8.404983e+00  2.307024e+00  5.441505e+00
    endloop
  endfacet
  facet normal  7.290645e-01  1.047341e-01  6.763843e-01
    outer loop
      vertex   7.329475e+00  8.849373e-01  1.575328e+01
      vertex   6.737047e+00  4.440575e-01  1.646012e+01
      vertex   7.365042e+00  4.440365e-01  1.578322e+01
    endloop
  endfacet
  facet normal -9.077890e-01  4.189228e-01 -2.056397e-02
    outer loop
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   4.930933e+00 -2.531955e+00  0.000000e+00
      vertex   4.924182e+00 -2.546585e+00 -1.464878e-17
    endloop
  endfacet
  facet normal -3.641221e-16 -4.140757e-16 -1.000000e+00
    outer loop
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
      vertex  -3.793262e+00 -5.489933e+00  6.765422e-16
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
    endloop
  endfacet
  facet normal  8.314203e-01 -3.535229e-01 -4.286744e-01
    outer loop
      vertex   6.487965e+00 -2.535486e+00  5.716991e-01
      vertex   6.261974e+00 -2.373744e+00 -1.699398e-15
      vertex   6.651994e+00 -2.146391e+00  5.689535e-01
    endloop
  endfacet
  facet normal  2.081612e-01 -4.875739e-01  8.479036e-01
    outer loop
      vertex   2.707990e+00 -1.189478e+00  1.866706e+01
      vertex   1.777746e+00 -1.470394e+00  1.873390e+01
      vertex   2.663114e+00 -1.470369e+00  1.851656e+01
    endloop
  endfacet
  facet normal  7.904703e-01 -1.044759e-01  6.035242e-01
    outer loop
      vertex   7.925358e+00 -4.433708e-01  1.504929e+01
      vertex   7.329536e+00 -8.843060e-01  1.575334e+01
      vertex   7.887176e+00 -8.843269e-01  1.502296e+01
    endloop
  endfacet
  facet normal -4.329123e-01  8.759902e-01  2.126693e-01
    outer loop
      vertex  -6.581262e+00  3.492887e+00  4.595612e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
      vertex  -6.742538e+00  3.359671e+00  4.816041e+00
    endloop
  endfacet
  facet normal  9.976236e-01  2.847675e-03  6.884048e-02
    outer loop
      vertex   9.562493e+00  2.565384e-04  1.070256e+01
      vertex   9.627322e+00 -4.434872e-01  9.781425e+00
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
    endloop
  endfacet
  facet normal  5.685545e-01 -8.131652e-01  1.245319e-01
    outer loop
      vertex   4.968148e+00 -4.831974e+00  2.986660e+00
      vertex   4.773260e+00 -4.990042e+00  2.844279e+00
      vertex   5.373260e+00 -4.632458e+00  2.439901e+00
    endloop
  endfacet
  facet normal  1.796579e-15 -3.806464e-16 -1.000000e+00
    outer loop
      vertex  -1.585613e+00 -6.485322e+00 -5.642188e-16
      vertex  -9.900771e-01 -5.485547e+00  1.251479e-16
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
    endloop
  endfacet
  facet normal  6.406418e-01  4.861483e-01  5.943381e-01
    outer loop
      vertex   7.133953e+00  1.467337e+00  1.558873e+01
      vertex   6.634518e+00  1.188099e+00  1.635548e+01
      vertex   7.252967e+00  1.188049e+00  1.568889e+01
    endloop
  endfacet
  facet normal -7.309663e-01 -6.354135e-01 -2.488732e-01
    outer loop
      vertex  -6.915232e+00 -3.205269e+00  2.348061e+00
      vertex  -7.044407e+00 -3.201189e+00  2.717045e+00
      vertex  -7.331246e+00 -2.868858e+00  2.711025e+00
    endloop
  endfacet
  facet normal  5.807101e-01  4.861766e-01  6.529993e-01
    outer loop
      vertex   6.525639e+00  1.467388e+00  1.624437e+01
      vertex   5.955045e+00  1.188147e+00  1.695970e+01
      vertex   6.634518e+00  1.188099e+00  1.635548e+01
    endloop
  endfacet
  facet normal  6.793016e-01  4.982480e-07  7.338592e-01
    outer loop
      vertex  -5.752640e+00  4.179514e+00  3.658571e+00
      vertex  -5.752707e+00 -4.183825e+00  3.658639e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
    endloop
  endfacet
  facet normal  1.390126e-01  9.718420e-01  1.902597e-01
    outer loop
      vertex   5.296712e+00  2.137880e+00  1.614445e+01
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   4.643673e+00  2.137899e+00  1.662149e+01
    endloop
  endfacet
  facet normal  2.489298e-01  9.659914e-01  6.996147e-02
    outer loop
      vertex   8.236661e+00  2.237776e+00  9.019822e+00
      vertex   8.253390e+00  2.206945e+00  9.385987e+00
      vertex   8.447516e+00  2.183165e+00  9.023621e+00
    endloop
  endfacet
  facet normal  9.010040e-01 -1.997399e-01 -3.850919e-01
    outer loop
      vertex   8.044003e+00 -1.046951e+00  2.654753e+00
      vertex   8.333261e+00 -1.052835e+00  3.334583e+00
      vertex   8.224885e+00 -1.560116e+00  3.344132e+00
    endloop
  endfacet
  facet normal  1.598029e-01 -9.706522e-01  1.797145e-01
    outer loop
      vertex   5.901518e+00 -2.137416e+00  1.560751e+01
      vertex   5.297066e+00 -2.137431e+00  1.614491e+01
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
    endloop
  endfacet
  facet normal  6.406131e-01  4.861904e-01  5.943348e-01
    outer loop
      vertex   7.133953e+00  1.467337e+00  1.558873e+01
      vertex   6.525639e+00  1.467388e+00  1.624437e+01
      vertex   6.634518e+00  1.188099e+00  1.635548e+01
    endloop
  endfacet
  facet normal  5.752338e-01  6.199263e-01  5.336641e-01
    outer loop
      vertex   7.016270e+00  1.661791e+00  1.548970e+01
      vertex   6.525639e+00  1.467388e+00  1.624437e+01
      vertex   7.133953e+00  1.467337e+00  1.558873e+01
    endloop
  endfacet
  facet normal -7.315739e-01  6.774904e-01 -7.619957e-02
    outer loop
      vertex  -8.848840e+00  1.867825e+00  6.140260e+00
      vertex  -8.978601e+00  1.807972e+00  6.853913e+00
      vertex  -8.666344e+00  2.145002e+00  6.852547e+00
    endloop
  endfacet
  facet normal  6.399813e-01  7.609731e-01  1.065085e-01
    outer loop
      vertex   8.636546e+00  1.949278e+00  1.144645e+01
      vertex   8.967095e+00  1.661316e+00  1.151767e+01
      vertex   8.775695e+00  1.949236e+00  1.061064e+01
    endloop
  endfacet
  facet normal -5.566298e-01  8.274673e-01  7.389857e-02
    outer loop
      vertex  -7.419713e+00  3.056143e+00  4.093033e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
    endloop
  endfacet
  facet normal  4.754274e-01  7.612043e-01  4.410631e-01
    outer loop
      vertex   6.757576e+00  1.949507e+00  1.527199e+01
      vertex   6.417946e+00  1.661885e+00  1.613447e+01
      vertex   7.016270e+00  1.661791e+00  1.548970e+01
    endloop
  endfacet
  facet normal -3.460260e-01 -9.107218e-01  2.255039e-01
    outer loop
      vertex  -6.959290e+00 -3.187130e+00  5.138649e+00
      vertex  -7.163385e+00 -3.026060e+00  5.475973e+00
      vertex  -7.326120e+00 -2.965523e+00  5.470749e+00
    endloop
  endfacet
  facet normal -2.737797e-01  7.618882e-01  5.870017e-01
    outer loop
      vertex  -3.337810e+00  1.950125e+00  1.775935e+01
      vertex  -4.120495e+00  1.950171e+00  1.739424e+01
      vertex  -4.278252e+00  1.663140e+00  1.769321e+01
    endloop
  endfacet
  facet normal -7.287698e-01 -6.739468e-01  1.212035e-01
    outer loop
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
      vertex  -9.110768e+00 -1.661802e+00  1.064930e+01
      vertex  -9.108448e+00 -1.664360e+00  1.064903e+01
    endloop
  endfacet
  facet normal  9.360767e-01  2.865553e-03  3.517843e-01
    outer loop
      vertex   9.167368e+00  2.927780e-04  1.252269e+01
      vertex   8.837360e+00 -4.434109e-01  1.340443e+01
      vertex   9.168580e+00 -4.434319e-01  1.252308e+01
    endloop
  endfacet
  facet normal  3.391950e-01 -9.043676e-01  2.589709e-01
    outer loop
      vertex   7.272491e+00 -1.948517e+00  1.459918e+01
      vertex   6.758233e+00 -1.948568e+00  1.527256e+01
      vertex   6.451702e+00 -2.137401e+00  1.501462e+01
    endloop
  endfacet
  facet normal -6.359920e-01 -2.394396e-04  7.716956e-01
    outer loop
      vertex   5.157131e+00  4.670424e+00  3.133343e+00
      vertex   5.207137e+00  1.683670e+00  3.173629e+00
      vertex   5.343349e+00  4.512934e+00  3.286766e+00
    endloop
  endfacet
  facet normal -7.444234e-01  6.676003e-01 -1.198135e-02
    outer loop
      vertex   3.904772e+00 -3.909714e+00  2.306490e+00
      vertex   4.284388e+00 -3.527809e+00 -4.764707e-16
      vertex   3.914279e+00 -3.940507e+00  1.637579e-16
    endloop
  endfacet
  facet normal  6.091517e-01 -4.773952e-07 -7.930537e-01
    outer loop
      vertex  -4.870253e+00  2.181326e+00  1.624569e+01
      vertex  -4.870266e+00 -2.180956e+00  1.624568e+01
      vertex  -5.184224e+00 -2.180954e+00  1.600453e+01
    endloop
  endfacet
  facet normal  6.230658e-01 -6.208627e-01  4.757295e-01
    outer loop
      vertex   7.675037e+00 -1.470186e+00  1.487670e+01
      vertex   7.132366e+00 -1.470213e+00  1.558741e+01
      vertex   7.016542e+00 -1.661133e+00  1.548994e+01
    endloop
  endfacet
  facet normal  4.742585e-01 -8.800965e-01  2.256543e-02
    outer loop
      vertex   8.756794e+00 -2.076908e+00  7.572255e+00
      vertex   8.816117e+00 -2.026272e+00  8.300370e+00
      vertex   8.428489e+00 -2.235312e+00  8.294211e+00
    endloop
  endfacet
  facet normal -4.340886e-01 -9.004995e-01 -2.583626e-02
    outer loop
      vertex  -3.173697e+00 -5.997675e+00  1.959259e+00
      vertex  -3.412686e+00 -5.885452e+00  2.063216e+00
      vertex  -3.166358e+00 -5.996792e+00  1.805169e+00
    endloop
  endfacet
  facet normal  3.359062e-15 -5.419154e-16 -1.000000e+00
    outer loop
      vertex  -6.933798e-02  5.577089e+00 -5.681219e-17
      vertex  -1.329709e-01  5.573674e+00 -2.687087e-16
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
    endloop
  endfacet
  facet normal -8.129994e-01 -5.516137e-01 -1.864247e-01
    outer loop
      vertex  -8.039986e+00 -2.437206e+00  4.057395e+00
      vertex  -8.236091e+00 -2.381275e+00  4.747116e+00
      vertex  -8.504741e+00 -1.981583e+00  4.736046e+00
    endloop
  endfacet
  facet normal  4.891957e-16  8.486601e-16 -1.000000e+00
    outer loop
      vertex   4.288389e+00  3.524311e+00 -2.220446e-16
      vertex   3.919394e+00  3.934411e+00 -5.451988e-17
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
    endloop
  endfacet
  facet normal -2.478823e-01 -9.685822e-01  2.007625e-02
    outer loop
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
      vertex  -8.284958e+00 -2.174232e+00  9.866986e+00
      vertex  -8.235943e+00 -2.180941e+00  1.014854e+01
    endloop
  endfacet
  facet normal  6.939504e-01 -4.875260e-01  5.298597e-01
    outer loop
      vertex   7.804265e+00 -1.189407e+00  1.496580e+01
      vertex   7.132366e+00 -1.470213e+00  1.558741e+01
      vertex   7.675037e+00 -1.470186e+00  1.487670e+01
    endloop
  endfacet
  facet normal  8.517102e-01  2.448311e-01 -4.633006e-01
    outer loop
      vertex   7.122206e+00  1.870544e+00  1.255249e+00
      vertex   7.248661e+00  1.420551e+00  1.249919e+00
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
    endloop
  endfacet
  facet normal  6.939451e-01 -4.875529e-01  5.298418e-01
    outer loop
      vertex   7.804265e+00 -1.189407e+00  1.496580e+01
      vertex   7.252472e+00 -1.189419e+00  1.568848e+01
      vertex   7.132366e+00 -1.470213e+00  1.558741e+01
    endloop
  endfacet
  facet normal  4.117488e-01  9.045941e-01  1.103286e-01
    outer loop
      vertex   8.245063e+00  2.137758e+00  1.136211e+01
      vertex   8.412847e+00  1.949324e+00  1.228092e+01
      vertex   8.636546e+00  1.949278e+00  1.144645e+01
    endloop
  endfacet
  facet normal  4.769506e-02 -1.044787e-01  9.933828e-01
    outer loop
      vertex   9.220275e-01 -4.431763e-01  1.916492e+01
      vertex  -1.979089e-04 -4.431534e-01  1.920920e+01
      vertex  -1.984666e-04 -8.841076e-01  1.916282e+01
    endloop
  endfacet
  facet normal  6.945583e-01  4.861635e-01  5.303147e-01
    outer loop
      vertex   7.676747e+00  1.467287e+00  1.487788e+01
      vertex   7.133953e+00  1.467337e+00  1.558873e+01
      vertex   7.252967e+00  1.188049e+00  1.568889e+01
    endloop
  endfacet
  facet normal  9.680139e-01  8.907188e-02 -2.345535e-01
    outer loop
      vertex   9.037666e+00  1.007128e+00  5.424614e+00
      vertex   9.212695e+00  9.799118e-01  6.136631e+00
      vertex   9.257026e+00  4.947186e-01  6.135334e+00
    endloop
  endfacet
  facet normal  7.948198e-01  2.894842e-03  6.068385e-01
    outer loop
      vertex   7.924301e+00  3.509521e-04  1.504856e+01
      vertex   7.365021e+00 -4.433498e-01  1.578320e+01
      vertex   7.925358e+00 -4.433708e-01  1.504929e+01
    endloop
  endfacet
  facet normal -1.016072e-01 -9.046453e-01  4.138752e-01
    outer loop
      vertex  -1.684684e+00 -1.949110e+00  1.825327e+01
      vertex  -2.523508e+00 -1.949160e+00  1.804723e+01
      vertex  -2.409062e+00 -2.137579e+00  1.766348e+01
    endloop
  endfacet
  facet normal  9.174221e-01 -7.392342e-02 -3.909886e-01
    outer loop
      vertex   8.083327e+00 -5.267620e-01  2.648672e+00
      vertex   8.333261e+00 -1.052835e+00  3.334583e+00
      vertex   8.044003e+00 -1.046951e+00  2.654753e+00
    endloop
  endfacet
  facet normal -1.356790e-15 -3.324352e-16 -1.000000e+00
    outer loop
      vertex   4.304089e+00  3.502916e+00  1.477984e-16
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
      vertex   4.621958e+00  3.067627e+00 -1.387779e-16
    endloop
  endfacet
  facet normal  7.948164e-01 -2.975974e-03  6.068427e-01
    outer loop
      vertex   7.925389e+00  4.440155e-01  1.504931e+01
      vertex   7.364036e+00  3.700256e-04  1.578237e+01
      vertex   7.924301e+00  3.509521e-04  1.504856e+01
    endloop
  endfacet
  facet normal  2.168663e-01  9.047080e-01  3.667048e-01
    outer loop
      vertex   4.643673e+00  2.137899e+00  1.662149e+01
      vertex   4.120631e+00  1.949694e+00  1.739514e+01
      vertex   4.864143e+00  1.949648e+00  1.695555e+01
    endloop
  endfacet
  facet normal  7.866554e-01 -5.949113e-01 -1.650875e-01
    outer loop
      vertex   8.505115e+00 -1.980730e+00  4.736032e+00
      vertex   8.691527e+00 -1.928049e+00  5.434463e+00
      vertex   8.406335e+00 -2.307093e+00  5.441423e+00
    endloop
  endfacet
  facet normal  1.727655e-01  9.718328e-01  1.602902e-01
    outer loop
      vertex   6.451268e+00  2.137846e+00  1.501424e+01
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   5.901123e+00  2.137865e+00  1.560709e+01
    endloop
  endfacet
  facet normal -1.727710e-01  9.718298e-01  1.603028e-01
    outer loop
      vertex  -5.777050e+00  2.180975e+00  1.547990e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
      vertex  -6.450688e+00  2.138182e+00  1.501330e+01
    endloop
  endfacet
  facet normal -1.847403e-01 -5.079393e-04  9.827873e-01
    outer loop
      vertex   1.446953e+00 -6.542450e+00  1.452726e+00
      vertex   1.605798e+00 -6.508545e+00  1.482603e+00
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
    endloop
  endfacet
  facet normal -6.609239e-01 -1.044798e-01  7.431444e-01
    outer loop
      vertex  -6.047397e+00 -4.429989e-01  1.707344e+01
      vertex  -6.704895e+00 -8.839283e-01  1.642670e+01
      vertex  -6.018261e+00 -8.839493e-01  1.703736e+01
    endloop
  endfacet
  facet normal -2.037078e-01 -9.707078e-01  1.273953e-01
    outer loop
      vertex  -6.941944e+00 -2.137688e+00  1.437088e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
    endloop
  endfacet
  facet normal  8.099577e-01 -5.862932e-01 -1.512437e-02
    outer loop
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
      vertex  -4.250774e+00  3.512644e+00  2.503092e+00
    endloop
  endfacet
  facet normal  7.904459e-01  1.047356e-01  6.035112e-01
    outer loop
      vertex   7.887117e+00  8.849163e-01  1.502292e+01
      vertex   7.365042e+00  4.440365e-01  1.578322e+01
      vertex   7.925389e+00  4.440155e-01  1.504931e+01
    endloop
  endfacet
  facet normal  1.727425e-01 -9.570128e-01  2.329944e-01
    outer loop
      vertex   5.195782e+00 -2.177322e+00  1.601951e+01
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
      vertex   4.869961e+00 -2.181000e+00  1.624597e+01
    endloop
  endfacet
  facet normal -6.310842e-01 -3.134010e-01  7.095863e-01
    outer loop
      vertex  -6.018261e+00 -8.839493e-01  1.703736e+01
      vertex  -6.634205e+00 -1.189585e+00  1.635457e+01
      vertex  -5.954819e+00 -1.189575e+00  1.695880e+01
    endloop
  endfacet
  facet normal  7.904450e-01  1.047380e-01  6.035120e-01
    outer loop
      vertex   7.887117e+00  8.849163e-01  1.502292e+01
      vertex   7.329475e+00  8.849373e-01  1.575328e+01
      vertex   7.365042e+00  4.440365e-01  1.578322e+01
    endloop
  endfacet
  facet normal  7.081121e-01  6.419646e-01 -2.940388e-01
    outer loop
      vertex   5.858973e+00  4.072660e+00  1.673073e+00
      vertex   6.515748e+00  3.498491e+00  2.001171e+00
      vertex   6.410461e+00  3.451159e+00  1.644279e+00
    endloop
  endfacet
  facet normal -6.497785e-01  6.816004e-07 -7.601236e-01
    outer loop
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   5.486000e+00  2.181242e+00  1.574896e+01
      vertex   5.485987e+00 -2.181002e+00  1.574896e+01
    endloop
  endfacet
  facet normal -1.433584e-01  3.024333e-03  9.896662e-01
    outer loop
      vertex  -9.222730e-01  5.807877e-04  1.916355e+01
      vertex  -1.836132e+00 -4.431095e-01  1.903253e+01
      vertex  -9.224034e-01 -4.431305e-01  1.916488e+01
    endloop
  endfacet
  facet normal  2.264556e-01  3.129783e-01  9.223679e-01
    outer loop
      vertex   2.708174e+00  1.188345e+00  1.866765e+01
      vertex   1.826918e+00  8.850937e-01  1.898691e+01
      vertex   2.736763e+00  8.850708e-01  1.876354e+01
    endloop
  endfacet
  facet normal -7.277023e-01  1.010499e-07  6.858931e-01
    outer loop
      vertex   6.088405e+00  3.909117e+00  4.004127e+00
      vertex   5.926448e+00 -4.044765e+00  3.832300e+00
      vertex   6.088456e+00 -3.913052e+00  4.004183e+00
    endloop
  endfacet
  facet normal  5.488370e-01  8.256431e-01 -1.307340e-01
    outer loop
      vertex   3.868523e+00  5.588697e+00  1.385323e+00
      vertex   4.596550e+00  5.160742e+00  1.738938e+00
      vertex   4.553915e+00  5.129000e+00  1.359486e+00
    endloop
  endfacet
  facet normal -8.008804e-01 -5.986078e-01 -1.609947e-02
    outer loop
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
      vertex   4.304089e+00  3.502916e+00  1.477984e-16
    endloop
  endfacet
  facet normal  1.097875e-15  4.725863e-16 -1.000000e+00
    outer loop
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
      vertex   3.914279e+00 -3.940507e+00  1.637579e-16
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
    endloop
  endfacet
  facet normal  7.548946e-01  3.129538e-01  5.763628e-01
    outer loop
      vertex   7.804801e+00  1.188002e+00  1.496616e+01
      vertex   7.329475e+00  8.849373e-01  1.575328e+01
      vertex   7.887117e+00  8.849163e-01  1.502292e+01
    endloop
  endfacet
  facet normal -6.079700e-01 -7.802944e-01  1.466743e-01
    outer loop
      vertex  -5.530277e+00 -4.362434e+00  3.450466e+00
      vertex  -6.098187e+00 -4.051413e+00  2.751067e+00
      vertex  -5.430634e+00 -4.562702e+00  2.798081e+00
    endloop
  endfacet
  facet normal -7.569447e-01 -6.212227e-01  2.027735e-01
    outer loop
      vertex  -8.878583e+00 -1.470785e+00  1.242973e+01
      vertex  -8.965373e+00 -1.662999e+00  1.151688e+01
      vertex  -8.733365e+00 -1.662915e+00  1.238321e+01
    endloop
  endfacet
  facet normal  6.945902e-01  4.861173e-01  5.303155e-01
    outer loop
      vertex   7.676747e+00  1.467287e+00  1.487788e+01
      vertex   7.252967e+00  1.188049e+00  1.568889e+01
      vertex   7.804801e+00  1.188002e+00  1.496616e+01
    endloop
  endfacet
  facet normal  5.448070e-01 -8.253986e-01  1.479946e-01
    outer loop
      vertex   6.237068e+00 -3.785059e+00  4.170946e+00
      vertex   6.088456e+00 -3.913052e+00  4.004183e+00
      vertex   6.262983e+00 -3.893271e+00  3.472025e+00
    endloop
  endfacet
  facet normal  6.236927e-01  6.198763e-01  4.761940e-01
    outer loop
      vertex   7.550162e+00  1.661696e+00  1.479060e+01
      vertex   7.133953e+00  1.467337e+00  1.558873e+01
      vertex   7.676747e+00  1.467287e+00  1.487788e+01
    endloop
  endfacet
  facet normal -7.439235e-01  6.469789e-01 -1.673204e-01
    outer loop
      vertex  -7.329176e+00  2.866369e+00  2.711174e+00
      vertex  -7.246525e+00  3.142607e+00  3.411828e+00
      vertex  -7.041600e+00  3.198557e+00  2.717051e+00
    endloop
  endfacet
  facet normal  5.154076e-01  7.612190e-01  3.935742e-01
    outer loop
      vertex   7.271794e+00  1.949461e+00  1.459869e+01
      vertex   6.757576e+00  1.949507e+00  1.527199e+01
      vertex   7.016270e+00  1.661791e+00  1.548970e+01
    endloop
  endfacet
  facet normal  8.972011e-01 -2.996395e-03  4.416121e-01
    outer loop
      vertex   8.837411e+00  4.439754e-01  1.340445e+01
      vertex   8.420458e+00  3.309250e-04  1.424855e+01
      vertex   8.836189e+00  3.118515e-04  1.340393e+01
    endloop
  endfacet
  facet normal  7.948123e-01 -2.962050e-03  6.068480e-01
    outer loop
      vertex   7.925389e+00  4.440155e-01  1.504931e+01
      vertex   7.365042e+00  4.440365e-01  1.578322e+01
      vertex   7.364036e+00  3.700256e-04  1.578237e+01
    endloop
  endfacet
  facet normal -4.196257e-01  9.050101e-01  6.979209e-02
    outer loop
      vertex  -8.243571e+00  2.138269e+00  1.136140e+01
      vertex  -8.376205e+00  2.138299e+00  1.056355e+01
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
    endloop
  endfacet
  facet normal  5.209122e-01 -6.208938e-01  5.857827e-01
    outer loop
      vertex   6.524189e+00 -1.470240e+00  1.624290e+01
      vertex   5.856004e+00 -1.470266e+00  1.683706e+01
      vertex   5.760838e+00 -1.661295e+00  1.671921e+01
    endloop
  endfacet
  facet normal  2.050865e-01 -9.704419e-01  1.272088e-01
    outer loop
      vertex   7.377430e+00 -2.137368e+00  1.367093e+01
      vertex   6.942640e+00 -2.137383e+00  1.437178e+01
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
    endloop
  endfacet
  facet normal -7.764129e-01  9.206468e-07 -6.302245e-01
    outer loop
      vertex   6.811804e+00 -2.176855e+00  1.428159e+01
      vertex   6.561598e+00 -2.181007e+00  1.458984e+01
      vertex   6.561607e+00  2.181231e+00  1.458983e+01
    endloop
  endfacet
  facet normal -4.203558e-01  1.047302e-01  9.012950e-01
    outer loop
      vertex  -3.620762e+00  8.852310e-01  1.845226e+01
      vertex  -4.469825e+00  8.852539e-01  1.805627e+01
      vertex  -4.491520e+00  4.443474e-01  1.809738e+01
    endloop
  endfacet
  facet normal  4.404601e-01 -1.761330e-03  8.977705e-01
    outer loop
      vertex  -3.644958e+00 -5.764738e+00  2.173019e+00
      vertex  -3.450266e+00 -4.332319e+00  2.080311e+00
      vertex  -3.842140e+00 -3.973835e+00  2.273273e+00
    endloop
  endfacet
  facet normal  3.993182e-01  6.201522e-01  6.752452e-01
    outer loop
      vertex   5.050371e+00  1.662075e+00  1.723773e+01
      vertex   4.278395e+00  1.662172e+00  1.769416e+01
      vertex   4.350276e+00  1.467543e+00  1.783040e+01
    endloop
  endfacet
  facet normal -5.144148e-01  7.621187e-01  3.931316e-01
    outer loop
      vertex  -6.756639e+00  1.950357e+00  1.527073e+01
      vertex  -7.547735e+00  1.665148e+00  1.478848e+01
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
    endloop
  endfacet
  facet normal -1.019186e-02 -9.990949e-01  4.129902e-02
    outer loop
      vertex  -1.968264e+00  2.181299e+00  1.759722e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
      vertex  -1.574408e+00  2.180941e+00  1.768574e+01
    endloop
  endfacet
  facet normal  8.530077e-01  2.169612e-01 -4.746637e-01
    outer loop
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
      vertex   6.890595e+00  1.320393e+00  5.645571e-01
      vertex   6.509523e+00  1.583495e+00  1.110223e-16
    endloop
  endfacet
  facet normal -9.983069e-01 -5.290200e-02 -2.417825e-02
    outer loop
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
    endloop
  endfacet
  facet normal -7.048393e-01 -7.090479e-01 -2.127435e-02
    outer loop
      vertex  -8.667470e+00 -2.144535e+00  6.852546e+00
      vertex  -8.756927e+00 -2.077204e+00  7.572257e+00
      vertex  -9.079116e+00 -1.757046e+00  7.576221e+00
    endloop
  endfacet
  facet normal  8.317784e-01 -3.527674e-01 -4.286022e-01
    outer loop
      vertex   6.487965e+00 -2.535486e+00  5.716991e-01
      vertex   6.104056e+00 -2.746094e+00  1.457168e-15
      vertex   6.261974e+00 -2.373744e+00 -1.699398e-15
    endloop
  endfacet
  facet normal -2.190225e-01 -9.757193e-01 -8.937847e-04
    outer loop
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
      vertex   9.514104e-01  5.493269e+00  1.380087e+00
      vertex   9.901700e-01  5.485833e+00 -1.118897e-16
    endloop
  endfacet
  facet normal  1.719530e-01 -9.814608e-01  8.465737e-02
    outer loop
      vertex   7.593364e+00 -2.177376e+00  1.286686e+01
      vertex   7.250019e+00 -2.174259e+00  1.360038e+01
      vertex   7.219731e+00 -2.181011e+00  1.358362e+01
    endloop
  endfacet
  facet normal  6.804394e-01  7.328044e-01  4.727816e-04
    outer loop
      vertex   8.815482e+00  2.026991e+00  8.300353e+00
      vertex   9.178001e+00  1.689901e+00  9.037074e+00
      vertex   9.146042e+00  1.720049e+00  8.305800e+00
    endloop
  endfacet
  facet normal -3.819387e-01 -9.048597e-01  1.880203e-01
    outer loop
      vertex  -7.726786e+00 -1.949560e+00  1.386397e+01
      vertex  -8.108208e+00 -1.949612e+00  1.308891e+01
      vertex  -7.740718e+00 -2.137720e+00  1.293013e+01
    endloop
  endfacet
  facet normal  1.762851e-01 -9.706531e-01  1.635732e-01
    outer loop
      vertex   6.451702e+00 -2.137401e+00  1.501462e+01
      vertex   5.788485e+00 -2.177371e+00  1.549219e+01
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
    endloop
  endfacet
  facet normal  8.451818e-01 -1.044759e-01  5.241685e-01
    outer loop
      vertex   8.421578e+00 -4.433918e-01  1.424917e+01
      vertex   7.925358e+00 -4.433708e-01  1.504929e+01
      vertex   7.887176e+00 -8.843269e-01  1.502296e+01
    endloop
  endfacet
  facet normal  8.498272e-01 -2.989254e-03  5.270529e-01
    outer loop
      vertex   8.421620e+00  4.439945e-01  1.424919e+01
      vertex   7.924301e+00  3.509521e-04  1.504856e+01
      vertex   8.420458e+00  3.309250e-04  1.424855e+01
    endloop
  endfacet
  facet normal  4.191264e-02  4.863815e-01  8.727407e-01
    outer loop
      vertex   8.930779e-01  1.467754e+00  1.886402e+01
      vertex  -1.872839e-04  1.188496e+00  1.906255e+01
      vertex   9.079884e-01  1.188446e+00  1.901897e+01
    endloop
  endfacet
  facet normal  4.892956e-01  3.721639e-04  8.721180e-01
    outer loop
      vertex  -4.143497e+00  5.457701e+00  2.439818e+00
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -3.940862e+00  5.589209e+00  2.326075e+00
    endloop
  endfacet
  facet normal -8.391737e-01 -4.578811e-01 -2.934831e-01
    outer loop
      vertex  -7.577415e+00 -2.478678e+00  2.692742e+00
      vertex  -7.819458e+00 -2.470802e+00  3.372544e+00
      vertex  -8.049710e+00 -2.038773e+00  3.356880e+00
    endloop
  endfacet
  facet normal  8.071468e-01  3.129386e-01  5.005831e-01
    outer loop
      vertex   8.293495e+00  1.187954e+00  1.417823e+01
      vertex   7.887117e+00  8.849163e-01  1.502292e+01
      vertex   8.380954e+00  8.848953e-01  1.422666e+01
    endloop
  endfacet
  facet normal  4.670754e-01 -8.804462e-01  8.157788e-02
    outer loop
      vertex   7.574584e+00 -2.943947e+00  4.775200e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
      vertex   7.213604e+00 -3.133890e+00  4.791992e+00
    endloop
  endfacet
  facet normal  8.521350e-01  3.129522e-01  4.194365e-01
    outer loop
      vertex   8.702976e+00  1.187906e+00  1.334635e+01
      vertex   8.293495e+00  1.187954e+00  1.417823e+01
      vertex   8.380954e+00  8.848953e-01  1.422666e+01
    endloop
  endfacet
  facet normal  6.598661e-01  1.962890e-04  7.513831e-01
    outer loop
      vertex  -5.530277e+00 -4.362434e+00  3.450466e+00
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
    endloop
  endfacet
  facet normal -2.511173e-01  9.048949e-01  3.436645e-01
    outer loop
      vertex  -4.643528e+00  2.138128e+00  1.662074e+01
      vertex  -5.296445e+00  2.138147e+00  1.614360e+01
      vertex  -5.547705e+00  1.950266e+00  1.645471e+01
    endloop
  endfacet
  facet normal  3.123294e-01  9.046901e-01  2.898037e-01
    outer loop
      vertex   6.451268e+00  2.137846e+00  1.501424e+01
      vertex   5.901123e+00  2.137865e+00  1.560709e+01
      vertex   6.181304e+00  1.949553e+00  1.589299e+01
    endloop
  endfacet
  facet normal -8.075078e-01 -5.896809e-01 -1.440784e-02
    outer loop
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.304089e+00  3.502916e+00  1.477984e-16
      vertex   4.621958e+00  3.067627e+00 -1.387779e-16
    endloop
  endfacet
  facet normal -7.433219e-01 -6.688175e-01 -1.247920e-02
    outer loop
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
      vertex   3.919394e+00  3.934411e+00 -5.451988e-17
      vertex   4.288389e+00  3.524311e+00 -2.220446e-16
    endloop
  endfacet
  facet normal -2.155434e-01 -9.707122e-01  1.061073e-01
    outer loop
      vertex  -7.376554e+00 -2.137703e+00  1.367004e+01
      vertex  -7.740718e+00 -2.137720e+00  1.293013e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
    endloop
  endfacet
  facet normal  7.486147e-01 -5.909743e-01 -3.005418e-01
    outer loop
      vertex   6.669502e+00 -3.123020e+00  1.631585e+00
      vertex   6.519882e+00 -3.500469e+00  2.001101e+00
      vertex   6.414841e+00 -3.452044e+00  1.644233e+00
    endloop
  endfacet
  facet normal  2.398281e-01 -9.708153e-01  4.207281e-04
    outer loop
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
      vertex  -1.519182e+00  5.361024e+00 -2.671474e-17
      vertex  -1.072226e+00  5.471439e+00  1.474515e-16
    endloop
  endfacet
  facet normal -8.586960e-01 -5.121341e-01 -1.896960e-02
    outer loop
      vertex   4.512546e+00  3.152292e+00  2.666971e+00
      vertex   4.621958e+00  3.067627e+00 -1.387779e-16
      vertex   4.634337e+00  3.046870e+00 -1.228184e-16
    endloop
  endfacet
  facet normal  7.426853e-01  4.860733e-01  4.605986e-01
    outer loop
      vertex   8.157441e+00  1.467236e+00  1.410288e+01
      vertex   7.804801e+00  1.188002e+00  1.496616e+01
      vertex   8.293495e+00  1.187954e+00  1.417823e+01
    endloop
  endfacet
  facet normal -6.228958e-01 -6.211725e-01  4.755475e-01
    outer loop
      vertex  -7.132257e+00 -1.470675e+00  1.558679e+01
      vertex  -7.674814e+00 -1.470701e+00  1.487608e+01
      vertex  -7.549392e+00 -1.662664e+00  1.478962e+01
    endloop
  endfacet
  facet normal -2.114509e-01  9.718295e-01  1.040948e-01
    outer loop
      vertex  -7.375982e+00  2.138216e+00  1.366973e+01
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
      vertex  -7.740116e+00  2.138235e+00  1.292988e+01
    endloop
  endfacet
  facet normal -2.575954e-01 -9.642115e-01  6.277564e-02
    outer loop
      vertex  -8.203500e+00 -2.272165e+00  8.653872e+00
      vertex  -8.448242e+00 -2.182707e+00  9.023640e+00
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
    endloop
  endfacet
  facet normal -1.011542e-14  2.268022e-14 -1.000000e+00
    outer loop
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
      vertex   6.385301e+00  2.017778e+00 -5.689893e-16
      vertex   6.398841e+00  1.977925e+00 -1.609823e-15
    endloop
  endfacet
  facet normal  6.668462e-01  6.198769e-01  4.136048e-01
    outer loop
      vertex   8.022988e+00  1.661601e+00  1.402842e+01
      vertex   7.550162e+00  1.661696e+00  1.479060e+01
      vertex   7.676747e+00  1.467287e+00  1.487788e+01
    endloop
  endfacet
  facet normal -9.986113e-01 -1.895206e-03 -5.264843e-02
    outer loop
      vertex  -9.590901e+00  7.381439e-04  8.313972e+00
      vertex  -9.629494e+00  6.732941e-04  9.045976e+00
      vertex  -9.630352e+00  4.547825e-01  9.045909e+00
    endloop
  endfacet
  facet normal -2.901268e-01  4.864992e-01  8.241026e-01
    outer loop
      vertex  -2.663953e+00  1.467962e+00  1.851822e+01
      vertex  -3.524038e+00  1.468016e+00  1.821539e+01
      vertex  -3.582908e+00  1.188694e+00  1.835956e+01
    endloop
  endfacet
  facet normal  5.512421e-01  7.610888e-01  3.418714e-01
    outer loop
      vertex   7.727200e+00  1.949415e+00  1.386461e+01
      vertex   7.550162e+00  1.661696e+00  1.479060e+01
      vertex   8.022988e+00  1.661601e+00  1.402842e+01
    endloop
  endfacet
  facet normal  5.899605e-01 -2.934094e-03  8.074268e-01
    outer loop
      vertex   6.047083e+00  4.440784e-01  1.707369e+01
      vertex   5.301584e+00  4.441013e-01  1.761840e+01
      vertex   5.300865e+00  4.310608e-04  1.761731e+01
    endloop
  endfacet
  facet normal  6.534488e-01  7.559768e-01 -3.877766e-02
    outer loop
      vertex   6.017262e+00  4.093054e+00  2.395866e+00
      vertex   6.093377e+00  4.045481e+00  2.751050e+00
      vertex   6.733425e+00  3.490854e+00  2.724072e+00
    endloop
  endfacet
  facet normal  3.621201e-01  9.046597e-01  2.246325e-01
    outer loop
      vertex   7.376937e+00  2.137812e+00  1.367065e+01
      vertex   6.942175e+00  2.137827e+00  1.437145e+01
      vertex   7.271794e+00  1.949461e+00  1.459869e+01
    endloop
  endfacet
  facet normal  8.451544e-01  1.047351e-01  5.241608e-01
    outer loop
      vertex   8.380954e+00  8.848953e-01  1.422666e+01
      vertex   7.887117e+00  8.849163e-01  1.502292e+01
      vertex   7.925389e+00  4.440155e-01  1.504931e+01
    endloop
  endfacet
  facet normal  4.310352e-01 -7.611057e-01  4.846925e-01
    outer loop
      vertex   6.418201e+00 -1.661215e+00  1.613475e+01
      vertex   5.760838e+00 -1.661295e+00  1.671921e+01
      vertex   5.548748e+00 -1.948668e+00  1.645657e+01
    endloop
  endfacet
  facet normal -7.824309e-02  9.718314e-01  2.223099e-01
    outer loop
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
      vertex  -3.186596e+00  2.138090e+00  1.738905e+01
    endloop
  endfacet
  facet normal -9.830086e-01  1.743469e-07 -1.835598e-01
    outer loop
      vertex   8.216428e+00 -2.177635e+00  1.054533e+01
      vertex   8.143600e+00 -2.181015e+00  1.093535e+01
      vertex   8.143600e+00  2.181211e+00  1.093534e+01
    endloop
  endfacet
  facet normal  2.205441e-01 -9.693156e-01  1.085698e-01
    outer loop
      vertex   7.741767e+00 -2.137351e+00  1.293098e+01
      vertex   7.377430e+00 -2.137368e+00  1.367093e+01
      vertex   7.250019e+00 -2.174259e+00  1.360038e+01
    endloop
  endfacet
  facet normal  5.820770e-01 -7.609872e-01  2.865047e-01
    outer loop
      vertex   8.419494e+00 -1.660886e+00  1.322384e+01
      vertex   8.023282e+00 -1.660970e+00  1.402858e+01
      vertex   7.727928e+00 -1.948465e+00  1.386502e+01
    endloop
  endfacet
  facet normal  8.857927e-01 -6.546181e-07 -4.640811e-01
    outer loop
      vertex  -7.406958e+00  2.181349e+00  1.322548e+01
      vertex  -7.406964e+00 -2.180943e+00  1.322548e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
    endloop
  endfacet
  facet normal  7.833648e-01 -4.874910e-01  3.856061e-01
    outer loop
      vertex   8.702374e+00 -1.189384e+00  1.334610e+01
      vertex   8.155621e+00 -1.470160e+00  1.410187e+01
      vertex   8.558311e+00 -1.470133e+00  1.328384e+01
    endloop
  endfacet
  facet normal -4.191719e-02 -4.876220e-01  8.720480e-01
    outer loop
      vertex  -1.970066e-04 -1.189507e+00  1.906195e+01
      vertex  -8.932351e-01 -1.470469e+00  1.886192e+01
      vertex  -1.939251e-04 -1.470444e+00  1.890486e+01
    endloop
  endfacet
  facet normal  7.833551e-01 -4.875212e-01  3.855879e-01
    outer loop
      vertex   8.702374e+00 -1.189384e+00  1.334610e+01
      vertex   8.292924e+00 -1.189396e+00  1.417792e+01
      vertex   8.155621e+00 -1.470160e+00  1.410187e+01
    endloop
  endfacet
  facet normal  5.062599e-01 -1.044748e-01  8.560292e-01
    outer loop
      vertex   5.301583e+00 -4.432869e-01  1.761840e+01
      vertex   4.491258e+00 -4.432640e-01  1.809764e+01
      vertex   4.469616e+00 -8.842201e-01  1.805662e+01
    endloop
  endfacet
  facet normal  9.575551e-01 -8.184023e-02 -2.763882e-01
    outer loop
      vertex   8.875030e+00 -5.201473e-01  4.715992e+00
      vertex   9.037848e+00 -1.008127e+00  5.424577e+00
      vertex   8.832570e+00 -1.031635e+00  4.720345e+00
    endloop
  endfacet
  facet normal  8.723170e-01  2.888696e-01 -3.944839e-01
    outer loop
      vertex   7.639423e+00  2.016447e+00  2.334038e+00
      vertex   7.942900e+00  1.551197e+00  2.664423e+00
      vertex   7.794792e+00  1.537182e+00  2.326651e+00
    endloop
  endfacet
  facet normal  5.304865e-01 -8.476416e-01 -9.369763e-03
    outer loop
      vertex  -2.650488e+00  4.882700e+00  1.761878e+00
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
    endloop
  endfacet
  facet normal -9.471666e-01  8.129143e-03 -3.206388e-01
    outer loop
      vertex  -8.641997e+00 -8.125305e-04  4.015808e+00
      vertex  -8.874574e+00  5.192089e-01  4.716022e+00
      vertex  -8.638139e+00  5.261440e-01  4.017769e+00
    endloop
  endfacet
  facet normal -3.982891e-01  9.049626e-01  1.496944e-01
    outer loop
      vertex  -7.740116e+00  2.138235e+00  1.292988e+01
      vertex  -8.410871e+00  1.950541e+00  1.227990e+01
      vertex  -8.107093e+00  1.950495e+00  1.308844e+01
    endloop
  endfacet
  facet normal -6.939151e-01 -4.876935e-01  5.297517e-01
    outer loop
      vertex  -7.252540e+00 -1.189594e+00  1.568800e+01
      vertex  -7.804250e+00 -1.189606e+00  1.496531e+01
      vertex  -7.674814e+00 -1.470701e+00  1.487608e+01
    endloop
  endfacet
  facet normal  8.972037e-01  2.872915e-03  4.416077e-01
    outer loop
      vertex   8.836189e+00  3.118515e-04  1.340393e+01
      vertex   8.421578e+00 -4.433918e-01  1.424917e+01
      vertex   8.837360e+00 -4.434109e-01  1.340443e+01
    endloop
  endfacet
  facet normal  1.491267e-15 -1.349322e-15 -1.000000e+00
    outer loop
      vertex  -3.097691e+00 -5.910476e+00  1.601150e-15
      vertex  -3.772143e+00 -5.505244e+00  4.857226e-17
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
    endloop
  endfacet
  facet normal  8.971997e-01 -2.989725e-03  4.416149e-01
    outer loop
      vertex   8.837411e+00  4.439754e-01  1.340445e+01
      vertex   8.421620e+00  4.439945e-01  1.424919e+01
      vertex   8.420458e+00  3.309250e-04  1.424855e+01
    endloop
  endfacet
  facet normal  5.155006e-01  7.611532e-01  3.935797e-01
    outer loop
      vertex   7.271794e+00  1.949461e+00  1.459869e+01
      vertex   7.016270e+00  1.661791e+00  1.548970e+01
      vertex   7.550162e+00  1.661696e+00  1.479060e+01
    endloop
  endfacet
  facet normal  7.548376e-01 -3.131615e-01  5.763247e-01
    outer loop
      vertex   7.887176e+00 -8.843269e-01  1.502296e+01
      vertex   7.329536e+00 -8.843060e-01  1.575334e+01
      vertex   7.252472e+00 -1.189419e+00  1.568848e+01
    endloop
  endfacet
  facet normal -1.545957e-01 -7.613462e-01  6.296445e-01
    outer loop
      vertex  -1.749077e+00 -1.662018e+00  1.858458e+01
      vertex  -2.619959e+00 -1.662099e+00  1.837066e+01
      vertex  -2.523508e+00 -1.949160e+00  1.804723e+01
    endloop
  endfacet
  facet normal -8.972221e-01 -2.727962e-03  4.415712e-01
    outer loop
      vertex  -8.421647e+00  4.444752e-01  1.424875e+01
      vertex  -8.837394e+00  4.444962e-01  1.340400e+01
      vertex  -8.836282e+00  8.068085e-04  1.340352e+01
    endloop
  endfacet
  facet normal  8.922708e-01  1.047284e-01  4.391864e-01
    outer loop
      vertex   8.794740e+00  8.848743e-01  1.338601e+01
      vertex   8.421620e+00  4.439945e-01  1.424919e+01
      vertex   8.837411e+00  4.439754e-01  1.340445e+01
    endloop
  endfacet
  facet normal -5.902519e-01 -8.070723e-01  1.539686e-02
    outer loop
      vertex  -6.933262e+00 -3.407667e+00  3.434591e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
    endloop
  endfacet
  facet normal -3.745724e-15 -5.680461e-15 -1.000000e+00
    outer loop
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
      vertex   4.414157e+00 -5.005417e+00  4.857226e-16
    endloop
  endfacet
  facet normal -4.800069e-02 -2.863901e-03  9.988432e-01
    outer loop
      vertex  -1.942747e-04  4.442348e-01  1.920913e+01
      vertex  -9.222730e-01  5.807877e-04  1.916355e+01
      vertex  -1.960567e-04  5.588531e-04  1.920786e+01
    endloop
  endfacet
  facet normal  5.156087e-01 -7.610139e-01  3.937075e-01
    outer loop
      vertex   7.550447e+00 -1.661053e+00  1.479081e+01
      vertex   6.758233e+00 -1.948568e+00  1.527256e+01
      vertex   7.272491e+00 -1.948517e+00  1.459918e+01
    endloop
  endfacet
  facet normal -5.609517e-02  9.979430e-01 -3.103266e-02
    outer loop
      vertex  -8.008703e-01  6.650064e+00  6.447229e-01
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
    endloop
  endfacet
  facet normal  7.841009e-01  4.860432e-01  3.859374e-01
    outer loop
      vertex   8.560225e+00  1.467184e+00  1.328466e+01
      vertex   8.293495e+00  1.187954e+00  1.417823e+01
      vertex   8.702976e+00  1.187906e+00  1.334635e+01
    endloop
  endfacet
  facet normal  7.840683e-01  4.860914e-01  3.859428e-01
    outer loop
      vertex   8.560225e+00  1.467184e+00  1.328466e+01
      vertex   8.157441e+00  1.467236e+00  1.410288e+01
      vertex   8.293495e+00  1.187954e+00  1.417823e+01
    endloop
  endfacet
  facet normal  7.419942e-01 -4.875028e-01  4.602018e-01
    outer loop
      vertex   8.292924e+00 -1.189396e+00  1.417792e+01
      vertex   7.675037e+00 -1.470186e+00  1.487670e+01
      vertex   8.155621e+00 -1.470160e+00  1.410187e+01
    endloop
  endfacet
  facet normal  4.332165e-01  8.760217e-01  2.119186e-01
    outer loop
      vertex   6.580883e+00  3.490953e+00  4.594908e+00
      vertex   6.742568e+00  3.357542e+00  4.815872e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
    endloop
  endfacet
  facet normal  6.608925e-01 -1.044858e-01  7.431714e-01
    outer loop
      vertex   6.737034e+00 -4.433289e-01  1.646011e+01
      vertex   6.047077e+00 -4.433079e-01  1.707368e+01
      vertex   6.017940e+00 -8.842640e-01  1.703760e+01
    endloop
  endfacet
  facet normal  2.489778e-01  9.660794e-01  6.856205e-02
    outer loop
      vertex   8.203593e+00  2.272276e+00  8.653778e+00
      vertex   8.236661e+00  2.237776e+00  9.019822e+00
      vertex   8.447516e+00  2.183165e+00  9.023621e+00
    endloop
  endfacet
  facet normal  7.041369e-01  6.197330e-01  3.465865e-01
    outer loop
      vertex   8.419196e+00  1.661506e+00  1.322371e+01
      vertex   8.157441e+00  1.467236e+00  1.410288e+01
      vertex   8.560225e+00  1.467184e+00  1.328466e+01
    endloop
  endfacet
  facet normal -4.404360e-01  1.793815e-03  8.977822e-01
    outer loop
      vertex   3.644418e+00  5.757833e+00  2.172665e+00
      vertex   3.450360e+00  4.332602e+00  2.080311e+00
      vertex   3.842232e+00  3.974119e+00  2.273273e+00
    endloop
  endfacet
  facet normal -2.887211e-01 -9.374727e-01  1.943840e-01
    outer loop
      vertex  -7.385486e+00 -2.856359e+00  5.890606e+00
      vertex  -7.511179e+00 -2.763084e+00  6.153759e+00
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
    endloop
  endfacet
  facet normal -2.168922e-01 -9.046963e-01  3.667184e-01
    outer loop
      vertex  -4.121021e+00 -1.949259e+00  1.739520e+01
      vertex  -4.643888e+00 -2.137625e+00  1.662126e+01
      vertex  -3.934147e+00 -2.137609e+00  1.704107e+01
    endloop
  endfacet
  facet normal  5.820209e-01  7.610410e-01  2.864757e-01
    outer loop
      vertex   8.108811e+00  1.949369e+00  1.308958e+01
      vertex   8.022988e+00  1.661601e+00  1.402842e+01
      vertex   8.419196e+00  1.661506e+00  1.322371e+01
    endloop
  endfacet
  facet normal  7.072789e-01  5.771154e-08  7.069347e-01
    outer loop
      vertex  -5.752640e+00  4.179514e+00  3.658571e+00
      vertex  -5.926451e+00  4.043840e+00  3.832467e+00
      vertex  -5.752707e+00 -4.183825e+00  3.658639e+00
    endloop
  endfacet
  facet normal -9.482424e-01  3.169289e-01 -1.981093e-02
    outer loop
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.330669e+00 -1.508112e+00 -2.775558e-17
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
    endloop
  endfacet
  facet normal  2.114473e-01  9.718311e-01  1.040883e-01
    outer loop
      vertex   7.741251e+00  2.137793e+00  1.293075e+01
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.376937e+00  2.137812e+00  1.367065e+01
    endloop
  endfacet
  facet normal  8.404622e-17  5.300132e-16 -1.000000e+00
    outer loop
      vertex   5.507741e+00  5.799408e-01  7.632783e-17
      vertex   6.687155e+00  3.876799e-01  7.355228e-17
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
    endloop
  endfacet
  facet normal  8.121607e-01  4.099558e-01 -4.151280e-01
    outer loop
      vertex   6.762638e+00  2.691202e+00  1.269223e+00
      vertex   6.957979e+00  2.296583e+00  1.261688e+00
      vertex   6.482162e+00  2.540468e+00  5.716410e-01
    endloop
  endfacet
  facet normal  4.448050e-01  4.862536e-01  7.521343e-01
    outer loop
      vertex   5.135185e+00  1.467489e+00  1.736625e+01
      vertex   4.350276e+00  1.467543e+00  1.783040e+01
      vertex   4.422884e+00  1.188246e+00  1.796803e+01
    endloop
  endfacet
  facet normal -3.257423e-02 -9.994672e-01  2.080322e-03
    outer loop
      vertex   3.864515e-01  5.562234e+00 -1.209102e-16
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
      vertex  -6.933798e-02  5.577089e+00 -5.681219e-17
    endloop
  endfacet
  facet normal -6.722453e-01 -7.402605e-01 -1.003277e-02
    outer loop
      vertex   3.842232e+00  3.974119e+00  2.273273e+00
      vertex   3.450360e+00  4.332602e+00  2.080311e+00
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
    endloop
  endfacet
  facet normal  8.624464e-01 -7.337977e-07 -5.061485e-01
    outer loop
      vertex  -7.015535e+00  2.181345e+00  1.393137e+01
      vertex  -7.015543e+00 -2.180944e+00  1.393137e+01
      vertex  -7.219871e+00 -2.180944e+00  1.358320e+01
    endloop
  endfacet
  facet normal -2.894313e-01  9.422063e-01  1.687510e-01
    outer loop
      vertex  -7.658601e+00  2.655306e+00  6.497398e+00
      vertex  -7.511187e+00  2.762133e+00  6.153776e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
    endloop
  endfacet
  facet normal  9.986029e-01 -4.677819e-02 -2.457906e-02
    outer loop
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.520691e+00  4.318787e-01 -2.428613e-17
      vertex  -5.432583e+00  5.453663e-01  3.363667e+00
    endloop
  endfacet
  facet normal  9.591118e-01 -4.874337e-07 -2.830277e-01
    outer loop
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
      vertex  -7.974323e+00  2.181356e+00  1.171618e+01
      vertex  -7.974327e+00 -2.180941e+00  1.171617e+01
    endloop
  endfacet
  facet normal  6.073657e-01 -7.609135e-01  2.282927e-01
    outer loop
      vertex   8.735147e+00 -1.660802e+00  1.238419e+01
      vertex   8.109565e+00 -1.948414e+00  1.308991e+01
      vertex   8.413611e+00 -1.948362e+00  1.228117e+01
    endloop
  endfacet
  facet normal  6.310912e-01 -3.131657e-01  7.096838e-01
    outer loop
      vertex   6.704575e+00 -8.842850e-01  1.642699e+01
      vertex   5.954641e+00 -1.189440e+00  1.695921e+01
      vertex   6.634067e+00 -1.189428e+00  1.635503e+01
    endloop
  endfacet
  facet normal -6.347346e-01 -7.701568e-01 -6.301253e-02
    outer loop
      vertex  -6.933262e+00 -3.407667e+00  3.434591e+00
      vertex  -7.421945e+00 -3.058773e+00  4.092888e+00
      vertex  -7.248965e+00 -3.145601e+00  3.411671e+00
    endloop
  endfacet
  facet normal  7.338558e-01 -6.207947e-01  2.758072e-01
    outer loop
      vertex   8.879113e+00 -1.470104e+00  1.243032e+01
      vertex   8.558311e+00 -1.470133e+00  1.328384e+01
      vertex   8.419494e+00 -1.660886e+00  1.322384e+01
    endloop
  endfacet
  facet normal  3.689904e-01 -4.875476e-01  7.912923e-01
    outer loop
      vertex   4.422585e+00 -1.189459e+00  1.796748e+01
      vertex   3.523055e+00 -1.470343e+00  1.821387e+01
      vertex   4.349310e+00 -1.470318e+00  1.782860e+01
    endloop
  endfacet
  facet normal -9.186738e-01  2.032321e-01 -3.387258e-01
    outer loop
      vertex  -8.332305e+00  1.050993e+00  3.334660e+00
      vertex  -8.479411e+00  1.548126e+00  4.031908e+00
      vertex  -8.223594e+00  1.558374e+00  3.344243e+00
    endloop
  endfacet
  facet normal -4.623944e-01 -6.211199e-01  6.327729e-01
    outer loop
      vertex  -5.134163e+00 -1.470596e+00  1.736407e+01
      vertex  -5.760451e+00 -1.662422e+00  1.671812e+01
      vertex  -5.050360e+00 -1.662342e+00  1.723709e+01
    endloop
  endfacet
  facet normal  8.173032e-01 -4.875100e-01  3.071635e-01
    outer loop
      vertex   9.028557e+00 -1.189371e+00  1.247821e+01
      vertex   8.702374e+00 -1.189384e+00  1.334610e+01
      vertex   8.558311e+00 -1.470133e+00  1.328384e+01
    endloop
  endfacet
  facet normal -7.336217e-01  6.211218e-01  2.756935e-01
    outer loop
      vertex  -8.417369e+00  1.663807e+00  1.322250e+01
      vertex  -8.880441e+00  1.468477e+00  1.243033e+01
      vertex  -8.559678e+00  1.468428e+00  1.328400e+01
    endloop
  endfacet
  facet normal  9.983069e-01  5.290302e-02 -2.417845e-02
    outer loop
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
    endloop
  endfacet
  facet normal -8.678337e-01 -7.311743e-02 -4.914453e-01
    outer loop
      vertex  -6.964637e+00 -8.798046e-01  5.629778e-01
      vertex  -7.001122e+00 -4.389858e-01  5.618219e-01
      vertex  -6.653766e+00 -7.855896e-01 -3.986009e-16
    endloop
  endfacet
  facet normal  1.545640e-01  7.614906e-01  6.294775e-01
    outer loop
      vertex   2.523059e+00  1.949789e+00  1.804679e+01
      vertex   1.748731e+00  1.662465e+00  1.858451e+01
      vertex   2.619659e+00  1.662367e+00  1.837077e+01
    endloop
  endfacet
  facet normal  7.338780e-01 -6.207590e-01  2.758286e-01
    outer loop
      vertex   8.879113e+00 -1.470104e+00  1.243032e+01
      vertex   8.419494e+00 -1.660886e+00  1.322384e+01
      vertex   8.735147e+00 -1.660802e+00  1.238419e+01
    endloop
  endfacet
  facet normal  4.154738e-01  9.096051e-01  2.118553e-04
    outer loop
      vertex  -2.293268e+00 -5.066431e+00  1.649853e+00
      vertex  -2.026798e+00 -5.187760e+00 -4.897124e-16
      vertex  -2.532545e+00 -4.956754e+00 -6.938894e-17
    endloop
  endfacet
  facet normal  8.678320e-01 -7.371525e-02 -4.913590e-01
    outer loop
      vertex   7.000465e+00 -4.384537e-01  5.618048e-01
      vertex   6.963712e+00 -8.787937e-01  5.629530e-01
      vertex   6.652763e+00 -7.870749e-01 -3.087808e-16
    endloop
  endfacet
  facet normal  8.903816e-01  7.285143e-02 -4.493476e-01
    outer loop
      vertex   7.711735e+00  1.016129e+00  1.959809e+00
      vertex   7.890829e+00  1.034529e+00  2.317666e+00
      vertex   7.930045e+00  5.198708e-01  2.311933e+00
    endloop
  endfacet
  facet normal  9.960628e-02  9.718308e-01  2.135967e-01
    outer loop
      vertex   3.933867e+00  2.137918e+00  1.704117e+01
      vertex   3.851037e+00  2.180897e+00  1.688424e+01
      vertex   3.186519e+00  2.137938e+00  1.738959e+01
    endloop
  endfacet
  facet normal  1.252331e-01  4.863558e-01  8.647397e-01
    outer loop
      vertex   1.778145e+00  1.467701e+00  1.873589e+01
      vertex   9.079884e-01  1.188446e+00  1.901897e+01
      vertex   1.807832e+00  1.188396e+00  1.888868e+01
    endloop
  endfacet
  facet normal  9.309568e-01 -1.044776e-01  3.498627e-01
    outer loop
      vertex   9.168580e+00 -4.434319e-01  1.252308e+01
      vertex   8.837360e+00 -4.434109e-01  1.340443e+01
      vertex   8.794788e+00 -8.843689e-01  1.338603e+01
    endloop
  endfacet
  facet normal  6.410562e-15 -3.027467e-15 -1.000000e+00
    outer loop
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
      vertex  -4.403078e-01 -5.559525e+00 -5.898060e-17
      vertex  -3.863586e-01 -5.561952e+00  2.942091e-16
    endloop
  endfacet
  facet normal  4.553368e-02 -3.132706e-01  9.485717e-01
    outer loop
      vertex   9.175830e-01 -8.841286e-01  1.911875e+01
      vertex  -1.970066e-04 -1.189507e+00  1.906195e+01
      vertex   9.079207e-01 -1.189497e+00  1.901836e+01
    endloop
  endfacet
  facet normal  1.324183e-01  9.911938e-01 -5.356491e-04
    outer loop
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
      vertex  -9.071357e-01 -5.499633e+00 -4.550758e-16
      vertex  -9.513160e-01 -5.492985e+00  1.380087e+00
    endloop
  endfacet
  facet normal  4.934356e-01  8.670114e-01 -6.937265e-02
    outer loop
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
      vertex   3.100696e+00  5.908006e+00  8.482798e-16
      vertex   3.084982e+00  5.916950e+00 -2.723516e-16
    endloop
  endfacet
  facet normal  8.071445e-01 -2.223993e-08  5.903539e-01
    outer loop
      vertex  -6.742538e+00  3.359671e+00  4.816041e+00
      vertex  -6.742536e+00 -3.362928e+00  4.816038e+00
      vertex  -6.582784e+00 -3.495262e+00  4.597621e+00
    endloop
  endfacet
  facet normal  4.444310e-01 -4.875468e-01  7.515180e-01
    outer loop
      vertex   5.220532e+00 -1.189449e+00  1.749559e+01
      vertex   4.349310e+00 -1.470318e+00  1.782860e+01
      vertex   5.134046e+00 -1.470291e+00  1.736454e+01
    endloop
  endfacet
  facet normal -8.889115e-01 -3.134717e-01  3.340237e-01
    outer loop
      vertex  -9.124593e+00 -8.838253e-01  1.250855e+01
      vertex  -9.028337e+00 -1.189642e+00  1.247771e+01
      vertex  -8.794991e+00 -8.838463e-01  1.338567e+01
    endloop
  endfacet
  facet normal -6.918638e-01  6.958323e-01 -1.927223e-01
    outer loop
      vertex  -7.329176e+00  2.866369e+00  2.711174e+00
      vertex  -7.546020e+00  2.839064e+00  3.391044e+00
      vertex  -7.246525e+00  3.142607e+00  3.411828e+00
    endloop
  endfacet
  facet normal  3.301592e-01 -7.611054e-01  5.583132e-01
    outer loop
      vertex   5.050582e+00 -1.661374e+00  1.723807e+01
      vertex   4.121053e+00 -1.948767e+00  1.739597e+01
      vertex   4.864637e+00 -1.948717e+00  1.695632e+01
    endloop
  endfacet
  facet normal  4.249917e-01  9.047140e-01  2.957151e-02
    outer loop
      vertex   8.775695e+00  1.949236e+00  1.061064e+01
      vertex   8.832999e+00  1.949952e+00  9.765159e+00
      vertex   8.433727e+00  2.137715e+00  9.758922e+00
    endloop
  endfacet
  facet normal -8.972568e-01 -1.844169e-01 -4.011492e-01
    outer loop
      vertex  -7.796678e+00 -1.540154e+00  2.326575e+00
      vertex  -7.944685e+00 -1.554760e+00  2.664340e+00
      vertex  -8.044674e+00 -1.047447e+00  2.654763e+00
    endloop
  endfacet
  facet normal  8.890646e-01  3.129317e-01  3.341228e-01
    outer loop
      vertex   9.029185e+00  1.187859e+00  1.247841e+01
      vertex   8.794740e+00  8.848743e-01  1.338601e+01
      vertex   9.124373e+00  8.848534e-01  1.250891e+01
    endloop
  endfacet
  facet normal  8.890564e-01  3.129502e-01  3.341269e-01
    outer loop
      vertex   9.029185e+00  1.187859e+00  1.247841e+01
      vertex   8.702976e+00  1.187906e+00  1.334635e+01
      vertex   8.794740e+00  8.848743e-01  1.338601e+01
    endloop
  endfacet
  facet normal -4.623899e-01 -6.211258e-01  6.327704e-01
    outer loop
      vertex  -5.134163e+00 -1.470596e+00  1.736407e+01
      vertex  -5.856068e+00 -1.470623e+00  1.683652e+01
      vertex  -5.760451e+00 -1.662422e+00  1.671812e+01
    endloop
  endfacet
  facet normal  7.507165e-01 -6.604891e-01 -1.336866e-02
    outer loop
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -4.250774e+00  3.512644e+00  2.503092e+00
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
    endloop
  endfacet
  facet normal -2.082092e-01 -4.876205e-01  8.478650e-01
    outer loop
      vertex  -1.808037e+00 -1.189526e+00  1.888795e+01
      vertex  -2.663391e+00 -1.470520e+00  1.851630e+01
      vertex  -1.778063e+00 -1.470493e+00  1.873373e+01
    endloop
  endfacet
  facet normal -9.886719e-01 -1.483080e-01 -2.307805e-02
    outer loop
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
      vertex   5.507741e+00  5.799408e-01  7.632783e-17
    endloop
  endfacet
  facet normal -1.545024e-01  7.617877e-01  6.291332e-01
    outer loop
      vertex  -1.684469e+00  1.950029e+00  1.825224e+01
      vertex  -2.523188e+00  1.950075e+00  1.804622e+01
      vertex  -2.619798e+00  1.662946e+00  1.837016e+01
    endloop
  endfacet
  facet normal  3.299737e-01  7.613971e-01  5.580249e-01
    outer loop
      vertex   4.864143e+00  1.949648e+00  1.695555e+01
      vertex   4.120631e+00  1.949694e+00  1.739514e+01
      vertex   4.278395e+00  1.662172e+00  1.769416e+01
    endloop
  endfacet
  facet normal  6.072968e-01  7.609879e-01  2.282279e-01
    outer loop
      vertex   8.412847e+00  1.949324e+00  1.228092e+01
      vertex   8.419196e+00  1.661506e+00  1.322371e+01
      vertex   8.734851e+00  1.661410e+00  1.238410e+01
    endloop
  endfacet
  facet normal  6.601629e-01 -7.465258e-01 -8.297113e-02
    outer loop
      vertex   8.236308e+00 -2.380280e+00  4.747092e+00
      vertex   8.406335e+00 -2.307093e+00  5.441423e+00
      vertex   8.071296e+00 -2.604301e+00  5.449783e+00
    endloop
  endfacet
  facet normal -3.324931e-01  9.431057e-01  4.700015e-05
    outer loop
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
      vertex   2.057736e+00 -5.175515e+00  6.071532e-17
      vertex   1.574826e+00 -5.345766e+00  2.471981e-16
    endloop
  endfacet
  facet normal  6.071995e-01  7.610588e-01  2.282502e-01
    outer loop
      vertex   8.412847e+00  1.949324e+00  1.228092e+01
      vertex   8.108811e+00  1.949369e+00  1.308958e+01
      vertex   8.419196e+00  1.661506e+00  1.322371e+01
    endloop
  endfacet
  facet normal -9.749693e-01  4.896953e-08  2.223394e-01
    outer loop
      vertex   8.005827e+00  2.413839e+00  7.563888e+00
      vertex   8.005828e+00 -2.413929e+00  7.563893e+00
      vertex   8.088119e+00  2.358255e+00  7.924740e+00
    endloop
  endfacet
  facet normal  9.989909e-01 -1.987584e-07 -4.491428e-02
    outer loop
      vertex  -8.235942e+00  2.181364e+00  1.014854e+01
      vertex  -8.235943e+00 -2.180941e+00  1.014854e+01
      vertex  -8.253727e+00  2.117157e-04  9.752975e+00
    endloop
  endfacet
  facet normal  2.205931e-01  9.718348e-01  8.292048e-02
    outer loop
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.741251e+00  2.137793e+00  1.293075e+01
    endloop
  endfacet
  facet normal -5.531862e-01  8.160983e-01  1.672380e-01
    outer loop
      vertex  -5.158133e+00  4.673937e+00  3.134282e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
      vertex  -5.344672e+00  4.515985e+00  3.288033e+00
    endloop
  endfacet
  facet normal  3.153627e-01  3.129771e-01  8.958749e-01
    outer loop
      vertex   3.582659e+00  1.188295e+00  1.835983e+01
      vertex   2.736763e+00  8.850708e-01  1.876354e+01
      vertex   3.620476e+00  8.850479e-01  1.845246e+01
    endloop
  endfacet
  facet normal -9.810303e-01  1.047323e-01  1.631275e-01
    outer loop
      vertex  -9.366744e+00  8.854465e-01  1.160335e+01
      vertex  -9.517486e+00  8.854656e-01  1.069680e+01
      vertex  -9.563660e+00  4.445534e-01  1.070219e+01
    endloop
  endfacet
  facet normal -8.312671e-01  3.542312e-01 -4.283868e-01
    outer loop
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
      vertex  -6.484798e+00  2.544256e+00  5.717058e-01
      vertex  -6.257010e+00  2.387415e+00  1.463476e-16
    endloop
  endfacet
  facet normal  4.124282e-01 -9.042643e-01  1.104951e-01
    outer loop
      vertex   8.637318e+00 -1.948309e+00  1.144662e+01
      vertex   8.413611e+00 -1.948362e+00  1.228117e+01
      vertex   8.032036e+00 -2.137334e+00  1.215893e+01
    endloop
  endfacet
  facet normal -4.928479e-01 -8.667094e-01 -7.691344e-02
    outer loop
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
      vertex  -3.097691e+00 -5.910476e+00  1.601150e-15
      vertex  -3.081993e+00 -5.919403e+00  2.393918e-16
    endloop
  endfacet
  facet normal -1.495847e-01  9.887488e-01 -3.973029e-04
    outer loop
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
      vertex   1.011927e+00 -5.480871e+00 -3.873638e-16
      vertex   5.742548e-01 -5.547085e+00  1.301043e-17
    endloop
  endfacet
  facet normal  3.386479e-01  9.046783e-01  2.586016e-01
    outer loop
      vertex   6.942175e+00  2.137827e+00  1.437145e+01
      vertex   6.451268e+00  2.137846e+00  1.501424e+01
      vertex   6.757576e+00  1.949507e+00  1.527199e+01
    endloop
  endfacet
  facet normal  6.267277e-01 -7.609320e-01  1.679134e-01
    outer loop
      vertex   8.967391e+00 -1.660718e+00  1.151774e+01
      vertex   8.735147e+00 -1.660802e+00  1.238419e+01
      vertex   8.413611e+00 -1.948362e+00  1.228117e+01
    endloop
  endfacet
  facet normal  3.541835e-01 -9.333726e-01  5.804911e-02
    outer loop
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
      vertex   8.143600e+00 -2.181015e+00  1.093535e+01
      vertex   8.216428e+00 -2.177635e+00  1.054533e+01
    endloop
  endfacet
  facet normal  4.344341e-01  8.812526e-01  1.861744e-01
    outer loop
      vertex   6.742568e+00  3.357542e+00  4.815872e+00
      vertex   6.959351e+00  3.182512e+00  5.138515e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
    endloop
  endfacet
  facet normal -8.416877e-16 -1.017385e-15 -1.000000e+00
    outer loop
      vertex  -6.686056e+00  3.930120e-01  5.273559e-16
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
      vertex  -6.697911e+00  7.241169e-03  9.298118e-16
    endloop
  endfacet
  facet normal  7.572733e-01 -6.207801e-01  2.029025e-01
    outer loop
      vertex   9.115124e+00 -1.470076e+00  1.154957e+01
      vertex   8.879113e+00 -1.470104e+00  1.243032e+01
      vertex   8.735147e+00 -1.660802e+00  1.238419e+01
    endloop
  endfacet
  facet normal  2.336001e-01 -9.720984e-01  2.134642e-02
    outer loop
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   1.427193e+00 -6.511893e+00 -2.001871e-15
      vertex   1.441300e+00 -6.508503e+00  1.031293e-15
    endloop
  endfacet
  facet normal -8.611577e-01 -4.877498e-01  1.432042e-01
    outer loop
      vertex  -9.268229e+00 -1.189653e+00  1.158213e+01
      vertex  -9.261168e+00 -1.470842e+00  1.066687e+01
      vertex  -9.114491e+00 -1.470814e+00  1.154900e+01
    endloop
  endfacet
  facet normal  8.498275e-01  2.894396e-03  5.270529e-01
    outer loop
      vertex   8.420458e+00  3.309250e-04  1.424855e+01
      vertex   7.924301e+00  3.509521e-04  1.504856e+01
      vertex   7.925358e+00 -4.433708e-01  1.504929e+01
    endloop
  endfacet
  facet normal  6.645289e-01  2.916506e-03  7.472569e-01
    outer loop
      vertex   6.736129e+00  3.900528e-04  1.645918e+01
      vertex   6.047077e+00 -4.433079e-01  1.707368e+01
      vertex   6.737034e+00 -4.433289e-01  1.646011e+01
    endloop
  endfacet
  facet normal -1.156172e-02 -9.705403e-01  2.406612e-01
    outer loop
      vertex  -1.725861e-04 -2.137535e+00  1.801501e+01
      vertex  -8.079415e-01 -2.137550e+00  1.797614e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
    endloop
  endfacet
  facet normal  3.825394e-01  7.613019e-01  5.235294e-01
    outer loop
      vertex   5.548191e+00  1.949602e+00  1.645586e+01
      vertex   5.050371e+00  1.662075e+00  1.723773e+01
      vertex   5.760602e+00  1.661981e+00  1.671890e+01
    endloop
  endfacet
  facet normal  2.083518e-01  4.862991e-01  8.485887e-01
    outer loop
      vertex   2.663707e+00  1.467648e+00  1.851851e+01
      vertex   1.807832e+00  1.188396e+00  1.888868e+01
      vertex   2.708174e+00  1.188345e+00  1.866765e+01
    endloop
  endfacet
  facet normal -4.834991e-01  3.130147e-01  8.174658e-01
    outer loop
      vertex  -4.423090e+00  1.188745e+00  1.796770e+01
      vertex  -5.276216e+00  8.852768e-01  1.757931e+01
      vertex  -4.469825e+00  8.852539e-01  1.805627e+01
    endloop
  endfacet
  facet normal -9.289392e-01  5.901178e-07 -3.702322e-01
    outer loop
      vertex   7.578020e+00  2.180861e+00  1.286023e+01
      vertex   7.727502e+00  2.181219e+00  1.248517e+01
      vertex   7.727498e+00 -2.181013e+00  1.248517e+01
    endloop
  endfacet
  facet normal -6.074200e-16 -2.430558e-15 -1.000000e+00
    outer loop
      vertex  -6.400501e+00  1.981328e+00 -4.718448e-16
      vertex  -5.330578e+00  1.508395e+00  2.775558e-17
      vertex  -6.499778e+00  1.629298e+00  4.440892e-16
    endloop
  endfacet
  facet normal -9.167992e-01  7.619774e-02 -3.920114e-01
    outer loop
      vertex  -8.082679e+00  5.254803e-01  2.648710e+00
      vertex  -8.373130e+00  5.283813e-01  3.328554e+00
      vertex  -8.332305e+00  1.050993e+00  3.334660e+00
    endloop
  endfacet
  facet normal  9.844543e-01 -9.349762e-02 -1.486877e-01
    outer loop
      vertex   9.401635e+00 -4.805756e-01  6.855621e+00
      vertex   9.468694e+00 -9.287109e-01  7.581409e+00
      vertex   9.356856e+00 -9.520664e-01  6.855625e+00
    endloop
  endfacet
  facet normal  9.173700e-01 -3.130847e-01  2.457850e-01
    outer loop
      vertex   9.366902e+00 -8.844090e-01  1.160383e+01
      vertex   9.124413e+00 -8.843880e-01  1.250893e+01
      vertex   9.028557e+00 -1.189371e+00  1.247821e+01
    endloop
  endfacet
  facet normal -4.658192e-01 -8.804183e-01 -8.874760e-02
    outer loop
      vertex  -3.147879e+00 -5.979671e+00  1.410045e+00
      vertex  -3.902367e+00 -5.617058e+00  1.772907e+00
      vertex  -3.873714e+00 -5.593157e+00  1.385406e+00
    endloop
  endfacet
  facet normal -3.549605e-01  4.401738e-04 -9.348812e-01
    outer loop
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   3.118692e+00 -2.180992e+00  1.722361e+01
      vertex   2.741342e+00 -2.180990e+00  1.736688e+01
    endloop
  endfacet
  facet normal  1.425314e-01 -1.044844e-01  9.842601e-01
    outer loop
      vertex   1.835788e+00 -4.431973e-01  1.903259e+01
      vertex   9.175830e-01 -8.841286e-01  1.911875e+01
      vertex   1.826940e+00 -8.841515e-01  1.898706e+01
    endloop
  endfacet
  facet normal  9.987963e-01  7.502896e-04 -4.904370e-02
    outer loop
      vertex  -8.235942e+00  2.181364e+00  1.014854e+01
      vertex  -8.253727e+00  2.117157e-04  9.752975e+00
      vertex  -8.255363e+00  2.181059e+00  9.753010e+00
    endloop
  endfacet
  facet normal  8.676572e-01  7.373857e-02 -4.916641e-01
    outer loop
      vertex   7.000476e+00  4.469490e-01  5.618172e-01
      vertex   6.687155e+00  3.876799e-01  7.355228e-17
      vertex   6.652087e+00  8.003138e-01  2.636780e-16
    endloop
  endfacet
  facet normal  9.174230e-01  3.129241e-01  2.457920e-01
    outer loop
      vertex   9.269166e+00  1.187811e+00  1.158277e+01
      vertex   9.124373e+00  8.848534e-01  1.250891e+01
      vertex   9.366868e+00  8.848324e-01  1.160382e+01
    endloop
  endfacet
  facet normal  8.441628e-01  4.860358e-01  2.261824e-01
    outer loop
      vertex   9.117169e+00  1.467085e+00  1.155001e+01
      vertex   8.881103e+00  1.467134e+00  1.243096e+01
      vertex   9.029185e+00  1.187859e+00  1.247841e+01
    endloop
  endfacet
  facet normal  7.581620e-01  6.196200e-01  2.031293e-01
    outer loop
      vertex   8.967095e+00  1.661316e+00  1.151767e+01
      vertex   8.881103e+00  1.467134e+00  1.243096e+01
      vertex   9.117169e+00  1.467085e+00  1.155001e+01
    endloop
  endfacet
  facet normal  7.580948e-01  6.196986e-01  2.031397e-01
    outer loop
      vertex   8.967095e+00  1.661316e+00  1.151767e+01
      vertex   8.734851e+00  1.661410e+00  1.238410e+01
      vertex   8.881103e+00  1.467134e+00  1.243096e+01
    endloop
  endfacet
  facet normal -2.899255e-01 -4.876290e-01  8.235055e-01
    outer loop
      vertex  -2.708294e+00 -1.189535e+00  1.866687e+01
      vertex  -3.582696e+00 -1.189545e+00  1.835902e+01
      vertex  -3.523293e+00 -1.470545e+00  1.821354e+01
    endloop
  endfacet
  facet normal  4.212201e-01 -9.042482e-01  7.006266e-02
    outer loop
      vertex   8.637318e+00 -1.948309e+00  1.144662e+01
      vertex   8.245609e+00 -2.137315e+00  1.136222e+01
      vertex   8.776464e+00 -1.948257e+00  1.061073e+01
    endloop
  endfacet
  facet normal  5.702661e-01  8.214295e-01  7.074676e-03
    outer loop
      vertex   7.418854e+00  3.053747e+00  4.092981e+00
      vertex   7.572250e+00  2.941378e+00  4.775318e+00
      vertex   7.917879e+00  2.701559e+00  4.760293e+00
    endloop
  endfacet
  facet normal  9.434775e-01  2.793709e-01 -1.783318e-01
    outer loop
      vertex   9.075440e+00  1.444485e+00  6.138266e+00
      vertex   9.356750e+00  9.523754e-01  6.855629e+00
      vertex   9.212695e+00  9.799118e-01  6.136631e+00
    endloop
  endfacet
  facet normal  3.830386e-01 -9.042780e-01  1.885810e-01
    outer loop
      vertex   8.109565e+00 -1.948414e+00  1.308991e+01
      vertex   7.377430e+00 -2.137368e+00  1.367093e+01
      vertex   7.741767e+00 -2.137351e+00  1.293098e+01
    endloop
  endfacet
  facet normal  1.171518e-01 -1.601983e-04  9.931140e-01
    outer loop
      vertex  -8.056749e-01  6.646356e+00  1.364390e+00
      vertex  -1.128328e+00  6.602671e+00  1.402445e+00
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
    endloop
  endfacet
  facet normal  7.733852e-01 -6.207415e-01  1.286673e-01
    outer loop
      vertex   9.261893e+00 -1.470047e+00  1.066743e+01
      vertex   8.967391e+00 -1.660718e+00  1.151774e+01
      vertex   9.111837e+00 -1.660636e+00  1.064991e+01
    endloop
  endfacet
  facet normal  8.612958e-01 -4.874821e-01  1.432859e-01
    outer loop
      vertex   9.417737e+00 -1.189346e+00  1.068564e+01
      vertex   9.115124e+00 -1.470076e+00  1.154957e+01
      vertex   9.261893e+00 -1.470047e+00  1.066743e+01
    endloop
  endfacet
  facet normal -4.330713e-01 -8.756412e-01  2.137796e-01
    outer loop
      vertex  -6.582784e+00 -3.495262e+00  4.597621e+00
      vertex  -6.742536e+00 -3.362928e+00  4.816038e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
    endloop
  endfacet
  facet normal -8.432746e-01 -4.877118e-01  2.258875e-01
    outer loop
      vertex  -9.028337e+00 -1.189642e+00  1.247771e+01
      vertex  -9.268229e+00 -1.189653e+00  1.158213e+01
      vertex  -9.114491e+00 -1.470814e+00  1.154900e+01
    endloop
  endfacet
  facet normal -2.965797e-01 -9.512348e-01  8.481172e-02
    outer loop
      vertex  -7.906280e+00 -2.481894e+00  7.203666e+00
      vertex  -8.379153e+00 -2.301985e+00  7.567893e+00
      vertex  -8.301743e+00 -2.390017e+00  6.851242e+00
    endloop
  endfacet
  facet normal  8.535761e-01 -2.129442e-01 -4.754605e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   6.513909e+00 -1.572044e+00 -3.101686e-15
      vertex   6.892925e+00 -1.313347e+00  5.645704e-01
    endloop
  endfacet
  facet normal  5.511494e-01  7.611546e-01  3.418741e-01
    outer loop
      vertex   7.727200e+00  1.949415e+00  1.386461e+01
      vertex   7.271794e+00  1.949461e+00  1.459869e+01
      vertex   7.550162e+00  1.661696e+00  1.479060e+01
    endloop
  endfacet
  facet normal -3.618543e-01 -9.048197e-01  2.244168e-01
    outer loop
      vertex  -7.271570e+00 -1.949509e+00  1.459810e+01
      vertex  -7.376554e+00 -2.137703e+00  1.367004e+01
      vertex  -6.941944e+00 -2.137688e+00  1.437088e+01
    endloop
  endfacet
  facet normal -2.044346e-02  9.048126e-01  4.253189e-01
    outer loop
      vertex  -1.551486e-04  2.138014e+00  1.801440e+01
      vertex  -8.078656e-01  2.138033e+00  1.797553e+01
      vertex  -8.462134e-01  1.949980e+00  1.837375e+01
    endloop
  endfacet
  facet normal -4.928035e-01 -8.669556e-01  7.438233e-02
    outer loop
      vertex  -7.574894e+00 -2.945297e+00  4.775242e+00
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
      vertex  -8.071532e+00 -2.605118e+00  5.449806e+00
    endloop
  endfacet
  facet normal -4.997247e-16  7.903809e-16 -1.000000e+00
    outer loop
      vertex  -6.686056e+00  3.930120e-01  5.273559e-16
      vertex  -6.650962e+00  8.014841e-01  8.326673e-16
      vertex  -5.520691e+00  4.318787e-01 -2.428613e-17
    endloop
  endfacet
  facet normal -2.737703e-01  7.618428e-01  5.870651e-01
    outer loop
      vertex  -3.337810e+00  1.950125e+00  1.775935e+01
      vertex  -4.278252e+00  1.663140e+00  1.769321e+01
      vertex  -3.465606e+00  1.663043e+00  1.807230e+01
    endloop
  endfacet
  facet normal  9.810488e-01 -1.044792e-01  1.631794e-01
    outer loop
      vertex   9.412238e+00 -4.434509e-01  1.161360e+01
      vertex   9.366902e+00 -8.844090e-01  1.160383e+01
      vertex   9.563747e+00 -4.434700e-01  1.070270e+01
    endloop
  endfacet
  facet normal  8.823258e-01 -1.396262e-02 -4.704319e-01
    outer loop
      vertex   7.565843e+00  1.035690e-03  1.591653e+00
      vertex   7.759639e+00  2.861023e-04  1.955153e+00
      vertex   7.752341e+00 -5.106583e-01  1.956629e+00
    endloop
  endfacet
  facet normal  1.588033e-01 -9.873071e-01 -2.507864e-03
    outer loop
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
      vertex  -1.072226e+00  5.471439e+00  1.474515e-16
      vertex  -1.011834e+00  5.481153e+00  3.025358e-16
    endloop
  endfacet
  facet normal -9.359558e-01  5.836233e-08  3.521176e-01
    outer loop
      vertex   7.658692e+00  2.654070e+00  6.497303e+00
      vertex   7.658683e+00 -2.654942e+00  6.497281e+00
      vertex   7.791418e+00 -2.560793e+00  6.850099e+00
    endloop
  endfacet
  facet normal  9.864439e-01  2.841536e-03  1.640745e-01
    outer loop
      vertex   9.562493e+00  2.565384e-04  1.070256e+01
      vertex   9.412238e+00 -4.434509e-01  1.161360e+01
      vertex   9.563747e+00 -4.434700e-01  1.070270e+01
    endloop
  endfacet
  facet normal  3.713215e-01 -9.060092e-01  2.031441e-01
    outer loop
      vertex   7.276844e+00 -2.937180e+00  5.680428e+00
      vertex   7.325849e+00 -2.964117e+00  5.470715e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
    endloop
  endfacet
  facet normal -9.961452e-02  9.718180e-01  2.136507e-01
    outer loop
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
      vertex  -3.933839e+00  2.138109e+00  1.704051e+01
    endloop
  endfacet
  facet normal -2.830513e-01 -9.047530e-01  3.182826e-01
    outer loop
      vertex  -5.548426e+00 -1.949358e+00  1.645558e+01
      vertex  -5.901175e+00 -2.137655e+00  1.560662e+01
      vertex  -5.296856e+00 -2.137640e+00  1.614409e+01
    endloop
  endfacet
  facet normal -6.231955e-01  6.205373e-01  4.759840e-01
    outer loop
      vertex  -7.015276e+00  1.663522e+00  1.548836e+01
      vertex  -7.550043e+00  1.662085e+00  1.479008e+01
      vertex  -7.676430e+00  1.468325e+00  1.487720e+01
    endloop
  endfacet
  facet normal  9.864435e-01  2.846398e-03  1.640768e-01
    outer loop
      vertex   9.411002e+00  2.746582e-04  1.161333e+01
      vertex   9.412238e+00 -4.434509e-01  1.161360e+01
      vertex   9.562493e+00  2.565384e-04  1.070256e+01
    endloop
  endfacet
  facet normal  8.457451e-01 -2.388904e-01 -4.771231e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
      vertex   6.503150e+00 -1.615171e+00  2.157996e-15
    endloop
  endfacet
  facet normal  5.279726e-02 -9.986024e-01 -2.352899e-03
    outer loop
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
      vertex  -1.329709e-01  5.573674e+00 -2.687087e-16
    endloop
  endfacet
  facet normal -1.873159e-01  9.718308e-01  1.430299e-01
    outer loop
      vertex  -6.450688e+00  2.138182e+00  1.501330e+01
      vertex  -6.315534e+00  2.180981e+00  1.489950e+01
      vertex  -6.941405e+00  2.138201e+00  1.437052e+01
    endloop
  endfacet
  facet normal -6.403902e-01  7.659069e-01  5.733248e-02
    outer loop
      vertex  -6.018507e+00  4.096174e+00  2.395986e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
      vertex  -5.371007e+00  4.634257e+00  2.440140e+00
    endloop
  endfacet
  facet normal  5.709286e-01 -8.194898e-01  4.976832e-02
    outer loop
      vertex   7.920142e+00 -2.704113e+00  4.760183e+00
      vertex   7.706047e+00 -2.810797e+00  5.459559e+00
      vertex   7.574584e+00 -2.943947e+00  4.775200e+00
    endloop
  endfacet
  facet normal  6.109276e-02 -9.045329e-01  4.220046e-01
    outer loop
      vertex   1.684419e+00 -1.948915e+00  1.825361e+01
      vertex   8.076244e-01 -2.137521e+00  1.797628e+01
      vertex   1.608019e+00 -2.137506e+00  1.786044e+01
    endloop
  endfacet
  facet normal -8.520076e-01 -3.134519e-01  4.193220e-01
    outer loop
      vertex  -8.381232e+00 -8.838654e-01  1.422637e+01
      vertex  -8.794991e+00 -8.838463e-01  1.338567e+01
      vertex  -8.702224e+00 -1.189629e+00  1.334559e+01
    endloop
  endfacet
  facet normal -9.606588e-01 -1.044745e-01  2.573321e-01
    outer loop
      vertex  -9.168757e+00 -4.428749e-01  1.252270e+01
      vertex  -9.367053e+00 -8.838062e-01  1.160342e+01
      vertex  -9.124593e+00 -8.838253e-01  1.250855e+01
    endloop
  endfacet
  facet normal  1.878958e-15  3.488768e-15 -1.000000e+00
    outer loop
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
      vertex   4.930933e+00 -2.531955e+00  0.000000e+00
      vertex   6.104056e+00 -2.746094e+00  1.457168e-15
    endloop
  endfacet
  facet normal -4.917994e-01  8.651149e-01  9.853797e-02
    outer loop
      vertex  -8.069816e+00  2.604250e+00  5.449877e+00
      vertex  -7.814534e+00  2.669630e+00  6.149975e+00
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
    endloop
  endfacet
  facet normal  8.972015e-01  2.883714e-03  4.416122e-01
    outer loop
      vertex   8.836189e+00  3.118515e-04  1.340393e+01
      vertex   8.420458e+00  3.309250e-04  1.424855e+01
      vertex   8.421578e+00 -4.433918e-01  1.424917e+01
    endloop
  endfacet
  facet normal  9.864416e-01 -3.017850e-03  1.640848e-01
    outer loop
      vertex   9.412313e+00  4.439354e-01  1.161362e+01
      vertex   9.411002e+00  2.746582e-04  1.161333e+01
      vertex   9.563832e+00  4.439163e-01  1.070271e+01
    endloop
  endfacet
  facet normal  3.990258e-01 -6.208773e-01  6.747515e-01
    outer loop
      vertex   5.134046e+00 -1.470291e+00  1.736454e+01
      vertex   4.278577e+00 -1.661456e+00  1.769453e+01
      vertex   5.050582e+00 -1.661374e+00  1.723807e+01
    endloop
  endfacet
  facet normal -8.879051e-01 -3.666894e-01 -2.777832e-01
    outer loop
      vertex  -8.290376e+00 -2.019579e+00  4.043274e+00
      vertex  -8.708583e+00 -1.524952e+00  4.727094e+00
      vertex  -8.480636e+00 -1.550205e+00  4.031820e+00
    endloop
  endfacet
  facet normal -9.309703e-01 -1.044689e-01  3.498296e-01
    outer loop
      vertex  -9.168757e+00 -4.428749e-01  1.252270e+01
      vertex  -9.124593e+00 -8.838253e-01  1.250855e+01
      vertex  -8.837564e+00 -4.428959e-01  1.340407e+01
    endloop
  endfacet
  facet normal -3.715861e-01  9.061007e-01  2.022505e-01
    outer loop
      vertex  -7.324272e+00  2.964247e+00  5.470831e+00
      vertex  -7.704495e+00  2.810812e+00  5.459666e+00
      vertex  -7.275784e+00  2.937731e+00  5.678710e+00
    endloop
  endfacet
  facet normal -3.945477e-16 -1.602228e-15 -1.000000e+00
    outer loop
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
      vertex   5.509706e+00 -3.781196e+00 -7.748432e-17
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
    endloop
  endfacet
  facet normal  4.204771e-01  9.046021e-01  6.995733e-02
    outer loop
      vertex   8.377821e+00  2.137769e+00  1.056418e+01
      vertex   8.636546e+00  1.949278e+00  1.144645e+01
      vertex   8.775695e+00  1.949236e+00  1.061064e+01
    endloop
  endfacet
  facet normal  5.243679e-16 -1.016466e-15 -1.000000e+00
    outer loop
      vertex  -6.593333e+00 -1.194343e+00  4.857226e-17
      vertex  -6.653766e+00 -7.855896e-01 -3.986009e-16
      vertex  -5.507651e+00 -5.796566e-01 -6.938894e-18
    endloop
  endfacet
  facet normal -4.226762e-01  3.061136e-03  9.062756e-01
    outer loop
      vertex  -3.637867e+00  6.446838e-04  1.849414e+01
      vertex  -4.490940e+00  6.666183e-04  1.809628e+01
      vertex  -4.491577e+00 -4.430428e-01  1.809748e+01
    endloop
  endfacet
  facet normal  8.679337e-01  7.512014e-02 -4.909666e-01
    outer loop
      vertex   6.963074e+00  8.865833e-01  5.629635e-01
      vertex   7.000476e+00  4.469490e-01  5.618172e-01
      vertex   6.652087e+00  8.003138e-01  2.636780e-16
    endloop
  endfacet
  facet normal  1.671732e-01  3.566843e-03  9.859211e-01
    outer loop
      vertex  -1.447180e+00  6.545197e+00  1.452800e+00
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
    endloop
  endfacet
  facet normal  9.708298e-01 -4.164288e-03 -2.397337e-01
    outer loop
      vertex  -8.071125e+00  2.181000e+00  1.132417e+01
      vertex  -7.974323e+00  2.181356e+00  1.171618e+01
      vertex  -8.088870e+00 -2.177027e+00  1.132801e+01
    endloop
  endfacet
  facet normal -7.412311e-01 -5.841238e-01 -3.307200e-01
    outer loop
      vertex  -6.308788e+00 -3.388851e+00  1.287506e+00
      vertex  -6.415605e+00 -3.455317e+00  1.644304e+00
      vertex  -6.669674e+00 -3.125740e+00  1.631636e+00
    endloop
  endfacet
  facet normal  6.111624e-02 -9.045579e-01  4.219475e-01
    outer loop
      vertex   1.684419e+00 -1.948915e+00  1.825361e+01
      vertex   8.459943e-01 -1.948963e+00  1.837494e+01
      vertex   8.076244e-01 -2.137521e+00  1.797628e+01
    endloop
  endfacet
  facet normal -7.548966e-01  3.130366e-01  5.763152e-01
    outer loop
      vertex  -7.252964e+00  1.188940e+00  1.568837e+01
      vertex  -7.804706e+00  1.188988e+00  1.496563e+01
      vertex  -7.887197e+00  8.853626e-01  1.502250e+01
    endloop
  endfacet
  facet normal -7.929325e-01  4.289239e-01 -4.327613e-01
    outer loop
      vertex  -6.960249e+00  2.299536e+00  1.261756e+00
      vertex  -7.112368e+00  2.370153e+00  1.610469e+00
      vertex  -6.902237e+00  2.768610e+00  1.620378e+00
    endloop
  endfacet
  facet normal -8.020213e-01 -4.803305e-01 -3.550274e-01
    outer loop
      vertex  -6.092205e+00 -3.255135e+00  5.783606e-01
      vertex  -6.300128e+00 -2.905363e+00  5.748463e-01
      vertex  -5.921600e+00 -3.112514e+00 -8.326673e-17
    endloop
  endfacet
  facet normal -2.047182e-02 -9.045816e-01  4.258086e-01
    outer loop
      vertex  -1.826766e-04 -1.949013e+00  1.841550e+01
      vertex  -8.079415e-01 -2.137550e+00  1.797614e+01
      vertex  -1.725861e-04 -2.137535e+00  1.801501e+01
    endloop
  endfacet
  facet normal -9.659442e-01 -2.701109e-03  2.587366e-01
    outer loop
      vertex  -9.168571e+00  4.445152e-01  1.252264e+01
      vertex  -9.412189e+00  4.445343e-01  1.161314e+01
      vertex  -9.411016e+00  8.449554e-04  1.161289e+01
    endloop
  endfacet
  facet normal -8.519828e-01 -1.814771e-01 -4.911124e-01
    outer loop
      vertex  -6.893128e+00 -1.314762e+00  5.645828e-01
      vertex  -6.593333e+00 -1.194343e+00  4.857226e-17
      vertex  -6.512477e+00 -1.573938e+00 -2.775558e-16
    endloop
  endfacet
  facet normal  6.236364e-01  6.199430e-01  4.761809e-01
    outer loop
      vertex   7.550162e+00  1.661696e+00  1.479060e+01
      vertex   7.016270e+00  1.661791e+00  1.548970e+01
      vertex   7.133953e+00  1.467337e+00  1.558873e+01
    endloop
  endfacet
  facet normal  1.338266e-15  8.791619e-16 -1.000000e+00
    outer loop
      vertex  -3.093479e+00  5.912963e+00  1.084202e-15
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
      vertex  -3.767807e+00  5.508892e+00 -1.734723e-16
    endloop
  endfacet
  facet normal  3.823989e-01  9.046211e-01  1.882332e-01
    outer loop
      vertex   7.741251e+00  2.137793e+00  1.293075e+01
      vertex   7.727200e+00  1.949415e+00  1.386461e+01
      vertex   8.108811e+00  1.949369e+00  1.308958e+01
    endloop
  endfacet
  facet normal -7.702724e-01  5.611050e-01 -3.030537e-01
    outer loop
      vertex  -7.038194e+00  2.828043e+00  1.973469e+00
      vertex  -6.912291e+00  3.203196e+00  2.348057e+00
      vertex  -6.786282e+00  3.180582e+00  1.985910e+00
    endloop
  endfacet
  facet normal  8.432181e-01  2.865014e-01 -4.548627e-01
    outer loop
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
      vertex   6.398841e+00  1.977925e+00 -1.609823e-15
      vertex   6.385301e+00  2.017778e+00 -5.689893e-16
    endloop
  endfacet
  facet normal -8.698961e-01  2.971466e-01 -3.936810e-01
    outer loop
      vertex  -7.795024e+00  1.538778e+00  2.326663e+00
      vertex  -7.943122e+00  1.552727e+00  2.664435e+00
      vertex  -7.784481e+00  2.034075e+00  2.677211e+00
    endloop
  endfacet
  facet normal  2.381880e-01 -9.704100e-01  3.963361e-02
    outer loop
      vertex   8.245609e+00 -2.137315e+00  1.136222e+01
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
      vertex   8.378459e+00 -2.137298e+00  1.056425e+01
    endloop
  endfacet
  facet normal -9.419390e-01  3.350522e-01 -2.215853e-02
    outer loop
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
      vertex   5.043385e+00 -2.145653e+00  3.044071e+00
    endloop
  endfacet
  facet normal  8.523268e-01  1.838998e-01 -4.896119e-01
    outer loop
      vertex   6.890595e+00  1.320393e+00  5.645571e-01
      vertex   6.590715e+00  1.207189e+00  1.187813e-15
      vertex   6.509523e+00  1.583495e+00  1.110223e-16
    endloop
  endfacet
  facet normal -7.904962e-01 -1.044801e-01  6.034896e-01
    outer loop
      vertex  -7.365310e+00 -4.429569e-01  1.578290e+01
      vertex  -7.887427e+00 -8.838863e-01  1.502266e+01
      vertex  -7.329827e+00 -8.839073e-01  1.575304e+01
    endloop
  endfacet
  facet normal -5.111248e-01  8.529814e-01 -1.057075e-01
    outer loop
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
      vertex  -3.093479e+00  5.912963e+00  1.084202e-15
      vertex  -3.767807e+00  5.508892e+00 -1.734723e-16
    endloop
  endfacet
  facet normal  6.439185e-16  6.471777e-16 -1.000000e+00
    outer loop
      vertex   6.687054e+00 -3.784631e-01  2.567391e-16
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
      vertex   6.698109e+00  7.242848e-03  5.134781e-16
    endloop
  endfacet
  facet normal  6.473635e-01 -7.608878e-01  4.438660e-02
    outer loop
      vertex   9.111837e+00 -1.660636e+00  1.064991e+01
      vertex   8.776464e+00 -1.948257e+00  1.061073e+01
      vertex   8.833118e+00 -1.949384e+00  9.765130e+00
    endloop
  endfacet
  facet normal  4.308398e-01  7.613138e-01  4.845394e-01
    outer loop
      vertex   6.181304e+00  1.949553e+00  1.589299e+01
      vertex   5.548191e+00  1.949602e+00  1.645586e+01
      vertex   5.760602e+00  1.661981e+00  1.671890e+01
    endloop
  endfacet
  facet normal -4.425668e-02 -9.990193e-01 -1.331941e-03
    outer loop
      vertex   3.864515e-01  5.562234e+00 -1.209102e-16
      vertex   4.796038e-01  5.556322e+00  1.338963e+00
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
    endloop
  endfacet
  facet normal -6.582908e-01 -2.321108e-04  7.527637e-01
    outer loop
      vertex   5.343349e+00  4.512934e+00  3.286766e+00
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
      vertex   5.525450e+00  4.358259e+00  3.445965e+00
    endloop
  endfacet
  facet normal  5.161419e-01  8.544602e-01  5.912087e-02
    outer loop
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   4.338367e+00  5.317045e+00  2.556341e+00
      vertex   4.680184e+00  5.115396e+00  2.486569e+00
    endloop
  endfacet
  facet normal -4.682178e-01 -8.775623e-01  1.032305e-01
    outer loop
      vertex  -6.582784e+00 -3.495262e+00  4.597621e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
    endloop
  endfacet
  facet normal  5.840079e-01  8.054554e-01 -1.008769e-01
    outer loop
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
      vertex   3.794700e+00  5.487965e+00  3.504141e-16
      vertex   3.773587e+00  5.503273e+00 -5.898060e-17
    endloop
  endfacet
  facet normal  8.922683e-01  1.047370e-01  4.391896e-01
    outer loop
      vertex   8.794740e+00  8.848743e-01  1.338601e+01
      vertex   8.380954e+00  8.848953e-01  1.422666e+01
      vertex   8.421620e+00  4.439945e-01  1.424919e+01
    endloop
  endfacet
  facet normal  5.749170e-01 -9.323508e-06  8.182118e-01
    outer loop
      vertex  -4.773528e+00 -4.994781e+00  2.844591e+00
      vertex  -4.721087e+00 -5.036455e+00  2.807743e+00
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
    endloop
  endfacet
  facet normal  5.349870e-01 -8.298650e-01  1.584711e-01
    outer loop
      vertex   4.719419e+00 -5.032785e+00  2.806460e+00
      vertex   4.533190e+00 -5.176903e+00  2.680458e+00
      vertex   4.683790e+00 -5.116857e+00  2.486486e+00
    endloop
  endfacet
  facet normal  4.013690e-01 -3.132018e-01  8.607017e-01
    outer loop
      vertex   4.469616e+00 -8.842201e-01  1.805662e+01
      vertex   3.582416e+00 -1.189468e+00  1.835927e+01
      vertex   4.422585e+00 -1.189459e+00  1.796748e+01
    endloop
  endfacet
  facet normal -5.531647e-01  8.323369e-01 -3.498793e-02
    outer loop
      vertex  -7.246525e+00  3.142607e+00  3.411828e+00
      vertex  -7.419713e+00  3.056143e+00  4.093033e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
    endloop
  endfacet
  facet normal  8.241028e-01  4.106494e-01 -3.901559e-01
    outer loop
      vertex   6.294444e+00  2.906713e+00  5.747747e-01
      vertex   6.097925e+00  2.755002e+00  1.526557e-16
      vertex   5.917587e+00  3.116910e+00  3.781697e-16
    endloop
  endfacet
  facet normal -5.090849e-01 -2.804532e-03  8.607118e-01
    outer loop
      vertex  -4.491520e+00  4.443474e-01  1.809738e+01
      vertex  -5.301142e+00  6.875992e-04  1.761707e+01
      vertex  -4.490940e+00  6.666183e-04  1.809628e+01
    endloop
  endfacet
  facet normal -8.813934e-01  1.653961e-02 -4.720933e-01
    outer loop
      vertex  -7.565663e+00  1.035690e-03  1.591647e+00
      vertex  -7.751578e+00  5.112591e-01  1.956624e+00
      vertex  -7.556970e+00  4.972897e-01  1.592804e+00
    endloop
  endfacet
  facet normal  7.535824e-01  5.980313e-01 -2.728956e-01
    outer loop
      vertex   5.614513e+00  3.917742e+00  5.862894e-01
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
    endloop
  endfacet
  facet normal  5.122260e-01  8.417451e-01  1.705573e-01
    outer loop
      vertex   6.237039e+00  3.781313e+00  4.170912e+00
      vertex   6.413812e+00  3.631025e+00  4.381729e+00
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
    endloop
  endfacet
  facet normal  3.947411e-01  9.175267e-01 -4.821076e-02
    outer loop
      vertex   2.363800e+00  6.274577e+00  6.326923e-01
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
      vertex   2.359956e+00  6.242986e+00  5.134781e-16
    endloop
  endfacet
  facet normal  9.329542e-01  2.579420e-01 -2.511223e-01
    outer loop
      vertex   8.707416e+00  1.522598e+00  4.727156e+00
      vertex   8.906188e+00  1.486849e+00  5.428903e+00
      vertex   9.037666e+00  1.007128e+00  5.424614e+00
    endloop
  endfacet
  facet normal  9.772766e-01 -8.924221e-02 -1.922665e-01
    outer loop
      vertex   9.256927e+00 -4.945354e-01  6.135322e+00
      vertex   9.356856e+00 -9.520664e-01  6.855625e+00
      vertex   9.212836e+00 -9.801426e-01  6.136613e+00
    endloop
  endfacet
  facet normal  3.801721e-15 -5.495321e-15 -1.000000e+00
    outer loop
      vertex  -4.435853e+00 -4.987197e+00  9.714451e-17
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
      vertex  -4.409382e+00 -5.011184e+00  3.295975e-16
    endloop
  endfacet
  facet normal -7.948459e-01  3.122259e-03  6.068032e-01
    outer loop
      vertex  -7.364252e+00  7.486343e-04  1.578201e+01
      vertex  -7.924467e+00  7.686615e-04  1.504819e+01
      vertex  -7.925608e+00 -4.429359e-01  1.504898e+01
    endloop
  endfacet
  facet normal  5.839947e-01  8.054650e-01 -1.008776e-01
    outer loop
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
      vertex   3.794700e+00  5.487965e+00  3.504141e-16
    endloop
  endfacet
  facet normal  6.075438e-01  7.811596e-01 -1.438064e-01
    outer loop
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
      vertex   4.408831e+00  5.010327e+00 -1.422473e-16
      vertex   3.794700e+00  5.487965e+00  3.504141e-16
    endloop
  endfacet
  facet normal -2.602842e-01 -6.210459e-01  7.392930e-01
    outer loop
      vertex  -2.663391e+00 -1.470520e+00  1.851630e+01
      vertex  -3.465818e+00 -1.662179e+00  1.807279e+01
      vertex  -2.619959e+00 -1.662099e+00  1.837066e+01
    endloop
  endfacet
  facet normal  4.755474e-01 -7.610379e-01  4.412210e-01
    outer loop
      vertex   7.016542e+00 -1.661133e+00  1.548994e+01
      vertex   6.181915e+00 -1.948618e+00  1.589363e+01
      vertex   6.758233e+00 -1.948568e+00  1.527256e+01
    endloop
  endfacet
  facet normal -2.083561e-01  4.864788e-01  8.484846e-01
    outer loop
      vertex  -1.778435e+00  1.467911e+00  1.873570e+01
      vertex  -2.663953e+00  1.467962e+00  1.851822e+01
      vertex  -2.708452e+00  1.188644e+00  1.866744e+01
    endloop
  endfacet
  facet normal  1.026638e-01 -9.704926e-01  2.181840e-01
    outer loop
      vertex   3.934129e+00 -2.137462e+00  1.704169e+01
      vertex   3.131773e+00 -2.174252e+00  1.725559e+01
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
    endloop
  endfacet
  facet normal -3.542879e-16 -7.321586e-16 -1.000000e+00
    outer loop
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
      vertex  -4.621866e+00 -3.067342e+00 -5.204170e-17
      vertex  -4.303997e+00 -3.502633e+00  1.540434e-16
    endloop
  endfacet
  facet normal -9.451602e-01  3.156642e-01 -8.383588e-02
    outer loop
      vertex  -9.468263e+00  9.300938e-01  7.581403e+00
      vertex  -9.395976e+00  1.340061e+00  8.310084e+00
      vertex  -9.322186e+00  1.366940e+00  7.579379e+00
    endloop
  endfacet
  facet normal  4.934057e-01  8.670284e-01 -6.937359e-02
    outer loop
      vertex   3.811989e+00  5.552401e+00  6.145887e-01
      vertex   3.100696e+00  5.908006e+00  8.482798e-16
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
    endloop
  endfacet
  facet normal  2.874759e-01  9.571262e-01 -3.559756e-02
    outer loop
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
      vertex   2.363800e+00  6.274577e+00  6.326923e-01
      vertex   1.593122e+00  6.482521e+00  2.211772e-17
    endloop
  endfacet
  facet normal -8.784449e-01 -4.331687e-01 -2.017407e-01
    outer loop
      vertex  -8.504741e+00 -1.981583e+00  4.736046e+00
      vertex  -8.691193e+00 -1.928747e+00  5.434473e+00
      vertex  -8.907181e+00 -1.488121e+00  5.428863e+00
    endloop
  endfacet
  facet normal  7.419879e-01 -4.875263e-01  4.601869e-01
    outer loop
      vertex   8.292924e+00 -1.189396e+00  1.417792e+01
      vertex   7.804265e+00 -1.189407e+00  1.496580e+01
      vertex   7.675037e+00 -1.470186e+00  1.487670e+01
    endloop
  endfacet
  facet normal  1.219741e-14 -8.336137e-15 -1.000000e+00
    outer loop
      vertex   4.288389e+00  3.524311e+00 -2.220446e-16
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
      vertex   4.304089e+00  3.502916e+00  1.477984e-16
    endloop
  endfacet
  facet normal -2.577783e-01  4.115389e-04 -9.662040e-01
    outer loop
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
      vertex   2.357441e+00 -2.180988e+00  1.749155e+01
      vertex   1.967929e+00  2.181269e+00  1.759733e+01
    endloop
  endfacet
  facet normal  7.433195e-01  6.688201e-01 -1.247988e-02
    outer loop
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
      vertex  -3.919302e+00 -3.934127e+00 -6.195441e-18
      vertex  -4.288297e+00 -3.524029e+00  0.000000e+00
    endloop
  endfacet
  facet normal -7.805077e-01  4.893688e-01 -3.890062e-01
    outer loop
      vertex  -7.270958e+00  2.428316e+00  1.969450e+00
      vertex  -7.433151e+00  2.462477e+00  2.337850e+00
      vertex  -7.186638e+00  2.859190e+00  2.342308e+00
    endloop
  endfacet
  facet normal  9.838194e-01 -9.687489e-02 -1.507143e-01
    outer loop
      vertex   9.401635e+00 -4.805756e-01  6.855621e+00
      vertex   9.514075e+00 -4.690056e-01  7.582161e+00
      vertex   9.468694e+00 -9.287109e-01  7.581409e+00
    endloop
  endfacet
  facet normal  9.125434e-01 -4.085775e-01 -1.813944e-02
    outer loop
      vertex  -5.043293e+00  2.145937e+00  3.044073e+00
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
      vertex  -4.930842e+00  2.532238e+00 -4.510281e-16
    endloop
  endfacet
  facet normal -2.333178e-01  9.722586e-01  1.661092e-02
    outer loop
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
      vertex  -1.742376e+00  6.437355e+00  1.058181e-16
    endloop
  endfacet
  facet normal  8.100303e-02 -9.814562e-01  1.737303e-01
    outer loop
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
      vertex   3.131773e+00 -2.174252e+00  1.725559e+01
      vertex   3.118692e+00 -2.180992e+00  1.722361e+01
    endloop
  endfacet
  facet normal -5.706201e-02  9.979243e-01 -2.984985e-02
    outer loop
      vertex   5.279288e-04  6.695167e+00  6.465187e-01
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
    endloop
  endfacet
  facet normal -9.712461e-01  2.368877e-01 -2.377522e-02
    outer loop
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.334304e+00 -1.493209e+00 -2.359224e-16
      vertex   5.330669e+00 -1.508112e+00 -2.775558e-17
    endloop
  endfacet
  facet normal  8.530062e-01  2.169658e-01 -4.746643e-01
    outer loop
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
      vertex   6.509523e+00  1.583495e+00  1.110223e-16
      vertex   6.498588e+00  1.626487e+00 -5.898060e-16
    endloop
  endfacet
  facet normal  6.900189e-01  6.999339e-01 -1.842997e-01
    outer loop
      vertex   5.192330e+00  4.603491e+00  1.333755e+00
      vertex   5.777733e+00  4.019957e+00  1.309361e+00
      vertex   5.073212e+00  4.526468e+00  5.952616e-01
    endloop
  endfacet
  facet normal -4.923628e-01  8.671004e-01 -7.560433e-02
    outer loop
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
      vertex  -3.077820e+00  5.921855e+00  1.040834e-16
      vertex  -3.093479e+00  5.912963e+00  1.084202e-15
    endloop
  endfacet
  facet normal  6.341033e-01  7.705878e-01 -6.409001e-02
    outer loop
      vertex   6.929443e+00  3.401724e+00  3.434681e+00
      vertex   7.418854e+00  3.053747e+00  4.092981e+00
      vertex   7.245383e+00  3.139837e+00  3.411770e+00
    endloop
  endfacet
  facet normal -1.869956e-01  6.205533e-01  7.615420e-01
    outer loop
      vertex  -1.748968e+00  1.662848e+00  1.858409e+01
      vertex  -2.663953e+00  1.467962e+00  1.851822e+01
      vertex  -1.778435e+00  1.467911e+00  1.873570e+01
    endloop
  endfacet
  facet normal  3.989371e-01  9.046311e-01  1.499727e-01
    outer loop
      vertex   8.031503e+00  2.137777e+00  1.215875e+01
      vertex   7.741251e+00  2.137793e+00  1.293075e+01
      vertex   8.108811e+00  1.949369e+00  1.308958e+01
    endloop
  endfacet
  facet normal  9.358872e-01 -2.758335e-01 -2.191599e-01
    outer loop
      vertex   9.037848e+00 -1.008127e+00  5.424577e+00
      vertex   9.212836e+00 -9.801426e-01  6.136613e+00
      vertex   9.076302e+00 -1.444693e+00  6.138244e+00
    endloop
  endfacet
  facet normal  9.944860e-01  1.399283e-03 -1.048603e-01
    outer loop
      vertex   9.513846e+00  7.247925e-04  7.582238e+00
      vertex   9.591002e+00  7.381439e-04  8.313971e+00
      vertex   9.591638e+00 -4.604244e-01  8.313849e+00
    endloop
  endfacet
  facet normal -6.856734e-01 -8.455336e-04  7.279088e-01
    outer loop
      vertex   5.752617e+00 -4.180309e+00  3.658392e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
      vertex   5.576082e+00 -4.319799e+00  3.491938e+00
    endloop
  endfacet
  facet normal -2.082119e-01 -4.876153e-01  8.478674e-01
    outer loop
      vertex  -1.808037e+00 -1.189526e+00  1.888795e+01
      vertex  -2.708294e+00 -1.189535e+00  1.866687e+01
      vertex  -2.663391e+00 -1.470520e+00  1.851630e+01
    endloop
  endfacet
  facet normal -8.225034e-01  4.118713e-01 -3.922373e-01
    outer loop
      vertex  -6.296607e+00  2.910921e+00  5.748339e-01
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
      vertex  -6.098308e+00  2.759493e+00  4.718448e-16
    endloop
  endfacet
  facet normal  2.281178e-01  9.736317e-01  1.907237e-03
    outer loop
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
      vertex  -9.900771e-01 -5.485547e+00  1.251479e-16
      vertex  -1.511060e+00 -5.363482e+00 -3.249137e-16
    endloop
  endfacet
  facet normal -8.014359e-01  4.831206e-01 -3.525549e-01
    outer loop
      vertex  -6.296607e+00  2.910921e+00  5.748339e-01
      vertex  -6.087716e+00  3.260000e+00  5.783348e-01
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
    endloop
  endfacet
  facet normal  6.638640e-01  7.337576e-01 -1.445145e-01
    outer loop
      vertex   5.073212e+00  4.526468e+00  5.952616e-01
      vertex   4.435295e+00  4.986383e+00  9.055257e-16
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
    endloop
  endfacet
  facet normal  9.767736e-01  8.976524e-02 -1.945653e-01
    outer loop
      vertex   9.212695e+00  9.799118e-01  6.136631e+00
      vertex   9.401737e+00  4.812756e-01  6.855625e+00
      vertex   9.257026e+00  4.947186e-01  6.135334e+00
    endloop
  endfacet
  facet normal  2.190188e-01  9.757202e-01 -8.925755e-04
    outer loop
      vertex  -1.413179e+00 -5.389250e+00  1.446859e+00
      vertex  -9.513160e-01 -5.492985e+00  1.380087e+00
      vertex  -9.900771e-01 -5.485547e+00  1.251479e-16
    endloop
  endfacet
  facet normal -8.527532e-01  1.800849e-01 -4.902870e-01
    outer loop
      vertex  -6.890904e+00  1.322287e+00  5.645704e-01
      vertex  -6.510569e+00  1.586219e+00  4.579670e-16
      vertex  -6.591945e+00  1.200882e+00 -6.308086e-18
    endloop
  endfacet
  facet normal  8.384405e-01  4.591545e-01 -2.935890e-01
    outer loop
      vertex   7.574259e+00  2.473860e+00  2.692841e+00
      vertex   7.816690e+00  2.465845e+00  3.372647e+00
      vertex   8.047511e+00  2.034334e+00  3.356977e+00
    endloop
  endfacet
  facet normal -8.384761e-01  2.977438e-01 -4.564061e-01
    outer loop
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
      vertex  -6.257010e+00  2.387415e+00  1.463476e-16
      vertex  -6.387031e+00  2.021261e+00  3.261280e-16
    endloop
  endfacet
  facet normal  7.036301e-15  3.534101e-15 -1.000000e+00
    outer loop
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
      vertex  -3.890054e+00  3.963817e+00  1.595946e-16
      vertex  -3.914187e+00  3.940789e+00 -9.159340e-17
    endloop
  endfacet
  facet normal  1.125183e-15 -6.406609e-16 -1.000000e+00
    outer loop
      vertex   6.104056e+00 -2.746094e+00  1.457168e-15
      vertex   4.930933e+00 -2.531955e+00  0.000000e+00
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
    endloop
  endfacet
  facet normal  5.515502e-01 -8.174822e-01  1.658777e-01
    outer loop
      vertex   4.968148e+00 -4.831974e+00  2.986660e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
      vertex   5.159244e+00 -4.672935e+00  3.135036e+00
    endloop
  endfacet
  facet normal -3.616345e-01  9.049415e-01  2.242801e-01
    outer loop
      vertex  -6.941405e+00  2.138201e+00  1.437052e+01
      vertex  -7.375982e+00  2.138216e+00  1.366973e+01
      vertex  -7.725738e+00  1.950449e+00  1.386340e+01
    endloop
  endfacet
  facet normal -8.166973e-01  4.225223e-01 -3.930401e-01
    outer loop
      vertex  -6.296607e+00  2.910921e+00  5.748339e-01
      vertex  -6.098308e+00  2.759493e+00  4.718448e-16
      vertex  -6.484798e+00  2.544256e+00  5.717058e-01
    endloop
  endfacet
  facet normal  6.962641e-01  3.129802e-01  6.459563e-01
    outer loop
      vertex   7.252967e+00  1.188049e+00  1.568889e+01
      vertex   6.634518e+00  1.188099e+00  1.635548e+01
      vertex   6.704513e+00  8.849583e-01  1.642692e+01
    endloop
  endfacet
  facet normal  2.324701e-01  9.718338e-01  3.868672e-02
    outer loop
      vertex   8.245063e+00  2.137758e+00  1.136211e+01
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
    endloop
  endfacet
  facet normal -8.434867e-01  2.845284e-01 -4.556027e-01
    outer loop
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
      vertex  -6.400501e+00  1.981328e+00 -4.718448e-16
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
    endloop
  endfacet
  facet normal -1.015269e-01  9.048227e-01  4.135070e-01
    outer loop
      vertex  -1.608142e+00  2.138052e+00  1.785956e+01
      vertex  -2.523188e+00  1.950075e+00  1.804622e+01
      vertex  -1.684469e+00  1.950029e+00  1.825224e+01
    endloop
  endfacet
  facet normal  1.565628e-01  9.718450e-01  1.760835e-01
    outer loop
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
      vertex   5.185051e+00  2.180913e+00  1.600622e+01
      vertex   5.296712e+00  2.137880e+00  1.614445e+01
    endloop
  endfacet
  facet normal  3.758357e-02 -6.210094e-01  7.829015e-01
    outer loop
      vertex   8.928719e-01 -1.470419e+00  1.886201e+01
      vertex  -1.939251e-04 -1.470444e+00  1.890486e+01
      vertex  -1.906334e-04 -1.661858e+00  1.875303e+01
    endloop
  endfacet
  facet normal -9.293608e-02 -7.613325e-01  6.416664e-01
    outer loop
      vertex  -8.786781e-01 -1.661938e+00  1.871074e+01
      vertex  -1.749077e+00 -1.662018e+00  1.858458e+01
      vertex  -1.684684e+00 -1.949110e+00  1.825327e+01
    endloop
  endfacet
  facet normal -8.677191e-01  7.454986e-02 -4.914325e-01
    outer loop
      vertex  -6.999551e+00  4.475117e-01  5.618038e-01
      vertex  -6.650962e+00  8.014841e-01  8.326673e-16
      vertex  -6.686056e+00  3.930120e-01  5.273559e-16
    endloop
  endfacet
  facet normal  5.768855e-01  8.154722e-01  4.699310e-02
    outer loop
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   4.680184e+00  5.115396e+00  2.486569e+00
      vertex   5.369289e+00  4.630590e+00  2.439991e+00
    endloop
  endfacet
  facet normal -2.248792e-01 -9.707140e-01  8.452080e-02
    outer loop
      vertex  -7.879442e+00 -2.177027e+00  1.210961e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
      vertex  -7.740718e+00 -2.137720e+00  1.293013e+01
    endloop
  endfacet
  facet normal  8.028318e-01  4.827841e-01 -3.498295e-01
    outer loop
      vertex   6.086132e+00  3.255663e+00  5.782843e-01
      vertex   6.294444e+00  2.906713e+00  5.747747e-01
      vertex   5.917587e+00  3.116910e+00  3.781697e-16
    endloop
  endfacet
  facet normal -2.899299e-01 -4.876211e-01  8.235086e-01
    outer loop
      vertex  -2.708294e+00 -1.189535e+00  1.866687e+01
      vertex  -3.523293e+00 -1.470545e+00  1.821354e+01
      vertex  -2.663391e+00 -1.470520e+00  1.851630e+01
    endloop
  endfacet
  facet normal -9.908699e-01 -4.436224e-03 -1.347482e-01
    outer loop
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
      vertex   8.143600e+00 -2.181015e+00  1.093535e+01
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
    endloop
  endfacet
  facet normal -6.352375e-01  7.626913e-01 -1.215533e-01
    outer loop
      vertex  -7.546020e+00  2.839064e+00  3.391044e+00
      vertex  -7.743393e+00  2.783541e+00  4.074136e+00
      vertex  -7.419713e+00  3.056143e+00  4.093033e+00
    endloop
  endfacet
  facet normal -2.602696e-01 -6.210706e-01  7.392774e-01
    outer loop
      vertex  -2.663391e+00 -1.470520e+00  1.851630e+01
      vertex  -3.523293e+00 -1.470545e+00  1.821354e+01
      vertex  -3.465818e+00 -1.662179e+00  1.807279e+01
    endloop
  endfacet
  facet normal -7.904786e-01  1.047353e-01  6.034684e-01
    outer loop
      vertex  -7.329620e+00  8.853416e-01  1.575287e+01
      vertex  -7.887197e+00  8.853626e-01  1.502250e+01
      vertex  -7.925472e+00  4.444542e-01  1.504889e+01
    endloop
  endfacet
  facet normal -6.939051e-01 -4.877079e-01  5.297515e-01
    outer loop
      vertex  -7.252540e+00 -1.189594e+00  1.568800e+01
      vertex  -7.674814e+00 -1.470701e+00  1.487608e+01
      vertex  -7.132257e+00 -1.470675e+00  1.558679e+01
    endloop
  endfacet
  facet normal  9.419393e-01 -3.350511e-01 -2.215900e-02
    outer loop
      vertex  -5.043293e+00  2.145937e+00  3.044073e+00
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
    endloop
  endfacet
  facet normal  4.186257e-02 -4.876224e-01  8.720504e-01
    outer loop
      vertex   9.079207e-01 -1.189497e+00  1.901836e+01
      vertex  -1.970066e-04 -1.189507e+00  1.906195e+01
      vertex  -1.939251e-04 -1.470444e+00  1.890486e+01
    endloop
  endfacet
  facet normal -9.469846e-16 -7.323843e-17 -1.000000e+00
    outer loop
      vertex  -1.519182e+00  5.361024e+00 -2.671474e-17
      vertex  -1.742376e+00  6.437355e+00  1.058181e-16
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
    endloop
  endfacet
  facet normal  7.330915e-01 -2.948641e-03  6.801236e-01
    outer loop
      vertex   7.365042e+00  4.440365e-01  1.578322e+01
      vertex   6.737047e+00  4.440575e-01  1.646012e+01
      vertex   6.736129e+00  3.900528e-04  1.645918e+01
    endloop
  endfacet
  facet normal -6.086069e-01  7.798926e-01  1.461684e-01
    outer loop
      vertex  -6.094630e+00  4.048422e+00  2.751176e+00
      vertex  -5.527053e+00  4.360826e+00  3.447559e+00
      vertex  -5.427495e+00  4.560225e+00  2.798193e+00
    endloop
  endfacet
  facet normal -4.733737e-01  8.773014e-01  7.911795e-02
    outer loop
      vertex  -3.928066e+00  5.611322e+00  2.157428e+00
      vertex  -3.940862e+00  5.589209e+00  2.326075e+00
      vertex  -3.644764e+00  5.762789e+00  2.172923e+00
    endloop
  endfacet
  facet normal  8.008803e-01  5.986080e-01 -1.609990e-02
    outer loop
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
      vertex  -4.303997e+00 -3.502633e+00  1.540434e-16
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
    endloop
  endfacet
  facet normal  7.444214e-01 -6.676025e-01 -1.198128e-02
    outer loop
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -4.284296e+00  3.528093e+00  2.613650e-16
      vertex  -3.914187e+00  3.940789e+00 -9.159340e-17
    endloop
  endfacet
  facet normal -3.483161e-16  1.508572e-16 -1.000000e+00
    outer loop
      vertex   2.532637e+00  4.957038e+00 -2.247706e-16
      vertex   2.026891e+00  5.188045e+00 -1.376214e-17
      vertex   3.084982e+00  5.916950e+00 -2.723516e-16
    endloop
  endfacet
  facet normal  1.834800e-01 -9.825817e-01 -2.946724e-02
    outer loop
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   8.043078e-01 -6.628206e+00 -3.209238e-17
      vertex   1.427193e+00 -6.511893e+00 -2.001871e-15
    endloop
  endfacet
  facet normal -9.442562e-01  8.166033e-02 -3.189230e-01
    outer loop
      vertex  -8.638139e+00  5.261440e-01  4.017769e+00
      vertex  -8.874574e+00  5.192089e-01  4.716022e+00
      vertex  -8.831814e+00  1.030754e+00  4.720401e+00
    endloop
  endfacet
  facet normal -1.145661e-15 -7.635651e-15 -1.000000e+00
    outer loop
      vertex  -5.330578e+00  1.508395e+00  2.775558e-17
      vertex  -5.334213e+00  1.493491e+00  1.457168e-16
      vertex  -6.499778e+00  1.629298e+00  4.440892e-16
    endloop
  endfacet
  facet normal -5.781701e-02 -9.978215e-01 -3.177273e-02
    outer loop
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
      vertex  -8.018533e-01 -6.648617e+00  6.447229e-01
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
    endloop
  endfacet
  facet normal -7.813326e-01  5.605446e-01 -2.744251e-01
    outer loop
      vertex  -6.087716e+00  3.260000e+00  5.783348e-01
      vertex  -5.615840e+00  3.921659e+00  5.863419e-01
      vertex  -5.501915e+00  3.793403e+00  3.122502e-16
    endloop
  endfacet
  facet normal -6.064684e-01 -7.804859e-01 -1.517822e-01
    outer loop
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
      vertex  -4.409382e+00 -5.011184e+00  3.295975e-16
      vertex  -3.793262e+00 -5.489933e+00  6.765422e-16
    endloop
  endfacet
  facet normal  8.315991e-01  3.549886e-01 -4.271138e-01
    outer loop
      vertex   6.482162e+00  2.540468e+00  5.716410e-01
      vertex   6.646580e+00  2.151999e+00  5.688972e-01
      vertex   6.256312e+00  2.381761e+00 -4.475587e-16
    endloop
  endfacet
  facet normal -8.616714e-01  4.868143e-01  1.432982e-01
    outer loop
      vertex  -9.116395e+00  1.468527e+00  1.154942e+01
      vertex  -9.417916e+00  1.189226e+00  1.068517e+01
      vertex  -9.268758e+00  1.189178e+00  1.158224e+01
    endloop
  endfacet
  facet normal -7.523089e-16  7.372994e-16 -1.000000e+00
    outer loop
      vertex   2.026891e+00  5.188045e+00 -1.376214e-17
      vertex   2.359956e+00  6.242986e+00  5.134781e-16
      vertex   3.084982e+00  5.916950e+00 -2.723516e-16
    endloop
  endfacet
  facet normal  4.426062e-02  9.990191e-01 -1.333138e-03
    outer loop
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
      vertex  -3.863586e-01 -5.561952e+00  2.942091e-16
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
    endloop
  endfacet
  facet normal  7.548853e-01  3.129731e-01  5.763645e-01
    outer loop
      vertex   7.804801e+00  1.188002e+00  1.496616e+01
      vertex   7.252967e+00  1.188049e+00  1.568889e+01
      vertex   7.329475e+00  8.849373e-01  1.575328e+01
    endloop
  endfacet
  facet normal -7.654371e-01 -5.481322e-01 -3.371308e-01
    outer loop
      vertex  -5.620892e+00 -3.918224e+00  5.863695e-01
      vertex  -6.308788e+00 -3.388851e+00  1.287506e+00
      vertex  -6.092205e+00 -3.255135e+00  5.783606e-01
    endloop
  endfacet
  facet normal -5.304869e-01  8.476414e-01 -9.369207e-03
    outer loop
      vertex   3.102859e+00 -4.597506e+00  1.930064e+00
      vertex   3.029783e+00 -4.664573e+00 -2.392762e-16
      vertex   2.650582e+00 -4.882418e+00  1.761878e+00
    endloop
  endfacet
  facet normal -7.298786e-01 -6.508362e-01 -2.090204e-01
    outer loop
      vertex  -5.079527e+00 -4.528217e+00  5.953417e-01
      vertex  -5.620892e+00 -3.918224e+00  5.863695e-01
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
    endloop
  endfacet
  facet normal  7.033659e-01 -6.208119e-01  3.462212e-01
    outer loop
      vertex   8.558311e+00 -1.470133e+00  1.328384e+01
      vertex   8.155621e+00 -1.470160e+00  1.410187e+01
      vertex   8.023282e+00 -1.660970e+00  1.402858e+01
    endloop
  endfacet
  facet normal -7.823853e-02  9.718410e-01  2.222697e-01
    outer loop
      vertex  -2.408869e+00  2.138071e+00  1.766289e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
      vertex  -3.186596e+00  2.138090e+00  1.738905e+01
    endloop
  endfacet
  facet normal  3.716460e-01  9.062114e-01  2.016433e-01
    outer loop
      vertex   7.323770e+00  2.962626e+00  5.470797e+00
      vertex   7.275499e+00  2.936335e+00  5.677919e+00
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
    endloop
  endfacet
  facet normal  2.335706e-01 -9.721061e-01  2.131561e-02
    outer loop
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
      vertex   8.020302e-01 -6.647965e+00  6.447020e-01
      vertex   1.441300e+00 -6.508503e+00  1.031293e-15
    endloop
  endfacet
  facet normal  5.358414e-02 -9.985604e-01 -2.432023e-03
    outer loop
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
      vertex  -1.329709e-01  5.573674e+00 -2.687087e-16
      vertex  -6.933798e-02  5.577089e+00 -5.681219e-17
    endloop
  endfacet
  facet normal  3.930906e-01 -9.181806e-01 -4.923801e-02
    outer loop
      vertex   3.110520e+00 -5.953293e+00  6.240654e-01
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
      vertex   2.362674e+00 -6.239994e+00  7.228014e-18
    endloop
  endfacet
  facet normal  3.990222e-01 -6.209112e-01  6.747226e-01
    outer loop
      vertex   5.134046e+00 -1.470291e+00  1.736454e+01
      vertex   4.349310e+00 -1.470318e+00  1.782860e+01
      vertex   4.278577e+00 -1.661456e+00  1.769453e+01
    endloop
  endfacet
  facet normal -7.820747e-01  6.208465e-01  5.393307e-02
    outer loop
      vertex  -9.110337e+00  1.662560e+00  1.064925e+01
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
      vertex  -9.263100e+00  1.468576e+00  1.066709e+01
    endloop
  endfacet
  facet normal -7.331282e-01 -2.767039e-03  6.800848e-01
    outer loop
      vertex  -6.737250e+00  4.444122e-01  1.645972e+01
      vertex  -7.364252e+00  7.486343e-04  1.578201e+01
      vertex  -6.736389e+00  7.286072e-04  1.645885e+01
    endloop
  endfacet
  facet normal  6.736247e-16 -1.388369e-17 -1.000000e+00
    outer loop
      vertex   3.864515e-01  5.562234e+00 -1.209102e-16
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
    endloop
  endfacet
  facet normal  6.962173e-01 -3.131765e-01  6.459118e-01
    outer loop
      vertex   7.329536e+00 -8.843060e-01  1.575334e+01
      vertex   6.704575e+00 -8.842850e-01  1.642699e+01
      vertex   6.634067e+00 -1.189428e+00  1.635503e+01
    endloop
  endfacet
  facet normal  9.174138e-01  3.129461e-01  2.457978e-01
    outer loop
      vertex   9.269166e+00  1.187811e+00  1.158277e+01
      vertex   9.029185e+00  1.187859e+00  1.247841e+01
      vertex   9.124373e+00  8.848534e-01  1.250891e+01
    endloop
  endfacet
  facet normal -8.172115e-01 -4.877124e-01  3.070862e-01
    outer loop
      vertex  -8.878583e+00 -1.470785e+00  1.242973e+01
      vertex  -8.557884e+00 -1.470757e+00  1.328322e+01
      vertex  -8.702224e+00 -1.189629e+00  1.334559e+01
    endloop
  endfacet
  facet normal  3.017903e-01 -9.520383e-01 -5.045374e-02
    outer loop
      vertex   2.366262e+00 -6.272387e+00  6.326914e-01
      vertex   1.754346e+00 -6.432830e+00  1.721713e-15
      vertex   2.362674e+00 -6.239994e+00  7.228014e-18
    endloop
  endfacet
  facet normal -2.263525e-03 -9.988970e-01  4.690089e-02
    outer loop
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex  -3.959303e-01  2.181288e+00  1.782579e+01
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
    endloop
  endfacet
  facet normal  2.349906e-16 -3.586997e-16 -1.000000e+00
    outer loop
      vertex   6.687054e+00 -3.784631e-01  2.567391e-16
      vertex   5.520783e+00 -4.315945e-01  1.734723e-18
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
    endloop
  endfacet
  facet normal  8.970002e-01  1.859073e-01 -4.010350e-01
    outer loop
      vertex   7.794792e+00  1.537182e+00  2.326651e+00
      vertex   7.942900e+00  1.551197e+00  2.664423e+00
      vertex   8.043606e+00  1.044596e+00  2.654828e+00
    endloop
  endfacet
  facet normal -7.591408e-01 -5.527521e-01 -3.437591e-01
    outer loop
      vertex  -6.669674e+00 -3.125740e+00  1.631636e+00
      vertex  -6.789246e+00 -3.181795e+00  1.985826e+00
      vertex  -7.040504e+00 -2.829029e+00  1.973458e+00
    endloop
  endfacet
  facet normal  6.964686e-18 -1.005721e-17 -1.000000e+00
    outer loop
      vertex  -1.574733e+00  5.346050e+00  1.179612e-16
      vertex  -2.350985e+00  6.245869e+00  1.035052e-16
      vertex  -1.742376e+00  6.437355e+00  1.058181e-16
    endloop
  endfacet
  facet normal  7.820318e-01 -6.208961e-01  5.398454e-02
    outer loop
      vertex   9.261893e+00 -1.470047e+00  1.066743e+01
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
      vertex   9.323505e+00 -1.470018e+00  9.775237e+00
    endloop
  endfacet
  facet normal -2.114521e-01  9.718292e-01  1.040958e-01
    outer loop
      vertex  -7.221535e+00  2.180989e+00  1.358414e+01
      vertex  -7.578096e+00  2.180994e+00  1.285980e+01
      vertex  -7.740116e+00  2.138235e+00  1.292988e+01
    endloop
  endfacet
  facet normal -5.339149e-01 -8.454904e-01 -8.991092e-03
    outer loop
      vertex   2.702310e+00  4.853266e+00  1.779746e+00
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
      vertex   3.088440e+00  4.607893e+00  1.924301e+00
    endloop
  endfacet
  facet normal  8.615781e-01 -1.421614e-01 -4.873123e-01
    outer loop
      vertex   6.963712e+00 -8.787937e-01  5.629530e-01
      vertex   6.892925e+00 -1.313347e+00  5.645704e-01
      vertex   6.594516e+00 -1.186593e+00 -2.079145e-15
    endloop
  endfacet
  facet normal -5.839535e-01  8.046649e-01 -1.072967e-01
    outer loop
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
      vertex  -3.767807e+00  5.508892e+00 -1.734723e-16
      vertex  -3.788864e+00  5.493610e+00 -1.020017e-15
    endloop
  endfacet
  facet normal -9.289103e-01  2.211802e-01 -2.969933e-01
    outer loop
      vertex  -8.596299e+00  1.045643e+00  4.023285e+00
      vertex  -8.707513e+00  1.523714e+00  4.727165e+00
      vertex  -8.479411e+00  1.548126e+00  4.031908e+00
    endloop
  endfacet
  facet normal -3.922663e-01  9.182715e-01 -5.389411e-02
    outer loop
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
      vertex  -2.364403e+00  6.277273e+00  6.327410e-01
      vertex  -2.350985e+00  6.245869e+00  1.035052e-16
    endloop
  endfacet
  facet normal -6.328576e-16 -3.596813e-16 -1.000000e+00
    outer loop
      vertex  -1.011834e+00  5.481153e+00  3.025358e-16
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
      vertex  -5.741618e-01  5.547369e+00  1.734723e-18
    endloop
  endfacet
  facet normal  2.370778e-01 -9.706995e-01  3.919985e-02
    outer loop
      vertex   8.378459e+00 -2.137298e+00  1.056425e+01
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
      vertex   8.216428e+00 -2.177635e+00  1.054533e+01
    endloop
  endfacet
  facet normal -3.527965e-01  9.356799e-01 -6.143379e-03
    outer loop
      vertex   2.166294e+00 -5.123985e+00  1.614154e+00
      vertex   2.057736e+00 -5.175515e+00  6.071532e-17
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
    endloop
  endfacet
  facet normal -7.400168e-01 -6.724555e-01 -1.337216e-02
    outer loop
      vertex   3.842232e+00  3.974119e+00  2.273273e+00
      vertex   3.919394e+00  3.934411e+00 -5.451988e-17
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
    endloop
  endfacet
  facet normal  3.302276e-01 -1.044747e-01  9.381017e-01
    outer loop
      vertex   3.638051e+00 -4.432430e-01  1.849553e+01
      vertex   2.750051e+00 -4.432201e-01  1.880812e+01
      vertex   2.736798e+00 -8.841743e-01  1.876368e+01
    endloop
  endfacet
  facet normal  3.392244e-01 -9.043359e-01  2.590435e-01
    outer loop
      vertex   7.272491e+00 -1.948517e+00  1.459918e+01
      vertex   6.451702e+00 -2.137401e+00  1.501462e+01
      vertex   6.942640e+00 -2.137383e+00  1.437178e+01
    endloop
  endfacet
  facet normal  9.195638e-01  9.391688e-03 -3.928284e-01
    outer loop
      vertex   8.083388e+00  5.249405e-01  2.648714e+00
      vertex   8.373780e+00  5.278606e-01  3.328556e+00
      vertex   8.378257e+00 -9.479523e-04  3.326392e+00
    endloop
  endfacet
  facet normal -8.244081e-01 -3.495438e-01 -4.451634e-01
    outer loop
      vertex  -6.487278e+00 -2.538105e+00  5.717039e-01
      vertex  -6.961944e+00 -2.297348e+00  1.261705e+00
      vertex  -6.650954e+00 -2.148561e+00  5.689487e-01
    endloop
  endfacet
  facet normal -6.563016e-14  3.713877e-14 -1.000000e+00
    outer loop
      vertex  -2.532545e+00 -4.956754e+00 -6.938894e-17
      vertex  -3.081993e+00 -5.919403e+00  2.393918e-16
      vertex  -3.097691e+00 -5.910476e+00  1.601150e-15
    endloop
  endfacet
  facet normal -8.258640e-01 -5.638439e-01  5.363930e-03
    outer loop
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
      vertex  -9.432609e+00 -1.316837e+00  9.041911e+00
      vertex  -9.178523e+00 -1.689043e+00  9.037090e+00
    endloop
  endfacet
  facet normal -9.005393e-01 -4.342898e-01 -2.052487e-02
    outer loop
      vertex   5.020370e+00  2.202127e+00  3.026297e+00
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
      vertex   4.911027e+00  2.571886e+00  1.632953e-16
    endloop
  endfacet
  facet normal -9.880753e-01 -1.521470e-01 -2.363159e-02
    outer loop
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
      vertex   5.344658e+00  1.140909e+00  3.287793e+00
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
    endloop
  endfacet
  facet normal  6.328751e-01  7.703193e-01 -7.795641e-02
    outer loop
      vertex   6.733425e+00  3.490854e+00  2.724072e+00
      vertex   6.929443e+00  3.401724e+00  3.434681e+00
      vertex   7.245383e+00  3.139837e+00  3.411770e+00
    endloop
  endfacet
  facet normal -9.864520e-01 -2.701397e-03  1.640280e-01
    outer loop
      vertex  -9.412189e+00  4.445343e-01  1.161314e+01
      vertex  -9.562470e+00  8.621216e-04  1.070205e+01
      vertex  -9.411016e+00  8.449554e-04  1.161289e+01
    endloop
  endfacet
  facet normal -2.128747e-02 -5.527487e-04 -9.997733e-01
    outer loop
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
      vertex  -9.322685e+00 -1.470871e+00  9.774732e+00
      vertex  -9.479942e+00 -1.189680e+00  9.777925e+00
    endloop
  endfacet
  facet normal  3.760133e-02  6.204468e-01  7.833466e-01
    outer loop
      vertex   8.782997e-01  1.662560e+00  1.871046e+01
      vertex  -1.770278e-04  1.662657e+00  1.875255e+01
      vertex  -1.819546e-04  1.467806e+00  1.890688e+01
    endloop
  endfacet
  facet normal -2.475047e-16 -2.268355e-16 -1.000000e+00
    outer loop
      vertex  -3.077820e+00  5.921855e+00  1.040834e-16
      vertex  -2.057643e+00  5.175800e+00  2.081668e-17
      vertex  -2.553828e+00  4.945892e+00  1.957759e-16
    endloop
  endfacet
  facet normal -6.311568e-01  3.130282e-01  7.096861e-01
    outer loop
      vertex  -5.955170e+00  1.188843e+00  1.695925e+01
      vertex  -6.634596e+00  1.188892e+00  1.635498e+01
      vertex  -6.704711e+00  8.853207e-01  1.642652e+01
    endloop
  endfacet
  facet normal -8.061014e-01 -5.915459e-01 -1.654635e-02
    outer loop
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
      vertex   4.288389e+00  3.524311e+00 -2.220446e-16
      vertex   4.304089e+00  3.502916e+00  1.477984e-16
    endloop
  endfacet
  facet normal  5.555208e-01  8.314156e-01  1.203412e-02
    outer loop
      vertex   7.079278e+00  3.280336e+00  4.113910e+00
      vertex   7.572250e+00  2.941378e+00  4.775318e+00
      vertex   7.418854e+00  3.053747e+00  4.092981e+00
    endloop
  endfacet
  facet normal -7.143030e-16  8.048072e-17 -1.000000e+00
    outer loop
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
      vertex   6.256312e+00  2.381761e+00 -4.475587e-16
      vertex   6.385301e+00  2.017778e+00 -5.689893e-16
    endloop
  endfacet
  facet normal -4.607401e-01 -8.875006e-01 -7.822804e-03
    outer loop
      vertex   2.702310e+00  4.853266e+00  1.779746e+00
      vertex   2.293362e+00  5.066713e+00  1.649853e+00
      vertex   2.532637e+00  4.957038e+00 -2.247706e-16
    endloop
  endfacet
  facet normal  8.461478e-01  5.267848e-01 -8.081949e-02
    outer loop
      vertex   8.978265e+00  1.807442e+00  6.853908e+00
      vertex   9.078284e+00  1.757601e+00  7.576207e+00
      vertex   9.322192e+00  1.366310e+00  7.579377e+00
    endloop
  endfacet
  facet normal -6.635835e-01 -7.323155e-01 -1.528755e-01
    outer loop
      vertex  -5.079527e+00 -4.528217e+00  5.953417e-01
      vertex  -4.435853e+00 -4.987197e+00  9.714451e-17
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
    endloop
  endfacet
  facet normal -8.099567e-01  5.862947e-01 -1.512371e-02
    outer loop
      vertex   4.554976e+00 -3.087290e+00  2.694959e+00
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
      vertex   4.250867e+00 -3.512360e+00  2.503091e+00
    endloop
  endfacet
  facet normal -3.088540e-01  2.992611e-07 -9.511095e-01
    outer loop
      vertex   2.741358e+00  2.181265e+00  1.736688e+01
      vertex   2.741342e+00 -2.180990e+00  1.736688e+01
      vertex   2.357441e+00 -2.180988e+00  1.749155e+01
    endloop
  endfacet
  facet normal  2.472352e-14  2.132978e-14 -1.000000e+00
    outer loop
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
      vertex  -3.788864e+00  5.493610e+00 -1.020017e-15
      vertex  -3.767807e+00  5.508892e+00 -1.734723e-16
    endloop
  endfacet
  facet normal -2.830098e-01 -9.047707e-01  3.182693e-01
    outer loop
      vertex  -5.548426e+00 -1.949358e+00  1.645558e+01
      vertex  -6.181426e+00 -1.949408e+00  1.589257e+01
      vertex  -5.901175e+00 -2.137655e+00  1.560662e+01
    endloop
  endfacet
  facet normal -8.357306e-01  5.489691e-01 -1.368613e-02
    outer loop
      vertex  -9.395976e+00  1.340061e+00  8.310084e+00
      vertex  -9.178032e+00  1.689976e+00  9.037078e+00
      vertex  -9.146167e+00  1.720255e+00  8.305802e+00
    endloop
  endfacet
  facet normal -9.944226e-01 -1.856007e-04 -1.054689e-01
    outer loop
      vertex  -9.513741e+00  7.247925e-04  7.582239e+00
      vertex  -9.591422e+00  4.617844e-01  8.313846e+00
      vertex  -9.513821e+00  4.703484e-01  7.582159e+00
    endloop
  endfacet
  facet normal -2.264946e-01  3.130071e-01  9.223485e-01
    outer loop
      vertex  -1.808141e+00  1.188595e+00  1.888854e+01
      vertex  -2.737066e+00  8.852081e-01  1.876338e+01
      vertex  -1.827242e+00  8.851852e-01  1.898681e+01
    endloop
  endfacet
  facet normal -9.699699e-01  2.420872e-01 -2.349946e-02
    outer loop
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.353013e+00 -1.098413e+00  3.294899e+00
      vertex   5.335972e+00 -1.486529e+00  1.040834e-16
    endloop
  endfacet
  facet normal -8.721230e-01  2.199762e-02 -4.887920e-01
    outer loop
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
      vertex  -6.999551e+00  4.475117e-01  5.618038e-01
      vertex  -6.686056e+00  3.930120e-01  5.273559e-16
    endloop
  endfacet
  facet normal  9.447639e-01  8.179859e-02 -3.173804e-01
    outer loop
      vertex   8.596871e+00  1.044603e+00  4.023283e+00
      vertex   8.832343e+00  1.029762e+00  4.720400e+00
      vertex   8.875118e+00  5.187302e-01  4.716023e+00
    endloop
  endfacet
  facet normal  9.404358e-01  2.973574e-01 -1.648003e-01
    outer loop
      vertex   9.075440e+00  1.444485e+00  6.138266e+00
      vertex   9.214503e+00  1.401918e+00  6.855026e+00
      vertex   9.356750e+00  9.523754e-01  6.855629e+00
    endloop
  endfacet
  facet normal -9.890710e-01  1.454201e-01 -2.432286e-02
    outer loop
      vertex   5.432676e+00 -5.450840e-01  3.363666e+00
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
      vertex   5.353013e+00 -1.098413e+00  3.294899e+00
    endloop
  endfacet
  facet normal  5.942994e-01  8.004746e-01 -7.777227e-02
    outer loop
      vertex   4.596550e+00  5.160742e+00  1.738938e+00
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
      vertex   5.311325e+00  4.662725e+00  2.075060e+00
    endloop
  endfacet
  facet normal -5.834257e-01 -8.047997e-01 -1.091415e-01
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -3.793262e+00 -5.489933e+00  6.765422e-16
      vertex  -3.772143e+00 -5.505244e+00  4.857226e-17
    endloop
  endfacet
  facet normal -2.828317e-01  9.049067e-01  3.180409e-01
    outer loop
      vertex  -5.296445e+00  2.138147e+00  1.614360e+01
      vertex  -5.900717e+00  2.138166e+00  1.560617e+01
      vertex  -6.180614e+00  1.950312e+00  1.589176e+01
    endloop
  endfacet
  facet normal -7.649146e-01  6.418810e-01 -5.380030e-02
    outer loop
      vertex  -8.848840e+00  1.867825e+00  6.140260e+00
      vertex  -8.666344e+00  2.145002e+00  6.852547e+00
      vertex  -8.549037e+00  2.225302e+00  6.142756e+00
    endloop
  endfacet
  facet normal  9.568280e-01 -8.454800e-02 -2.780859e-01
    outer loop
      vertex   8.875030e+00 -5.201473e-01  4.715992e+00
      vertex   9.081166e+00 -5.084686e-01  5.421710e+00
      vertex   9.037848e+00 -1.008127e+00  5.424577e+00
    endloop
  endfacet
  facet normal -9.282129e-01  5.867448e-07 -3.720493e-01
    outer loop
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
      vertex   7.727498e+00 -2.181013e+00  1.248517e+01
      vertex   7.727502e+00  2.181219e+00  1.248517e+01
    endloop
  endfacet
  facet normal  6.962171e-01 -3.131500e-01  6.459249e-01
    outer loop
      vertex   7.329536e+00 -8.843060e-01  1.575334e+01
      vertex   6.634067e+00 -1.189428e+00  1.635503e+01
      vertex   7.252472e+00 -1.189419e+00  1.568848e+01
    endloop
  endfacet
  facet normal -2.137047e-15 -1.176141e-16 -1.000000e+00
    outer loop
      vertex   9.072288e-01  5.499919e+00  6.370290e-17
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
      vertex   9.901700e-01  5.485833e+00 -1.118897e-16
    endloop
  endfacet
  facet normal  6.351032e-01 -7.628545e-01 -1.212310e-01
    outer loop
      vertex   7.548003e+00 -2.840347e+00  3.390848e+00
      vertex   7.745208e+00 -2.784725e+00  4.073960e+00
      vertex   7.421623e+00 -3.057121e+00  4.092836e+00
    endloop
  endfacet
  facet normal -9.699610e-01  2.421228e-01 -2.349754e-02
    outer loop
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.335972e+00 -1.486529e+00  1.040834e-16
      vertex   5.334304e+00 -1.493209e+00 -2.359224e-16
    endloop
  endfacet
  facet normal  8.585306e-01  4.998234e-01 -1.144632e-01
    outer loop
      vertex   8.848385e+00  1.867100e+00  6.140252e+00
      vertex   8.978265e+00  1.807442e+00  6.853908e+00
      vertex   9.214503e+00  1.401918e+00  6.855026e+00
    endloop
  endfacet
  facet normal -7.884767e-01  5.145029e-01 -3.370329e-01
    outer loop
      vertex  -7.433151e+00  2.462477e+00  2.337850e+00
      vertex  -7.575926e+00  2.476240e+00  2.692879e+00
      vertex  -7.329176e+00  2.866369e+00  2.711174e+00
    endloop
  endfacet
  facet normal  2.830830e-01  9.047089e-01  3.183801e-01
    outer loop
      vertex   5.901123e+00  2.137865e+00  1.560709e+01
      vertex   5.296712e+00  2.137880e+00  1.614445e+01
      vertex   5.548191e+00  1.949602e+00  1.645586e+01
    endloop
  endfacet
  facet normal  6.929097e-01 -7.190985e-01 -5.266590e-02
    outer loop
      vertex   6.622387e+00 -3.512589e+00  2.356283e+00
      vertex   6.096882e+00 -4.047859e+00  2.750938e+00
      vertex   6.020991e+00 -4.094975e+00  2.395767e+00
    endloop
  endfacet
  facet normal  1.437423e-15  3.475896e-16 -1.000000e+00
    outer loop
      vertex   8.043078e-01 -6.628206e+00 -3.209238e-17
      vertex   1.330639e-01 -5.573392e+00 -6.303118e-16
      vertex   5.742548e-01 -5.547085e+00  1.301043e-17
    endloop
  endfacet
  facet normal -8.777637e-01  7.409310e-02 -4.733298e-01
    outer loop
      vertex  -7.556970e+00  4.972897e-01  1.592804e+00
      vertex  -7.710962e+00  1.017282e+00  1.959771e+00
      vertex  -7.516775e+00  9.891090e-01  1.595251e+00
    endloop
  endfacet
  facet normal  3.543003e-16 -3.416693e-16 -1.000000e+00
    outer loop
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
      vertex   1.330639e-01 -5.573392e+00 -6.303118e-16
      vertex   8.043078e-01 -6.628206e+00 -3.209238e-17
    endloop
  endfacet
  facet normal  8.174793e-01  5.755847e-01  2.073477e-02
    outer loop
      vertex   9.427593e+00  1.298067e+00  9.776810e+00
      vertex   9.432271e+00  1.317898e+00  9.041898e+00
      vertex   9.171400e+00  1.661978e+00  9.775407e+00
    endloop
  endfacet
  facet normal  9.712535e-01 -2.368571e-01 -2.377717e-02
    outer loop
      vertex  -5.221743e+00  1.634893e+00  3.185600e+00
      vertex  -5.334213e+00  1.493491e+00  1.457168e-16
      vertex  -5.330578e+00  1.508395e+00  2.775558e-17
    endloop
  endfacet
  facet normal -4.450745e-01 -8.939374e-01  5.277018e-02
    outer loop
      vertex  -8.429038e+00 -2.235327e+00  8.294219e+00
      vertex  -8.448242e+00 -2.182707e+00  9.023640e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
    endloop
  endfacet
  facet normal -4.447531e-01  4.865564e-01  7.519691e-01
    outer loop
      vertex  -4.350411e+00  1.468069e+00  1.782996e+01
      vertex  -5.135251e+00  1.468121e+00  1.736573e+01
      vertex  -5.221046e+00  1.188795e+00  1.749572e+01
    endloop
  endfacet
  facet normal -9.435465e-16 -7.862762e-16 -1.000000e+00
    outer loop
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
      vertex  -4.930842e+00  2.532238e+00 -4.510281e-16
      vertex  -6.098308e+00  2.759493e+00  4.718448e-16
    endloop
  endfacet
  facet normal  8.392648e-01 -6.357532e-07 -5.437230e-01
    outer loop
      vertex  -7.015535e+00  2.181345e+00  1.393137e+01
      vertex  -6.796014e+00  2.180985e+00  1.427022e+01
      vertex  -7.015543e+00 -2.180944e+00  1.393137e+01
    endloop
  endfacet
  facet normal -3.937230e-01 -9.176091e-01 -5.454974e-02
    outer loop
      vertex  -2.367681e+00 -6.277615e+00  6.327448e-01
      vertex  -3.111942e+00 -5.957758e+00  6.241255e-01
      vertex  -2.354590e+00 -6.245616e+00 -4.946853e-16
    endloop
  endfacet
  facet normal -6.799458e-02 -9.814900e-01  1.790365e-01
    outer loop
      vertex  -2.741698e+00 -2.180965e+00  1.736673e+01
      vertex  -3.132050e+00 -2.174236e+00  1.725537e+01
      vertex  -3.119041e+00 -2.180964e+00  1.722343e+01
    endloop
  endfacet
  facet normal  9.201353e-01  1.151245e-02 -3.914313e-01
    outer loop
      vertex   8.083388e+00  5.249405e-01  2.648714e+00
      vertex   8.378257e+00 -9.479523e-04  3.326392e+00
      vertex   8.089043e+00 -6.465912e-04  2.646547e+00
    endloop
  endfacet
  facet normal -4.834986e-01  3.130111e-01  8.174676e-01
    outer loop
      vertex  -4.423090e+00  1.188745e+00  1.796770e+01
      vertex  -5.221046e+00  1.188795e+00  1.749572e+01
      vertex  -5.276216e+00  8.852768e-01  1.757931e+01
    endloop
  endfacet
  facet normal  3.732705e-01  9.128793e-01  1.652893e-01
    outer loop
      vertex   7.323770e+00  2.962626e+00  5.470797e+00
      vertex   7.704113e+00  2.809126e+00  5.459638e+00
      vertex   7.211188e+00  3.131544e+00  4.792114e+00
    endloop
  endfacet
  facet normal  2.604750e-01  6.202065e-01  7.399301e-01
    outer loop
      vertex   3.465590e+00  1.662270e+00  1.807309e+01
      vertex   2.663707e+00  1.467648e+00  1.851851e+01
      vertex   3.523838e+00  1.467596e+00  1.821576e+01
    endloop
  endfacet
  facet normal -2.564722e-01  9.665405e-01 -4.615011e-03
    outer loop
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
      vertex   1.654704e+00 -5.317679e+00  1.492412e+00
      vertex   1.519274e+00 -5.360741e+00 -2.147588e-16
    endloop
  endfacet
  facet normal -2.492565e-01  9.659898e-01  6.880932e-02
    outer loop
      vertex  -8.236568e+00  2.238081e+00  9.019915e+00
      vertex  -8.203500e+00  2.272688e+00  8.653869e+00
      vertex  -8.446853e+00  2.183558e+00  9.023612e+00
    endloop
  endfacet
  facet normal  8.505466e-16  6.203041e-16 -1.000000e+00
    outer loop
      vertex   2.532637e+00  4.957038e+00 -2.247706e-16
      vertex   3.100696e+00  5.908006e+00  8.482798e-16
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
    endloop
  endfacet
  facet normal  9.804108e-01  4.390867e-04 -1.969632e-01
    outer loop
      vertex   9.257026e+00  4.947186e-01  6.135334e+00
      vertex   9.401737e+00  4.812756e-01  6.855625e+00
      vertex   9.401924e+00  6.008148e-04  6.855484e+00
    endloop
  endfacet
  facet normal -6.856585e-01  8.521682e-04  7.279229e-01
    outer loop
      vertex   5.575973e+00  4.315458e+00  3.491837e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
      vertex   5.752496e+00  4.176069e+00  3.658274e+00
    endloop
  endfacet
  facet normal -4.143745e-16 -2.689540e-16 -1.000000e+00
    outer loop
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
      vertex   5.137590e+00  2.076873e+00  9.801188e-17
      vertex   6.256312e+00  2.381761e+00 -4.475587e-16
    endloop
  endfacet
  facet normal -7.754448e-16  1.218367e-16 -1.000000e+00
    outer loop
      vertex  -2.532545e+00 -4.956754e+00 -6.938894e-17
      vertex  -2.026798e+00 -5.187760e+00 -4.897124e-16
      vertex  -3.081993e+00 -5.919403e+00  2.393918e-16
    endloop
  endfacet
  facet normal  1.251093e-01 -4.875924e-01  8.640609e-01
    outer loop
      vertex   1.807706e+00 -1.189487e+00  1.888808e+01
      vertex   8.928719e-01 -1.470419e+00  1.886201e+01
      vertex   1.777746e+00 -1.470394e+00  1.873390e+01
    endloop
  endfacet
  facet normal -9.368688e-01  3.130586e-01  1.557923e-01
    outer loop
      vertex  -9.268758e+00  1.189178e+00  1.158224e+01
      vertex  -9.417916e+00  1.189226e+00  1.068517e+01
      vertex  -9.517486e+00  8.854656e-01  1.069680e+01
    endloop
  endfacet
  facet normal  7.573031e-01 -6.207358e-01  2.029262e-01
    outer loop
      vertex   9.115124e+00 -1.470076e+00  1.154957e+01
      vertex   8.735147e+00 -1.660802e+00  1.238419e+01
      vertex   8.967391e+00 -1.660718e+00  1.151774e+01
    endloop
  endfacet
  facet normal  6.726648e-01  7.398810e-01 -9.908560e-03
    outer loop
      vertex  -3.842140e+00 -3.973835e+00  2.273273e+00
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
      vertex  -3.919302e+00 -3.934127e+00 -6.195441e-18
    endloop
  endfacet
  facet normal  9.659313e-01  2.846256e-03  2.587829e-01
    outer loop
      vertex   9.411002e+00  2.746582e-04  1.161333e+01
      vertex   9.168580e+00 -4.434319e-01  1.252308e+01
      vertex   9.412238e+00 -4.434509e-01  1.161360e+01
    endloop
  endfacet
  facet normal -6.631382e-01  7.331737e-01 -1.506791e-01
    outer loop
      vertex  -5.075042e+00  4.531092e+00  5.953255e-01
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
    endloop
  endfacet
  facet normal -8.950264e-01 -1.281428e-02 -4.458291e-01
    outer loop
      vertex  -7.759465e+00  2.861023e-04  1.955147e+00
      vertex  -7.752903e+00 -5.110149e-01  1.956669e+00
      vertex  -7.936165e+00 -2.708435e-04  2.309898e+00
    endloop
  endfacet
  facet normal -4.307355e-01 -7.614872e-01  4.843596e-01
    outer loop
      vertex  -5.760451e+00 -1.662422e+00  1.671812e+01
      vertex  -6.417627e+00 -1.662502e+00  1.613357e+01
      vertex  -6.181426e+00 -1.949408e+00  1.589257e+01
    endloop
  endfacet
  facet normal -5.834157e-01 -8.048069e-01 -1.091418e-01
    outer loop
      vertex  -3.817526e+00 -5.555700e+00  6.146612e-01
      vertex  -4.476315e+00 -5.076813e+00  6.049128e-01
      vertex  -3.793262e+00 -5.489933e+00  6.765422e-16
    endloop
  endfacet
  facet normal -2.281196e-01 -9.736313e-01  1.905460e-03
    outer loop
      vertex   1.413274e+00  5.389532e+00  1.446859e+00
      vertex   9.901700e-01  5.485833e+00 -1.118897e-16
      vertex   1.511153e+00  5.363768e+00 -6.869505e-17
    endloop
  endfacet
  facet normal  6.593110e-01  7.294052e-01 -1.824203e-01
    outer loop
      vertex   5.192330e+00  4.603491e+00  1.333755e+00
      vertex   5.073212e+00  4.526468e+00  5.952616e-01
      vertex   4.470068e+00  5.074046e+00  6.048336e-01
    endloop
  endfacet
  facet normal -4.690414e-16 -1.296162e-16 -1.000000e+00
    outer loop
      vertex  -6.686056e+00  3.930120e-01  5.273559e-16
      vertex  -5.520691e+00  4.318787e-01 -2.428613e-17
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
    endloop
  endfacet
  facet normal  8.639718e-01  5.032853e-01 -1.602074e-02
    outer loop
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
      vertex  -4.634246e+00 -3.046586e+00  9.436896e-17
      vertex  -4.910936e+00 -2.571602e+00  2.405483e-17
    endloop
  endfacet
  facet normal  5.139062e-01 -4.376397e-04  8.578463e-01
    outer loop
      vertex  -4.143497e+00  5.457701e+00  2.439818e+00
      vertex  -4.340185e+00  5.320688e+00  2.557577e+00
      vertex  -4.250774e+00  3.512644e+00  2.503092e+00
    endloop
  endfacet
  facet normal -4.242076e-01 -9.041728e-01  5.019489e-02
    outer loop
      vertex  -8.832759e+00 -1.949820e+00  9.764791e+00
      vertex  -8.842285e+00 -1.986095e+00  9.030837e+00
      vertex  -8.433034e+00 -2.137630e+00  9.759876e+00
    endloop
  endfacet
  facet normal -1.547051e-16 -1.240925e-16 -1.000000e+00
    outer loop
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
      vertex  -4.288297e+00 -3.524029e+00  0.000000e+00
      vertex  -3.919302e+00 -3.934127e+00 -6.195441e-18
    endloop
  endfacet
  facet normal -4.154749e-01 -9.096047e-01  2.113051e-04
    outer loop
      vertex   2.293362e+00  5.066713e+00  1.649853e+00
      vertex   2.026891e+00  5.188045e+00 -1.376214e-17
      vertex   2.532637e+00  4.957038e+00 -2.247706e-16
    endloop
  endfacet
  facet normal  7.533612e-01 -6.052259e-01 -2.571937e-01
    outer loop
      vertex   7.189068e+00 -2.859085e+00  2.342245e+00
      vertex   7.043986e+00 -3.198912e+00  2.716952e+00
      vertex   6.914867e+00 -3.202835e+00  2.347976e+00
    endloop
  endfacet
  facet normal  9.817344e-01 -3.044177e-07 -1.902565e-01
    outer loop
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
      vertex  -8.143588e+00  2.181360e+00  1.093485e+01
      vertex  -8.143590e+00 -2.180941e+00  1.093485e+01
    endloop
  endfacet
  facet normal -8.639721e-01 -5.032847e-01 -1.602021e-02
    outer loop
      vertex   4.787632e+00  2.692854e+00  2.854461e+00
      vertex   4.634337e+00  3.046870e+00 -1.228184e-16
      vertex   4.911027e+00  2.571886e+00  1.632953e-16
    endloop
  endfacet
  facet normal -8.972202e-01 -2.736824e-03  4.415750e-01
    outer loop
      vertex  -8.421647e+00  4.444752e-01  1.424875e+01
      vertex  -8.836282e+00  8.068085e-04  1.340352e+01
      vertex  -8.420585e+00  7.877350e-04  1.424816e+01
    endloop
  endfacet
  facet normal  5.680929e-01 -8.215453e-01 -4.831063e-02
    outer loop
      vertex   7.745208e+00 -2.784725e+00  4.073960e+00
      vertex   7.920142e+00 -2.704113e+00  4.760183e+00
      vertex   7.574584e+00 -2.943947e+00  4.775200e+00
    endloop
  endfacet
  facet normal  8.164369e-17 -1.381798e-16 -1.000000e+00
    outer loop
      vertex  -3.919302e+00 -3.934127e+00 -6.195441e-18
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
      vertex  -4.435853e+00 -4.987197e+00  9.714451e-17
    endloop
  endfacet
  facet normal  2.300722e-01 -9.583555e-01  1.691790e-01
    outer loop
      vertex   7.658683e+00 -2.654942e+00  6.497281e+00
      vertex   7.903616e+00 -2.533827e+00  6.850272e+00
      vertex   7.791418e+00 -2.560793e+00  6.850099e+00
    endloop
  endfacet
  facet normal  9.443468e-01 -8.110467e-02 -3.187963e-01
    outer loop
      vertex   8.638652e+00 -5.277958e-01  4.017734e+00
      vertex   8.875030e+00 -5.201473e-01  4.715992e+00
      vertex   8.832570e+00 -1.031635e+00  4.720345e+00
    endloop
  endfacet
  facet normal -2.276555e-01  9.718288e-01  6.100794e-02
    outer loop
      vertex  -8.243571e+00  2.138269e+00  1.136140e+01
      vertex  -8.030187e+00  2.138250e+00  1.215796e+01
      vertex  -7.862149e+00  2.180998e+00  1.210406e+01
    endloop
  endfacet
  facet normal -7.729958e-01  6.212484e-01  1.285615e-01
    outer loop
      vertex  -8.964732e+00  1.663997e+00  1.151674e+01
      vertex  -9.263100e+00  1.468576e+00  1.066709e+01
      vertex  -9.116395e+00  1.468527e+00  1.154942e+01
    endloop
  endfacet
  facet normal  1.911244e-01 -9.706563e-01  1.459369e-01
    outer loop
      vertex   6.942640e+00 -2.137383e+00  1.437178e+01
      vertex   6.451702e+00 -2.137401e+00  1.501462e+01
      vertex   6.328104e+00 -2.177372e+00  1.491063e+01
    endloop
  endfacet
  facet normal  3.823440e-01  9.046435e-01  1.882369e-01
    outer loop
      vertex   7.741251e+00  2.137793e+00  1.293075e+01
      vertex   7.376937e+00  2.137812e+00  1.367065e+01
      vertex   7.727200e+00  1.949415e+00  1.386461e+01
    endloop
  endfacet
  facet normal -9.450448e-01 -3.263457e-01 -1.972368e-02
    outer loop
      vertex   5.207137e+00  1.683670e+00  3.173629e+00
      vertex   5.137590e+00  2.076873e+00  9.801188e-17
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
    endloop
  endfacet
  facet normal  7.932814e-01  4.773654e-01 -3.779245e-01
    outer loop
      vertex   6.542725e+00  3.050726e+00  1.277834e+00
      vertex   6.294444e+00  2.906713e+00  5.747747e-01
      vertex   6.086132e+00  3.255663e+00  5.782843e-01
    endloop
  endfacet
  facet normal -8.526574e-01 -2.144083e-01 -4.764499e-01
    outer loop
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
      vertex  -6.893128e+00 -1.314762e+00  5.645828e-01
      vertex  -6.512477e+00 -1.573938e+00 -2.775558e-16
    endloop
  endfacet
  facet normal  8.614238e-01 -5.075680e-01 -1.799467e-02
    outer loop
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
      vertex  -4.642149e+00  3.035010e+00  2.037722e-16
    endloop
  endfacet
  facet normal -9.979934e-01 -5.887777e-02 -2.329564e-02
    outer loop
      vertex   5.429294e+00  5.799408e-01  3.360712e+00
      vertex   5.507741e+00  5.799408e-01  7.632783e-17
      vertex   5.536693e+00  8.920296e-02 -1.813364e-16
    endloop
  endfacet
  facet normal  9.976265e-01 -2.940935e-03  6.879461e-02
    outer loop
      vertex   9.563832e+00  4.439163e-01  1.070271e+01
      vertex   9.626081e+00  3.869430e-04  9.781058e+00
      vertex   9.627390e+00  4.457207e-01  9.781108e+00
    endloop
  endfacet
  facet normal  1.414156e-01  9.047511e-01  4.017799e-01
    outer loop
      vertex   3.186519e+00  2.137938e+00  1.738959e+01
      vertex   2.408713e+00  2.137957e+00  1.766331e+01
      vertex   2.523059e+00  1.949789e+00  1.804679e+01
    endloop
  endfacet
  facet normal -8.548679e-01 -2.722169e-01 -4.416998e-01
    outer loop
      vertex  -7.468137e+00 -1.986961e+00  1.966080e+00
      vertex  -7.796678e+00 -1.540154e+00  2.326575e+00
      vertex  -7.617569e+00 -1.512686e+00  1.962998e+00
    endloop
  endfacet
  facet normal  5.051383e-01  8.630357e-01 -2.163309e-03
    outer loop
      vertex  -2.702217e+00 -4.852983e+00  1.779746e+00
      vertex  -2.532545e+00 -4.956754e+00 -6.938894e-17
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
    endloop
  endfacet
  facet normal -6.704487e-01  7.419066e-01 -8.549179e-03
    outer loop
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
      vertex   3.890146e+00 -3.963536e+00 -1.120631e-15
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
    endloop
  endfacet
  facet normal -4.111020e-01 -9.049081e-01  1.101657e-01
    outer loop
      vertex  -8.412040e+00 -1.949663e+00  1.228027e+01
      vertex  -8.635535e+00 -1.949717e+00  1.144582e+01
      vertex  -8.244216e+00 -2.137755e+00  1.136154e+01
    endloop
  endfacet
  facet normal  9.921681e-01 -1.044798e-01  6.845867e-02
    outer loop
      vertex   9.563747e+00 -4.434700e-01  1.070270e+01
      vertex   9.517684e+00 -8.844261e-01  1.069732e+01
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
    endloop
  endfacet
  facet normal  4.102396e-16 -3.633908e-16 -1.000000e+00
    outer loop
      vertex   4.911027e+00  2.571886e+00  1.632953e-16
      vertex   4.634337e+00  3.046870e+00 -1.228184e-16
      vertex   5.917587e+00  3.116910e+00  3.781697e-16
    endloop
  endfacet
  facet normal -1.546211e-01 -7.613217e-01  6.296679e-01
    outer loop
      vertex  -1.749077e+00 -1.662018e+00  1.858458e+01
      vertex  -2.523508e+00 -1.949160e+00  1.804723e+01
      vertex  -1.684684e+00 -1.949110e+00  1.825327e+01
    endloop
  endfacet
  facet normal  8.093209e-15  1.725297e-14 -1.000000e+00
    outer loop
      vertex  -6.400501e+00  1.981328e+00 -4.718448e-16
      vertex  -6.387031e+00  2.021261e+00  3.261280e-16
      vertex  -5.330578e+00  1.508395e+00  2.775558e-17
    endloop
  endfacet
  facet normal -8.655090e-01 -1.566105e-01 -4.757808e-01
    outer loop
      vertex  -7.250942e+00 -1.419529e+00  1.249917e+00
      vertex  -7.518944e+00 -9.877434e-01  1.595321e+00
      vertex  -7.333118e+00 -9.526539e-01  1.245728e+00
    endloop
  endfacet
  facet normal -1.414821e-01 -9.046675e-01  4.019447e-01
    outer loop
      vertex  -2.523508e+00 -1.949160e+00  1.804723e+01
      vertex  -3.338233e+00 -1.949209e+00  1.776034e+01
      vertex  -3.186847e+00 -2.137594e+00  1.738963e+01
    endloop
  endfacet
  facet normal -2.722750e-15 -1.705474e-17 -1.000000e+00
    outer loop
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
      vertex   6.513909e+00 -1.572044e+00 -3.101686e-15
      vertex   5.335972e+00 -1.486529e+00  1.040834e-16
    endloop
  endfacet
  facet normal  4.834223e-01 -3.131865e-01  8.174455e-01
    outer loop
      vertex   5.276037e+00 -8.842430e-01  1.757970e+01
      vertex   4.422585e+00 -1.189459e+00  1.796748e+01
      vertex   5.220532e+00 -1.189449e+00  1.749559e+01
    endloop
  endfacet
  facet normal -2.398301e-01  9.708148e-01  4.210261e-04
    outer loop
      vertex   1.120664e+00 -5.459822e+00  1.401345e+00
      vertex   1.519274e+00 -5.360741e+00 -2.147588e-16
      vertex   1.072319e+00 -5.471157e+00  1.188286e-16
    endloop
  endfacet
  facet normal  6.030007e-01  7.976931e-01 -8.709393e-03
    outer loop
      vertex  -3.088347e+00 -4.607609e+00  1.924301e+00
      vertex  -3.486286e+00 -4.327804e+00  8.355585e-17
      vertex  -3.450266e+00 -4.332319e+00  2.080311e+00
    endloop
  endfacet
  facet normal -9.935446e-01 -1.009268e-01 -5.179609e-02
    outer loop
      vertex  -9.591765e+00 -4.601555e-01  8.313853e+00
      vertex  -9.545940e+00 -9.107361e-01  8.312819e+00
      vertex  -9.630630e+00 -4.532566e-01  9.045915e+00
    endloop
  endfacet
  facet normal -6.451265e-01  7.626740e-01  4.626283e-02
    outer loop
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
      vertex  -9.169055e+00  1.664450e+00  9.776033e+00
      vertex  -8.831487e+00  1.950674e+00  9.764766e+00
    endloop
  endfacet
  facet normal  6.131388e-02 -1.481646e-02 -9.980086e-01
    outer loop
      vertex   9.427947e+00 -1.297487e+00  9.776816e+00
      vertex   9.580970e+00 -8.844510e-01  9.780086e+00
      vertex   9.480363e+00 -1.189333e+00  9.778431e+00
    endloop
  endfacet
  facet normal -4.701743e-01  8.822708e-01 -2.311743e-02
    outer loop
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
      vertex  -3.644764e+00  5.762789e+00  2.172923e+00
      vertex  -3.411066e+00  5.884436e+00  2.062481e+00
    endloop
  endfacet
  facet normal  7.400159e-01  6.724564e-01 -1.337241e-02
    outer loop
      vertex  -4.196729e+00 -3.579691e+00  2.470920e+00
      vertex  -3.842140e+00 -3.973835e+00  2.273273e+00
      vertex  -3.919302e+00 -3.934127e+00 -6.195441e-18
    endloop
  endfacet
  facet normal  8.071399e-01  3.129535e-01  5.005850e-01
    outer loop
      vertex   8.293495e+00  1.187954e+00  1.417823e+01
      vertex   7.804801e+00  1.188002e+00  1.496616e+01
      vertex   7.887117e+00  8.849163e-01  1.502292e+01
    endloop
  endfacet
  facet normal  8.922965e-01 -1.044748e-01  4.391947e-01
    outer loop
      vertex   8.837360e+00 -4.434109e-01  1.340443e+01
      vertex   8.421578e+00 -4.433918e-01  1.424917e+01
      vertex   8.381008e+00 -8.843479e-01  1.422670e+01
    endloop
  endfacet
  facet normal -2.903918e-01 -2.999813e-03  9.569031e-01
    outer loop
      vertex   2.394752e+00 -6.291546e+00  1.679824e+00
      vertex   2.650582e+00 -4.882418e+00  1.761878e+00
      vertex   2.166294e+00 -5.123985e+00  1.614154e+00
    endloop
  endfacet
  facet normal -9.989877e-01 -0.000000e+00 -4.498411e-02
    outer loop
      vertex   8.235993e+00  2.181208e+00  1.014908e+01
      vertex   8.253806e+00  9.536743e-05  9.753502e+00
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
    endloop
  endfacet
  facet normal -1.501918e-16 -2.933580e-16 -1.000000e+00
    outer loop
      vertex   3.864515e-01  5.562234e+00 -1.209102e-16
      vertex  -6.933798e-02  5.577089e+00 -5.681219e-17
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
    endloop
  endfacet
  facet normal -9.944597e-01 -1.049678e-01  5.610166e-03
    outer loop
      vertex  -9.630630e+00 -4.532566e-01  9.045915e+00
      vertex  -9.581048e+00 -8.837691e-01  9.779908e+00
      vertex  -9.627370e+00 -4.448690e-01  9.780826e+00
    endloop
  endfacet
  facet normal  9.368953e-01  3.129527e-01  1.558460e-01
    outer loop
      vertex   9.269166e+00  1.187811e+00  1.158277e+01
      vertex   9.366868e+00  8.848324e-01  1.160382e+01
      vertex   9.418399e+00  1.187765e+00  1.068572e+01
    endloop
  endfacet
  facet normal  1.546190e-01 -7.611887e-01  6.298291e-01
    outer loop
      vertex   2.619772e+00 -1.661618e+00  1.837120e+01
      vertex   1.684419e+00 -1.948915e+00  1.825361e+01
      vertex   2.523320e+00 -1.948866e+00  1.804772e+01
    endloop
  endfacet
  facet normal  3.505770e-01  4.380421e-04 -9.365338e-01
    outer loop
      vertex  -2.741681e+00  2.181307e+00  1.736673e+01
      vertex  -3.119041e+00 -2.180964e+00  1.722343e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
    endloop
  endfacet
  facet normal -8.860965e-01  4.419933e-04 -4.635004e-01
    outer loop
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   7.406844e+00 -2.181011e+00  1.322591e+01
      vertex   7.219731e+00 -2.181011e+00  1.358362e+01
    endloop
  endfacet
  facet normal -6.093665e-15 -1.248159e-14 -1.000000e+00
    outer loop
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
      vertex   5.330669e+00 -1.508112e+00 -2.775558e-17
      vertex   5.334304e+00 -1.493209e+00 -2.359224e-16
    endloop
  endfacet
  facet normal  7.742255e-01  6.196602e-01  1.288262e-01
    outer loop
      vertex   8.967095e+00  1.661316e+00  1.151767e+01
      vertex   9.117169e+00  1.467085e+00  1.155001e+01
      vertex   9.111658e+00  1.661106e+00  1.064988e+01
    endloop
  endfacet
  facet normal  7.438534e-01 -6.469766e-01 -1.676402e-01
    outer loop
      vertex   7.331333e+00 -2.866991e+00  2.710981e+00
      vertex   7.248614e+00 -3.143639e+00  3.411612e+00
      vertex   7.043986e+00 -3.198912e+00  2.716952e+00
    endloop
  endfacet
  facet normal  1.016862e-01 -9.045273e-01  4.141139e-01
    outer loop
      vertex   2.523320e+00 -1.948866e+00  1.804772e+01
      vertex   1.684419e+00 -1.948915e+00  1.825361e+01
      vertex   1.608019e+00 -2.137506e+00  1.786044e+01
    endloop
  endfacet
  facet normal -3.663252e-15 -6.923797e-15 -1.000000e+00
    outer loop
      vertex   6.104056e+00 -2.746094e+00  1.457168e-15
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
      vertex   6.261974e+00 -2.373744e+00 -1.699398e-15
    endloop
  endfacet
  facet normal  9.360725e-01 -2.996488e-03  3.517945e-01
    outer loop
      vertex   9.168643e+00  4.439545e-01  1.252310e+01
      vertex   8.837411e+00  4.439754e-01  1.340445e+01
      vertex   8.836189e+00  3.118515e-04  1.340393e+01
    endloop
  endfacet
  facet normal -5.560590e-01 -8.310322e-01  1.356068e-02
    outer loop
      vertex  -7.082557e+00 -3.285522e+00  4.113823e+00
      vertex  -7.574894e+00 -2.945297e+00  4.775242e+00
      vertex  -7.421945e+00 -3.058773e+00  4.092888e+00
    endloop
  endfacet
  facet normal  9.606479e-01 -1.044688e-01  2.573750e-01
    outer loop
      vertex   9.412238e+00 -4.434509e-01  1.161360e+01
      vertex   9.124413e+00 -8.843880e-01  1.250893e+01
      vertex   9.366902e+00 -8.844090e-01  1.160383e+01
    endloop
  endfacet
  facet normal -9.055777e-01  4.236938e-01 -2.031498e-02
    outer loop
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   5.043385e+00 -2.145653e+00  3.044071e+00
      vertex   4.930933e+00 -2.531955e+00  0.000000e+00
    endloop
  endfacet
  facet normal  7.013478e-01  6.799057e-01 -2.141016e-01
    outer loop
      vertex   5.858973e+00  4.072660e+00  1.673073e+00
      vertex   5.938993e+00  4.104437e+00  2.036110e+00
      vertex   6.515748e+00  3.498491e+00  2.001171e+00
    endloop
  endfacet
  facet normal  4.091516e-01  9.098536e-01 -6.900368e-02
    outer loop
      vertex   3.106787e+00  5.954473e+00  6.240587e-01
      vertex   3.084982e+00  5.916950e+00 -2.723516e-16
      vertex   2.359956e+00  6.242986e+00  5.134781e-16
    endloop
  endfacet
  facet normal  2.888720e-02 -1.151330e-07 -9.995828e-01
    outer loop
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex  -3.959477e-01 -2.180975e+00  1.782579e+01
      vertex  -3.959303e-01  2.181288e+00  1.782579e+01
    endloop
  endfacet
  facet normal -4.708975e-15 -6.701006e-15 -1.000000e+00
    outer loop
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
      vertex  -4.404419e+00  5.015305e+00 -2.983724e-16
    endloop
  endfacet
  facet normal -4.238506e-01  9.043341e-01  5.030390e-02
    outer loop
      vertex  -8.841281e+00  1.986910e+00  9.030815e+00
      vertex  -8.831487e+00  1.950674e+00  9.764766e+00
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
    endloop
  endfacet
  facet normal  1.674361e-01  9.858828e-01  6.109485e-04
    outer loop
      vertex  -9.513160e-01 -5.492985e+00  1.380087e+00
      vertex  -9.071357e-01 -5.499633e+00 -4.550758e-16
      vertex  -9.900771e-01 -5.485547e+00  1.251479e-16
    endloop
  endfacet
  facet normal  5.339176e-01  8.454887e-01 -8.992232e-03
    outer loop
      vertex  -3.088347e+00 -4.607609e+00  1.924301e+00
      vertex  -2.702217e+00 -4.852983e+00  1.779746e+00
      vertex  -3.015460e+00 -4.674102e+00  5.551115e-17
    endloop
  endfacet
  facet normal  3.315630e-01  6.201420e-01  7.109781e-01
    outer loop
      vertex   4.278395e+00  1.662172e+00  1.769416e+01
      vertex   3.523838e+00  1.467596e+00  1.821576e+01
      vertex   4.350276e+00  1.467543e+00  1.783040e+01
    endloop
  endfacet
  facet normal  2.081628e-01 -4.875801e-01  8.478997e-01
    outer loop
      vertex   2.707990e+00 -1.189478e+00  1.866706e+01
      vertex   1.807706e+00 -1.189487e+00  1.888808e+01
      vertex   1.777746e+00 -1.470394e+00  1.873390e+01
    endloop
  endfacet
  facet normal  1.741477e-01  9.842726e-01 -2.966514e-02
    outer loop
      vertex   8.009114e-01  6.646766e+00  6.447020e-01
      vertex   1.592028e+00  6.506646e+00  6.398239e-01
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
    endloop
  endfacet
  facet normal  8.520878e-01 -3.131156e-01  4.194101e-01
    outer loop
      vertex   8.794788e+00 -8.843689e-01  1.338603e+01
      vertex   8.381008e+00 -8.843479e-01  1.422670e+01
      vertex   8.292924e+00 -1.189396e+00  1.417792e+01
    endloop
  endfacet
  facet normal  8.535744e-01 -2.129495e-01 -4.754612e-01
    outer loop
      vertex   6.788228e+00 -1.737507e+00  5.665798e-01
      vertex   6.503150e+00 -1.615171e+00  2.157996e-15
      vertex   6.513909e+00 -1.572044e+00 -3.101686e-15
    endloop
  endfacet
  facet normal -9.077655e-01  1.858411e-01 -3.760650e-01
    outer loop
      vertex  -8.042939e+00  1.045719e+00  2.654829e+00
      vertex  -8.223594e+00  1.558374e+00  3.344243e+00
      vertex  -7.943122e+00  1.552727e+00  2.664435e+00
    endloop
  endfacet
  facet normal -7.336009e-01  6.211556e-01  2.756730e-01
    outer loop
      vertex  -8.417369e+00  1.663807e+00  1.322250e+01
      vertex  -8.732751e+00  1.663901e+00  1.238302e+01
      vertex  -8.880441e+00  1.468477e+00  1.243033e+01
    endloop
  endfacet
  facet normal  7.330961e-01  2.916103e-03  6.801189e-01
    outer loop
      vertex   7.364036e+00  3.700256e-04  1.578237e+01
      vertex   6.736129e+00  3.900528e-04  1.645918e+01
      vertex   6.737034e+00 -4.433289e-01  1.646011e+01
    endloop
  endfacet
  facet normal -5.100642e-01  8.590288e-01  4.363243e-02
    outer loop
      vertex  -8.755844e+00  2.077982e+00  7.572240e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
      vertex  -8.377645e+00  2.302767e+00  7.567872e+00
    endloop
  endfacet
  facet normal -3.275024e-16 -3.747007e-16 -1.000000e+00
    outer loop
      vertex  -6.387031e+00  2.021261e+00  3.261280e-16
      vertex  -6.257010e+00  2.387415e+00  1.463476e-16
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
    endloop
  endfacet
  facet normal -4.800053e-02  3.023951e-03  9.988427e-01
    outer loop
      vertex  -1.960567e-04  5.588531e-04  1.920786e+01
      vertex  -9.222730e-01  5.807877e-04  1.916355e+01
      vertex  -9.224034e-01 -4.431305e-01  1.916488e+01
    endloop
  endfacet
  facet normal  4.923535e-01 -4.040565e-03 -8.703859e-01
    outer loop
      vertex  -4.202793e+00  2.181318e+00  1.668542e+01
      vertex  -3.851411e+00  2.180926e+00  1.688419e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
    endloop
  endfacet
  facet normal -5.279975e-02  9.986023e-01 -2.353093e-03
    outer loop
      vertex   4.720717e-05 -5.577303e+00  1.324935e+00
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
      vertex   1.330639e-01 -5.573392e+00 -6.303118e-16
    endloop
  endfacet
  facet normal -7.062629e-01 -6.707400e-01 -2.264962e-01
    outer loop
      vertex  -6.520677e+00 -3.503586e+00  2.001183e+00
      vertex  -6.623233e+00 -3.515539e+00  2.356373e+00
      vertex  -6.915232e+00 -3.205269e+00  2.348061e+00
    endloop
  endfacet
  facet normal  3.123776e-01  9.046701e-01  2.898143e-01
    outer loop
      vertex   6.451268e+00  2.137846e+00  1.501424e+01
      vertex   6.181304e+00  1.949553e+00  1.589299e+01
      vertex   6.757576e+00  1.949507e+00  1.527199e+01
    endloop
  endfacet
  facet normal  6.905249e-01 -6.932587e-01 -2.063194e-01
    outer loop
      vertex   5.078556e+00 -4.523216e+00  5.952883e-01
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
    endloop
  endfacet
  facet normal -8.581551e-01  2.437027e-01 -4.518615e-01
    outer loop
      vertex  -7.248943e+00  1.422327e+00  1.249935e+00
      vertex  -7.288819e+00  1.934694e+00  1.602000e+00
      vertex  -7.123807e+00  1.872915e+00  1.255299e+00
    endloop
  endfacet
  facet normal  6.902771e-01 -7.233956e-01 -1.471093e-02
    outer loop
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
      vertex  -3.914187e+00  3.940789e+00 -9.159340e-17
      vertex  -3.890054e+00  3.963817e+00  1.595946e-16
    endloop
  endfacet
  facet normal -5.952178e-02  9.982271e-01 -1.580922e-04
    outer loop
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
      vertex   5.742548e-01 -5.547085e+00  1.301043e-17
      vertex   1.330639e-01 -5.573392e+00 -6.303118e-16
    endloop
  endfacet
  facet normal  8.703536e-01 -1.563060e-01 -4.669615e-01
    outer loop
      vertex   7.332275e+00 -9.518204e-01  1.245701e+00
      vertex   7.428255e+00 -1.468988e+00  1.597705e+00
      vertex   7.250757e+00 -1.418285e+00  1.249901e+00
    endloop
  endfacet
  facet normal  5.602781e-01 -3.131743e-01  7.668182e-01
    outer loop
      vertex   6.017940e+00 -8.842640e-01  1.703760e+01
      vertex   5.220532e+00 -1.189449e+00  1.749559e+01
      vertex   5.954641e+00 -1.189440e+00  1.695921e+01
    endloop
  endfacet
  facet normal  5.930953e-16  6.217525e-16 -1.000000e+00
    outer loop
      vertex   3.919394e+00  3.934411e+00 -5.451988e-17
      vertex   4.435295e+00  4.986383e+00  9.055257e-16
      vertex   4.997289e+00  4.427972e+00  8.916479e-16
    endloop
  endfacet
  facet normal  1.564364e-01 -9.876844e-01 -2.697184e-03
    outer loop
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
      vertex  -1.011834e+00  5.481153e+00  3.025358e-16
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
    endloop
  endfacet
  facet normal -9.091386e-01 -4.161048e-01 -1.799229e-02
    outer loop
      vertex   5.020370e+00  2.202127e+00  3.026297e+00
      vertex   4.911027e+00  2.571886e+00  1.632953e-16
      vertex   5.137590e+00  2.076873e+00  9.801188e-17
    endloop
  endfacet
  facet normal  4.730826e-01  8.797257e-01  4.770404e-02
    outer loop
      vertex   8.377968e+00  2.301989e+00  7.567876e+00
      vertex   8.428094e+00  2.235647e+00  8.294197e+00
      vertex   8.815482e+00  2.026991e+00  8.300353e+00
    endloop
  endfacet
  facet normal -3.153614e-01 -3.133330e-01  8.957509e-01
    outer loop
      vertex  -2.737131e+00 -8.840389e-01  1.876358e+01
      vertex  -3.620850e+00 -8.840160e-01  1.845246e+01
      vertex  -3.582696e+00 -1.189545e+00  1.835902e+01
    endloop
  endfacet
  facet normal -8.719186e-01  3.292052e-01 -3.624665e-01
    outer loop
      vertex  -7.943122e+00  1.552727e+00  2.664435e+00
      vertex  -8.223594e+00  1.558374e+00  3.344243e+00
      vertex  -8.048572e+00  2.035978e+00  3.357002e+00
    endloop
  endfacet
  facet normal  9.606481e-01 -1.044797e-01  2.573697e-01
    outer loop
      vertex   9.412238e+00 -4.434509e-01  1.161360e+01
      vertex   9.168580e+00 -4.434319e-01  1.252308e+01
      vertex   9.124413e+00 -8.843880e-01  1.250893e+01
    endloop
  endfacet
  facet normal -3.469720e-01  9.167650e-01  1.978695e-01
    outer loop
      vertex  -7.324272e+00  2.964247e+00  5.470831e+00
      vertex  -7.275784e+00  2.937731e+00  5.678710e+00
      vertex  -7.163397e+00  3.024019e+00  5.475995e+00
    endloop
  endfacet
  facet normal  9.979931e-01  5.888334e-02 -2.329618e-02
    outer loop
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
      vertex  -5.507651e+00 -5.796566e-01 -6.938894e-18
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
    endloop
  endfacet
  facet normal -5.520095e-01 -8.170450e-01  1.665025e-01
    outer loop
      vertex  -4.968631e+00 -4.836309e+00  2.987150e+00
      vertex  -5.159912e+00 -4.676804e+00  3.135705e+00
      vertex  -5.430634e+00 -4.562702e+00  2.798081e+00
    endloop
  endfacet
  facet normal  8.460512e-01  2.401289e-01 -4.759575e-01
    outer loop
      vertex   6.784000e+00  1.743816e+00  5.665369e-01
      vertex   6.498588e+00  1.626487e+00 -5.898060e-16
      vertex   6.398841e+00  1.977925e+00 -1.609823e-15
    endloop
  endfacet
  facet normal  3.225129e-01  9.465640e-01  1.438318e-03
    outer loop
      vertex  -1.862915e+00 -5.245935e+00  1.537825e+00
      vertex  -1.511060e+00 -5.363482e+00 -3.249137e-16
      vertex  -2.026798e+00 -5.187760e+00 -4.897124e-16
    endloop
  endfacet
  facet normal  8.108768e-01 -5.850286e-01 -1.484709e-02
    outer loop
      vertex  -4.554883e+00  3.087572e+00  2.694960e+00
      vertex  -4.642149e+00  3.035010e+00  2.037722e-16
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
    endloop
  endfacet
  facet normal  1.572198e-02 -9.421272e-01  3.348866e-01
    outer loop
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
      vertex   3.955254e-01 -2.180979e+00  1.782582e+01
    endloop
  endfacet
  facet normal  6.230825e-01 -6.208227e-01  4.757599e-01
    outer loop
      vertex   7.675037e+00 -1.470186e+00  1.487670e+01
      vertex   7.016542e+00 -1.661133e+00  1.548994e+01
      vertex   7.550447e+00 -1.661053e+00  1.479081e+01
    endloop
  endfacet
  facet normal -2.368317e-01 -9.707509e-01  3.941508e-02
    outer loop
      vertex  -8.244216e+00 -2.137755e+00  1.136154e+01
      vertex  -8.376802e+00 -2.137806e+00  1.056362e+01
      vertex  -8.219111e+00 -2.177027e+00  1.054515e+01
    endloop
  endfacet
  facet normal -4.923884e-01  8.670857e-01 -7.560385e-02
    outer loop
      vertex  -3.108129e+00  5.959063e+00  6.241188e-01
      vertex  -3.093479e+00  5.912963e+00  1.084202e-15
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
    endloop
  endfacet
  facet normal -4.834434e-01 -3.133643e-01  8.173648e-01
    outer loop
      vertex  -4.469936e+00 -8.839931e-01  1.805646e+01
      vertex  -5.276351e+00 -8.839722e-01  1.757950e+01
      vertex  -5.220737e+00 -1.189564e+00  1.749524e+01
    endloop
  endfacet
  facet normal  8.586856e-01  5.121518e-01 -1.896868e-02
    outer loop
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
      vertex  -4.621866e+00 -3.067342e+00 -5.204170e-17
      vertex  -4.634246e+00 -3.046586e+00  9.436896e-17
    endloop
  endfacet
  facet normal  8.654352e-01  1.585588e-01 -4.752694e-01
    outer loop
      vertex   7.248661e+00  1.420551e+00  1.249919e+00
      vertex   7.517587e+00  9.879436e-01  1.595290e+00
      vertex   7.331723e+00  9.546490e-01  1.245735e+00
    endloop
  endfacet
  facet normal  7.626092e-01 -5.550343e-01 -3.322109e-01
    outer loop
      vertex   6.547676e+00 -3.050220e+00  1.277827e+00
      vertex   6.414841e+00 -3.452044e+00  1.644233e+00
      vertex   6.307900e+00 -3.385426e+00  1.287444e+00
    endloop
  endfacet
  facet normal  9.292421e-02 -7.612285e-01  6.417915e-01
    outer loop
      vertex   1.748804e+00 -1.661699e+00  1.858495e+01
      vertex   8.459943e-01 -1.948963e+00  1.837494e+01
      vertex   1.684419e+00 -1.948915e+00  1.825361e+01
    endloop
  endfacet
  facet normal -3.299977e-01 -7.614229e-01  5.579756e-01
    outer loop
      vertex  -4.278516e+00 -1.662261e+00  1.769369e+01
      vertex  -5.050360e+00 -1.662342e+00  1.723709e+01
      vertex  -4.864460e+00 -1.949308e+00  1.695544e+01
    endloop
  endfacet
  facet normal  4.116953e-01  9.046167e-01  1.103430e-01
    outer loop
      vertex   8.245063e+00  2.137758e+00  1.136211e+01
      vertex   8.031503e+00  2.137777e+00  1.215875e+01
      vertex   8.412847e+00  1.949324e+00  1.228092e+01
    endloop
  endfacet
  facet normal -4.562094e-01  8.883365e-01 -5.226166e-02
    outer loop
      vertex  -3.899050e+00  5.616796e+00  1.772953e+00
      vertex  -3.411066e+00  5.884436e+00  2.062481e+00
      vertex  -3.163172e+00  5.996607e+00  1.805202e+00
    endloop
  endfacet
  facet normal -8.808524e-01 -3.003799e-01 -3.658839e-01
    outer loop
      vertex  -7.785738e+00 -2.036400e+00  2.677091e+00
      vertex  -8.224982e+00 -1.560852e+00  3.344146e+00
      vertex  -7.944685e+00 -1.554760e+00  2.664340e+00
    endloop
  endfacet
  facet normal  3.987089e-01 -4.464537e-04  9.170774e-01
    outer loop
      vertex  -3.173697e+00 -5.997675e+00  1.959259e+00
      vertex  -3.450266e+00 -4.332319e+00  2.080311e+00
      vertex  -3.412686e+00 -5.885452e+00  2.063216e+00
    endloop
  endfacet
  facet normal  9.091390e-01  4.161040e-01 -1.799246e-02
    outer loop
      vertex  -5.020278e+00 -2.201843e+00  3.026298e+00
      vertex  -4.910936e+00 -2.571602e+00  2.405483e-17
      vertex  -5.137498e+00 -2.076589e+00  1.309716e-16
    endloop
  endfacet
  facet normal  9.450139e-01  3.264340e-01 -1.973535e-02
    outer loop
      vertex  -5.207044e+00 -1.683388e+00  3.173630e+00
      vertex  -5.137498e+00 -2.076589e+00  1.309716e-16
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
    endloop
  endfacet
  facet normal  9.992850e-01 -3.043852e-02 -2.242417e-02
    outer loop
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
      vertex  -5.520691e+00  4.318787e-01 -2.428613e-17
    endloop
  endfacet
  facet normal  8.721786e-01 -2.057282e-02 -4.887547e-01
    outer loop
      vertex   7.000465e+00 -4.384537e-01  5.618048e-01
      vertex   6.687054e+00 -3.784631e-01  2.567391e-16
      vertex   7.010666e+00  4.501343e-03  5.613642e-01
    endloop
  endfacet
  facet normal  2.499154e-16  4.208785e-16 -1.000000e+00
    outer loop
      vertex   2.026891e+00  5.188045e+00 -1.376214e-17
      vertex   1.511153e+00  5.363768e+00 -6.869505e-17
      vertex   2.359956e+00  6.242986e+00  5.134781e-16
    endloop
  endfacet
  facet normal -7.904794e-01  1.047393e-01  6.034666e-01
    outer loop
      vertex  -7.329620e+00  8.853416e-01  1.575287e+01
      vertex  -7.925472e+00  4.444542e-01  1.504889e+01
      vertex  -7.365190e+00  4.444332e-01  1.578280e+01
    endloop
  endfacet
  facet normal -9.897193e-01 -1.004229e-01 -1.018383e-01
    outer loop
      vertex  -9.591765e+00 -4.601555e-01  8.313853e+00
      vertex  -9.468905e+00 -9.282398e-01  7.581413e+00
      vertex  -9.545940e+00 -9.107361e-01  8.312819e+00
    endloop
  endfacet
  facet normal  5.085186e-01 -8.610458e-01 -2.984338e-03
    outer loop
      vertex  -2.650488e+00  4.882700e+00  1.761878e+00
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
      vertex  -2.553828e+00  4.945892e+00  1.957759e-16
    endloop
  endfacet
  facet normal -5.814523e-01 -7.615774e-01  2.862047e-01
    outer loop
      vertex  -8.021980e+00 -1.662747e+00  1.402742e+01
      vertex  -8.417951e+00 -1.662831e+00  1.322275e+01
      vertex  -8.108208e+00 -1.949612e+00  1.308891e+01
    endloop
  endfacet
  facet normal -8.377270e-01  3.568544e-01 -4.133624e-01
    outer loop
      vertex  -6.764935e+00  2.694681e+00  1.269298e+00
      vertex  -6.484798e+00  2.544256e+00  5.717058e-01
      vertex  -6.649155e+00  2.155241e+00  5.689583e-01
    endloop
  endfacet
  facet normal  1.495889e-01 -9.887482e-01 -3.978304e-04
    outer loop
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
      vertex  -1.011834e+00  5.481153e+00  3.025358e-16
      vertex  -5.741618e-01  5.547369e+00  1.734723e-18
    endloop
  endfacet
  facet normal -9.374269e-01  3.478412e-01  1.540938e-02
    outer loop
      vertex  -9.427529e+00  1.298449e+00  9.776813e+00
      vertex  -9.432225e+00  1.318350e+00  9.041901e+00
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
    endloop
  endfacet
  facet normal -9.770100e-01 -9.269955e-02 -1.919852e-01
    outer loop
      vertex  -9.401835e+00 -4.804020e-01  6.855625e+00
      vertex  -9.213157e+00 -9.798908e-01  6.136618e+00
      vertex  -9.357120e+00 -9.516964e-01  6.855629e+00
    endloop
  endfacet
  facet normal  8.152382e-02 -9.693812e-01  2.316332e-01
    outer loop
      vertex   3.186728e+00 -2.137477e+00  1.739015e+01
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
      vertex   3.131773e+00 -2.174252e+00  1.725559e+01
    endloop
  endfacet
  facet normal  2.332195e-01 -9.704015e-01  6.268664e-02
    outer loop
      vertex   8.245609e+00 -2.137315e+00  1.136222e+01
      vertex   7.878036e+00 -2.177375e+00  1.210960e+01
      vertex   8.090086e+00 -2.176857e+00  1.132872e+01
    endloop
  endfacet
  facet normal -6.209449e-01 -2.529215e-04  7.838542e-01
    outer loop
      vertex   5.159244e+00 -4.672935e+00  3.135036e+00
      vertex   5.221836e+00 -1.634611e+00  3.185599e+00
      vertex   5.043385e+00 -2.145653e+00  3.044071e+00
    endloop
  endfacet
  facet normal -8.535748e-01  2.138250e-01 -4.750673e-01
    outer loop
      vertex  -6.890904e+00  1.322287e+00  5.645704e-01
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
      vertex  -6.510569e+00  1.586219e+00  4.579670e-16
    endloop
  endfacet
  facet normal  9.294293e-02 -7.612589e-01  6.417527e-01
    outer loop
      vertex   1.748804e+00 -1.661699e+00  1.858495e+01
      vertex   8.783308e-01 -1.661779e+00  1.871092e+01
      vertex   8.459943e-01 -1.948963e+00  1.837494e+01
    endloop
  endfacet
  facet normal  2.002800e-01  9.718309e-01  1.242286e-01
    outer loop
      vertex   7.376937e+00  2.137812e+00  1.367065e+01
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   6.942175e+00  2.137827e+00  1.437145e+01
    endloop
  endfacet
  facet normal  6.994523e-01  6.786717e-01 -2.239897e-01
    outer loop
      vertex   5.938993e+00  4.104437e+00  2.036110e+00
      vertex   6.618492e+00  3.509832e+00  2.356373e+00
      vertex   6.515748e+00  3.498491e+00  2.001171e+00
    endloop
  endfacet
  facet normal -9.712527e-01  2.518076e-03 -2.380374e-01
    outer loop
      vertex  -9.082709e+00 -2.098083e-05  5.420651e+00
      vertex  -9.257729e+00  3.471375e-04  6.134778e+00
      vertex  -9.256581e+00  4.951496e-01  6.135331e+00
    endloop
  endfacet
  facet normal  9.886707e-01  1.483159e-01 -2.307857e-02
    outer loop
      vertex  -5.429202e+00 -5.796566e-01  3.360714e+00
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
      vertex  -5.507651e+00 -5.796566e-01 -6.938894e-18
    endloop
  endfacet
  facet normal -9.024247e-16  7.412945e-16 -1.000000e+00
    outer loop
      vertex   3.773587e+00  5.503273e+00 -5.898060e-17
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
      vertex   3.100696e+00  5.908006e+00  8.482798e-16
    endloop
  endfacet
  facet normal  8.595834e-01  5.004677e-01 -1.031914e-01
    outer loop
      vertex   8.978265e+00  1.807442e+00  6.853908e+00
      vertex   9.322192e+00  1.366310e+00  7.579377e+00
      vertex   9.214503e+00  1.401918e+00  6.855026e+00
    endloop
  endfacet
  facet normal  5.749687e-15  5.154401e-14 -1.000000e+00
    outer loop
      vertex  -6.499778e+00  1.629298e+00  4.440892e-16
      vertex  -5.334213e+00  1.493491e+00  1.457168e-16
      vertex  -5.335880e+00  1.486812e+00 -2.081668e-16
    endloop
  endfacet
  facet normal -1.761822e-01 -9.706907e-01  1.634610e-01
    outer loop
      vertex  -5.901175e+00 -2.137655e+00  1.560662e+01
      vertex  -6.451189e+00 -2.137671e+00  1.501371e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
    endloop
  endfacet
  facet normal  2.516939e-01 -9.044104e-01  3.445171e-01
    outer loop
      vertex   5.548748e+00 -1.948668e+00  1.645657e+01
      vertex   4.643985e+00 -2.137446e+00  1.662199e+01
      vertex   5.297066e+00 -2.137431e+00  1.614491e+01
    endloop
  endfacet
  facet normal -5.298194e-01  2.068662e-02  8.478581e-01
    outer loop
      vertex  -4.545118e+00 -2.180956e+00  1.647151e+01
      vertex  -4.202807e+00 -2.180958e+00  1.668542e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
    endloop
  endfacet
  facet normal -1.208518e-16  2.075627e-16 -1.000000e+00
    outer loop
      vertex   9.901700e-01  5.485833e+00 -1.118897e-16
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
      vertex   1.593122e+00  6.482521e+00  2.211772e-17
    endloop
  endfacet
  facet normal -7.547962e-01 -3.134371e-01  5.762290e-01
    outer loop
      vertex  -7.329827e+00 -8.839073e-01  1.575304e+01
      vertex  -7.887427e+00 -8.838863e-01  1.502266e+01
      vertex  -7.804250e+00 -1.189606e+00  1.496531e+01
    endloop
  endfacet
  facet normal  2.324516e-01  9.718382e-01  3.868795e-02
    outer loop
      vertex   8.245063e+00  2.137758e+00  1.136211e+01
      vertex   8.377821e+00  2.137769e+00  1.056418e+01
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
    endloop
  endfacet
  facet normal  7.255324e-01  6.210836e-01 -2.964086e-01
    outer loop
      vertex   6.410461e+00  3.451159e+00  1.644279e+00
      vertex   6.515748e+00  3.498491e+00  2.001171e+00
      vertex   6.784631e+00  3.177065e+00  1.985825e+00
    endloop
  endfacet
  facet normal  4.005469e-01 -5.998119e-07 -9.162762e-01
    outer loop
      vertex  -3.488899e+00  2.181314e+00  1.706183e+01
      vertex  -3.488914e+00 -2.180962e+00  1.706183e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
    endloop
  endfacet
  facet normal  1.002083e-16  7.383104e-17 -1.000000e+00
    outer loop
      vertex   1.511153e+00  5.363768e+00 -6.869505e-17
      vertex   9.901700e-01  5.485833e+00 -1.118897e-16
      vertex   1.593122e+00  6.482521e+00  2.211772e-17
    endloop
  endfacet
  facet normal -6.720628e-16 -1.169697e-15 -1.000000e+00
    outer loop
      vertex   4.621958e+00  3.067627e+00 -1.387779e-16
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
      vertex   4.634337e+00  3.046870e+00 -1.228184e-16
    endloop
  endfacet
  facet normal  5.746837e-01 -6.208455e-01  5.331881e-01
    outer loop
      vertex   7.132366e+00 -1.470213e+00  1.558741e+01
      vertex   6.418201e+00 -1.661215e+00  1.613475e+01
      vertex   7.016542e+00 -1.661133e+00  1.548994e+01
    endloop
  endfacet
  facet normal -3.887672e-01  9.195537e-01 -5.728014e-02
    outer loop
      vertex  -3.144492e+00  5.979891e+00  1.410066e+00
      vertex  -3.163172e+00  5.996607e+00  1.805202e+00
      vertex  -2.788353e+00  6.155375e+00  1.810062e+00
    endloop
  endfacet
  facet normal -2.524604e-01 -9.553845e-01  1.533106e-01
    outer loop
      vertex  -7.658592e+00 -2.655830e+00  6.497374e+00
      vertex  -7.903955e+00 -2.534363e+00  6.850277e+00
      vertex  -7.816230e+00 -2.669928e+00  6.149938e+00
    endloop
  endfacet
  facet normal -4.197361e-01 -9.049552e-01  6.983991e-02
    outer loop
      vertex  -8.635535e+00 -1.949717e+00  1.144582e+01
      vertex  -8.774490e+00 -1.949768e+00  1.061004e+01
      vertex  -8.376802e+00 -2.137806e+00  1.056362e+01
    endloop
  endfacet
  facet normal  9.944364e-01  1.051888e-01  5.629567e-03
    outer loop
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
      vertex   9.580951e+00  8.847990e-01  9.780159e+00
      vertex   9.627390e+00  4.457207e-01  9.781108e+00
    endloop
  endfacet
  facet normal -5.807747e-01  7.622302e-01  2.858425e-01
    outer loop
      vertex  -7.725738e+00  1.950449e+00  1.386340e+01
      vertex  -8.107093e+00  1.950495e+00  1.308844e+01
      vertex  -8.417369e+00  1.663807e+00  1.322250e+01
    endloop
  endfacet
  facet normal  4.554027e-02 -3.132893e-01  9.485652e-01
    outer loop
      vertex   9.175830e-01 -8.841286e-01  1.911875e+01
      vertex  -1.984666e-04 -8.841076e-01  1.916282e+01
      vertex  -1.970066e-04 -1.189507e+00  1.906195e+01
    endloop
  endfacet
  facet normal  1.554705e-16 -1.690749e-15 -1.000000e+00
    outer loop
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
      vertex   3.914279e+00 -3.940507e+00  1.637579e-16
      vertex   4.284388e+00 -3.527809e+00 -4.764707e-16
    endloop
  endfacet
  facet normal -5.711118e-16  2.971376e-16 -1.000000e+00
    outer loop
      vertex   3.794700e+00  5.487965e+00  3.504141e-16
      vertex   4.408831e+00  5.010327e+00 -1.422473e-16
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
    endloop
  endfacet
  facet normal  5.175150e-02 -9.351817e-01  3.503670e-01
    outer loop
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
      vertex   7.924814e-01 -2.176695e+00  1.781923e+01
      vertex   1.183383e+00 -2.180983e+00  1.775005e+01
    endloop
  endfacet
  facet normal -4.683210e-01  8.776408e-01  1.020883e-01
    outer loop
      vertex  -6.581262e+00  3.492887e+00  4.595612e+00
      vertex  -7.080110e+00  3.282721e+00  4.113973e+00
      vertex  -7.211841e+00  3.133539e+00  4.792163e+00
    endloop
  endfacet
  facet normal  8.987091e-01 -1.763993e-01 -4.015038e-01
    outer loop
      vertex   7.891260e+00 -1.036148e+00  2.317596e+00
      vertex   7.944548e+00 -1.553850e+00  2.664325e+00
      vertex   7.796534e+00 -1.539156e+00  2.326561e+00
    endloop
  endfacet
  facet normal -8.310288e-01 -3.522220e-01 -4.305008e-01
    outer loop
      vertex  -6.487278e+00 -2.538105e+00  5.717039e-01
      vertex  -6.650954e+00 -2.148561e+00  5.689487e-01
      vertex  -6.260275e+00 -2.374932e+00 -9.714451e-17
    endloop
  endfacet
  facet normal -7.031112e-01 -6.211919e-01  3.460568e-01
    outer loop
      vertex  -8.155293e+00 -1.470728e+00  1.410125e+01
      vertex  -8.417951e+00 -1.662831e+00  1.322275e+01
      vertex  -8.021980e+00 -1.662747e+00  1.402742e+01
    endloop
  endfacet
  facet normal  1.561960e-16  1.370895e-15 -1.000000e+00
    outer loop
      vertex   6.687054e+00 -3.784631e-01  2.567391e-16
      vertex   6.652763e+00 -7.870749e-01 -3.087808e-16
      vertex   5.520783e+00 -4.315945e-01  1.734723e-18
    endloop
  endfacet
  facet normal  5.964485e-01  4.331258e-04  8.026512e-01
    outer loop
      vertex  -4.967633e+00  4.832796e+00  2.986400e+00
      vertex  -5.043293e+00  2.145937e+00  3.044073e+00
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
    endloop
  endfacet
  facet normal -1.416130e-02 -9.990859e-01  4.033335e-02
    outer loop
      vertex  -2.741681e+00  2.181307e+00  1.736673e+01
      vertex  -3.119747e+00  2.180952e+00  1.722521e+01
      vertex  -2.358289e+00  2.180974e+00  1.749311e+01
    endloop
  endfacet
  facet normal  5.607464e-15 -1.161791e-14 -1.000000e+00
    outer loop
      vertex  -6.501628e+00 -1.617079e+00  2.844947e-16
      vertex  -6.512477e+00 -1.573938e+00 -2.775558e-16
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
    endloop
  endfacet
  facet normal  2.276223e-01  9.718367e-01  6.100527e-02
    outer loop
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   8.031503e+00  2.137777e+00  1.215875e+01
    endloop
  endfacet
  facet normal -7.816230e-01 -5.589097e-01 -2.769214e-01
    outer loop
      vertex  -5.620892e+00 -3.918224e+00  5.863695e-01
      vertex  -6.092205e+00 -3.255135e+00  5.783606e-01
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
    endloop
  endfacet
  facet normal -3.213096e-15  2.717861e-16 -1.000000e+00
    outer loop
      vertex   8.043078e-01 -6.628206e+00 -3.209238e-17
      vertex   1.011927e+00 -5.480871e+00 -3.873638e-16
      vertex   1.427193e+00 -6.511893e+00 -2.001871e-15
    endloop
  endfacet
  facet normal -1.725193e-01 -9.844583e-01 -3.284496e-02
    outer loop
      vertex  -8.018533e-01 -6.648617e+00  6.447229e-01
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
    endloop
  endfacet
  facet normal  8.719123e-01  4.859487e-01  6.018952e-02
    outer loop
      vertex   9.263976e+00  1.467035e+00  1.066768e+01
      vertex   9.481034e+00  1.187719e+00  9.778445e+00
      vertex   9.325606e+00  1.466988e+00  9.775280e+00
    endloop
  endfacet
  facet normal  5.312117e-16 -2.579810e-15 -1.000000e+00
    outer loop
      vertex   4.634337e+00  3.046870e+00 -1.228184e-16
      vertex   5.504234e+00  3.789168e+00 -1.575707e-15
      vertex   5.917587e+00  3.116910e+00  3.781697e-16
    endloop
  endfacet
  facet normal  3.935868e-16  4.069914e-17 -1.000000e+00
    outer loop
      vertex   3.794700e+00  5.487965e+00  3.504141e-16
      vertex   3.486378e+00  4.328087e+00  1.818568e-16
      vertex   3.015552e+00  4.674385e+00  1.063964e-17
    endloop
  endfacet
  facet normal  2.474025e-01 -9.687616e-01  1.711429e-02
    outer loop
      vertex   8.378459e+00 -2.137298e+00  1.056425e+01
      vertex   8.235993e+00 -2.181015e+00  1.014908e+01
      vertex   8.433884e+00 -2.137402e+00  9.757127e+00
    endloop
  endfacet
  facet normal  7.172188e-15  4.910770e-14 -1.000000e+00
    outer loop
      vertex   6.503150e+00 -1.615171e+00  2.157996e-15
      vertex   5.334304e+00 -1.493209e+00 -2.359224e-16
      vertex   5.335972e+00 -1.486529e+00  1.040834e-16
    endloop
  endfacet
  facet normal -7.331274e-01  3.110643e-03  6.800842e-01
    outer loop
      vertex  -6.736389e+00  7.286072e-04  1.645885e+01
      vertex  -7.364252e+00  7.486343e-04  1.578201e+01
      vertex  -7.365310e+00 -4.429569e-01  1.578290e+01
    endloop
  endfacet
  facet normal  4.492552e-02  9.989895e-01 -1.286751e-03
    outer loop
      vertex  -4.795094e-01 -5.556038e+00  1.338963e+00
      vertex  -3.863586e-01 -5.561952e+00  2.942091e-16
      vertex  -4.403078e-01 -5.559525e+00 -5.898060e-17
    endloop
  endfacet
  facet normal  1.434949e-02 -9.990603e-01  4.089812e-02
    outer loop
      vertex   3.119434e+00  2.180903e+00  1.722538e+01
      vertex   2.741358e+00  2.181265e+00  1.736688e+01
      vertex   2.357970e+00  2.180932e+00  1.749327e+01
    endloop
  endfacet
  facet normal  7.891515e-01 -5.872298e-01 -1.800030e-01
    outer loop
      vertex   7.819855e+00 -2.469397e+00  3.372513e+00
      vertex   7.745208e+00 -2.784725e+00  4.073960e+00
      vertex   7.548003e+00 -2.840347e+00  3.390848e+00
    endloop
  endfacet
  facet normal -3.480181e-02 -9.705366e-01  2.384272e-01
    outer loop
      vertex  -8.079415e-01 -2.137550e+00  1.797614e+01
      vertex  -1.577339e+00 -2.177605e+00  1.770079e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
    endloop
  endfacet
  facet normal  3.757794e-02 -6.209915e-01  7.829161e-01
    outer loop
      vertex   8.928719e-01 -1.470419e+00  1.886201e+01
      vertex  -1.906334e-04 -1.661858e+00  1.875303e+01
      vertex   8.783308e-01 -1.661779e+00  1.871092e+01
    endloop
  endfacet
  facet normal -2.437975e-16 -2.971145e-16 -1.000000e+00
    outer loop
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
      vertex  -3.890054e+00  3.963817e+00  1.595946e-16
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
    endloop
  endfacet
  facet normal  8.141124e-17  2.532491e-16 -1.000000e+00
    outer loop
      vertex  -4.910936e+00 -2.571602e+00  2.405483e-17
      vertex  -6.102031e+00 -2.749480e+00 -1.179612e-16
      vertex  -5.137498e+00 -2.076589e+00  1.309716e-16
    endloop
  endfacet
  facet normal  4.834256e-01 -3.132094e-01  8.174347e-01
    outer loop
      vertex   5.276037e+00 -8.842430e-01  1.757970e+01
      vertex   4.469616e+00 -8.842201e-01  1.805662e+01
      vertex   4.422585e+00 -1.189459e+00  1.796748e+01
    endloop
  endfacet
  facet normal  4.203305e-01 -1.044718e-01  9.013367e-01
    outer loop
      vertex   4.491258e+00 -4.432640e-01  1.809764e+01
      vertex   3.620520e+00 -8.841972e-01  1.845259e+01
      vertex   4.469616e+00 -8.842201e-01  1.805662e+01
    endloop
  endfacet
  facet normal -3.719874e-01 -9.056756e-01  2.034137e-01
    outer loop
      vertex  -7.326120e+00 -2.965523e+00  5.470749e+00
      vertex  -7.276982e+00 -2.938496e+00  5.680944e+00
      vertex  -7.706357e+00 -2.811855e+00  5.459588e+00
    endloop
  endfacet
  facet normal -9.149840e-01 -2.027789e-01 -3.488337e-01
    outer loop
      vertex  -8.224982e+00 -1.560852e+00  3.344146e+00
      vertex  -8.597669e+00 -1.047401e+00  4.023223e+00
      vertex  -8.333854e+00 -1.053164e+00  3.334592e+00
    endloop
  endfacet
  facet normal  8.945063e-15  7.270070e-15 -1.000000e+00
    outer loop
      vertex  -4.307566e+00  3.498758e+00 -1.600572e-16
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
      vertex  -4.284296e+00  3.528093e+00  2.613650e-16
    endloop
  endfacet
  facet normal  1.476530e-16  8.725568e-17 -1.000000e+00
    outer loop
      vertex   4.404008e-01  5.559808e+00  0.000000e+00
      vertex   8.062172e-01  6.626396e+00  1.470798e-16
      vertex   9.072288e-01  5.499919e+00  6.370290e-17
    endloop
  endfacet
  facet normal  1.872974e-01  9.718361e-01  1.430183e-01
    outer loop
      vertex   6.795857e+00  2.180871e+00  1.427060e+01
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   6.451268e+00  2.137846e+00  1.501424e+01
    endloop
  endfacet
  facet normal  4.734812e-01  8.772781e-01  7.873163e-02
    outer loop
      vertex   3.926537e+00  5.606951e+00  2.157274e+00
      vertex   3.644418e+00  5.757833e+00  2.172665e+00
      vertex   3.939172e+00  5.585073e+00  2.325060e+00
    endloop
  endfacet
  facet normal -1.263412e-15 -2.029774e-15 -1.000000e+00
    outer loop
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
      vertex   3.890146e+00 -3.963536e+00 -1.120631e-15
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
    endloop
  endfacet
  facet normal -2.128788e-16  7.998851e-16 -1.000000e+00
    outer loop
      vertex  -3.093479e+00  5.912963e+00  1.084202e-15
      vertex  -2.553828e+00  4.945892e+00  1.957759e-16
      vertex  -3.029691e+00  4.664856e+00  7.228015e-17
    endloop
  endfacet
  facet normal -5.060600e-16  3.072029e-15 -1.000000e+00
    outer loop
      vertex   6.398535e+00 -1.985539e+00 -5.759282e-16
      vertex   6.261974e+00 -2.373744e+00 -1.699398e-15
      vertex   5.157904e+00 -2.025023e+00 -6.938894e-17
    endloop
  endfacet
  facet normal -9.682518e-01  8.580520e-02 -2.347892e-01
    outer loop
      vertex  -9.080769e+00  5.083599e-01  5.421729e+00
      vertex  -9.212256e+00  9.808025e-01  6.136631e+00
      vertex  -9.037185e+00  1.008070e+00  5.424614e+00
    endloop
  endfacet
  facet normal -8.299516e-16  1.255917e-15 -1.000000e+00
    outer loop
      vertex   5.137590e+00  2.076873e+00  9.801188e-17
      vertex   6.097925e+00  2.755002e+00  1.526557e-16
      vertex   6.256312e+00  2.381761e+00 -4.475587e-16
    endloop
  endfacet
  facet normal  6.200809e-01  7.623726e-01 -1.851698e-01
    outer loop
      vertex   4.553915e+00  5.129000e+00  1.359486e+00
      vertex   5.252198e+00  4.645002e+00  1.705145e+00
      vertex   5.192330e+00  4.603491e+00  1.333755e+00
    endloop
  endfacet
  facet normal -1.801038e-01 -9.046719e-01  3.861753e-01
    outer loop
      vertex  -3.338233e+00 -1.949209e+00  1.776034e+01
      vertex  -3.934147e+00 -2.137609e+00  1.704107e+01
      vertex  -3.186847e+00 -2.137594e+00  1.738963e+01
    endloop
  endfacet
  facet normal -9.021767e-01 -1.778365e-05  4.313667e-01
    outer loop
      vertex   7.382584e+00  2.855700e+00  5.884530e+00
      vertex   7.385159e+00 -2.855360e+00  5.889679e+00
      vertex   7.511272e+00  2.760725e+00  6.153669e+00
    endloop
  endfacet
  facet normal -9.894881e-01  1.007287e-01 -1.037644e-01
    outer loop
      vertex  -9.513821e+00  4.703484e-01  7.582159e+00
      vertex  -9.591422e+00  4.617844e-01  8.313846e+00
      vertex  -9.545411e+00  9.126930e-01  8.312806e+00
    endloop
  endfacet
  facet normal -9.864525e-01 -2.694795e-03  1.640249e-01
    outer loop
      vertex  -9.412189e+00  4.445343e-01  1.161314e+01
      vertex  -9.563660e+00  4.445534e-01  1.070219e+01
      vertex  -9.562470e+00  8.621216e-04  1.070205e+01
    endloop
  endfacet
  facet normal  7.657152e-01  5.172143e-01 -3.823214e-01
    outer loop
      vertex   6.664850e+00  3.122030e+00  1.631618e+00
      vertex   7.036183e+00  2.824865e+00  1.973314e+00
      vertex   6.900171e+00  2.765280e+00  1.620299e+00
    endloop
  endfacet
  facet normal -2.497914e-15 -3.948486e-16 -1.000000e+00
    outer loop
      vertex  -1.574733e+00  5.346050e+00  1.179612e-16
      vertex  -1.742376e+00  6.437355e+00  1.058181e-16
      vertex  -1.519182e+00  5.361024e+00 -2.671474e-17
    endloop
  endfacet
  facet normal -5.162871e-01  8.543574e-01  5.933838e-02
    outer loop
      vertex  -4.640317e+00  5.169970e+00  2.116257e+00
      vertex  -4.681918e+00  5.119100e+00  2.486733e+00
      vertex  -4.340185e+00  5.320688e+00  2.557577e+00
    endloop
  endfacet
  facet normal  4.117368e-01 -9.029774e-01  1.229003e-01
    outer loop
      vertex   8.198556e+00 -2.495211e+00  6.145896e+00
      vertex   7.903616e+00 -2.533827e+00  6.850272e+00
      vertex   7.815907e+00 -2.669142e+00  6.149922e+00
    endloop
  endfacet
  facet normal  7.309235e-01 -6.513669e-01 -2.036465e-01
    outer loop
      vertex   5.619496e+00 -3.913401e+00  5.863152e-01
      vertex   5.078556e+00 -4.523216e+00  5.952883e-01
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
    endloop
  endfacet
  facet normal  8.676534e-01 -7.281270e-02 -4.918086e-01
    outer loop
      vertex   7.000465e+00 -4.384537e-01  5.618048e-01
      vertex   6.652763e+00 -7.870749e-01 -3.087808e-16
      vertex   6.687054e+00 -3.784631e-01  2.567391e-16
    endloop
  endfacet
  facet normal  1.225363e-16 -1.627002e-14 -1.000000e+00
    outer loop
      vertex   6.498588e+00  1.626487e+00 -5.898060e-16
      vertex   6.509523e+00  1.583495e+00  1.110223e-16
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
    endloop
  endfacet
  facet normal -4.774075e-02  1.047336e-01  9.933538e-01
    outer loop
      vertex  -1.912162e-04  8.851395e-01  1.916265e+01
      vertex  -9.179352e-01  8.851624e-01  1.911854e+01
      vertex  -9.223928e-01  4.442577e-01  1.916481e+01
    endloop
  endfacet
  facet normal  6.400486e-01 -7.609230e-01  1.064609e-01
    outer loop
      vertex   8.967391e+00 -1.660718e+00  1.151774e+01
      vertex   8.637318e+00 -1.948309e+00  1.144662e+01
      vertex   9.111837e+00 -1.660636e+00  1.064991e+01
    endloop
  endfacet
  facet normal -8.852012e-01  4.362414e-01 -1.615928e-01
    outer loop
      vertex  -8.906251e+00  1.487829e+00  5.428909e+00
      vertex  -8.848840e+00  1.867825e+00  6.140260e+00
      vertex  -8.690358e+00  1.927992e+00  5.434532e+00
    endloop
  endfacet
  facet normal  8.749072e-01 -4.693707e-01 -1.192838e-01
    outer loop
      vertex   9.076302e+00 -1.444693e+00  6.138244e+00
      vertex   8.979527e+00 -1.806957e+00  6.853909e+00
      vertex   8.849883e+00 -1.867241e+00  6.140228e+00
    endloop
  endfacet
  facet normal -5.839329e-01  8.046798e-01 -1.072975e-01
    outer loop
      vertex  -4.471776e+00  5.078700e+00  6.048985e-01
      vertex  -3.813564e+00  5.557645e+00  6.146545e-01
      vertex  -3.788864e+00  5.493610e+00 -1.020017e-15
    endloop
  endfacet
  facet normal -7.319050e-16  4.537951e-15 -1.000000e+00
    outer loop
      vertex   5.454060e+00 -9.622504e-01 -2.263814e-16
      vertex   6.652763e+00 -7.870749e-01 -3.087808e-16
      vertex   6.594516e+00 -1.186593e+00 -2.079145e-15
    endloop
  endfacet
  facet normal -3.121783e-01 -9.047939e-01  2.896427e-01
    outer loop
      vertex  -6.181426e+00 -1.949408e+00  1.589257e+01
      vertex  -6.757536e+00 -1.949457e+00  1.527148e+01
      vertex  -6.451189e+00 -2.137671e+00  1.501371e+01
    endloop
  endfacet
  facet normal  6.267208e-01  7.609385e-01  1.679095e-01
    outer loop
      vertex   8.636546e+00  1.949278e+00  1.144645e+01
      vertex   8.734851e+00  1.661410e+00  1.238410e+01
      vertex   8.967095e+00  1.661316e+00  1.151767e+01
    endloop
  endfacet
  facet normal  5.625921e-01 -5.286209e-04  8.267344e-01
    outer loop
      vertex  -4.721087e+00 -5.036455e+00  2.807743e+00
      vertex  -4.512453e+00 -3.152010e+00  2.666972e+00
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
    endloop
  endfacet
  facet normal  9.810200e-01  1.047418e-01  1.631833e-01
    outer loop
      vertex   9.366868e+00  8.848324e-01  1.160382e+01
      vertex   9.412313e+00  4.439354e-01  1.161362e+01
      vertex   9.517658e+00  8.848133e-01  1.069732e+01
    endloop
  endfacet
  facet normal -6.625890e-01 -7.474354e-01 -4.812755e-02
    outer loop
      vertex  -8.071532e+00 -2.605118e+00  5.449806e+00
      vertex  -8.550210e+00 -2.225395e+00  6.142725e+00
      vertex  -8.406209e+00 -2.307894e+00  5.441439e+00
    endloop
  endfacet
  facet normal -4.596823e-01 -8.876624e-04  8.880830e-01
    outer loop
      vertex   3.644418e+00  5.757833e+00  2.172665e+00
      vertex   3.842232e+00  3.974119e+00  2.273273e+00
      vertex   3.939172e+00  5.585073e+00  2.325060e+00
    endloop
  endfacet
  facet normal -5.704299e-16  2.239271e-15 -1.000000e+00
    outer loop
      vertex  -5.536572e+00 -8.949064e-02  5.074066e-17
      vertex  -6.687660e+00 -3.790381e-01  5.898060e-17
      vertex  -6.697911e+00  7.241169e-03  9.298118e-16
    endloop
  endfacet
  facet normal  4.204535e-01  9.046124e-01  6.996647e-02
    outer loop
      vertex   8.245063e+00  2.137758e+00  1.136211e+01
      vertex   8.636546e+00  1.949278e+00  1.144645e+01
      vertex   8.377821e+00  2.137769e+00  1.056418e+01
    endloop
  endfacet
  facet normal  3.053698e-16  1.140368e-15 -1.000000e+00
    outer loop
      vertex  -6.591945e+00  1.200882e+00 -6.308086e-18
      vertex  -6.510569e+00  1.586219e+00  4.579670e-16
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
    endloop
  endfacet
  facet normal -9.072737e-01 -7.239321e-02 -4.142629e-01
    outer loop
      vertex  -8.083801e+00 -5.270309e-01  2.648676e+00
      vertex  -7.930489e+00 -5.212479e-01  2.311898e+00
      vertex  -7.891964e+00 -1.036732e+00  2.317606e+00
    endloop
  endfacet
  facet normal  5.513157e-01 -7.610148e-01  3.419173e-01
    outer loop
      vertex   8.023282e+00 -1.660970e+00  1.402858e+01
      vertex   7.550447e+00 -1.661053e+00  1.479081e+01
      vertex   7.272491e+00 -1.948517e+00  1.459918e+01
    endloop
  endfacet
  facet normal -2.343901e-01  9.719020e-01  2.163482e-02
    outer loop
      vertex  -8.376205e+00  2.138299e+00  1.056355e+01
      vertex  -8.200814e+00  2.181055e+00  1.054299e+01
      vertex  -8.235942e+00  2.181364e+00  1.014854e+01
    endloop
  endfacet
  facet normal -5.933740e-02 -9.977900e-01 -2.990223e-02
    outer loop
      vertex   5.287504e-04 -6.695167e+00  6.465187e-01
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
      vertex   8.921291e-03 -6.676291e+00 -2.974689e-16
    endloop
  endfacet
  facet normal -1.238001e-01 -9.814901e-01  1.461185e-01
    outer loop
      vertex  -5.486282e+00 -2.180952e+00  1.574862e+01
      vertex  -5.184224e+00 -2.180954e+00  1.600453e+01
      vertex  -5.205849e+00 -2.174232e+00  1.603135e+01
    endloop
  endfacet
  facet normal  5.801848e-01 -4.875448e-01  6.524459e-01
    outer loop
      vertex   6.634067e+00 -1.189428e+00  1.635503e+01
      vertex   5.856004e+00 -1.470266e+00  1.683706e+01
      vertex   6.524189e+00 -1.470240e+00  1.624290e+01
    endloop
  endfacet
  facet normal -4.444526e-01 -4.876504e-01  7.514381e-01
    outer loop
      vertex  -4.422828e+00 -1.189554e+00  1.796718e+01
      vertex  -5.220737e+00 -1.189564e+00  1.749524e+01
      vertex  -5.134163e+00 -1.470596e+00  1.736407e+01
    endloop
  endfacet
  facet normal -5.380411e-17  1.204728e-16 -1.000000e+00
    outer loop
      vertex   4.642241e+00 -3.034725e+00 -5.828671e-17
      vertex   4.924182e+00 -2.546585e+00 -1.464878e-17
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
    endloop
  endfacet
  facet normal  9.471974e-01  5.417209e-03 -3.206056e-01
    outer loop
      vertex   8.638736e+00  5.256424e-01  4.017771e+00
      vertex   8.875118e+00  5.187302e-01  4.716023e+00
      vertex   8.877553e+00 -4.463196e-04  4.714444e+00
    endloop
  endfacet
  facet normal -2.151199e-01  7.618350e-01  6.110080e-01
    outer loop
      vertex  -2.523188e+00  1.950075e+00  1.804622e+01
      vertex  -3.337810e+00  1.950125e+00  1.775935e+01
      vertex  -3.465606e+00  1.663043e+00  1.807230e+01
    endloop
  endfacet
  facet normal  2.446428e-02 -4.369620e-05  9.997007e-01
    outer loop
      vertex  -4.039023e-01  6.679846e+00  1.334868e+00
      vertex   4.720717e-05  5.577585e+00  1.324935e+00
      vertex   4.720593e-05  6.690340e+00  1.324984e+00
    endloop
  endfacet
  facet normal  2.835395e-01 -9.043856e-01  3.188919e-01
    outer loop
      vertex   6.181915e+00 -1.948618e+00  1.589363e+01
      vertex   5.297066e+00 -2.137431e+00  1.614491e+01
      vertex   5.901518e+00 -2.137416e+00  1.560751e+01
    endloop
  endfacet
  facet normal -2.151058e-01  7.617936e-01  6.110647e-01
    outer loop
      vertex  -2.523188e+00  1.950075e+00  1.804622e+01
      vertex  -3.465606e+00  1.663043e+00  1.807230e+01
      vertex  -2.619798e+00  1.662946e+00  1.837016e+01
    endloop
  endfacet
  facet normal -8.535786e-01  2.138138e-01 -4.750656e-01
    outer loop
      vertex  -6.785774e+00  1.746426e+00  5.665808e-01
      vertex  -6.499778e+00  1.629298e+00  4.440892e-16
      vertex  -6.510569e+00  1.586219e+00  4.579670e-16
    endloop
  endfacet
  facet normal -4.002469e-01 -9.023294e-01  1.600128e-01
    outer loop
      vertex  -6.959290e+00 -3.187130e+00  5.138649e+00
      vertex  -7.326120e+00 -2.965523e+00  5.470749e+00
      vertex  -7.213975e+00 -3.135624e+00  4.792043e+00
    endloop
  endfacet
  facet normal  3.446944e-02 -9.988936e-01  3.199003e-02
    outer loop
      vertex   6.315326e+00  2.180876e+00  1.489987e+01
      vertex   6.051607e+00  2.181234e+00  1.519522e+01
      vertex   5.776798e+00  2.180880e+00  1.548026e+01
    endloop
  endfacet
  facet normal  9.106129e-01  1.261655e-02 -4.130676e-01
    outer loop
      vertex   7.930045e+00  5.198708e-01  2.311933e+00
      vertex   8.089043e+00 -6.465912e-04  2.646547e+00
      vertex   7.936329e+00 -2.689362e-04  2.309899e+00
    endloop
  endfacet
  facet normal  4.554671e-02  3.130077e-01  9.486578e-01
    outer loop
      vertex   9.079884e-01  1.188446e+00  1.901897e+01
      vertex  -1.872839e-04  1.188496e+00  1.906255e+01
      vertex  -1.912162e-04  8.851395e-01  1.916265e+01
    endloop
  endfacet
  facet normal -4.834496e-01 -3.133513e-01  8.173662e-01
    outer loop
      vertex  -4.469936e+00 -8.839931e-01  1.805646e+01
      vertex  -5.220737e+00 -1.189564e+00  1.749524e+01
      vertex  -4.422828e+00 -1.189554e+00  1.796718e+01
    endloop
  endfacet
  facet normal  2.171488e-01 -9.044546e-01  3.671623e-01
    outer loop
      vertex   4.864637e+00 -1.948717e+00  1.695632e+01
      vertex   4.121053e+00 -1.948767e+00  1.739597e+01
      vertex   3.934129e+00 -2.137462e+00  1.704169e+01
    endloop
  endfacet
  facet normal  9.360754e-01  2.872803e-03  3.517875e-01
    outer loop
      vertex   9.167368e+00  2.927780e-04  1.252269e+01
      vertex   8.836189e+00  3.118515e-04  1.340393e+01
      vertex   8.837360e+00 -4.434109e-01  1.340443e+01
    endloop
  endfacet
  facet normal -3.622414e-16 -2.047072e-15 -1.000000e+00
    outer loop
      vertex  -6.591945e+00  1.200882e+00 -6.308086e-18
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
      vertex  -6.650962e+00  8.014841e-01  8.326673e-16
    endloop
  endfacet
  facet normal -1.123761e-01 -6.210192e-01  7.756976e-01
    outer loop
      vertex  -8.932351e-01 -1.470469e+00  1.886192e+01
      vertex  -1.749077e+00 -1.662018e+00  1.858458e+01
      vertex  -8.786781e-01 -1.661938e+00  1.871074e+01
    endloop
  endfacet
  facet normal  2.151913e-01  7.614961e-01  6.114053e-01
    outer loop
      vertex   3.337795e+00  1.949743e+00  1.776009e+01
      vertex   2.523059e+00  1.949789e+00  1.804679e+01
      vertex   2.619659e+00  1.662367e+00  1.837077e+01
    endloop
  endfacet
  facet normal -8.762703e-01  3.966281e-01 -2.735626e-01
    outer loop
      vertex  -8.479411e+00  1.548126e+00  4.031908e+00
      vertex  -8.707513e+00  1.523714e+00  4.727165e+00
      vertex  -8.503814e+00  1.979933e+00  4.736134e+00
    endloop
  endfacet
  facet normal  3.459338e-01  9.112238e-01  2.236089e-01
    outer loop
      vertex   6.959351e+00  3.182512e+00  5.138515e+00
      vertex   7.163462e+00  3.022242e+00  5.475860e+00
      vertex   7.323770e+00  2.962626e+00  5.470797e+00
    endloop
  endfacet
  facet normal -4.629530e-17  3.973610e-16 -1.000000e+00
    outer loop
      vertex   6.509523e+00  1.583495e+00  1.110223e-16
      vertex   5.434920e+00  1.065391e+00 -4.510281e-17
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
    endloop
  endfacet
  facet normal -7.259226e-01 -6.200610e-01 -2.975916e-01
    outer loop
      vertex  -6.415605e+00 -3.455317e+00  1.644304e+00
      vertex  -6.520677e+00 -3.503586e+00  2.001183e+00
      vertex  -6.789246e+00 -3.181795e+00  1.985826e+00
    endloop
  endfacet
  facet normal -3.984749e-01 -9.048701e-01  1.497596e-01
    outer loop
      vertex  -8.030813e+00 -2.137737e+00  1.215816e+01
      vertex  -7.740718e+00 -2.137720e+00  1.293013e+01
      vertex  -8.108208e+00 -1.949612e+00  1.308891e+01
    endloop
  endfacet
  facet normal -4.895304e-15  3.607598e-15 -1.000000e+00
    outer loop
      vertex  -4.999187e+00 -4.427117e+00  2.220446e-16
      vertex  -4.303997e+00 -3.502633e+00  1.540434e-16
      vertex  -4.288297e+00 -3.524029e+00  0.000000e+00
    endloop
  endfacet
  facet normal -5.224352e-01 -8.419651e-01  1.347452e-01
    outer loop
      vertex  -5.752707e+00 -4.183825e+00  3.658639e+00
      vertex  -5.926527e+00 -4.048138e+00  3.832550e+00
      vertex  -6.264063e+00 -3.896368e+00  3.472196e+00
    endloop
  endfacet
  facet normal  8.941576e-01 -1.406546e-02 -4.475314e-01
    outer loop
      vertex   7.752341e+00 -5.106583e-01  1.956629e+00
      vertex   7.759639e+00  2.861023e-04  1.955153e+00
      vertex   7.929991e+00 -5.209370e-01  2.311893e+00
    endloop
  endfacet
  facet normal -6.902883e-01  7.233849e-01 -1.471427e-02
    outer loop
      vertex   3.521596e+00 -4.272234e+00  2.113484e+00
      vertex   3.914279e+00 -3.940507e+00  1.637579e-16
      vertex   3.890146e+00 -3.963536e+00 -1.120631e-15
    endloop
  endfacet
  facet normal  4.364935e-16 -1.895308e-16 -1.000000e+00
    outer loop
      vertex  -1.519182e+00  5.361024e+00 -2.671474e-17
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
      vertex  -1.072226e+00  5.471439e+00  1.474515e-16
    endloop
  endfacet
  facet normal  5.494720e-01 -8.187318e-01  1.666093e-01
    outer loop
      vertex   5.529263e+00 -4.359472e+00  3.449402e+00
      vertex   5.346348e+00 -4.514809e+00  3.289315e+00
      vertex   5.429493e+00 -4.559002e+00  2.797934e+00
    endloop
  endfacet
  facet normal  7.400923e-01  6.222734e-01 -2.550280e-01
    outer loop
      vertex   5.777733e+00  4.019957e+00  1.309361e+00
      vertex   6.303267e+00  3.385946e+00  1.287462e+00
      vertex   5.614513e+00  3.917742e+00  5.862894e-01
    endloop
  endfacet
  facet normal  8.169283e-01 -4.219934e-01 -3.931280e-01
    outer loop
      vertex   6.487965e+00 -2.535486e+00  5.716991e-01
      vertex   6.300029e+00 -2.902218e+00  5.748234e-01
      vertex   6.104056e+00 -2.746094e+00  1.457168e-15
    endloop
  endfacet
  facet normal -5.768069e-01 -8.155474e-01  4.664814e-02
    outer loop
      vertex  -4.643901e+00 -5.171534e+00  2.116185e+00
      vertex  -4.685282e+00 -5.121077e+00  2.486646e+00
      vertex  -5.374352e+00 -4.636389e+00  2.440040e+00
    endloop
  endfacet
  facet normal  1.868842e-01 -6.209335e-01  7.612594e-01
    outer loop
      vertex   2.663114e+00 -1.470369e+00  1.851656e+01
      vertex   1.748804e+00 -1.661699e+00  1.858495e+01
      vertex   2.619772e+00 -1.661618e+00  1.837120e+01
    endloop
  endfacet
  facet normal -5.556014e-16 -1.992483e-16 -1.000000e+00
    outer loop
      vertex  -4.430835e+00  4.991413e+00 -1.387779e-17
      vertex  -3.914187e+00  3.940789e+00 -9.159340e-17
      vertex  -4.998640e+00  4.427993e+00  4.138555e-16
    endloop
  endfacet
  facet normal -4.193131e-02  4.864092e-01  8.727244e-01
    outer loop
      vertex  -1.819546e-04  1.467806e+00  1.890688e+01
      vertex  -9.083396e-01  1.188545e+00  1.901889e+01
      vertex  -1.872839e-04  1.188496e+00  1.906255e+01
    endloop
  endfacet
  facet normal -4.204139e-01  9.073322e-01 -6.908571e-04
    outer loop
      vertex   2.166294e+00 -5.123985e+00  1.614154e+00
      vertex   2.553920e+00 -4.945607e+00 -2.782992e-16
      vertex   2.057736e+00 -5.175515e+00  6.071532e-17
    endloop
  endfacet
  facet normal  6.092268e-01  7.929114e-01  1.159061e-02
    outer loop
      vertex   8.069473e+00  2.602678e+00  5.449855e+00
      vertex   8.197143e+00  2.494410e+00  6.145931e+00
      vertex   8.548699e+00  2.224340e+00  6.142745e+00
    endloop
  endfacet
  facet normal -3.122150e-01 -9.047785e-01  2.896507e-01
    outer loop
      vertex  -6.181426e+00 -1.949408e+00  1.589257e+01
      vertex  -6.451189e+00 -2.137671e+00  1.501371e+01
      vertex  -5.901175e+00 -2.137655e+00  1.560662e+01
    endloop
  endfacet
  facet normal -4.243492e-01  9.050220e-01  2.937444e-02
    outer loop
      vertex  -8.376205e+00  2.138299e+00  1.056355e+01
      vertex  -8.432110e+00  2.138231e+00  9.758054e+00
      vertex  -8.773240e+00  1.950632e+00  1.060990e+01
    endloop
  endfacet
  facet normal  7.266710e-01  6.218269e-01 -2.920284e-01
    outer loop
      vertex   6.515748e+00  3.498491e+00  2.001171e+00
      vertex   6.910635e+00  3.199858e+00  2.347902e+00
      vertex   6.784631e+00  3.177065e+00  1.985825e+00
    endloop
  endfacet
  facet normal  7.733603e-01 -6.207759e-01  1.286510e-01
    outer loop
      vertex   9.115124e+00 -1.470076e+00  1.154957e+01
      vertex   8.967391e+00 -1.660718e+00  1.151774e+01
      vertex   9.261893e+00 -1.470047e+00  1.066743e+01
    endloop
  endfacet
  facet normal  8.180569e-01  4.860617e-01  3.074523e-01
    outer loop
      vertex   8.881103e+00  1.467134e+00  1.243096e+01
      vertex   8.560225e+00  1.467184e+00  1.328466e+01
      vertex   8.702976e+00  1.187906e+00  1.334635e+01
    endloop
  endfacet
  facet normal  5.900296e-01 -2.302936e-04  8.073817e-01
    outer loop
      vertex  -4.967633e+00  4.832796e+00  2.986400e+00
      vertex  -4.820034e+00  2.631083e+00  2.877908e+00
      vertex  -4.773370e+00  4.990690e+00  2.844480e+00
    endloop
  endfacet
  facet normal -7.348705e-02  2.173318e-03  9.972938e-01
    outer loop
      vertex   8.060707e-01 -6.644463e+00  1.364411e+00
      vertex   5.706832e-01 -5.547085e+00  1.344675e+00
      vertex   4.041913e-01 -6.678841e+00  1.334873e+00
    endloop
  endfacet
  facet normal -1.772058e-01 -9.841460e-01  7.401583e-03
    outer loop
      vertex  -8.284958e+00 -2.174232e+00  9.866986e+00
      vertex  -8.269004e+00 -2.177960e+00  9.753304e+00
      vertex  -8.235943e+00 -2.180941e+00  1.014854e+01
    endloop
  endfacet
  facet normal  7.994492e-01 -4.031544e-01 -4.453622e-01
    outer loop
      vertex   6.651994e+00 -2.146391e+00  5.689535e-01
      vertex   6.962789e+00 -2.295359e+00  1.261698e+00
      vertex   6.767753e+00 -2.690432e+00  1.269229e+00
    endloop
  endfacet
  facet normal  2.602690e-01 -9.655269e-01 -4.242027e-03
    outer loop
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
      vertex  -1.574733e+00  5.346050e+00  1.179612e-16
      vertex  -1.519182e+00  5.361024e+00 -2.671474e-17
    endloop
  endfacet
  facet normal  6.637704e-01 -7.333965e-01 -1.467592e-01
    outer loop
      vertex   5.078556e+00 -4.523216e+00  5.952883e-01
      vertex   4.474941e+00 -5.071439e+00  6.048517e-01
      vertex   4.440704e+00 -4.981390e+00  2.498002e-16
    endloop
  endfacet
  facet normal -4.858998e-01  1.142278e-03  8.740138e-01
    outer loop
      vertex   3.939172e+00  5.585073e+00  2.325060e+00
      vertex   3.842232e+00  3.974119e+00  2.273273e+00
      vertex   4.196823e+00  3.579973e+00  2.470919e+00
    endloop
  endfacet
  facet normal -1.130323e-02  9.718322e-01  2.354027e-01
    outer loop
      vertex  -1.948181e-04  2.180928e+00  1.783723e+01
      vertex  -7.909350e-01  2.180936e+00  1.779923e+01
      vertex  -8.078656e-01  2.138033e+00  1.797553e+01
    endloop
  endfacet
  facet normal  4.729528e-01 -8.775649e-01  7.871172e-02
    outer loop
      vertex   3.942708e+00 -5.586086e+00  2.326981e+00
      vertex   3.644648e+00 -5.760553e+00  2.172778e+00
      vertex   3.930022e+00 -5.608150e+00  2.157217e+00
    endloop
  endfacet
  facet normal -7.290984e-01  1.047366e-01  6.763474e-01
    outer loop
      vertex  -6.704711e+00  8.853207e-01  1.642652e+01
      vertex  -7.365190e+00  4.444332e-01  1.578280e+01
      vertex  -6.737250e+00  4.444122e-01  1.645972e+01
    endloop
  endfacet
  facet normal -1.869129e-01 -6.210402e-01  7.611653e-01
    outer loop
      vertex  -1.778063e+00 -1.470493e+00  1.873373e+01
      vertex  -2.663391e+00 -1.470520e+00  1.851630e+01
      vertex  -2.619959e+00 -1.662099e+00  1.837066e+01
    endloop
  endfacet
  facet normal  8.585125e-01 -4.152454e-01 -3.008778e-01
    outer loop
      vertex   7.786209e+00 -2.035057e+00  2.677070e+00
      vertex   7.819855e+00 -2.469397e+00  3.372513e+00
      vertex   7.577900e+00 -2.477064e+00  2.692711e+00
    endloop
  endfacet
  facet normal -4.497866e-15  4.371199e-15 -1.000000e+00
    outer loop
      vertex  -5.507435e+00 -3.786364e+00  7.881427e-16
      vertex  -4.634246e+00 -3.046586e+00  9.436896e-17
      vertex  -4.621866e+00 -3.067342e+00 -5.204170e-17
    endloop
  endfacet
  facet normal  2.423011e-01 -9.702011e-01  1.070482e-04
    outer loop
      vertex   1.820122e+00 -6.455023e+00  1.445436e+00
      vertex   2.004912e+00 -6.408859e+00  1.572065e+00
      vertex   1.605798e+00 -6.508545e+00  1.482603e+00
    endloop
  endfacet
  facet normal -5.920228e-16 -3.515772e-16 -1.000000e+00
    outer loop
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
      vertex  -1.329709e-01  5.573674e+00 -2.687087e-16
      vertex  -5.741618e-01  5.547369e+00  1.734723e-18
    endloop
  endfacet
  facet normal  9.935014e-01  1.013409e-01 -5.181664e-02
    outer loop
      vertex   9.545728e+00  9.119377e-01  8.312808e+00
      vertex   9.630630e+00  4.544315e-01  9.045911e+00
      vertex   9.591737e+00  4.614162e-01  8.313847e+00
    endloop
  endfacet
  facet normal -7.547989e-01 -3.134317e-01  5.762285e-01
    outer loop
      vertex  -7.329827e+00 -8.839073e-01  1.575304e+01
      vertex  -7.804250e+00 -1.189606e+00  1.496531e+01
      vertex  -7.252540e+00 -1.189594e+00  1.568800e+01
    endloop
  endfacet
  facet normal -9.606287e-01  6.154775e-07 -2.778353e-01
    outer loop
      vertex   7.862114e+00  2.180857e+00  1.210450e+01
      vertex   7.974295e+00  2.181215e+00  1.171663e+01
      vertex   7.974292e+00 -2.181013e+00  1.171663e+01
    endloop
  endfacet
  facet normal -4.863207e-16 -1.052597e-15 -1.000000e+00
    outer loop
      vertex   1.441300e+00 -6.508503e+00  1.031293e-15
      vertex   1.072319e+00 -5.471157e+00  1.188286e-16
      vertex   1.519274e+00 -5.360741e+00 -2.147588e-16
    endloop
  endfacet
  facet normal -9.837717e-01  9.723807e-02 -1.507915e-01
    outer loop
      vertex  -9.401338e+00  4.816837e-01  6.855623e+00
      vertex  -9.513821e+00  4.703484e-01  7.582159e+00
      vertex  -9.468263e+00  9.300938e-01  7.581403e+00
    endloop
  endfacet
  facet normal -3.284241e-16 -9.474608e-17 -1.000000e+00
    outer loop
      vertex  -5.330578e+00  1.508395e+00  2.775558e-17
      vertex  -6.387031e+00  2.021261e+00  3.261280e-16
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
    endloop
  endfacet
  facet normal -5.964230e-01 -4.502052e-04  8.026701e-01
    outer loop
      vertex   4.968148e+00 -4.831974e+00  2.986660e+00
      vertex   5.043385e+00 -2.145653e+00  3.044071e+00
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
    endloop
  endfacet
  facet normal  1.004721e-14  6.356218e-15 -1.000000e+00
    outer loop
      vertex   4.307658e+00 -3.498473e+00 -5.620504e-17
      vertex   5.007560e+00 -4.416769e+00  1.138970e-15
      vertex   4.284388e+00 -3.527809e+00 -4.764707e-16
    endloop
  endfacet
  facet normal  6.838554e-01 -7.295094e-01 -1.255807e-02
    outer loop
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
      vertex  -3.904679e+00  3.909998e+00  2.306491e+00
      vertex  -3.914187e+00  3.940789e+00 -9.159340e-17
    endloop
  endfacet
  facet normal  4.226388e-01  2.965397e-03  9.062933e-01
    outer loop
      vertex   4.490647e+00  4.520416e-04  1.809648e+01
      vertex   3.637555e+00  4.730225e-04  1.849431e+01
      vertex   3.638051e+00 -4.432430e-01  1.849553e+01
    endloop
  endfacet
  facet normal -8.199436e-01  3.870170e-01 -4.217941e-01
    outer loop
      vertex  -7.466674e+00  1.986303e+00  1.966105e+00
      vertex  -7.640823e+00  2.018465e+00  2.334151e+00
      vertex  -7.433151e+00  2.462477e+00  2.337850e+00
    endloop
  endfacet
  facet normal -2.658713e-01  9.615968e-01  6.814698e-02
    outer loop
      vertex  -8.203500e+00  2.272688e+00  8.653869e+00
      vertex  -8.154238e+00  2.312090e+00  8.290074e+00
      vertex  -8.427589e+00  2.236219e+00  8.294190e+00
    endloop
  endfacet
  facet normal  4.931511e-01 -8.670682e-01 -7.067306e-02
    outer loop
      vertex   3.816425e+00 -5.551033e+00  6.146011e-01
      vertex   3.110520e+00 -5.953293e+00  6.240654e-01
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
    endloop
  endfacet
  facet normal -8.841966e-16  2.786813e-16 -1.000000e+00
    outer loop
      vertex  -2.026798e+00 -5.187760e+00 -4.897124e-16
      vertex  -2.354590e+00 -6.245616e+00 -4.946853e-16
      vertex  -3.081993e+00 -5.919403e+00  2.393918e-16
    endloop
  endfacet
  facet normal  5.249900e-01  8.506548e-01 -2.778179e-02
    outer loop
      vertex   3.897675e+00  5.612207e+00  1.772821e+00
      vertex   3.926537e+00  5.606951e+00  2.157274e+00
      vertex   4.638740e+00  5.166063e+00  2.116110e+00
    endloop
  endfacet
  facet normal  4.656486e-02 -9.988852e-01  7.754961e-03
    outer loop
      vertex   8.201133e+00  2.180852e+00  1.054355e+01
      vertex   8.143600e+00  2.181211e+00  1.093534e+01
      vertex   8.071131e+00  2.180856e+00  1.132464e+01
    endloop
  endfacet
  facet normal  4.536397e-01 -8.867324e-01 -8.897535e-02
    outer loop
      vertex   3.872465e+00 -5.588881e+00  1.385299e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
      vertex   3.165092e+00 -5.992880e+00  1.805041e+00
    endloop
  endfacet
  facet normal  5.737926e-02 -9.693756e-01  2.387853e-01
    outer loop
      vertex   2.408868e+00 -2.137492e+00  1.766389e+01
      vertex   1.576988e+00 -2.177616e+00  1.770090e+01
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
    endloop
  endfacet
  facet normal -8.298070e-01  4.546159e-01 -3.236430e-01
    outer loop
      vertex  -7.784481e+00  2.034075e+00  2.677211e+00
      vertex  -8.048572e+00  2.035978e+00  3.357002e+00
      vertex  -7.818043e+00  2.467924e+00  3.372682e+00
    endloop
  endfacet
  facet normal  5.297663e-01 -9.955710e-07 -8.481437e-01
    outer loop
      vertex  -4.202793e+00  2.181318e+00  1.668542e+01
      vertex  -3.859632e+00 -2.177117e+00  1.689977e+01
      vertex  -4.202807e+00 -2.180958e+00  1.668542e+01
    endloop
  endfacet
  facet normal -2.761289e-01 -9.377117e-01  2.108309e-01
    outer loop
      vertex  -6.561809e+00 -2.180946e+00  1.458945e+01
      vertex  -6.329442e+00 -2.177030e+00  1.491121e+01
      vertex  -6.810974e+00 -2.177029e+00  1.428054e+01
    endloop
  endfacet
  facet normal  8.765659e-01 -3.962771e-01 -2.731241e-01
    outer loop
      vertex   8.480577e+00 -1.549639e+00  4.031807e+00
      vertex   8.708557e+00 -1.524548e+00  4.727085e+00
      vertex   8.505115e+00 -1.980730e+00  4.736032e+00
    endloop
  endfacet
  facet normal -6.727958e-16  2.611212e-16 -1.000000e+00
    outer loop
      vertex  -5.453969e+00  9.625327e-01  6.938894e-17
      vertex  -5.520691e+00  4.318787e-01 -2.428613e-17
      vertex  -6.650962e+00  8.014841e-01  8.326673e-16
    endloop
  endfacet
  facet normal -2.636683e-01 -9.561237e-01  1.276968e-01
    outer loop
      vertex  -7.406964e+00 -2.180943e+00  1.322548e+01
      vertex  -7.249969e+00 -2.174229e+00  1.359991e+01
      vertex  -7.594768e+00 -2.177027e+00  1.286702e+01
    endloop
  endfacet
  facet normal -8.450040e-01 -2.396785e-01 -4.780402e-01
    outer loop
      vertex  -6.787491e+00 -1.739288e+00  5.665770e-01
      vertex  -6.501628e+00 -1.617079e+00  2.844947e-16
      vertex  -6.397487e+00 -1.984235e+00  1.539173e-16
    endloop
  endfacet
  facet normal -8.409860e-01 -4.086705e-01 -3.545854e-01
    outer loop
      vertex  -7.434761e+00 -2.464277e+00  2.337805e+00
      vertex  -7.577415e+00 -2.478678e+00  2.692742e+00
      vertex  -7.785738e+00 -2.036400e+00  2.677091e+00
    endloop
  endfacet
  facet normal -1.934030e-16 -3.766177e-16 -1.000000e+00
    outer loop
      vertex  -5.311913e+00 -1.571666e+00  3.729655e-17
      vertex  -6.501628e+00 -1.617079e+00  2.844947e-16
      vertex  -5.434622e+00 -1.066470e+00 -1.292369e-16
    endloop
  endfacet
  facet normal  4.699263e-01 -8.823806e-01 -2.395215e-02
    outer loop
      vertex   3.644648e+00 -5.760553e+00  2.172778e+00
      vertex   3.901385e+00 -5.612966e+00  1.772780e+00
      vertex   3.930022e+00 -5.608150e+00  2.157217e+00
    endloop
  endfacet
  facet normal  1.693871e-16  1.271430e-16 -1.000000e+00
    outer loop
      vertex  -6.102031e+00 -2.749480e+00 -1.179612e-16
      vertex  -6.260275e+00 -2.374932e+00 -9.714451e-17
      vertex  -5.137498e+00 -2.076589e+00  1.309716e-16
    endloop
  endfacet
  facet normal  8.620989e-01  4.860230e-01  1.434126e-01
    outer loop
      vertex   9.117169e+00  1.467085e+00  1.155001e+01
      vertex   9.269166e+00  1.187811e+00  1.158277e+01
      vertex   9.263976e+00  1.467035e+00  1.066768e+01
    endloop
  endfacet
  facet normal -9.474841e-01  3.130563e-01  6.534296e-02
    outer loop
      vertex  -9.517486e+00  8.854656e-01  1.069680e+01
      vertex  -9.480475e+00  1.189270e+00  9.777935e+00
      vertex  -9.580712e+00  8.854856e-01  9.779905e+00
    endloop
  endfacet
  facet normal -3.382380e-01  9.049335e-01  2.582451e-01
    outer loop
      vertex  -6.450688e+00  2.138182e+00  1.501330e+01
      vertex  -6.941405e+00  2.138201e+00  1.437052e+01
      vertex  -7.270593e+00  1.950403e+00  1.459744e+01
    endloop
  endfacet
  facet normal -8.658175e-01  5.000820e-01 -1.667150e-02
    outer loop
      vertex   4.820126e+00 -2.630800e+00  2.877907e+00
      vertex   4.924182e+00 -2.546585e+00 -1.464878e-17
      vertex   4.642241e+00 -3.034725e+00 -5.828671e-17
    endloop
  endfacet
  facet normal  6.203498e-01 -7.629216e-01 -1.819804e-01
    outer loop
      vertex   5.078556e+00 -4.523216e+00  5.952883e-01
      vertex   5.197096e+00 -4.602970e+00  1.333733e+00
      vertex   4.558254e+00 -5.128565e+00  1.359461e+00
    endloop
  endfacet
  facet normal -7.216848e-01 -6.087900e-01 -3.294631e-01
    outer loop
      vertex  -5.783556e+00 -4.023340e+00  1.309416e+00
      vertex  -6.415605e+00 -3.455317e+00  1.644304e+00
      vertex  -6.308788e+00 -3.388851e+00  1.287506e+00
    endloop
  endfacet
  facet normal  7.819576e-01 -4.592552e-01 -4.214580e-01
    outer loop
      vertex   7.114815e+00 -2.367758e+00  1.610386e+00
      vertex   7.273337e+00 -2.427338e+00  1.969424e+00
      vertex   7.040828e+00 -2.826899e+00  1.973431e+00
    endloop
  endfacet
  facet normal  2.904739e-16 -8.530641e-17 -1.000000e+00
    outer loop
      vertex  -2.026798e+00 -5.187760e+00 -4.897124e-16
      vertex  -1.511060e+00 -5.363482e+00 -3.249137e-16
      vertex  -2.354590e+00 -6.245616e+00 -4.946853e-16
    endloop
  endfacet
  facet normal  5.951747e-02 -9.982274e-01 -1.585007e-04
    outer loop
      vertex  -5.705888e-01  5.547369e+00  1.344675e+00
      vertex  -5.741618e-01  5.547369e+00  1.734723e-18
      vertex  -1.329709e-01  5.573674e+00 -2.687087e-16
    endloop
  endfacet
  facet normal  3.769139e-01 -3.369308e-01  8.627940e-01
    outer loop
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
      vertex   3.118692e+00 -2.180992e+00  1.722361e+01
      vertex   3.488575e+00 -2.180994e+00  1.706203e+01
    endloop
  endfacet
  facet normal -1.778165e-01 -9.832625e-01 -3.970006e-02
    outer loop
      vertex  -1.594657e+00 -6.509521e+00  6.398621e-01
      vertex  -1.585613e+00 -6.485322e+00 -5.642188e-16
      vertex  -7.934912e-01 -6.628572e+00  9.134186e-16
    endloop
  endfacet
  facet normal -8.808668e-01 -1.408409e-02 -4.731548e-01
    outer loop
      vertex  -7.565663e+00  1.035690e-03  1.591647e+00
      vertex  -7.370649e+00 -4.772720e-01  1.242829e+00
      vertex  -7.558371e+00 -4.955788e-01  1.592854e+00
    endloop
  endfacet
  facet normal  1.195006e-17 -4.845909e-16 -1.000000e+00
    outer loop
      vertex  -1.011834e+00  5.481153e+00  3.025358e-16
      vertex  -1.422250e+00  6.514177e+00 -2.029626e-16
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
    endloop
  endfacet
  facet normal -8.944764e-01 -1.766212e-01 -4.107518e-01
    outer loop
      vertex  -7.796678e+00 -1.540154e+00  2.326575e+00
      vertex  -8.044674e+00 -1.047447e+00  2.654763e+00
      vertex  -7.891964e+00 -1.036732e+00  2.317606e+00
    endloop
  endfacet
  facet normal -6.791962e-01  4.795856e-07  7.339569e-01
    outer loop
      vertex   5.752496e+00  4.176069e+00  3.658274e+00
      vertex   5.458477e+00  1.757812e-02  3.386195e+00
      vertex   5.752617e+00 -4.180309e+00  3.658392e+00
    endloop
  endfacet
  facet normal  7.917319e-16  5.360855e-17 -1.000000e+00
    outer loop
      vertex   3.029783e+00 -4.664573e+00 -2.392762e-16
      vertex   3.483805e+00 -4.330739e+00  1.380840e-16
      vertex   3.789027e+00 -5.492561e+00  3.174544e-16
    endloop
  endfacet
  facet normal  9.659279e-01 -3.013024e-03  2.587937e-01
    outer loop
      vertex   9.412313e+00  4.439354e-01  1.161362e+01
      vertex   9.168643e+00  4.439545e-01  1.252310e+01
      vertex   9.167368e+00  2.927780e-04  1.252269e+01
    endloop
  endfacet
  facet normal -8.313327e-01 -5.061881e-01 -2.294770e-01
    outer loop
      vertex  -8.039986e+00 -2.437206e+00  4.057395e+00
      vertex  -8.504741e+00 -1.981583e+00  4.736046e+00
      vertex  -8.290376e+00 -2.019579e+00  4.043274e+00
    endloop
  endfacet
  facet normal  7.375769e-17  8.433488e-16 -1.000000e+00
    outer loop
      vertex  -5.157812e+00  2.025308e+00 -7.796052e-17
      vertex  -6.257010e+00  2.387415e+00  1.463476e-16
      vertex  -6.098308e+00  2.759493e+00  4.718448e-16
    endloop
  endfacet
  facet normal -9.679359e-01 -2.501256e-01 -2.317833e-02
    outer loop
      vertex   5.344658e+00  1.140909e+00  3.287793e+00
      vertex   5.207137e+00  1.683670e+00  3.173629e+00
      vertex   5.312153e+00  1.571366e+00  1.616354e-16
    endloop
  endfacet
  facet normal -7.974531e-01 -4.979796e-01 -3.407123e-01
    outer loop
      vertex  -7.188881e+00 -2.861088e+00  2.342285e+00
      vertex  -7.577415e+00 -2.478678e+00  2.692742e+00
      vertex  -7.434761e+00 -2.464277e+00  2.337805e+00
    endloop
  endfacet
  facet normal -4.013984e-01 -3.133386e-01  8.606383e-01
    outer loop
      vertex  -3.620850e+00 -8.840160e-01  1.845246e+01
      vertex  -4.422828e+00 -1.189554e+00  1.796718e+01
      vertex  -3.582696e+00 -1.189545e+00  1.835902e+01
    endloop
  endfacet
  facet normal  2.564720e-01 -9.665406e-01 -4.615843e-03
    outer loop
      vertex  -1.654610e+00  5.317961e+00  1.492412e+00
      vertex  -1.519182e+00  5.361024e+00 -2.671474e-17
      vertex  -1.120569e+00  5.460104e+00  1.401345e+00
    endloop
  endfacet
  facet normal -1.693012e-16 -8.915255e-17 -1.000000e+00
    outer loop
      vertex  -7.891537e-01  6.630673e+00 -2.518503e-16
      vertex   8.517145e-03  6.676285e+00 -3.909633e-16
      vertex  -1.329709e-01  5.573674e+00 -2.687087e-16
    endloop
  endfacet
  facet normal  6.400971e-01 -7.608758e-01  1.065068e-01
    outer loop
      vertex   9.111837e+00 -1.660636e+00  1.064991e+01
      vertex   8.637318e+00 -1.948309e+00  1.144662e+01
      vertex   8.776464e+00 -1.948257e+00  1.061073e+01
    endloop
  endfacet
  facet normal  8.758441e-02 -9.645731e-01  2.488526e-01
    outer loop
      vertex   3.131773e+00 -2.174252e+00  1.725559e+01
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
      vertex   2.741342e+00 -2.180990e+00  1.736688e+01
    endloop
  endfacet
  facet normal  6.402894e-01  7.652639e-01 -6.633813e-02
    outer loop
      vertex   7.245383e+00  3.139837e+00  3.411770e+00
      vertex   7.418854e+00  3.053747e+00  4.092981e+00
      vertex   7.742470e+00  2.781343e+00  4.074096e+00
    endloop
  endfacet
  facet normal -8.734361e-01  2.684155e-02 -4.861984e-01
    outer loop
      vertex  -7.010478e+00  4.501343e-03  5.613642e-01
      vertex  -6.686056e+00  3.930120e-01  5.273559e-16
      vertex  -6.697911e+00  7.241169e-03  9.298118e-16
    endloop
  endfacet
  facet normal  1.457850e-01 -9.572488e-01  2.498426e-01
    outer loop
      vertex   4.563868e+00 -2.174255e+00  1.650061e+01
      vertex   3.860061e+00 -2.176847e+00  1.690136e+01
      vertex   4.202488e+00 -2.180996e+00  1.668565e+01
    endloop
  endfacet
  facet normal  5.019014e-02 -9.814867e-01  1.848371e-01
    outer loop
      vertex   2.367333e+00 -2.174250e+00  1.752464e+01
      vertex   1.967912e+00 -2.180986e+00  1.759733e+01
      vertex   2.357441e+00 -2.180988e+00  1.749155e+01
    endloop
  endfacet
  facet normal -6.411372e-01 -7.646395e-01 -6.534157e-02
    outer loop
      vertex  -7.248965e+00 -3.145601e+00  3.411671e+00
      vertex  -7.421945e+00 -3.058773e+00  4.092888e+00
      vertex  -7.745277e+00 -2.786051e+00  4.074001e+00
    endloop
  endfacet
  facet normal -8.422630e-01 -4.591286e-01 -2.824782e-01
    outer loop
      vertex  -7.819458e+00 -2.470802e+00  3.372544e+00
      vertex  -8.290376e+00 -2.019579e+00  4.043274e+00
      vertex  -8.049710e+00 -2.038773e+00  3.356880e+00
    endloop
  endfacet
  facet normal -2.737792e-17  1.193514e-16 -1.000000e+00
    outer loop
      vertex   4.911027e+00  2.571886e+00  1.632953e-16
      vertex   6.097925e+00  2.755002e+00  1.526557e-16
      vertex   5.137590e+00  2.076873e+00  9.801188e-17
    endloop
  endfacet
  facet normal  4.229123e-16 -2.845899e-16 -1.000000e+00
    outer loop
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
      vertex   3.029783e+00 -4.664573e+00 -2.392762e-16
      vertex   3.789027e+00 -5.492561e+00  3.174544e-16
    endloop
  endfacet
  facet normal  9.333859e-01  7.367464e-03 -3.587986e-01
    outer loop
      vertex   8.373780e+00  5.278606e-01  3.328556e+00
      vertex   8.638736e+00  5.256424e-01  4.017771e+00
      vertex   8.642137e+00 -8.125305e-04  4.015808e+00
    endloop
  endfacet
  facet normal -8.682790e-01  1.442272e-01 -4.746474e-01
    outer loop
      vertex  -7.248943e+00  1.422327e+00  1.249935e+00
      vertex  -6.890904e+00  1.322287e+00  5.645704e-01
      vertex  -6.962196e+00  8.877678e-01  5.629520e-01
    endloop
  endfacet
  facet normal -7.837752e-01  4.867076e-01  3.857616e-01
    outer loop
      vertex  -8.157006e+00  1.468376e+00  1.410220e+01
      vertex  -8.702725e+00  1.189085e+00  1.334581e+01
      vertex  -8.293319e+00  1.189035e+00  1.417769e+01
    endloop
  endfacet
  facet normal -8.474552e-01 -5.267459e-01 -6.601843e-02
    outer loop
      vertex  -9.079116e+00 -1.757046e+00  7.576221e+00
      vertex  -9.396447e+00 -1.338486e+00  8.310097e+00
      vertex  -9.322753e+00 -1.365467e+00  7.579388e+00
    endloop
  endfacet
  facet normal -8.882965e-01  6.641629e-07 -4.592703e-01
    outer loop
      vertex   7.221422e+00  2.180867e+00  1.358455e+01
      vertex   7.406849e+00  2.181223e+00  1.322590e+01
      vertex   7.406844e+00 -2.181011e+00  1.322591e+01
    endloop
  endfacet
  facet normal  1.445103e-16  9.164487e-17 -1.000000e+00
    outer loop
      vertex   3.096344e+00 -5.910489e+00  1.434483e-16
      vertex   2.362674e+00 -6.239994e+00  7.228014e-18
      vertex   2.057736e+00 -5.175515e+00  6.071532e-17
    endloop
  endfacet
  facet normal  6.104059e-01 -7.920123e-01 -1.101011e-02
    outer loop
      vertex  -3.521503e+00  4.272516e+00  2.113484e+00
      vertex  -3.483713e+00  4.331022e+00 -4.857226e-17
      vertex  -3.102766e+00  4.597788e+00  1.930065e+00
    endloop
  endfacet
  facet normal -8.790779e-01 -3.315185e-01 -3.425165e-01
    outer loop
      vertex  -7.785738e+00 -2.036400e+00  2.677091e+00
      vertex  -8.049710e+00 -2.038773e+00  3.356880e+00
      vertex  -8.224982e+00 -1.560852e+00  3.344146e+00
    endloop
  endfacet
  facet normal -1.609153e-02 -9.405609e-01  3.392436e-01
    outer loop
      vertex  -1.994994e-04 -2.177049e+00  1.785545e+01
      vertex  -7.927897e-01 -2.176831e+00  1.781846e+01
      vertex  -3.959477e-01 -2.180975e+00  1.782579e+01
    endloop
  endfacet
  facet normal  9.005386e-01  4.342914e-01 -2.052537e-02
    outer loop
      vertex  -4.787539e+00 -2.692570e+00  2.854462e+00
      vertex  -4.910936e+00 -2.571602e+00  2.405483e-17
      vertex  -5.020278e+00 -2.201843e+00  3.026298e+00
    endloop
  endfacet
  facet normal  6.266299e-01  7.610067e-01  1.679400e-01
    outer loop
      vertex   8.636546e+00  1.949278e+00  1.144645e+01
      vertex   8.412847e+00  1.949324e+00  1.228092e+01
      vertex   8.734851e+00  1.661410e+00  1.238410e+01
    endloop
  endfacet
  facet normal  8.017478e-01 -4.828015e-01 -3.522826e-01
    outer loop
      vertex   6.300029e+00 -2.902218e+00  5.748234e-01
      vertex   6.091302e+00 -3.251385e+00  5.783205e-01
      vertex   5.924675e+00 -3.106108e+00 -1.358867e-16
    endloop
  endfacet
  facet normal  6.467000e-01 -7.613655e-01  4.584345e-02
    outer loop
      vertex   9.171998e+00 -1.661129e+00  9.771967e+00
      vertex   8.833118e+00 -1.949384e+00  9.765130e+00
      vertex   8.842025e+00 -1.986032e+00  9.030830e+00
    endloop
  endfacet
  facet normal -3.313983e-01  6.206621e-01  7.106009e-01
    outer loop
      vertex  -3.465606e+00  1.663043e+00  1.807230e+01
      vertex  -4.350411e+00  1.468069e+00  1.782996e+01
      vertex  -3.524038e+00  1.468016e+00  1.821539e+01
    endloop
  endfacet
  facet normal  5.213996e-01  6.199837e-01  5.863127e-01
    outer loop
      vertex   6.417946e+00  1.661885e+00  1.613447e+01
      vertex   5.857304e+00  1.467438e+00  1.683866e+01
      vertex   6.525639e+00  1.467388e+00  1.624437e+01
    endloop
  endfacet
  facet normal  1.707676e-16  3.946242e-16 -1.000000e+00
    outer loop
      vertex  -5.918192e+00  3.119182e+00  1.908196e-17
      vertex  -4.642149e+00  3.035010e+00  2.037722e-16
      vertex  -4.924090e+00  2.546866e+00 -3.700744e-17
    endloop
  endfacet
  facet normal -2.511192e-01  9.048871e-01  3.436838e-01
    outer loop
      vertex  -4.643528e+00  2.138128e+00  1.662074e+01
      vertex  -5.547705e+00  1.950266e+00  1.645471e+01
      vertex  -4.863835e+00  1.950220e+00  1.695451e+01
    endloop
  endfacet
  facet normal  6.599378e-01 -1.798072e-04  7.513202e-01
    outer loop
      vertex  -5.527053e+00  4.360826e+00  3.447559e+00
      vertex  -5.458386e+00 -1.729584e-02  3.386196e+00
      vertex  -5.432583e+00  5.453663e-01  3.363667e+00
    endloop
  endfacet
  facet normal  3.109796e-02  7.616062e-01  6.472936e-01
    outer loop
      vertex   8.459144e-01  1.949884e+00  1.837395e+01
      vertex  -1.770278e-04  1.662657e+00  1.875255e+01
      vertex   8.782997e-01  1.662560e+00  1.871046e+01
    endloop
  endfacet
  facet normal  1.585946e-16  1.207501e-16 -1.000000e+00
    outer loop
      vertex  -1.574733e+00  5.346050e+00  1.179612e-16
      vertex  -2.057643e+00  5.175800e+00  2.081668e-17
      vertex  -2.350985e+00  6.245869e+00  1.035052e-16
    endloop
  endfacet
  facet normal  9.677612e-01  8.588274e-02 -2.367748e-01
    outer loop
      vertex   9.037666e+00  1.007128e+00  5.424614e+00
      vertex   9.257026e+00  4.947186e-01  6.135334e+00
      vertex   9.081264e+00  5.079060e-01  5.421731e+00
    endloop
  endfacet
  facet normal  8.679889e-01 -1.642029e-01 -4.686498e-01
    outer loop
      vertex   7.518118e+00 -9.869938e-01  1.595263e+00
      vertex   7.617409e+00 -1.511604e+00  1.962971e+00
      vertex   7.428255e+00 -1.468988e+00  1.597705e+00
    endloop
  endfacet
endsolid vcg
`;